// Auto-generated from naeringskoder.csv
export interface IndustryCode {
  code: string;
  name: string;
  shortName: string;
  level: number;
  parentCode: string;
  children?: IndustryCode[];
}

export const industryCodes: Record<string, IndustryCode[]> = {
  "level1": [
    {
      "code": "A",
      "name": "Jordbruk, skogbruk og fiske",
      "shortName": "Jordbruk, skogbruk og fiske",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "B",
      "name": "Bergverksdrift og utvinning",
      "shortName": "Bergverksdrift og utvinning",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "C",
      "name": "Industri",
      "shortName": "Industri",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "D",
      "name": "Elektrisitets-, gass-, damp- og varmtvannsforsyning",
      "shortName": "Kraftforsyning",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "E",
      "name": "Vannforsyning, avløps- og renovasjonsvirksomhet",
      "shortName": "Vann, avløp, renovasjon",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "F",
      "name": "Bygge- og anleggsvirksomhet",
      "shortName": "Bygge- og anleggsvirksomhet",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "G",
      "name": "Varehandel, reparasjon av motorvogner",
      "shortName": "Varehandel, bilverksteder",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "H",
      "name": "Transport og lagring",
      "shortName": "Transport og lagring",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "I",
      "name": "Overnattings- og serveringsvirksomhet",
      "shortName": "Overnattings- og serveringsvirks.",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "J",
      "name": "Informasjon og kommunikasjon",
      "shortName": "Informasjon og kommunikasjon",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "K",
      "name": "Finansierings- og forsikringsvirksomhet",
      "shortName": "Finansiering og forsikring",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "L",
      "name": "Omsetning og drift av fast eiendom",
      "shortName": "Omsetning og drift av fast eiendom",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "M",
      "name": "Faglig, vitenskapelig og teknisk tjenesteyting",
      "shortName": "Faglig, vit. og tekn. tjenesteyting",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "N",
      "name": "Forretningsmessig tjenesteyting",
      "shortName": "Forretningsmessig tjenesteyting",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "O",
      "name": "Offentlig administrasjon og forsvar, og trygdeordninger underlagt offentlig forvaltning",
      "shortName": "Off.adm., forsvar, sosialforsikring",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "P",
      "name": "Undervisning",
      "shortName": "Undervisning",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "Q",
      "name": "Helse- og sosialtjenester",
      "shortName": "Helse- og sosialtjenester",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "R",
      "name": "Kulturell virksomhet, underholdning og fritidsaktiviteter",
      "shortName": "Kultur, underholdning og fritid",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "S",
      "name": "Annen tjenesteyting",
      "shortName": "Annen tjenesteyting",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "T",
      "name": "Lønnet arbeid i private husholdninger",
      "shortName": "Lønnet arbeid i private husholdn.",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "U",
      "name": "Internasjonale organisasjoner og organer",
      "shortName": "Internasjonale organer",
      "level": 1,
      "parentCode": ""
    }
  ],
  "level2": [
    {
      "code": "01",
      "name": "Jordbruk og tjenester tilknyttet jordbruk, jakt og viltstell",
      "shortName": "Jordbruk, tilhør. tjenester, jakt",
      "level": 2,
      "parentCode": "A"
    },
    {
      "code": "02",
      "name": "Skogbruk og tjenester tilknyttet skogbruk",
      "shortName": "Skogbruk og tilhørende tjenester",
      "level": 2,
      "parentCode": "A"
    },
    {
      "code": "03",
      "name": "Fiske, fangst og akvakultur",
      "shortName": "Fiske, fangst og akvakultur",
      "level": 2,
      "parentCode": "A"
    },
    {
      "code": "05",
      "name": "Bryting av steinkull og brunkull",
      "shortName": "Bryting av steinkull og brunkull",
      "level": 2,
      "parentCode": "B"
    },
    {
      "code": "06",
      "name": "Utvinning av råolje og naturgass",
      "shortName": "Utvinning av råolje og naturgass",
      "level": 2,
      "parentCode": "B"
    },
    {
      "code": "07",
      "name": "Bryting av metallholdig malm",
      "shortName": "Bryting av metallholdig malm",
      "level": 2,
      "parentCode": "B"
    },
    {
      "code": "08",
      "name": "Bryting og bergverksdrift ellers",
      "shortName": "Bryting og bergverksdrift ellers",
      "level": 2,
      "parentCode": "B"
    },
    {
      "code": "09",
      "name": "Tjenester tilknyttet bergverksdrift og utvinning",
      "shortName": "Tjenester til bergverk og utvinning",
      "level": 2,
      "parentCode": "B"
    },
    {
      "code": "10",
      "name": "Produksjon av nærings- og nytelsesmidler",
      "shortName": "Næringsmiddelindustri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "11",
      "name": "Produksjon av drikkevarer",
      "shortName": "Drikkevareindustri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "12",
      "name": "Produksjon av tobakksvarer",
      "shortName": "Tobakksindustri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "13",
      "name": "Produksjon av tekstiler",
      "shortName": "Tekstilindustri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "14",
      "name": "Produksjon av klær",
      "shortName": "Bekledningsindustri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "15",
      "name": "Produksjon av lær og lærvarer",
      "shortName": "Lær- og lærvareindustri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "16",
      "name": "Produksjon av trelast og varer av tre, kork, strå og flettematerialer, unntatt møbler",
      "shortName": "Trelast- og trevareindustri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "17",
      "name": "Produksjon av papir og papirvarer",
      "shortName": "Papir- og papirvareindustri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "18",
      "name": "Trykking og reproduksjon av innspilte opptak",
      "shortName": "Trykking, grafisk industri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "19",
      "name": "Produksjon av kull- og raffinerte petroleumsprodukter",
      "shortName": "Petroleums- og kullvareindustri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "20",
      "name": "Produksjon av kjemikalier og kjemiske produkter",
      "shortName": "Kjemisk industri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "21",
      "name": "Produksjon av farmasøytiske råvarer og preparater",
      "shortName": "Farmasøytisk industri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "22",
      "name": "Produksjon av gummi- og plastprodukter",
      "shortName": "Gummivare- og plastindustri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "23",
      "name": "Produksjon av andre ikke-metallholdige mineralprodukter",
      "shortName": "Mineralproduktindustri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "24",
      "name": "Produksjon av metaller",
      "shortName": "Metallindustri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "25",
      "name": "Produksjon av metallvarer, unntatt maskiner og utstyr",
      "shortName": "Metallvareindustri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "26",
      "name": "Produksjon av datamaskiner og elektroniske og optiske produkter",
      "shortName": "Data- og elektronisk industri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "27",
      "name": "Produksjon av elektrisk utstyr",
      "shortName": "Elektroteknisk industri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "28",
      "name": "Produksjon av maskiner og utstyr til generell bruk, ikke nevnt annet sted",
      "shortName": "Maskinindustri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "29",
      "name": "Produksjon av motorvogner og tilhengere",
      "shortName": "Motorkjøretøyindustri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "30",
      "name": "Produksjon av andre transportmidler",
      "shortName": "Transportmiddelindustri ellers",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "31",
      "name": "Produksjon av møbler",
      "shortName": "Møbelindustri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "32",
      "name": "Annen industriproduksjon",
      "shortName": "Annen industri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "33",
      "name": "Reparasjon og installasjon av maskiner og utstyr",
      "shortName": "Maskinreparasjon og -installasjon",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "35",
      "name": "Elektrisitets-, gass-, damp- og varmtvannsforsyning",
      "shortName": "Kraftforsyning",
      "level": 2,
      "parentCode": "D"
    },
    {
      "code": "36",
      "name": "Uttak fra kilde, rensing og distribusjon av vann",
      "shortName": "Vannforsyning",
      "level": 2,
      "parentCode": "E"
    },
    {
      "code": "37",
      "name": "Oppsamling og behandling av avløpsvann",
      "shortName": "Håndtering av avløpsvann",
      "level": 2,
      "parentCode": "E"
    },
    {
      "code": "38",
      "name": "Innsamling, behandling, disponering og gjenvinning av avfall",
      "shortName": "Avfallshåndtering",
      "level": 2,
      "parentCode": "E"
    },
    {
      "code": "39",
      "name": "Miljørydding, miljørensing og lignende virksomhet",
      "shortName": "Miljørydding og miljørensing",
      "level": 2,
      "parentCode": "E"
    },
    {
      "code": "41",
      "name": "Oppføring av bygninger",
      "shortName": "Oppføring av bygninger",
      "level": 2,
      "parentCode": "F"
    },
    {
      "code": "42",
      "name": "Anleggsvirksomhet",
      "shortName": "Anleggsvirksomhet",
      "level": 2,
      "parentCode": "F"
    },
    {
      "code": "43",
      "name": "Spesialisert bygge- og anleggsvirksomhet",
      "shortName": "Spes. bygge- og anleggsvirksomhet",
      "level": 2,
      "parentCode": "F"
    },
    {
      "code": "45",
      "name": "Handel med og reparasjon av motorvogner",
      "shortName": "Kjøretøyreparasjoner og -handel",
      "level": 2,
      "parentCode": "G"
    },
    {
      "code": "46",
      "name": "Agentur- og engroshandel, unntatt med motorvogner",
      "shortName": "Agentur- og engroshandel",
      "level": 2,
      "parentCode": "G"
    },
    {
      "code": "47",
      "name": "Detaljhandel, unntatt med motorvogner",
      "shortName": "Detaljhandel, unntatt motorvogner",
      "level": 2,
      "parentCode": "G"
    },
    {
      "code": "49",
      "name": "Landtransport og rørtransport",
      "shortName": "Landtransport og rørtransport",
      "level": 2,
      "parentCode": "H"
    },
    {
      "code": "50",
      "name": "Sjøfart",
      "shortName": "Sjøfart",
      "level": 2,
      "parentCode": "H"
    },
    {
      "code": "51",
      "name": "Lufttransport",
      "shortName": "Lufttransport",
      "level": 2,
      "parentCode": "H"
    },
    {
      "code": "52",
      "name": "Lagring og andre tjenester tilknyttet transport",
      "shortName": "Transporttjenester og lagring",
      "level": 2,
      "parentCode": "H"
    },
    {
      "code": "53",
      "name": "Post og distribusjonsvirksomhet",
      "shortName": "Post og distribusjonsvirksomhet",
      "level": 2,
      "parentCode": "H"
    },
    {
      "code": "55",
      "name": "Overnattingsvirksomhet",
      "shortName": "Overnattingsvirksomhet",
      "level": 2,
      "parentCode": "I"
    },
    {
      "code": "56",
      "name": "Serveringsvirksomhet",
      "shortName": "Serveringsvirksomhet",
      "level": 2,
      "parentCode": "I"
    },
    {
      "code": "58",
      "name": "Forlagsvirksomhet",
      "shortName": "Forlagsvirksomhet",
      "level": 2,
      "parentCode": "J"
    },
    {
      "code": "59",
      "name": "Film-, video- og fjernsynsprogramproduksjon, utgivelse av musikk- og lydopptak",
      "shortName": "Film- og TV-prod., musikkutgivelse",
      "level": 2,
      "parentCode": "J"
    },
    {
      "code": "60",
      "name": "Radio- og fjernsynskringkasting",
      "shortName": "Radio- og fjernsynskringkasting",
      "level": 2,
      "parentCode": "J"
    },
    {
      "code": "61",
      "name": "Telekommunikasjon",
      "shortName": "Telekommunikasjon",
      "level": 2,
      "parentCode": "J"
    },
    {
      "code": "62",
      "name": "Tjenester tilknyttet informasjonsteknologi",
      "shortName": "IT-tjenester",
      "level": 2,
      "parentCode": "J"
    },
    {
      "code": "63",
      "name": "Informasjonstjenester",
      "shortName": "Informasjonstjenester",
      "level": 2,
      "parentCode": "J"
    },
    {
      "code": "64",
      "name": "Finansieringsvirksomhet",
      "shortName": "Finansieringsvirksomhet",
      "level": 2,
      "parentCode": "K"
    },
    {
      "code": "65",
      "name": "Forsikringsvirksomhet og pensjonskasser, unntatt trygdeordninger underlagt offentlig forvaltning",
      "shortName": "Forsikring og pensjonskasser",
      "level": 2,
      "parentCode": "K"
    },
    {
      "code": "66",
      "name": "Tjenester tilknyttet finansierings- og forsikringsvirksomhet",
      "shortName": "Finans-, forsikringshjelpetjenester",
      "level": 2,
      "parentCode": "K"
    },
    {
      "code": "68",
      "name": "Omsetning og drift av fast eiendom",
      "shortName": "Omsetning og drift av fast eiendom",
      "level": 2,
      "parentCode": "L"
    },
    {
      "code": "69",
      "name": "Juridisk og regnskapsmessig tjenesteyting",
      "shortName": "Juridisk og regnsk.messig tj.yting",
      "level": 2,
      "parentCode": "M"
    },
    {
      "code": "70",
      "name": "Hovedkontortjenester, administrativ rådgivning",
      "shortName": "Hovedkontortjen. og adm. rådgivning",
      "level": 2,
      "parentCode": "M"
    },
    {
      "code": "71",
      "name": "Arkitektvirksomhet og teknisk konsulentvirksomhet, og teknisk prøving og analyse",
      "shortName": "Arkitekter og tekniske konsulenter",
      "level": 2,
      "parentCode": "M"
    },
    {
      "code": "72",
      "name": "Forskning og utviklingsarbeid",
      "shortName": "Forskning og utviklingsarbeid",
      "level": 2,
      "parentCode": "M"
    },
    {
      "code": "73",
      "name": "Annonse- og reklamevirksomhet og markedsundersøkelser",
      "shortName": "Reklamevirksomhet og markedsund.",
      "level": 2,
      "parentCode": "M"
    },
    {
      "code": "74",
      "name": "Annen faglig, vitenskapelig og teknisk virksomhet",
      "shortName": "Fagl., vit. og tekn. virks. ellers",
      "level": 2,
      "parentCode": "M"
    },
    {
      "code": "75",
      "name": "Veterinærtjenester",
      "shortName": "Veterinærtjenester",
      "level": 2,
      "parentCode": "M"
    },
    {
      "code": "77",
      "name": "Utleie- og leasingvirksomhet",
      "shortName": "Utleie- og leasingvirksomhet",
      "level": 2,
      "parentCode": "N"
    },
    {
      "code": "78",
      "name": "Arbeidskrafttjenester",
      "shortName": "Arbeidskrafttjenester",
      "level": 2,
      "parentCode": "N"
    },
    {
      "code": "79",
      "name": "Reisebyrå- og reisearrangørvirksomhet og tilknyttede tjenester",
      "shortName": "Reisebyråer og reisearrangører",
      "level": 2,
      "parentCode": "N"
    },
    {
      "code": "80",
      "name": "Vakttjeneste og etterforsking",
      "shortName": "Vakttjeneste og etterforsking",
      "level": 2,
      "parentCode": "N"
    },
    {
      "code": "81",
      "name": "Tjenester tilknyttet eiendomsdrift",
      "shortName": "Tjenester tilknyttet eiendomsdrift",
      "level": 2,
      "parentCode": "N"
    },
    {
      "code": "82",
      "name": "Annen forretningsmessig tjenesteyting",
      "shortName": "Forretningsm. tjenesteyt. ellers",
      "level": 2,
      "parentCode": "N"
    },
    {
      "code": "84",
      "name": "Offentlig administrasjon og forsvar, og trygdeordninger underlagt offentlig forvaltning",
      "shortName": "Off.adm., forsvar, sosialforsikring",
      "level": 2,
      "parentCode": "O"
    },
    {
      "code": "85",
      "name": "Undervisning",
      "shortName": "Undervisning",
      "level": 2,
      "parentCode": "P"
    },
    {
      "code": "86",
      "name": "Helsetjenester",
      "shortName": "Helsetjenester",
      "level": 2,
      "parentCode": "Q"
    },
    {
      "code": "87",
      "name": "Pleie- og omsorgstjenester i institusjon",
      "shortName": "Pleie og omsorg i institusjon",
      "level": 2,
      "parentCode": "Q"
    },
    {
      "code": "88",
      "name": "Sosiale omsorgstjenester uten botilbud",
      "shortName": "Omsorg uten botilbud, barnehager mv.",
      "level": 2,
      "parentCode": "Q"
    },
    {
      "code": "90",
      "name": "Kunstnerisk virksomhet og underholdningsvirksomhet",
      "shortName": "Kunstnerisk virks. og underholdning",
      "level": 2,
      "parentCode": "R"
    },
    {
      "code": "91",
      "name": "Drift av biblioteker, arkiver, museer og annen kulturvirksomhet",
      "shortName": "Bibliotek, muséer o.a. kulturvirks.",
      "level": 2,
      "parentCode": "R"
    },
    {
      "code": "92",
      "name": "Lotteri og totalisatorspill",
      "shortName": "Lotteri og totalisatorspill",
      "level": 2,
      "parentCode": "R"
    },
    {
      "code": "93",
      "name": "Sports- og fritidsaktiviteter og drift av fornøyelsesetablissementer",
      "shortName": "Sports- og fritidsaktiviteter",
      "level": 2,
      "parentCode": "R"
    },
    {
      "code": "94",
      "name": "Aktiviteter i medlemsorganisasjoner",
      "shortName": "Aktiviteter i medlemsorgansiasjoner",
      "level": 2,
      "parentCode": "S"
    },
    {
      "code": "95",
      "name": "Reparasjon av datamaskiner, husholdningsvarer og varer til personlig bruk",
      "shortName": "Reparasjon av varer til pers. bruk",
      "level": 2,
      "parentCode": "S"
    },
    {
      "code": "96",
      "name": "Annen personlig tjenesteyting",
      "shortName": "Annen personlig tjenesteyting",
      "level": 2,
      "parentCode": "S"
    },
    {
      "code": "97",
      "name": "Lønnet arbeid i private husholdninger",
      "shortName": "Lønnet arbeid i private husholdn.",
      "level": 2,
      "parentCode": "T"
    },
    {
      "code": "99",
      "name": "Internasjonale organisasjoner og organer",
      "shortName": "Internasjonale organer",
      "level": 2,
      "parentCode": "U"
    }
  ],
  "level3": [
    {
      "code": "01.1",
      "name": "Dyrking av ettårige vekster",
      "shortName": "Dyrking av ettårige vekster",
      "level": 3,
      "parentCode": "01"
    },
    {
      "code": "01.2",
      "name": "Dyrking av flerårige vekster",
      "shortName": "Dyrking av flerårige vekster",
      "level": 3,
      "parentCode": "01"
    },
    {
      "code": "01.3",
      "name": "Planteformering",
      "shortName": "Planteformering",
      "level": 3,
      "parentCode": "01"
    },
    {
      "code": "01.4",
      "name": "Husdyrhold",
      "shortName": "Husdyrhold",
      "level": 3,
      "parentCode": "01"
    },
    {
      "code": "01.5",
      "name": "Kombinert husdyrhold og planteproduksjon",
      "shortName": "Komb. husdyrhold og planteprod.",
      "level": 3,
      "parentCode": "01"
    },
    {
      "code": "01.6",
      "name": "Tjenester tilknyttet jordbruk og etterbehandling av vekster etter innhøsting",
      "shortName": "Tjenester tilknyttet jordbruk",
      "level": 3,
      "parentCode": "01"
    },
    {
      "code": "01.7",
      "name": "Jakt, viltstell og tjenester tilknyttet jakt og viltstell",
      "shortName": "Jakt, viltstell og tilkn. tjenester",
      "level": 3,
      "parentCode": "01"
    },
    {
      "code": "02.1",
      "name": "Skogskjøtsel og andre skogbruksaktiviteter",
      "shortName": "Skogskjøtsel, andre skogbruksakt.",
      "level": 3,
      "parentCode": "02"
    },
    {
      "code": "02.2",
      "name": "Avvirkning",
      "shortName": "Avvirkning",
      "level": 3,
      "parentCode": "02"
    },
    {
      "code": "02.3",
      "name": "Innsamling av viltvoksende produkter av annet enn tre",
      "shortName": "Innsaml. av sopp, bær, mose etc.",
      "level": 3,
      "parentCode": "02"
    },
    {
      "code": "02.4",
      "name": "Tjenester tilknyttet skogbruk",
      "shortName": "Tjenester tilknyttet skogbruk",
      "level": 3,
      "parentCode": "02"
    },
    {
      "code": "03.1",
      "name": "Fiske og fangst",
      "shortName": "Fiske og fangst",
      "level": 3,
      "parentCode": "03"
    },
    {
      "code": "03.2",
      "name": "Akvakultur",
      "shortName": "Akvakultur",
      "level": 3,
      "parentCode": "03"
    },
    {
      "code": "05.1",
      "name": "Bryting av steinkull",
      "shortName": "Bryting av steinkull",
      "level": 3,
      "parentCode": "05"
    },
    {
      "code": "05.2",
      "name": "Bryting av brunkull",
      "shortName": "Bryting av brunkull",
      "level": 3,
      "parentCode": "05"
    },
    {
      "code": "06.1",
      "name": "Utvinning av råolje",
      "shortName": "Utvinning av råolje",
      "level": 3,
      "parentCode": "06"
    },
    {
      "code": "06.2",
      "name": "Utvinning av naturgass",
      "shortName": "Utvinning av naturgass",
      "level": 3,
      "parentCode": "06"
    },
    {
      "code": "07.1",
      "name": "Bryting av jernmalm",
      "shortName": "Bryting av jernmalm",
      "level": 3,
      "parentCode": "07"
    },
    {
      "code": "07.2",
      "name": "Bryting av ikke-jernholdig malm",
      "shortName": "Bryting av ikke-jernholdig malm",
      "level": 3,
      "parentCode": "07"
    },
    {
      "code": "08.1",
      "name": "Bryting av stein, utvinning av sand og leire",
      "shortName": "Bryt. av stein, utv. av sand, leire",
      "level": 3,
      "parentCode": "08"
    },
    {
      "code": "08.9",
      "name": "Annen bryting og utvinning",
      "shortName": "Annen bryting og utvinning",
      "level": 3,
      "parentCode": "08"
    },
    {
      "code": "09.1",
      "name": "Tjenester tilknyttet utvinning av råolje og naturgass",
      "shortName": "Utvinningstjenester",
      "level": 3,
      "parentCode": "09"
    },
    {
      "code": "09.9",
      "name": "Tjenester tilknyttet annen bergverksdrift",
      "shortName": "Bergverkstjenester",
      "level": 3,
      "parentCode": "09"
    },
    {
      "code": "10.1",
      "name": "Produksjon, bearbeiding og konservering av kjøtt og kjøttvarer",
      "shortName": "Bearbeiding kjøtt og kjøttvarer",
      "level": 3,
      "parentCode": "10"
    },
    {
      "code": "10.2",
      "name": "Bearbeiding og konservering av fisk, skalldyr og bløtdyr",
      "shortName": "Bearbeiding fisk, skalldyr, bløtdyr",
      "level": 3,
      "parentCode": "10"
    },
    {
      "code": "10.3",
      "name": "Bearbeiding og konservering av frukt og grønnsaker",
      "shortName": "Bearbeiding frukt og grønnsaker",
      "level": 3,
      "parentCode": "10"
    },
    {
      "code": "10.4",
      "name": "Produksjon av vegetabilske og animalske oljer og fettstoffer",
      "shortName": "Produksjon oljer og fettstoff",
      "level": 3,
      "parentCode": "10"
    },
    {
      "code": "10.5",
      "name": "Produksjon av meierivarer og iskrem",
      "shortName": "Produksjon av meierivarer og iskrem",
      "level": 3,
      "parentCode": "10"
    },
    {
      "code": "10.6",
      "name": "Produksjon av kornvarer, stivelse og stivelsesprodukter",
      "shortName": "Produksjon kornvarer, stivelse mv.",
      "level": 3,
      "parentCode": "10"
    },
    {
      "code": "10.7",
      "name": "Produksjon av bakeri- og pastavarer",
      "shortName": "Produksjon av bakeri- og pastavarer",
      "level": 3,
      "parentCode": "10"
    },
    {
      "code": "10.8",
      "name": "Produksjon av andre næringsmidler",
      "shortName": "Produksjon av andre næringsmidler",
      "level": 3,
      "parentCode": "10"
    },
    {
      "code": "10.9",
      "name": "Produksjon av fôrvarer",
      "shortName": "Produksjon av fôrvarer",
      "level": 3,
      "parentCode": "10"
    },
    {
      "code": "11.0",
      "name": "Produksjon av drikkevarer",
      "shortName": "Produksjon av drikkevarer",
      "level": 3,
      "parentCode": "11"
    },
    {
      "code": "12.0",
      "name": "Produksjon av tobakksvarer",
      "shortName": "Tobakksindustri",
      "level": 3,
      "parentCode": "12"
    },
    {
      "code": "13.1",
      "name": "Bearbeiding og spinning av tekstilfibrer",
      "shortName": "Bearb./spinning av tekstilfibrer",
      "level": 3,
      "parentCode": "13"
    },
    {
      "code": "13.2",
      "name": "Veving av tekstiler",
      "shortName": "Veving av tekstiler",
      "level": 3,
      "parentCode": "13"
    },
    {
      "code": "13.3",
      "name": "Etterbehandling av tekstiler",
      "shortName": "Etterbehandling av tekstiler",
      "level": 3,
      "parentCode": "13"
    },
    {
      "code": "13.9",
      "name": "Produksjon av andre tekstiler",
      "shortName": "Produksjon av andre tekstiler",
      "level": 3,
      "parentCode": "13"
    },
    {
      "code": "14.1",
      "name": "Produksjon av klær, unntatt pelsvarer",
      "shortName": "Produksjon av klær, unnt. pelsvarer",
      "level": 3,
      "parentCode": "14"
    },
    {
      "code": "14.2",
      "name": "Produksjon av pelsvarer",
      "shortName": "Produksjon av pelsvarer",
      "level": 3,
      "parentCode": "14"
    },
    {
      "code": "14.3",
      "name": "Produksjon av klær av trikotasje",
      "shortName": "Prod. av klær av trikotasje",
      "level": 3,
      "parentCode": "14"
    },
    {
      "code": "15.1",
      "name": "Beredning av lær, produksjon av reiseeffekter og salmakerartikler og beredning og farging av pelsskinn",
      "shortName": "Bered. lær, prod. av reiseeff. mv.",
      "level": 3,
      "parentCode": "15"
    },
    {
      "code": "15.2",
      "name": "Produksjon av skotøy",
      "shortName": "Produksjon av skotøy",
      "level": 3,
      "parentCode": "15"
    },
    {
      "code": "16.1",
      "name": "Saging, høvling og impregnering av tre",
      "shortName": "Saging, høvling mv. av tre",
      "level": 3,
      "parentCode": "16"
    },
    {
      "code": "16.2",
      "name": "Produksjon av varer av tre, kork, strå og flettematerialer",
      "shortName": "Produksjon trevarer, kork mv.",
      "level": 3,
      "parentCode": "16"
    },
    {
      "code": "17.1",
      "name": "Produksjon av papirmasse, papir og papp",
      "shortName": "Prod. av papirmasse, papir og papp",
      "level": 3,
      "parentCode": "17"
    },
    {
      "code": "17.2",
      "name": "Produksjon av varer av papir og papp",
      "shortName": "Produksjon av varer av papir og papp",
      "level": 3,
      "parentCode": "17"
    },
    {
      "code": "18.1",
      "name": "Trykking og tjenester tilknyttet trykking",
      "shortName": "Trykking, tilhørende tjenester",
      "level": 3,
      "parentCode": "18"
    },
    {
      "code": "18.2",
      "name": "Reproduksjon av innspilte opptak",
      "shortName": "Reproduksjon av innspilte opptak",
      "level": 3,
      "parentCode": "18"
    },
    {
      "code": "19.1",
      "name": "Produksjon av kullprodukter",
      "shortName": "Produksjon av kullprodukter",
      "level": 3,
      "parentCode": "19"
    },
    {
      "code": "19.2",
      "name": "Produksjon av raffinerte petroleumsprodukter",
      "shortName": "Prod. raffinerte petroleumsprodukt",
      "level": 3,
      "parentCode": "19"
    },
    {
      "code": "20.1",
      "name": "Produksjon av kjemiske råvarer, gjødsel og nitrogenforbindelser, basisplast og syntetisk gummi",
      "shortName": "Produksjon kjemiske råvarer mv.",
      "level": 3,
      "parentCode": "20"
    },
    {
      "code": "20.2",
      "name": "Produksjon av plantevern- og skadedyrmidler og andre landbrukskjemiske produkter",
      "shortName": "Produksjon landbrukskjemiske prod.",
      "level": 3,
      "parentCode": "20"
    },
    {
      "code": "20.3",
      "name": "Produksjon av maling og lakk, trykkfarger og tetningsmidler",
      "shortName": "Produksjon maling, lakk mv.",
      "level": 3,
      "parentCode": "20"
    },
    {
      "code": "20.4",
      "name": "Produksjon av såpe og vaskemidler, rense- og polermidler, parfyme og toalettartikler",
      "shortName": "Produksjon vaske- og toalettartikler",
      "level": 3,
      "parentCode": "20"
    },
    {
      "code": "20.5",
      "name": "Produksjon av andre kjemiske produkter",
      "shortName": "Produksjon andre kjemiske prod.",
      "level": 3,
      "parentCode": "20"
    },
    {
      "code": "20.6",
      "name": "Produksjon av kunstfibrer",
      "shortName": "Produksjon av kunstfibrer",
      "level": 3,
      "parentCode": "20"
    },
    {
      "code": "21.1",
      "name": "Produksjon av farmasøytiske råvarer",
      "shortName": "Farmasøytiske råvarer",
      "level": 3,
      "parentCode": "21"
    },
    {
      "code": "21.2",
      "name": "Produksjon av farmasøytiske preparater",
      "shortName": "Farmasøytiske preparater",
      "level": 3,
      "parentCode": "21"
    },
    {
      "code": "22.1",
      "name": "Produksjon av gummiprodukter",
      "shortName": "Produksjon av gummiprodukter",
      "level": 3,
      "parentCode": "22"
    },
    {
      "code": "22.2",
      "name": "Produksjon av plastprodukter",
      "shortName": "Produksjon av plastprodukter",
      "level": 3,
      "parentCode": "22"
    },
    {
      "code": "23.1",
      "name": "Produksjon av glass og glassprodukter",
      "shortName": "Produksjon av glass og glassprodukter",
      "level": 3,
      "parentCode": "23"
    },
    {
      "code": "23.2",
      "name": "Produksjon av ildfaste produkter",
      "shortName": "Prod. av ildfaste produkter",
      "level": 3,
      "parentCode": "23"
    },
    {
      "code": "23.3",
      "name": "Produksjon av byggevarer av brent leire",
      "shortName": "Prod. av byggevarer av brent leire",
      "level": 3,
      "parentCode": "23"
    },
    {
      "code": "23.4",
      "name": "Produksjon av andre porselensprodukter og keramiske produkter",
      "shortName": "Prod. av porselens-/keram.prod. el.",
      "level": 3,
      "parentCode": "23"
    },
    {
      "code": "23.5",
      "name": "Produksjon av sement, kalk og gips",
      "shortName": "Produksjon av sement, kalk og gips",
      "level": 3,
      "parentCode": "23"
    },
    {
      "code": "23.6",
      "name": "Produksjon av betong-, sement- og gipsprodukter",
      "shortName": "Prod. av betong-/sement-/gipsprod.",
      "level": 3,
      "parentCode": "23"
    },
    {
      "code": "23.7",
      "name": "Hogging og bearbeiding av monument- og bygningsstein",
      "shortName": "Hogg./bearb. av monum.-/bygn.stein",
      "level": 3,
      "parentCode": "23"
    },
    {
      "code": "23.9",
      "name": "Produksjon av ikke-metallholdige mineralprodukter ikke nevnt annet sted",
      "shortName": "Prod. ikke-metallholdige mineralprod.",
      "level": 3,
      "parentCode": "23"
    },
    {
      "code": "24.1",
      "name": "Produksjon av jern og stål, samt ferrolegeringer",
      "shortName": "Produksjon jern, stål, ferroleger.",
      "level": 3,
      "parentCode": "24"
    },
    {
      "code": "24.2",
      "name": "Produksjon av andre rør og rørdeler av stål",
      "shortName": "Annen rør- og rørdelprod. av stål",
      "level": 3,
      "parentCode": "24"
    },
    {
      "code": "24.3",
      "name": "Annen bearbeiding av jern og stål",
      "shortName": "Annen bearbeiding av jern og stål",
      "level": 3,
      "parentCode": "24"
    },
    {
      "code": "24.4",
      "name": "Produksjon av ikke-jernholdige metaller",
      "shortName": "Prod. av ikke-jernh. metaller",
      "level": 3,
      "parentCode": "24"
    },
    {
      "code": "24.5",
      "name": "Støping av metaller",
      "shortName": "Støping av metaller",
      "level": 3,
      "parentCode": "24"
    },
    {
      "code": "25.1",
      "name": "Produksjon av metallkonstruksjoner",
      "shortName": "Produksjon av metallkonstruksjoner",
      "level": 3,
      "parentCode": "25"
    },
    {
      "code": "25.2",
      "name": "Produksjon av tanker, cisterner og andre beholdere av metall",
      "shortName": "Tanker, cisterner, sentralvarmeanl.",
      "level": 3,
      "parentCode": "25"
    },
    {
      "code": "25.3",
      "name": "Produksjon av dampkjeler, unntatt kjeler til sentralvarmeanlegg",
      "shortName": "Dampkjeler unnt. sentralvarmeanl",
      "level": 3,
      "parentCode": "25"
    },
    {
      "code": "25.4",
      "name": "Produksjon av våpen og ammunisjon",
      "shortName": "Våpen- og ammunisjonsproduksjon",
      "level": 3,
      "parentCode": "25"
    },
    {
      "code": "25.5",
      "name": "Smiing, stansing og valsing av metall, og pulvermetallurgi",
      "shortName": "Stansing/valsing/pulvermetallurgi",
      "level": 3,
      "parentCode": "25"
    },
    {
      "code": "25.6",
      "name": "Overflatebehandling og bearbeiding av metaller",
      "shortName": "Overflatebeh./bearb. av metaller",
      "level": 3,
      "parentCode": "25"
    },
    {
      "code": "25.7",
      "name": "Produksjon av kjøkkenredskaper, skjære- og klipperedskaper, håndverktøy og andre jernvarer",
      "shortName": "Produksjon redskaper, andre jernvarer",
      "level": 3,
      "parentCode": "25"
    },
    {
      "code": "25.9",
      "name": "Produksjon av andre metallvarer",
      "shortName": "Produksjon av andre metallvarer",
      "level": 3,
      "parentCode": "25"
    },
    {
      "code": "26.1",
      "name": "Produksjon av elektroniske komponenter og kretskort",
      "shortName": "Elek. komponenter, kretskort",
      "level": 3,
      "parentCode": "26"
    },
    {
      "code": "26.2",
      "name": "Produksjon av datamaskiner og tilleggsutstyr",
      "shortName": "Prod. datamaskiner og tilleggsutstyr",
      "level": 3,
      "parentCode": "26"
    },
    {
      "code": "26.3",
      "name": "Produksjon av kommunikasjonsutstyr",
      "shortName": "Prod. av kommunikasjonsutstyr",
      "level": 3,
      "parentCode": "26"
    },
    {
      "code": "26.4",
      "name": "Produksjon av elektronikk til husholdningsbruk",
      "shortName": "Prod. av husholdningselektronikk",
      "level": 3,
      "parentCode": "26"
    },
    {
      "code": "26.5",
      "name": "Produksjon av måle-, kontroll- og navigasjonsinstrumenter, og klokker og ur",
      "shortName": "Måle- og kontrollinstrumenter",
      "level": 3,
      "parentCode": "26"
    },
    {
      "code": "26.6",
      "name": "Produksjon av strålingsutstyr, elektromedisinsk og elektroterapeutisk utstyr",
      "shortName": "Elektromed./elektroterap. utst. mv.",
      "level": 3,
      "parentCode": "26"
    },
    {
      "code": "26.7",
      "name": "Produksjon av optiske instrumenter og fotografisk utstyr",
      "shortName": "Optiske instr./fotografisk utstyr",
      "level": 3,
      "parentCode": "26"
    },
    {
      "code": "26.8",
      "name": "Produksjon av magnetiske og optiske media",
      "shortName": "Magnetiske/optiske media",
      "level": 3,
      "parentCode": "26"
    },
    {
      "code": "27.1",
      "name": "Produksjon av elektromotorer, generatorer, transformatorer og elektriske fordelings- og kontrolltavler og paneler",
      "shortName": "Elektromotorer, generatorer mv.",
      "level": 3,
      "parentCode": "27"
    },
    {
      "code": "27.2",
      "name": "Produksjon av batterier og akkumulatorer",
      "shortName": "Batterier, akkumulatorer",
      "level": 3,
      "parentCode": "27"
    },
    {
      "code": "27.3",
      "name": "Produksjon av ledninger og ledningsmateriell",
      "shortName": "Ledninger og ledningsmateriell",
      "level": 3,
      "parentCode": "27"
    },
    {
      "code": "27.4",
      "name": "Produksjon av belysningsutstyr",
      "shortName": "Prod. av belysningsutstyr",
      "level": 3,
      "parentCode": "27"
    },
    {
      "code": "27.5",
      "name": "Produksjon av husholdningsmaskiner og -apparater",
      "shortName": "Husholdningsmaskinproduksjon",
      "level": 3,
      "parentCode": "27"
    },
    {
      "code": "27.9",
      "name": "Produksjon av annet elektrisk utstyr",
      "shortName": "Produksjon elektrisk utstyr ellers",
      "level": 3,
      "parentCode": "27"
    },
    {
      "code": "28.1",
      "name": "Produksjon av maskiner og utstyr til generell bruk",
      "shortName": "Prod. mask. og utstyr generell bruk",
      "level": 3,
      "parentCode": "28"
    },
    {
      "code": "28.2",
      "name": "Produksjon av andre maskiner og annet utstyr til generell bruk",
      "shortName": "Annen maskinprod. for generell bruk",
      "level": 3,
      "parentCode": "28"
    },
    {
      "code": "28.3",
      "name": "Produksjon av jordbruks- og skogbruksmaskiner",
      "shortName": "Jord- og skogbruksmaskinproduksjon",
      "level": 3,
      "parentCode": "28"
    },
    {
      "code": "28.4",
      "name": "Produksjon av maskiner til metallbearbeiding og annet maskinverktøy",
      "shortName": "Mask.verktøy til metallbearb. mv.",
      "level": 3,
      "parentCode": "28"
    },
    {
      "code": "28.9",
      "name": "Produksjon av andre spesialmaskiner",
      "shortName": "Produksjon av andre spesialmaskiner",
      "level": 3,
      "parentCode": "28"
    },
    {
      "code": "29.1",
      "name": "Produksjon av motorvogner",
      "shortName": "Motorvognproduksjon",
      "level": 3,
      "parentCode": "29"
    },
    {
      "code": "29.2",
      "name": "Produksjon av karosserier og tilhengere",
      "shortName": "Karosseri- og tilhengerproduksjon",
      "level": 3,
      "parentCode": "29"
    },
    {
      "code": "29.3",
      "name": "Produksjon av deler og utstyr til motorvogner",
      "shortName": "Utstyr- og delprod. motorvogner",
      "level": 3,
      "parentCode": "29"
    },
    {
      "code": "30.1",
      "name": "Bygging av skip og båter",
      "shortName": "Bygging av skip og oljeplattformer",
      "level": 3,
      "parentCode": "30"
    },
    {
      "code": "30.2",
      "name": "Produksjon av lokomotiver og annet rullende materiell til jernbane og sporvei",
      "shortName": "Jernbane- og sporvognmateriell mv.",
      "level": 3,
      "parentCode": "30"
    },
    {
      "code": "30.3",
      "name": "Produksjon av luftfartøyer og romfartøyer og lignende utstyr",
      "shortName": "Prod. luft- og romfartøy og lignende",
      "level": 3,
      "parentCode": "30"
    },
    {
      "code": "30.4",
      "name": "Produksjon av militære stridskjøretøyer",
      "shortName": "Produksjon militære stridskjøretøy",
      "level": 3,
      "parentCode": "30"
    },
    {
      "code": "30.9",
      "name": "Produksjon av transportmidler ikke nevnt annet sted",
      "shortName": "Produksjon transportmidler ellers",
      "level": 3,
      "parentCode": "30"
    },
    {
      "code": "31.0",
      "name": "Produksjon av møbler",
      "shortName": "Produksjon av møbler",
      "level": 3,
      "parentCode": "31"
    },
    {
      "code": "32.1",
      "name": "Produksjon av gull- og sølvvarer, bijouteri og lignende artikler",
      "shortName": "Produksjon gull- og sølvvarer mv.",
      "level": 3,
      "parentCode": "32"
    },
    {
      "code": "32.2",
      "name": "Produksjon av musikkinstrumenter",
      "shortName": "Musikkinstrumentproduksjon",
      "level": 3,
      "parentCode": "32"
    },
    {
      "code": "32.3",
      "name": "Produksjon av sportsartikler",
      "shortName": "Sportsartikkelproduksjon",
      "level": 3,
      "parentCode": "32"
    },
    {
      "code": "32.4",
      "name": "Produksjon av spill og leker",
      "shortName": "Spill- og leketøyproduksjon",
      "level": 3,
      "parentCode": "32"
    },
    {
      "code": "32.5",
      "name": "Produksjon av medisinske og tanntekniske instrumenter og utstyr",
      "shortName": "Medisinske og tanntekniske instr.",
      "level": 3,
      "parentCode": "32"
    },
    {
      "code": "32.9",
      "name": "Industriproduksjon ikke nevnt annet sted",
      "shortName": "Industriproduksjon el.",
      "level": 3,
      "parentCode": "32"
    },
    {
      "code": "33.1",
      "name": "Reparasjon av metallvarer, maskiner og utstyr",
      "shortName": "Reparasjon metallvarer, maskiner mv.",
      "level": 3,
      "parentCode": "33"
    },
    {
      "code": "33.2",
      "name": "Installasjon av industrimaskiner og -utstyr",
      "shortName": "Installasjon industrimask., utstyr",
      "level": 3,
      "parentCode": "33"
    },
    {
      "code": "35.1",
      "name": "Produksjon, overføring og distribusjon av elektrisitet",
      "shortName": "El.prod., overføring og distrib.",
      "level": 3,
      "parentCode": "35"
    },
    {
      "code": "35.2",
      "name": "Produksjon av gass og distribusjon av gass gjennom ledningsnett",
      "shortName": "Produksjon gass gj. ledningsnett",
      "level": 3,
      "parentCode": "35"
    },
    {
      "code": "35.3",
      "name": "Damp- og varmtvannsforsyning",
      "shortName": "Damp- og varmtvannsforsyning",
      "level": 3,
      "parentCode": "35"
    },
    {
      "code": "36.0",
      "name": "Uttak fra kilde, rensing og distribusjon av vann",
      "shortName": "Vannforsyning",
      "level": 3,
      "parentCode": "36"
    },
    {
      "code": "37.0",
      "name": "Oppsamling og behandling av avløpsvann",
      "shortName": "Håndtering av avløpsvann",
      "level": 3,
      "parentCode": "37"
    },
    {
      "code": "38.1",
      "name": "Innsamling av avfall",
      "shortName": "Innsamling av avfall",
      "level": 3,
      "parentCode": "38"
    },
    {
      "code": "38.2",
      "name": "Behandling og disponering av avfall",
      "shortName": "Behandl. og disponering av avfall",
      "level": 3,
      "parentCode": "38"
    },
    {
      "code": "38.3",
      "name": "Materialgjenvinning",
      "shortName": "Materialgjenvinning",
      "level": 3,
      "parentCode": "38"
    },
    {
      "code": "39.0",
      "name": "Miljørydding, miljørensing og lignende virksomhet",
      "shortName": "Miljørydding og miljørensing",
      "level": 3,
      "parentCode": "39"
    },
    {
      "code": "41.1",
      "name": "Utvikling av byggeprosjekter",
      "shortName": "Utvikling av byggeprosjekter",
      "level": 3,
      "parentCode": "41"
    },
    {
      "code": "41.2",
      "name": "Oppføring av bygninger",
      "shortName": "Oppføring av bygninger",
      "level": 3,
      "parentCode": "41"
    },
    {
      "code": "42.1",
      "name": "Bygging av veier og jernbaner",
      "shortName": "Bygging av veier og jernbaner",
      "level": 3,
      "parentCode": "42"
    },
    {
      "code": "42.2",
      "name": "Bygging av vann- og kloakkanlegg, og anlegg for elektrisitet og telekommunikasjon",
      "shortName": "Vann-/kloakk-, el-. og telekom. anl.",
      "level": 3,
      "parentCode": "42"
    },
    {
      "code": "42.9",
      "name": "Bygging av andre anlegg",
      "shortName": "Bygging av andre anlegg",
      "level": 3,
      "parentCode": "42"
    },
    {
      "code": "43.1",
      "name": "Riving og grunnarbeid",
      "shortName": "Riving og grunnarbeid",
      "level": 3,
      "parentCode": "43"
    },
    {
      "code": "43.2",
      "name": "Elektrisk installasjonsarbeid, VVS-arbeid og annet installasjonsarbeid",
      "shortName": "El. install., VVS, annet installarb.",
      "level": 3,
      "parentCode": "43"
    },
    {
      "code": "43.3",
      "name": "Ferdiggjøring av bygninger",
      "shortName": "Ferdiggjøring av bygninger",
      "level": 3,
      "parentCode": "43"
    },
    {
      "code": "43.9",
      "name": "Annen spesialisert bygge- og anleggsvirksomhet",
      "shortName": "Annen spes. bygge- og anleggsvirks.",
      "level": 3,
      "parentCode": "43"
    },
    {
      "code": "45.1",
      "name": "Handel med motorvogner, unntatt motorsykler",
      "shortName": "Motorvognhandel, unnt. motorsykler",
      "level": 3,
      "parentCode": "45"
    },
    {
      "code": "45.2",
      "name": "Vedlikehold og reparasjon av motorvogner, unntatt motorsykler",
      "shortName": "Rep. av motorvogner/unnt. motorsyk.",
      "level": 3,
      "parentCode": "45"
    },
    {
      "code": "45.3",
      "name": "Handel med deler og utstyr til motorvogner, unntatt motorsykler",
      "shortName": "Del-/utstyrshdl. til motorvogner",
      "level": 3,
      "parentCode": "45"
    },
    {
      "code": "45.4",
      "name": "Handel med motorsykler, deler og utstyr. Vedlikehold og reparasjon av motorsykler",
      "shortName": "Motorsykkelhandel og -rep. mv.",
      "level": 3,
      "parentCode": "45"
    },
    {
      "code": "46.1",
      "name": "Agenturhandel",
      "shortName": "Agenturhandel",
      "level": 3,
      "parentCode": "46"
    },
    {
      "code": "46.2",
      "name": "Engroshandel med jordbruksråvarer og levende dyr",
      "shortName": "Engrosh. jordbr.råvarer og lev. dyr",
      "level": 3,
      "parentCode": "46"
    },
    {
      "code": "46.3",
      "name": "Engroshandel med nærings- og nytelsesmidler",
      "shortName": "Engrosh., nærings- og nytelsesmidler",
      "level": 3,
      "parentCode": "46"
    },
    {
      "code": "46.4",
      "name": "Engroshandel med husholdningsvarer og varer til personlig bruk",
      "shortName": "Engrosh. hush.- og varer pers. bruk",
      "level": 3,
      "parentCode": "46"
    },
    {
      "code": "46.5",
      "name": "Engroshandel med IKT-utstyr",
      "shortName": "Engrosh. IKT-utstyr",
      "level": 3,
      "parentCode": "46"
    },
    {
      "code": "46.6",
      "name": "Engroshandel med andre maskiner og annet utstyr",
      "shortName": "Engrosh. mask. og utstyr el",
      "level": 3,
      "parentCode": "46"
    },
    {
      "code": "46.7",
      "name": "Engroshandel med spesialisert vareutvalg ellers",
      "shortName": "Engrosh. med spes. vareutvalg el.",
      "level": 3,
      "parentCode": "46"
    },
    {
      "code": "46.9",
      "name": "Uspesifisert engroshandel",
      "shortName": "Uspesifisert engroshandel",
      "level": 3,
      "parentCode": "46"
    },
    {
      "code": "47.1",
      "name": "Butikkhandel med bredt vareutvalg",
      "shortName": "Butikkh. med bredt vareutvalg",
      "level": 3,
      "parentCode": "47"
    },
    {
      "code": "47.2",
      "name": "Butikkhandel med nærings- og nytelsesmidler i spesialforretninger",
      "shortName": "Spesialforr. nær.- og nytelsesmidl.",
      "level": 3,
      "parentCode": "47"
    },
    {
      "code": "47.3",
      "name": "Detaljhandel med drivstoff til motorvogner",
      "shortName": "Detaljh. drivstoff til motorvogner",
      "level": 3,
      "parentCode": "47"
    },
    {
      "code": "47.4",
      "name": "Butikkhandel med IKT-utstyr i spesialforretninger",
      "shortName": "Butikkh. med IKT-utstyr",
      "level": 3,
      "parentCode": "47"
    },
    {
      "code": "47.5",
      "name": "Butikkhandel med andre husholdningsvarer i spesialforretninger",
      "shortName": "Butikkh. med andre husholdningsvarer",
      "level": 3,
      "parentCode": "47"
    },
    {
      "code": "47.6",
      "name": "Butikkhandel med bøker, musikkartikler og andre fritidsartikler i spesialforretninger",
      "shortName": "Butikkh. med bøker, musikkart. etc.",
      "level": 3,
      "parentCode": "47"
    },
    {
      "code": "47.7",
      "name": "Annen butikkhandel i spesialforretninger",
      "shortName": "Annen butikkhandel",
      "level": 3,
      "parentCode": "47"
    },
    {
      "code": "47.8",
      "name": "Torghandel",
      "shortName": "Torghandel",
      "level": 3,
      "parentCode": "47"
    },
    {
      "code": "47.9",
      "name": "Detaljhandel utenom utsalgssted",
      "shortName": "Detaljh. utenom utsalgssted",
      "level": 3,
      "parentCode": "47"
    },
    {
      "code": "49.1",
      "name": "Passasjertransport med jernbane",
      "shortName": "Passasjertransp. med jernbane",
      "level": 3,
      "parentCode": "49"
    },
    {
      "code": "49.2",
      "name": "Godstransport med jernbane",
      "shortName": "Godstransp. med jernbane",
      "level": 3,
      "parentCode": "49"
    },
    {
      "code": "49.3",
      "name": "Annen landtransport med passasjerer",
      "shortName": "Annen landtransp. med passasjerer",
      "level": 3,
      "parentCode": "49"
    },
    {
      "code": "49.4",
      "name": "Godstransport på vei, herunder flyttetransport",
      "shortName": "Godstransp. på vei/flyttetransport",
      "level": 3,
      "parentCode": "49"
    },
    {
      "code": "49.5",
      "name": "Rørtransport",
      "shortName": "Rørtransport",
      "level": 3,
      "parentCode": "49"
    },
    {
      "code": "50.1",
      "name": "Sjøfart og kysttrafikk med passasjerer",
      "shortName": "Sjøfart og kysttraf. m/passasjerer",
      "level": 3,
      "parentCode": "50"
    },
    {
      "code": "50.2",
      "name": "Sjøfart og kysttrafikk med gods",
      "shortName": "Sjøfart og kysttrafikk med gods",
      "level": 3,
      "parentCode": "50"
    },
    {
      "code": "50.3",
      "name": "Passasjertransport på elver og innsjøer",
      "shortName": "Passasjertr. på elver og innsjøer",
      "level": 3,
      "parentCode": "50"
    },
    {
      "code": "50.4",
      "name": "Godstransport på elver og innsjøer",
      "shortName": "Godstransp. på elver og innsjøer",
      "level": 3,
      "parentCode": "50"
    },
    {
      "code": "51.1",
      "name": "Lufttransport med passasjerer",
      "shortName": "Lufttransp. med passasjerer",
      "level": 3,
      "parentCode": "51"
    },
    {
      "code": "51.2",
      "name": "Lufttransport med gods samt romfart",
      "shortName": "Lufttransp. med gods samt romfart",
      "level": 3,
      "parentCode": "51"
    },
    {
      "code": "52.1",
      "name": "Lagring",
      "shortName": "Lagring",
      "level": 3,
      "parentCode": "52"
    },
    {
      "code": "52.2",
      "name": "Andre tjenester tilknyttet transport",
      "shortName": "Andre tjenester tilkn. transport",
      "level": 3,
      "parentCode": "52"
    },
    {
      "code": "53.1",
      "name": "Landsdekkende posttjenester",
      "shortName": "Landsdekkende posttjenester",
      "level": 3,
      "parentCode": "53"
    },
    {
      "code": "53.2",
      "name": "Andre post- og budtjenester",
      "shortName": "Andre post- og budtjenester",
      "level": 3,
      "parentCode": "53"
    },
    {
      "code": "55.1",
      "name": "Hotellvirksomhet",
      "shortName": "Hotellvirksomhet",
      "level": 3,
      "parentCode": "55"
    },
    {
      "code": "55.2",
      "name": "Drift av vandrerhjem og ferieleiligheter",
      "shortName": "Drift av vandrerhjem/ferieleil.",
      "level": 3,
      "parentCode": "55"
    },
    {
      "code": "55.3",
      "name": "Drift av campingplasser",
      "shortName": "Drift av campingplasser",
      "level": 3,
      "parentCode": "55"
    },
    {
      "code": "55.9",
      "name": "Annen overnatting",
      "shortName": "Annen overnatting",
      "level": 3,
      "parentCode": "55"
    },
    {
      "code": "56.1",
      "name": "Restaurantvirksomhet",
      "shortName": "Restaurantvirksomhet",
      "level": 3,
      "parentCode": "56"
    },
    {
      "code": "56.2",
      "name": "Cateringvirksomhet og kantiner drevet som selvstendig virksomhet",
      "shortName": "Catering- og kantinevirksomhet",
      "level": 3,
      "parentCode": "56"
    },
    {
      "code": "56.3",
      "name": "Drift av barer",
      "shortName": "Drift av barer",
      "level": 3,
      "parentCode": "56"
    },
    {
      "code": "58.1",
      "name": "Utgivelse av bøker, tidsskrifter og annen forlagsvirksomhet",
      "shortName": "Utgiv. av bøker, tidsskrifter etc.",
      "level": 3,
      "parentCode": "58"
    },
    {
      "code": "58.2",
      "name": "Utgivelse av programvare",
      "shortName": "Utgivelse av programvare",
      "level": 3,
      "parentCode": "58"
    },
    {
      "code": "59.1",
      "name": "Virksomhet innen film, video og fjernsynsprogrammer",
      "shortName": "Virks. innen film/video/tv-program.",
      "level": 3,
      "parentCode": "59"
    },
    {
      "code": "59.2",
      "name": "Produksjon og utgivelse av musikk- og lydopptak",
      "shortName": "Prod./utgiv. av musikk-/lydopptak",
      "level": 3,
      "parentCode": "59"
    },
    {
      "code": "60.1",
      "name": "Radiokringkasting",
      "shortName": "Radiokringkasting",
      "level": 3,
      "parentCode": "60"
    },
    {
      "code": "60.2",
      "name": "Fjernsynskringkasting",
      "shortName": "Fjernsynskringkasting",
      "level": 3,
      "parentCode": "60"
    },
    {
      "code": "61.1",
      "name": "Kabelbasert telekommunikasjon",
      "shortName": "Kabelbasert telekomm.",
      "level": 3,
      "parentCode": "61"
    },
    {
      "code": "61.2",
      "name": "Trådløs telekommunikasjon",
      "shortName": "Trådløs telekomm.",
      "level": 3,
      "parentCode": "61"
    },
    {
      "code": "61.3",
      "name": "Satellittbasert telekommunikasjon",
      "shortName": "Satellittbasert telekomm.",
      "level": 3,
      "parentCode": "61"
    },
    {
      "code": "61.9",
      "name": "Telekommunikasjon ellers",
      "shortName": "Telekommunikasjon ellers",
      "level": 3,
      "parentCode": "61"
    },
    {
      "code": "62.0",
      "name": "Tjenester tilknyttet informasjonsteknologi",
      "shortName": "Tjen. tilkn. informasjonsteknologi",
      "level": 3,
      "parentCode": "62"
    },
    {
      "code": "63.1",
      "name": "Databehandling, datalagring og tilknyttede tjenester, drift av web-portaler",
      "shortName": "Databeh./datalagr./web-portaler",
      "level": 3,
      "parentCode": "63"
    },
    {
      "code": "63.9",
      "name": "Andre informasjonstjenester",
      "shortName": "Andre informasjonstjenester",
      "level": 3,
      "parentCode": "63"
    },
    {
      "code": "64.1",
      "name": "Bankvirksomhet",
      "shortName": "Bankvirksomhet",
      "level": 3,
      "parentCode": "64"
    },
    {
      "code": "64.2",
      "name": "Holdingselskaper",
      "shortName": "Holdingselskaper",
      "level": 3,
      "parentCode": "64"
    },
    {
      "code": "64.3",
      "name": "Verdipapirfond, investeringsselskaper o.l.",
      "shortName": "Verdipapirfond/invest.selskap o.l.",
      "level": 3,
      "parentCode": "64"
    },
    {
      "code": "64.9",
      "name": "Annen finansieringsvirksomhet",
      "shortName": "Annen finansieringsvirksomhet",
      "level": 3,
      "parentCode": "64"
    },
    {
      "code": "65.1",
      "name": "Forsikring",
      "shortName": "Forsikring",
      "level": 3,
      "parentCode": "65"
    },
    {
      "code": "65.2",
      "name": "Gjenforsikring",
      "shortName": "Gjenforsikring",
      "level": 3,
      "parentCode": "65"
    },
    {
      "code": "65.3",
      "name": "Pensjonskasser",
      "shortName": "Pensjonskasser",
      "level": 3,
      "parentCode": "65"
    },
    {
      "code": "66.1",
      "name": "Tjenester tilknyttet finansieringsvirksomhet",
      "shortName": "Tjen. tilkn. finansieringsvirks.",
      "level": 3,
      "parentCode": "66"
    },
    {
      "code": "66.2",
      "name": "Tjenester tilknyttet forsikringsvirksomhet og pensjonskasser",
      "shortName": "Tjen. til forsikr./pensjonskasser",
      "level": 3,
      "parentCode": "66"
    },
    {
      "code": "66.3",
      "name": "Fondsforvaltningsvirksomhet",
      "shortName": "Fondsforvaltningsvirksomhet",
      "level": 3,
      "parentCode": "66"
    },
    {
      "code": "68.1",
      "name": "Kjøp og salg av egen fast eiendom",
      "shortName": "Kjøp/salg av egen fast eiendom",
      "level": 3,
      "parentCode": "68"
    },
    {
      "code": "68.2",
      "name": "Utleie av egen eller leid fast eiendom",
      "shortName": "Utleie av egen/leid fast eiendom",
      "level": 3,
      "parentCode": "68"
    },
    {
      "code": "68.3",
      "name": "Omsetning og drift av fast eiendom på oppdrag",
      "shortName": "Oppdragsvirksomhet for fast eiendom",
      "level": 3,
      "parentCode": "68"
    },
    {
      "code": "69.1",
      "name": "Juridisk tjenesteyting",
      "shortName": "Juridisk tjenesteyting",
      "level": 3,
      "parentCode": "69"
    },
    {
      "code": "69.2",
      "name": "Regnskap, revisjon og skatterådgivning",
      "shortName": "Regnskap/revisjon/skatterådgiv.",
      "level": 3,
      "parentCode": "69"
    },
    {
      "code": "70.1",
      "name": "Hovedkontortjenester",
      "shortName": "Hovedkontortjenester",
      "level": 3,
      "parentCode": "70"
    },
    {
      "code": "70.2",
      "name": "Administrativ rådgivning",
      "shortName": "Administrativ rådgivning",
      "level": 3,
      "parentCode": "70"
    },
    {
      "code": "71.1",
      "name": "Arkitektvirksomhet og teknisk konsulentvirksomhet",
      "shortName": "Arkitekt- og tekn. konsulentvirks.",
      "level": 3,
      "parentCode": "71"
    },
    {
      "code": "71.2",
      "name": "Teknisk prøving og analyse",
      "shortName": "Teknisk prøving og analyse",
      "level": 3,
      "parentCode": "71"
    },
    {
      "code": "72.1",
      "name": "Forskning og utviklingsarbeid innen naturvitenskap og teknikk",
      "shortName": "Forskning naturvitenskap, teknikk",
      "level": 3,
      "parentCode": "72"
    },
    {
      "code": "72.2",
      "name": "Forskning og utviklingsarbeid innen samfunnsvitenskap og humanistiske fag",
      "shortName": "Forskning samfunnsvit., human. fag",
      "level": 3,
      "parentCode": "72"
    },
    {
      "code": "73.1",
      "name": "Annonse- og reklamevirksomhet",
      "shortName": "Annonse- og reklamevirksomhet",
      "level": 3,
      "parentCode": "73"
    },
    {
      "code": "73.2",
      "name": "Markeds- og opinionsundersøkelser",
      "shortName": "Markeds- og opinionsundersøkelser",
      "level": 3,
      "parentCode": "73"
    },
    {
      "code": "74.1",
      "name": "Spesialisert designvirksomhet",
      "shortName": "Spesialisert designvirksomhet",
      "level": 3,
      "parentCode": "74"
    },
    {
      "code": "74.2",
      "name": "Fotografvirksomhet",
      "shortName": "Fotografvirksomhet",
      "level": 3,
      "parentCode": "74"
    },
    {
      "code": "74.3",
      "name": "Oversettelses- og tolkevirksomhet",
      "shortName": "Oversettelses- og tolkevirksomhet",
      "level": 3,
      "parentCode": "74"
    },
    {
      "code": "74.9",
      "name": "Annen faglig, vitenskapelig og teknisk virksomhet",
      "shortName": "Annen faglig/vit.skap./tekn. virks.",
      "level": 3,
      "parentCode": "74"
    },
    {
      "code": "75.0",
      "name": "Veterinærtjenester",
      "shortName": "Veterinærtjenester",
      "level": 3,
      "parentCode": "75"
    },
    {
      "code": "77.1",
      "name": "Utleie og leasing av motorvogner",
      "shortName": "Bilutleie",
      "level": 3,
      "parentCode": "77"
    },
    {
      "code": "77.2",
      "name": "Utleie og leasing av husholdningsvarer og varer til personlig bruk",
      "shortName": "Utl. hush.varer og varer pers. bruk",
      "level": 3,
      "parentCode": "77"
    },
    {
      "code": "77.3",
      "name": "Utleie og leasing av andre maskiner, og annet utstyr og materiell",
      "shortName": "Utleie av maskiner og utstyr ellers",
      "level": 3,
      "parentCode": "77"
    },
    {
      "code": "77.4",
      "name": "Leasing av immateriell eiendom og lignende produkter, unntatt opphavsrettsbeskyttede verker",
      "shortName": "Leas. av immateriell eiendom mv.",
      "level": 3,
      "parentCode": "77"
    },
    {
      "code": "78.1",
      "name": "Rekruttering og formidling av arbeidskraft",
      "shortName": "Rekrutt./formidling av arbeidskraft",
      "level": 3,
      "parentCode": "78"
    },
    {
      "code": "78.2",
      "name": "Utleie av arbeidskraft",
      "shortName": "Utleie av arbeidskraft",
      "level": 3,
      "parentCode": "78"
    },
    {
      "code": "78.3",
      "name": "Andre personaladministrative tjenester",
      "shortName": "Andre personaladm. tjen.",
      "level": 3,
      "parentCode": "78"
    },
    {
      "code": "79.1",
      "name": "Reisebyrå- og reisearrangørvirksomhet",
      "shortName": "Reisebyrå- og reisearrangørvirks.",
      "level": 3,
      "parentCode": "79"
    },
    {
      "code": "79.9",
      "name": "Annen arrangørvirksomhet og tilknyttede tjenester",
      "shortName": "Annen arrangørvirks. og tilkn.tjen.",
      "level": 3,
      "parentCode": "79"
    },
    {
      "code": "80.1",
      "name": "Private vakttjenester",
      "shortName": "Private vakttjenester",
      "level": 3,
      "parentCode": "80"
    },
    {
      "code": "80.2",
      "name": "Tjenester tilknyttet vakttjenester",
      "shortName": "Tjenester tilknyttet vakttjenester",
      "level": 3,
      "parentCode": "80"
    },
    {
      "code": "80.3",
      "name": "Etterforsking",
      "shortName": "Etterforsking",
      "level": 3,
      "parentCode": "80"
    },
    {
      "code": "81.1",
      "name": "Kombinerte tjenester tilknyttet eiendomsdrift",
      "shortName": "Komb. tjen. tilkn. eiendomsdrift",
      "level": 3,
      "parentCode": "81"
    },
    {
      "code": "81.2",
      "name": "Rengjøringsvirksomhet",
      "shortName": "Rengjøringsvirksomhet",
      "level": 3,
      "parentCode": "81"
    },
    {
      "code": "81.3",
      "name": "Beplantning av hager og parkanlegg",
      "shortName": "Beplantning av hager og parkanl.",
      "level": 3,
      "parentCode": "81"
    },
    {
      "code": "82.1",
      "name": "Kontortjenester",
      "shortName": "Kontortjenester",
      "level": 3,
      "parentCode": "82"
    },
    {
      "code": "82.2",
      "name": "Telefonvakttjenester og telefonsalg",
      "shortName": "Telefonvakttjenester/telefonsalg",
      "level": 3,
      "parentCode": "82"
    },
    {
      "code": "82.3",
      "name": "Kongress-, messe- og utstillingsvirksomhet",
      "shortName": "Kongress-/messe-/utstillingsvirks.",
      "level": 3,
      "parentCode": "82"
    },
    {
      "code": "82.9",
      "name": "Forretningsmessig tjenesteyting ikke nevnt annet sted",
      "shortName": "Annen forretningsmessig tj.yting",
      "level": 3,
      "parentCode": "82"
    },
    {
      "code": "84.1",
      "name": "Offentlig administrasjon og forvaltning",
      "shortName": "Off. administrasjon, forvaltning",
      "level": 3,
      "parentCode": "84"
    },
    {
      "code": "84.2",
      "name": "Offentlig administrasjon tilknyttet utenriks- og sikkerhetssaker",
      "shortName": "Off.adm. utenriks-/sikkerhetssaker",
      "level": 3,
      "parentCode": "84"
    },
    {
      "code": "84.3",
      "name": "Trygdeordninger underlagt offentlig forvaltning",
      "shortName": "Sosialforsikring, trygd",
      "level": 3,
      "parentCode": "84"
    },
    {
      "code": "85.1",
      "name": "Førskoleundervisning",
      "shortName": "Førskoleundervisning",
      "level": 3,
      "parentCode": "85"
    },
    {
      "code": "85.2",
      "name": "Grunnskoleundervisning",
      "shortName": "Grunnskoleundervisning",
      "level": 3,
      "parentCode": "85"
    },
    {
      "code": "85.3",
      "name": "Undervisning på videregående skoles nivå",
      "shortName": "Undervisning videregående skoler",
      "level": 3,
      "parentCode": "85"
    },
    {
      "code": "85.4",
      "name": "Undervisning i høyere utdanning",
      "shortName": "Undervisning i høyere utdanning",
      "level": 3,
      "parentCode": "85"
    },
    {
      "code": "85.5",
      "name": "Annen undervisning",
      "shortName": "Annen undervisning",
      "level": 3,
      "parentCode": "85"
    },
    {
      "code": "85.6",
      "name": "Tjenester tilknyttet undervisning",
      "shortName": "Tjenester tilkn. undervisning",
      "level": 3,
      "parentCode": "85"
    },
    {
      "code": "86.1",
      "name": "Sykehustjenester",
      "shortName": "Sykehustjenester",
      "level": 3,
      "parentCode": "86"
    },
    {
      "code": "86.2",
      "name": "Lege- og tannlegetjenester",
      "shortName": "Lege- og tannlegetjenester",
      "level": 3,
      "parentCode": "86"
    },
    {
      "code": "86.9",
      "name": "Andre helsetjenester",
      "shortName": "Andre helsetjenester",
      "level": 3,
      "parentCode": "86"
    },
    {
      "code": "87.1",
      "name": "Pleie- og omsorgstjenester i institusjon",
      "shortName": "Pleie- og omsorg i institusjon",
      "level": 3,
      "parentCode": "87"
    },
    {
      "code": "87.2",
      "name": "Institusjoner og bofellesskap innen omsorg for psykisk utviklingshemmede, psykisk helsearbeid og rusmiddelomsorg",
      "shortName": "Inst./bof.skap psyk.utv.hem. mv.",
      "level": 3,
      "parentCode": "87"
    },
    {
      "code": "87.3",
      "name": "Institusjoner og bofellesskap innen omsorg for eldre og funksjonshemmede",
      "shortName": "Inst./bofellesskap eldre/funksj.hem.",
      "level": 3,
      "parentCode": "87"
    },
    {
      "code": "87.9",
      "name": "Andre omsorgsinstitusjoner",
      "shortName": "Andre omsorgsinstitusjoner",
      "level": 3,
      "parentCode": "87"
    },
    {
      "code": "88.1",
      "name": "Sosialtjenester uten botilbud for eldre og funksjonshemmede",
      "shortName": "Sosialtj. u/botilbud eldre/funksj.hem",
      "level": 3,
      "parentCode": "88"
    },
    {
      "code": "88.9",
      "name": "Andre sosialtjenester uten botilbud",
      "shortName": "Andre sosialtjen. uten botilbud",
      "level": 3,
      "parentCode": "88"
    },
    {
      "code": "90.0",
      "name": "Kunstnerisk virksomhet og underholdningsvirksomhet",
      "shortName": "Kunstnerisk virks. og underholdning",
      "level": 3,
      "parentCode": "90"
    },
    {
      "code": "91.0",
      "name": "Drift av biblioteker, arkiver, museer og annen kulturvirksomhet",
      "shortName": "Bibliotek, muséer o.a. kulturvirks.",
      "level": 3,
      "parentCode": "91"
    },
    {
      "code": "92.0",
      "name": "Lotteri og totalisatorspill",
      "shortName": "Lotteri og totalisatorspill",
      "level": 3,
      "parentCode": "92"
    },
    {
      "code": "93.1",
      "name": "Sportsaktiviteter",
      "shortName": "Sportsaktiviteter",
      "level": 3,
      "parentCode": "93"
    },
    {
      "code": "93.2",
      "name": "Fritidsaktiviteter og drift av fornøyelsesetablissementer",
      "shortName": "Fritidsaktiviteter, fornøyelsesetabl.",
      "level": 3,
      "parentCode": "93"
    },
    {
      "code": "94.1",
      "name": "Næringslivs- og arbeidsgiverorganisasjoner og yrkessammenslutninger",
      "shortName": "Næringslivs-/arbeidsgiverorg mv.",
      "level": 3,
      "parentCode": "94"
    },
    {
      "code": "94.2",
      "name": "Arbeidstakerorganisasjoner",
      "shortName": "Arbeidstakerorganisasjoner",
      "level": 3,
      "parentCode": "94"
    },
    {
      "code": "94.9",
      "name": "Aktiviteter i andre medlemsorganisasjoner",
      "shortName": "Aktiviteter i andre medlemsorg.",
      "level": 3,
      "parentCode": "94"
    },
    {
      "code": "95.1",
      "name": "Reparasjon av datamaskiner og kommunikasjonsutstyr",
      "shortName": "Rep. av datamaskiner og komm.utstyr",
      "level": 3,
      "parentCode": "95"
    },
    {
      "code": "95.2",
      "name": "Reparasjon av husholdningsvarer og varer til personlig bruk",
      "shortName": "Reparasjon varer personlig bruk",
      "level": 3,
      "parentCode": "95"
    },
    {
      "code": "96.0",
      "name": "Annen personlig tjenesteyting",
      "shortName": "Annen personlig tjenesteyting",
      "level": 3,
      "parentCode": "96"
    },
    {
      "code": "97.0",
      "name": "Lønnet arbeid i private husholdninger",
      "shortName": "Lønnet arbeid i private husholdn.",
      "level": 3,
      "parentCode": "97"
    },
    {
      "code": "99.0",
      "name": "Internasjonale organisasjoner og organer",
      "shortName": "Internasjonale organer",
      "level": 3,
      "parentCode": "99"
    }
  ],
  "level4": [
    {
      "code": "01.11",
      "name": "Dyrking av korn (unntatt ris), belgvekster og oljeholdige vekster",
      "shortName": "Dyrking av korn, belgvekster mv.",
      "level": 4,
      "parentCode": "01.1"
    },
    {
      "code": "01.12",
      "name": "Dyrking av ris",
      "shortName": "Dyrking av ris",
      "level": 4,
      "parentCode": "01.1"
    },
    {
      "code": "01.13",
      "name": "Dyrking av grønnsaker, meloner, rot- og knollvekster",
      "shortName": "Dyrking av grønnsaker, poteter mv.",
      "level": 4,
      "parentCode": "01.1"
    },
    {
      "code": "01.14",
      "name": "Dyrking av sukkerrør",
      "shortName": "Dyrking av sukkerrør",
      "level": 4,
      "parentCode": "01.1"
    },
    {
      "code": "01.15",
      "name": "Dyrking av tobakk",
      "shortName": "Dyrking av tobakk",
      "level": 4,
      "parentCode": "01.1"
    },
    {
      "code": "01.16",
      "name": "Dyrking av fibervekster",
      "shortName": "Dyrking av fibervekster",
      "level": 4,
      "parentCode": "01.1"
    },
    {
      "code": "01.19",
      "name": "Dyrking av ettårige vekster ellers",
      "shortName": "Dyrking av ettårige vekster ellers",
      "level": 4,
      "parentCode": "01.1"
    },
    {
      "code": "01.21",
      "name": "Dyrking av druer",
      "shortName": "Dyrking av druer",
      "level": 4,
      "parentCode": "01.2"
    },
    {
      "code": "01.22",
      "name": "Dyrking av tropiske og subtropiske frukter",
      "shortName": "Dyrking av trop./subtrop. frukter",
      "level": 4,
      "parentCode": "01.2"
    },
    {
      "code": "01.23",
      "name": "Dyrking av sitrusfrukter",
      "shortName": "Dyrking av sitrusfrukter",
      "level": 4,
      "parentCode": "01.2"
    },
    {
      "code": "01.24",
      "name": "Dyrking av kjernefrukter og steinfrukter",
      "shortName": "Dyrking av kjerne- og steinfrukter",
      "level": 4,
      "parentCode": "01.2"
    },
    {
      "code": "01.25",
      "name": "Dyrking av annen frukt som vokser på trær eller busker samt nøtter",
      "shortName": "Dyrking av bær og nøtter mv.",
      "level": 4,
      "parentCode": "01.2"
    },
    {
      "code": "01.26",
      "name": "Dyrking av oljeholdige frukter",
      "shortName": "Dyrking av oljeholdige frukter",
      "level": 4,
      "parentCode": "01.2"
    },
    {
      "code": "01.27",
      "name": "Dyrking av vekster for produksjon av drikkevarer",
      "shortName": "Dyrk. vekster for prod. av drikkev.",
      "level": 4,
      "parentCode": "01.2"
    },
    {
      "code": "01.28",
      "name": "Dyrking av krydder og aromatiske, medisinske og farmasøytiske vekster",
      "shortName": "Dyrking av krydder mv.",
      "level": 4,
      "parentCode": "01.2"
    },
    {
      "code": "01.29",
      "name": "Dyrking av flerårige vekster ellers",
      "shortName": "Dyrking av flerårige vekster ellers",
      "level": 4,
      "parentCode": "01.2"
    },
    {
      "code": "01.30",
      "name": "Planteformering",
      "shortName": "Planteformering",
      "level": 4,
      "parentCode": "01.3"
    },
    {
      "code": "01.41",
      "name": "Melkeproduksjon på storfe",
      "shortName": "Melkeproduksjon på storfe",
      "level": 4,
      "parentCode": "01.4"
    },
    {
      "code": "01.42",
      "name": "Oppdrett av annet storfe",
      "shortName": "Oppdrett av annet storfe",
      "level": 4,
      "parentCode": "01.4"
    },
    {
      "code": "01.43",
      "name": "Oppdrett av hester og andre dyr av hestefamilien",
      "shortName": "Oppdrett av hester, esler o.l.",
      "level": 4,
      "parentCode": "01.4"
    },
    {
      "code": "01.44",
      "name": "Oppdrett av kameler og andre kameldyr",
      "shortName": "Oppdrett av kameler og kameldyr el.",
      "level": 4,
      "parentCode": "01.4"
    },
    {
      "code": "01.45",
      "name": "Saue- og geitehold",
      "shortName": "Saue- og geitehold",
      "level": 4,
      "parentCode": "01.4"
    },
    {
      "code": "01.46",
      "name": "Svinehold",
      "shortName": "Svinehold",
      "level": 4,
      "parentCode": "01.4"
    },
    {
      "code": "01.47",
      "name": "Fjørfehold",
      "shortName": "Fjørfehold",
      "level": 4,
      "parentCode": "01.4"
    },
    {
      "code": "01.49",
      "name": "Husdyrhold ellers",
      "shortName": "Husdyrhold ellers",
      "level": 4,
      "parentCode": "01.4"
    },
    {
      "code": "01.50",
      "name": "Kombinert husdyrhold og planteproduksjon",
      "shortName": "Komb. husdyrhold og planteprod.",
      "level": 4,
      "parentCode": "01.5"
    },
    {
      "code": "01.61",
      "name": "Tjenester tilknyttet planteproduksjon",
      "shortName": "Tjenester tilknyttet planteprod.",
      "level": 4,
      "parentCode": "01.6"
    },
    {
      "code": "01.62",
      "name": "Tjenester tilknyttet husdyrhold",
      "shortName": "Tjenester tilknyttet husdyrhold",
      "level": 4,
      "parentCode": "01.6"
    },
    {
      "code": "01.63",
      "name": "Etterbehandling av vekster etter innhøsting",
      "shortName": "Etterbeh. av vekster etter innhøst.",
      "level": 4,
      "parentCode": "01.6"
    },
    {
      "code": "01.64",
      "name": "Behandling av såfrø",
      "shortName": "Behandling av såfrø",
      "level": 4,
      "parentCode": "01.6"
    },
    {
      "code": "01.70",
      "name": "Jakt, viltstell og tjenester tilknyttet jakt og viltstell",
      "shortName": "Jakt, viltstell og tilkn. tjenester",
      "level": 4,
      "parentCode": "01.7"
    },
    {
      "code": "02.10",
      "name": "Skogskjøtsel og andre skogbruksaktiviteter",
      "shortName": "Skogskjøtsel, andre skogbruksakt.",
      "level": 4,
      "parentCode": "02.1"
    },
    {
      "code": "02.20",
      "name": "Avvirkning",
      "shortName": "Avvirkning",
      "level": 4,
      "parentCode": "02.2"
    },
    {
      "code": "02.30",
      "name": "Innsamling av viltvoksende produkter av annet enn tre",
      "shortName": "Innsaml. av sopp, bær, mose etc.",
      "level": 4,
      "parentCode": "02.3"
    },
    {
      "code": "02.40",
      "name": "Tjenester tilknyttet skogbruk",
      "shortName": "Tjenester tilknyttet skogbruk",
      "level": 4,
      "parentCode": "02.4"
    },
    {
      "code": "03.11",
      "name": "Hav- og kystfiske og fangst",
      "shortName": "Hav- og kystfiske og fangst",
      "level": 4,
      "parentCode": "03.1"
    },
    {
      "code": "03.12",
      "name": "Ferskvannsfiske",
      "shortName": "Ferskvannsfiske",
      "level": 4,
      "parentCode": "03.1"
    },
    {
      "code": "03.21",
      "name": "Hav- og kystbasert akvakultur",
      "shortName": "Hav- og kystbasert akvakultur",
      "level": 4,
      "parentCode": "03.2"
    },
    {
      "code": "03.22",
      "name": "Ferskvannsbasert akvakultur",
      "shortName": "Ferskvannsbasert akvakultur",
      "level": 4,
      "parentCode": "03.2"
    },
    {
      "code": "05.10",
      "name": "Bryting av steinkull",
      "shortName": "Bryting av steinkull",
      "level": 4,
      "parentCode": "05.1"
    },
    {
      "code": "05.20",
      "name": "Bryting av brunkull",
      "shortName": "Bryting av brunkull",
      "level": 4,
      "parentCode": "05.2"
    },
    {
      "code": "06.10",
      "name": "Utvinning av råolje",
      "shortName": "Utvinning av råolje",
      "level": 4,
      "parentCode": "06.1"
    },
    {
      "code": "06.20",
      "name": "Utvinning av naturgass",
      "shortName": "Utvinning av naturgass",
      "level": 4,
      "parentCode": "06.2"
    },
    {
      "code": "07.10",
      "name": "Bryting av jernmalm",
      "shortName": "Bryting av jernmalm",
      "level": 4,
      "parentCode": "07.1"
    },
    {
      "code": "07.21",
      "name": "Bryting av uran- og thoriummalm",
      "shortName": "Bryting av uran- og thoriummalm",
      "level": 4,
      "parentCode": "07.2"
    },
    {
      "code": "07.29",
      "name": "Bryting av ikke-jernholdig malm ellers",
      "shortName": "Bryting av annen ikke-jernh. malm",
      "level": 4,
      "parentCode": "07.2"
    },
    {
      "code": "08.11",
      "name": "Bryting av stein til bygge- og anleggsvirksomhet, kalkstein, gips, kritt og skifer",
      "shortName": "Bryt. bygn.-/kalkstein/skifer mv.",
      "level": 4,
      "parentCode": "08.1"
    },
    {
      "code": "08.12",
      "name": "Utvinning fra grus- og sandtak, og utvinning av leire og kaolin",
      "shortName": "Utv. fra grus- og sandtak, leire mv.",
      "level": 4,
      "parentCode": "08.1"
    },
    {
      "code": "08.91",
      "name": "Bryting og utvinning av kjemiske mineraler og gjødselsmineraler",
      "shortName": "Utv. kjem. mineraler/gjødselsmin.",
      "level": 4,
      "parentCode": "08.9"
    },
    {
      "code": "08.92",
      "name": "Stikking av torv",
      "shortName": "Stikking av torv",
      "level": 4,
      "parentCode": "08.9"
    },
    {
      "code": "08.93",
      "name": "Utvinning av salt",
      "shortName": "Utvinning av salt",
      "level": 4,
      "parentCode": "08.9"
    },
    {
      "code": "08.99",
      "name": "Annen bryting og utvinning ikke nevnt annet sted",
      "shortName": "Annen bryting og utvinning",
      "level": 4,
      "parentCode": "08.9"
    },
    {
      "code": "09.10",
      "name": "Tjenester tilknyttet utvinning av råolje og naturgass",
      "shortName": "Utvinningstjenester",
      "level": 4,
      "parentCode": "09.1"
    },
    {
      "code": "09.90",
      "name": "Tjenester tilknyttet annen bergverksdrift",
      "shortName": "Bergverkstjenester",
      "level": 4,
      "parentCode": "09.9"
    },
    {
      "code": "10.11",
      "name": "Bearbeiding og konservering av kjøtt",
      "shortName": "Kjøttbearbeiding og konservering",
      "level": 4,
      "parentCode": "10.1"
    },
    {
      "code": "10.12",
      "name": "Bearbeiding og konservering av fjørfekjøtt",
      "shortName": "Fjørfekjøttbearb. og konservering",
      "level": 4,
      "parentCode": "10.1"
    },
    {
      "code": "10.13",
      "name": "Produksjon av kjøtt- og fjørfevarer",
      "shortName": "Kjøtt- og fjørfevareproduksjon",
      "level": 4,
      "parentCode": "10.1"
    },
    {
      "code": "10.20",
      "name": "Bearbeiding og konservering av fisk, skalldyr og bløtdyr",
      "shortName": "Bearbeiding fisk, skalldyr, bløtdyr",
      "level": 4,
      "parentCode": "10.2"
    },
    {
      "code": "10.31",
      "name": "Bearbeiding og konservering av poteter",
      "shortName": "Potetbearbeiding",
      "level": 4,
      "parentCode": "10.3"
    },
    {
      "code": "10.32",
      "name": "Produksjon av juice av frukt og grønnsaker",
      "shortName": "Frukt- og grønnsakjuiceproduksjon",
      "level": 4,
      "parentCode": "10.3"
    },
    {
      "code": "10.39",
      "name": "Bearbeiding og konservering av frukt og grønnsaker ellers",
      "shortName": "Frukt- og grønnsakbearbeiding el.",
      "level": 4,
      "parentCode": "10.3"
    },
    {
      "code": "10.41",
      "name": "Produksjon av oljer og fettstoffer",
      "shortName": "Prod. av oljer og fettstoffer",
      "level": 4,
      "parentCode": "10.4"
    },
    {
      "code": "10.42",
      "name": "Produksjon av margarin og lignende spiselige fettstoffer",
      "shortName": "Margarinproduksjon m.m.",
      "level": 4,
      "parentCode": "10.4"
    },
    {
      "code": "10.51",
      "name": "Produksjon av meierivarer",
      "shortName": "Meierivareproduksjon",
      "level": 4,
      "parentCode": "10.5"
    },
    {
      "code": "10.52",
      "name": "Produksjon av iskrem",
      "shortName": "Iskremproduksjon",
      "level": 4,
      "parentCode": "10.5"
    },
    {
      "code": "10.61",
      "name": "Produksjon av kornvarer",
      "shortName": "Kornvareproduksjon",
      "level": 4,
      "parentCode": "10.6"
    },
    {
      "code": "10.62",
      "name": "Produksjon av stivelse og stivelsesprodukter",
      "shortName": "Prod. av stivelse og stivelseprod.",
      "level": 4,
      "parentCode": "10.6"
    },
    {
      "code": "10.71",
      "name": "Produksjon av brød og ferske konditorvarer",
      "shortName": "Brød og ferske konditorvarer",
      "level": 4,
      "parentCode": "10.7"
    },
    {
      "code": "10.72",
      "name": "Produksjon av kavringer, kjeks og konserverte konditorvarer",
      "shortName": "Kavring- og kjeksprod. mv.",
      "level": 4,
      "parentCode": "10.7"
    },
    {
      "code": "10.73",
      "name": "Produksjon av makaroni, nudler, couscous og lignende pastavarer",
      "shortName": "Pastavareproduksjon",
      "level": 4,
      "parentCode": "10.7"
    },
    {
      "code": "10.81",
      "name": "Produksjon av sukker",
      "shortName": "Sukkerproduksjon",
      "level": 4,
      "parentCode": "10.8"
    },
    {
      "code": "10.82",
      "name": "Produksjon av kakao, sjokolade og sukkervarer",
      "shortName": "Kakao-, sjokolade- og sukkervareprod.",
      "level": 4,
      "parentCode": "10.8"
    },
    {
      "code": "10.83",
      "name": "Bearbeiding av te og kaffe",
      "shortName": "Te- og kaffebearbeiding",
      "level": 4,
      "parentCode": "10.8"
    },
    {
      "code": "10.84",
      "name": "Produksjon av smakstilsettingsstoffer og krydderier",
      "shortName": "Smakstilsettingsstoffer og krydder",
      "level": 4,
      "parentCode": "10.8"
    },
    {
      "code": "10.85",
      "name": "Produksjon av ferdigmat",
      "shortName": "Ferdigmatproduksjon",
      "level": 4,
      "parentCode": "10.8"
    },
    {
      "code": "10.86",
      "name": "Produksjon av homogeniserte matprodukter og diettmat",
      "shortName": "Diettmat og homogeniserte matprod.",
      "level": 4,
      "parentCode": "10.8"
    },
    {
      "code": "10.89",
      "name": "Produksjon av næringsmidler ikke nevnt annet sted",
      "shortName": "Produksjon av næringsmidler el.",
      "level": 4,
      "parentCode": "10.8"
    },
    {
      "code": "10.91",
      "name": "Produksjon av fôrvarer til husdyrhold",
      "shortName": "Fôrvareproduksjon til husdyr",
      "level": 4,
      "parentCode": "10.9"
    },
    {
      "code": "10.92",
      "name": "Produksjon av fôrvarer til kjæledyr",
      "shortName": "Fôrvareproduksjon til kjæledyr",
      "level": 4,
      "parentCode": "10.9"
    },
    {
      "code": "11.01",
      "name": "Destillering, rektifisering og blanding av sprit",
      "shortName": "Destill. alkoholholdige drikkevarer",
      "level": 4,
      "parentCode": "11.0"
    },
    {
      "code": "11.02",
      "name": "Produksjon av vin",
      "shortName": "Vinproduksjon",
      "level": 4,
      "parentCode": "11.0"
    },
    {
      "code": "11.03",
      "name": "Produksjon av sider og annen fruktvin",
      "shortName": "Sider- og annen fruktvinproduksjon",
      "level": 4,
      "parentCode": "11.0"
    },
    {
      "code": "11.04",
      "name": "Produksjon av andre ikke-destillerte gjærede drikkevarer",
      "shortName": "Ikke-destill. gjærede drikkevarer",
      "level": 4,
      "parentCode": "11.0"
    },
    {
      "code": "11.05",
      "name": "Produksjon av øl",
      "shortName": "Ølproduksjon",
      "level": 4,
      "parentCode": "11.0"
    },
    {
      "code": "11.06",
      "name": "Produksjon av malt",
      "shortName": "Maltproduksjon",
      "level": 4,
      "parentCode": "11.0"
    },
    {
      "code": "11.07",
      "name": "Produksjon av mineralvann, leskedrikker og annet vann på flaske",
      "shortName": "Mineralvann- og leskedrikkproduksjon",
      "level": 4,
      "parentCode": "11.0"
    },
    {
      "code": "12.00",
      "name": "Produksjon av tobakksvarer",
      "shortName": "Tobakksindustri",
      "level": 4,
      "parentCode": "12.0"
    },
    {
      "code": "13.10",
      "name": "Bearbeiding og spinning av tekstilfibrer",
      "shortName": "Bearb./spinning av tekstilfibrer",
      "level": 4,
      "parentCode": "13.1"
    },
    {
      "code": "13.20",
      "name": "Veving av tekstiler",
      "shortName": "Veving av tekstiler",
      "level": 4,
      "parentCode": "13.2"
    },
    {
      "code": "13.30",
      "name": "Etterbehandling av tekstiler",
      "shortName": "Etterbehandling av tekstiler",
      "level": 4,
      "parentCode": "13.3"
    },
    {
      "code": "13.91",
      "name": "Produksjon av stoffer av trikotasje",
      "shortName": "Trikotasjestoffproduksjon",
      "level": 4,
      "parentCode": "13.9"
    },
    {
      "code": "13.92",
      "name": "Produksjon av tekstilvarer, unntatt klær",
      "shortName": "Tekstilvareproduksjon, unntatt klær",
      "level": 4,
      "parentCode": "13.9"
    },
    {
      "code": "13.93",
      "name": "Produksjon av gulvtepper, -matter og -ryer",
      "shortName": "Gulvteppe-, matte- og ryeproduksjon",
      "level": 4,
      "parentCode": "13.9"
    },
    {
      "code": "13.94",
      "name": "Produksjon av tauverk og nett",
      "shortName": "Tauverk- og nettproduksjon",
      "level": 4,
      "parentCode": "13.9"
    },
    {
      "code": "13.95",
      "name": "Produksjon av ikke-vevde tekstiler og tekstilvarer, unntatt klær",
      "shortName": "Fiberproduksjon mv.",
      "level": 4,
      "parentCode": "13.9"
    },
    {
      "code": "13.96",
      "name": "Produksjon av tekstiler til teknisk og industriell bruk",
      "shortName": "Tekstiler til tekn./industriell bruk",
      "level": 4,
      "parentCode": "13.9"
    },
    {
      "code": "13.99",
      "name": "Produksjon av tekstiler ikke nevnt annet sted",
      "shortName": "Tekstilproduksjon el.",
      "level": 4,
      "parentCode": "13.9"
    },
    {
      "code": "14.11",
      "name": "Produksjon av klær av lær",
      "shortName": "Produksjon av klær av lær",
      "level": 4,
      "parentCode": "14.1"
    },
    {
      "code": "14.12",
      "name": "Produksjon av arbeidstøy",
      "shortName": "Arbeidstøyproduksjon",
      "level": 4,
      "parentCode": "14.1"
    },
    {
      "code": "14.13",
      "name": "Produksjon av annet yttertøy",
      "shortName": "Annen yttertøyproduksjon",
      "level": 4,
      "parentCode": "14.1"
    },
    {
      "code": "14.14",
      "name": "Produksjon av undertøy og innertøy",
      "shortName": "Undertøy- og innertøyproduksjon",
      "level": 4,
      "parentCode": "14.1"
    },
    {
      "code": "14.19",
      "name": "Produksjon av klær og tilbehør ellers",
      "shortName": "Produksjon av klær og tilbehør el.",
      "level": 4,
      "parentCode": "14.1"
    },
    {
      "code": "14.20",
      "name": "Produksjon av pelsvarer",
      "shortName": "Produksjon av pelsvarer",
      "level": 4,
      "parentCode": "14.2"
    },
    {
      "code": "14.31",
      "name": "Produksjon av strømpevarer",
      "shortName": "Strømpevareproduksjon",
      "level": 4,
      "parentCode": "14.3"
    },
    {
      "code": "14.39",
      "name": "Produksjon av andre klær av trikotasje",
      "shortName": "Prod. av klær av trikotasje el.",
      "level": 4,
      "parentCode": "14.3"
    },
    {
      "code": "15.11",
      "name": "Beredning av lær, og beredning og farging av pelsskinn",
      "shortName": "Lærberedning",
      "level": 4,
      "parentCode": "15.1"
    },
    {
      "code": "15.12",
      "name": "Produksjon av reiseeffekter og salmakerartikler",
      "shortName": "Reiseeffekter og salmakerartikler",
      "level": 4,
      "parentCode": "15.1"
    },
    {
      "code": "15.20",
      "name": "Produksjon av skotøy",
      "shortName": "Produksjon av skotøy",
      "level": 4,
      "parentCode": "15.2"
    },
    {
      "code": "16.10",
      "name": "Saging, høvling og impregnering av tre",
      "shortName": "Saging, høvling mv. av tre",
      "level": 4,
      "parentCode": "16.1"
    },
    {
      "code": "16.21",
      "name": "Produksjon av finerplater og andre bygnings- og møbelplater av tre",
      "shortName": "Bygnings- og møbelplateproduksjon",
      "level": 4,
      "parentCode": "16.2"
    },
    {
      "code": "16.22",
      "name": "Produksjon av sammensatte parkettstaver",
      "shortName": "Sammensatte parkettstavprod.",
      "level": 4,
      "parentCode": "16.2"
    },
    {
      "code": "16.23",
      "name": "Produksjon av andre bygningsartikler",
      "shortName": "Annen bygningsartikkelprod.",
      "level": 4,
      "parentCode": "16.2"
    },
    {
      "code": "16.24",
      "name": "Produksjon av treemballasje",
      "shortName": "Treemballasjeproduksjon",
      "level": 4,
      "parentCode": "16.2"
    },
    {
      "code": "16.29",
      "name": "Produksjon av andre trevarer og varer av kork, strå og flettematerialer",
      "shortName": "Andre tre-, kork-, stråvarer mv.",
      "level": 4,
      "parentCode": "16.2"
    },
    {
      "code": "17.11",
      "name": "Produksjon av papirmasse",
      "shortName": "Produksjon av papirmasse",
      "level": 4,
      "parentCode": "17.1"
    },
    {
      "code": "17.12",
      "name": "Produksjon av papir og papp",
      "shortName": "Produksjon av papir og papp",
      "level": 4,
      "parentCode": "17.1"
    },
    {
      "code": "17.21",
      "name": "Produksjon av bølgepapp og emballasje av papir og papp",
      "shortName": "Bølgepapp, papir- og pappemballasje",
      "level": 4,
      "parentCode": "17.2"
    },
    {
      "code": "17.22",
      "name": "Produksjon av husholdnings-, sanitær- og toalettartikler av papir",
      "shortName": "Hushold.-/toalettartikler av papir",
      "level": 4,
      "parentCode": "17.2"
    },
    {
      "code": "17.23",
      "name": "Produksjon av kontorartikler av papir",
      "shortName": "Prod. av kontorartikler av papir",
      "level": 4,
      "parentCode": "17.2"
    },
    {
      "code": "17.24",
      "name": "Produksjon av tapeter",
      "shortName": "Tapetproduksjon",
      "level": 4,
      "parentCode": "17.2"
    },
    {
      "code": "17.29",
      "name": "Produksjon av varer av papir og papp ellers",
      "shortName": "Papir- og pappvareproduksjon el.",
      "level": 4,
      "parentCode": "17.2"
    },
    {
      "code": "18.11",
      "name": "Trykking av aviser",
      "shortName": "Trykking av aviser",
      "level": 4,
      "parentCode": "18.1"
    },
    {
      "code": "18.12",
      "name": "Trykking ellers",
      "shortName": "Trykking ellers",
      "level": 4,
      "parentCode": "18.1"
    },
    {
      "code": "18.13",
      "name": "Ferdiggjøring før trykking og publisering",
      "shortName": "Ferdiggjøring før trykking og publ.",
      "level": 4,
      "parentCode": "18.1"
    },
    {
      "code": "18.14",
      "name": "Bokbinding og tilknyttede tjenester",
      "shortName": "Bokbinding og tilkn. tjenester",
      "level": 4,
      "parentCode": "18.1"
    },
    {
      "code": "18.20",
      "name": "Reproduksjon av innspilte opptak",
      "shortName": "Reproduksjon av innspilte opptak",
      "level": 4,
      "parentCode": "18.2"
    },
    {
      "code": "19.10",
      "name": "Produksjon av kullprodukter",
      "shortName": "Produksjon av kullprodukter",
      "level": 4,
      "parentCode": "19.1"
    },
    {
      "code": "19.20",
      "name": "Produksjon av raffinerte petroleumsprodukter",
      "shortName": "Prod. raffinerte petroleumsprodukt",
      "level": 4,
      "parentCode": "19.2"
    },
    {
      "code": "20.11",
      "name": "Produksjon av industrigasser",
      "shortName": "Industrigassproduksjon",
      "level": 4,
      "parentCode": "20.1"
    },
    {
      "code": "20.12",
      "name": "Produksjon av fargestoffer og pigmenter",
      "shortName": "Fargestoff- og pigmentproduksjon",
      "level": 4,
      "parentCode": "20.1"
    },
    {
      "code": "20.13",
      "name": "Produksjon av andre uorganiske kjemikalier",
      "shortName": "Uorganisk kjemikalieproduksjon el.",
      "level": 4,
      "parentCode": "20.1"
    },
    {
      "code": "20.14",
      "name": "Produksjon av andre organiske kjemiske råvarer",
      "shortName": "Annen org. kjemisk råvareproduksjon",
      "level": 4,
      "parentCode": "20.1"
    },
    {
      "code": "20.15",
      "name": "Produksjon av gjødsel, nitrogenforbindelser og vekstjord",
      "shortName": "Gjødselproduksjon mv.",
      "level": 4,
      "parentCode": "20.1"
    },
    {
      "code": "20.16",
      "name": "Produksjon av basisplast",
      "shortName": "Basisplastproduksjon",
      "level": 4,
      "parentCode": "20.1"
    },
    {
      "code": "20.17",
      "name": "Produksjon av syntetisk gummi",
      "shortName": "Produksjon av syntetisk gummi",
      "level": 4,
      "parentCode": "20.1"
    },
    {
      "code": "20.20",
      "name": "Produksjon av plantevern- og skadedyrmidler og andre landbrukskjemiske produkter",
      "shortName": "Produksjon landbrukskjemiske prod.",
      "level": 4,
      "parentCode": "20.2"
    },
    {
      "code": "20.30",
      "name": "Produksjon av maling og lakk, trykkfarger og tetningsmidler",
      "shortName": "Produksjon maling, lakk mv.",
      "level": 4,
      "parentCode": "20.3"
    },
    {
      "code": "20.41",
      "name": "Produksjon av såpe og vaskemidler, rense- og polermidler",
      "shortName": "Såpe- og vaskemiddelprod. mv.",
      "level": 4,
      "parentCode": "20.4"
    },
    {
      "code": "20.42",
      "name": "Produksjon av parfyme og toalettartikler",
      "shortName": "Parfyme og toalettartikler",
      "level": 4,
      "parentCode": "20.4"
    },
    {
      "code": "20.51",
      "name": "Produksjon av eksplosiver",
      "shortName": "Produksjon av eksplosiver",
      "level": 4,
      "parentCode": "20.5"
    },
    {
      "code": "20.52",
      "name": "Produksjon av lim",
      "shortName": "Limproduksjon",
      "level": 4,
      "parentCode": "20.5"
    },
    {
      "code": "20.53",
      "name": "Produksjon av eteriske oljer",
      "shortName": "Produksjon av eteriske oljer",
      "level": 4,
      "parentCode": "20.5"
    },
    {
      "code": "20.59",
      "name": "Produksjon av kjemiske produkter ikke nevnt annet sted",
      "shortName": "Annen kjemisk produksjon",
      "level": 4,
      "parentCode": "20.5"
    },
    {
      "code": "20.60",
      "name": "Produksjon av kunstfibrer",
      "shortName": "Produksjon av kunstfibrer",
      "level": 4,
      "parentCode": "20.6"
    },
    {
      "code": "21.10",
      "name": "Produksjon av farmasøytiske råvarer",
      "shortName": "Farmasøytiske råvarer",
      "level": 4,
      "parentCode": "21.1"
    },
    {
      "code": "21.20",
      "name": "Produksjon av farmasøytiske preparater",
      "shortName": "Farmasøytiske preparater",
      "level": 4,
      "parentCode": "21.2"
    },
    {
      "code": "22.11",
      "name": "Produksjon av gummidekk og slanger til gummidekk, og regummiering og vulkanisering av gummidekk",
      "shortName": "Gummidekkprod., -regumm. og -vulk.",
      "level": 4,
      "parentCode": "22.1"
    },
    {
      "code": "22.19",
      "name": "Produksjon av gummiprodukter ellers",
      "shortName": "Produksjon av gummiprodukter el.",
      "level": 4,
      "parentCode": "22.1"
    },
    {
      "code": "22.21",
      "name": "Produksjon av halvfabrikater av plast",
      "shortName": "Prod. av halvfabrikater av plast",
      "level": 4,
      "parentCode": "22.2"
    },
    {
      "code": "22.22",
      "name": "Produksjon av plastemballasje",
      "shortName": "Plastemballasjeproduksjon",
      "level": 4,
      "parentCode": "22.2"
    },
    {
      "code": "22.23",
      "name": "Produksjon av byggevarer av plast",
      "shortName": "Byggevareprod. av plast",
      "level": 4,
      "parentCode": "22.2"
    },
    {
      "code": "22.29",
      "name": "Produksjon av plastprodukter ellers",
      "shortName": "Prod. av plastprodukter el.",
      "level": 4,
      "parentCode": "22.2"
    },
    {
      "code": "23.11",
      "name": "Produksjon av planglass",
      "shortName": "Planglassproduksjon",
      "level": 4,
      "parentCode": "23.1"
    },
    {
      "code": "23.12",
      "name": "Bearbeiding av planglass",
      "shortName": "Planglassbearbeiding",
      "level": 4,
      "parentCode": "23.1"
    },
    {
      "code": "23.13",
      "name": "Produksjon av emballasje og husholdningsartikler av glass og krystall",
      "shortName": "Emb. og hush.art. av glass/krystall",
      "level": 4,
      "parentCode": "23.1"
    },
    {
      "code": "23.14",
      "name": "Produksjon av glassfibrer",
      "shortName": "Glassfiberproduksjon",
      "level": 4,
      "parentCode": "23.1"
    },
    {
      "code": "23.19",
      "name": "Produksjon av teknisk glass og andre glassvarer",
      "shortName": "Tekn. glass- og annen glassvareprod.",
      "level": 4,
      "parentCode": "23.1"
    },
    {
      "code": "23.20",
      "name": "Produksjon av ildfaste produkter",
      "shortName": "Prod. av ildfaste produkter",
      "level": 4,
      "parentCode": "23.2"
    },
    {
      "code": "23.31",
      "name": "Produksjon av keramiske vegg- og gulvfliser",
      "shortName": "Keramisk byggematerialproduksjon",
      "level": 4,
      "parentCode": "23.3"
    },
    {
      "code": "23.32",
      "name": "Produksjon av murstein, teglstein og andre byggevarer av brent leire",
      "shortName": "Mur-, teglstein- o.a. byggevareprod.",
      "level": 4,
      "parentCode": "23.3"
    },
    {
      "code": "23.41",
      "name": "Produksjon av keramiske husholdningsartikler og dekorasjonsgjenstander",
      "shortName": "Keramiske husholdningsartikler mv.",
      "level": 4,
      "parentCode": "23.4"
    },
    {
      "code": "23.42",
      "name": "Produksjon av sanitærutstyr av keramisk materiale",
      "shortName": "Prod. av keramisk sanitærutstyr",
      "level": 4,
      "parentCode": "23.4"
    },
    {
      "code": "23.43",
      "name": "Produksjon av isolatorer og isoleringsdeler av keramisk materiale",
      "shortName": "Prod. av keramiske isoleringsdeler",
      "level": 4,
      "parentCode": "23.4"
    },
    {
      "code": "23.44",
      "name": "Produksjon av andre keramiske produkter for teknisk bruk",
      "shortName": "Prod. av keram. prod. for tekn. bruk",
      "level": 4,
      "parentCode": "23.4"
    },
    {
      "code": "23.49",
      "name": "Produksjon av andre keramiske produkter",
      "shortName": "Prod. av andre keramiske prod.",
      "level": 4,
      "parentCode": "23.4"
    },
    {
      "code": "23.51",
      "name": "Produksjon av sement",
      "shortName": "Sementproduksjon",
      "level": 4,
      "parentCode": "23.5"
    },
    {
      "code": "23.52",
      "name": "Produksjon av kalk og gips",
      "shortName": "Kalk- og gipsproduksjon",
      "level": 4,
      "parentCode": "23.5"
    },
    {
      "code": "23.61",
      "name": "Produksjon av betongprodukter for bygge- og anleggsvirksomhet",
      "shortName": "Betongprodukter for bygg og anlegg",
      "level": 4,
      "parentCode": "23.6"
    },
    {
      "code": "23.62",
      "name": "Produksjon av gipsprodukter for bygge- og anleggsvirksomhet",
      "shortName": "Gipsprodukter for bygg av anlegg",
      "level": 4,
      "parentCode": "23.6"
    },
    {
      "code": "23.63",
      "name": "Produksjon av ferdigblandet betong",
      "shortName": "Ferdigblandet betong",
      "level": 4,
      "parentCode": "23.6"
    },
    {
      "code": "23.64",
      "name": "Produksjon av mørtel",
      "shortName": "Mørtelproduksjon",
      "level": 4,
      "parentCode": "23.6"
    },
    {
      "code": "23.65",
      "name": "Produksjon av fibersement",
      "shortName": "Fibersementproduksjon",
      "level": 4,
      "parentCode": "23.6"
    },
    {
      "code": "23.69",
      "name": "Produksjon av betong-, sement- og gipsprodukter ellers",
      "shortName": "Annen betong-, sement- og gipsprod.",
      "level": 4,
      "parentCode": "23.6"
    },
    {
      "code": "23.70",
      "name": "Hogging og bearbeiding av monument- og bygningsstein",
      "shortName": "Hogg./bearb. av monum.-/bygn.stein",
      "level": 4,
      "parentCode": "23.7"
    },
    {
      "code": "23.91",
      "name": "Produksjon av slipestoffer",
      "shortName": "Slipestoffproduksjon",
      "level": 4,
      "parentCode": "23.9"
    },
    {
      "code": "23.99",
      "name": "Produksjon av ikke-metallholdige mineralprodukter ikke nevnt annet sted",
      "shortName": "Prod. av ikke-met. mineralprod. el.",
      "level": 4,
      "parentCode": "23.9"
    },
    {
      "code": "24.10",
      "name": "Produksjon av jern og stål, samt ferrolegeringer",
      "shortName": "Produksjon jern,  stål, ferroleger.",
      "level": 4,
      "parentCode": "24.1"
    },
    {
      "code": "24.20",
      "name": "Produksjon av andre rør og rørdeler av stål",
      "shortName": "Annen rør- og rørdelprod. av stål",
      "level": 4,
      "parentCode": "24.2"
    },
    {
      "code": "24.31",
      "name": "Kaldtrekking av stenger og profiler",
      "shortName": "Kaldtrekking av stenger og profiler",
      "level": 4,
      "parentCode": "24.3"
    },
    {
      "code": "24.32",
      "name": "Kaldvalsing av bånd",
      "shortName": "Kaldvalsing av bånd",
      "level": 4,
      "parentCode": "24.3"
    },
    {
      "code": "24.33",
      "name": "Kaldvalsing og pressing av profilerte plater og profiler",
      "shortName": "Kaldv./press. av prof. plater mv.",
      "level": 4,
      "parentCode": "24.3"
    },
    {
      "code": "24.34",
      "name": "Kaldtrekking av tråd",
      "shortName": "Kaldtrekking av tråd",
      "level": 4,
      "parentCode": "24.3"
    },
    {
      "code": "24.41",
      "name": "Produksjon av edelmetaller",
      "shortName": "Edelmetallproduksjon",
      "level": 4,
      "parentCode": "24.4"
    },
    {
      "code": "24.42",
      "name": "Produksjon av aluminium",
      "shortName": "Produksjon av aluminium",
      "level": 4,
      "parentCode": "24.4"
    },
    {
      "code": "24.43",
      "name": "Produksjon av bly, sink og tinn",
      "shortName": "Bly-, sink- og tinnproduksjon",
      "level": 4,
      "parentCode": "24.4"
    },
    {
      "code": "24.44",
      "name": "Produksjon av kobber",
      "shortName": "Kobberproduksjon",
      "level": 4,
      "parentCode": "24.4"
    },
    {
      "code": "24.45",
      "name": "Produksjon av ikke-jernholdige metaller ellers",
      "shortName": "Prod. ikke-jernhold. metaller ellers",
      "level": 4,
      "parentCode": "24.4"
    },
    {
      "code": "24.46",
      "name": "Produksjon av kjernebrensel",
      "shortName": "Kjernebrenselproduksjon",
      "level": 4,
      "parentCode": "24.4"
    },
    {
      "code": "24.51",
      "name": "Støping av jern",
      "shortName": "Støping av jern",
      "level": 4,
      "parentCode": "24.5"
    },
    {
      "code": "24.52",
      "name": "Støping av stål",
      "shortName": "Støping av stål",
      "level": 4,
      "parentCode": "24.5"
    },
    {
      "code": "24.53",
      "name": "Støping av lettmetaller",
      "shortName": "Støping av lettmetaller",
      "level": 4,
      "parentCode": "24.5"
    },
    {
      "code": "24.54",
      "name": "Støping av andre ikke-jernholdige metaller",
      "shortName": "Annen ikke-jernholdig metallstøp.",
      "level": 4,
      "parentCode": "24.5"
    },
    {
      "code": "25.11",
      "name": "Produksjon av metallkonstruksjoner og deler",
      "shortName": "Prod. av metallkonstruksj. og deler",
      "level": 4,
      "parentCode": "25.1"
    },
    {
      "code": "25.12",
      "name": "Produksjon av dører og vinduer av metall",
      "shortName": "Bygningsartikkelprod. av metall",
      "level": 4,
      "parentCode": "25.1"
    },
    {
      "code": "25.21",
      "name": "Produksjon av radiatorer og kjeler til sentralvarmeanlegg",
      "shortName": "Sentralv.kjeler- og radiatorprod.",
      "level": 4,
      "parentCode": "25.2"
    },
    {
      "code": "25.29",
      "name": "Produksjon av andre tanker, cisterner og beholdere av metall",
      "shortName": "Prod. av metallbeholdere",
      "level": 4,
      "parentCode": "25.2"
    },
    {
      "code": "25.30",
      "name": "Produksjon av dampkjeler, unntatt kjeler til sentralvarmeanlegg",
      "shortName": "Dampkjeler unnt. sentralvarmeanl.",
      "level": 4,
      "parentCode": "25.3"
    },
    {
      "code": "25.40",
      "name": "Produksjon av våpen og ammunisjon",
      "shortName": "Våpen- og ammunisjonsproduksjon",
      "level": 4,
      "parentCode": "25.4"
    },
    {
      "code": "25.50",
      "name": "Smiing, stansing og valsing av metall, og pulvermetallurgi",
      "shortName": "Stansing/valsing/pulvermetallurgi",
      "level": 4,
      "parentCode": "25.5"
    },
    {
      "code": "25.61",
      "name": "Overflatebehandling av metaller",
      "shortName": "Overflatebehandling av metaller",
      "level": 4,
      "parentCode": "25.6"
    },
    {
      "code": "25.62",
      "name": "Bearbeiding av metaller",
      "shortName": "Bearbeiding av metaller",
      "level": 4,
      "parentCode": "25.6"
    },
    {
      "code": "25.71",
      "name": "Produksjon av kjøkkenredskaper og skjære- og klipperedskaper",
      "shortName": "Kjøkkenredskapsproduksjon",
      "level": 4,
      "parentCode": "25.7"
    },
    {
      "code": "25.72",
      "name": "Produksjon av låser og beslag",
      "shortName": "Låse- og beslagproduksjon",
      "level": 4,
      "parentCode": "25.7"
    },
    {
      "code": "25.73",
      "name": "Produksjon av håndverktøy",
      "shortName": "Håndverktøyproduksjon",
      "level": 4,
      "parentCode": "25.7"
    },
    {
      "code": "25.91",
      "name": "Produksjon av stålfat og lignende beholdere av jern og stål",
      "shortName": "Prod. av behold. mv. av jern/stål",
      "level": 4,
      "parentCode": "25.9"
    },
    {
      "code": "25.92",
      "name": "Produksjon av emballasje av lettmetall",
      "shortName": "Prod. av lettmetallemballasje",
      "level": 4,
      "parentCode": "25.9"
    },
    {
      "code": "25.93",
      "name": "Produksjon av varer av metalltråd, kjetting og fjærer",
      "shortName": "Metalltrådvareproduksjon",
      "level": 4,
      "parentCode": "25.9"
    },
    {
      "code": "25.94",
      "name": "Produksjon av bolter og skruer",
      "shortName": "Bolte- og skrueproduksjon",
      "level": 4,
      "parentCode": "25.9"
    },
    {
      "code": "25.99",
      "name": "Produksjon av metallvarer ikke nevnt annet sted",
      "shortName": "Metallvareprod. el.",
      "level": 4,
      "parentCode": "25.9"
    },
    {
      "code": "26.11",
      "name": "Produksjon av elektroniske komponenter",
      "shortName": "Prod. av elektroniske komponenter",
      "level": 4,
      "parentCode": "26.1"
    },
    {
      "code": "26.12",
      "name": "Produksjon av kretskort",
      "shortName": "Produksjon av kretskort",
      "level": 4,
      "parentCode": "26.1"
    },
    {
      "code": "26.20",
      "name": "Produksjon av datamaskiner og tilleggsutstyr",
      "shortName": "Prod. datamaskiner og tilleggsutstyr",
      "level": 4,
      "parentCode": "26.2"
    },
    {
      "code": "26.30",
      "name": "Produksjon av kommunikasjonsutstyr",
      "shortName": "Prod. av kommunikasjonsutstyr",
      "level": 4,
      "parentCode": "26.3"
    },
    {
      "code": "26.40",
      "name": "Produksjon av elektronikk til husholdningsbruk",
      "shortName": "Prod. av husholdningselektronikk",
      "level": 4,
      "parentCode": "26.4"
    },
    {
      "code": "26.51",
      "name": "Produksjon av måle-, kontroll- og navigasjonsinstrumenter",
      "shortName": "Måle-, kontroll- og navig.instr.",
      "level": 4,
      "parentCode": "26.5"
    },
    {
      "code": "26.52",
      "name": "Produksjon av klokker og ur",
      "shortName": "Klokke- og urproduksjon",
      "level": 4,
      "parentCode": "26.5"
    },
    {
      "code": "26.60",
      "name": "Produksjon av strålingsutstyr, elektromedisinsk og elektroterapeutisk utstyr",
      "shortName": "Elektromed./elektroterap. utst. mv.",
      "level": 4,
      "parentCode": "26.6"
    },
    {
      "code": "26.70",
      "name": "Produksjon av optiske instrumenter og fotografisk utstyr",
      "shortName": "Optiske instr./fotografisk utstyr",
      "level": 4,
      "parentCode": "26.7"
    },
    {
      "code": "26.80",
      "name": "Produksjon av magnetiske og optiske media",
      "shortName": "Magnetiske/optiske media",
      "level": 4,
      "parentCode": "26.8"
    },
    {
      "code": "27.11",
      "name": "Produksjon av elektromotorer, generatorer og transformatorer",
      "shortName": "Elektromotor-, generatorprod. mv.",
      "level": 4,
      "parentCode": "27.1"
    },
    {
      "code": "27.12",
      "name": "Produksjon av elektriske fordelings- og kontrolltavler og paneler",
      "shortName": "Elektriske tavler, paneler mv.",
      "level": 4,
      "parentCode": "27.1"
    },
    {
      "code": "27.20",
      "name": "Produksjon av batterier og akkumulatorer",
      "shortName": "Batterier, akkumulatorer",
      "level": 4,
      "parentCode": "27.2"
    },
    {
      "code": "27.31",
      "name": "Produksjon av optiske fiberkabler",
      "shortName": "Prod. av optiske fiberkabler",
      "level": 4,
      "parentCode": "27.3"
    },
    {
      "code": "27.32",
      "name": "Produksjon av andre elektroniske og elektriske ledninger og kabler",
      "shortName": "Elektron./el. ledninger/kabler el.",
      "level": 4,
      "parentCode": "27.3"
    },
    {
      "code": "27.33",
      "name": "Produksjon av ledningsmateriell",
      "shortName": "Prod. av ledningsmateriell",
      "level": 4,
      "parentCode": "27.3"
    },
    {
      "code": "27.40",
      "name": "Produksjon av belysningsutstyr",
      "shortName": "Prod. av belysningsutstyr",
      "level": 4,
      "parentCode": "27.4"
    },
    {
      "code": "27.51",
      "name": "Produksjon av elektriske husholdningsmaskiner og apparater",
      "shortName": "Elektr. hush.maskin-/apparatprod.",
      "level": 4,
      "parentCode": "27.5"
    },
    {
      "code": "27.52",
      "name": "Produksjon av ikke-elektriske husholdningsmaskiner og apparater",
      "shortName": "Ikke-el. hush.mask.-/apparatprod.",
      "level": 4,
      "parentCode": "27.5"
    },
    {
      "code": "27.90",
      "name": "Produksjon av annet elektrisk utstyr",
      "shortName": "Produksjon elektrisk utstyr ellers",
      "level": 4,
      "parentCode": "27.9"
    },
    {
      "code": "28.11",
      "name": "Produksjon av motorer og turbiner, unntatt motorer til luftfartøyer og motorvogner",
      "shortName": "Skipsmotor-/motor- og turbinprod. el.",
      "level": 4,
      "parentCode": "28.1"
    },
    {
      "code": "28.12",
      "name": "Produksjon av komponenter til hydraulisk og pneumatisk utstyr",
      "shortName": "Komp. til hydraul./pneumatisk utstyr",
      "level": 4,
      "parentCode": "28.1"
    },
    {
      "code": "28.13",
      "name": "Produksjon av pumper og kompressorer ellers",
      "shortName": "Pumpe- og kompressorprod. el.",
      "level": 4,
      "parentCode": "28.1"
    },
    {
      "code": "28.14",
      "name": "Produksjon av kraner og ventiler ellers",
      "shortName": "Kran- og ventilproduksjon el.",
      "level": 4,
      "parentCode": "28.1"
    },
    {
      "code": "28.15",
      "name": "Produksjon av lagre, gir, tannhjulsutvekslinger og andre innretninger for kraftoverføring",
      "shortName": "Lager-, girproduksjon mv.",
      "level": 4,
      "parentCode": "28.1"
    },
    {
      "code": "28.21",
      "name": "Produksjon av industri- og laboratorieovner samt brennere",
      "shortName": "Industri- og laboratorieovnprod.",
      "level": 4,
      "parentCode": "28.2"
    },
    {
      "code": "28.22",
      "name": "Produksjon av løfte- og håndteringsutstyr",
      "shortName": "Løfte- og håndteringsutstyr",
      "level": 4,
      "parentCode": "28.2"
    },
    {
      "code": "28.23",
      "name": "Produksjon av kontormaskiner og utstyr (unntatt datamaskiner og tilleggsutstyr)",
      "shortName": "Kontormaskinproduksjon",
      "level": 4,
      "parentCode": "28.2"
    },
    {
      "code": "28.24",
      "name": "Produksjon av motordrevet håndverktøy",
      "shortName": "Prod. av motordrevet håndverktøy",
      "level": 4,
      "parentCode": "28.2"
    },
    {
      "code": "28.25",
      "name": "Produksjon av kjøle- og ventilasjonsanlegg, unntatt til husholdningsbruk",
      "shortName": "Kjøle- og ventilasjonsanleggprod.",
      "level": 4,
      "parentCode": "28.2"
    },
    {
      "code": "28.29",
      "name": "Produksjon av maskiner og utstyr til generell bruk, ikke nevnt annet sted",
      "shortName": "Maskiner og utstyr til gen. bruk el.",
      "level": 4,
      "parentCode": "28.2"
    },
    {
      "code": "28.30",
      "name": "Produksjon av jordbruks- og skogbruksmaskiner",
      "shortName": "Jord- og skogbruksmaskinproduksjon",
      "level": 4,
      "parentCode": "28.3"
    },
    {
      "code": "28.41",
      "name": "Produksjon av maskinverktøy til metallbearbeiding",
      "shortName": "Maskinverktøy til metallbearb.",
      "level": 4,
      "parentCode": "28.4"
    },
    {
      "code": "28.49",
      "name": "Produksjon av maskinverktøy ikke nevnt annet sted",
      "shortName": "Prod. av maskinverktøy el.",
      "level": 4,
      "parentCode": "28.4"
    },
    {
      "code": "28.91",
      "name": "Produksjon av maskiner og utstyr til metallurgisk industri",
      "shortName": "Mask./utstyr metallurgisk industri",
      "level": 4,
      "parentCode": "28.9"
    },
    {
      "code": "28.92",
      "name": "Produksjon av maskiner og utstyr til bergverksdrift og bygge- og anleggsvirksomhet",
      "shortName": "Mask./utstyr bergverk, bygg og anl.",
      "level": 4,
      "parentCode": "28.9"
    },
    {
      "code": "28.93",
      "name": "Produksjon av maskiner og utstyr til nærings- og nytelsesmiddelindustri",
      "shortName": "Mask./utstyr næringsmiddelindustri",
      "level": 4,
      "parentCode": "28.9"
    },
    {
      "code": "28.94",
      "name": "Produksjon av maskiner og utstyr til tekstil-, konfeksjons- og lærvareindustri",
      "shortName": "Mask./utstyr tekstilindustri",
      "level": 4,
      "parentCode": "28.9"
    },
    {
      "code": "28.95",
      "name": "Produksjon av maskiner og utstyr til papir- og pappvareindustri",
      "shortName": "Mask./utstyr papir- og pappvareindustri",
      "level": 4,
      "parentCode": "28.9"
    },
    {
      "code": "28.96",
      "name": "Produksjon av maskiner og utstyr til plast- og gummiindustri",
      "shortName": "Mask./utstyr plast- og gummiindustri",
      "level": 4,
      "parentCode": "28.9"
    },
    {
      "code": "28.99",
      "name": "Produksjon av spesialmaskiner ikke nevnt annet sted",
      "shortName": "Spesialmaskinproduksjon el.",
      "level": 4,
      "parentCode": "28.9"
    },
    {
      "code": "29.10",
      "name": "Produksjon av motorvogner",
      "shortName": "Motorvognproduksjon",
      "level": 4,
      "parentCode": "29.1"
    },
    {
      "code": "29.20",
      "name": "Produksjon av karosserier og tilhengere",
      "shortName": "Karosseri- og tilhengerproduksjon",
      "level": 4,
      "parentCode": "29.2"
    },
    {
      "code": "29.31",
      "name": "Produksjon av elektrisk og elektronisk utstyr til motorvogner",
      "shortName": "Elektrisk/elektron. utstyr motorv.",
      "level": 4,
      "parentCode": "29.3"
    },
    {
      "code": "29.32",
      "name": "Produksjon av andre deler og annet utstyr til motorvogner",
      "shortName": "Annet utstyr-/delprod. til motorv.",
      "level": 4,
      "parentCode": "29.3"
    },
    {
      "code": "30.11",
      "name": "Bygging av skip og flytende materiell",
      "shortName": "Bygg av skip og flytende materiell",
      "level": 4,
      "parentCode": "30.1"
    },
    {
      "code": "30.12",
      "name": "Bygging av fritidsbåter",
      "shortName": "Bygging av fritidsbåter",
      "level": 4,
      "parentCode": "30.1"
    },
    {
      "code": "30.20",
      "name": "Produksjon av lokomotiver og annet rullende materiell til jernbane og sporvei",
      "shortName": "Jernbane- og sporvognmateriell mv.",
      "level": 4,
      "parentCode": "30.2"
    },
    {
      "code": "30.30",
      "name": "Produksjon av luftfartøyer og romfartøyer og lignende utstyr",
      "shortName": "Prod. luft- og romfartøy og lignende",
      "level": 4,
      "parentCode": "30.3"
    },
    {
      "code": "30.40",
      "name": "Produksjon av militære stridskjøretøyer",
      "shortName": "Produksjon militære stridskjøretøy",
      "level": 4,
      "parentCode": "30.4"
    },
    {
      "code": "30.91",
      "name": "Produksjon av motorsykler",
      "shortName": "Motorsykkelproduksjon",
      "level": 4,
      "parentCode": "30.9"
    },
    {
      "code": "30.92",
      "name": "Produksjon av sykler og invalidevogner",
      "shortName": "Sykkel- og invalidevognprod.",
      "level": 4,
      "parentCode": "30.9"
    },
    {
      "code": "30.99",
      "name": "Produksjon av andre transportmidler ikke nevnt annet sted",
      "shortName": "Transportmiddelproduksjon el.",
      "level": 4,
      "parentCode": "30.9"
    },
    {
      "code": "31.01",
      "name": "Produksjon av kontor- og butikkmøbler",
      "shortName": "Kontor- og butikkmøbelprod.",
      "level": 4,
      "parentCode": "31.0"
    },
    {
      "code": "31.02",
      "name": "Produksjon av kjøkkenmøbler",
      "shortName": "Kjøkkenmøbelproduksjon",
      "level": 4,
      "parentCode": "31.0"
    },
    {
      "code": "31.03",
      "name": "Produksjon av madrasser",
      "shortName": "Madrassproduksjon",
      "level": 4,
      "parentCode": "31.0"
    },
    {
      "code": "31.09",
      "name": "Produksjon av møbler ellers",
      "shortName": "Møbelproduksjon el.",
      "level": 4,
      "parentCode": "31.0"
    },
    {
      "code": "32.11",
      "name": "Preging av mynter og medaljer",
      "shortName": "Mynt- og medaljepreging",
      "level": 4,
      "parentCode": "32.1"
    },
    {
      "code": "32.12",
      "name": "Produksjon av gull- og sølvvarer og lignende artikler",
      "shortName": "Gull- og sølvvareprod. mv.",
      "level": 4,
      "parentCode": "32.1"
    },
    {
      "code": "32.13",
      "name": "Produksjon av bijouteri og lignende artikler",
      "shortName": "Bijouterivareproduksjon mv.",
      "level": 4,
      "parentCode": "32.1"
    },
    {
      "code": "32.20",
      "name": "Produksjon av musikkinstrumenter",
      "shortName": "Musikkinstrumentproduksjon",
      "level": 4,
      "parentCode": "32.2"
    },
    {
      "code": "32.30",
      "name": "Produksjon av sportsartikler",
      "shortName": "Sportsartikkelproduksjon",
      "level": 4,
      "parentCode": "32.3"
    },
    {
      "code": "32.40",
      "name": "Produksjon av spill og leker",
      "shortName": "Spill- og leketøyproduksjon",
      "level": 4,
      "parentCode": "32.4"
    },
    {
      "code": "32.50",
      "name": "Produksjon av medisinske og tanntekniske instrumenter og utstyr",
      "shortName": "Medisinske og tanntekniske instr.",
      "level": 4,
      "parentCode": "32.5"
    },
    {
      "code": "32.91",
      "name": "Produksjon av koster og børster",
      "shortName": "Kost- og børsteproduksjon",
      "level": 4,
      "parentCode": "32.9"
    },
    {
      "code": "32.99",
      "name": "Annen industriproduksjon ikke nevnt annet sted",
      "shortName": "Industriproduksjon ellers",
      "level": 4,
      "parentCode": "32.9"
    },
    {
      "code": "33.11",
      "name": "Reparasjon av bearbeidede metallprodukter",
      "shortName": "Rep. av bearbeidede metallprodukter",
      "level": 4,
      "parentCode": "33.1"
    },
    {
      "code": "33.12",
      "name": "Reparasjon av maskiner",
      "shortName": "Reparasjon av maskiner",
      "level": 4,
      "parentCode": "33.1"
    },
    {
      "code": "33.13",
      "name": "Reparasjon av elektronisk og optisk utstyr",
      "shortName": "Rep. av elektronisk og optisk utstyr",
      "level": 4,
      "parentCode": "33.1"
    },
    {
      "code": "33.14",
      "name": "Reparasjon av elektrisk utstyr",
      "shortName": "Rep. av elektrisk utstyr",
      "level": 4,
      "parentCode": "33.1"
    },
    {
      "code": "33.15",
      "name": "Reparasjon og vedlikehold av skip og båter",
      "shortName": "Rep./vedlikehold av skip og båter",
      "level": 4,
      "parentCode": "33.1"
    },
    {
      "code": "33.16",
      "name": "Reparasjon og vedlikehold av luftfartøyer og romfartøyer",
      "shortName": "Rep./vedlikeh. luft- og romfartøyer",
      "level": 4,
      "parentCode": "33.1"
    },
    {
      "code": "33.17",
      "name": "Reparasjon og vedlikehold av andre transportmidler",
      "shortName": "Rep./vedlikeh. av andre transportmidler",
      "level": 4,
      "parentCode": "33.1"
    },
    {
      "code": "33.19",
      "name": "Reparasjon av annet utstyr",
      "shortName": "Rep. av annet utstyr",
      "level": 4,
      "parentCode": "33.1"
    },
    {
      "code": "33.20",
      "name": "Installasjon av industrimaskiner og -utstyr",
      "shortName": "Installasjon industrimask. og utstyr",
      "level": 4,
      "parentCode": "33.2"
    },
    {
      "code": "35.11",
      "name": "Produksjon av elektrisitet",
      "shortName": "Produksjon av elektrisitet",
      "level": 4,
      "parentCode": "35.1"
    },
    {
      "code": "35.12",
      "name": "Overføring av elektrisitet",
      "shortName": "Overføring av elektrisitet",
      "level": 4,
      "parentCode": "35.1"
    },
    {
      "code": "35.13",
      "name": "Distribusjon av elektrisitet",
      "shortName": "Distribusjon av elektrisitet",
      "level": 4,
      "parentCode": "35.1"
    },
    {
      "code": "35.14",
      "name": "Handel med elektrisitet",
      "shortName": "Handel med elektrisitet",
      "level": 4,
      "parentCode": "35.1"
    },
    {
      "code": "35.21",
      "name": "Produksjon av gass",
      "shortName": "Gassproduksjon",
      "level": 4,
      "parentCode": "35.2"
    },
    {
      "code": "35.22",
      "name": "Distribusjon av gass gjennom ledningsnett",
      "shortName": "Gassdistrib. via. ledningsnett",
      "level": 4,
      "parentCode": "35.2"
    },
    {
      "code": "35.23",
      "name": "Handel med gass gjennom ledningsnett",
      "shortName": "Handel med gass via ledningsnett",
      "level": 4,
      "parentCode": "35.2"
    },
    {
      "code": "35.30",
      "name": "Damp- og varmtvannsforsyning",
      "shortName": "Damp- og varmtvannsforsyning",
      "level": 4,
      "parentCode": "35.3"
    },
    {
      "code": "36.00",
      "name": "Uttak fra kilde, rensing og distribusjon av vann",
      "shortName": "Vannforsyning",
      "level": 4,
      "parentCode": "36.0"
    },
    {
      "code": "37.00",
      "name": "Oppsamling og behandling av avløpsvann",
      "shortName": "Håndtering av avløpsvann",
      "level": 4,
      "parentCode": "37.0"
    },
    {
      "code": "38.11",
      "name": "Innsamling av ikke-farlig avfall",
      "shortName": "Innsaml. av ikke-farlig avfall",
      "level": 4,
      "parentCode": "38.1"
    },
    {
      "code": "38.12",
      "name": "Innsamling av farlig avfall",
      "shortName": "Innsamling av farlig avfall",
      "level": 4,
      "parentCode": "38.1"
    },
    {
      "code": "38.21",
      "name": "Behandling og disponering av ikke-farlig avfall",
      "shortName": "Behandl. og disp. av ikke-farlig avfall",
      "level": 4,
      "parentCode": "38.2"
    },
    {
      "code": "38.22",
      "name": "Behandling og disponering av farlig avfall",
      "shortName": "Behandl. og disp. av farlig avfall",
      "level": 4,
      "parentCode": "38.2"
    },
    {
      "code": "38.31",
      "name": "Demontering av vrakede gjenstander",
      "shortName": "Demont. av vrakede gjenstander",
      "level": 4,
      "parentCode": "38.3"
    },
    {
      "code": "38.32",
      "name": "Sortering og bearbeiding av avfall for materialgjenvinning",
      "shortName": "Sort./bearb. avfall for matr.gjenv.",
      "level": 4,
      "parentCode": "38.3"
    },
    {
      "code": "39.00",
      "name": "Miljørydding, miljørensing og lignende virksomhet",
      "shortName": "Miljørydding og miljørensing",
      "level": 4,
      "parentCode": "39.0"
    },
    {
      "code": "41.10",
      "name": "Utvikling av byggeprosjekter",
      "shortName": "Utvikling av byggeprosjekter",
      "level": 4,
      "parentCode": "41.1"
    },
    {
      "code": "41.20",
      "name": "Oppføring av bygninger",
      "shortName": "Oppføring av bygninger",
      "level": 4,
      "parentCode": "41.2"
    },
    {
      "code": "42.11",
      "name": "Bygging av veier og motorveier",
      "shortName": "Bygging av veier og motorveier",
      "level": 4,
      "parentCode": "42.1"
    },
    {
      "code": "42.12",
      "name": "Bygging av jernbaner og undergrunnsbaner",
      "shortName": "Bygg. av jernbaner/undergrunnsbaner",
      "level": 4,
      "parentCode": "42.1"
    },
    {
      "code": "42.13",
      "name": "Bygging av bruer og tunneler",
      "shortName": "Bygging av bruer og tunneler",
      "level": 4,
      "parentCode": "42.1"
    },
    {
      "code": "42.21",
      "name": "Bygging av vann- og kloakkanlegg",
      "shortName": "Bygging av vann- og kloakkanl.",
      "level": 4,
      "parentCode": "42.2"
    },
    {
      "code": "42.22",
      "name": "Bygging av anlegg for elektrisitet og telekommunikasjon",
      "shortName": "Bygg. av el.anl. og telekomm.anl.",
      "level": 4,
      "parentCode": "42.2"
    },
    {
      "code": "42.91",
      "name": "Bygging av havne- og damanlegg",
      "shortName": "Bygging av havne- og damanlegg",
      "level": 4,
      "parentCode": "42.9"
    },
    {
      "code": "42.99",
      "name": "Bygging av andre anlegg ikke nevnt annet sted",
      "shortName": "Bygging av andre anlegg",
      "level": 4,
      "parentCode": "42.9"
    },
    {
      "code": "43.11",
      "name": "Riving av bygninger og andre konstruksjoner",
      "shortName": "Riv. av bygn./andre konstruksjoner",
      "level": 4,
      "parentCode": "43.1"
    },
    {
      "code": "43.12",
      "name": "Grunnarbeid",
      "shortName": "Grunnarbeid",
      "level": 4,
      "parentCode": "43.1"
    },
    {
      "code": "43.13",
      "name": "Prøveboring",
      "shortName": "Prøveboring",
      "level": 4,
      "parentCode": "43.1"
    },
    {
      "code": "43.21",
      "name": "Elektrisk installasjonsarbeid",
      "shortName": "Elektrisk installasjonsarbeid",
      "level": 4,
      "parentCode": "43.2"
    },
    {
      "code": "43.22",
      "name": "VVS-arbeid",
      "shortName": "VVS-arbeid",
      "level": 4,
      "parentCode": "43.2"
    },
    {
      "code": "43.29",
      "name": "Annet installasjonsarbeid",
      "shortName": "Annet installasjonsarbeid",
      "level": 4,
      "parentCode": "43.2"
    },
    {
      "code": "43.31",
      "name": "Stukkatørarbeid og pussing",
      "shortName": "Stukkatørarbeid og pussing",
      "level": 4,
      "parentCode": "43.3"
    },
    {
      "code": "43.32",
      "name": "Snekkerarbeid",
      "shortName": "Snekkerarbeid",
      "level": 4,
      "parentCode": "43.3"
    },
    {
      "code": "43.33",
      "name": "Gulvlegging og tapetsering",
      "shortName": "Gulvlegging og tapetsering",
      "level": 4,
      "parentCode": "43.3"
    },
    {
      "code": "43.34",
      "name": "Maler- og glassarbeid",
      "shortName": "Maler- og glassarbeid",
      "level": 4,
      "parentCode": "43.3"
    },
    {
      "code": "43.39",
      "name": "Annen ferdiggjøring av bygninger",
      "shortName": "Annen ferdiggjøring av bygninger",
      "level": 4,
      "parentCode": "43.3"
    },
    {
      "code": "43.91",
      "name": "Takarbeid",
      "shortName": "Takarbeid",
      "level": 4,
      "parentCode": "43.9"
    },
    {
      "code": "43.99",
      "name": "Annen spesialisert bygge- og anleggsvirksomhet",
      "shortName": "Annen spes. bygge- og anleggsvirks.",
      "level": 4,
      "parentCode": "43.9"
    },
    {
      "code": "45.11",
      "name": "Handel med biler og lette motorvogner, unntatt motorsykler",
      "shortName": "Handel med biler og lette motorv.",
      "level": 4,
      "parentCode": "45.1"
    },
    {
      "code": "45.19",
      "name": "Handel med andre motorvogner, unntatt motorsykler",
      "shortName": "Handel med andre motorvogner",
      "level": 4,
      "parentCode": "45.1"
    },
    {
      "code": "45.20",
      "name": "Vedlikehold og reparasjon av motorvogner, unntatt motorsykler",
      "shortName": "Rep. av motorvogner/unnt. motorsyk.",
      "level": 4,
      "parentCode": "45.2"
    },
    {
      "code": "45.31",
      "name": "Agentur- og engroshandel med deler og utstyr til motorvogner, unntatt motorsykler",
      "shortName": "Agent.-/engrosh. motorv./-deler mv.",
      "level": 4,
      "parentCode": "45.3"
    },
    {
      "code": "45.32",
      "name": "Detaljhandel med deler og utstyr til motorvogner, unntatt motorsykler",
      "shortName": "Detalj. deler/utstyr til motorvogn",
      "level": 4,
      "parentCode": "45.3"
    },
    {
      "code": "45.40",
      "name": "Handel med motorsykler, deler og utstyr. Vedlikehold og reparasjon av motorsykler",
      "shortName": "Motorsykkelhandel og -rep. mv.",
      "level": 4,
      "parentCode": "45.4"
    },
    {
      "code": "46.11",
      "name": "Agenturhandel med jordbruksråvarer, levende dyr, tekstilråvarer og innsatsvarer",
      "shortName": "Agentur jordbr. og tekstilråv. mv.",
      "level": 4,
      "parentCode": "46.1"
    },
    {
      "code": "46.12",
      "name": "Agenturhandel med brensel, drivstoff, malm, metaller og industrikjemikalier",
      "shortName": "Agentur brensel, drivstoff mv.",
      "level": 4,
      "parentCode": "46.1"
    },
    {
      "code": "46.13",
      "name": "Agenturhandel med tømmer, trelast og byggevarer",
      "shortName": "Agentur tømmer, trelast, byggev.",
      "level": 4,
      "parentCode": "46.1"
    },
    {
      "code": "46.14",
      "name": "Agenturhandel med maskiner, produksjonsutstyr, båter og luftfartøyer",
      "shortName": "Agentur maskiner, prod.utstyr mv.",
      "level": 4,
      "parentCode": "46.1"
    },
    {
      "code": "46.15",
      "name": "Agenturhandel med møbler, husholdningsvarer og jernvarer",
      "shortName": "Agentur møbler, hush.- og jernvarer",
      "level": 4,
      "parentCode": "46.1"
    },
    {
      "code": "46.16",
      "name": "Agenturhandel med tekstiler, klær, pelsskinn, skotøy og lærvarer",
      "shortName": "Agentur tekstiler/klær/skotøy mv.",
      "level": 4,
      "parentCode": "46.1"
    },
    {
      "code": "46.17",
      "name": "Agenturhandel med nærings- og nytelsesmidler",
      "shortName": "Agentur nærings- og nytelsesmidler",
      "level": 4,
      "parentCode": "46.1"
    },
    {
      "code": "46.18",
      "name": "Agenturhandel med spesialisert vareutvalg ellers",
      "shortName": "Agentur spesialisert vareutvalg el.",
      "level": 4,
      "parentCode": "46.1"
    },
    {
      "code": "46.19",
      "name": "Agenturhandel med bredt vareutvalg",
      "shortName": "Agentur bredt vareutvalg",
      "level": 4,
      "parentCode": "46.1"
    },
    {
      "code": "46.21",
      "name": "Engroshandel med korn, råtobakk, såvarer og fôrvarer",
      "shortName": "Engrosh. korn, såvarer og fôr",
      "level": 4,
      "parentCode": "46.2"
    },
    {
      "code": "46.22",
      "name": "Engroshandel med blomster og planter",
      "shortName": "Engrosh. blomster og planter",
      "level": 4,
      "parentCode": "46.2"
    },
    {
      "code": "46.23",
      "name": "Engroshandel med levende dyr",
      "shortName": "Engrosh. levende dyr",
      "level": 4,
      "parentCode": "46.2"
    },
    {
      "code": "46.24",
      "name": "Engroshandel med huder, skinn og lær",
      "shortName": "Engrosh. huder, skinn og lær",
      "level": 4,
      "parentCode": "46.2"
    },
    {
      "code": "46.31",
      "name": "Engroshandel med frukt og grønnsaker",
      "shortName": "Engrosh. frukt og grønnsaker",
      "level": 4,
      "parentCode": "46.3"
    },
    {
      "code": "46.32",
      "name": "Engroshandel med kjøtt og kjøttvarer",
      "shortName": "Engrosh. kjøtt og kjøttvarer",
      "level": 4,
      "parentCode": "46.3"
    },
    {
      "code": "46.33",
      "name": "Engroshandel med meierivarer, egg, matolje og -fett",
      "shortName": "Engrosh. meierivarer, egg mv.",
      "level": 4,
      "parentCode": "46.3"
    },
    {
      "code": "46.34",
      "name": "Engroshandel med drikkevarer",
      "shortName": "Engrosh. drikkevarer",
      "level": 4,
      "parentCode": "46.3"
    },
    {
      "code": "46.35",
      "name": "Engroshandel med tobakksvarer",
      "shortName": "Engrosh. tobakksvarer",
      "level": 4,
      "parentCode": "46.3"
    },
    {
      "code": "46.36",
      "name": "Engroshandel med sukker, sjokolade og sukkervarer",
      "shortName": "Engrosh. sukker, sjok. og sukkerv.",
      "level": 4,
      "parentCode": "46.3"
    },
    {
      "code": "46.37",
      "name": "Engroshandel med kaffe, te, kakao og krydder",
      "shortName": "Engrosh. kaffe, te, kakao mv.",
      "level": 4,
      "parentCode": "46.3"
    },
    {
      "code": "46.38",
      "name": "Engroshandel med andre næringsmidler, herunder fisk, skalldyr og bløtdyr",
      "shortName": "Engrosh. andre næringsmidler",
      "level": 4,
      "parentCode": "46.3"
    },
    {
      "code": "46.39",
      "name": "Engroshandel med bredt utvalg av nærings- og nytelsesmidler",
      "shortName": "Engrosh. bredt utv. nær.-/nyt. midl",
      "level": 4,
      "parentCode": "46.3"
    },
    {
      "code": "46.41",
      "name": "Engroshandel med tekstiler og utstyrsvarer",
      "shortName": "Engrosh. tekstiler og utstyrsvarer",
      "level": 4,
      "parentCode": "46.4"
    },
    {
      "code": "46.42",
      "name": "Engroshandel med klær og skotøy",
      "shortName": "Engrosh. klær og skotøy",
      "level": 4,
      "parentCode": "46.4"
    },
    {
      "code": "46.43",
      "name": "Engroshandel med elektriske husholdningsapparater",
      "shortName": "Engrosh. el. husholdningsapp. mv..",
      "level": 4,
      "parentCode": "46.4"
    },
    {
      "code": "46.44",
      "name": "Engroshandel med kjøkkenutstyr, glass, steintøy og rengjøringsmidler",
      "shortName": "Engrosh. kjøkkenutstyr, steintøy mv.",
      "level": 4,
      "parentCode": "46.4"
    },
    {
      "code": "46.45",
      "name": "Engroshandel med parfyme og kosmetikk",
      "shortName": "Engrosh. parfyme og kosmetikk",
      "level": 4,
      "parentCode": "46.4"
    },
    {
      "code": "46.46",
      "name": "Engroshandel med sykepleie- og apotekvarer",
      "shortName": "Engrosh. sykepleie- og apotekvarer",
      "level": 4,
      "parentCode": "46.4"
    },
    {
      "code": "46.47",
      "name": "Engroshandel med møbler, gulvbelegg, gulvtepper og belysningsutstyr",
      "shortName": "Engrosh. møbler og innredningsart.",
      "level": 4,
      "parentCode": "46.4"
    },
    {
      "code": "46.48",
      "name": "Engroshandel med klokker, ur, gull- og sølvvarer",
      "shortName": "Engrosh. klokker/ur/gull-/sølvvarer",
      "level": 4,
      "parentCode": "46.4"
    },
    {
      "code": "46.49",
      "name": "Engroshandel med husholdningsvarer og varer til personlig bruk ellers",
      "shortName": "Engrosh. husholdningsvarer m.m.",
      "level": 4,
      "parentCode": "46.4"
    },
    {
      "code": "46.51",
      "name": "Engroshandel med datamaskiner, tilleggsutstyr til datamaskiner samt programvare",
      "shortName": "Engrosh. datamask., programv. mv..",
      "level": 4,
      "parentCode": "46.5"
    },
    {
      "code": "46.52",
      "name": "Engroshandel med elektronikkutstyr og telekommunikasjonsutstyr samt deler",
      "shortName": "Engrosh. elektronikk-/telekomm.uts.",
      "level": 4,
      "parentCode": "46.5"
    },
    {
      "code": "46.61",
      "name": "Engroshandel med maskiner og utstyr til jordbruk og skogbruk",
      "shortName": "Engrosh. jordbr.-/skogbr.mask. mv.",
      "level": 4,
      "parentCode": "46.6"
    },
    {
      "code": "46.62",
      "name": "Engroshandel med maskinverktøy",
      "shortName": "Engrosh. maskinverktøy",
      "level": 4,
      "parentCode": "46.6"
    },
    {
      "code": "46.63",
      "name": "Engroshandel med maskiner og utstyr til bergverksdrift, olje- og gassutvinning og bygge- og anleggsvirksomhet",
      "shortName": "Engros mask bygg/anl./oljeutv. mv.",
      "level": 4,
      "parentCode": "46.6"
    },
    {
      "code": "46.64",
      "name": "Engroshandel med maskiner og utstyr til tekstilproduksjon",
      "shortName": "Engrosh. tekstilprod.maskiner mv.",
      "level": 4,
      "parentCode": "46.6"
    },
    {
      "code": "46.65",
      "name": "Engroshandel med kontormøbler",
      "shortName": "Engrosh. kontormøbler",
      "level": 4,
      "parentCode": "46.6"
    },
    {
      "code": "46.66",
      "name": "Engroshandel med maskiner og utstyr til kontor ellers",
      "shortName": "Engrosh. kontormask., -utstyr el.",
      "level": 4,
      "parentCode": "46.6"
    },
    {
      "code": "46.69",
      "name": "Engroshandel med maskiner og utstyr ellers",
      "shortName": "Engrosh. maskiner og utstyr el.",
      "level": 4,
      "parentCode": "46.6"
    },
    {
      "code": "46.71",
      "name": "Engroshandel med drivstoff og brensel",
      "shortName": "Engrosh. drivstoff og brensel",
      "level": 4,
      "parentCode": "46.7"
    },
    {
      "code": "46.72",
      "name": "Engroshandel med metaller og metallholdig malm",
      "shortName": "Engrosh. metaller og metallh. malm",
      "level": 4,
      "parentCode": "46.7"
    },
    {
      "code": "46.73",
      "name": "Engroshandel med tømmer, trelast, byggevarer og sanitærutstyr",
      "shortName": "Engrosh. tømmer/trelast/byggev. mv.",
      "level": 4,
      "parentCode": "46.7"
    },
    {
      "code": "46.74",
      "name": "Engroshandel med jernvarer, rørleggerartikler og oppvarmingsutstyr",
      "shortName": "Engrosh. jernv., rørleggerart. m.m.",
      "level": 4,
      "parentCode": "46.7"
    },
    {
      "code": "46.75",
      "name": "Engroshandel med kjemiske produkter",
      "shortName": "Engrosh. kjemiske produkter",
      "level": 4,
      "parentCode": "46.7"
    },
    {
      "code": "46.76",
      "name": "Engroshandel med innsatsvarer ellers",
      "shortName": "Engrosh. innsatsvarer el.",
      "level": 4,
      "parentCode": "46.7"
    },
    {
      "code": "46.77",
      "name": "Engroshandel med avfall og skrap",
      "shortName": "Engrosh. avfall og skrap",
      "level": 4,
      "parentCode": "46.7"
    },
    {
      "code": "46.90",
      "name": "Uspesifisert engroshandel",
      "shortName": "Uspesifisert engroshandel",
      "level": 4,
      "parentCode": "46.9"
    },
    {
      "code": "47.11",
      "name": "Butikkhandel med bredt vareutvalg med hovedvekt på nærings- og nytelsesmidler",
      "shortName": "Butikkh. bredt utvalg nær.midler mv.",
      "level": 4,
      "parentCode": "47.1"
    },
    {
      "code": "47.19",
      "name": "Butikkhandel med bredt vareutvalg ellers",
      "shortName": "Butikkh. bredt vareutvalg el.",
      "level": 4,
      "parentCode": "47.1"
    },
    {
      "code": "47.21",
      "name": "Butikkhandel med frukt og grønnsaker",
      "shortName": "Butikkh. frukt og grønnsaker",
      "level": 4,
      "parentCode": "47.2"
    },
    {
      "code": "47.22",
      "name": "Butikkhandel med kjøtt og kjøttvarer",
      "shortName": "Butikkh. kjøtt og kjøttvarer",
      "level": 4,
      "parentCode": "47.2"
    },
    {
      "code": "47.23",
      "name": "Butikkhandel med fisk, skalldyr og bløtdyr",
      "shortName": "Butikkh. fisk, skalldyr og bløtdyr",
      "level": 4,
      "parentCode": "47.2"
    },
    {
      "code": "47.24",
      "name": "Butikkhandel med bakervarer, konditorvarer og sukkervarer",
      "shortName": "Butikkh. baker-, konditorvarer mv.",
      "level": 4,
      "parentCode": "47.2"
    },
    {
      "code": "47.25",
      "name": "Butikkhandel med drikkevarer",
      "shortName": "Butikkh. drikkevarer",
      "level": 4,
      "parentCode": "47.2"
    },
    {
      "code": "47.26",
      "name": "Butikkhandel med tobakksvarer",
      "shortName": "Butikkh. tobakksvarer",
      "level": 4,
      "parentCode": "47.2"
    },
    {
      "code": "47.29",
      "name": "Butikkhandel med nærings- og nytelsesmidler ellers",
      "shortName": "Butikkh. nær.- og nytelsesmidler el.",
      "level": 4,
      "parentCode": "47.2"
    },
    {
      "code": "47.30",
      "name": "Detaljhandel med drivstoff til motorvogner",
      "shortName": "Detaljh. drivstoff til motorvogner",
      "level": 4,
      "parentCode": "47.3"
    },
    {
      "code": "47.41",
      "name": "Butikkhandel med datamaskiner og utstyr til datamaskiner",
      "shortName": "Butikkh. datamask. og tilleggsutst.",
      "level": 4,
      "parentCode": "47.4"
    },
    {
      "code": "47.42",
      "name": "Butikkhandel med telekommunikasjonsutstyr",
      "shortName": "Butikkh. telekommunikasjonsutstyr",
      "level": 4,
      "parentCode": "47.4"
    },
    {
      "code": "47.43",
      "name": "Butikkhandel med audio- og videoutstyr",
      "shortName": "Butikkh. audio- og videoutstyr",
      "level": 4,
      "parentCode": "47.4"
    },
    {
      "code": "47.51",
      "name": "Butikkhandel med tekstiler og utstyrsvarer",
      "shortName": "Butikkh. tekstiler og utstyrsvarer",
      "level": 4,
      "parentCode": "47.5"
    },
    {
      "code": "47.52",
      "name": "Butikkhandel med jernvarer, fargevarer og glass",
      "shortName": "Butikkh. jernv., fargev. og glass",
      "level": 4,
      "parentCode": "47.5"
    },
    {
      "code": "47.53",
      "name": "Butikkhandel med tapeter, gulvtepper og gardiner",
      "shortName": "Butikkh. tapet/gulvtepper/gardiner",
      "level": 4,
      "parentCode": "47.5"
    },
    {
      "code": "47.54",
      "name": "Butikkhandel med elektriske husholdningsapparater",
      "shortName": "Butikkh. el. hush.apparater",
      "level": 4,
      "parentCode": "47.5"
    },
    {
      "code": "47.59",
      "name": "Butikkhandel med møbler, belysningsutstyr og andre innredningsartikler",
      "shortName": "Butikkh. møbler/belys.utstyr mv.",
      "level": 4,
      "parentCode": "47.5"
    },
    {
      "code": "47.61",
      "name": "Butikkhandel med bøker",
      "shortName": "Butikkh. bøker",
      "level": 4,
      "parentCode": "47.6"
    },
    {
      "code": "47.62",
      "name": "Butikkhandel med aviser og papirvarer",
      "shortName": "Butikkh. aviser og papirvarer",
      "level": 4,
      "parentCode": "47.6"
    },
    {
      "code": "47.63",
      "name": "Butikkhandel med innspillinger av musikk og video",
      "shortName": "Butikkh. innspill. av musikk/video",
      "level": 4,
      "parentCode": "47.6"
    },
    {
      "code": "47.64",
      "name": "Butikkhandel med sportsutstyr",
      "shortName": "Butikkh. sportsutstyr",
      "level": 4,
      "parentCode": "47.6"
    },
    {
      "code": "47.65",
      "name": "Butikkhandel med spill og leker",
      "shortName": "Butikkh. spill og leker",
      "level": 4,
      "parentCode": "47.6"
    },
    {
      "code": "47.71",
      "name": "Butikkhandel med klær",
      "shortName": "Butikkh. klær",
      "level": 4,
      "parentCode": "47.7"
    },
    {
      "code": "47.72",
      "name": "Butikkhandel med skotøy og lærvarer",
      "shortName": "Butikkh. skotøy og lærvarer",
      "level": 4,
      "parentCode": "47.7"
    },
    {
      "code": "47.73",
      "name": "Butikkhandel med apotekvarer",
      "shortName": "Butikkh. apotekvarer",
      "level": 4,
      "parentCode": "47.7"
    },
    {
      "code": "47.74",
      "name": "Butikkhandel med medisinske og ortopediske artikler",
      "shortName": "Butikkh. medisinske/ortop. art.",
      "level": 4,
      "parentCode": "47.7"
    },
    {
      "code": "47.75",
      "name": "Butikkhandel med kosmetikk og toalettartikler",
      "shortName": "Butikkh. kosmetikk og toalettart.",
      "level": 4,
      "parentCode": "47.7"
    },
    {
      "code": "47.76",
      "name": "Butikkhandel med blomster og planter, kjæledyr og fôrvarer til kjæledyr",
      "shortName": "Butikkh. blomster/planter mv.",
      "level": 4,
      "parentCode": "47.7"
    },
    {
      "code": "47.77",
      "name": "Butikkhandel med ur, gull- og sølvvarer",
      "shortName": "Butikkh. ur, gull- og sølvvarer",
      "level": 4,
      "parentCode": "47.7"
    },
    {
      "code": "47.78",
      "name": "Annen butikkhandel med andre nye varer i spesialforretninger",
      "shortName": "Butikkh. nye varer i spes.forr. el.",
      "level": 4,
      "parentCode": "47.7"
    },
    {
      "code": "47.79",
      "name": "Butikkhandel med brukte varer",
      "shortName": "Butikkh. brukte varer",
      "level": 4,
      "parentCode": "47.7"
    },
    {
      "code": "47.81",
      "name": "Torghandel med næringsmidler, drikkevarer og tobakksvarer",
      "shortName": "Torgh. nær.midl./drikkev./tobakksv.",
      "level": 4,
      "parentCode": "47.8"
    },
    {
      "code": "47.82",
      "name": "Torghandel med tekstiler, klær, skotøy og utstyrsvarer",
      "shortName": "Torgh. tekstiler, klær, skotøy m.m.",
      "level": 4,
      "parentCode": "47.8"
    },
    {
      "code": "47.89",
      "name": "Torghandel med andre varer",
      "shortName": "Torgh. andre varer",
      "level": 4,
      "parentCode": "47.8"
    },
    {
      "code": "47.91",
      "name": "Postordrehandel og handel via Internett",
      "shortName": "Postordreh. og handel via Internett",
      "level": 4,
      "parentCode": "47.9"
    },
    {
      "code": "47.99",
      "name": "Detaljhandel utenom utsalgssted ellers",
      "shortName": "Detaljh. utenom utsalgssted el.",
      "level": 4,
      "parentCode": "47.9"
    },
    {
      "code": "49.10",
      "name": "Passasjertransport med jernbane",
      "shortName": "Passasjertransp. med jernbane",
      "level": 4,
      "parentCode": "49.1"
    },
    {
      "code": "49.20",
      "name": "Godstransport med jernbane",
      "shortName": "Godstransp. med jernbane",
      "level": 4,
      "parentCode": "49.2"
    },
    {
      "code": "49.31",
      "name": "Transport med rutebil og sporvei i by- og forstadsområde",
      "shortName": "Rutebil/sporvei i by-/forstadsomr.",
      "level": 4,
      "parentCode": "49.3"
    },
    {
      "code": "49.32",
      "name": "Drosjebiltransport",
      "shortName": "Drosjebiltransport",
      "level": 4,
      "parentCode": "49.3"
    },
    {
      "code": "49.39",
      "name": "Landtransport med passasjerer ikke nevnt annet sted",
      "shortName": "Landtr. med passasjerer el.",
      "level": 4,
      "parentCode": "49.3"
    },
    {
      "code": "49.41",
      "name": "Godstransport på vei",
      "shortName": "Godstransport på vei",
      "level": 4,
      "parentCode": "49.4"
    },
    {
      "code": "49.42",
      "name": "Flyttetransport",
      "shortName": "Flyttetransport",
      "level": 4,
      "parentCode": "49.4"
    },
    {
      "code": "49.50",
      "name": "Rørtransport",
      "shortName": "Rørtransport",
      "level": 4,
      "parentCode": "49.5"
    },
    {
      "code": "50.10",
      "name": "Sjøfart og kysttrafikk med passasjerer",
      "shortName": "Sjøfart og kysttraf. m/passasjerer",
      "level": 4,
      "parentCode": "50.1"
    },
    {
      "code": "50.20",
      "name": "Sjøfart og kysttrafikk med gods",
      "shortName": "Sjøfart og kysttrafikk med gods",
      "level": 4,
      "parentCode": "50.2"
    },
    {
      "code": "50.30",
      "name": "Passasjertransport på elver og innsjøer",
      "shortName": "Passasjertr. på elver og innsjøer",
      "level": 4,
      "parentCode": "50.3"
    },
    {
      "code": "50.40",
      "name": "Godstransport på elver og innsjøer",
      "shortName": "Godstransp. på elver og innsjøer",
      "level": 4,
      "parentCode": "50.4"
    },
    {
      "code": "51.10",
      "name": "Lufttransport med passasjerer",
      "shortName": "Lufttransp. med passasjerer",
      "level": 4,
      "parentCode": "51.1"
    },
    {
      "code": "51.21",
      "name": "Lufttransport med gods",
      "shortName": "Lufttransp. med gods",
      "level": 4,
      "parentCode": "51.2"
    },
    {
      "code": "51.22",
      "name": "Romfart",
      "shortName": "Romfart",
      "level": 4,
      "parentCode": "51.2"
    },
    {
      "code": "52.10",
      "name": "Lagring",
      "shortName": "Lagring",
      "level": 4,
      "parentCode": "52.1"
    },
    {
      "code": "52.21",
      "name": "Andre tjenester tilknyttet landtransport",
      "shortName": "Andre tjen. tilkn. landtransport",
      "level": 4,
      "parentCode": "52.2"
    },
    {
      "code": "52.22",
      "name": "Andre tjenester tilknyttet sjøtransport",
      "shortName": "Andre tjen. tilkn. sjøtransport",
      "level": 4,
      "parentCode": "52.2"
    },
    {
      "code": "52.23",
      "name": "Andre tjenester tilknyttet lufttransport",
      "shortName": "Andre tjen. tilkn. lufttransport",
      "level": 4,
      "parentCode": "52.2"
    },
    {
      "code": "52.24",
      "name": "Lasting og lossing",
      "shortName": "Lasting og lossing",
      "level": 4,
      "parentCode": "52.2"
    },
    {
      "code": "52.29",
      "name": "Andre tjenester tilknyttet transport",
      "shortName": "Andre tjenester tilknyttet transport",
      "level": 4,
      "parentCode": "52.2"
    },
    {
      "code": "53.10",
      "name": "Landsdekkende posttjenester",
      "shortName": "Landsdekkende posttjenester",
      "level": 4,
      "parentCode": "53.1"
    },
    {
      "code": "53.20",
      "name": "Andre post- og budtjenester",
      "shortName": "Andre post- og budtjenester",
      "level": 4,
      "parentCode": "53.2"
    },
    {
      "code": "55.10",
      "name": "Hotellvirksomhet",
      "shortName": "Hotellvirksomhet",
      "level": 4,
      "parentCode": "55.1"
    },
    {
      "code": "55.20",
      "name": "Drift av vandrerhjem og ferieleiligheter",
      "shortName": "Drift av vandrerhjem/ferieleil.",
      "level": 4,
      "parentCode": "55.2"
    },
    {
      "code": "55.30",
      "name": "Drift av campingplasser",
      "shortName": "Drift av campingplasser",
      "level": 4,
      "parentCode": "55.3"
    },
    {
      "code": "55.90",
      "name": "Annen overnatting",
      "shortName": "Annen overnatting",
      "level": 4,
      "parentCode": "55.9"
    },
    {
      "code": "56.10",
      "name": "Restaurantvirksomhet",
      "shortName": "Restaurantvirksomhet",
      "level": 4,
      "parentCode": "56.1"
    },
    {
      "code": "56.21",
      "name": "Cateringvirksomhet",
      "shortName": "Cateringvirksomhet",
      "level": 4,
      "parentCode": "56.2"
    },
    {
      "code": "56.29",
      "name": "Kantiner drevet som selvstendig virksomhet",
      "shortName": "Kantinedrift, selvst. virksomhet",
      "level": 4,
      "parentCode": "56.2"
    },
    {
      "code": "56.30",
      "name": "Drift av barer",
      "shortName": "Drift av barer",
      "level": 4,
      "parentCode": "56.3"
    },
    {
      "code": "58.11",
      "name": "Utgivelse av bøker",
      "shortName": "Utgivelse av bøker",
      "level": 4,
      "parentCode": "58.1"
    },
    {
      "code": "58.12",
      "name": "Utgivelse av kataloger og adresselister",
      "shortName": "Utgiv. av kataloger/adresselister",
      "level": 4,
      "parentCode": "58.1"
    },
    {
      "code": "58.13",
      "name": "Utgivelse av aviser",
      "shortName": "Utgivelse av aviser",
      "level": 4,
      "parentCode": "58.1"
    },
    {
      "code": "58.14",
      "name": "Utgivelse av blader og tidsskrifter",
      "shortName": "Utgivelse av blader og tidsskrifter",
      "level": 4,
      "parentCode": "58.1"
    },
    {
      "code": "58.19",
      "name": "Forlagsvirksomhet ellers",
      "shortName": "Forlagsvirksomhet ellers",
      "level": 4,
      "parentCode": "58.1"
    },
    {
      "code": "58.21",
      "name": "Utgivelse av programvare for dataspill",
      "shortName": "Utgiv. av programv. for dataspill",
      "level": 4,
      "parentCode": "58.2"
    },
    {
      "code": "58.29",
      "name": "Utgivelse av annen programvare",
      "shortName": "Utgiv. av annen programvare",
      "level": 4,
      "parentCode": "58.2"
    },
    {
      "code": "59.11",
      "name": "Produksjon av film, video og fjernsynsprogrammer",
      "shortName": "Prod. av film/video/fjernsynsprogr.",
      "level": 4,
      "parentCode": "59.1"
    },
    {
      "code": "59.12",
      "name": "Etterarbeid knyttet til produksjon av film, video og fjernsynsprogrammer",
      "shortName": "Etterarb. til film-/video-/TV-prod.",
      "level": 4,
      "parentCode": "59.1"
    },
    {
      "code": "59.13",
      "name": "Distribusjon av film, video og fjernsynsprogrammer",
      "shortName": "Distrib. film/video/fjernsynsprogr.",
      "level": 4,
      "parentCode": "59.1"
    },
    {
      "code": "59.14",
      "name": "Filmframvisning",
      "shortName": "Filmframvisning",
      "level": 4,
      "parentCode": "59.1"
    },
    {
      "code": "59.20",
      "name": "Produksjon og utgivelse av musikk- og lydopptak",
      "shortName": "Prod./utgiv. av musikk-/lydopptak",
      "level": 4,
      "parentCode": "59.2"
    },
    {
      "code": "60.10",
      "name": "Radiokringkasting",
      "shortName": "Radiokringkasting",
      "level": 4,
      "parentCode": "60.1"
    },
    {
      "code": "60.20",
      "name": "Fjernsynskringkasting",
      "shortName": "Fjernsynskringkasting",
      "level": 4,
      "parentCode": "60.2"
    },
    {
      "code": "61.10",
      "name": "Kabelbasert telekommunikasjon",
      "shortName": "Kabelbasert telekomm.",
      "level": 4,
      "parentCode": "61.1"
    },
    {
      "code": "61.20",
      "name": "Trådløs telekommunikasjon",
      "shortName": "Trådløs telekomm.",
      "level": 4,
      "parentCode": "61.2"
    },
    {
      "code": "61.30",
      "name": "Satellittbasert telekommunikasjon",
      "shortName": "Satellittbasert telekomm.",
      "level": 4,
      "parentCode": "61.3"
    },
    {
      "code": "61.90",
      "name": "Telekommunikasjon ellers",
      "shortName": "Telekommunikasjon ellers",
      "level": 4,
      "parentCode": "61.9"
    },
    {
      "code": "62.01",
      "name": "Programmeringstjenester",
      "shortName": "Programmeringstjenester",
      "level": 4,
      "parentCode": "62.0"
    },
    {
      "code": "62.02",
      "name": "Konsulentvirksomhet tilknyttet informasjonsteknologi",
      "shortName": "Kons.virks. tilkn. informasj.tekn.",
      "level": 4,
      "parentCode": "62.0"
    },
    {
      "code": "62.03",
      "name": "Forvaltning og drift av IT-systemer",
      "shortName": "Forvaltning og drift av IT-systemer",
      "level": 4,
      "parentCode": "62.0"
    },
    {
      "code": "62.09",
      "name": "Andre tjenester tilknyttet informasjonsteknologi",
      "shortName": "Tjen. tilkn. informasjonsteknologi el.",
      "level": 4,
      "parentCode": "62.0"
    },
    {
      "code": "63.11",
      "name": "Databehandling, datalagring og tilknyttede tjenester",
      "shortName": "Databeh./-lagring og tilkn. tjen.",
      "level": 4,
      "parentCode": "63.1"
    },
    {
      "code": "63.12",
      "name": "Drift av web-portaler",
      "shortName": "Drift av web-portaler",
      "level": 4,
      "parentCode": "63.1"
    },
    {
      "code": "63.91",
      "name": "Nyhetsbyråer",
      "shortName": "Nyhetsbyråer",
      "level": 4,
      "parentCode": "63.9"
    },
    {
      "code": "63.99",
      "name": "Andre informasjonstjenester ikke nevnt annet sted",
      "shortName": "Andre informasjonstjenester",
      "level": 4,
      "parentCode": "63.9"
    },
    {
      "code": "64.11",
      "name": "Sentralbankvirksomhet",
      "shortName": "Sentralbankvirksomhet",
      "level": 4,
      "parentCode": "64.1"
    },
    {
      "code": "64.19",
      "name": "Bankvirksomhet ellers",
      "shortName": "Bankvirksomhet ellers",
      "level": 4,
      "parentCode": "64.1"
    },
    {
      "code": "64.20",
      "name": "Holdingselskaper",
      "shortName": "Holdingselskaper",
      "level": 4,
      "parentCode": "64.2"
    },
    {
      "code": "64.30",
      "name": "Verdipapirfond, investeringsselskaper o.l.",
      "shortName": "Verdipapirfond/invest.selskap. o.l.",
      "level": 4,
      "parentCode": "64.3"
    },
    {
      "code": "64.91",
      "name": "Finansiell leasing",
      "shortName": "Finansiell leasing",
      "level": 4,
      "parentCode": "64.9"
    },
    {
      "code": "64.92",
      "name": "Annen kredittgivning",
      "shortName": "Annen kredittgivning",
      "level": 4,
      "parentCode": "64.9"
    },
    {
      "code": "64.99",
      "name": "Annen finansieringsvirksomhet ikke nevnt annet sted",
      "shortName": "Finansieringsvirksomhet el.",
      "level": 4,
      "parentCode": "64.9"
    },
    {
      "code": "65.11",
      "name": "Livsforsikring",
      "shortName": "Livsforsikring",
      "level": 4,
      "parentCode": "65.1"
    },
    {
      "code": "65.12",
      "name": "Skadeforsikring",
      "shortName": "Skadeforsikring",
      "level": 4,
      "parentCode": "65.1"
    },
    {
      "code": "65.20",
      "name": "Gjenforsikring",
      "shortName": "Gjenforsikring",
      "level": 4,
      "parentCode": "65.2"
    },
    {
      "code": "65.30",
      "name": "Pensjonskasser",
      "shortName": "Pensjonskasser",
      "level": 4,
      "parentCode": "65.3"
    },
    {
      "code": "66.11",
      "name": "Administrasjon av finansmarkeder",
      "shortName": "Administrasjon av finansmarkeder",
      "level": 4,
      "parentCode": "66.1"
    },
    {
      "code": "66.12",
      "name": "Verdipapirmegling",
      "shortName": "Verdipapirmegling",
      "level": 4,
      "parentCode": "66.1"
    },
    {
      "code": "66.19",
      "name": "Andre tjenester tilknyttet finansieringsvirksomhet",
      "shortName": "Tjen. tilkn. finansieringsvirks. el.",
      "level": 4,
      "parentCode": "66.1"
    },
    {
      "code": "66.21",
      "name": "Risiko- og skadevurdering",
      "shortName": "Risiko- og skadevurdering",
      "level": 4,
      "parentCode": "66.2"
    },
    {
      "code": "66.22",
      "name": "Forsikringsformidling",
      "shortName": "Forsikringsformidling",
      "level": 4,
      "parentCode": "66.2"
    },
    {
      "code": "66.29",
      "name": "Andre tjenester tilknyttet forsikringsvirksomhet og pensjonskasser",
      "shortName": "Tjen. fors.virks./pensj.kasser el.",
      "level": 4,
      "parentCode": "66.2"
    },
    {
      "code": "66.30",
      "name": "Fondsforvaltningsvirksomhet",
      "shortName": "Fondsforvaltningsvirksomhet",
      "level": 4,
      "parentCode": "66.3"
    },
    {
      "code": "68.10",
      "name": "Kjøp og salg av egen fast eiendom",
      "shortName": "Kjøp/salg av egen fast eiendom",
      "level": 4,
      "parentCode": "68.1"
    },
    {
      "code": "68.20",
      "name": "Utleie av egen eller leid fast eiendom",
      "shortName": "Utleie av egen/leid fast eiendom",
      "level": 4,
      "parentCode": "68.2"
    },
    {
      "code": "68.31",
      "name": "Eiendomsmegling",
      "shortName": "Eiendomsmegling",
      "level": 4,
      "parentCode": "68.3"
    },
    {
      "code": "68.32",
      "name": "Eiendomsforvaltning",
      "shortName": "Eiendomsforvaltning",
      "level": 4,
      "parentCode": "68.3"
    },
    {
      "code": "69.10",
      "name": "Juridisk tjenesteyting",
      "shortName": "Juridisk tjenesteyting",
      "level": 4,
      "parentCode": "69.1"
    },
    {
      "code": "69.20",
      "name": "Regnskap, revisjon og skatterådgivning",
      "shortName": "Regnskap/revisjon/skatterådgiv.",
      "level": 4,
      "parentCode": "69.2"
    },
    {
      "code": "70.10",
      "name": "Hovedkontortjenester",
      "shortName": "Hovedkontortjenester",
      "level": 4,
      "parentCode": "70.1"
    },
    {
      "code": "70.21",
      "name": "PR og kommunikasjonstjenester",
      "shortName": "PR og kommunikasjonstjenester",
      "level": 4,
      "parentCode": "70.2"
    },
    {
      "code": "70.22",
      "name": "Bedriftsrådgivning og annen administrativ rådgivning",
      "shortName": "Bedriftsrådgiv./annen adm. rådgiv.",
      "level": 4,
      "parentCode": "70.2"
    },
    {
      "code": "71.11",
      "name": "Arkitektvirksomhet",
      "shortName": "Arkitektvirksomhet",
      "level": 4,
      "parentCode": "71.1"
    },
    {
      "code": "71.12",
      "name": "Teknisk konsulentvirksomhet",
      "shortName": "Teknisk konsulentvirksomhet",
      "level": 4,
      "parentCode": "71.1"
    },
    {
      "code": "71.20",
      "name": "Teknisk prøving og analyse",
      "shortName": "Teknisk prøving og analyse",
      "level": 4,
      "parentCode": "71.2"
    },
    {
      "code": "72.11",
      "name": "Forskning og utviklingsarbeid innen bioteknologi",
      "shortName": "Forsk./utvikl.arb. innen bioteknologi",
      "level": 4,
      "parentCode": "72.1"
    },
    {
      "code": "72.19",
      "name": "Annen forskning og annet utviklingsarbeid innen naturvitenskap og teknikk",
      "shortName": "Annen forsk. innen naturvit. og teknikk",
      "level": 4,
      "parentCode": "72.1"
    },
    {
      "code": "72.20",
      "name": "Forskning og utviklingsarbeid innen samfunnsvitenskap og humanistiske fag",
      "shortName": "Forskning samfunnsvit., human. fag",
      "level": 4,
      "parentCode": "72.2"
    },
    {
      "code": "73.11",
      "name": "Reklamebyråer",
      "shortName": "Reklamebyråer",
      "level": 4,
      "parentCode": "73.1"
    },
    {
      "code": "73.12",
      "name": "Medieformidlingstjenester",
      "shortName": "Medieformidlingstjenester",
      "level": 4,
      "parentCode": "73.1"
    },
    {
      "code": "73.20",
      "name": "Markeds- og opinionsundersøkelser",
      "shortName": "Markeds- og opinionsundersøkelser",
      "level": 4,
      "parentCode": "73.2"
    },
    {
      "code": "74.10",
      "name": "Spesialisert designvirksomhet",
      "shortName": "Spesialisert designvirksomhet",
      "level": 4,
      "parentCode": "74.1"
    },
    {
      "code": "74.20",
      "name": "Fotografvirksomhet",
      "shortName": "Fotografvirksomhet",
      "level": 4,
      "parentCode": "74.2"
    },
    {
      "code": "74.30",
      "name": "Oversettelses- og tolkevirksomhet",
      "shortName": "Oversettelses- og tolkevirksomhet",
      "level": 4,
      "parentCode": "74.3"
    },
    {
      "code": "74.90",
      "name": "Annen faglig, vitenskapelig og teknisk virksomhet",
      "shortName": "Annen faglig/vit.skap./tekn. virks.",
      "level": 4,
      "parentCode": "74.9"
    },
    {
      "code": "75.00",
      "name": "Veterinærtjenester",
      "shortName": "Veterinærtjenester",
      "level": 4,
      "parentCode": "75.0"
    },
    {
      "code": "77.11",
      "name": "Utleie og leasing av biler og andre lette motorvogner",
      "shortName": "Utl./leas. biler/andre lette motorv.",
      "level": 4,
      "parentCode": "77.1"
    },
    {
      "code": "77.12",
      "name": "Utleie og leasing av lastebiler",
      "shortName": "Utleie og leasing av lastebiler",
      "level": 4,
      "parentCode": "77.1"
    },
    {
      "code": "77.21",
      "name": "Utleie og leasing av sports- og fritidsutstyr",
      "shortName": "Utl./leas. sports- og fritidsutstyr",
      "level": 4,
      "parentCode": "77.2"
    },
    {
      "code": "77.22",
      "name": "Utleie av videofilm, DVD og lignende",
      "shortName": "Utleie videofilm, DVD og lignende",
      "level": 4,
      "parentCode": "77.2"
    },
    {
      "code": "77.29",
      "name": "Utleie og leasing av andre husholdningsvarer og varer til personlig bruk",
      "shortName": "Utl./leas. husholdningsvarer el.",
      "level": 4,
      "parentCode": "77.2"
    },
    {
      "code": "77.31",
      "name": "Utleie og leasing av landbruksmaskiner og -utstyr",
      "shortName": "Utl./leas. landbruksmaskiner og -utstyr",
      "level": 4,
      "parentCode": "77.3"
    },
    {
      "code": "77.32",
      "name": "Utleie og leasing av bygge- og anleggsmaskiner og -utstyr",
      "shortName": "Utl./leas. bygge- og anleggsmask.",
      "level": 4,
      "parentCode": "77.3"
    },
    {
      "code": "77.33",
      "name": "Utleie og leasing av kontor- og datamaskiner",
      "shortName": "Utl./leas. kontor- og datamaskiner",
      "level": 4,
      "parentCode": "77.3"
    },
    {
      "code": "77.34",
      "name": "Utleie og leasing av sjøtransportmateriell",
      "shortName": "Utl./leas. sjøtransportmateriell",
      "level": 4,
      "parentCode": "77.3"
    },
    {
      "code": "77.35",
      "name": "Utleie og leasing av lufttransportmateriell",
      "shortName": "Utl./leas. lufttransportmateriell",
      "level": 4,
      "parentCode": "77.3"
    },
    {
      "code": "77.39",
      "name": "Utleie og leasing av andre maskiner og annet utstyr og materiell ikke nevnt annet sted",
      "shortName": "Utl./leas. andre mask./annet utstyr",
      "level": 4,
      "parentCode": "77.3"
    },
    {
      "code": "77.40",
      "name": "Leasing av immateriell eiendom og lignende produkter, unntatt opphavsrettsbeskyttede verker",
      "shortName": "Leas. av immateriell eiendom mv.",
      "level": 4,
      "parentCode": "77.4"
    },
    {
      "code": "78.10",
      "name": "Rekruttering og formidling av arbeidskraft",
      "shortName": "Rekrutt./formidling av arbeidskraft",
      "level": 4,
      "parentCode": "78.1"
    },
    {
      "code": "78.20",
      "name": "Utleie av arbeidskraft",
      "shortName": "Utleie av arbeidskraft",
      "level": 4,
      "parentCode": "78.2"
    },
    {
      "code": "78.30",
      "name": "Andre personaladministrative tjenester",
      "shortName": "Andre personaladm. tjen.",
      "level": 4,
      "parentCode": "78.3"
    },
    {
      "code": "79.11",
      "name": "Reisebyråvirksomhet",
      "shortName": "Reisebyråvirksomhet",
      "level": 4,
      "parentCode": "79.1"
    },
    {
      "code": "79.12",
      "name": "Reisearrangørvirksomhet",
      "shortName": "Reisearrangørvirksomhet",
      "level": 4,
      "parentCode": "79.1"
    },
    {
      "code": "79.90",
      "name": "Annen arrangørvirksomhet og tilknyttede tjenester",
      "shortName": "Annen arrangørvirks. og tilkn. tjen.",
      "level": 4,
      "parentCode": "79.9"
    },
    {
      "code": "80.10",
      "name": "Private vakttjenester",
      "shortName": "Private vakttjenester",
      "level": 4,
      "parentCode": "80.1"
    },
    {
      "code": "80.20",
      "name": "Tjenester tilknyttet vakttjenester",
      "shortName": "Tjenester tilknyttet vakttjenester",
      "level": 4,
      "parentCode": "80.2"
    },
    {
      "code": "80.30",
      "name": "Etterforsking",
      "shortName": "Etterforsking",
      "level": 4,
      "parentCode": "80.3"
    },
    {
      "code": "81.10",
      "name": "Kombinerte tjenester tilknyttet eiendomsdrift",
      "shortName": "Komb. tjen. tilkn. eiendomsdrift",
      "level": 4,
      "parentCode": "81.1"
    },
    {
      "code": "81.21",
      "name": "Rengjøring av bygninger",
      "shortName": "Rengjøring av bygninger",
      "level": 4,
      "parentCode": "81.2"
    },
    {
      "code": "81.22",
      "name": "Utvendig rengjøring av bygninger og industriell rengjøring",
      "shortName": "Utv. rengj. bygn./ind. rengjøring",
      "level": 4,
      "parentCode": "81.2"
    },
    {
      "code": "81.29",
      "name": "Annen rengjøringsvirksomhet",
      "shortName": "Annen rengjøringsvirksomhet",
      "level": 4,
      "parentCode": "81.2"
    },
    {
      "code": "81.30",
      "name": "Beplantning av hager og parkanlegg",
      "shortName": "Beplantning av hager og parkanl.",
      "level": 4,
      "parentCode": "81.3"
    },
    {
      "code": "82.11",
      "name": "Kombinerte kontortjenester",
      "shortName": "Kombinerte kontortjenester",
      "level": 4,
      "parentCode": "82.1"
    },
    {
      "code": "82.19",
      "name": "Fotokopiering, forberedelse av dokumenter og andre spesialiserte kontortjenester",
      "shortName": "Fotokopiering/spes. kontortjen. el.",
      "level": 4,
      "parentCode": "82.1"
    },
    {
      "code": "82.20",
      "name": "Telefonvakttjenester og telefonsalg",
      "shortName": "Telefonvakttjenester/telefonsalg",
      "level": 4,
      "parentCode": "82.2"
    },
    {
      "code": "82.30",
      "name": "Kongress-, messe- og utstillingsvirksomhet",
      "shortName": "Kongress-/messe-/utstillingsvirks.",
      "level": 4,
      "parentCode": "82.3"
    },
    {
      "code": "82.91",
      "name": "Inkasso- og kredittopplysningsvirksomhet",
      "shortName": "Inkasso- og kredittopplysningsvirks.",
      "level": 4,
      "parentCode": "82.9"
    },
    {
      "code": "82.92",
      "name": "Pakkevirksomhet",
      "shortName": "Pakkevirksomhet",
      "level": 4,
      "parentCode": "82.9"
    },
    {
      "code": "82.99",
      "name": "Annen forretningsmessig tjenesteyting ikke nevnt annet sted",
      "shortName": "Forr.messig tj.yting ikke nevnt el.",
      "level": 4,
      "parentCode": "82.9"
    },
    {
      "code": "84.11",
      "name": "Generell offentlig administrasjon",
      "shortName": "Generell offentlig administrasjon",
      "level": 4,
      "parentCode": "84.1"
    },
    {
      "code": "84.12",
      "name": "Offentlig administrasjon tilknyttet helsestell, sosial virksomhet, undervisning, kirke, kultur og miljøvern",
      "shortName": "Off.adm. helse, sos.virks. m.m.",
      "level": 4,
      "parentCode": "84.1"
    },
    {
      "code": "84.13",
      "name": "Offentlig administrasjon tilknyttet næringsvirksomhet og arbeidsmarked",
      "shortName": "Off.adm. nær.virks. og arb.marked",
      "level": 4,
      "parentCode": "84.1"
    },
    {
      "code": "84.21",
      "name": "Utenrikssaker",
      "shortName": "Utenrikssaker",
      "level": 4,
      "parentCode": "84.2"
    },
    {
      "code": "84.22",
      "name": "Forsvar",
      "shortName": "Forsvar",
      "level": 4,
      "parentCode": "84.2"
    },
    {
      "code": "84.23",
      "name": "Retts- og fengselsvesen",
      "shortName": "Retts- og fengselsvesen",
      "level": 4,
      "parentCode": "84.2"
    },
    {
      "code": "84.24",
      "name": "Politi- og påtalemyndighet",
      "shortName": "Politi- og påtalemyndighet",
      "level": 4,
      "parentCode": "84.2"
    },
    {
      "code": "84.25",
      "name": "Brannvern",
      "shortName": "Brannvern",
      "level": 4,
      "parentCode": "84.2"
    },
    {
      "code": "84.30",
      "name": "Trygdeordninger underlagt offentlig forvaltning",
      "shortName": "Sosialforsikring, trygd",
      "level": 4,
      "parentCode": "84.3"
    },
    {
      "code": "85.10",
      "name": "Førskoleundervisning",
      "shortName": "Førskoleundervisning",
      "level": 4,
      "parentCode": "85.1"
    },
    {
      "code": "85.20",
      "name": "Grunnskoleundervisning",
      "shortName": "Grunnskoleundervisning",
      "level": 4,
      "parentCode": "85.2"
    },
    {
      "code": "85.31",
      "name": "Videregående opplæring innen allmennfaglige studieretninger",
      "shortName": "Undervisning i allmennfag",
      "level": 4,
      "parentCode": "85.3"
    },
    {
      "code": "85.32",
      "name": "Videregående opplæring innen tekniske og andre yrkesfaglige studieretninger",
      "shortName": "Undervisn. i tekn./yrkesrettede fag",
      "level": 4,
      "parentCode": "85.3"
    },
    {
      "code": "85.41",
      "name": "Undervisning ved fagskoler",
      "shortName": "Undervisning ved fagskoler",
      "level": 4,
      "parentCode": "85.4"
    },
    {
      "code": "85.42",
      "name": "Undervisning på universitets- og høgskolenivå",
      "shortName": "Undervisning universitet, høgskoler",
      "level": 4,
      "parentCode": "85.4"
    },
    {
      "code": "85.51",
      "name": "Undervisning innen idrett og rekreasjon",
      "shortName": "Underv. innen idrett og rekreasjon",
      "level": 4,
      "parentCode": "85.5"
    },
    {
      "code": "85.52",
      "name": "Undervisning innen kultur",
      "shortName": "Undervisning innen kultur",
      "level": 4,
      "parentCode": "85.5"
    },
    {
      "code": "85.53",
      "name": "Trafikkskoleundervisning",
      "shortName": "Trafikkskoleundervisning",
      "level": 4,
      "parentCode": "85.5"
    },
    {
      "code": "85.59",
      "name": "Annen undervisning ikke nevnt annet sted",
      "shortName": "Undervisning el.",
      "level": 4,
      "parentCode": "85.5"
    },
    {
      "code": "85.60",
      "name": "Tjenester tilknyttet undervisning",
      "shortName": "Tjenester tilkn. undervisning",
      "level": 4,
      "parentCode": "85.6"
    },
    {
      "code": "86.10",
      "name": "Sykehustjenester",
      "shortName": "Sykehustjenester",
      "level": 4,
      "parentCode": "86.1"
    },
    {
      "code": "86.21",
      "name": "Legetjeneste",
      "shortName": "Legetjeneste",
      "level": 4,
      "parentCode": "86.2"
    },
    {
      "code": "86.22",
      "name": "Spesialisert legetjeneste",
      "shortName": "Spesialisert legetjeneste",
      "level": 4,
      "parentCode": "86.2"
    },
    {
      "code": "86.23",
      "name": "Tannhelsetjenester",
      "shortName": "Tannhelsetjenester",
      "level": 4,
      "parentCode": "86.2"
    },
    {
      "code": "86.90",
      "name": "Andre helsetjenester",
      "shortName": "Andre helsetjenester",
      "level": 4,
      "parentCode": "86.9"
    },
    {
      "code": "87.10",
      "name": "Pleie- og omsorgstjenester i institusjon",
      "shortName": "Pleie- og omsorg i institusjon",
      "level": 4,
      "parentCode": "87.1"
    },
    {
      "code": "87.20",
      "name": "Institusjoner og bofellesskap innen omsorg for psykisk utviklingshemmede, psykisk helsearbeid og rusmiddelomsorg",
      "shortName": "Inst./bof.skap psyk. utv.hem. mv.",
      "level": 4,
      "parentCode": "87.2"
    },
    {
      "code": "87.30",
      "name": "Institusjoner og bofellesskap innen omsorg for eldre og funksjonshemmede",
      "shortName": "Inst./bofellesskap eldre/funksj.hem.",
      "level": 4,
      "parentCode": "87.3"
    },
    {
      "code": "87.90",
      "name": "Andre omsorgsinstitusjoner",
      "shortName": "Andre omsorgsinstitusjoner",
      "level": 4,
      "parentCode": "87.9"
    },
    {
      "code": "88.10",
      "name": "Sosialtjenester uten botilbud for eldre og funksjonshemmede",
      "shortName": "Sosialtj. u/botilbud eldre/funksj.hem.",
      "level": 4,
      "parentCode": "88.1"
    },
    {
      "code": "88.91",
      "name": "Sosialtjenester uten botilbud for barn og ungdom",
      "shortName": "Sosialtj. u/botilbud barn/ungdom",
      "level": 4,
      "parentCode": "88.9"
    },
    {
      "code": "88.99",
      "name": "Andre sosialtjenester uten botilbud ikke nevnt annet sted",
      "shortName": "Sosialtjenester u/botilbud el.",
      "level": 4,
      "parentCode": "88.9"
    },
    {
      "code": "90.01",
      "name": "Utøvende kunstnere og underholdningsvirksomhet",
      "shortName": "Utøv. kunstnere og underhold.virks.",
      "level": 4,
      "parentCode": "90.0"
    },
    {
      "code": "90.02",
      "name": "Tjenester tilknyttet underholdningsvirksomhet",
      "shortName": "Tjen. tilkn. underholdningsvirks.",
      "level": 4,
      "parentCode": "90.0"
    },
    {
      "code": "90.03",
      "name": "Selvstendig kunstnerisk virksomhet",
      "shortName": "Selvstendig kunstnerisk virks.",
      "level": 4,
      "parentCode": "90.0"
    },
    {
      "code": "90.04",
      "name": "Drift av lokaler tilknyttet kunstnerisk virksomhet",
      "shortName": "Drift lokaler tilkn. kunst.virks.",
      "level": 4,
      "parentCode": "90.0"
    },
    {
      "code": "91.01",
      "name": "Drift av biblioteker og arkiver",
      "shortName": "Drift av biblioteker og arkiver",
      "level": 4,
      "parentCode": "91.0"
    },
    {
      "code": "91.02",
      "name": "Drift av museer",
      "shortName": "Drift av museer",
      "level": 4,
      "parentCode": "91.0"
    },
    {
      "code": "91.03",
      "name": "Drift av historiske steder og bygninger og lignende severdigheter",
      "shortName": "Drift av hist. steder og bygn. mv.",
      "level": 4,
      "parentCode": "91.0"
    },
    {
      "code": "91.04",
      "name": "Drift av botaniske og zoologiske hager og naturreservater",
      "shortName": "Drift av bot./zool. hager/naturres.",
      "level": 4,
      "parentCode": "91.0"
    },
    {
      "code": "92.00",
      "name": "Lotteri og totalisatorspill",
      "shortName": "Lotteri og totalisatorspill",
      "level": 4,
      "parentCode": "92.0"
    },
    {
      "code": "93.11",
      "name": "Drift av idrettsanlegg",
      "shortName": "Drift av idrettsanlegg",
      "level": 4,
      "parentCode": "93.1"
    },
    {
      "code": "93.12",
      "name": "Idrettslag og -klubber",
      "shortName": "Idrettslag og -klubber",
      "level": 4,
      "parentCode": "93.1"
    },
    {
      "code": "93.13",
      "name": "Treningssentre",
      "shortName": "Treningssentre",
      "level": 4,
      "parentCode": "93.1"
    },
    {
      "code": "93.19",
      "name": "Andre sportsaktiviteter",
      "shortName": "Andre sportsaktiviteter",
      "level": 4,
      "parentCode": "93.1"
    },
    {
      "code": "93.21",
      "name": "Drift av fornøyelses- og temaparker",
      "shortName": "Drift av fornøyelses- og temaparker",
      "level": 4,
      "parentCode": "93.2"
    },
    {
      "code": "93.29",
      "name": "Andre fritidsaktiviteter",
      "shortName": "Andre fritidsaktiviteter",
      "level": 4,
      "parentCode": "93.2"
    },
    {
      "code": "94.11",
      "name": "Næringslivs- og arbeidsgiverorganisasjoner",
      "shortName": "Næringslivs-/arbeidsgiverorg. mv.",
      "level": 4,
      "parentCode": "94.1"
    },
    {
      "code": "94.12",
      "name": "Yrkessammenslutninger",
      "shortName": "Yrkessammenslutninger",
      "level": 4,
      "parentCode": "94.1"
    },
    {
      "code": "94.20",
      "name": "Arbeidstakerorganisasjoner",
      "shortName": "Arbeidstakerorganisasjoner",
      "level": 4,
      "parentCode": "94.2"
    },
    {
      "code": "94.91",
      "name": "Religiøse organisasjoner",
      "shortName": "Religiøse organisasjoner",
      "level": 4,
      "parentCode": "94.9"
    },
    {
      "code": "94.92",
      "name": "Partipolitiske organisasjoner",
      "shortName": "Partipolitiske organisasjoner",
      "level": 4,
      "parentCode": "94.9"
    },
    {
      "code": "94.99",
      "name": "Aktiviteter i andre medlemsorganisasjoner ikke nevnt annet sted",
      "shortName": "Aktiviteter i andre medlemsorg. el.",
      "level": 4,
      "parentCode": "94.9"
    },
    {
      "code": "95.11",
      "name": "Reparasjon av datamaskiner og tilleggsutstyr",
      "shortName": "Rep. av datamask. og tilleggsutstyr",
      "level": 4,
      "parentCode": "95.1"
    },
    {
      "code": "95.12",
      "name": "Reparasjon av kommunikasjonsutstyr",
      "shortName": "Rep. av kommunikasjonsutstyr",
      "level": 4,
      "parentCode": "95.1"
    },
    {
      "code": "95.21",
      "name": "Reparasjon av elektronikk til husholdningsbruk",
      "shortName": "Rep. av elektronikk til hush.bruk",
      "level": 4,
      "parentCode": "95.2"
    },
    {
      "code": "95.22",
      "name": "Reparasjon av husholdningsvarer og hageredskaper",
      "shortName": "Rep. av hush.varer og hageredskaper",
      "level": 4,
      "parentCode": "95.2"
    },
    {
      "code": "95.23",
      "name": "Reparasjon av skotøy og lærvarer",
      "shortName": "Rep. av skotøy og lærvarer",
      "level": 4,
      "parentCode": "95.2"
    },
    {
      "code": "95.24",
      "name": "Reparasjon av møbler og boliginnredning",
      "shortName": "Rep. av møbler og boliginnredning",
      "level": 4,
      "parentCode": "95.2"
    },
    {
      "code": "95.25",
      "name": "Reparasjon av ur, gull- og sølvvarer",
      "shortName": "Rep. av ur, gull- og sølvvarer",
      "level": 4,
      "parentCode": "95.2"
    },
    {
      "code": "95.29",
      "name": "Reparasjon av andre husholdningsvarer og varer til personlig bruk",
      "shortName": "Rep. av husholdningsvarer el.",
      "level": 4,
      "parentCode": "95.2"
    },
    {
      "code": "96.01",
      "name": "Vaskeri- og renserivirksomhet",
      "shortName": "Vaskeri- og renserivirksomhet",
      "level": 4,
      "parentCode": "96.0"
    },
    {
      "code": "96.02",
      "name": "Frisering og annen skjønnhetspleie",
      "shortName": "Frisering og skjønnhetspleie el.",
      "level": 4,
      "parentCode": "96.0"
    },
    {
      "code": "96.03",
      "name": "Begravelsesbyråvirksomhet og drift av kirkegårder og krematorier",
      "shortName": "Begrav.byrå, kirkegårdsdrift mv.",
      "level": 4,
      "parentCode": "96.0"
    },
    {
      "code": "96.04",
      "name": "Virksomhet knyttet til kroppspleie og fysisk velvære",
      "shortName": "Helsestudiovirksomhet mv..",
      "level": 4,
      "parentCode": "96.0"
    },
    {
      "code": "96.09",
      "name": "Personlig tjenesteyting ikke nevnt annet sted",
      "shortName": "Personlig tjenesteyting el.",
      "level": 4,
      "parentCode": "96.0"
    },
    {
      "code": "97.00",
      "name": "Lønnet arbeid i private husholdninger",
      "shortName": "Lønnet arbeid i private husholdn.",
      "level": 4,
      "parentCode": "97.0"
    },
    {
      "code": "99.00",
      "name": "Internasjonale organisasjoner og organer",
      "shortName": "Internasjonale organer",
      "level": 4,
      "parentCode": "99.0"
    }
  ],
  "level5": [
    {
      "code": "01.110",
      "name": "Dyrking av korn (unntatt ris), belgvekster og oljeholdige vekster",
      "shortName": "Dyrking av korn, belgvekster mv.",
      "level": 5,
      "parentCode": "01.11"
    },
    {
      "code": "01.120",
      "name": "Dyrking av ris",
      "shortName": "Dyrking av ris",
      "level": 5,
      "parentCode": "01.12"
    },
    {
      "code": "01.130",
      "name": "Dyrking av grønnsaker, meloner, rot- og knollvekster",
      "shortName": "Dyrking av grønnsaker, poteter mv.",
      "level": 5,
      "parentCode": "01.13"
    },
    {
      "code": "01.140",
      "name": "Dyrking av sukkerrør",
      "shortName": "Dyrking av sukkerrør",
      "level": 5,
      "parentCode": "01.14"
    },
    {
      "code": "01.150",
      "name": "Dyrking av tobakk",
      "shortName": "Dyrking av tobakk",
      "level": 5,
      "parentCode": "01.15"
    },
    {
      "code": "01.160",
      "name": "Dyrking av fibervekster",
      "shortName": "Dyrking av fibervekster",
      "level": 5,
      "parentCode": "01.16"
    },
    {
      "code": "01.190",
      "name": "Dyrking av ettårige vekster ellers",
      "shortName": "Dyrking av ettårige vekster ellers",
      "level": 5,
      "parentCode": "01.19"
    },
    {
      "code": "01.210",
      "name": "Dyrking av druer",
      "shortName": "Dyrking av druer",
      "level": 5,
      "parentCode": "01.21"
    },
    {
      "code": "01.220",
      "name": "Dyrking av tropiske og subtropiske frukter",
      "shortName": "Dyrking av trop./subtrop. frukter",
      "level": 5,
      "parentCode": "01.22"
    },
    {
      "code": "01.230",
      "name": "Dyrking av sitrusfrukter",
      "shortName": "Dyrking av sitrusfrukter",
      "level": 5,
      "parentCode": "01.23"
    },
    {
      "code": "01.240",
      "name": "Dyrking av kjernefrukter og steinfrukter",
      "shortName": "Dyrking av kjerne- og steinfrukter",
      "level": 5,
      "parentCode": "01.24"
    },
    {
      "code": "01.250",
      "name": "Dyrking av annen frukt som vokser på trær eller busker samt nøtter",
      "shortName": "Dyrking av bær og nøtter mv.",
      "level": 5,
      "parentCode": "01.25"
    },
    {
      "code": "01.260",
      "name": "Dyrking av oljeholdige frukter",
      "shortName": "Dyrking av oljeholdige frukter",
      "level": 5,
      "parentCode": "01.26"
    },
    {
      "code": "01.270",
      "name": "Dyrking av vekster for produksjon av drikkevarer",
      "shortName": "Dyrk. vekster for prod. av drikkev.",
      "level": 5,
      "parentCode": "01.27"
    },
    {
      "code": "01.280",
      "name": "Dyrking av krydder og aromatiske, medisinske og farmasøytiske vekster",
      "shortName": "Dyrking av krydder mv.",
      "level": 5,
      "parentCode": "01.28"
    },
    {
      "code": "01.290",
      "name": "Dyrking av flerårige vekster ellers",
      "shortName": "Dyrking av flerårige vekster ellers",
      "level": 5,
      "parentCode": "01.29"
    },
    {
      "code": "01.300",
      "name": "Planteformering",
      "shortName": "Planteformering",
      "level": 5,
      "parentCode": "01.30"
    },
    {
      "code": "01.410",
      "name": "Melkeproduksjon på storfe",
      "shortName": "Melkeproduksjon på storfe",
      "level": 5,
      "parentCode": "01.41"
    },
    {
      "code": "01.420",
      "name": "Oppdrett av annet storfe",
      "shortName": "Oppdrett av annet storfe",
      "level": 5,
      "parentCode": "01.42"
    },
    {
      "code": "01.430",
      "name": "Oppdrett av hester og andre dyr av hestefamilien",
      "shortName": "Oppdrett av hester, esler o.l.",
      "level": 5,
      "parentCode": "01.43"
    },
    {
      "code": "01.440",
      "name": "Oppdrett av kameler og andre kameldyr",
      "shortName": "Oppdrett av kameler og kameldyr el.",
      "level": 5,
      "parentCode": "01.44"
    },
    {
      "code": "01.451",
      "name": "Sauehold",
      "shortName": "Sauehold",
      "level": 5,
      "parentCode": "01.45"
    },
    {
      "code": "01.452",
      "name": "Geitehold",
      "shortName": "Geitehold",
      "level": 5,
      "parentCode": "01.45"
    },
    {
      "code": "01.460",
      "name": "Svinehold",
      "shortName": "Svinehold",
      "level": 5,
      "parentCode": "01.46"
    },
    {
      "code": "01.471",
      "name": "Hold av verpehøner for konsumeggproduksjon",
      "shortName": "Verpehøner for konsumeggprod.",
      "level": 5,
      "parentCode": "01.47"
    },
    {
      "code": "01.479",
      "name": "Annet fjørfehold",
      "shortName": "Annet fjørfehold",
      "level": 5,
      "parentCode": "01.47"
    },
    {
      "code": "01.490",
      "name": "Husdyrhold ellers",
      "shortName": "Husdyrhold ellers",
      "level": 5,
      "parentCode": "01.49"
    },
    {
      "code": "01.500",
      "name": "Kombinert husdyrhold og planteproduksjon",
      "shortName": "Komb. husdyrhold og planteprod.",
      "level": 5,
      "parentCode": "01.50"
    },
    {
      "code": "01.610",
      "name": "Tjenester tilknyttet planteproduksjon",
      "shortName": "Tjenester tilknyttet planteprod.",
      "level": 5,
      "parentCode": "01.61"
    },
    {
      "code": "01.620",
      "name": "Tjenester tilknyttet husdyrhold",
      "shortName": "Tjenester tilknyttet husdyrhold",
      "level": 5,
      "parentCode": "01.62"
    },
    {
      "code": "01.630",
      "name": "Etterbehandling av vekster etter innhøsting",
      "shortName": "Etterbeh. av vekster etter innhøst.",
      "level": 5,
      "parentCode": "01.63"
    },
    {
      "code": "01.640",
      "name": "Behandling av såfrø",
      "shortName": "Behandling av såfrø",
      "level": 5,
      "parentCode": "01.64"
    },
    {
      "code": "01.700",
      "name": "Jakt, viltstell og tjenester tilknyttet jakt og viltstell",
      "shortName": "Jakt, viltstell og tilkn. tjenester",
      "level": 5,
      "parentCode": "01.70"
    },
    {
      "code": "02.100",
      "name": "Skogskjøtsel og andre skogbruksaktiviteter",
      "shortName": "Skogskjøtsel, andre skogbruksakt.",
      "level": 5,
      "parentCode": "02.10"
    },
    {
      "code": "02.200",
      "name": "Avvirkning",
      "shortName": "Avvirkning",
      "level": 5,
      "parentCode": "02.20"
    },
    {
      "code": "02.300",
      "name": "Innsamling av viltvoksende produkter av annet enn tre",
      "shortName": "Innsaml. av sopp, bær, mose etc.",
      "level": 5,
      "parentCode": "02.30"
    },
    {
      "code": "02.400",
      "name": "Tjenester tilknyttet skogbruk",
      "shortName": "Tjenester tilknyttet skogbruk",
      "level": 5,
      "parentCode": "02.40"
    },
    {
      "code": "03.111",
      "name": "Hav- og kystfiske",
      "shortName": "Hav- og kystfiske",
      "level": 5,
      "parentCode": "03.11"
    },
    {
      "code": "03.112",
      "name": "Hvalfangst",
      "shortName": "Hvalfangst",
      "level": 5,
      "parentCode": "03.11"
    },
    {
      "code": "03.120",
      "name": "Ferskvannsfiske",
      "shortName": "Ferskvannsfiske",
      "level": 5,
      "parentCode": "03.12"
    },
    {
      "code": "03.211",
      "name": "Produksjon av matfisk, bløtdyr, krepsdyr og pigghuder i hav- og kystbasert akvakultur",
      "shortName": "Matfisk/krepsdyr mv. hav-/kystbas.",
      "level": 5,
      "parentCode": "03.21"
    },
    {
      "code": "03.212",
      "name": "Produksjon av yngel og settefisk i hav- og kystbasert akvakultur",
      "shortName": "Yngel, settefisk hav-/kystbas.",
      "level": 5,
      "parentCode": "03.21"
    },
    {
      "code": "03.213",
      "name": "Tjenester tilknyttet hav- og kystbasert akvakultur",
      "shortName": "Tjen. tilkn. hav-/kystbas. akvakult.",
      "level": 5,
      "parentCode": "03.21"
    },
    {
      "code": "03.221",
      "name": "Produksjon av matfisk, bløtdyr og krepsdyr i ferskvannsbasert akvakultur",
      "shortName": "Matfisk/krepsdyr mv. ferskvannsbas.",
      "level": 5,
      "parentCode": "03.22"
    },
    {
      "code": "03.222",
      "name": "Produksjon av yngel og settefisk i ferskvannsbasert akvakultur",
      "shortName": "Yngel, settefisk ferskvannsbasert",
      "level": 5,
      "parentCode": "03.22"
    },
    {
      "code": "03.223",
      "name": "Tjenester tilknyttet ferskvannsbasert akvakultur",
      "shortName": "Tjen. tilkn. ferskvannsbas. akvakult",
      "level": 5,
      "parentCode": "03.22"
    },
    {
      "code": "05.100",
      "name": "Bryting av steinkull",
      "shortName": "Bryting av steinkull",
      "level": 5,
      "parentCode": "05.10"
    },
    {
      "code": "05.200",
      "name": "Bryting av brunkull",
      "shortName": "Bryting av brunkull",
      "level": 5,
      "parentCode": "05.20"
    },
    {
      "code": "06.100",
      "name": "Utvinning av råolje",
      "shortName": "Utvinning av råolje",
      "level": 5,
      "parentCode": "06.10"
    },
    {
      "code": "06.200",
      "name": "Utvinning av naturgass",
      "shortName": "Utvinning av naturgass",
      "level": 5,
      "parentCode": "06.20"
    },
    {
      "code": "07.100",
      "name": "Bryting av jernmalm",
      "shortName": "Bryting av jernmalm",
      "level": 5,
      "parentCode": "07.10"
    },
    {
      "code": "07.210",
      "name": "Bryting av uran- og thoriummalm",
      "shortName": "Bryting av uran- og thoriummalm",
      "level": 5,
      "parentCode": "07.21"
    },
    {
      "code": "07.290",
      "name": "Bryting av ikke-jernholdig malm ellers",
      "shortName": "Bryting av annen ikke-jernh. malm",
      "level": 5,
      "parentCode": "07.29"
    },
    {
      "code": "08.111",
      "name": "Bryting av stein til bygge- og anleggsvirksomhet",
      "shortName": "Bryting stein til bygge- og anl.virks",
      "level": 5,
      "parentCode": "08.11"
    },
    {
      "code": "08.112",
      "name": "Bryting av kalkstein, gips og kritt",
      "shortName": "Bryting av kalkstein, gips og kritt",
      "level": 5,
      "parentCode": "08.11"
    },
    {
      "code": "08.113",
      "name": "Bryting av skifer",
      "shortName": "Bryting av skifer",
      "level": 5,
      "parentCode": "08.11"
    },
    {
      "code": "08.120",
      "name": "Utvinning fra grus- og sandtak, og utvinning av leire og kaolin",
      "shortName": "Utv. fra grus- og sandtak, leire mv.",
      "level": 5,
      "parentCode": "08.12"
    },
    {
      "code": "08.910",
      "name": "Bryting og utvinning av kjemiske mineraler og gjødselsmineraler",
      "shortName": "Utv. kjem. mineraler/gjødselsmin.",
      "level": 5,
      "parentCode": "08.91"
    },
    {
      "code": "08.920",
      "name": "Stikking av torv",
      "shortName": "Stikking av torv",
      "level": 5,
      "parentCode": "08.92"
    },
    {
      "code": "08.930",
      "name": "Utvinning av salt",
      "shortName": "Utvinning av salt",
      "level": 5,
      "parentCode": "08.93"
    },
    {
      "code": "08.990",
      "name": "Annen bryting og utvinning ikke nevnt annet sted",
      "shortName": "Annen bryting og utvinning",
      "level": 5,
      "parentCode": "08.99"
    },
    {
      "code": "09.101",
      "name": "Boretjenester tilknyttet utvinning av råolje og naturgass",
      "shortName": "Boretj. tilkn. utv. råolje/naturgass",
      "level": 5,
      "parentCode": "09.10"
    },
    {
      "code": "09.109",
      "name": "Andre tjenester tilknyttet utvinning av råolje og naturgass",
      "shortName": "Tjen. til utv. råolje/naturgass el.",
      "level": 5,
      "parentCode": "09.10"
    },
    {
      "code": "09.900",
      "name": "Tjenester tilknyttet annen bergverksdrift",
      "shortName": "Bergverkstjenester",
      "level": 5,
      "parentCode": "09.90"
    },
    {
      "code": "10.110",
      "name": "Bearbeiding og konservering av kjøtt",
      "shortName": "Kjøttbearbeiding og konservering",
      "level": 5,
      "parentCode": "10.11"
    },
    {
      "code": "10.120",
      "name": "Bearbeiding og konservering av fjørfekjøtt",
      "shortName": "Fjørfekjøttbearb. og konservering",
      "level": 5,
      "parentCode": "10.12"
    },
    {
      "code": "10.130",
      "name": "Produksjon av kjøtt- og fjørfevarer",
      "shortName": "Kjøtt- og fjørfevareproduksjon",
      "level": 5,
      "parentCode": "10.13"
    },
    {
      "code": "10.201",
      "name": "Produksjon av saltfisk, tørrfisk og klippfisk",
      "shortName": "Salt-, tørr- og klippfiskproduksjon",
      "level": 5,
      "parentCode": "10.20"
    },
    {
      "code": "10.202",
      "name": "Frysing av fisk, fiskefileter, skalldyr og bløtdyr",
      "shortName": "Frysing av fisk, fiskefileter mv.",
      "level": 5,
      "parentCode": "10.20"
    },
    {
      "code": "10.203",
      "name": "Produksjon av fiskehermetikk",
      "shortName": "Fiskehermetikkproduksjon",
      "level": 5,
      "parentCode": "10.20"
    },
    {
      "code": "10.209",
      "name": "Slakting, bearbeiding og konservering av fisk og fiskevarer ellers",
      "shortName": "Bearb. og konserv. av fisk/fiskev.",
      "level": 5,
      "parentCode": "10.20"
    },
    {
      "code": "10.310",
      "name": "Bearbeiding og konservering av poteter",
      "shortName": "Potetbearbeiding",
      "level": 5,
      "parentCode": "10.31"
    },
    {
      "code": "10.320",
      "name": "Produksjon av juice av frukt og grønnsaker",
      "shortName": "Frukt- og grønnsakjuiceproduksjon",
      "level": 5,
      "parentCode": "10.32"
    },
    {
      "code": "10.390",
      "name": "Bearbeiding og konservering av frukt og grønnsaker ellers",
      "shortName": "Frukt- og grønnsakbearbeiding el.",
      "level": 5,
      "parentCode": "10.39"
    },
    {
      "code": "10.411",
      "name": "Produksjon av rå fiskeoljer og fett",
      "shortName": "Prod. av rå fiskeoljer og fett",
      "level": 5,
      "parentCode": "10.41"
    },
    {
      "code": "10.412",
      "name": "Produksjon av andre uraffinerte oljer og fett",
      "shortName": "Prod. av andre uraff. oljer og fett",
      "level": 5,
      "parentCode": "10.41"
    },
    {
      "code": "10.413",
      "name": "Produksjon av raffinerte oljer og fett",
      "shortName": "Raffinert olje- og fettproduksjon",
      "level": 5,
      "parentCode": "10.41"
    },
    {
      "code": "10.420",
      "name": "Produksjon av margarin og lignende spiselige fettstoffer",
      "shortName": "Margarinproduksjon m.m.",
      "level": 5,
      "parentCode": "10.42"
    },
    {
      "code": "10.510",
      "name": "Produksjon av meierivarer",
      "shortName": "Meierivareproduksjon",
      "level": 5,
      "parentCode": "10.51"
    },
    {
      "code": "10.520",
      "name": "Produksjon av iskrem",
      "shortName": "Iskremproduksjon",
      "level": 5,
      "parentCode": "10.52"
    },
    {
      "code": "10.610",
      "name": "Produksjon av kornvarer",
      "shortName": "Kornvareproduksjon",
      "level": 5,
      "parentCode": "10.61"
    },
    {
      "code": "10.620",
      "name": "Produksjon av stivelse og stivelsesprodukter",
      "shortName": "Prod. av stivelse og stivelseprod.",
      "level": 5,
      "parentCode": "10.62"
    },
    {
      "code": "10.710",
      "name": "Produksjon av brød og ferske konditorvarer",
      "shortName": "Brød og ferske konditorvarer",
      "level": 5,
      "parentCode": "10.71"
    },
    {
      "code": "10.720",
      "name": "Produksjon av kavringer, kjeks og konserverte konditorvarer",
      "shortName": "Kavring- og kjeksprod. mv.",
      "level": 5,
      "parentCode": "10.72"
    },
    {
      "code": "10.730",
      "name": "Produksjon av makaroni, nudler, couscous og lignende pastavarer",
      "shortName": "Pastavareproduksjon",
      "level": 5,
      "parentCode": "10.73"
    },
    {
      "code": "10.810",
      "name": "Produksjon av sukker",
      "shortName": "Sukkerproduksjon",
      "level": 5,
      "parentCode": "10.81"
    },
    {
      "code": "10.820",
      "name": "Produksjon av kakao, sjokolade og sukkervarer",
      "shortName": "Kakao-, sjokolade- og sukkervareprod.",
      "level": 5,
      "parentCode": "10.82"
    },
    {
      "code": "10.830",
      "name": "Bearbeiding av te og kaffe",
      "shortName": "Te- og kaffebearbeiding",
      "level": 5,
      "parentCode": "10.83"
    },
    {
      "code": "10.840",
      "name": "Produksjon av smakstilsettingsstoffer og krydderier",
      "shortName": "Smakstilsettingsstoffer og krydder",
      "level": 5,
      "parentCode": "10.84"
    },
    {
      "code": "10.850",
      "name": "Produksjon av ferdigmat",
      "shortName": "Ferdigmatproduksjon",
      "level": 5,
      "parentCode": "10.85"
    },
    {
      "code": "10.860",
      "name": "Produksjon av homogeniserte matprodukter og diettmat",
      "shortName": "Diettmat og homogeniserte matprod.",
      "level": 5,
      "parentCode": "10.86"
    },
    {
      "code": "10.890",
      "name": "Produksjon av næringsmidler ikke nevnt annet sted",
      "shortName": "Produksjon av næringsmidler el.",
      "level": 5,
      "parentCode": "10.89"
    },
    {
      "code": "10.910",
      "name": "Produksjon av fôrvarer til husdyrhold",
      "shortName": "Fôrvareproduksjon til husdyr",
      "level": 5,
      "parentCode": "10.91"
    },
    {
      "code": "10.920",
      "name": "Produksjon av fôrvarer til kjæledyr",
      "shortName": "Fôrvareproduksjon til kjæledyr",
      "level": 5,
      "parentCode": "10.92"
    },
    {
      "code": "11.010",
      "name": "Destillering, rektifisering og blanding av sprit",
      "shortName": "Destill. alkoholholdige drikkevarer",
      "level": 5,
      "parentCode": "11.01"
    },
    {
      "code": "11.020",
      "name": "Produksjon av vin",
      "shortName": "Vinproduksjon",
      "level": 5,
      "parentCode": "11.02"
    },
    {
      "code": "11.030",
      "name": "Produksjon av sider og annen fruktvin",
      "shortName": "Sider- og annen fruktvinproduksjon",
      "level": 5,
      "parentCode": "11.03"
    },
    {
      "code": "11.040",
      "name": "Produksjon av andre ikke-destillerte gjærede drikkevarer",
      "shortName": "Ikke-destill. gjærede drikkevarer",
      "level": 5,
      "parentCode": "11.04"
    },
    {
      "code": "11.050",
      "name": "Produksjon av øl",
      "shortName": "Ølproduksjon",
      "level": 5,
      "parentCode": "11.05"
    },
    {
      "code": "11.060",
      "name": "Produksjon av malt",
      "shortName": "Maltproduksjon",
      "level": 5,
      "parentCode": "11.06"
    },
    {
      "code": "11.070",
      "name": "Produksjon av mineralvann, leskedrikker og annet vann på flaske",
      "shortName": "Mineralvann- og leskedrikkproduksjon",
      "level": 5,
      "parentCode": "11.07"
    },
    {
      "code": "12.000",
      "name": "Produksjon av tobakksvarer",
      "shortName": "Tobakksindustri",
      "level": 5,
      "parentCode": "12.00"
    },
    {
      "code": "13.100",
      "name": "Bearbeiding og spinning av tekstilfibrer",
      "shortName": "Bearb./spinning av tekstilfibrer",
      "level": 5,
      "parentCode": "13.10"
    },
    {
      "code": "13.200",
      "name": "Veving av tekstiler",
      "shortName": "Veving av tekstiler",
      "level": 5,
      "parentCode": "13.20"
    },
    {
      "code": "13.300",
      "name": "Etterbehandling av tekstiler",
      "shortName": "Etterbehandling av tekstiler",
      "level": 5,
      "parentCode": "13.30"
    },
    {
      "code": "13.910",
      "name": "Produksjon av stoffer av trikotasje",
      "shortName": "Trikotasjestoffproduksjon",
      "level": 5,
      "parentCode": "13.91"
    },
    {
      "code": "13.921",
      "name": "Produksjon av utstyrsvarer",
      "shortName": "Utstyrsvareproduksjon",
      "level": 5,
      "parentCode": "13.92"
    },
    {
      "code": "13.929",
      "name": "Produksjon av andre tekstilvarer, unntatt klær",
      "shortName": "Annen tekstilvareprod., unnt. klær",
      "level": 5,
      "parentCode": "13.92"
    },
    {
      "code": "13.930",
      "name": "Produksjon av gulvtepper, -matter og -ryer",
      "shortName": "Gulvteppe-, matte- og ryeproduksjon",
      "level": 5,
      "parentCode": "13.93"
    },
    {
      "code": "13.940",
      "name": "Produksjon av tauverk og nett",
      "shortName": "Tauverk- og nettproduksjon",
      "level": 5,
      "parentCode": "13.94"
    },
    {
      "code": "13.950",
      "name": "Produksjon av ikke-vevde tekstiler og tekstilvarer, unntatt klær",
      "shortName": "Fiberproduksjon mv.",
      "level": 5,
      "parentCode": "13.95"
    },
    {
      "code": "13.960",
      "name": "Produksjon av tekstiler til teknisk og industriell bruk",
      "shortName": "Tekstiler til tekn./industriell bruk",
      "level": 5,
      "parentCode": "13.96"
    },
    {
      "code": "13.990",
      "name": "Produksjon av tekstiler ikke nevnt annet sted",
      "shortName": "Tekstilproduksjon el.",
      "level": 5,
      "parentCode": "13.99"
    },
    {
      "code": "14.110",
      "name": "Produksjon av klær av lær",
      "shortName": "Produksjon av klær av lær",
      "level": 5,
      "parentCode": "14.11"
    },
    {
      "code": "14.120",
      "name": "Produksjon av arbeidstøy",
      "shortName": "Arbeidstøyproduksjon",
      "level": 5,
      "parentCode": "14.12"
    },
    {
      "code": "14.130",
      "name": "Produksjon av annet yttertøy",
      "shortName": "Annen yttertøyproduksjon",
      "level": 5,
      "parentCode": "14.13"
    },
    {
      "code": "14.140",
      "name": "Produksjon av undertøy og innertøy",
      "shortName": "Undertøy- og innertøyproduksjon",
      "level": 5,
      "parentCode": "14.14"
    },
    {
      "code": "14.190",
      "name": "Produksjon av klær og tilbehør ellers",
      "shortName": "Produksjon av klær og tilbehør el.",
      "level": 5,
      "parentCode": "14.19"
    },
    {
      "code": "14.200",
      "name": "Produksjon av pelsvarer",
      "shortName": "Produksjon av pelsvarer",
      "level": 5,
      "parentCode": "14.20"
    },
    {
      "code": "14.310",
      "name": "Produksjon av strømpevarer",
      "shortName": "Strømpevareproduksjon",
      "level": 5,
      "parentCode": "14.31"
    },
    {
      "code": "14.390",
      "name": "Produksjon av andre klær av trikotasje",
      "shortName": "Prod. av klær av trikotasje el.",
      "level": 5,
      "parentCode": "14.39"
    },
    {
      "code": "15.110",
      "name": "Beredning av lær, og beredning og farging av pelsskinn",
      "shortName": "Lærberedning",
      "level": 5,
      "parentCode": "15.11"
    },
    {
      "code": "15.120",
      "name": "Produksjon av reiseeffekter og salmakerartikler",
      "shortName": "Reiseeffekter og salmakerartikler",
      "level": 5,
      "parentCode": "15.12"
    },
    {
      "code": "15.200",
      "name": "Produksjon av skotøy",
      "shortName": "Produksjon av skotøy",
      "level": 5,
      "parentCode": "15.20"
    },
    {
      "code": "16.100",
      "name": "Saging, høvling og impregnering av tre",
      "shortName": "Saging, høvling mv. av tre",
      "level": 5,
      "parentCode": "16.10"
    },
    {
      "code": "16.210",
      "name": "Produksjon av finerplater og andre bygnings- og møbelplater av tre",
      "shortName": "Bygnings- og møbelplateproduksjon",
      "level": 5,
      "parentCode": "16.21"
    },
    {
      "code": "16.220",
      "name": "Produksjon av sammensatte parkettstaver",
      "shortName": "Sammensatte parkettstavprod.",
      "level": 5,
      "parentCode": "16.22"
    },
    {
      "code": "16.231",
      "name": "Produksjon av monteringsferdige hus",
      "shortName": "Ferdighusproduksjon",
      "level": 5,
      "parentCode": "16.23"
    },
    {
      "code": "16.232",
      "name": "Produksjon av bygningsartikler",
      "shortName": "Bygningsartikkelproduksjon",
      "level": 5,
      "parentCode": "16.23"
    },
    {
      "code": "16.240",
      "name": "Produksjon av treemballasje",
      "shortName": "Treemballasjeproduksjon",
      "level": 5,
      "parentCode": "16.24"
    },
    {
      "code": "16.290",
      "name": "Produksjon av andre trevarer og varer av kork, strå og flettematerialer",
      "shortName": "Andre tre-, kork-, stråvarer mv.",
      "level": 5,
      "parentCode": "16.29"
    },
    {
      "code": "17.110",
      "name": "Produksjon av papirmasse",
      "shortName": "Produksjon av papirmasse",
      "level": 5,
      "parentCode": "17.11"
    },
    {
      "code": "17.120",
      "name": "Produksjon av papir og papp",
      "shortName": "Produksjon av papir og papp",
      "level": 5,
      "parentCode": "17.12"
    },
    {
      "code": "17.210",
      "name": "Produksjon av bølgepapp og emballasje av papir og papp",
      "shortName": "Bølgepapp, papir- og pappemballasje",
      "level": 5,
      "parentCode": "17.21"
    },
    {
      "code": "17.220",
      "name": "Produksjon av husholdnings-, sanitær- og toalettartikler av papir",
      "shortName": "Hushold.-/toalettartikler av papir",
      "level": 5,
      "parentCode": "17.22"
    },
    {
      "code": "17.230",
      "name": "Produksjon av kontorartikler av papir",
      "shortName": "Prod. av kontorartikler av papir",
      "level": 5,
      "parentCode": "17.23"
    },
    {
      "code": "17.240",
      "name": "Produksjon av tapeter",
      "shortName": "Tapetproduksjon",
      "level": 5,
      "parentCode": "17.24"
    },
    {
      "code": "17.290",
      "name": "Produksjon av varer av papir og papp ellers",
      "shortName": "Papir- og pappvareproduksjon el.",
      "level": 5,
      "parentCode": "17.29"
    },
    {
      "code": "18.110",
      "name": "Trykking av aviser",
      "shortName": "Trykking av aviser",
      "level": 5,
      "parentCode": "18.11"
    },
    {
      "code": "18.120",
      "name": "Trykking ellers",
      "shortName": "Trykking ellers",
      "level": 5,
      "parentCode": "18.12"
    },
    {
      "code": "18.130",
      "name": "Ferdiggjøring før trykking og publisering",
      "shortName": "Ferdiggjøring før trykking og publ.",
      "level": 5,
      "parentCode": "18.13"
    },
    {
      "code": "18.140",
      "name": "Bokbinding og tilknyttede tjenester",
      "shortName": "Bokbinding og tilkn. tjenester",
      "level": 5,
      "parentCode": "18.14"
    },
    {
      "code": "18.200",
      "name": "Reproduksjon av innspilte opptak",
      "shortName": "Reproduksjon av innspilte opptak",
      "level": 5,
      "parentCode": "18.20"
    },
    {
      "code": "19.100",
      "name": "Produksjon av kullprodukter",
      "shortName": "Produksjon av kullprodukter",
      "level": 5,
      "parentCode": "19.10"
    },
    {
      "code": "19.200",
      "name": "Produksjon av raffinerte petroleumsprodukter",
      "shortName": "Prod. raffinerte petroleumsprodukt",
      "level": 5,
      "parentCode": "19.20"
    },
    {
      "code": "20.110",
      "name": "Produksjon av industrigasser",
      "shortName": "Industrigassproduksjon",
      "level": 5,
      "parentCode": "20.11"
    },
    {
      "code": "20.120",
      "name": "Produksjon av fargestoffer og pigmenter",
      "shortName": "Fargestoff- og pigmentproduksjon",
      "level": 5,
      "parentCode": "20.12"
    },
    {
      "code": "20.130",
      "name": "Produksjon av andre uorganiske kjemikalier",
      "shortName": "Uorganisk kjemikalieproduksjon el.",
      "level": 5,
      "parentCode": "20.13"
    },
    {
      "code": "20.140",
      "name": "Produksjon av andre organiske kjemiske råvarer",
      "shortName": "Annen org. kjemisk råvareproduksjon",
      "level": 5,
      "parentCode": "20.14"
    },
    {
      "code": "20.150",
      "name": "Produksjon av gjødsel, nitrogenforbindelser og vekstjord",
      "shortName": "Gjødselproduksjon mv.",
      "level": 5,
      "parentCode": "20.15"
    },
    {
      "code": "20.160",
      "name": "Produksjon av basisplast",
      "shortName": "Basisplastproduksjon",
      "level": 5,
      "parentCode": "20.16"
    },
    {
      "code": "20.170",
      "name": "Produksjon av syntetisk gummi",
      "shortName": "Produksjon av syntetisk gummi",
      "level": 5,
      "parentCode": "20.17"
    },
    {
      "code": "20.200",
      "name": "Produksjon av plantevern- og skadedyrmidler og andre landbrukskjemiske produkter",
      "shortName": "Produksjon landbrukskjemiske prod.",
      "level": 5,
      "parentCode": "20.20"
    },
    {
      "code": "20.300",
      "name": "Produksjon av maling og lakk, trykkfarger og tetningsmidler",
      "shortName": "Produksjon maling, lakk mv.",
      "level": 5,
      "parentCode": "20.30"
    },
    {
      "code": "20.410",
      "name": "Produksjon av såpe og vaskemidler, rense- og polermidler",
      "shortName": "Såpe- og vaskemiddelprod. mv.",
      "level": 5,
      "parentCode": "20.41"
    },
    {
      "code": "20.420",
      "name": "Produksjon av parfyme og toalettartikler",
      "shortName": "Parfyme og toalettartikler",
      "level": 5,
      "parentCode": "20.42"
    },
    {
      "code": "20.510",
      "name": "Produksjon av eksplosiver",
      "shortName": "Produksjon av eksplosiver",
      "level": 5,
      "parentCode": "20.51"
    },
    {
      "code": "20.520",
      "name": "Produksjon av lim",
      "shortName": "Limproduksjon",
      "level": 5,
      "parentCode": "20.52"
    },
    {
      "code": "20.530",
      "name": "Produksjon av eteriske oljer",
      "shortName": "Produksjon av eteriske oljer",
      "level": 5,
      "parentCode": "20.53"
    },
    {
      "code": "20.590",
      "name": "Produksjon av kjemiske produkter ikke nevnt annet sted",
      "shortName": "Annen kjemisk produksjon",
      "level": 5,
      "parentCode": "20.59"
    },
    {
      "code": "20.600",
      "name": "Produksjon av kunstfibrer",
      "shortName": "Produksjon av kunstfibrer",
      "level": 5,
      "parentCode": "20.60"
    },
    {
      "code": "21.100",
      "name": "Produksjon av farmasøytiske råvarer",
      "shortName": "Farmasøytiske råvarer",
      "level": 5,
      "parentCode": "21.10"
    },
    {
      "code": "21.200",
      "name": "Produksjon av farmasøytiske preparater",
      "shortName": "Farmasøytiske preparater",
      "level": 5,
      "parentCode": "21.20"
    },
    {
      "code": "22.110",
      "name": "Produksjon av gummidekk og slanger til gummidekk, og regummiering og vulkanisering av gummidekk",
      "shortName": "Gummidekkprod., -regumm. og -vulk",
      "level": 5,
      "parentCode": "22.11"
    },
    {
      "code": "22.190",
      "name": "Produksjon av gummiprodukter ellers",
      "shortName": "Produksjon av gummiprodukter el.",
      "level": 5,
      "parentCode": "22.19"
    },
    {
      "code": "22.210",
      "name": "Produksjon av halvfabrikater av plast",
      "shortName": "Prod. av halvfabrikater av plast",
      "level": 5,
      "parentCode": "22.21"
    },
    {
      "code": "22.220",
      "name": "Produksjon av plastemballasje",
      "shortName": "Plastemballasjeproduksjon",
      "level": 5,
      "parentCode": "22.22"
    },
    {
      "code": "22.230",
      "name": "Produksjon av byggevarer av plast",
      "shortName": "Byggevareprod. av plast",
      "level": 5,
      "parentCode": "22.23"
    },
    {
      "code": "22.290",
      "name": "Produksjon av plastprodukter ellers",
      "shortName": "Prod. av plastprodukter el.",
      "level": 5,
      "parentCode": "22.29"
    },
    {
      "code": "23.110",
      "name": "Produksjon av planglass",
      "shortName": "Planglassproduksjon",
      "level": 5,
      "parentCode": "23.11"
    },
    {
      "code": "23.120",
      "name": "Bearbeiding av planglass",
      "shortName": "Planglassbearbeiding",
      "level": 5,
      "parentCode": "23.12"
    },
    {
      "code": "23.130",
      "name": "Produksjon av emballasje og husholdningsartikler av glass og krystall",
      "shortName": "Emb. og hush.art. av glass/krystall",
      "level": 5,
      "parentCode": "23.13"
    },
    {
      "code": "23.140",
      "name": "Produksjon av glassfibrer",
      "shortName": "Glassfiberproduksjon",
      "level": 5,
      "parentCode": "23.14"
    },
    {
      "code": "23.190",
      "name": "Produksjon av teknisk glass og andre glassvarer",
      "shortName": "Tekn. glass- og annen glassvareprod.",
      "level": 5,
      "parentCode": "23.19"
    },
    {
      "code": "23.200",
      "name": "Produksjon av ildfaste produkter",
      "shortName": "Prod. av ildfaste produkter",
      "level": 5,
      "parentCode": "23.20"
    },
    {
      "code": "23.310",
      "name": "Produksjon av keramiske vegg- og gulvfliser",
      "shortName": "Keramisk byggematerialproduksjon",
      "level": 5,
      "parentCode": "23.31"
    },
    {
      "code": "23.320",
      "name": "Produksjon av murstein, teglstein og andre byggevarer av brent leire",
      "shortName": "Mur-, teglstein- o.a. byggevareprod.",
      "level": 5,
      "parentCode": "23.32"
    },
    {
      "code": "23.410",
      "name": "Produksjon av keramiske husholdningsartikler og dekorasjonsgjenstander",
      "shortName": "Keramiske husholdningsartikler mv.",
      "level": 5,
      "parentCode": "23.41"
    },
    {
      "code": "23.420",
      "name": "Produksjon av sanitærutstyr av keramisk materiale",
      "shortName": "Prod. av keramisk sanitærutstyr",
      "level": 5,
      "parentCode": "23.42"
    },
    {
      "code": "23.430",
      "name": "Produksjon av isolatorer og isoleringsdeler av keramisk materiale",
      "shortName": "Prod. av keramiske isoleringsdeler",
      "level": 5,
      "parentCode": "23.43"
    },
    {
      "code": "23.440",
      "name": "Produksjon av andre keramiske produkter for teknisk bruk",
      "shortName": "Prod. av keram. prod. for tekn. bruk",
      "level": 5,
      "parentCode": "23.44"
    },
    {
      "code": "23.490",
      "name": "Produksjon av andre keramiske produkter",
      "shortName": "Prod. av andre keram. prod.",
      "level": 5,
      "parentCode": "23.49"
    },
    {
      "code": "23.510",
      "name": "Produksjon av sement",
      "shortName": "Sementproduksjon",
      "level": 5,
      "parentCode": "23.51"
    },
    {
      "code": "23.520",
      "name": "Produksjon av kalk og gips",
      "shortName": "Kalk- og gipsproduksjon",
      "level": 5,
      "parentCode": "23.52"
    },
    {
      "code": "23.610",
      "name": "Produksjon av betongprodukter for bygge- og anleggsvirksomhet",
      "shortName": "Betongprodukter for bygg og anlegg",
      "level": 5,
      "parentCode": "23.61"
    },
    {
      "code": "23.620",
      "name": "Produksjon av gipsprodukter for bygge- og anleggsvirksomhet",
      "shortName": "Gipsprodukter for bygg og anlegg",
      "level": 5,
      "parentCode": "23.62"
    },
    {
      "code": "23.630",
      "name": "Produksjon av ferdigblandet betong",
      "shortName": "Ferdigblandet betong",
      "level": 5,
      "parentCode": "23.63"
    },
    {
      "code": "23.640",
      "name": "Produksjon av mørtel",
      "shortName": "Mørtelproduksjon",
      "level": 5,
      "parentCode": "23.64"
    },
    {
      "code": "23.650",
      "name": "Produksjon av fibersement",
      "shortName": "Fibersementproduksjon",
      "level": 5,
      "parentCode": "23.65"
    },
    {
      "code": "23.690",
      "name": "Produksjon av betong-, sement- og gipsprodukter ellers",
      "shortName": "Annen betong-, sement- og gipsprod.",
      "level": 5,
      "parentCode": "23.69"
    },
    {
      "code": "23.700",
      "name": "Hogging og bearbeiding av monument- og bygningsstein",
      "shortName": "Hogg./bearb. av monum.-/bygn.stein",
      "level": 5,
      "parentCode": "23.70"
    },
    {
      "code": "23.910",
      "name": "Produksjon av slipestoffer",
      "shortName": "Slipestoffproduksjon",
      "level": 5,
      "parentCode": "23.91"
    },
    {
      "code": "23.990",
      "name": "Produksjon av ikke-metallholdige mineralprodukter ikke nevnt annet sted",
      "shortName": "Prod. av ikke-met. mineralprod. el.",
      "level": 5,
      "parentCode": "23.99"
    },
    {
      "code": "24.101",
      "name": "Produksjon av jern og stål",
      "shortName": "Jern- og stålproduksjon",
      "level": 5,
      "parentCode": "24.10"
    },
    {
      "code": "24.102",
      "name": "Produksjon av ferrolegeringer",
      "shortName": "Prod. av ferrolegeringer",
      "level": 5,
      "parentCode": "24.10"
    },
    {
      "code": "24.200",
      "name": "Produksjon av andre rør og rørdeler av stål",
      "shortName": "Annen rør- og rørdelprod. av stål",
      "level": 5,
      "parentCode": "24.20"
    },
    {
      "code": "24.310",
      "name": "Kaldtrekking av stenger og profiler",
      "shortName": "Kaldtrekking av stenger og profiler",
      "level": 5,
      "parentCode": "24.31"
    },
    {
      "code": "24.320",
      "name": "Kaldvalsing av bånd",
      "shortName": "Kaldvalsing av bånd",
      "level": 5,
      "parentCode": "24.32"
    },
    {
      "code": "24.330",
      "name": "Kaldvalsing og pressing av profilerte plater og profiler",
      "shortName": "Kaldv./press. av prof. plater mv.",
      "level": 5,
      "parentCode": "24.33"
    },
    {
      "code": "24.340",
      "name": "Kaldtrekking av tråd",
      "shortName": "Kaldtrekking av tråd",
      "level": 5,
      "parentCode": "24.34"
    },
    {
      "code": "24.410",
      "name": "Produksjon av edelmetaller",
      "shortName": "Edelmetallproduksjon",
      "level": 5,
      "parentCode": "24.41"
    },
    {
      "code": "24.421",
      "name": "Produksjon av primæraluminium",
      "shortName": "Prod. av primæraluminium",
      "level": 5,
      "parentCode": "24.42"
    },
    {
      "code": "24.422",
      "name": "Produksjon av halvfabrikater av aluminium",
      "shortName": "Prod. av halvfabrikater av aluminium",
      "level": 5,
      "parentCode": "24.42"
    },
    {
      "code": "24.430",
      "name": "Produksjon av bly, sink og tinn",
      "shortName": "Bly-, sink- og tinnproduksjon",
      "level": 5,
      "parentCode": "24.43"
    },
    {
      "code": "24.440",
      "name": "Produksjon av kobber",
      "shortName": "Kobberproduksjon",
      "level": 5,
      "parentCode": "24.44"
    },
    {
      "code": "24.450",
      "name": "Produksjon av ikke-jernholdige metaller ellers",
      "shortName": "Prod. ikke-jernhold. metaller ellers",
      "level": 5,
      "parentCode": "24.45"
    },
    {
      "code": "24.460",
      "name": "Produksjon av kjernebrensel",
      "shortName": "Kjernebrenselproduksjon",
      "level": 5,
      "parentCode": "24.46"
    },
    {
      "code": "24.510",
      "name": "Støping av jern",
      "shortName": "Støping av jern",
      "level": 5,
      "parentCode": "24.51"
    },
    {
      "code": "24.520",
      "name": "Støping av stål",
      "shortName": "Støping av stål",
      "level": 5,
      "parentCode": "24.52"
    },
    {
      "code": "24.530",
      "name": "Støping av lettmetaller",
      "shortName": "Støping av lettmetaller",
      "level": 5,
      "parentCode": "24.53"
    },
    {
      "code": "24.540",
      "name": "Støping av andre ikke-jernholdige metaller",
      "shortName": "Annen ikke-jernholdig metallstøp.",
      "level": 5,
      "parentCode": "24.54"
    },
    {
      "code": "25.110",
      "name": "Produksjon av metallkonstruksjoner og deler",
      "shortName": "Prod. av metallkonstruksj. og deler",
      "level": 5,
      "parentCode": "25.11"
    },
    {
      "code": "25.120",
      "name": "Produksjon av dører og vinduer av metall",
      "shortName": "Bygningsartikkelprod. av metall",
      "level": 5,
      "parentCode": "25.12"
    },
    {
      "code": "25.210",
      "name": "Produksjon av radiatorer og kjeler til sentralvarmeanlegg",
      "shortName": "Sentralv.kjeler- og radiatorprod.",
      "level": 5,
      "parentCode": "25.21"
    },
    {
      "code": "25.290",
      "name": "Produksjon av andre tanker, cisterner og beholdere av metall",
      "shortName": "Prod. av metallbeholdere",
      "level": 5,
      "parentCode": "25.29"
    },
    {
      "code": "25.300",
      "name": "Produksjon av dampkjeler, unntatt kjeler til sentralvarmeanlegg",
      "shortName": "Dampkjeler unnt. sentralvarmeanl.",
      "level": 5,
      "parentCode": "25.30"
    },
    {
      "code": "25.400",
      "name": "Produksjon av våpen og ammunisjon",
      "shortName": "Våpen- og ammunisjonsproduksjon",
      "level": 5,
      "parentCode": "25.40"
    },
    {
      "code": "25.500",
      "name": "Smiing, stansing og valsing av metall, og pulvermetallurgi",
      "shortName": "Stansing/valsing/pulvermetallurgi",
      "level": 5,
      "parentCode": "25.50"
    },
    {
      "code": "25.610",
      "name": "Overflatebehandling av metaller",
      "shortName": "Overflatebehandling av metaller",
      "level": 5,
      "parentCode": "25.61"
    },
    {
      "code": "25.620",
      "name": "Bearbeiding av metaller",
      "shortName": "Bearbeiding av metaller",
      "level": 5,
      "parentCode": "25.62"
    },
    {
      "code": "25.710",
      "name": "Produksjon av kjøkkenredskaper og skjære- og klipperedskaper",
      "shortName": "Kjøkkenredskapsproduksjon",
      "level": 5,
      "parentCode": "25.71"
    },
    {
      "code": "25.720",
      "name": "Produksjon av låser og beslag",
      "shortName": "Låse- og beslagproduksjon",
      "level": 5,
      "parentCode": "25.72"
    },
    {
      "code": "25.730",
      "name": "Produksjon av håndverktøy",
      "shortName": "Håndverktøyproduksjon",
      "level": 5,
      "parentCode": "25.73"
    },
    {
      "code": "25.910",
      "name": "Produksjon av stålfat og lignende beholdere av jern og stål",
      "shortName": "Prod. av behold. mv. av jern/stål",
      "level": 5,
      "parentCode": "25.91"
    },
    {
      "code": "25.920",
      "name": "Produksjon av emballasje av lettmetall",
      "shortName": "Prod. av lettmetallemballasje",
      "level": 5,
      "parentCode": "25.92"
    },
    {
      "code": "25.930",
      "name": "Produksjon av varer av metalltråd, kjetting og fjærer",
      "shortName": "Metalltrådvareproduksjon",
      "level": 5,
      "parentCode": "25.93"
    },
    {
      "code": "25.940",
      "name": "Produksjon av bolter og skruer",
      "shortName": "Bolte- og skrueproduksjon",
      "level": 5,
      "parentCode": "25.94"
    },
    {
      "code": "25.990",
      "name": "Produksjon av metallvarer ikke nevnt annet sted",
      "shortName": "Metallvareprod. el.",
      "level": 5,
      "parentCode": "25.99"
    },
    {
      "code": "26.110",
      "name": "Produksjon av elektroniske komponenter",
      "shortName": "Prod. av elektroniske komponenter",
      "level": 5,
      "parentCode": "26.11"
    },
    {
      "code": "26.120",
      "name": "Produksjon av kretskort",
      "shortName": "Produksjon av kretskort",
      "level": 5,
      "parentCode": "26.12"
    },
    {
      "code": "26.200",
      "name": "Produksjon av datamaskiner og tilleggsutstyr",
      "shortName": "Prod. datamaskiner og tilleggsutstyr",
      "level": 5,
      "parentCode": "26.20"
    },
    {
      "code": "26.300",
      "name": "Produksjon av kommunikasjonsutstyr",
      "shortName": "Prod. av kommunikasjonsutstyr",
      "level": 5,
      "parentCode": "26.30"
    },
    {
      "code": "26.400",
      "name": "Produksjon av elektronikk til husholdningsbruk",
      "shortName": "Prod. av husholdningselektronikk",
      "level": 5,
      "parentCode": "26.40"
    },
    {
      "code": "26.510",
      "name": "Produksjon av måle-, kontroll- og navigasjonsinstrumenter",
      "shortName": "Måle-, kontroll- og navig.instr.",
      "level": 5,
      "parentCode": "26.51"
    },
    {
      "code": "26.520",
      "name": "Produksjon av klokker og ur",
      "shortName": "Klokke- og urproduksjon",
      "level": 5,
      "parentCode": "26.52"
    },
    {
      "code": "26.600",
      "name": "Produksjon av strålingsutstyr, elektromedisinsk og elektroterapeutisk utstyr",
      "shortName": "Elektromed./elektroterap. utst. mv.",
      "level": 5,
      "parentCode": "26.60"
    },
    {
      "code": "26.700",
      "name": "Produksjon av optiske instrumenter og fotografisk utstyr",
      "shortName": "Optiske instr./fotografisk utstyr",
      "level": 5,
      "parentCode": "26.70"
    },
    {
      "code": "26.800",
      "name": "Produksjon av magnetiske og optiske media",
      "shortName": "Magnetiske/optiske media",
      "level": 5,
      "parentCode": "26.80"
    },
    {
      "code": "27.110",
      "name": "Produksjon av elektromotorer, generatorer og transformatorer",
      "shortName": "Elektromotor-, generatorprod. mv.",
      "level": 5,
      "parentCode": "27.11"
    },
    {
      "code": "27.120",
      "name": "Produksjon av elektriske fordelings- og kontrolltavler og paneler",
      "shortName": "Elektriske tavler, paneler mv.",
      "level": 5,
      "parentCode": "27.12"
    },
    {
      "code": "27.200",
      "name": "Produksjon av batterier og akkumulatorer",
      "shortName": "Batterier, akkumulatorer",
      "level": 5,
      "parentCode": "27.20"
    },
    {
      "code": "27.310",
      "name": "Produksjon av optiske fiberkabler",
      "shortName": "Prod. av optiske fiberkabler",
      "level": 5,
      "parentCode": "27.31"
    },
    {
      "code": "27.320",
      "name": "Produksjon av andre elektroniske og elektriske ledninger og kabler",
      "shortName": "Elektron./el. ledninger/kabler el.",
      "level": 5,
      "parentCode": "27.32"
    },
    {
      "code": "27.330",
      "name": "Produksjon av ledningsmateriell",
      "shortName": "Prod. av ledningsmateriell",
      "level": 5,
      "parentCode": "27.33"
    },
    {
      "code": "27.400",
      "name": "Produksjon av belysningsutstyr",
      "shortName": "Prod. av belysningsutstyr",
      "level": 5,
      "parentCode": "27.40"
    },
    {
      "code": "27.510",
      "name": "Produksjon av elektriske husholdningsmaskiner og apparater",
      "shortName": "Elektr. hush.maskin-/apparatprod.",
      "level": 5,
      "parentCode": "27.51"
    },
    {
      "code": "27.520",
      "name": "Produksjon av ikke-elektriske husholdningsmaskiner og apparater",
      "shortName": "Ikke-el. hush.mask.-/apparatprod.",
      "level": 5,
      "parentCode": "27.52"
    },
    {
      "code": "27.900",
      "name": "Produksjon av annet elektrisk utstyr",
      "shortName": "Produksjon elektrisk utstyr ellers",
      "level": 5,
      "parentCode": "27.90"
    },
    {
      "code": "28.110",
      "name": "Produksjon av motorer og turbiner, unntatt motorer til luftfartøyer og motorvogner",
      "shortName": "Skipsmotor-/motor- og turbinprod. el.",
      "level": 5,
      "parentCode": "28.11"
    },
    {
      "code": "28.120",
      "name": "Produksjon av komponenter til hydraulisk og pneumatisk utstyr",
      "shortName": "Komp. til hydraul./pneumatisk utstyr",
      "level": 5,
      "parentCode": "28.12"
    },
    {
      "code": "28.130",
      "name": "Produksjon av pumper og kompressorer ellers",
      "shortName": "Pumpe- og kompressorprod. el.",
      "level": 5,
      "parentCode": "28.13"
    },
    {
      "code": "28.140",
      "name": "Produksjon av kraner og ventiler ellers",
      "shortName": "Kran- og ventilproduksjon el.",
      "level": 5,
      "parentCode": "28.14"
    },
    {
      "code": "28.150",
      "name": "Produksjon av lagre, gir, tannhjulsutvekslinger og andre innretninger for kraftoverføring",
      "shortName": "Lager-, girproduksjon mv.",
      "level": 5,
      "parentCode": "28.15"
    },
    {
      "code": "28.210",
      "name": "Produksjon av industri- og laboratorieovner samt brennere",
      "shortName": "Industri- og laboratorieovnprod.",
      "level": 5,
      "parentCode": "28.21"
    },
    {
      "code": "28.221",
      "name": "Produksjon av løfte- og håndteringsutstyr til skip og båter",
      "shortName": "Løfteutstyr m.m. for skip og båter",
      "level": 5,
      "parentCode": "28.22"
    },
    {
      "code": "28.229",
      "name": "Produksjon av løfte- og håndteringsutstyr ellers",
      "shortName": "Løfte- og håndteringsutstyr el.",
      "level": 5,
      "parentCode": "28.22"
    },
    {
      "code": "28.230",
      "name": "Produksjon av kontormaskiner og utstyr (unntatt datamaskiner og tilleggsutstyr)",
      "shortName": "Kontormaskinproduksjon",
      "level": 5,
      "parentCode": "28.23"
    },
    {
      "code": "28.240",
      "name": "Produksjon av motordrevet håndverktøy",
      "shortName": "Prod. av motordrevet håndverktøy",
      "level": 5,
      "parentCode": "28.24"
    },
    {
      "code": "28.250",
      "name": "Produksjon av kjøle- og ventilasjonsanlegg, unntatt til husholdningsbruk",
      "shortName": "Kjøle- og ventilasjonsanleggprod.",
      "level": 5,
      "parentCode": "28.25"
    },
    {
      "code": "28.290",
      "name": "Produksjon av maskiner og utstyr til generell bruk, ikke nevnt annet sted",
      "shortName": "Maskiner og utstyr til gen. bruk el.",
      "level": 5,
      "parentCode": "28.29"
    },
    {
      "code": "28.300",
      "name": "Produksjon av jordbruks- og skogbruksmaskiner",
      "shortName": "Jord- og skogbruksmaskinproduksjon",
      "level": 5,
      "parentCode": "28.30"
    },
    {
      "code": "28.410",
      "name": "Produksjon av maskinverktøy til metallbearbeiding",
      "shortName": "Maskinverktøy til metallbearb.",
      "level": 5,
      "parentCode": "28.41"
    },
    {
      "code": "28.490",
      "name": "Produksjon av maskinverktøy ikke nevnt annet sted",
      "shortName": "Prod. av maskinverktøy el.",
      "level": 5,
      "parentCode": "28.49"
    },
    {
      "code": "28.910",
      "name": "Produksjon av maskiner og utstyr til metallurgisk industri",
      "shortName": "Mask./utstyr metallurgisk industri",
      "level": 5,
      "parentCode": "28.91"
    },
    {
      "code": "28.920",
      "name": "Produksjon av maskiner og utstyr til bergverksdrift og bygge- og anleggsvirksomhet",
      "shortName": "Mask./utstyr bergverk, bygg og anl.",
      "level": 5,
      "parentCode": "28.92"
    },
    {
      "code": "28.930",
      "name": "Produksjon av maskiner og utstyr til nærings- og nytelsesmiddelindustri",
      "shortName": "Mask./utstyr næringsmiddelindustri",
      "level": 5,
      "parentCode": "28.93"
    },
    {
      "code": "28.940",
      "name": "Produksjon av maskiner og utstyr til tekstil-, konfeksjons- og lærvareindustri",
      "shortName": "Mask./utstyr tekstilindustri",
      "level": 5,
      "parentCode": "28.94"
    },
    {
      "code": "28.950",
      "name": "Produksjon av maskiner og utstyr til papir- og pappvareindustri",
      "shortName": "Mask./utstyr papir- og pappvareindustri",
      "level": 5,
      "parentCode": "28.95"
    },
    {
      "code": "28.960",
      "name": "Produksjon av maskiner og utstyr til plast- og gummiindustri",
      "shortName": "Mask./utstyr plast- og gummiindustri",
      "level": 5,
      "parentCode": "28.96"
    },
    {
      "code": "28.990",
      "name": "Produksjon av spesialmaskiner ikke nevnt annet sted",
      "shortName": "Spesialmaskinproduksjon el.",
      "level": 5,
      "parentCode": "28.99"
    },
    {
      "code": "29.100",
      "name": "Produksjon av motorvogner",
      "shortName": "Motorvognproduksjon",
      "level": 5,
      "parentCode": "29.10"
    },
    {
      "code": "29.200",
      "name": "Produksjon av karosserier og tilhengere",
      "shortName": "Karosseri- og tilhengerproduksjon",
      "level": 5,
      "parentCode": "29.20"
    },
    {
      "code": "29.310",
      "name": "Produksjon av elektrisk og elektronisk utstyr til motorvogner",
      "shortName": "Elektrisk/elektron. utstyr motorv.",
      "level": 5,
      "parentCode": "29.31"
    },
    {
      "code": "29.320",
      "name": "Produksjon av andre deler og annet utstyr til motorvogner",
      "shortName": "Annet utstyr-/delprod. til motorv.",
      "level": 5,
      "parentCode": "29.32"
    },
    {
      "code": "30.111",
      "name": "Bygging av skip og skrog over 100 br.tonn",
      "shortName": "Bygg. av skip/skrog over 100 br.tonn",
      "level": 5,
      "parentCode": "30.11"
    },
    {
      "code": "30.112",
      "name": "Bygging av skip under 100 br.tonn",
      "shortName": "Bygg. av skip under 100 br.tonn",
      "level": 5,
      "parentCode": "30.11"
    },
    {
      "code": "30.113",
      "name": "Bygging av oljeplattformer og moduler",
      "shortName": "Bygging oljeplattformer, moduler",
      "level": 5,
      "parentCode": "30.11"
    },
    {
      "code": "30.114",
      "name": "Produksjon av annet flytende materiell",
      "shortName": "Annen flytende materiellproduksjon",
      "level": 5,
      "parentCode": "30.11"
    },
    {
      "code": "30.115",
      "name": "Innrednings- og installasjonsarbeid utført på skip over 100 br.tonn",
      "shortName": "Install. m.m. på skip over 100 br.t.",
      "level": 5,
      "parentCode": "30.11"
    },
    {
      "code": "30.116",
      "name": "Innrednings- og installasjonsarbeid utført på oljeplattformer og moduler",
      "shortName": "Install. m.m. på oljepl./moduler",
      "level": 5,
      "parentCode": "30.11"
    },
    {
      "code": "30.120",
      "name": "Bygging av fritidsbåter",
      "shortName": "Bygging av fritidsbåter",
      "level": 5,
      "parentCode": "30.12"
    },
    {
      "code": "30.200",
      "name": "Produksjon av lokomotiver og annet rullende materiell til jernbane og sporvei",
      "shortName": "Jernbane- og sporvognmateriell mv.",
      "level": 5,
      "parentCode": "30.20"
    },
    {
      "code": "30.300",
      "name": "Produksjon av luftfartøyer og romfartøyer og lignende utstyr",
      "shortName": "Prod. luft- og romfartøy og lignende",
      "level": 5,
      "parentCode": "30.30"
    },
    {
      "code": "30.400",
      "name": "Produksjon av militære stridskjøretøyer",
      "shortName": "Produksjon militære stridskjøretøy",
      "level": 5,
      "parentCode": "30.40"
    },
    {
      "code": "30.910",
      "name": "Produksjon av motorsykler",
      "shortName": "Motorsykkelproduksjon",
      "level": 5,
      "parentCode": "30.91"
    },
    {
      "code": "30.920",
      "name": "Produksjon av sykler og invalidevogner",
      "shortName": "Sykkel- og invalidevognprod.",
      "level": 5,
      "parentCode": "30.92"
    },
    {
      "code": "30.990",
      "name": "Produksjon av andre transportmidler ikke nevnt annet sted",
      "shortName": "Transportmiddelproduksjon el.",
      "level": 5,
      "parentCode": "30.99"
    },
    {
      "code": "31.010",
      "name": "Produksjon av kontor- og butikkmøbler",
      "shortName": "Kontor- og butikkmøbelprod.",
      "level": 5,
      "parentCode": "31.01"
    },
    {
      "code": "31.020",
      "name": "Produksjon av kjøkkenmøbler",
      "shortName": "Kjøkkenmøbelproduksjon",
      "level": 5,
      "parentCode": "31.02"
    },
    {
      "code": "31.030",
      "name": "Produksjon av madrasser",
      "shortName": "Madrassproduksjon",
      "level": 5,
      "parentCode": "31.03"
    },
    {
      "code": "31.090",
      "name": "Produksjon av møbler ellers",
      "shortName": "Møbelproduksjon el.",
      "level": 5,
      "parentCode": "31.09"
    },
    {
      "code": "32.110",
      "name": "Preging av mynter og medaljer",
      "shortName": "Mynt- og medaljepreging",
      "level": 5,
      "parentCode": "32.11"
    },
    {
      "code": "32.120",
      "name": "Produksjon av gull- og sølvvarer og lignende artikler",
      "shortName": "Gull- og sølvvareprod. mv.",
      "level": 5,
      "parentCode": "32.12"
    },
    {
      "code": "32.130",
      "name": "Produksjon av bijouteri og lignende artikler",
      "shortName": "Bijouterivareproduksjon mv.",
      "level": 5,
      "parentCode": "32.13"
    },
    {
      "code": "32.200",
      "name": "Produksjon av musikkinstrumenter",
      "shortName": "Musikkinstrumentproduksjon",
      "level": 5,
      "parentCode": "32.20"
    },
    {
      "code": "32.300",
      "name": "Produksjon av sportsartikler",
      "shortName": "Sportsartikkelproduksjon",
      "level": 5,
      "parentCode": "32.30"
    },
    {
      "code": "32.400",
      "name": "Produksjon av spill og leker",
      "shortName": "Spill- og leketøyproduksjon",
      "level": 5,
      "parentCode": "32.40"
    },
    {
      "code": "32.500",
      "name": "Produksjon av medisinske og tanntekniske instrumenter og utstyr",
      "shortName": "Medisinske og tanntekniske instr.",
      "level": 5,
      "parentCode": "32.50"
    },
    {
      "code": "32.910",
      "name": "Produksjon av koster og børster",
      "shortName": "Kost- og børsteproduksjon",
      "level": 5,
      "parentCode": "32.91"
    },
    {
      "code": "32.990",
      "name": "Annen industriproduksjon ikke nevnt annet sted",
      "shortName": "Industriproduksjon ellers",
      "level": 5,
      "parentCode": "32.99"
    },
    {
      "code": "33.110",
      "name": "Reparasjon av bearbeidede metallprodukter",
      "shortName": "Rep. av bearbeidede metallprodukter",
      "level": 5,
      "parentCode": "33.11"
    },
    {
      "code": "33.120",
      "name": "Reparasjon av maskiner",
      "shortName": "Reparasjon av maskiner",
      "level": 5,
      "parentCode": "33.12"
    },
    {
      "code": "33.130",
      "name": "Reparasjon av elektronisk og optisk utstyr",
      "shortName": "Rep. av elektronisk og optisk utstyr",
      "level": 5,
      "parentCode": "33.13"
    },
    {
      "code": "33.140",
      "name": "Reparasjon av elektrisk utstyr",
      "shortName": "Rep. av elektrisk utstyr",
      "level": 5,
      "parentCode": "33.14"
    },
    {
      "code": "33.150",
      "name": "Reparasjon og vedlikehold av skip og båter",
      "shortName": "Rep./vedlikehold av skip og båter",
      "level": 5,
      "parentCode": "33.15"
    },
    {
      "code": "33.160",
      "name": "Reparasjon og vedlikehold av luftfartøyer og romfartøyer",
      "shortName": "Rep./vedlikeh. luft- og romfartøyer",
      "level": 5,
      "parentCode": "33.16"
    },
    {
      "code": "33.170",
      "name": "Reparasjon og vedlikehold av andre transportmidler",
      "shortName": "Rep./vedlikeh. av andre transportmidler",
      "level": 5,
      "parentCode": "33.17"
    },
    {
      "code": "33.190",
      "name": "Reparasjon av annet utstyr",
      "shortName": "Rep. av annet utstyr",
      "level": 5,
      "parentCode": "33.19"
    },
    {
      "code": "33.200",
      "name": "Installasjon av industrimaskiner og -utstyr",
      "shortName": "Installasjon industrimask. og utstyr",
      "level": 5,
      "parentCode": "33.20"
    },
    {
      "code": "35.111",
      "name": "Produksjon av elektrisitet fra vannkraft",
      "shortName": "Elektrisitetsprod. fra vannkraft",
      "level": 5,
      "parentCode": "35.11"
    },
    {
      "code": "35.112",
      "name": "Produksjon av elektrisitet fra vindkraft",
      "shortName": "Elektrisitetsprod. fra vindkraft",
      "level": 5,
      "parentCode": "35.11"
    },
    {
      "code": "35.113",
      "name": "Produksjon av elektrisitet fra biobrensel",
      "shortName": "El. fra biobrensel",
      "level": 5,
      "parentCode": "35.11"
    },
    {
      "code": "35.114",
      "name": "Produksjon av elektrisitet fra naturgass",
      "shortName": "Elektrisitetsprod. fra naturgass",
      "level": 5,
      "parentCode": "35.11"
    },
    {
      "code": "35.119",
      "name": "Produksjon av elektrisitet ellers",
      "shortName": "Elektrisitetsprod. ellers",
      "level": 5,
      "parentCode": "35.11"
    },
    {
      "code": "35.120",
      "name": "Overføring av elektrisitet",
      "shortName": "Overføring av elektrisitet",
      "level": 5,
      "parentCode": "35.12"
    },
    {
      "code": "35.130",
      "name": "Distribusjon av elektrisitet",
      "shortName": "Distribusjon av elektrisitet",
      "level": 5,
      "parentCode": "35.13"
    },
    {
      "code": "35.140",
      "name": "Handel med elektrisitet",
      "shortName": "Handel med elektrisitet",
      "level": 5,
      "parentCode": "35.14"
    },
    {
      "code": "35.210",
      "name": "Produksjon av gass",
      "shortName": "Gassproduksjon",
      "level": 5,
      "parentCode": "35.21"
    },
    {
      "code": "35.220",
      "name": "Distribusjon av gass gjennom ledningsnett",
      "shortName": "Gassdistrib. via ledningsnett",
      "level": 5,
      "parentCode": "35.22"
    },
    {
      "code": "35.230",
      "name": "Handel med gass gjennom ledningsnett",
      "shortName": "Handel med gass via ledningsnett",
      "level": 5,
      "parentCode": "35.23"
    },
    {
      "code": "35.300",
      "name": "Damp- og varmtvannsforsyning",
      "shortName": "Damp- og varmtvannsforsyning",
      "level": 5,
      "parentCode": "35.30"
    },
    {
      "code": "36.000",
      "name": "Uttak fra kilde, rensing og distribusjon av vann",
      "shortName": "Vannforsyning",
      "level": 5,
      "parentCode": "36.00"
    },
    {
      "code": "37.000",
      "name": "Oppsamling og behandling av avløpsvann",
      "shortName": "Håndtering av avløpsvann",
      "level": 5,
      "parentCode": "37.00"
    },
    {
      "code": "38.110",
      "name": "Innsamling av ikke-farlig avfall",
      "shortName": "Innsaml. av ikke-farlig avfall",
      "level": 5,
      "parentCode": "38.11"
    },
    {
      "code": "38.120",
      "name": "Innsamling av farlig avfall",
      "shortName": "Innsamling av farlig avfall",
      "level": 5,
      "parentCode": "38.12"
    },
    {
      "code": "38.210",
      "name": "Behandling og disponering av ikke-farlig avfall",
      "shortName": "Behandl. og disp. av ikke-farlig avfall",
      "level": 5,
      "parentCode": "38.21"
    },
    {
      "code": "38.220",
      "name": "Behandling og disponering av farlig avfall",
      "shortName": "Behandl. og disp. av farlig avfall",
      "level": 5,
      "parentCode": "38.22"
    },
    {
      "code": "38.310",
      "name": "Demontering av vrakede gjenstander",
      "shortName": "Demont. av vrakede gjenstander",
      "level": 5,
      "parentCode": "38.31"
    },
    {
      "code": "38.320",
      "name": "Sortering og bearbeiding av avfall for materialgjenvinning",
      "shortName": "Sort./bearb. avfall for matr.gjenv.",
      "level": 5,
      "parentCode": "38.32"
    },
    {
      "code": "39.000",
      "name": "Miljørydding, miljørensing og lignende virksomhet",
      "shortName": "Miljørydding og miljørensing",
      "level": 5,
      "parentCode": "39.00"
    },
    {
      "code": "41.101",
      "name": "Boligbyggelag",
      "shortName": "Boligbyggelag",
      "level": 5,
      "parentCode": "41.10"
    },
    {
      "code": "41.109",
      "name": "Utvikling og salg av egen fast eiendom ellers",
      "shortName": "Utvikl./salg av egen fast eiendom",
      "level": 5,
      "parentCode": "41.10"
    },
    {
      "code": "41.200",
      "name": "Oppføring av bygninger",
      "shortName": "Oppføring av bygninger",
      "level": 5,
      "parentCode": "41.20"
    },
    {
      "code": "42.110",
      "name": "Bygging av veier og motorveier",
      "shortName": "Bygging av veier og motorveier",
      "level": 5,
      "parentCode": "42.11"
    },
    {
      "code": "42.120",
      "name": "Bygging av jernbaner og undergrunnsbaner",
      "shortName": "Bygg. av jernbaner/undergrunnsbaner",
      "level": 5,
      "parentCode": "42.12"
    },
    {
      "code": "42.130",
      "name": "Bygging av bruer og tunneler",
      "shortName": "Bygging av bruer og tunneler",
      "level": 5,
      "parentCode": "42.13"
    },
    {
      "code": "42.210",
      "name": "Bygging av vann- og kloakkanlegg",
      "shortName": "Bygging av vann- og kloakkanl.",
      "level": 5,
      "parentCode": "42.21"
    },
    {
      "code": "42.220",
      "name": "Bygging av anlegg for elektrisitet og telekommunikasjon",
      "shortName": "Bygg. av el.anl. og telekomm.anl.",
      "level": 5,
      "parentCode": "42.22"
    },
    {
      "code": "42.910",
      "name": "Bygging av havne- og damanlegg",
      "shortName": "Bygging av havne- og damanlegg",
      "level": 5,
      "parentCode": "42.91"
    },
    {
      "code": "42.990",
      "name": "Bygging av andre anlegg ikke nevnt annet sted",
      "shortName": "Bygging av andre anlegg",
      "level": 5,
      "parentCode": "42.99"
    },
    {
      "code": "43.110",
      "name": "Riving av bygninger og andre konstruksjoner",
      "shortName": "Riv. av bygn./andre konstruksjoner",
      "level": 5,
      "parentCode": "43.11"
    },
    {
      "code": "43.120",
      "name": "Grunnarbeid",
      "shortName": "Grunnarbeid",
      "level": 5,
      "parentCode": "43.12"
    },
    {
      "code": "43.130",
      "name": "Prøveboring",
      "shortName": "Prøveboring",
      "level": 5,
      "parentCode": "43.13"
    },
    {
      "code": "43.210",
      "name": "Elektrisk installasjonsarbeid",
      "shortName": "Elektrisk installasjonsarbeid",
      "level": 5,
      "parentCode": "43.21"
    },
    {
      "code": "43.221",
      "name": "Rørleggerarbeid",
      "shortName": "Rørleggerarbeid",
      "level": 5,
      "parentCode": "43.22"
    },
    {
      "code": "43.222",
      "name": "Kuldeanlegg- og varmepumpearbeid",
      "shortName": "Kuldeanlegg- og varmepumpearbeid",
      "level": 5,
      "parentCode": "43.22"
    },
    {
      "code": "43.223",
      "name": "Ventilasjonsarbeid",
      "shortName": "Ventilasjonsarbeid",
      "level": 5,
      "parentCode": "43.22"
    },
    {
      "code": "43.290",
      "name": "Annet installasjonsarbeid",
      "shortName": "Annet installasjonsarbeid",
      "level": 5,
      "parentCode": "43.29"
    },
    {
      "code": "43.310",
      "name": "Stukkatørarbeid og pussing",
      "shortName": "Stukkatørarbeid og pussing",
      "level": 5,
      "parentCode": "43.31"
    },
    {
      "code": "43.320",
      "name": "Snekkerarbeid",
      "shortName": "Snekkerarbeid",
      "level": 5,
      "parentCode": "43.32"
    },
    {
      "code": "43.330",
      "name": "Gulvlegging og tapetsering",
      "shortName": "Gulvlegging og tapetsering",
      "level": 5,
      "parentCode": "43.33"
    },
    {
      "code": "43.341",
      "name": "Malerarbeid",
      "shortName": "Malerarbeid",
      "level": 5,
      "parentCode": "43.34"
    },
    {
      "code": "43.342",
      "name": "Glassarbeid",
      "shortName": "Glassarbeid",
      "level": 5,
      "parentCode": "43.34"
    },
    {
      "code": "43.390",
      "name": "Annen ferdiggjøring av bygninger",
      "shortName": "Annen ferdiggjøring av bygninger",
      "level": 5,
      "parentCode": "43.39"
    },
    {
      "code": "43.911",
      "name": "Blikkenslagerarbeid",
      "shortName": "Blikkenslagerarbeid",
      "level": 5,
      "parentCode": "43.91"
    },
    {
      "code": "43.919",
      "name": "Takarbeid ellers",
      "shortName": "Takarbeid ellers",
      "level": 5,
      "parentCode": "43.91"
    },
    {
      "code": "43.990",
      "name": "Annen spesialisert bygge- og anleggsvirksomhet",
      "shortName": "Annen spes. bygge- og anleggsvirks.",
      "level": 5,
      "parentCode": "43.99"
    },
    {
      "code": "45.111",
      "name": "Agentur- og engroshandel med biler og lette motorvogner, unntatt motorsykler",
      "shortName": "Agentur/engros biler/unnt. motorsyk",
      "level": 5,
      "parentCode": "45.11"
    },
    {
      "code": "45.112",
      "name": "Detaljhandel med biler og lette motorvogner, unntatt motorsykler",
      "shortName": "Detaljh. biler, unnt. motorsykler",
      "level": 5,
      "parentCode": "45.11"
    },
    {
      "code": "45.191",
      "name": "Agentur- og engroshandel med andre motorvogner, unntatt motorsykler",
      "shortName": "Agentur/engros motorvogner el.",
      "level": 5,
      "parentCode": "45.19"
    },
    {
      "code": "45.192",
      "name": "Detaljhandel med andre motorvogner, unntatt motorsykler",
      "shortName": "Detaljh. motorvogner el.",
      "level": 5,
      "parentCode": "45.19"
    },
    {
      "code": "45.200",
      "name": "Vedlikehold og reparasjon av motorvogner, unntatt motorsykler",
      "shortName": "Rep. av motorvogner/unnt. motorsyk.",
      "level": 5,
      "parentCode": "45.20"
    },
    {
      "code": "45.310",
      "name": "Agentur- og engroshandel med deler og utstyr til motorvogner, unntatt motorsykler",
      "shortName": "Agent.-/engrosh. motorv./-deler mv.",
      "level": 5,
      "parentCode": "45.31"
    },
    {
      "code": "45.320",
      "name": "Detaljhandel med deler og utstyr til motorvogner, unntatt motorsykler",
      "shortName": "Detalj. deler/utstyr til motorvogn",
      "level": 5,
      "parentCode": "45.32"
    },
    {
      "code": "45.401",
      "name": "Agentur- og engroshandel med motorsykler, deler og utstyr",
      "shortName": "Agentur-/engrosh. motorsykler",
      "level": 5,
      "parentCode": "45.40"
    },
    {
      "code": "45.402",
      "name": "Detaljhandel med motorsykler, deler og utstyr",
      "shortName": "Detaljh. motorsykler mv.",
      "level": 5,
      "parentCode": "45.40"
    },
    {
      "code": "45.403",
      "name": "Vedlikehold og reparasjon av motorsykler",
      "shortName": "Motorsykkelvedlikehold og -rep.",
      "level": 5,
      "parentCode": "45.40"
    },
    {
      "code": "46.110",
      "name": "Agenturhandel med jordbruksråvarer, levende dyr, tekstilråvarer og innsatsvarer",
      "shortName": "Agentur jordbr. og tekstilråv. mv.",
      "level": 5,
      "parentCode": "46.11"
    },
    {
      "code": "46.120",
      "name": "Agenturhandel med brensel, drivstoff, malm, metaller og industrikjemikalier",
      "shortName": "Agentur brensel, drivstoff mv.",
      "level": 5,
      "parentCode": "46.12"
    },
    {
      "code": "46.130",
      "name": "Agenturhandel med tømmer, trelast og byggevarer",
      "shortName": "Agentur tømmer. trelast, byggev.",
      "level": 5,
      "parentCode": "46.13"
    },
    {
      "code": "46.140",
      "name": "Agenturhandel med maskiner, produksjonsutstyr, båter og luftfartøyer",
      "shortName": "Agentur maskiner, prod.utstyr mv.",
      "level": 5,
      "parentCode": "46.14"
    },
    {
      "code": "46.150",
      "name": "Agenturhandel med møbler, husholdningsvarer og jernvarer",
      "shortName": "Agentur møbler, hush.- og jernvarer",
      "level": 5,
      "parentCode": "46.15"
    },
    {
      "code": "46.160",
      "name": "Agenturhandel med tekstiler, klær, pelsskinn, skotøy og lærvarer",
      "shortName": "Agentur tekstiler/klær/skotøy mv.",
      "level": 5,
      "parentCode": "46.16"
    },
    {
      "code": "46.170",
      "name": "Agenturhandel med nærings- og nytelsesmidler",
      "shortName": "Agentur nærings- og nytelsesmidler",
      "level": 5,
      "parentCode": "46.17"
    },
    {
      "code": "46.180",
      "name": "Agenturhandel med spesialisert vareutvalg ellers",
      "shortName": "Agentur spesialisert vareutvalg el.",
      "level": 5,
      "parentCode": "46.18"
    },
    {
      "code": "46.190",
      "name": "Agenturhandel med bredt vareutvalg",
      "shortName": "Agentur bredt vareutvalg",
      "level": 5,
      "parentCode": "46.19"
    },
    {
      "code": "46.210",
      "name": "Engroshandel med korn, råtobakk, såvarer og fôrvarer",
      "shortName": "Engrosh. korn, såvarer og fôr",
      "level": 5,
      "parentCode": "46.21"
    },
    {
      "code": "46.220",
      "name": "Engroshandel med blomster og planter",
      "shortName": "Engrosh. blomster og planter",
      "level": 5,
      "parentCode": "46.22"
    },
    {
      "code": "46.230",
      "name": "Engroshandel med levende dyr",
      "shortName": "Engrosh. levende dyr",
      "level": 5,
      "parentCode": "46.23"
    },
    {
      "code": "46.240",
      "name": "Engroshandel med huder, skinn og lær",
      "shortName": "Engrosh. huder, skinn og lær",
      "level": 5,
      "parentCode": "46.24"
    },
    {
      "code": "46.310",
      "name": "Engroshandel med frukt og grønnsaker",
      "shortName": "Engrosh. frukt og grønnsaker",
      "level": 5,
      "parentCode": "46.31"
    },
    {
      "code": "46.320",
      "name": "Engroshandel med kjøtt og kjøttvarer",
      "shortName": "Engrosh. kjøtt og kjøttvarer",
      "level": 5,
      "parentCode": "46.32"
    },
    {
      "code": "46.330",
      "name": "Engroshandel med meierivarer, egg, matolje og -fett",
      "shortName": "Engrosh. meierivarer, egg mv.",
      "level": 5,
      "parentCode": "46.33"
    },
    {
      "code": "46.341",
      "name": "Engroshandel med vin og brennevin",
      "shortName": "Engrosh. vin og brennevin",
      "level": 5,
      "parentCode": "46.34"
    },
    {
      "code": "46.349",
      "name": "Engroshandel med drikkevarer ellers",
      "shortName": "Engrosh. drikkevarer el.",
      "level": 5,
      "parentCode": "46.34"
    },
    {
      "code": "46.350",
      "name": "Engroshandel med tobakksvarer",
      "shortName": "Engrosh. tobakksvarer",
      "level": 5,
      "parentCode": "46.35"
    },
    {
      "code": "46.360",
      "name": "Engroshandel med sukker, sjokolade og sukkervarer",
      "shortName": "Engrosh. sukker, sjok. og sukkerv.",
      "level": 5,
      "parentCode": "46.36"
    },
    {
      "code": "46.370",
      "name": "Engroshandel med kaffe, te, kakao og krydder",
      "shortName": "Engrosh. kaffe, te, kakao mv.",
      "level": 5,
      "parentCode": "46.37"
    },
    {
      "code": "46.381",
      "name": "Engroshandel med fisk, skalldyr og bløtdyr",
      "shortName": "Engrosh. fisk og skalldyr",
      "level": 5,
      "parentCode": "46.38"
    },
    {
      "code": "46.389",
      "name": "Engroshandel med spesialisert utvalg av nærings- og nytelsesmidler ikke nevnt annet sted",
      "shortName": "Engrosh. spes. utv. nær.-/nyt.midl.",
      "level": 5,
      "parentCode": "46.38"
    },
    {
      "code": "46.390",
      "name": "Engroshandel med bredt utvalg av nærings- og nytelsesmidler",
      "shortName": "Engrosh. bredt utv. nær.-/nyt.midl.",
      "level": 5,
      "parentCode": "46.39"
    },
    {
      "code": "46.410",
      "name": "Engroshandel med tekstiler og utstyrsvarer",
      "shortName": "Engrosh. tekstiler og utstyrsvarer",
      "level": 5,
      "parentCode": "46.41"
    },
    {
      "code": "46.421",
      "name": "Engroshandel med klær",
      "shortName": "Engrosh. klær",
      "level": 5,
      "parentCode": "46.42"
    },
    {
      "code": "46.422",
      "name": "Engroshandel med skotøy",
      "shortName": "Engrosh. skotøy",
      "level": 5,
      "parentCode": "46.42"
    },
    {
      "code": "46.431",
      "name": "Engroshandel med elektriske husholdningsapparater og -maskiner",
      "shortName": "Engrosh. el.hush.app. og -maskiner",
      "level": 5,
      "parentCode": "46.43"
    },
    {
      "code": "46.432",
      "name": "Engroshandel med radio og fjernsyn",
      "shortName": "Engrosh. radio og fjernsyn",
      "level": 5,
      "parentCode": "46.43"
    },
    {
      "code": "46.433",
      "name": "Engroshandel med plater, musikk- og videokassetter og CD- og DVD-plater",
      "shortName": "Engrosh. musikk-,videokass.,CD,DVD",
      "level": 5,
      "parentCode": "46.43"
    },
    {
      "code": "46.434",
      "name": "Engroshandel med fotoutstyr",
      "shortName": "Engrosh. fotoutstyr",
      "level": 5,
      "parentCode": "46.43"
    },
    {
      "code": "46.435",
      "name": "Engroshandel med optiske artikler",
      "shortName": "Engrosh. optiske artikler",
      "level": 5,
      "parentCode": "46.43"
    },
    {
      "code": "46.441",
      "name": "Engroshandel med kjøkkenutstyr, glass og steintøy",
      "shortName": "Engrosh. kjøkkenutstyr, steintøy mv.",
      "level": 5,
      "parentCode": "46.44"
    },
    {
      "code": "46.442",
      "name": "Engroshandel med rengjøringsmidler",
      "shortName": "Engrosh. rengjøringsmidler",
      "level": 5,
      "parentCode": "46.44"
    },
    {
      "code": "46.450",
      "name": "Engroshandel med parfyme og kosmetikk",
      "shortName": "Engrosh. parfyme og kosmetikk",
      "level": 5,
      "parentCode": "46.45"
    },
    {
      "code": "46.460",
      "name": "Engroshandel med sykepleie- og apotekvarer",
      "shortName": "Engrosh. sykepleie- og apotekvarer",
      "level": 5,
      "parentCode": "46.46"
    },
    {
      "code": "46.471",
      "name": "Engroshandel med møbler",
      "shortName": "Engrosh. møbler",
      "level": 5,
      "parentCode": "46.47"
    },
    {
      "code": "46.472",
      "name": "Engroshandel med gulvtepper",
      "shortName": "Engrosh. gulvtepper",
      "level": 5,
      "parentCode": "46.47"
    },
    {
      "code": "46.473",
      "name": "Engroshandel med belysningsutstyr",
      "shortName": "Engrosh. belysningsutstyr",
      "level": 5,
      "parentCode": "46.47"
    },
    {
      "code": "46.481",
      "name": "Engroshandel med klokker og ur",
      "shortName": "Engrosh. klokker og ur",
      "level": 5,
      "parentCode": "46.48"
    },
    {
      "code": "46.482",
      "name": "Engroshandel med gull- og sølvvarer",
      "shortName": "Engrosh. gull- og sølvvarer",
      "level": 5,
      "parentCode": "46.48"
    },
    {
      "code": "46.491",
      "name": "Engroshandel med bøker, aviser og blader",
      "shortName": "Engrosh. bøker, aviser og blader",
      "level": 5,
      "parentCode": "46.49"
    },
    {
      "code": "46.492",
      "name": "Engroshandel med reiseeffekter og lærvarer",
      "shortName": "Engrosh. reiseeffekter og lærvarer",
      "level": 5,
      "parentCode": "46.49"
    },
    {
      "code": "46.493",
      "name": "Engroshandel med fritidsbåter og -utstyr",
      "shortName": "Engrosh. fritidsbåter og -utstyr",
      "level": 5,
      "parentCode": "46.49"
    },
    {
      "code": "46.494",
      "name": "Engroshandel med sportsutstyr",
      "shortName": "Engrosh. sportsutstyr",
      "level": 5,
      "parentCode": "46.49"
    },
    {
      "code": "46.495",
      "name": "Engroshandel med spill og leker",
      "shortName": "Engrosh. spill og leker",
      "level": 5,
      "parentCode": "46.49"
    },
    {
      "code": "46.499",
      "name": "Engroshandel med husholdningsvarer og varer til personlig bruk ikke nevnt annet sted",
      "shortName": "Engrosh. hush.varer ellers",
      "level": 5,
      "parentCode": "46.49"
    },
    {
      "code": "46.510",
      "name": "Engroshandel med datamaskiner, tilleggsutstyr til datamaskiner samt programvare",
      "shortName": "Engrosh. datamask., programv. mv.",
      "level": 5,
      "parentCode": "46.51"
    },
    {
      "code": "46.520",
      "name": "Engroshandel med elektronikkutstyr og telekommunikasjonsutstyr samt deler",
      "shortName": "Engrosh. elektronikk-/telekomm.uts.",
      "level": 5,
      "parentCode": "46.52"
    },
    {
      "code": "46.610",
      "name": "Engroshandel med maskiner og utstyr til jordbruk og skogbruk",
      "shortName": "Engrosh. jordbr.-/skogbr.mask. mv.",
      "level": 5,
      "parentCode": "46.61"
    },
    {
      "code": "46.620",
      "name": "Engroshandel med maskinverktøy",
      "shortName": "Engrosh. maskinverktøy",
      "level": 5,
      "parentCode": "46.62"
    },
    {
      "code": "46.630",
      "name": "Engroshandel med maskiner og utstyr til bergverksdrift, olje- og gassutvinning og bygge- og anleggsvirksomhet",
      "shortName": "Engros mask bygg/anl./oljeutv. mv.",
      "level": 5,
      "parentCode": "46.63"
    },
    {
      "code": "46.640",
      "name": "Engroshandel med maskiner og utstyr til tekstilproduksjon",
      "shortName": "Engrosh. tekstilprod.maskiner mv.",
      "level": 5,
      "parentCode": "46.64"
    },
    {
      "code": "46.650",
      "name": "Engroshandel med kontormøbler",
      "shortName": "Engrosh. kontormøbler",
      "level": 5,
      "parentCode": "46.65"
    },
    {
      "code": "46.660",
      "name": "Engroshandel med maskiner og utstyr til kontor ellers",
      "shortName": "Engrosh. kontormask., -utstyr el.",
      "level": 5,
      "parentCode": "46.66"
    },
    {
      "code": "46.691",
      "name": "Engroshandel med maskiner og utstyr til kraftproduksjon og installasjon",
      "shortName": "Engrosh. kraftprod.-,install.utstyr",
      "level": 5,
      "parentCode": "46.69"
    },
    {
      "code": "46.692",
      "name": "Engroshandel med skipsutstyr og fiskeredskap",
      "shortName": "Engrosh. skipsutstyr og fiskeredsk.",
      "level": 5,
      "parentCode": "46.69"
    },
    {
      "code": "46.693",
      "name": "Engroshandel med maskiner og utstyr til industri ellers",
      "shortName": "Engrosh. utstyr industri ellers",
      "level": 5,
      "parentCode": "46.69"
    },
    {
      "code": "46.694",
      "name": "Engroshandel med maskiner og utstyr til handel, transport og tjenesteyting ellers",
      "shortName": "Engrosh. utstyr handel, transp. mv.",
      "level": 5,
      "parentCode": "46.69"
    },
    {
      "code": "46.710",
      "name": "Engroshandel med drivstoff og brensel",
      "shortName": "Engrosh. drivstoff og brensel",
      "level": 5,
      "parentCode": "46.71"
    },
    {
      "code": "46.720",
      "name": "Engroshandel med metaller og metallholdig malm",
      "shortName": "Engrosh. metaller og metallh. malm",
      "level": 5,
      "parentCode": "46.72"
    },
    {
      "code": "46.731",
      "name": "Engroshandel med tømmer",
      "shortName": "Engrosh. tømmer",
      "level": 5,
      "parentCode": "46.73"
    },
    {
      "code": "46.732",
      "name": "Engroshandel med trelast",
      "shortName": "Engrosh. trelast",
      "level": 5,
      "parentCode": "46.73"
    },
    {
      "code": "46.733",
      "name": "Engroshandel med fargevarer",
      "shortName": "Engrosh. fargevarer",
      "level": 5,
      "parentCode": "46.73"
    },
    {
      "code": "46.739",
      "name": "Engroshandel med byggevarer ikke nevnt annet sted",
      "shortName": "Engrosh. byggevarer el.",
      "level": 5,
      "parentCode": "46.73"
    },
    {
      "code": "46.740",
      "name": "Engroshandel med jernvarer, rørleggerartikler og oppvarmingsutstyr",
      "shortName": "Engrosh. jernv., rørleggerart. m.m.",
      "level": 5,
      "parentCode": "46.74"
    },
    {
      "code": "46.750",
      "name": "Engroshandel med kjemiske produkter",
      "shortName": "Engrosh. kjemiske produkter",
      "level": 5,
      "parentCode": "46.75"
    },
    {
      "code": "46.761",
      "name": "Engroshandel med papir og papp",
      "shortName": "Engrosh. papir og papp",
      "level": 5,
      "parentCode": "46.76"
    },
    {
      "code": "46.769",
      "name": "Engroshandel med innsatsvarer ikke nevnt annet sted",
      "shortName": "Engrosh innsatsvarer el.",
      "level": 5,
      "parentCode": "46.76"
    },
    {
      "code": "46.770",
      "name": "Engroshandel med avfall og skrap",
      "shortName": "Engrosh. avfall og skrap",
      "level": 5,
      "parentCode": "46.77"
    },
    {
      "code": "46.900",
      "name": "Uspesifisert engroshandel",
      "shortName": "Uspesifisert engroshandel",
      "level": 5,
      "parentCode": "46.90"
    },
    {
      "code": "47.111",
      "name": "Butikkhandel med bredt vareutvalg med hovedvekt på nærings- og nytelsesmidler",
      "shortName": "Butikkh. bredt utvalg nær.midler mv.",
      "level": 5,
      "parentCode": "47.11"
    },
    {
      "code": "47.112",
      "name": "Kioskhandel med bredt vareutvalg med hovedvekt på nærings- og nytelsesmidler",
      "shortName": "Kioskh. bredt utvalg nær.midler mv.",
      "level": 5,
      "parentCode": "47.11"
    },
    {
      "code": "47.190",
      "name": "Butikkhandel med bredt vareutvalg ellers",
      "shortName": "Butikkh. bredt vareutvalg el.",
      "level": 5,
      "parentCode": "47.19"
    },
    {
      "code": "47.210",
      "name": "Butikkhandel med frukt og grønnsaker",
      "shortName": "Butikkh. frukt og grønnsaker",
      "level": 5,
      "parentCode": "47.21"
    },
    {
      "code": "47.220",
      "name": "Butikkhandel med kjøtt og kjøttvarer",
      "shortName": "Butikkh. kjøtt og kjøttvarer",
      "level": 5,
      "parentCode": "47.22"
    },
    {
      "code": "47.230",
      "name": "Butikkhandel med fisk, skalldyr og bløtdyr",
      "shortName": "Butikkh. fisk, skalldyr og bløtdyr",
      "level": 5,
      "parentCode": "47.23"
    },
    {
      "code": "47.241",
      "name": "Butikkhandel med bakervarer og konditorvarer",
      "shortName": "Butikkh. baker- og konditorvarer",
      "level": 5,
      "parentCode": "47.24"
    },
    {
      "code": "47.242",
      "name": "Butikkhandel med sukkervarer",
      "shortName": "Butikkh. sukkervarer",
      "level": 5,
      "parentCode": "47.24"
    },
    {
      "code": "47.251",
      "name": "Butikkhandel med vin og brennevin",
      "shortName": "Butikkh. vin og brennevin",
      "level": 5,
      "parentCode": "47.25"
    },
    {
      "code": "47.259",
      "name": "Butikkhandel med drikkevarer ellers",
      "shortName": "Butikkh. drikkevarer el.",
      "level": 5,
      "parentCode": "47.25"
    },
    {
      "code": "47.260",
      "name": "Butikkhandel med tobakksvarer",
      "shortName": "Butikkh. tobakksvarer",
      "level": 5,
      "parentCode": "47.26"
    },
    {
      "code": "47.291",
      "name": "Butikkhandel med helsekost",
      "shortName": "Butikkh. helsekost",
      "level": 5,
      "parentCode": "47.29"
    },
    {
      "code": "47.292",
      "name": "Butikkhandel med kaffe og te",
      "shortName": "Butikkh. kaffe og te",
      "level": 5,
      "parentCode": "47.29"
    },
    {
      "code": "47.299",
      "name": "Butikkhandel med nærings- og nytelsesmidler ikke nevnt annet sted",
      "shortName": "Butikkh. nær.- og nytelsesmidler el.",
      "level": 5,
      "parentCode": "47.29"
    },
    {
      "code": "47.300",
      "name": "Detaljhandel med drivstoff til motorvogner",
      "shortName": "Detaljh. drivstoff til motorvogner",
      "level": 5,
      "parentCode": "47.30"
    },
    {
      "code": "47.410",
      "name": "Butikkhandel med datamaskiner og utstyr til datamaskiner",
      "shortName": "Butikkh. datamask. og tilleggsutst.",
      "level": 5,
      "parentCode": "47.41"
    },
    {
      "code": "47.420",
      "name": "Butikkhandel med telekommunikasjonsutstyr",
      "shortName": "Butikkh. telekommunikasjonsutstyr",
      "level": 5,
      "parentCode": "47.42"
    },
    {
      "code": "47.430",
      "name": "Butikkhandel med audio- og videoutstyr",
      "shortName": "Butikkh. audio- og videoutstyr",
      "level": 5,
      "parentCode": "47.43"
    },
    {
      "code": "47.510",
      "name": "Butikkhandel med tekstiler og utstyrsvarer",
      "shortName": "Butikkh. tekstiler og utstyrsvarer",
      "level": 5,
      "parentCode": "47.51"
    },
    {
      "code": "47.521",
      "name": "Butikkhandel med bredt utvalg av jernvarer, fargevarer og andre byggevarer",
      "shortName": "Byggvarehus m.m.",
      "level": 5,
      "parentCode": "47.52"
    },
    {
      "code": "47.522",
      "name": "Butikkhandel med jernvarer",
      "shortName": "Butikkh. jernvarer",
      "level": 5,
      "parentCode": "47.52"
    },
    {
      "code": "47.523",
      "name": "Butikkhandel med fargevarer",
      "shortName": "Butikkh. fargevarer",
      "level": 5,
      "parentCode": "47.52"
    },
    {
      "code": "47.524",
      "name": "Butikkhandel med trelast",
      "shortName": "Butikkh. trelast",
      "level": 5,
      "parentCode": "47.52"
    },
    {
      "code": "47.529",
      "name": "Butikkhandel med byggevarer ikke nevnt annet sted",
      "shortName": "Butikkh. byggevarer el.",
      "level": 5,
      "parentCode": "47.52"
    },
    {
      "code": "47.531",
      "name": "Butikkhandel med tapeter og gulvbelegg",
      "shortName": "Butikkh. tapeter og gulvbelegg",
      "level": 5,
      "parentCode": "47.53"
    },
    {
      "code": "47.532",
      "name": "Butikkhandel med tepper",
      "shortName": "Butikkh. tepper",
      "level": 5,
      "parentCode": "47.53"
    },
    {
      "code": "47.533",
      "name": "Butikkhandel med gardiner",
      "shortName": "Butikkh. gardiner",
      "level": 5,
      "parentCode": "47.53"
    },
    {
      "code": "47.540",
      "name": "Butikkhandel med elektriske husholdningsapparater",
      "shortName": "Butikkh. el. hush.apparater",
      "level": 5,
      "parentCode": "47.54"
    },
    {
      "code": "47.591",
      "name": "Butikkhandel med møbler",
      "shortName": "Butikkh. møbler",
      "level": 5,
      "parentCode": "47.59"
    },
    {
      "code": "47.592",
      "name": "Butikkhandel med belysningsutstyr",
      "shortName": "Butikkh. belysningsutstyr",
      "level": 5,
      "parentCode": "47.59"
    },
    {
      "code": "47.593",
      "name": "Butikkhandel med kjøkkenutstyr, glass og steintøy",
      "shortName": "Butikkh. kjøkkenutstyr/steintøy mv.",
      "level": 5,
      "parentCode": "47.59"
    },
    {
      "code": "47.594",
      "name": "Butikkhandel med musikkinstrumenter og noter",
      "shortName": "Butikkh. musikkinstr. og noter",
      "level": 5,
      "parentCode": "47.59"
    },
    {
      "code": "47.599",
      "name": "Butikkhandel med innredningsartikler ikke nevnt annet sted",
      "shortName": "Butikkh. innredningsartikler el.",
      "level": 5,
      "parentCode": "47.59"
    },
    {
      "code": "47.610",
      "name": "Butikkhandel med bøker",
      "shortName": "Butikkh. bøker",
      "level": 5,
      "parentCode": "47.61"
    },
    {
      "code": "47.620",
      "name": "Butikkhandel med aviser og papirvarer",
      "shortName": "Butikkh. aviser og papirvarer",
      "level": 5,
      "parentCode": "47.62"
    },
    {
      "code": "47.630",
      "name": "Butikkhandel med innspillinger av musikk og video",
      "shortName": "Butikkh. innspill. av musikk/video",
      "level": 5,
      "parentCode": "47.63"
    },
    {
      "code": "47.641",
      "name": "Butikkhandel med sportsutstyr",
      "shortName": "Butikkh. sportsutstyr",
      "level": 5,
      "parentCode": "47.64"
    },
    {
      "code": "47.642",
      "name": "Butikkhandel med fritidsbåter og -utstyr",
      "shortName": "Butikkh. fritidsbåter og -utstyr",
      "level": 5,
      "parentCode": "47.64"
    },
    {
      "code": "47.650",
      "name": "Butikkhandel med spill og leker",
      "shortName": "Butikkh. spill og leker",
      "level": 5,
      "parentCode": "47.65"
    },
    {
      "code": "47.710",
      "name": "Butikkhandel med klær",
      "shortName": "Butikkh. klær",
      "level": 5,
      "parentCode": "47.71"
    },
    {
      "code": "47.721",
      "name": "Butikkhandel med skotøy",
      "shortName": "Butikkh. skotøy",
      "level": 5,
      "parentCode": "47.72"
    },
    {
      "code": "47.722",
      "name": "Butikkhandel med reiseeffekter av lær og lærimitasjoner og varer av lær",
      "shortName": "Butikkh. reiseeff. og andre lærvarer",
      "level": 5,
      "parentCode": "47.72"
    },
    {
      "code": "47.730",
      "name": "Butikkhandel med apotekvarer",
      "shortName": "Butikkh. apotekvarer",
      "level": 5,
      "parentCode": "47.73"
    },
    {
      "code": "47.740",
      "name": "Butikkhandel med medisinske og ortopediske artikler",
      "shortName": "Butikkh. medisinske/ortop. art.",
      "level": 5,
      "parentCode": "47.74"
    },
    {
      "code": "47.750",
      "name": "Butikkhandel med kosmetikk og toalettartikler",
      "shortName": "Butikkh. kosmetikk og toalettart.",
      "level": 5,
      "parentCode": "47.75"
    },
    {
      "code": "47.761",
      "name": "Butikkhandel med blomster og planter",
      "shortName": "Butikkh. blomster og planter",
      "level": 5,
      "parentCode": "47.76"
    },
    {
      "code": "47.762",
      "name": "Butikkhandel med kjæledyr og fôrvarer til kjæledyr",
      "shortName": "Butikkh. kjæledyr mv.",
      "level": 5,
      "parentCode": "47.76"
    },
    {
      "code": "47.771",
      "name": "Butikkhandel med ur og klokker",
      "shortName": "Butikkh. ur og klokker",
      "level": 5,
      "parentCode": "47.77"
    },
    {
      "code": "47.772",
      "name": "Butikkhandel med gull- og sølvvarer",
      "shortName": "Butikkh. gull- og sølvvarer",
      "level": 5,
      "parentCode": "47.77"
    },
    {
      "code": "47.781",
      "name": "Butikkhandel med fotoutstyr",
      "shortName": "Butikkh. fotoutstyr",
      "level": 5,
      "parentCode": "47.78"
    },
    {
      "code": "47.782",
      "name": "Butikkhandel med optiske artikler",
      "shortName": "Butikkh. optiske artikler",
      "level": 5,
      "parentCode": "47.78"
    },
    {
      "code": "47.789",
      "name": "Butikkhandel ikke nevnt annet sted",
      "shortName": "Butikkh. el.",
      "level": 5,
      "parentCode": "47.78"
    },
    {
      "code": "47.791",
      "name": "Butikkhandel med antikviteter",
      "shortName": "Butikkh. antikviteter",
      "level": 5,
      "parentCode": "47.79"
    },
    {
      "code": "47.792",
      "name": "Butikkhandel med brukte klær",
      "shortName": "Butikkh. brukte klær",
      "level": 5,
      "parentCode": "47.79"
    },
    {
      "code": "47.799",
      "name": "Butikkhandel med brukte varer ellers",
      "shortName": "Butikkh. brukte varer el.",
      "level": 5,
      "parentCode": "47.79"
    },
    {
      "code": "47.810",
      "name": "Torghandel med næringsmidler, drikkevarer og tobakksvarer",
      "shortName": "Torgh. nær.midl./drikkev./tobakksv",
      "level": 5,
      "parentCode": "47.81"
    },
    {
      "code": "47.820",
      "name": "Torghandel med tekstiler, klær, skotøy og utstyrsvarer",
      "shortName": "Torgh. tekstiler, klær, skotøy m.m.",
      "level": 5,
      "parentCode": "47.82"
    },
    {
      "code": "47.890",
      "name": "Torghandel med andre varer",
      "shortName": "Torghandel med andre varer",
      "level": 5,
      "parentCode": "47.89"
    },
    {
      "code": "47.911",
      "name": "Postordre-/Internetthandel med bredt vareutvalg",
      "shortName": "Postord.-/Internetth. br. vareutv.",
      "level": 5,
      "parentCode": "47.91"
    },
    {
      "code": "47.912",
      "name": "Postordre-/Internetthandel med tekstiler, utstyrsvarer, klær, skotøy, reiseeffekter og lærvarer",
      "shortName": "Postord.-/Internetth. tekstiler mv.",
      "level": 5,
      "parentCode": "47.91"
    },
    {
      "code": "47.913",
      "name": "Postordre-/Internetthandel med belysningsutstyr, kjøkkenutstyr, møbler og innredningsartikler",
      "shortName": "Postord.-/Internetth. møbler mv.",
      "level": 5,
      "parentCode": "47.91"
    },
    {
      "code": "47.914",
      "name": "Postordre-/Internetthandel med elektriske husholdningsapparater, radio, fjernsyn, plater, kassetter og musikkinstrumenter",
      "shortName": "Post.-/Internetth. el.hush.app. mv.",
      "level": 5,
      "parentCode": "47.91"
    },
    {
      "code": "47.915",
      "name": "Postordre-/internetthandel med bøker, papir, aviser og blader",
      "shortName": "Postord.-/Internetth. bøker mv.",
      "level": 5,
      "parentCode": "47.91"
    },
    {
      "code": "47.916",
      "name": "Postordre-/Internetthandel med IKT-utstyr",
      "shortName": "Postord.-/Internetth. IKT-utstyr",
      "level": 5,
      "parentCode": "47.91"
    },
    {
      "code": "47.917",
      "name": "Postordre-/Internetthandel med helsekost",
      "shortName": "Postord.-/Internetth. helsekost",
      "level": 5,
      "parentCode": "47.91"
    },
    {
      "code": "47.919",
      "name": "Postordre-/Internetthandel med annet spesialisert vareutvalg",
      "shortName": "Postord.-/Internetth. ellers",
      "level": 5,
      "parentCode": "47.91"
    },
    {
      "code": "47.990",
      "name": "Detaljhandel utenom utsalgssted ellers",
      "shortName": "Detaljh. utenom utsalgssted el.",
      "level": 5,
      "parentCode": "47.99"
    },
    {
      "code": "49.100",
      "name": "Passasjertransport med jernbane",
      "shortName": "Passasjertransp. med jernbane",
      "level": 5,
      "parentCode": "49.10"
    },
    {
      "code": "49.200",
      "name": "Godstransport med jernbane",
      "shortName": "Godstransp. med jernbane",
      "level": 5,
      "parentCode": "49.20"
    },
    {
      "code": "49.311",
      "name": "Rutebiltransport i by- og forstadsområde",
      "shortName": "Rutebiltransp. by-/forstadsområde",
      "level": 5,
      "parentCode": "49.31"
    },
    {
      "code": "49.312",
      "name": "Transport med sporveis- og forstadsbane",
      "shortName": "Transp. sporveis-/forstadsbane",
      "level": 5,
      "parentCode": "49.31"
    },
    {
      "code": "49.320",
      "name": "Drosjebiltransport",
      "shortName": "Drosjebiltransport",
      "level": 5,
      "parentCode": "49.32"
    },
    {
      "code": "49.391",
      "name": "Rutebiltransport utenfor by- og forstadsområde",
      "shortName": "Rutebiltr. utenfor by-/forstadsomr.",
      "level": 5,
      "parentCode": "49.39"
    },
    {
      "code": "49.392",
      "name": "Turbiltransport",
      "shortName": "Turbiltransport",
      "level": 5,
      "parentCode": "49.39"
    },
    {
      "code": "49.393",
      "name": "Transport med taubaner, kabelbaner og skiheiser",
      "shortName": "Transp. tau-/kabelbaner/skiheiser",
      "level": 5,
      "parentCode": "49.39"
    },
    {
      "code": "49.410",
      "name": "Godstransport på vei",
      "shortName": "Godstransport på vei",
      "level": 5,
      "parentCode": "49.41"
    },
    {
      "code": "49.420",
      "name": "Flyttetransport",
      "shortName": "Flyttetransport",
      "level": 5,
      "parentCode": "49.42"
    },
    {
      "code": "49.500",
      "name": "Rørtransport",
      "shortName": "Rørtransport",
      "level": 5,
      "parentCode": "49.50"
    },
    {
      "code": "50.101",
      "name": "Utenriks sjøfart med passasjerer",
      "shortName": "Utenriks sjøfart med passasjerer",
      "level": 5,
      "parentCode": "50.10"
    },
    {
      "code": "50.102",
      "name": "Innenlandske kystruter med passasjerer",
      "shortName": "Innenl. kystruter med passasjerer",
      "level": 5,
      "parentCode": "50.10"
    },
    {
      "code": "50.109",
      "name": "Kysttrafikk ellers med passasjerer",
      "shortName": "Kysttrafikk ellers med passasjerer",
      "level": 5,
      "parentCode": "50.10"
    },
    {
      "code": "50.201",
      "name": "Utenriks sjøfart med gods",
      "shortName": "Utenriks sjøfart med gods",
      "level": 5,
      "parentCode": "50.20"
    },
    {
      "code": "50.202",
      "name": "Innenriks sjøfart med gods",
      "shortName": "Innenriks sjøfart med gods",
      "level": 5,
      "parentCode": "50.20"
    },
    {
      "code": "50.203",
      "name": "Slepebåter",
      "shortName": "Slepebåter",
      "level": 5,
      "parentCode": "50.20"
    },
    {
      "code": "50.204",
      "name": "Forsyning og andre sjøtransporttjenester for offshore",
      "shortName": "Forsyn./andre sjøtr.tj. for offshore",
      "level": 5,
      "parentCode": "50.20"
    },
    {
      "code": "50.300",
      "name": "Passasjertransport på elver og innsjøer",
      "shortName": "Passasjertr. på elver og innsjøer",
      "level": 5,
      "parentCode": "50.30"
    },
    {
      "code": "50.400",
      "name": "Godstransport på elver og innsjøer",
      "shortName": "Godstransp. på elver og innsjøer",
      "level": 5,
      "parentCode": "50.40"
    },
    {
      "code": "51.100",
      "name": "Lufttransport med passasjerer",
      "shortName": "Lufttransp. med passasjerer",
      "level": 5,
      "parentCode": "51.10"
    },
    {
      "code": "51.210",
      "name": "Lufttransport med gods",
      "shortName": "Lufttransp. med gods",
      "level": 5,
      "parentCode": "51.21"
    },
    {
      "code": "51.220",
      "name": "Romfart",
      "shortName": "Romfart",
      "level": 5,
      "parentCode": "51.22"
    },
    {
      "code": "52.100",
      "name": "Lagring",
      "shortName": "Lagring",
      "level": 5,
      "parentCode": "52.10"
    },
    {
      "code": "52.211",
      "name": "Drift av gods- og transportsentraler",
      "shortName": "Drift av gods- og transportsentraler",
      "level": 5,
      "parentCode": "52.21"
    },
    {
      "code": "52.212",
      "name": "Drift av parkeringsplasser og parkeringshus",
      "shortName": "Drift av parkeringsplasser og -hus",
      "level": 5,
      "parentCode": "52.21"
    },
    {
      "code": "52.213",
      "name": "Drift av bomstasjoner",
      "shortName": "Drift av bomstasjoner",
      "level": 5,
      "parentCode": "52.21"
    },
    {
      "code": "52.214",
      "name": "Drift av taxisentraler og annen formidling av persontransport",
      "shortName": "Drift av taxisentraler m.m.",
      "level": 5,
      "parentCode": "52.21"
    },
    {
      "code": "52.216",
      "name": "Kondensering av gass med henblikk på transport",
      "shortName": "Kondensering av gass mtp. transport",
      "level": 5,
      "parentCode": "52.21"
    },
    {
      "code": "52.219",
      "name": "Tjenester tilknyttet landtransport ellers",
      "shortName": "Tjen. tilkn. landtransport el.",
      "level": 5,
      "parentCode": "52.21"
    },
    {
      "code": "52.221",
      "name": "Drift av havne- og kaianlegg",
      "shortName": "Drift av havne- og kaianlegg",
      "level": 5,
      "parentCode": "52.22"
    },
    {
      "code": "52.222",
      "name": "Redningstjeneste",
      "shortName": "Redningstjeneste",
      "level": 5,
      "parentCode": "52.22"
    },
    {
      "code": "52.223",
      "name": "Forsyningsbaser",
      "shortName": "Forsyningsbaser",
      "level": 5,
      "parentCode": "52.22"
    },
    {
      "code": "52.229",
      "name": "Tjenester tilknyttet sjøtransport ellers",
      "shortName": "Tjen. tilkn. sjøtransport el.",
      "level": 5,
      "parentCode": "52.22"
    },
    {
      "code": "52.230",
      "name": "Andre tjenester tilknyttet lufttransport",
      "shortName": "Andre tjen. tilkn. lufttransport",
      "level": 5,
      "parentCode": "52.23"
    },
    {
      "code": "52.240",
      "name": "Lasting og lossing",
      "shortName": "Lasting og lossing",
      "level": 5,
      "parentCode": "52.24"
    },
    {
      "code": "52.291",
      "name": "Spedisjon",
      "shortName": "Spedisjon",
      "level": 5,
      "parentCode": "52.29"
    },
    {
      "code": "52.292",
      "name": "Skipsmegling",
      "shortName": "Skipsmegling",
      "level": 5,
      "parentCode": "52.29"
    },
    {
      "code": "52.293",
      "name": "Flymegling",
      "shortName": "Flymegling",
      "level": 5,
      "parentCode": "52.29"
    },
    {
      "code": "52.299",
      "name": "Transportformidling ellers",
      "shortName": "Transportformidling ellers",
      "level": 5,
      "parentCode": "52.29"
    },
    {
      "code": "53.100",
      "name": "Landsdekkende posttjenester",
      "shortName": "Landsdekkende posttjenester",
      "level": 5,
      "parentCode": "53.10"
    },
    {
      "code": "53.200",
      "name": "Andre post- og budtjenester",
      "shortName": "Andre post- og budtjenester",
      "level": 5,
      "parentCode": "53.20"
    },
    {
      "code": "55.101",
      "name": "Drift av hoteller, pensjonater og moteller med restaurant",
      "shortName": "Drift av hoteller med restaurant",
      "level": 5,
      "parentCode": "55.10"
    },
    {
      "code": "55.102",
      "name": "Drift av hoteller, pensjonater og moteller uten restaurant",
      "shortName": "Drift av hoteller uten restaurant",
      "level": 5,
      "parentCode": "55.10"
    },
    {
      "code": "55.201",
      "name": "Drift av vandrerhjem",
      "shortName": "Drift av vandrerhjem",
      "level": 5,
      "parentCode": "55.20"
    },
    {
      "code": "55.202",
      "name": "Drift av ferieleiligheter",
      "shortName": "Drift av ferieleiligheter",
      "level": 5,
      "parentCode": "55.20"
    },
    {
      "code": "55.300",
      "name": "Drift av campingplasser",
      "shortName": "Drift av campingplasser",
      "level": 5,
      "parentCode": "55.30"
    },
    {
      "code": "55.900",
      "name": "Annen overnatting",
      "shortName": "Annen overnatting",
      "level": 5,
      "parentCode": "55.90"
    },
    {
      "code": "56.101",
      "name": "Drift av restauranter og kafeer",
      "shortName": "Drift av restauranter og kafeer",
      "level": 5,
      "parentCode": "56.10"
    },
    {
      "code": "56.102",
      "name": "Drift av gatekjøkken",
      "shortName": "Drift av gatekjøkken",
      "level": 5,
      "parentCode": "56.10"
    },
    {
      "code": "56.210",
      "name": "Cateringvirksomhet",
      "shortName": "Cateringvirksomhet",
      "level": 5,
      "parentCode": "56.21"
    },
    {
      "code": "56.290",
      "name": "Kantiner drevet som selvstendig virksomhet",
      "shortName": "Kantinedrift, selvst. virksomhet",
      "level": 5,
      "parentCode": "56.29"
    },
    {
      "code": "56.301",
      "name": "Drift av puber",
      "shortName": "Drift av puber",
      "level": 5,
      "parentCode": "56.30"
    },
    {
      "code": "56.309",
      "name": "Drift av barer ellers",
      "shortName": "Drift av barer ellers",
      "level": 5,
      "parentCode": "56.30"
    },
    {
      "code": "58.110",
      "name": "Utgivelse av bøker",
      "shortName": "Utgivelse av bøker",
      "level": 5,
      "parentCode": "58.11"
    },
    {
      "code": "58.120",
      "name": "Utgivelse av kataloger og adresselister",
      "shortName": "Utgiv. av kataloger/adresselister",
      "level": 5,
      "parentCode": "58.12"
    },
    {
      "code": "58.130",
      "name": "Utgivelse av aviser",
      "shortName": "Utgivelse av aviser",
      "level": 5,
      "parentCode": "58.13"
    },
    {
      "code": "58.140",
      "name": "Utgivelse av blader og tidsskrifter",
      "shortName": "Utgivelse av blader og tidsskrifter",
      "level": 5,
      "parentCode": "58.14"
    },
    {
      "code": "58.190",
      "name": "Forlagsvirksomhet ellers",
      "shortName": "Forlagsvirksomhet ellers",
      "level": 5,
      "parentCode": "58.19"
    },
    {
      "code": "58.210",
      "name": "Utgivelse av programvare for dataspill",
      "shortName": "Utgiv. av programv. for dataspill",
      "level": 5,
      "parentCode": "58.21"
    },
    {
      "code": "58.290",
      "name": "Utgivelse av annen programvare",
      "shortName": "Utgiv. av annen programvare",
      "level": 5,
      "parentCode": "58.29"
    },
    {
      "code": "59.110",
      "name": "Produksjon av film, video og fjernsynsprogrammer",
      "shortName": "Prod. av film/video/fjernsynsprogr.",
      "level": 5,
      "parentCode": "59.11"
    },
    {
      "code": "59.120",
      "name": "Etterarbeid knyttet til produksjon av film, video og fjernsynsprogrammer",
      "shortName": "Etterarb. til film-/video-/TV-prod.",
      "level": 5,
      "parentCode": "59.12"
    },
    {
      "code": "59.130",
      "name": "Distribusjon av film, video og fjernsynsprogrammer",
      "shortName": "Distrib. film/video/fjernsynsprogr.",
      "level": 5,
      "parentCode": "59.13"
    },
    {
      "code": "59.140",
      "name": "Filmframvisning",
      "shortName": "Filmframvisning",
      "level": 5,
      "parentCode": "59.14"
    },
    {
      "code": "59.200",
      "name": "Produksjon og utgivelse av musikk- og lydopptak",
      "shortName": "Prod./utgiv. av musikk-/lydopptak",
      "level": 5,
      "parentCode": "59.20"
    },
    {
      "code": "60.100",
      "name": "Radiokringkasting",
      "shortName": "Radiokringkasting",
      "level": 5,
      "parentCode": "60.10"
    },
    {
      "code": "60.200",
      "name": "Fjernsynskringkasting",
      "shortName": "Fjernsynskringkasting",
      "level": 5,
      "parentCode": "60.20"
    },
    {
      "code": "61.100",
      "name": "Kabelbasert telekommunikasjon",
      "shortName": "Kabelbasert telekomm.",
      "level": 5,
      "parentCode": "61.10"
    },
    {
      "code": "61.200",
      "name": "Trådløs telekommunikasjon",
      "shortName": "Trådløs telekomm.",
      "level": 5,
      "parentCode": "61.20"
    },
    {
      "code": "61.300",
      "name": "Satellittbasert telekommunikasjon",
      "shortName": "Satellittbasert telekomm.",
      "level": 5,
      "parentCode": "61.30"
    },
    {
      "code": "61.900",
      "name": "Telekommunikasjon ellers",
      "shortName": "Telekommunikasjon ellers",
      "level": 5,
      "parentCode": "61.90"
    },
    {
      "code": "62.010",
      "name": "Programmeringstjenester",
      "shortName": "Programmeringstjenester",
      "level": 5,
      "parentCode": "62.01"
    },
    {
      "code": "62.020",
      "name": "Konsulentvirksomhet tilknyttet informasjonsteknologi",
      "shortName": "Kons.virks. tilkn. informasj.tekn.",
      "level": 5,
      "parentCode": "62.02"
    },
    {
      "code": "62.030",
      "name": "Forvaltning og drift av IT-systemer",
      "shortName": "Forvaltning og drift av IT-systemer",
      "level": 5,
      "parentCode": "62.03"
    },
    {
      "code": "62.090",
      "name": "Andre tjenester tilknyttet informasjonsteknologi",
      "shortName": "Tjen. tilkn. informasjonsteknologi el.",
      "level": 5,
      "parentCode": "62.09"
    },
    {
      "code": "63.110",
      "name": "Databehandling, datalagring og tilknyttede tjenester",
      "shortName": "Databeh./-lagring og tilkn. tjen.",
      "level": 5,
      "parentCode": "63.11"
    },
    {
      "code": "63.120",
      "name": "Drift av web-portaler",
      "shortName": "Drift av web-portaler",
      "level": 5,
      "parentCode": "63.12"
    },
    {
      "code": "63.910",
      "name": "Nyhetsbyråer",
      "shortName": "Nyhetsbyråer",
      "level": 5,
      "parentCode": "63.91"
    },
    {
      "code": "63.990",
      "name": "Andre informasjonstjenester ikke nevnt annet sted",
      "shortName": "Andre informasjonstjenester",
      "level": 5,
      "parentCode": "63.99"
    },
    {
      "code": "64.110",
      "name": "Sentralbankvirksomhet",
      "shortName": "Sentralbankvirksomhet",
      "level": 5,
      "parentCode": "64.11"
    },
    {
      "code": "64.190",
      "name": "Bankvirksomhet ellers",
      "shortName": "Bankvirksomhet ellers",
      "level": 5,
      "parentCode": "64.19"
    },
    {
      "code": "64.201",
      "name": "Finansielle holdingselskaper",
      "shortName": "Finansielle holdingselskaper",
      "level": 5,
      "parentCode": "64.20"
    },
    {
      "code": "64.202",
      "name": "Spesielle holdingselskaper",
      "shortName": "Spesielle holdingselskaper",
      "level": 5,
      "parentCode": "64.20"
    },
    {
      "code": "64.301",
      "name": "Verdipapirfond",
      "shortName": "Verdipapirfond",
      "level": 5,
      "parentCode": "64.30"
    },
    {
      "code": "64.302",
      "name": "Alternative investeringsfond (AIF) som ikke er verdipapirfond",
      "shortName": "Alternative investeringsfond AIF",
      "level": 5,
      "parentCode": "64.30"
    },
    {
      "code": "64.305",
      "name": "Finansstiftelser",
      "shortName": "Finansstiftelser",
      "level": 5,
      "parentCode": "64.30"
    },
    {
      "code": "64.306",
      "name": "Egeninvesteringsselskaper i finansielle konsern og for offentlig forvaltning",
      "shortName": "Egeninvesteringsselskaper i finansielle konsern og for offentlig forvaltning",
      "level": 5,
      "parentCode": "64.30"
    },
    {
      "code": "64.308",
      "name": "Familieeide egeninvesteringsselskaper",
      "shortName": "Familieide egeninvesteringsselskaper",
      "level": 5,
      "parentCode": "64.30"
    },
    {
      "code": "64.910",
      "name": "Finansiell leasing",
      "shortName": "Finansiell leasing",
      "level": 5,
      "parentCode": "64.91"
    },
    {
      "code": "64.920",
      "name": "Annen kredittgivning",
      "shortName": "Annen kredittgiving",
      "level": 5,
      "parentCode": "64.92"
    },
    {
      "code": "64.990",
      "name": "Annen finansieringsvirksomhet ikke nevnt annet sted",
      "shortName": "Finansieringsvirksomhet el.",
      "level": 5,
      "parentCode": "64.99"
    },
    {
      "code": "65.110",
      "name": "Livsforsikring",
      "shortName": "Livsforsikring",
      "level": 5,
      "parentCode": "65.11"
    },
    {
      "code": "65.120",
      "name": "Skadeforsikring",
      "shortName": "Skadeforsikring",
      "level": 5,
      "parentCode": "65.12"
    },
    {
      "code": "65.200",
      "name": "Gjenforsikring",
      "shortName": "Gjenforsikring",
      "level": 5,
      "parentCode": "65.20"
    },
    {
      "code": "65.300",
      "name": "Pensjonskasser",
      "shortName": "Pensjonskasser",
      "level": 5,
      "parentCode": "65.30"
    },
    {
      "code": "66.110",
      "name": "Administrasjon av finansmarkeder",
      "shortName": "Administrasjon av finansmarkeder",
      "level": 5,
      "parentCode": "66.11"
    },
    {
      "code": "66.120",
      "name": "Verdipapirmegling",
      "shortName": "Verdipapirmegling",
      "level": 5,
      "parentCode": "66.12"
    },
    {
      "code": "66.190",
      "name": "Andre tjenester tilknyttet finansieringsvirksomhet",
      "shortName": "Tjen. tilkn. finansieringsvirks. el.",
      "level": 5,
      "parentCode": "66.19"
    },
    {
      "code": "66.210",
      "name": "Risiko- og skadevurdering",
      "shortName": "Risiko- og skadevurdering",
      "level": 5,
      "parentCode": "66.21"
    },
    {
      "code": "66.220",
      "name": "Forsikringsformidling",
      "shortName": "Forsikringsformidling",
      "level": 5,
      "parentCode": "66.22"
    },
    {
      "code": "66.290",
      "name": "Andre tjenester tilknyttet forsikringsvirksomhet og pensjonskasser",
      "shortName": "Tjen. fors.virks./pensj.kasser el.",
      "level": 5,
      "parentCode": "66.29"
    },
    {
      "code": "66.300",
      "name": "Fondsforvaltningsvirksomhet",
      "shortName": "Fondsforvaltningsvirksomhet",
      "level": 5,
      "parentCode": "66.30"
    },
    {
      "code": "68.100",
      "name": "Kjøp og salg av egen fast eiendom",
      "shortName": "Kjøp/salg av egen fast eiendom",
      "level": 5,
      "parentCode": "68.10"
    },
    {
      "code": "68.201",
      "name": "Borettslag",
      "shortName": "Borettslag",
      "level": 5,
      "parentCode": "68.20"
    },
    {
      "code": "68.209",
      "name": "Utleie av egen eller leid fast eiendom ellers",
      "shortName": "Utl. av egen/leid fast eiendom el.",
      "level": 5,
      "parentCode": "68.20"
    },
    {
      "code": "68.310",
      "name": "Eiendomsmegling",
      "shortName": "Eiendomsmegling",
      "level": 5,
      "parentCode": "68.31"
    },
    {
      "code": "68.320",
      "name": "Eiendomsforvaltning",
      "shortName": "Eiendomsforvaltning",
      "level": 5,
      "parentCode": "68.32"
    },
    {
      "code": "69.100",
      "name": "Juridisk tjenesteyting",
      "shortName": "Juridisk tjenesteyting",
      "level": 5,
      "parentCode": "69.10"
    },
    {
      "code": "69.201",
      "name": "Regnskap og bokføring",
      "shortName": "Regnskap og bokføring",
      "level": 5,
      "parentCode": "69.20"
    },
    {
      "code": "69.202",
      "name": "Revisjon",
      "shortName": "Revisjon",
      "level": 5,
      "parentCode": "69.20"
    },
    {
      "code": "69.203",
      "name": "Skatterådgivning",
      "shortName": "Skatterådgivning",
      "level": 5,
      "parentCode": "69.20"
    },
    {
      "code": "70.100",
      "name": "Hovedkontortjenester",
      "shortName": "Hovedkontortjenester",
      "level": 5,
      "parentCode": "70.10"
    },
    {
      "code": "70.210",
      "name": "PR og kommunikasjonstjenester",
      "shortName": "PR og kommunikasjonstjenester",
      "level": 5,
      "parentCode": "70.21"
    },
    {
      "code": "70.220",
      "name": "Bedriftsrådgivning og annen administrativ rådgivning",
      "shortName": "Bedriftsrådgiv./annen adm. rådgiv.",
      "level": 5,
      "parentCode": "70.22"
    },
    {
      "code": "71.111",
      "name": "Plan- og reguleringsarbeid",
      "shortName": "Plan- og reguleringsarbeid",
      "level": 5,
      "parentCode": "71.11"
    },
    {
      "code": "71.112",
      "name": "Arkitekttjenester vedrørende byggverk",
      "shortName": "Arkitekttjen. vedr. byggverk",
      "level": 5,
      "parentCode": "71.11"
    },
    {
      "code": "71.113",
      "name": "Landskapsarkitekttjenester",
      "shortName": "Landskapsarkitekttjenester",
      "level": 5,
      "parentCode": "71.11"
    },
    {
      "code": "71.121",
      "name": "Byggeteknisk konsulentvirksomhet",
      "shortName": "Byggeteknisk konsulentvirks.",
      "level": 5,
      "parentCode": "71.12"
    },
    {
      "code": "71.122",
      "name": "Geologiske undersøkelser",
      "shortName": "Geologiske undersøkelser",
      "level": 5,
      "parentCode": "71.12"
    },
    {
      "code": "71.123",
      "name": "Kart og oppmåling",
      "shortName": "Kart og oppmåling",
      "level": 5,
      "parentCode": "71.12"
    },
    {
      "code": "71.129",
      "name": "Annen teknisk konsulentvirksomhet",
      "shortName": "Annen teknisk konsulentvirks.",
      "level": 5,
      "parentCode": "71.12"
    },
    {
      "code": "71.200",
      "name": "Teknisk prøving og analyse",
      "shortName": "Teknisk prøving og analyse",
      "level": 5,
      "parentCode": "71.20"
    },
    {
      "code": "72.110",
      "name": "Forskning og utviklingsarbeid innen bioteknologi",
      "shortName": "Forsk./utvikl.arb. innen bioteknologi",
      "level": 5,
      "parentCode": "72.11"
    },
    {
      "code": "72.190",
      "name": "Annen forskning og annet utviklingsarbeid innen naturvitenskap og teknikk",
      "shortName": "Annen forsk. innen naturvit. og teknikk",
      "level": 5,
      "parentCode": "72.19"
    },
    {
      "code": "72.200",
      "name": "Forskning og utviklingsarbeid innen samfunnsvitenskap og humanistiske fag",
      "shortName": "Forskning samfunnsvit., human. fag",
      "level": 5,
      "parentCode": "72.20"
    },
    {
      "code": "73.110",
      "name": "Reklamebyråer",
      "shortName": "Reklamebyråer",
      "level": 5,
      "parentCode": "73.11"
    },
    {
      "code": "73.120",
      "name": "Medieformidlingstjenester",
      "shortName": "Medieformidlingstjenester",
      "level": 5,
      "parentCode": "73.12"
    },
    {
      "code": "73.200",
      "name": "Markeds- og opinionsundersøkelser",
      "shortName": "Markeds- og opinionsundersøkelser",
      "level": 5,
      "parentCode": "73.20"
    },
    {
      "code": "74.101",
      "name": "Industridesign, produktdesign og annen teknisk designvirksomhet",
      "shortName": "Ind.-/produkt-/tekn.designvirks el",
      "level": 5,
      "parentCode": "74.10"
    },
    {
      "code": "74.102",
      "name": "Grafisk og visuell kommunikasjonsdesign",
      "shortName": "Grafisk/visuell kommunikasj.design",
      "level": 5,
      "parentCode": "74.10"
    },
    {
      "code": "74.103",
      "name": "Interiørarkitekt-, interiørdesign- og interiørkonsulentvirksomhet",
      "shortName": "Interiørark./-design/interiørkons.",
      "level": 5,
      "parentCode": "74.10"
    },
    {
      "code": "74.200",
      "name": "Fotografvirksomhet",
      "shortName": "Fotografvirksomhet",
      "level": 5,
      "parentCode": "74.20"
    },
    {
      "code": "74.300",
      "name": "Oversettelses- og tolkevirksomhet",
      "shortName": "Oversettelses- og tolkevirksomhet",
      "level": 5,
      "parentCode": "74.30"
    },
    {
      "code": "74.901",
      "name": "Takseringsvirksomhet",
      "shortName": "Takseringsvirksomhet",
      "level": 5,
      "parentCode": "74.90"
    },
    {
      "code": "74.902",
      "name": "Modellbyråvirksomhet",
      "shortName": "Modellbyråvirksomhet",
      "level": 5,
      "parentCode": "74.90"
    },
    {
      "code": "74.903",
      "name": "Impresariovirksomhet",
      "shortName": "Impresariovirksomhet",
      "level": 5,
      "parentCode": "74.90"
    },
    {
      "code": "74.909",
      "name": "Annen faglig, vitenskapelig og teknisk virksomhet ikke nevnt annet sted",
      "shortName": "Faglig/vit.skapelig/tekn.virks. el.",
      "level": 5,
      "parentCode": "74.90"
    },
    {
      "code": "75.000",
      "name": "Veterinærtjenester",
      "shortName": "Veterinærtjenester",
      "level": 5,
      "parentCode": "75.00"
    },
    {
      "code": "77.110",
      "name": "Utleie og leasing av biler og andre lette motorvogner",
      "shortName": "Utl./leas. biler/andre lette motorv.",
      "level": 5,
      "parentCode": "77.11"
    },
    {
      "code": "77.120",
      "name": "Utleie og leasing av lastebiler",
      "shortName": "Utleie og leasing av lastebiler",
      "level": 5,
      "parentCode": "77.12"
    },
    {
      "code": "77.210",
      "name": "Utleie og leasing av sports- og fritidsutstyr",
      "shortName": "Utl./leas. sports- og fritidsutstyr",
      "level": 5,
      "parentCode": "77.21"
    },
    {
      "code": "77.220",
      "name": "Utleie av videofilm, DVD og lignende",
      "shortName": "Utleie videofilm, DVD og lignende",
      "level": 5,
      "parentCode": "77.22"
    },
    {
      "code": "77.290",
      "name": "Utleie og leasing av andre husholdningsvarer og varer til personlig bruk",
      "shortName": "Utl./leas. husholdningsvarer el.",
      "level": 5,
      "parentCode": "77.29"
    },
    {
      "code": "77.310",
      "name": "Utleie og leasing av landbruksmaskiner og -utstyr",
      "shortName": "Utl./leas. landbruksmaskiner og -utstyr",
      "level": 5,
      "parentCode": "77.31"
    },
    {
      "code": "77.320",
      "name": "Utleie og leasing av bygge- og anleggsmaskiner og -utstyr",
      "shortName": "Utl./leas. bygge- og anleggsmask.",
      "level": 5,
      "parentCode": "77.32"
    },
    {
      "code": "77.330",
      "name": "Utleie og leasing av kontor- og datamaskiner",
      "shortName": "Utl./leas. kontor- og datamaskiner",
      "level": 5,
      "parentCode": "77.33"
    },
    {
      "code": "77.340",
      "name": "Utleie og leasing av sjøtransportmateriell",
      "shortName": "Utl./leas. sjøtransportmateriell",
      "level": 5,
      "parentCode": "77.34"
    },
    {
      "code": "77.350",
      "name": "Utleie og leasing av lufttransportmateriell",
      "shortName": "Utl./leas. lufttransportmateriell",
      "level": 5,
      "parentCode": "77.35"
    },
    {
      "code": "77.390",
      "name": "Utleie og leasing av andre maskiner og annet utstyr og materiell ikke nevnt annet sted",
      "shortName": "Utl./leas. andre mask./annet utstyr",
      "level": 5,
      "parentCode": "77.39"
    },
    {
      "code": "77.400",
      "name": "Leasing av immateriell eiendom og lignende produkter, unntatt opphavsrettsbeskyttede verker",
      "shortName": "Leas. av immateriell eiendom mv.",
      "level": 5,
      "parentCode": "77.40"
    },
    {
      "code": "78.100",
      "name": "Rekruttering og formidling av arbeidskraft",
      "shortName": "Rekrutt./formidling av arbeidskraft",
      "level": 5,
      "parentCode": "78.10"
    },
    {
      "code": "78.200",
      "name": "Utleie av arbeidskraft",
      "shortName": "Utleie av arbeidskraft",
      "level": 5,
      "parentCode": "78.20"
    },
    {
      "code": "78.300",
      "name": "Andre personaladministrative tjenester",
      "shortName": "Andre personaladm. tjen.",
      "level": 5,
      "parentCode": "78.30"
    },
    {
      "code": "79.110",
      "name": "Reisebyråvirksomhet",
      "shortName": "Reisebyråvirksomhet",
      "level": 5,
      "parentCode": "79.11"
    },
    {
      "code": "79.120",
      "name": "Reisearrangørvirksomhet",
      "shortName": "Reisearrangørvirksomhet",
      "level": 5,
      "parentCode": "79.12"
    },
    {
      "code": "79.901",
      "name": "Turistkontorvirksomhet og destinasjonsselskaper",
      "shortName": "Turistkontorvirks./destinasj.selsk.",
      "level": 5,
      "parentCode": "79.90"
    },
    {
      "code": "79.902",
      "name": "Guider og reiseledere",
      "shortName": "Guider og reiseledere",
      "level": 5,
      "parentCode": "79.90"
    },
    {
      "code": "79.903",
      "name": "Opplevelses-, arrangements- og aktivitetsarrangørvirksomhet",
      "shortName": "Opplevelses-/arrangementsvirks.m.m.",
      "level": 5,
      "parentCode": "79.90"
    },
    {
      "code": "79.909",
      "name": "Turistrelaterte tjenester ikke nevnt annet sted",
      "shortName": "Turistrelaterte tjenester el.",
      "level": 5,
      "parentCode": "79.90"
    },
    {
      "code": "80.100",
      "name": "Private vakttjenester",
      "shortName": "Private vakttjenester",
      "level": 5,
      "parentCode": "80.10"
    },
    {
      "code": "80.200",
      "name": "Tjenester tilknyttet vakttjenester",
      "shortName": "Tjenester tilknyttet vakttjenester",
      "level": 5,
      "parentCode": "80.20"
    },
    {
      "code": "80.300",
      "name": "Etterforsking",
      "shortName": "Etterforsking",
      "level": 5,
      "parentCode": "80.30"
    },
    {
      "code": "81.101",
      "name": "Vaktmestertjenester",
      "shortName": "Vaktmestertjenester",
      "level": 5,
      "parentCode": "81.10"
    },
    {
      "code": "81.109",
      "name": "Andre kombinerte tjenester tilknyttet eiendomsdrift",
      "shortName": "Andre komb. tjen. tilkn. eiendomsdr.",
      "level": 5,
      "parentCode": "81.10"
    },
    {
      "code": "81.210",
      "name": "Rengjøring av bygninger",
      "shortName": "Rengjøring av bygninger",
      "level": 5,
      "parentCode": "81.21"
    },
    {
      "code": "81.220",
      "name": "Utvendig rengjøring av bygninger og industriell rengjøring",
      "shortName": "Utv. rengj. bygn./ind. rengjøring",
      "level": 5,
      "parentCode": "81.22"
    },
    {
      "code": "81.291",
      "name": "Skadedyrkontroll",
      "shortName": "Skadedyrkontroll",
      "level": 5,
      "parentCode": "81.29"
    },
    {
      "code": "81.299",
      "name": "Annen rengjøringsvirksomhet ikke nevnt annet sted",
      "shortName": "Rengjøringsvirksomhet ellers",
      "level": 5,
      "parentCode": "81.29"
    },
    {
      "code": "81.300",
      "name": "Beplantning av hager og parkanlegg",
      "shortName": "Beplantning av hager og parkanl.",
      "level": 5,
      "parentCode": "81.30"
    },
    {
      "code": "82.110",
      "name": "Kombinerte kontortjenester",
      "shortName": "Kombinerte kontortjenester",
      "level": 5,
      "parentCode": "82.11"
    },
    {
      "code": "82.190",
      "name": "Fotokopiering, forberedelse av dokumenter og andre spesialiserte kontortjenester",
      "shortName": "Fotokopiering/spes. kontortjen. el.",
      "level": 5,
      "parentCode": "82.19"
    },
    {
      "code": "82.201",
      "name": "Telefonvakttjenester",
      "shortName": "Telefonvakttjenester",
      "level": 5,
      "parentCode": "82.20"
    },
    {
      "code": "82.202",
      "name": "Telefonsalg",
      "shortName": "Telefonsalg",
      "level": 5,
      "parentCode": "82.20"
    },
    {
      "code": "82.300",
      "name": "Kongress-, messe- og utstillingsvirksomhet",
      "shortName": "Kongress-/messe-/utstillingsvirks.",
      "level": 5,
      "parentCode": "82.30"
    },
    {
      "code": "82.910",
      "name": "Inkasso- og kredittopplysningsvirksomhet",
      "shortName": "Inkasso- og kredittopplysningsvirks.",
      "level": 5,
      "parentCode": "82.91"
    },
    {
      "code": "82.920",
      "name": "Pakkevirksomhet",
      "shortName": "Pakkevirksomhet",
      "level": 5,
      "parentCode": "82.92"
    },
    {
      "code": "82.990",
      "name": "Annen forretningsmessig tjenesteyting ikke nevnt annet sted",
      "shortName": "Forr.messig tj.yting ikke nevnt el.",
      "level": 5,
      "parentCode": "82.99"
    },
    {
      "code": "84.110",
      "name": "Generell offentlig administrasjon",
      "shortName": "Generell offentlig administrasjon",
      "level": 5,
      "parentCode": "84.11"
    },
    {
      "code": "84.120",
      "name": "Offentlig administrasjon tilknyttet helsestell, sosial virksomhet, undervisning, kirke, kultur og miljøvern",
      "shortName": "Off.adm. helse, sos.virks. m.m.",
      "level": 5,
      "parentCode": "84.12"
    },
    {
      "code": "84.130",
      "name": "Offentlig administrasjon tilknyttet næringsvirksomhet og arbeidsmarked",
      "shortName": "Off.adm. nær.virks. og arb.marked",
      "level": 5,
      "parentCode": "84.13"
    },
    {
      "code": "84.210",
      "name": "Utenrikssaker",
      "shortName": "Utenrikssaker",
      "level": 5,
      "parentCode": "84.21"
    },
    {
      "code": "84.220",
      "name": "Forsvar",
      "shortName": "Forsvar",
      "level": 5,
      "parentCode": "84.22"
    },
    {
      "code": "84.230",
      "name": "Retts- og fengselsvesen",
      "shortName": "Retts- og fengselsvesen",
      "level": 5,
      "parentCode": "84.23"
    },
    {
      "code": "84.240",
      "name": "Politi- og påtalemyndighet",
      "shortName": "Politi- og påtalemyndighet",
      "level": 5,
      "parentCode": "84.24"
    },
    {
      "code": "84.250",
      "name": "Brannvern",
      "shortName": "Brannvern",
      "level": 5,
      "parentCode": "84.25"
    },
    {
      "code": "84.300",
      "name": "Trygdeordninger underlagt offentlig forvaltning",
      "shortName": "Sosialforsikring, trygd",
      "level": 5,
      "parentCode": "84.30"
    },
    {
      "code": "85.100",
      "name": "Førskoleundervisning",
      "shortName": "Førskoleundervisning",
      "level": 5,
      "parentCode": "85.10"
    },
    {
      "code": "85.201",
      "name": "Ordinær grunnskoleundervisning",
      "shortName": "Ordinær grunnskoleundervisning",
      "level": 5,
      "parentCode": "85.20"
    },
    {
      "code": "85.202",
      "name": "Spesialskoleundervisning for funksjonshemmede",
      "shortName": "Spes.undervisn. for funksj.hemmede",
      "level": 5,
      "parentCode": "85.20"
    },
    {
      "code": "85.203",
      "name": "Kompetansesentra og annen spesialundervisning",
      "shortName": "Kompetansesentra og lignende",
      "level": 5,
      "parentCode": "85.20"
    },
    {
      "code": "85.310",
      "name": "Videregående opplæring innen allmennfaglige studieretninger",
      "shortName": "Undervisning i allmennfag",
      "level": 5,
      "parentCode": "85.31"
    },
    {
      "code": "85.320",
      "name": "Videregående opplæring innen tekniske og andre yrkesfaglige studieretninger",
      "shortName": "Undervisn. i tekn./yrkesrettede fag",
      "level": 5,
      "parentCode": "85.32"
    },
    {
      "code": "85.410",
      "name": "Undervisning ved fagskoler",
      "shortName": "Undervisning ved fagskoler",
      "level": 5,
      "parentCode": "85.41"
    },
    {
      "code": "85.421",
      "name": "Undervisning ved universiteter",
      "shortName": "Undervisning ved universiteter",
      "level": 5,
      "parentCode": "85.42"
    },
    {
      "code": "85.422",
      "name": "Undervisning ved vitenskapelige høgskoler",
      "shortName": "Underv. ved vit.skap høgskoler",
      "level": 5,
      "parentCode": "85.42"
    },
    {
      "code": "85.423",
      "name": "Undervisning ved statlige høgskoler",
      "shortName": "Underv. ved statlige høgskoler",
      "level": 5,
      "parentCode": "85.42"
    },
    {
      "code": "85.424",
      "name": "Undervisning ved militære høgskoler",
      "shortName": "Underv. ved militære høgskoler",
      "level": 5,
      "parentCode": "85.42"
    },
    {
      "code": "85.429",
      "name": "Undervisning ved andre høgskoler",
      "shortName": "Underv. ved andre høgskoler",
      "level": 5,
      "parentCode": "85.42"
    },
    {
      "code": "85.510",
      "name": "Undervisning innen idrett og rekreasjon",
      "shortName": "Underv. innen idrett og rekreasjon",
      "level": 5,
      "parentCode": "85.51"
    },
    {
      "code": "85.521",
      "name": "Kommunal kulturskoleundervisning",
      "shortName": "Kommunal kulturskoleunderv.",
      "level": 5,
      "parentCode": "85.52"
    },
    {
      "code": "85.522",
      "name": "Undervisning i kunstfag",
      "shortName": "Undervisning i kunstfag",
      "level": 5,
      "parentCode": "85.52"
    },
    {
      "code": "85.529",
      "name": "Annen undervisning innen kultur",
      "shortName": "Annen undervisning innen kultur",
      "level": 5,
      "parentCode": "85.52"
    },
    {
      "code": "85.530",
      "name": "Trafikkskoleundervisning",
      "shortName": "Trafikkskoleundervisning",
      "level": 5,
      "parentCode": "85.53"
    },
    {
      "code": "85.591",
      "name": "Folkehøgskoleundervisning",
      "shortName": "Folkehøgskoleundervisning",
      "level": 5,
      "parentCode": "85.59"
    },
    {
      "code": "85.592",
      "name": "Arbeidsmarkedskurs",
      "shortName": "Arbeidsmarkedkurs",
      "level": 5,
      "parentCode": "85.59"
    },
    {
      "code": "85.593",
      "name": "Studieforbunds- og frivillige organisasjoners kurs",
      "shortName": "Studieforb.- og friv. organ kurs",
      "level": 5,
      "parentCode": "85.59"
    },
    {
      "code": "85.594",
      "name": "Voksenopplæringssentre",
      "shortName": "Voksenopplæringssentre",
      "level": 5,
      "parentCode": "85.59"
    },
    {
      "code": "85.595",
      "name": "Timelærervirksomhet",
      "shortName": "Timelærervirksomhet",
      "level": 5,
      "parentCode": "85.59"
    },
    {
      "code": "85.596",
      "name": "Undervisning innen religion",
      "shortName": "Undervisning innen religion",
      "level": 5,
      "parentCode": "85.59"
    },
    {
      "code": "85.599",
      "name": "Annen undervisning ikke nevnt annet sted",
      "shortName": "Undervisning ellers",
      "level": 5,
      "parentCode": "85.59"
    },
    {
      "code": "85.601",
      "name": "Pedagogisk-psykologisk rådgivningstjeneste",
      "shortName": "Pedag./psyk. rådgivningstjeneste",
      "level": 5,
      "parentCode": "85.60"
    },
    {
      "code": "85.609",
      "name": "Andre tjenester tilknyttet undervisning",
      "shortName": "Tjenester tilkn. undervisning el.",
      "level": 5,
      "parentCode": "85.60"
    },
    {
      "code": "86.101",
      "name": "Alminnelige somatiske sykehus",
      "shortName": "Alminnelige somatiske sykehus",
      "level": 5,
      "parentCode": "86.10"
    },
    {
      "code": "86.102",
      "name": "Somatiske spesialsykehus",
      "shortName": "Somatiske spesialsykehus",
      "level": 5,
      "parentCode": "86.10"
    },
    {
      "code": "86.103",
      "name": "Andre somatiske spesialinstitusjoner",
      "shortName": "Andre somat. spesialinstitusjoner",
      "level": 5,
      "parentCode": "86.10"
    },
    {
      "code": "86.104",
      "name": "Institusjoner i psykisk helsevern for voksne",
      "shortName": "Inst. i psyk helsevern voksne",
      "level": 5,
      "parentCode": "86.10"
    },
    {
      "code": "86.105",
      "name": "Institusjoner i psykisk helsevern for barn og unge",
      "shortName": "Inst. psyk. helsevern barn/unge",
      "level": 5,
      "parentCode": "86.10"
    },
    {
      "code": "86.106",
      "name": "Rusmiddelinstitusjoner",
      "shortName": "Rusmiddelinstitusjoner",
      "level": 5,
      "parentCode": "86.10"
    },
    {
      "code": "86.107",
      "name": "Rehabiliterings- og opptreningsinstitusjoner",
      "shortName": "Rehab.- og opptreningsinstitusjoner",
      "level": 5,
      "parentCode": "86.10"
    },
    {
      "code": "86.211",
      "name": "Allmenn legetjeneste",
      "shortName": "Allmenn legetjeneste",
      "level": 5,
      "parentCode": "86.21"
    },
    {
      "code": "86.212",
      "name": "Somatiske poliklinikker",
      "shortName": "Somatiske poliklinikker",
      "level": 5,
      "parentCode": "86.21"
    },
    {
      "code": "86.221",
      "name": "Spesialisert legetjeneste, unntatt psykiatrisk legetjeneste",
      "shortName": "Spes.legetj., unnt. psykiatrisk",
      "level": 5,
      "parentCode": "86.22"
    },
    {
      "code": "86.222",
      "name": "Legetjenester innen psykisk helsevern",
      "shortName": "Legetj. innen psykisk helsevern",
      "level": 5,
      "parentCode": "86.22"
    },
    {
      "code": "86.223",
      "name": "Poliklinikker i psykisk helsevern for voksne",
      "shortName": "Poliklin. i psyk. helsevern voksne",
      "level": 5,
      "parentCode": "86.22"
    },
    {
      "code": "86.224",
      "name": "Poliklinikker i psykisk helsevern for barn og unge",
      "shortName": "Poliklin. i psyk. helsev. barn/unge",
      "level": 5,
      "parentCode": "86.22"
    },
    {
      "code": "86.225",
      "name": "Rusmiddelpoliklinikker",
      "shortName": "Rusmiddelpoliklinikker",
      "level": 5,
      "parentCode": "86.22"
    },
    {
      "code": "86.230",
      "name": "Tannhelsetjenester",
      "shortName": "Tannhelsetjenester",
      "level": 5,
      "parentCode": "86.23"
    },
    {
      "code": "86.901",
      "name": "Hjemmesykepleie",
      "shortName": "Hjemmesykepleie",
      "level": 5,
      "parentCode": "86.90"
    },
    {
      "code": "86.902",
      "name": "Fysioterapitjeneste",
      "shortName": "Fysioterapitjeneste",
      "level": 5,
      "parentCode": "86.90"
    },
    {
      "code": "86.903",
      "name": "Helsestasjons- og skolehelsetjeneste",
      "shortName": "Helsestasjons- og skolehelsetjeneste",
      "level": 5,
      "parentCode": "86.90"
    },
    {
      "code": "86.904",
      "name": "Annen forebyggende helsetjeneste",
      "shortName": "Annen forebyggende helsetjeneste",
      "level": 5,
      "parentCode": "86.90"
    },
    {
      "code": "86.905",
      "name": "Klinisk psykologtjeneste",
      "shortName": "Klinisk psykologtjeneste",
      "level": 5,
      "parentCode": "86.90"
    },
    {
      "code": "86.906",
      "name": "Medisinske laboratorietjenester",
      "shortName": "Medisinske laboratorietjenester",
      "level": 5,
      "parentCode": "86.90"
    },
    {
      "code": "86.907",
      "name": "Ambulansetjenester",
      "shortName": "Ambulansetjenester",
      "level": 5,
      "parentCode": "86.90"
    },
    {
      "code": "86.909",
      "name": "Andre helsetjenester",
      "shortName": "Andre helsetjenester",
      "level": 5,
      "parentCode": "86.90"
    },
    {
      "code": "87.101",
      "name": "Somatiske spesialsykehjem",
      "shortName": "Somatiske spesialsykehjem",
      "level": 5,
      "parentCode": "87.10"
    },
    {
      "code": "87.102",
      "name": "Somatiske sykehjem",
      "shortName": "Somatiske sykehjem",
      "level": 5,
      "parentCode": "87.10"
    },
    {
      "code": "87.201",
      "name": "Psykiatriske sykehjem",
      "shortName": "Psykiatriske sykehjem",
      "level": 5,
      "parentCode": "87.20"
    },
    {
      "code": "87.202",
      "name": "Omsorgsinstitusjoner for rusmiddelmisbrukere",
      "shortName": "Omsorgsinst. for rusmiddelmisbruk.",
      "level": 5,
      "parentCode": "87.20"
    },
    {
      "code": "87.203",
      "name": "Bofellesskap for psykisk utviklingshemmede",
      "shortName": "Bofellesskap for psyk utv.hemmede",
      "level": 5,
      "parentCode": "87.20"
    },
    {
      "code": "87.301",
      "name": "Aldershjem",
      "shortName": "Aldershjem",
      "level": 5,
      "parentCode": "87.30"
    },
    {
      "code": "87.302",
      "name": "Bofellesskap for eldre og funksjonshemmede med fast tilknyttet personell hele døgnet",
      "shortName": "Heldøgns pleie eldre/funksjonshem.",
      "level": 5,
      "parentCode": "87.30"
    },
    {
      "code": "87.303",
      "name": "Bofellesskap for eldre og funksjonshemmede med fast tilknyttet personell deler av døgnet",
      "shortName": "Deldøgns pleie eldre /funksj.hem.",
      "level": 5,
      "parentCode": "87.30"
    },
    {
      "code": "87.304",
      "name": "Avlastningsboliger/-institusjoner",
      "shortName": "Avlastningsboliger/-institusjoner",
      "level": 5,
      "parentCode": "87.30"
    },
    {
      "code": "87.305",
      "name": "Barneboliger",
      "shortName": "Barneboliger",
      "level": 5,
      "parentCode": "87.30"
    },
    {
      "code": "87.901",
      "name": "Institusjoner innen barne- og ungdomsvern",
      "shortName": "Inst for barne- og ungdomsvern",
      "level": 5,
      "parentCode": "87.90"
    },
    {
      "code": "87.909",
      "name": "Omsorgsinstitusjoner ellers",
      "shortName": "Omsorgsinstitusjoner ellers",
      "level": 5,
      "parentCode": "87.90"
    },
    {
      "code": "88.101",
      "name": "Hjemmehjelp",
      "shortName": "Hjemmehjelp",
      "level": 5,
      "parentCode": "88.10"
    },
    {
      "code": "88.102",
      "name": "Dagsentra/aktivitetssentra for eldre og funksjonshemmede",
      "shortName": "Akt.sentra eldre og funksjonshem.",
      "level": 5,
      "parentCode": "88.10"
    },
    {
      "code": "88.103",
      "name": "Eldresentre",
      "shortName": "Eldresentre",
      "level": 5,
      "parentCode": "88.10"
    },
    {
      "code": "88.911",
      "name": "Barnehager",
      "shortName": "Barnehager",
      "level": 5,
      "parentCode": "88.91"
    },
    {
      "code": "88.912",
      "name": "Barneparker og dagmammaer",
      "shortName": "Barneparker og dagmammaer",
      "level": 5,
      "parentCode": "88.91"
    },
    {
      "code": "88.913",
      "name": "Skolefritidsordninger",
      "shortName": "Skolefritidsordninger",
      "level": 5,
      "parentCode": "88.91"
    },
    {
      "code": "88.914",
      "name": "Fritidsklubber for barn og ungdom",
      "shortName": "Fritidsklubber for barn og ungdom",
      "level": 5,
      "parentCode": "88.91"
    },
    {
      "code": "88.991",
      "name": "Barneverntjenester",
      "shortName": "Barneverntjenester",
      "level": 5,
      "parentCode": "88.99"
    },
    {
      "code": "88.992",
      "name": "Familieverntjenester",
      "shortName": "Familieverntjenester",
      "level": 5,
      "parentCode": "88.99"
    },
    {
      "code": "88.993",
      "name": "Arbeidstrening for ordinært arbeidsmarked",
      "shortName": "Arb.trening for ordinært arb.marked",
      "level": 5,
      "parentCode": "88.99"
    },
    {
      "code": "88.994",
      "name": "Varig tilrettelagt arbeid",
      "shortName": "Varig tilrettelagt arbeid",
      "level": 5,
      "parentCode": "88.99"
    },
    {
      "code": "88.995",
      "name": "Sosiale velferdsorganisasjoner",
      "shortName": "Sosiale velferdsorganisasjoner",
      "level": 5,
      "parentCode": "88.99"
    },
    {
      "code": "88.996",
      "name": "Asylmottak",
      "shortName": "Asylmottak",
      "level": 5,
      "parentCode": "88.99"
    },
    {
      "code": "88.997",
      "name": "Sosialtjenester for rusmiddelmisbrukere uten botilbud",
      "shortName": "Sos.tj. rusmisbr. uten botilbud",
      "level": 5,
      "parentCode": "88.99"
    },
    {
      "code": "88.998",
      "name": "Kommunale sosialkontortjenester",
      "shortName": "Kommunale sosialkontortjenester",
      "level": 5,
      "parentCode": "88.99"
    },
    {
      "code": "88.999",
      "name": "Andre sosialtjenester uten botilbud",
      "shortName": "Andre sosialtjenester uten botilbud",
      "level": 5,
      "parentCode": "88.99"
    },
    {
      "code": "90.011",
      "name": "Utøvende kunstnere og underholdningsvirksomhet innen musikk",
      "shortName": "Utøv. kunstnere innen musikk",
      "level": 5,
      "parentCode": "90.01"
    },
    {
      "code": "90.012",
      "name": "Utøvende kunstnere og underholdningsvirksomhet innen scenekunst",
      "shortName": "Utøv. kunstnere innen scenekunst",
      "level": 5,
      "parentCode": "90.01"
    },
    {
      "code": "90.019",
      "name": "Utøvende kunstnere og underholdningsvirksomhet ikke nevnt annet sted",
      "shortName": "Utøv. kunstnere ellers",
      "level": 5,
      "parentCode": "90.01"
    },
    {
      "code": "90.020",
      "name": "Tjenester tilknyttet underholdningsvirksomhet",
      "shortName": "Tjen. tilkn. underholdningsvirks.",
      "level": 5,
      "parentCode": "90.02"
    },
    {
      "code": "90.031",
      "name": "Selvstendig kunstnerisk virksomhet innen visuell kunst",
      "shortName": "Selvst. kunst.virks. visuell kunst",
      "level": 5,
      "parentCode": "90.03"
    },
    {
      "code": "90.032",
      "name": "Selvstendig kunstnerisk virksomhet innen musikk",
      "shortName": "Selvst. kunst.virks. innen musikk",
      "level": 5,
      "parentCode": "90.03"
    },
    {
      "code": "90.033",
      "name": "Selvstendig kunstnerisk virksomhet innen scenekunst",
      "shortName": "Selvst. kunst.virks. scenekunst",
      "level": 5,
      "parentCode": "90.03"
    },
    {
      "code": "90.034",
      "name": "Selvstendig kunstnerisk virksomhet innen litteratur",
      "shortName": "Selvst. kunst.virks. litteratur",
      "level": 5,
      "parentCode": "90.03"
    },
    {
      "code": "90.035",
      "name": "Selvstendig kunstnerisk virksomhet innen blogging ",
      "shortName": "Selvstendig kunstnerisk virksomhet innen blogging ",
      "level": 5,
      "parentCode": "90.03"
    },
    {
      "code": "90.039",
      "name": "Selvstendig kunstnerisk virksomhet ikke nevnt annet sted",
      "shortName": "Annen selvst. kunstnerisk virks.",
      "level": 5,
      "parentCode": "90.03"
    },
    {
      "code": "90.040",
      "name": "Drift av lokaler tilknyttet kunstnerisk virksomhet",
      "shortName": "Drift lokaler tilkn. kunst.virks.",
      "level": 5,
      "parentCode": "90.04"
    },
    {
      "code": "91.011",
      "name": "Drift av folkebiblioteker",
      "shortName": "Drift av folkebiblioteker",
      "level": 5,
      "parentCode": "91.01"
    },
    {
      "code": "91.012",
      "name": "Drift av fag- og forskningsbiblioteker",
      "shortName": "Drift av fag-/forskningsbiblioteker",
      "level": 5,
      "parentCode": "91.01"
    },
    {
      "code": "91.013",
      "name": "Drift av arkiver",
      "shortName": "Drift av arkiver",
      "level": 5,
      "parentCode": "91.01"
    },
    {
      "code": "91.021",
      "name": "Drift av kunst- og kunstindustrimuseer",
      "shortName": "Drift av kunst-/kunstindustrimuseer",
      "level": 5,
      "parentCode": "91.02"
    },
    {
      "code": "91.022",
      "name": "Drift av kulturhistoriske museer",
      "shortName": "Drift av kulturhistoriske museer",
      "level": 5,
      "parentCode": "91.02"
    },
    {
      "code": "91.023",
      "name": "Drift av naturhistoriske museer",
      "shortName": "Drift av naturhistoriske museer",
      "level": 5,
      "parentCode": "91.02"
    },
    {
      "code": "91.029",
      "name": "Drift av museer ikke nevnt annet sted",
      "shortName": "Drift av museer ellers",
      "level": 5,
      "parentCode": "91.02"
    },
    {
      "code": "91.030",
      "name": "Drift av historiske steder og bygninger og lignende severdigheter",
      "shortName": "Drift av hist. steder og bygn. mv.",
      "level": 5,
      "parentCode": "91.03"
    },
    {
      "code": "91.040",
      "name": "Drift av botaniske og zoologiske hager og naturreservater",
      "shortName": "Drift av bot./zool. hager/naturres.",
      "level": 5,
      "parentCode": "91.04"
    },
    {
      "code": "92.000",
      "name": "Lotteri og totalisatorspill",
      "shortName": "Lotteri og totalisatorspill",
      "level": 5,
      "parentCode": "92.00"
    },
    {
      "code": "93.110",
      "name": "Drift av idrettsanlegg",
      "shortName": "Drift av idrettsanlegg",
      "level": 5,
      "parentCode": "93.11"
    },
    {
      "code": "93.120",
      "name": "Idrettslag og -klubber",
      "shortName": "Idrettslag og -klubber",
      "level": 5,
      "parentCode": "93.12"
    },
    {
      "code": "93.130",
      "name": "Treningssentre",
      "shortName": "Treningssentre",
      "level": 5,
      "parentCode": "93.13"
    },
    {
      "code": "93.190",
      "name": "Andre sportsaktiviteter",
      "shortName": "Andre sportsaktiviteter",
      "level": 5,
      "parentCode": "93.19"
    },
    {
      "code": "93.210",
      "name": "Drift av fornøyelses- og temaparker",
      "shortName": "Drift av fornøyelses- og temaparker",
      "level": 5,
      "parentCode": "93.21"
    },
    {
      "code": "93.291",
      "name": "Opplevelsesaktiviteter",
      "shortName": "Opplevelsesaktiviteter",
      "level": 5,
      "parentCode": "93.29"
    },
    {
      "code": "93.292",
      "name": "Fritidsetablissement",
      "shortName": "Fritidsetablissement",
      "level": 5,
      "parentCode": "93.29"
    },
    {
      "code": "93.299",
      "name": "Fritidsvirksomhet ellers",
      "shortName": "Firtidsvirksomhet ellers",
      "level": 5,
      "parentCode": "93.29"
    },
    {
      "code": "94.110",
      "name": "Næringslivs- og arbeidsgiverorganisasjoner",
      "shortName": "Næringslivs-/arbeidsgiverorg. mv.",
      "level": 5,
      "parentCode": "94.11"
    },
    {
      "code": "94.120",
      "name": "Yrkessammenslutninger",
      "shortName": "Yrkessammenslutninger",
      "level": 5,
      "parentCode": "94.12"
    },
    {
      "code": "94.200",
      "name": "Arbeidstakerorganisasjoner",
      "shortName": "Arbeidstakerorganisasjoner",
      "level": 5,
      "parentCode": "94.20"
    },
    {
      "code": "94.910",
      "name": "Religiøse organisasjoner",
      "shortName": "Religiøse organisasjoner",
      "level": 5,
      "parentCode": "94.91"
    },
    {
      "code": "94.920",
      "name": "Partipolitiske organisasjoner",
      "shortName": "Partipolitiske organisasjoner",
      "level": 5,
      "parentCode": "94.92"
    },
    {
      "code": "94.991",
      "name": "Aktiviteter i andre interesseorganisasjoner ikke nevnt annet sted",
      "shortName": "Interesseorganisasjoner ellers",
      "level": 5,
      "parentCode": "94.99"
    },
    {
      "code": "94.992",
      "name": "Fond/legat som støtter veldedige og allmennyttige formål",
      "shortName": "Fond/legat allmennyttige formål",
      "level": 5,
      "parentCode": "94.99"
    },
    {
      "code": "95.110",
      "name": "Reparasjon av datamaskiner og tilleggsutstyr",
      "shortName": "Rep. av datamask. og tilleggsutstyr",
      "level": 5,
      "parentCode": "95.11"
    },
    {
      "code": "95.120",
      "name": "Reparasjon av kommunikasjonsutstyr",
      "shortName": "Rep. av kommunikasjonsutstyr",
      "level": 5,
      "parentCode": "95.12"
    },
    {
      "code": "95.210",
      "name": "Reparasjon av elektronikk til husholdningsbruk",
      "shortName": "Rep. av elektronikk til hush.bruk",
      "level": 5,
      "parentCode": "95.21"
    },
    {
      "code": "95.220",
      "name": "Reparasjon av husholdningsvarer og hageredskaper",
      "shortName": "Rep. av hush.varer og hageredskaper",
      "level": 5,
      "parentCode": "95.22"
    },
    {
      "code": "95.230",
      "name": "Reparasjon av skotøy og lærvarer",
      "shortName": "Rep. av skotøy og lærvarer",
      "level": 5,
      "parentCode": "95.23"
    },
    {
      "code": "95.240",
      "name": "Reparasjon av møbler og boliginnredning",
      "shortName": "Rep. av møbler og boliginnredning",
      "level": 5,
      "parentCode": "95.24"
    },
    {
      "code": "95.250",
      "name": "Reparasjon av ur, gull- og sølvvarer",
      "shortName": "Rep. av ur, gull- og sølvvarer",
      "level": 5,
      "parentCode": "95.25"
    },
    {
      "code": "95.290",
      "name": "Reparasjon av andre husholdningsvarer og varer til personlig bruk",
      "shortName": "Rep. av husholdningsvarer el.",
      "level": 5,
      "parentCode": "95.29"
    },
    {
      "code": "96.010",
      "name": "Vaskeri- og renserivirksomhet",
      "shortName": "Vaskeri- og renserivirksomhet",
      "level": 5,
      "parentCode": "96.01"
    },
    {
      "code": "96.020",
      "name": "Frisering og annen skjønnhetspleie",
      "shortName": "Frisering og skjønnhetspleie el.",
      "level": 5,
      "parentCode": "96.02"
    },
    {
      "code": "96.030",
      "name": "Begravelsesbyråvirksomhet og drift av kirkegårder og krematorier",
      "shortName": "Begrav.byrå, kirkegårdsdrift mv..",
      "level": 5,
      "parentCode": "96.03"
    },
    {
      "code": "96.040",
      "name": "Virksomhet knyttet til kroppspleie og fysisk velvære",
      "shortName": "Helsestudiovirksomhet mv.",
      "level": 5,
      "parentCode": "96.04"
    },
    {
      "code": "96.090",
      "name": "Personlig tjenesteyting ikke nevnt annet sted",
      "shortName": "Personlig tjenesteyting el.",
      "level": 5,
      "parentCode": "96.09"
    },
    {
      "code": "97.000",
      "name": "Lønnet arbeid i private husholdninger",
      "shortName": "Lønnet arbeid i private husholdn.",
      "level": 5,
      "parentCode": "97.00"
    },
    {
      "code": "99.000",
      "name": "Internasjonale organisasjoner og organer",
      "shortName": "Internasjonale organer",
      "level": 5,
      "parentCode": "99.00"
    }
  ],
  "all": [
    {
      "code": "A",
      "name": "Jordbruk, skogbruk og fiske",
      "shortName": "Jordbruk, skogbruk og fiske",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "B",
      "name": "Bergverksdrift og utvinning",
      "shortName": "Bergverksdrift og utvinning",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "C",
      "name": "Industri",
      "shortName": "Industri",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "D",
      "name": "Elektrisitets-, gass-, damp- og varmtvannsforsyning",
      "shortName": "Kraftforsyning",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "E",
      "name": "Vannforsyning, avløps- og renovasjonsvirksomhet",
      "shortName": "Vann, avløp, renovasjon",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "F",
      "name": "Bygge- og anleggsvirksomhet",
      "shortName": "Bygge- og anleggsvirksomhet",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "G",
      "name": "Varehandel, reparasjon av motorvogner",
      "shortName": "Varehandel, bilverksteder",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "H",
      "name": "Transport og lagring",
      "shortName": "Transport og lagring",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "I",
      "name": "Overnattings- og serveringsvirksomhet",
      "shortName": "Overnattings- og serveringsvirks.",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "J",
      "name": "Informasjon og kommunikasjon",
      "shortName": "Informasjon og kommunikasjon",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "K",
      "name": "Finansierings- og forsikringsvirksomhet",
      "shortName": "Finansiering og forsikring",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "L",
      "name": "Omsetning og drift av fast eiendom",
      "shortName": "Omsetning og drift av fast eiendom",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "M",
      "name": "Faglig, vitenskapelig og teknisk tjenesteyting",
      "shortName": "Faglig, vit. og tekn. tjenesteyting",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "N",
      "name": "Forretningsmessig tjenesteyting",
      "shortName": "Forretningsmessig tjenesteyting",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "O",
      "name": "Offentlig administrasjon og forsvar, og trygdeordninger underlagt offentlig forvaltning",
      "shortName": "Off.adm., forsvar, sosialforsikring",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "P",
      "name": "Undervisning",
      "shortName": "Undervisning",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "Q",
      "name": "Helse- og sosialtjenester",
      "shortName": "Helse- og sosialtjenester",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "R",
      "name": "Kulturell virksomhet, underholdning og fritidsaktiviteter",
      "shortName": "Kultur, underholdning og fritid",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "S",
      "name": "Annen tjenesteyting",
      "shortName": "Annen tjenesteyting",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "T",
      "name": "Lønnet arbeid i private husholdninger",
      "shortName": "Lønnet arbeid i private husholdn.",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "U",
      "name": "Internasjonale organisasjoner og organer",
      "shortName": "Internasjonale organer",
      "level": 1,
      "parentCode": ""
    },
    {
      "code": "01",
      "name": "Jordbruk og tjenester tilknyttet jordbruk, jakt og viltstell",
      "shortName": "Jordbruk, tilhør. tjenester, jakt",
      "level": 2,
      "parentCode": "A"
    },
    {
      "code": "02",
      "name": "Skogbruk og tjenester tilknyttet skogbruk",
      "shortName": "Skogbruk og tilhørende tjenester",
      "level": 2,
      "parentCode": "A"
    },
    {
      "code": "03",
      "name": "Fiske, fangst og akvakultur",
      "shortName": "Fiske, fangst og akvakultur",
      "level": 2,
      "parentCode": "A"
    },
    {
      "code": "05",
      "name": "Bryting av steinkull og brunkull",
      "shortName": "Bryting av steinkull og brunkull",
      "level": 2,
      "parentCode": "B"
    },
    {
      "code": "06",
      "name": "Utvinning av råolje og naturgass",
      "shortName": "Utvinning av råolje og naturgass",
      "level": 2,
      "parentCode": "B"
    },
    {
      "code": "07",
      "name": "Bryting av metallholdig malm",
      "shortName": "Bryting av metallholdig malm",
      "level": 2,
      "parentCode": "B"
    },
    {
      "code": "08",
      "name": "Bryting og bergverksdrift ellers",
      "shortName": "Bryting og bergverksdrift ellers",
      "level": 2,
      "parentCode": "B"
    },
    {
      "code": "09",
      "name": "Tjenester tilknyttet bergverksdrift og utvinning",
      "shortName": "Tjenester til bergverk og utvinning",
      "level": 2,
      "parentCode": "B"
    },
    {
      "code": "10",
      "name": "Produksjon av nærings- og nytelsesmidler",
      "shortName": "Næringsmiddelindustri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "11",
      "name": "Produksjon av drikkevarer",
      "shortName": "Drikkevareindustri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "12",
      "name": "Produksjon av tobakksvarer",
      "shortName": "Tobakksindustri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "13",
      "name": "Produksjon av tekstiler",
      "shortName": "Tekstilindustri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "14",
      "name": "Produksjon av klær",
      "shortName": "Bekledningsindustri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "15",
      "name": "Produksjon av lær og lærvarer",
      "shortName": "Lær- og lærvareindustri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "16",
      "name": "Produksjon av trelast og varer av tre, kork, strå og flettematerialer, unntatt møbler",
      "shortName": "Trelast- og trevareindustri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "17",
      "name": "Produksjon av papir og papirvarer",
      "shortName": "Papir- og papirvareindustri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "18",
      "name": "Trykking og reproduksjon av innspilte opptak",
      "shortName": "Trykking, grafisk industri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "19",
      "name": "Produksjon av kull- og raffinerte petroleumsprodukter",
      "shortName": "Petroleums- og kullvareindustri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "20",
      "name": "Produksjon av kjemikalier og kjemiske produkter",
      "shortName": "Kjemisk industri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "21",
      "name": "Produksjon av farmasøytiske råvarer og preparater",
      "shortName": "Farmasøytisk industri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "22",
      "name": "Produksjon av gummi- og plastprodukter",
      "shortName": "Gummivare- og plastindustri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "23",
      "name": "Produksjon av andre ikke-metallholdige mineralprodukter",
      "shortName": "Mineralproduktindustri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "24",
      "name": "Produksjon av metaller",
      "shortName": "Metallindustri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "25",
      "name": "Produksjon av metallvarer, unntatt maskiner og utstyr",
      "shortName": "Metallvareindustri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "26",
      "name": "Produksjon av datamaskiner og elektroniske og optiske produkter",
      "shortName": "Data- og elektronisk industri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "27",
      "name": "Produksjon av elektrisk utstyr",
      "shortName": "Elektroteknisk industri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "28",
      "name": "Produksjon av maskiner og utstyr til generell bruk, ikke nevnt annet sted",
      "shortName": "Maskinindustri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "29",
      "name": "Produksjon av motorvogner og tilhengere",
      "shortName": "Motorkjøretøyindustri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "30",
      "name": "Produksjon av andre transportmidler",
      "shortName": "Transportmiddelindustri ellers",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "31",
      "name": "Produksjon av møbler",
      "shortName": "Møbelindustri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "32",
      "name": "Annen industriproduksjon",
      "shortName": "Annen industri",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "33",
      "name": "Reparasjon og installasjon av maskiner og utstyr",
      "shortName": "Maskinreparasjon og -installasjon",
      "level": 2,
      "parentCode": "C"
    },
    {
      "code": "35",
      "name": "Elektrisitets-, gass-, damp- og varmtvannsforsyning",
      "shortName": "Kraftforsyning",
      "level": 2,
      "parentCode": "D"
    },
    {
      "code": "36",
      "name": "Uttak fra kilde, rensing og distribusjon av vann",
      "shortName": "Vannforsyning",
      "level": 2,
      "parentCode": "E"
    },
    {
      "code": "37",
      "name": "Oppsamling og behandling av avløpsvann",
      "shortName": "Håndtering av avløpsvann",
      "level": 2,
      "parentCode": "E"
    },
    {
      "code": "38",
      "name": "Innsamling, behandling, disponering og gjenvinning av avfall",
      "shortName": "Avfallshåndtering",
      "level": 2,
      "parentCode": "E"
    },
    {
      "code": "39",
      "name": "Miljørydding, miljørensing og lignende virksomhet",
      "shortName": "Miljørydding og miljørensing",
      "level": 2,
      "parentCode": "E"
    },
    {
      "code": "41",
      "name": "Oppføring av bygninger",
      "shortName": "Oppføring av bygninger",
      "level": 2,
      "parentCode": "F"
    },
    {
      "code": "42",
      "name": "Anleggsvirksomhet",
      "shortName": "Anleggsvirksomhet",
      "level": 2,
      "parentCode": "F"
    },
    {
      "code": "43",
      "name": "Spesialisert bygge- og anleggsvirksomhet",
      "shortName": "Spes. bygge- og anleggsvirksomhet",
      "level": 2,
      "parentCode": "F"
    },
    {
      "code": "45",
      "name": "Handel med og reparasjon av motorvogner",
      "shortName": "Kjøretøyreparasjoner og -handel",
      "level": 2,
      "parentCode": "G"
    },
    {
      "code": "46",
      "name": "Agentur- og engroshandel, unntatt med motorvogner",
      "shortName": "Agentur- og engroshandel",
      "level": 2,
      "parentCode": "G"
    },
    {
      "code": "47",
      "name": "Detaljhandel, unntatt med motorvogner",
      "shortName": "Detaljhandel, unntatt motorvogner",
      "level": 2,
      "parentCode": "G"
    },
    {
      "code": "49",
      "name": "Landtransport og rørtransport",
      "shortName": "Landtransport og rørtransport",
      "level": 2,
      "parentCode": "H"
    },
    {
      "code": "50",
      "name": "Sjøfart",
      "shortName": "Sjøfart",
      "level": 2,
      "parentCode": "H"
    },
    {
      "code": "51",
      "name": "Lufttransport",
      "shortName": "Lufttransport",
      "level": 2,
      "parentCode": "H"
    },
    {
      "code": "52",
      "name": "Lagring og andre tjenester tilknyttet transport",
      "shortName": "Transporttjenester og lagring",
      "level": 2,
      "parentCode": "H"
    },
    {
      "code": "53",
      "name": "Post og distribusjonsvirksomhet",
      "shortName": "Post og distribusjonsvirksomhet",
      "level": 2,
      "parentCode": "H"
    },
    {
      "code": "55",
      "name": "Overnattingsvirksomhet",
      "shortName": "Overnattingsvirksomhet",
      "level": 2,
      "parentCode": "I"
    },
    {
      "code": "56",
      "name": "Serveringsvirksomhet",
      "shortName": "Serveringsvirksomhet",
      "level": 2,
      "parentCode": "I"
    },
    {
      "code": "58",
      "name": "Forlagsvirksomhet",
      "shortName": "Forlagsvirksomhet",
      "level": 2,
      "parentCode": "J"
    },
    {
      "code": "59",
      "name": "Film-, video- og fjernsynsprogramproduksjon, utgivelse av musikk- og lydopptak",
      "shortName": "Film- og TV-prod., musikkutgivelse",
      "level": 2,
      "parentCode": "J"
    },
    {
      "code": "60",
      "name": "Radio- og fjernsynskringkasting",
      "shortName": "Radio- og fjernsynskringkasting",
      "level": 2,
      "parentCode": "J"
    },
    {
      "code": "61",
      "name": "Telekommunikasjon",
      "shortName": "Telekommunikasjon",
      "level": 2,
      "parentCode": "J"
    },
    {
      "code": "62",
      "name": "Tjenester tilknyttet informasjonsteknologi",
      "shortName": "IT-tjenester",
      "level": 2,
      "parentCode": "J"
    },
    {
      "code": "63",
      "name": "Informasjonstjenester",
      "shortName": "Informasjonstjenester",
      "level": 2,
      "parentCode": "J"
    },
    {
      "code": "64",
      "name": "Finansieringsvirksomhet",
      "shortName": "Finansieringsvirksomhet",
      "level": 2,
      "parentCode": "K"
    },
    {
      "code": "65",
      "name": "Forsikringsvirksomhet og pensjonskasser, unntatt trygdeordninger underlagt offentlig forvaltning",
      "shortName": "Forsikring og pensjonskasser",
      "level": 2,
      "parentCode": "K"
    },
    {
      "code": "66",
      "name": "Tjenester tilknyttet finansierings- og forsikringsvirksomhet",
      "shortName": "Finans-, forsikringshjelpetjenester",
      "level": 2,
      "parentCode": "K"
    },
    {
      "code": "68",
      "name": "Omsetning og drift av fast eiendom",
      "shortName": "Omsetning og drift av fast eiendom",
      "level": 2,
      "parentCode": "L"
    },
    {
      "code": "69",
      "name": "Juridisk og regnskapsmessig tjenesteyting",
      "shortName": "Juridisk og regnsk.messig tj.yting",
      "level": 2,
      "parentCode": "M"
    },
    {
      "code": "70",
      "name": "Hovedkontortjenester, administrativ rådgivning",
      "shortName": "Hovedkontortjen. og adm. rådgivning",
      "level": 2,
      "parentCode": "M"
    },
    {
      "code": "71",
      "name": "Arkitektvirksomhet og teknisk konsulentvirksomhet, og teknisk prøving og analyse",
      "shortName": "Arkitekter og tekniske konsulenter",
      "level": 2,
      "parentCode": "M"
    },
    {
      "code": "72",
      "name": "Forskning og utviklingsarbeid",
      "shortName": "Forskning og utviklingsarbeid",
      "level": 2,
      "parentCode": "M"
    },
    {
      "code": "73",
      "name": "Annonse- og reklamevirksomhet og markedsundersøkelser",
      "shortName": "Reklamevirksomhet og markedsund.",
      "level": 2,
      "parentCode": "M"
    },
    {
      "code": "74",
      "name": "Annen faglig, vitenskapelig og teknisk virksomhet",
      "shortName": "Fagl., vit. og tekn. virks. ellers",
      "level": 2,
      "parentCode": "M"
    },
    {
      "code": "75",
      "name": "Veterinærtjenester",
      "shortName": "Veterinærtjenester",
      "level": 2,
      "parentCode": "M"
    },
    {
      "code": "77",
      "name": "Utleie- og leasingvirksomhet",
      "shortName": "Utleie- og leasingvirksomhet",
      "level": 2,
      "parentCode": "N"
    },
    {
      "code": "78",
      "name": "Arbeidskrafttjenester",
      "shortName": "Arbeidskrafttjenester",
      "level": 2,
      "parentCode": "N"
    },
    {
      "code": "79",
      "name": "Reisebyrå- og reisearrangørvirksomhet og tilknyttede tjenester",
      "shortName": "Reisebyråer og reisearrangører",
      "level": 2,
      "parentCode": "N"
    },
    {
      "code": "80",
      "name": "Vakttjeneste og etterforsking",
      "shortName": "Vakttjeneste og etterforsking",
      "level": 2,
      "parentCode": "N"
    },
    {
      "code": "81",
      "name": "Tjenester tilknyttet eiendomsdrift",
      "shortName": "Tjenester tilknyttet eiendomsdrift",
      "level": 2,
      "parentCode": "N"
    },
    {
      "code": "82",
      "name": "Annen forretningsmessig tjenesteyting",
      "shortName": "Forretningsm. tjenesteyt. ellers",
      "level": 2,
      "parentCode": "N"
    },
    {
      "code": "84",
      "name": "Offentlig administrasjon og forsvar, og trygdeordninger underlagt offentlig forvaltning",
      "shortName": "Off.adm., forsvar, sosialforsikring",
      "level": 2,
      "parentCode": "O"
    },
    {
      "code": "85",
      "name": "Undervisning",
      "shortName": "Undervisning",
      "level": 2,
      "parentCode": "P"
    },
    {
      "code": "86",
      "name": "Helsetjenester",
      "shortName": "Helsetjenester",
      "level": 2,
      "parentCode": "Q"
    },
    {
      "code": "87",
      "name": "Pleie- og omsorgstjenester i institusjon",
      "shortName": "Pleie og omsorg i institusjon",
      "level": 2,
      "parentCode": "Q"
    },
    {
      "code": "88",
      "name": "Sosiale omsorgstjenester uten botilbud",
      "shortName": "Omsorg uten botilbud, barnehager mv.",
      "level": 2,
      "parentCode": "Q"
    },
    {
      "code": "90",
      "name": "Kunstnerisk virksomhet og underholdningsvirksomhet",
      "shortName": "Kunstnerisk virks. og underholdning",
      "level": 2,
      "parentCode": "R"
    },
    {
      "code": "91",
      "name": "Drift av biblioteker, arkiver, museer og annen kulturvirksomhet",
      "shortName": "Bibliotek, muséer o.a. kulturvirks.",
      "level": 2,
      "parentCode": "R"
    },
    {
      "code": "92",
      "name": "Lotteri og totalisatorspill",
      "shortName": "Lotteri og totalisatorspill",
      "level": 2,
      "parentCode": "R"
    },
    {
      "code": "93",
      "name": "Sports- og fritidsaktiviteter og drift av fornøyelsesetablissementer",
      "shortName": "Sports- og fritidsaktiviteter",
      "level": 2,
      "parentCode": "R"
    },
    {
      "code": "94",
      "name": "Aktiviteter i medlemsorganisasjoner",
      "shortName": "Aktiviteter i medlemsorgansiasjoner",
      "level": 2,
      "parentCode": "S"
    },
    {
      "code": "95",
      "name": "Reparasjon av datamaskiner, husholdningsvarer og varer til personlig bruk",
      "shortName": "Reparasjon av varer til pers. bruk",
      "level": 2,
      "parentCode": "S"
    },
    {
      "code": "96",
      "name": "Annen personlig tjenesteyting",
      "shortName": "Annen personlig tjenesteyting",
      "level": 2,
      "parentCode": "S"
    },
    {
      "code": "97",
      "name": "Lønnet arbeid i private husholdninger",
      "shortName": "Lønnet arbeid i private husholdn.",
      "level": 2,
      "parentCode": "T"
    },
    {
      "code": "99",
      "name": "Internasjonale organisasjoner og organer",
      "shortName": "Internasjonale organer",
      "level": 2,
      "parentCode": "U"
    },
    {
      "code": "01.1",
      "name": "Dyrking av ettårige vekster",
      "shortName": "Dyrking av ettårige vekster",
      "level": 3,
      "parentCode": "01"
    },
    {
      "code": "01.2",
      "name": "Dyrking av flerårige vekster",
      "shortName": "Dyrking av flerårige vekster",
      "level": 3,
      "parentCode": "01"
    },
    {
      "code": "01.3",
      "name": "Planteformering",
      "shortName": "Planteformering",
      "level": 3,
      "parentCode": "01"
    },
    {
      "code": "01.4",
      "name": "Husdyrhold",
      "shortName": "Husdyrhold",
      "level": 3,
      "parentCode": "01"
    },
    {
      "code": "01.5",
      "name": "Kombinert husdyrhold og planteproduksjon",
      "shortName": "Komb. husdyrhold og planteprod.",
      "level": 3,
      "parentCode": "01"
    },
    {
      "code": "01.6",
      "name": "Tjenester tilknyttet jordbruk og etterbehandling av vekster etter innhøsting",
      "shortName": "Tjenester tilknyttet jordbruk",
      "level": 3,
      "parentCode": "01"
    },
    {
      "code": "01.7",
      "name": "Jakt, viltstell og tjenester tilknyttet jakt og viltstell",
      "shortName": "Jakt, viltstell og tilkn. tjenester",
      "level": 3,
      "parentCode": "01"
    },
    {
      "code": "02.1",
      "name": "Skogskjøtsel og andre skogbruksaktiviteter",
      "shortName": "Skogskjøtsel, andre skogbruksakt.",
      "level": 3,
      "parentCode": "02"
    },
    {
      "code": "02.2",
      "name": "Avvirkning",
      "shortName": "Avvirkning",
      "level": 3,
      "parentCode": "02"
    },
    {
      "code": "02.3",
      "name": "Innsamling av viltvoksende produkter av annet enn tre",
      "shortName": "Innsaml. av sopp, bær, mose etc.",
      "level": 3,
      "parentCode": "02"
    },
    {
      "code": "02.4",
      "name": "Tjenester tilknyttet skogbruk",
      "shortName": "Tjenester tilknyttet skogbruk",
      "level": 3,
      "parentCode": "02"
    },
    {
      "code": "03.1",
      "name": "Fiske og fangst",
      "shortName": "Fiske og fangst",
      "level": 3,
      "parentCode": "03"
    },
    {
      "code": "03.2",
      "name": "Akvakultur",
      "shortName": "Akvakultur",
      "level": 3,
      "parentCode": "03"
    },
    {
      "code": "05.1",
      "name": "Bryting av steinkull",
      "shortName": "Bryting av steinkull",
      "level": 3,
      "parentCode": "05"
    },
    {
      "code": "05.2",
      "name": "Bryting av brunkull",
      "shortName": "Bryting av brunkull",
      "level": 3,
      "parentCode": "05"
    },
    {
      "code": "06.1",
      "name": "Utvinning av råolje",
      "shortName": "Utvinning av råolje",
      "level": 3,
      "parentCode": "06"
    },
    {
      "code": "06.2",
      "name": "Utvinning av naturgass",
      "shortName": "Utvinning av naturgass",
      "level": 3,
      "parentCode": "06"
    },
    {
      "code": "07.1",
      "name": "Bryting av jernmalm",
      "shortName": "Bryting av jernmalm",
      "level": 3,
      "parentCode": "07"
    },
    {
      "code": "07.2",
      "name": "Bryting av ikke-jernholdig malm",
      "shortName": "Bryting av ikke-jernholdig malm",
      "level": 3,
      "parentCode": "07"
    },
    {
      "code": "08.1",
      "name": "Bryting av stein, utvinning av sand og leire",
      "shortName": "Bryt. av stein, utv. av sand, leire",
      "level": 3,
      "parentCode": "08"
    },
    {
      "code": "08.9",
      "name": "Annen bryting og utvinning",
      "shortName": "Annen bryting og utvinning",
      "level": 3,
      "parentCode": "08"
    },
    {
      "code": "09.1",
      "name": "Tjenester tilknyttet utvinning av råolje og naturgass",
      "shortName": "Utvinningstjenester",
      "level": 3,
      "parentCode": "09"
    },
    {
      "code": "09.9",
      "name": "Tjenester tilknyttet annen bergverksdrift",
      "shortName": "Bergverkstjenester",
      "level": 3,
      "parentCode": "09"
    },
    {
      "code": "10.1",
      "name": "Produksjon, bearbeiding og konservering av kjøtt og kjøttvarer",
      "shortName": "Bearbeiding kjøtt og kjøttvarer",
      "level": 3,
      "parentCode": "10"
    },
    {
      "code": "10.2",
      "name": "Bearbeiding og konservering av fisk, skalldyr og bløtdyr",
      "shortName": "Bearbeiding fisk, skalldyr, bløtdyr",
      "level": 3,
      "parentCode": "10"
    },
    {
      "code": "10.3",
      "name": "Bearbeiding og konservering av frukt og grønnsaker",
      "shortName": "Bearbeiding frukt og grønnsaker",
      "level": 3,
      "parentCode": "10"
    },
    {
      "code": "10.4",
      "name": "Produksjon av vegetabilske og animalske oljer og fettstoffer",
      "shortName": "Produksjon oljer og fettstoff",
      "level": 3,
      "parentCode": "10"
    },
    {
      "code": "10.5",
      "name": "Produksjon av meierivarer og iskrem",
      "shortName": "Produksjon av meierivarer og iskrem",
      "level": 3,
      "parentCode": "10"
    },
    {
      "code": "10.6",
      "name": "Produksjon av kornvarer, stivelse og stivelsesprodukter",
      "shortName": "Produksjon kornvarer, stivelse mv.",
      "level": 3,
      "parentCode": "10"
    },
    {
      "code": "10.7",
      "name": "Produksjon av bakeri- og pastavarer",
      "shortName": "Produksjon av bakeri- og pastavarer",
      "level": 3,
      "parentCode": "10"
    },
    {
      "code": "10.8",
      "name": "Produksjon av andre næringsmidler",
      "shortName": "Produksjon av andre næringsmidler",
      "level": 3,
      "parentCode": "10"
    },
    {
      "code": "10.9",
      "name": "Produksjon av fôrvarer",
      "shortName": "Produksjon av fôrvarer",
      "level": 3,
      "parentCode": "10"
    },
    {
      "code": "11.0",
      "name": "Produksjon av drikkevarer",
      "shortName": "Produksjon av drikkevarer",
      "level": 3,
      "parentCode": "11"
    },
    {
      "code": "12.0",
      "name": "Produksjon av tobakksvarer",
      "shortName": "Tobakksindustri",
      "level": 3,
      "parentCode": "12"
    },
    {
      "code": "13.1",
      "name": "Bearbeiding og spinning av tekstilfibrer",
      "shortName": "Bearb./spinning av tekstilfibrer",
      "level": 3,
      "parentCode": "13"
    },
    {
      "code": "13.2",
      "name": "Veving av tekstiler",
      "shortName": "Veving av tekstiler",
      "level": 3,
      "parentCode": "13"
    },
    {
      "code": "13.3",
      "name": "Etterbehandling av tekstiler",
      "shortName": "Etterbehandling av tekstiler",
      "level": 3,
      "parentCode": "13"
    },
    {
      "code": "13.9",
      "name": "Produksjon av andre tekstiler",
      "shortName": "Produksjon av andre tekstiler",
      "level": 3,
      "parentCode": "13"
    },
    {
      "code": "14.1",
      "name": "Produksjon av klær, unntatt pelsvarer",
      "shortName": "Produksjon av klær, unnt. pelsvarer",
      "level": 3,
      "parentCode": "14"
    },
    {
      "code": "14.2",
      "name": "Produksjon av pelsvarer",
      "shortName": "Produksjon av pelsvarer",
      "level": 3,
      "parentCode": "14"
    },
    {
      "code": "14.3",
      "name": "Produksjon av klær av trikotasje",
      "shortName": "Prod. av klær av trikotasje",
      "level": 3,
      "parentCode": "14"
    },
    {
      "code": "15.1",
      "name": "Beredning av lær, produksjon av reiseeffekter og salmakerartikler og beredning og farging av pelsskinn",
      "shortName": "Bered. lær, prod. av reiseeff. mv.",
      "level": 3,
      "parentCode": "15"
    },
    {
      "code": "15.2",
      "name": "Produksjon av skotøy",
      "shortName": "Produksjon av skotøy",
      "level": 3,
      "parentCode": "15"
    },
    {
      "code": "16.1",
      "name": "Saging, høvling og impregnering av tre",
      "shortName": "Saging, høvling mv. av tre",
      "level": 3,
      "parentCode": "16"
    },
    {
      "code": "16.2",
      "name": "Produksjon av varer av tre, kork, strå og flettematerialer",
      "shortName": "Produksjon trevarer, kork mv.",
      "level": 3,
      "parentCode": "16"
    },
    {
      "code": "17.1",
      "name": "Produksjon av papirmasse, papir og papp",
      "shortName": "Prod. av papirmasse, papir og papp",
      "level": 3,
      "parentCode": "17"
    },
    {
      "code": "17.2",
      "name": "Produksjon av varer av papir og papp",
      "shortName": "Produksjon av varer av papir og papp",
      "level": 3,
      "parentCode": "17"
    },
    {
      "code": "18.1",
      "name": "Trykking og tjenester tilknyttet trykking",
      "shortName": "Trykking, tilhørende tjenester",
      "level": 3,
      "parentCode": "18"
    },
    {
      "code": "18.2",
      "name": "Reproduksjon av innspilte opptak",
      "shortName": "Reproduksjon av innspilte opptak",
      "level": 3,
      "parentCode": "18"
    },
    {
      "code": "19.1",
      "name": "Produksjon av kullprodukter",
      "shortName": "Produksjon av kullprodukter",
      "level": 3,
      "parentCode": "19"
    },
    {
      "code": "19.2",
      "name": "Produksjon av raffinerte petroleumsprodukter",
      "shortName": "Prod. raffinerte petroleumsprodukt",
      "level": 3,
      "parentCode": "19"
    },
    {
      "code": "20.1",
      "name": "Produksjon av kjemiske råvarer, gjødsel og nitrogenforbindelser, basisplast og syntetisk gummi",
      "shortName": "Produksjon kjemiske råvarer mv.",
      "level": 3,
      "parentCode": "20"
    },
    {
      "code": "20.2",
      "name": "Produksjon av plantevern- og skadedyrmidler og andre landbrukskjemiske produkter",
      "shortName": "Produksjon landbrukskjemiske prod.",
      "level": 3,
      "parentCode": "20"
    },
    {
      "code": "20.3",
      "name": "Produksjon av maling og lakk, trykkfarger og tetningsmidler",
      "shortName": "Produksjon maling, lakk mv.",
      "level": 3,
      "parentCode": "20"
    },
    {
      "code": "20.4",
      "name": "Produksjon av såpe og vaskemidler, rense- og polermidler, parfyme og toalettartikler",
      "shortName": "Produksjon vaske- og toalettartikler",
      "level": 3,
      "parentCode": "20"
    },
    {
      "code": "20.5",
      "name": "Produksjon av andre kjemiske produkter",
      "shortName": "Produksjon andre kjemiske prod.",
      "level": 3,
      "parentCode": "20"
    },
    {
      "code": "20.6",
      "name": "Produksjon av kunstfibrer",
      "shortName": "Produksjon av kunstfibrer",
      "level": 3,
      "parentCode": "20"
    },
    {
      "code": "21.1",
      "name": "Produksjon av farmasøytiske råvarer",
      "shortName": "Farmasøytiske råvarer",
      "level": 3,
      "parentCode": "21"
    },
    {
      "code": "21.2",
      "name": "Produksjon av farmasøytiske preparater",
      "shortName": "Farmasøytiske preparater",
      "level": 3,
      "parentCode": "21"
    },
    {
      "code": "22.1",
      "name": "Produksjon av gummiprodukter",
      "shortName": "Produksjon av gummiprodukter",
      "level": 3,
      "parentCode": "22"
    },
    {
      "code": "22.2",
      "name": "Produksjon av plastprodukter",
      "shortName": "Produksjon av plastprodukter",
      "level": 3,
      "parentCode": "22"
    },
    {
      "code": "23.1",
      "name": "Produksjon av glass og glassprodukter",
      "shortName": "Produksjon av glass og glassprodukter",
      "level": 3,
      "parentCode": "23"
    },
    {
      "code": "23.2",
      "name": "Produksjon av ildfaste produkter",
      "shortName": "Prod. av ildfaste produkter",
      "level": 3,
      "parentCode": "23"
    },
    {
      "code": "23.3",
      "name": "Produksjon av byggevarer av brent leire",
      "shortName": "Prod. av byggevarer av brent leire",
      "level": 3,
      "parentCode": "23"
    },
    {
      "code": "23.4",
      "name": "Produksjon av andre porselensprodukter og keramiske produkter",
      "shortName": "Prod. av porselens-/keram.prod. el.",
      "level": 3,
      "parentCode": "23"
    },
    {
      "code": "23.5",
      "name": "Produksjon av sement, kalk og gips",
      "shortName": "Produksjon av sement, kalk og gips",
      "level": 3,
      "parentCode": "23"
    },
    {
      "code": "23.6",
      "name": "Produksjon av betong-, sement- og gipsprodukter",
      "shortName": "Prod. av betong-/sement-/gipsprod.",
      "level": 3,
      "parentCode": "23"
    },
    {
      "code": "23.7",
      "name": "Hogging og bearbeiding av monument- og bygningsstein",
      "shortName": "Hogg./bearb. av monum.-/bygn.stein",
      "level": 3,
      "parentCode": "23"
    },
    {
      "code": "23.9",
      "name": "Produksjon av ikke-metallholdige mineralprodukter ikke nevnt annet sted",
      "shortName": "Prod. ikke-metallholdige mineralprod.",
      "level": 3,
      "parentCode": "23"
    },
    {
      "code": "24.1",
      "name": "Produksjon av jern og stål, samt ferrolegeringer",
      "shortName": "Produksjon jern, stål, ferroleger.",
      "level": 3,
      "parentCode": "24"
    },
    {
      "code": "24.2",
      "name": "Produksjon av andre rør og rørdeler av stål",
      "shortName": "Annen rør- og rørdelprod. av stål",
      "level": 3,
      "parentCode": "24"
    },
    {
      "code": "24.3",
      "name": "Annen bearbeiding av jern og stål",
      "shortName": "Annen bearbeiding av jern og stål",
      "level": 3,
      "parentCode": "24"
    },
    {
      "code": "24.4",
      "name": "Produksjon av ikke-jernholdige metaller",
      "shortName": "Prod. av ikke-jernh. metaller",
      "level": 3,
      "parentCode": "24"
    },
    {
      "code": "24.5",
      "name": "Støping av metaller",
      "shortName": "Støping av metaller",
      "level": 3,
      "parentCode": "24"
    },
    {
      "code": "25.1",
      "name": "Produksjon av metallkonstruksjoner",
      "shortName": "Produksjon av metallkonstruksjoner",
      "level": 3,
      "parentCode": "25"
    },
    {
      "code": "25.2",
      "name": "Produksjon av tanker, cisterner og andre beholdere av metall",
      "shortName": "Tanker, cisterner, sentralvarmeanl.",
      "level": 3,
      "parentCode": "25"
    },
    {
      "code": "25.3",
      "name": "Produksjon av dampkjeler, unntatt kjeler til sentralvarmeanlegg",
      "shortName": "Dampkjeler unnt. sentralvarmeanl",
      "level": 3,
      "parentCode": "25"
    },
    {
      "code": "25.4",
      "name": "Produksjon av våpen og ammunisjon",
      "shortName": "Våpen- og ammunisjonsproduksjon",
      "level": 3,
      "parentCode": "25"
    },
    {
      "code": "25.5",
      "name": "Smiing, stansing og valsing av metall, og pulvermetallurgi",
      "shortName": "Stansing/valsing/pulvermetallurgi",
      "level": 3,
      "parentCode": "25"
    },
    {
      "code": "25.6",
      "name": "Overflatebehandling og bearbeiding av metaller",
      "shortName": "Overflatebeh./bearb. av metaller",
      "level": 3,
      "parentCode": "25"
    },
    {
      "code": "25.7",
      "name": "Produksjon av kjøkkenredskaper, skjære- og klipperedskaper, håndverktøy og andre jernvarer",
      "shortName": "Produksjon redskaper, andre jernvarer",
      "level": 3,
      "parentCode": "25"
    },
    {
      "code": "25.9",
      "name": "Produksjon av andre metallvarer",
      "shortName": "Produksjon av andre metallvarer",
      "level": 3,
      "parentCode": "25"
    },
    {
      "code": "26.1",
      "name": "Produksjon av elektroniske komponenter og kretskort",
      "shortName": "Elek. komponenter, kretskort",
      "level": 3,
      "parentCode": "26"
    },
    {
      "code": "26.2",
      "name": "Produksjon av datamaskiner og tilleggsutstyr",
      "shortName": "Prod. datamaskiner og tilleggsutstyr",
      "level": 3,
      "parentCode": "26"
    },
    {
      "code": "26.3",
      "name": "Produksjon av kommunikasjonsutstyr",
      "shortName": "Prod. av kommunikasjonsutstyr",
      "level": 3,
      "parentCode": "26"
    },
    {
      "code": "26.4",
      "name": "Produksjon av elektronikk til husholdningsbruk",
      "shortName": "Prod. av husholdningselektronikk",
      "level": 3,
      "parentCode": "26"
    },
    {
      "code": "26.5",
      "name": "Produksjon av måle-, kontroll- og navigasjonsinstrumenter, og klokker og ur",
      "shortName": "Måle- og kontrollinstrumenter",
      "level": 3,
      "parentCode": "26"
    },
    {
      "code": "26.6",
      "name": "Produksjon av strålingsutstyr, elektromedisinsk og elektroterapeutisk utstyr",
      "shortName": "Elektromed./elektroterap. utst. mv.",
      "level": 3,
      "parentCode": "26"
    },
    {
      "code": "26.7",
      "name": "Produksjon av optiske instrumenter og fotografisk utstyr",
      "shortName": "Optiske instr./fotografisk utstyr",
      "level": 3,
      "parentCode": "26"
    },
    {
      "code": "26.8",
      "name": "Produksjon av magnetiske og optiske media",
      "shortName": "Magnetiske/optiske media",
      "level": 3,
      "parentCode": "26"
    },
    {
      "code": "27.1",
      "name": "Produksjon av elektromotorer, generatorer, transformatorer og elektriske fordelings- og kontrolltavler og paneler",
      "shortName": "Elektromotorer, generatorer mv.",
      "level": 3,
      "parentCode": "27"
    },
    {
      "code": "27.2",
      "name": "Produksjon av batterier og akkumulatorer",
      "shortName": "Batterier, akkumulatorer",
      "level": 3,
      "parentCode": "27"
    },
    {
      "code": "27.3",
      "name": "Produksjon av ledninger og ledningsmateriell",
      "shortName": "Ledninger og ledningsmateriell",
      "level": 3,
      "parentCode": "27"
    },
    {
      "code": "27.4",
      "name": "Produksjon av belysningsutstyr",
      "shortName": "Prod. av belysningsutstyr",
      "level": 3,
      "parentCode": "27"
    },
    {
      "code": "27.5",
      "name": "Produksjon av husholdningsmaskiner og -apparater",
      "shortName": "Husholdningsmaskinproduksjon",
      "level": 3,
      "parentCode": "27"
    },
    {
      "code": "27.9",
      "name": "Produksjon av annet elektrisk utstyr",
      "shortName": "Produksjon elektrisk utstyr ellers",
      "level": 3,
      "parentCode": "27"
    },
    {
      "code": "28.1",
      "name": "Produksjon av maskiner og utstyr til generell bruk",
      "shortName": "Prod. mask. og utstyr generell bruk",
      "level": 3,
      "parentCode": "28"
    },
    {
      "code": "28.2",
      "name": "Produksjon av andre maskiner og annet utstyr til generell bruk",
      "shortName": "Annen maskinprod. for generell bruk",
      "level": 3,
      "parentCode": "28"
    },
    {
      "code": "28.3",
      "name": "Produksjon av jordbruks- og skogbruksmaskiner",
      "shortName": "Jord- og skogbruksmaskinproduksjon",
      "level": 3,
      "parentCode": "28"
    },
    {
      "code": "28.4",
      "name": "Produksjon av maskiner til metallbearbeiding og annet maskinverktøy",
      "shortName": "Mask.verktøy til metallbearb. mv.",
      "level": 3,
      "parentCode": "28"
    },
    {
      "code": "28.9",
      "name": "Produksjon av andre spesialmaskiner",
      "shortName": "Produksjon av andre spesialmaskiner",
      "level": 3,
      "parentCode": "28"
    },
    {
      "code": "29.1",
      "name": "Produksjon av motorvogner",
      "shortName": "Motorvognproduksjon",
      "level": 3,
      "parentCode": "29"
    },
    {
      "code": "29.2",
      "name": "Produksjon av karosserier og tilhengere",
      "shortName": "Karosseri- og tilhengerproduksjon",
      "level": 3,
      "parentCode": "29"
    },
    {
      "code": "29.3",
      "name": "Produksjon av deler og utstyr til motorvogner",
      "shortName": "Utstyr- og delprod. motorvogner",
      "level": 3,
      "parentCode": "29"
    },
    {
      "code": "30.1",
      "name": "Bygging av skip og båter",
      "shortName": "Bygging av skip og oljeplattformer",
      "level": 3,
      "parentCode": "30"
    },
    {
      "code": "30.2",
      "name": "Produksjon av lokomotiver og annet rullende materiell til jernbane og sporvei",
      "shortName": "Jernbane- og sporvognmateriell mv.",
      "level": 3,
      "parentCode": "30"
    },
    {
      "code": "30.3",
      "name": "Produksjon av luftfartøyer og romfartøyer og lignende utstyr",
      "shortName": "Prod. luft- og romfartøy og lignende",
      "level": 3,
      "parentCode": "30"
    },
    {
      "code": "30.4",
      "name": "Produksjon av militære stridskjøretøyer",
      "shortName": "Produksjon militære stridskjøretøy",
      "level": 3,
      "parentCode": "30"
    },
    {
      "code": "30.9",
      "name": "Produksjon av transportmidler ikke nevnt annet sted",
      "shortName": "Produksjon transportmidler ellers",
      "level": 3,
      "parentCode": "30"
    },
    {
      "code": "31.0",
      "name": "Produksjon av møbler",
      "shortName": "Produksjon av møbler",
      "level": 3,
      "parentCode": "31"
    },
    {
      "code": "32.1",
      "name": "Produksjon av gull- og sølvvarer, bijouteri og lignende artikler",
      "shortName": "Produksjon gull- og sølvvarer mv.",
      "level": 3,
      "parentCode": "32"
    },
    {
      "code": "32.2",
      "name": "Produksjon av musikkinstrumenter",
      "shortName": "Musikkinstrumentproduksjon",
      "level": 3,
      "parentCode": "32"
    },
    {
      "code": "32.3",
      "name": "Produksjon av sportsartikler",
      "shortName": "Sportsartikkelproduksjon",
      "level": 3,
      "parentCode": "32"
    },
    {
      "code": "32.4",
      "name": "Produksjon av spill og leker",
      "shortName": "Spill- og leketøyproduksjon",
      "level": 3,
      "parentCode": "32"
    },
    {
      "code": "32.5",
      "name": "Produksjon av medisinske og tanntekniske instrumenter og utstyr",
      "shortName": "Medisinske og tanntekniske instr.",
      "level": 3,
      "parentCode": "32"
    },
    {
      "code": "32.9",
      "name": "Industriproduksjon ikke nevnt annet sted",
      "shortName": "Industriproduksjon el.",
      "level": 3,
      "parentCode": "32"
    },
    {
      "code": "33.1",
      "name": "Reparasjon av metallvarer, maskiner og utstyr",
      "shortName": "Reparasjon metallvarer, maskiner mv.",
      "level": 3,
      "parentCode": "33"
    },
    {
      "code": "33.2",
      "name": "Installasjon av industrimaskiner og -utstyr",
      "shortName": "Installasjon industrimask., utstyr",
      "level": 3,
      "parentCode": "33"
    },
    {
      "code": "35.1",
      "name": "Produksjon, overføring og distribusjon av elektrisitet",
      "shortName": "El.prod., overføring og distrib.",
      "level": 3,
      "parentCode": "35"
    },
    {
      "code": "35.2",
      "name": "Produksjon av gass og distribusjon av gass gjennom ledningsnett",
      "shortName": "Produksjon gass gj. ledningsnett",
      "level": 3,
      "parentCode": "35"
    },
    {
      "code": "35.3",
      "name": "Damp- og varmtvannsforsyning",
      "shortName": "Damp- og varmtvannsforsyning",
      "level": 3,
      "parentCode": "35"
    },
    {
      "code": "36.0",
      "name": "Uttak fra kilde, rensing og distribusjon av vann",
      "shortName": "Vannforsyning",
      "level": 3,
      "parentCode": "36"
    },
    {
      "code": "37.0",
      "name": "Oppsamling og behandling av avløpsvann",
      "shortName": "Håndtering av avløpsvann",
      "level": 3,
      "parentCode": "37"
    },
    {
      "code": "38.1",
      "name": "Innsamling av avfall",
      "shortName": "Innsamling av avfall",
      "level": 3,
      "parentCode": "38"
    },
    {
      "code": "38.2",
      "name": "Behandling og disponering av avfall",
      "shortName": "Behandl. og disponering av avfall",
      "level": 3,
      "parentCode": "38"
    },
    {
      "code": "38.3",
      "name": "Materialgjenvinning",
      "shortName": "Materialgjenvinning",
      "level": 3,
      "parentCode": "38"
    },
    {
      "code": "39.0",
      "name": "Miljørydding, miljørensing og lignende virksomhet",
      "shortName": "Miljørydding og miljørensing",
      "level": 3,
      "parentCode": "39"
    },
    {
      "code": "41.1",
      "name": "Utvikling av byggeprosjekter",
      "shortName": "Utvikling av byggeprosjekter",
      "level": 3,
      "parentCode": "41"
    },
    {
      "code": "41.2",
      "name": "Oppføring av bygninger",
      "shortName": "Oppføring av bygninger",
      "level": 3,
      "parentCode": "41"
    },
    {
      "code": "42.1",
      "name": "Bygging av veier og jernbaner",
      "shortName": "Bygging av veier og jernbaner",
      "level": 3,
      "parentCode": "42"
    },
    {
      "code": "42.2",
      "name": "Bygging av vann- og kloakkanlegg, og anlegg for elektrisitet og telekommunikasjon",
      "shortName": "Vann-/kloakk-, el-. og telekom. anl.",
      "level": 3,
      "parentCode": "42"
    },
    {
      "code": "42.9",
      "name": "Bygging av andre anlegg",
      "shortName": "Bygging av andre anlegg",
      "level": 3,
      "parentCode": "42"
    },
    {
      "code": "43.1",
      "name": "Riving og grunnarbeid",
      "shortName": "Riving og grunnarbeid",
      "level": 3,
      "parentCode": "43"
    },
    {
      "code": "43.2",
      "name": "Elektrisk installasjonsarbeid, VVS-arbeid og annet installasjonsarbeid",
      "shortName": "El. install., VVS, annet installarb.",
      "level": 3,
      "parentCode": "43"
    },
    {
      "code": "43.3",
      "name": "Ferdiggjøring av bygninger",
      "shortName": "Ferdiggjøring av bygninger",
      "level": 3,
      "parentCode": "43"
    },
    {
      "code": "43.9",
      "name": "Annen spesialisert bygge- og anleggsvirksomhet",
      "shortName": "Annen spes. bygge- og anleggsvirks.",
      "level": 3,
      "parentCode": "43"
    },
    {
      "code": "45.1",
      "name": "Handel med motorvogner, unntatt motorsykler",
      "shortName": "Motorvognhandel, unnt. motorsykler",
      "level": 3,
      "parentCode": "45"
    },
    {
      "code": "45.2",
      "name": "Vedlikehold og reparasjon av motorvogner, unntatt motorsykler",
      "shortName": "Rep. av motorvogner/unnt. motorsyk.",
      "level": 3,
      "parentCode": "45"
    },
    {
      "code": "45.3",
      "name": "Handel med deler og utstyr til motorvogner, unntatt motorsykler",
      "shortName": "Del-/utstyrshdl. til motorvogner",
      "level": 3,
      "parentCode": "45"
    },
    {
      "code": "45.4",
      "name": "Handel med motorsykler, deler og utstyr. Vedlikehold og reparasjon av motorsykler",
      "shortName": "Motorsykkelhandel og -rep. mv.",
      "level": 3,
      "parentCode": "45"
    },
    {
      "code": "46.1",
      "name": "Agenturhandel",
      "shortName": "Agenturhandel",
      "level": 3,
      "parentCode": "46"
    },
    {
      "code": "46.2",
      "name": "Engroshandel med jordbruksråvarer og levende dyr",
      "shortName": "Engrosh. jordbr.råvarer og lev. dyr",
      "level": 3,
      "parentCode": "46"
    },
    {
      "code": "46.3",
      "name": "Engroshandel med nærings- og nytelsesmidler",
      "shortName": "Engrosh., nærings- og nytelsesmidler",
      "level": 3,
      "parentCode": "46"
    },
    {
      "code": "46.4",
      "name": "Engroshandel med husholdningsvarer og varer til personlig bruk",
      "shortName": "Engrosh. hush.- og varer pers. bruk",
      "level": 3,
      "parentCode": "46"
    },
    {
      "code": "46.5",
      "name": "Engroshandel med IKT-utstyr",
      "shortName": "Engrosh. IKT-utstyr",
      "level": 3,
      "parentCode": "46"
    },
    {
      "code": "46.6",
      "name": "Engroshandel med andre maskiner og annet utstyr",
      "shortName": "Engrosh. mask. og utstyr el",
      "level": 3,
      "parentCode": "46"
    },
    {
      "code": "46.7",
      "name": "Engroshandel med spesialisert vareutvalg ellers",
      "shortName": "Engrosh. med spes. vareutvalg el.",
      "level": 3,
      "parentCode": "46"
    },
    {
      "code": "46.9",
      "name": "Uspesifisert engroshandel",
      "shortName": "Uspesifisert engroshandel",
      "level": 3,
      "parentCode": "46"
    },
    {
      "code": "47.1",
      "name": "Butikkhandel med bredt vareutvalg",
      "shortName": "Butikkh. med bredt vareutvalg",
      "level": 3,
      "parentCode": "47"
    },
    {
      "code": "47.2",
      "name": "Butikkhandel med nærings- og nytelsesmidler i spesialforretninger",
      "shortName": "Spesialforr. nær.- og nytelsesmidl.",
      "level": 3,
      "parentCode": "47"
    },
    {
      "code": "47.3",
      "name": "Detaljhandel med drivstoff til motorvogner",
      "shortName": "Detaljh. drivstoff til motorvogner",
      "level": 3,
      "parentCode": "47"
    },
    {
      "code": "47.4",
      "name": "Butikkhandel med IKT-utstyr i spesialforretninger",
      "shortName": "Butikkh. med IKT-utstyr",
      "level": 3,
      "parentCode": "47"
    },
    {
      "code": "47.5",
      "name": "Butikkhandel med andre husholdningsvarer i spesialforretninger",
      "shortName": "Butikkh. med andre husholdningsvarer",
      "level": 3,
      "parentCode": "47"
    },
    {
      "code": "47.6",
      "name": "Butikkhandel med bøker, musikkartikler og andre fritidsartikler i spesialforretninger",
      "shortName": "Butikkh. med bøker, musikkart. etc.",
      "level": 3,
      "parentCode": "47"
    },
    {
      "code": "47.7",
      "name": "Annen butikkhandel i spesialforretninger",
      "shortName": "Annen butikkhandel",
      "level": 3,
      "parentCode": "47"
    },
    {
      "code": "47.8",
      "name": "Torghandel",
      "shortName": "Torghandel",
      "level": 3,
      "parentCode": "47"
    },
    {
      "code": "47.9",
      "name": "Detaljhandel utenom utsalgssted",
      "shortName": "Detaljh. utenom utsalgssted",
      "level": 3,
      "parentCode": "47"
    },
    {
      "code": "49.1",
      "name": "Passasjertransport med jernbane",
      "shortName": "Passasjertransp. med jernbane",
      "level": 3,
      "parentCode": "49"
    },
    {
      "code": "49.2",
      "name": "Godstransport med jernbane",
      "shortName": "Godstransp. med jernbane",
      "level": 3,
      "parentCode": "49"
    },
    {
      "code": "49.3",
      "name": "Annen landtransport med passasjerer",
      "shortName": "Annen landtransp. med passasjerer",
      "level": 3,
      "parentCode": "49"
    },
    {
      "code": "49.4",
      "name": "Godstransport på vei, herunder flyttetransport",
      "shortName": "Godstransp. på vei/flyttetransport",
      "level": 3,
      "parentCode": "49"
    },
    {
      "code": "49.5",
      "name": "Rørtransport",
      "shortName": "Rørtransport",
      "level": 3,
      "parentCode": "49"
    },
    {
      "code": "50.1",
      "name": "Sjøfart og kysttrafikk med passasjerer",
      "shortName": "Sjøfart og kysttraf. m/passasjerer",
      "level": 3,
      "parentCode": "50"
    },
    {
      "code": "50.2",
      "name": "Sjøfart og kysttrafikk med gods",
      "shortName": "Sjøfart og kysttrafikk med gods",
      "level": 3,
      "parentCode": "50"
    },
    {
      "code": "50.3",
      "name": "Passasjertransport på elver og innsjøer",
      "shortName": "Passasjertr. på elver og innsjøer",
      "level": 3,
      "parentCode": "50"
    },
    {
      "code": "50.4",
      "name": "Godstransport på elver og innsjøer",
      "shortName": "Godstransp. på elver og innsjøer",
      "level": 3,
      "parentCode": "50"
    },
    {
      "code": "51.1",
      "name": "Lufttransport med passasjerer",
      "shortName": "Lufttransp. med passasjerer",
      "level": 3,
      "parentCode": "51"
    },
    {
      "code": "51.2",
      "name": "Lufttransport med gods samt romfart",
      "shortName": "Lufttransp. med gods samt romfart",
      "level": 3,
      "parentCode": "51"
    },
    {
      "code": "52.1",
      "name": "Lagring",
      "shortName": "Lagring",
      "level": 3,
      "parentCode": "52"
    },
    {
      "code": "52.2",
      "name": "Andre tjenester tilknyttet transport",
      "shortName": "Andre tjenester tilkn. transport",
      "level": 3,
      "parentCode": "52"
    },
    {
      "code": "53.1",
      "name": "Landsdekkende posttjenester",
      "shortName": "Landsdekkende posttjenester",
      "level": 3,
      "parentCode": "53"
    },
    {
      "code": "53.2",
      "name": "Andre post- og budtjenester",
      "shortName": "Andre post- og budtjenester",
      "level": 3,
      "parentCode": "53"
    },
    {
      "code": "55.1",
      "name": "Hotellvirksomhet",
      "shortName": "Hotellvirksomhet",
      "level": 3,
      "parentCode": "55"
    },
    {
      "code": "55.2",
      "name": "Drift av vandrerhjem og ferieleiligheter",
      "shortName": "Drift av vandrerhjem/ferieleil.",
      "level": 3,
      "parentCode": "55"
    },
    {
      "code": "55.3",
      "name": "Drift av campingplasser",
      "shortName": "Drift av campingplasser",
      "level": 3,
      "parentCode": "55"
    },
    {
      "code": "55.9",
      "name": "Annen overnatting",
      "shortName": "Annen overnatting",
      "level": 3,
      "parentCode": "55"
    },
    {
      "code": "56.1",
      "name": "Restaurantvirksomhet",
      "shortName": "Restaurantvirksomhet",
      "level": 3,
      "parentCode": "56"
    },
    {
      "code": "56.2",
      "name": "Cateringvirksomhet og kantiner drevet som selvstendig virksomhet",
      "shortName": "Catering- og kantinevirksomhet",
      "level": 3,
      "parentCode": "56"
    },
    {
      "code": "56.3",
      "name": "Drift av barer",
      "shortName": "Drift av barer",
      "level": 3,
      "parentCode": "56"
    },
    {
      "code": "58.1",
      "name": "Utgivelse av bøker, tidsskrifter og annen forlagsvirksomhet",
      "shortName": "Utgiv. av bøker, tidsskrifter etc.",
      "level": 3,
      "parentCode": "58"
    },
    {
      "code": "58.2",
      "name": "Utgivelse av programvare",
      "shortName": "Utgivelse av programvare",
      "level": 3,
      "parentCode": "58"
    },
    {
      "code": "59.1",
      "name": "Virksomhet innen film, video og fjernsynsprogrammer",
      "shortName": "Virks. innen film/video/tv-program.",
      "level": 3,
      "parentCode": "59"
    },
    {
      "code": "59.2",
      "name": "Produksjon og utgivelse av musikk- og lydopptak",
      "shortName": "Prod./utgiv. av musikk-/lydopptak",
      "level": 3,
      "parentCode": "59"
    },
    {
      "code": "60.1",
      "name": "Radiokringkasting",
      "shortName": "Radiokringkasting",
      "level": 3,
      "parentCode": "60"
    },
    {
      "code": "60.2",
      "name": "Fjernsynskringkasting",
      "shortName": "Fjernsynskringkasting",
      "level": 3,
      "parentCode": "60"
    },
    {
      "code": "61.1",
      "name": "Kabelbasert telekommunikasjon",
      "shortName": "Kabelbasert telekomm.",
      "level": 3,
      "parentCode": "61"
    },
    {
      "code": "61.2",
      "name": "Trådløs telekommunikasjon",
      "shortName": "Trådløs telekomm.",
      "level": 3,
      "parentCode": "61"
    },
    {
      "code": "61.3",
      "name": "Satellittbasert telekommunikasjon",
      "shortName": "Satellittbasert telekomm.",
      "level": 3,
      "parentCode": "61"
    },
    {
      "code": "61.9",
      "name": "Telekommunikasjon ellers",
      "shortName": "Telekommunikasjon ellers",
      "level": 3,
      "parentCode": "61"
    },
    {
      "code": "62.0",
      "name": "Tjenester tilknyttet informasjonsteknologi",
      "shortName": "Tjen. tilkn. informasjonsteknologi",
      "level": 3,
      "parentCode": "62"
    },
    {
      "code": "63.1",
      "name": "Databehandling, datalagring og tilknyttede tjenester, drift av web-portaler",
      "shortName": "Databeh./datalagr./web-portaler",
      "level": 3,
      "parentCode": "63"
    },
    {
      "code": "63.9",
      "name": "Andre informasjonstjenester",
      "shortName": "Andre informasjonstjenester",
      "level": 3,
      "parentCode": "63"
    },
    {
      "code": "64.1",
      "name": "Bankvirksomhet",
      "shortName": "Bankvirksomhet",
      "level": 3,
      "parentCode": "64"
    },
    {
      "code": "64.2",
      "name": "Holdingselskaper",
      "shortName": "Holdingselskaper",
      "level": 3,
      "parentCode": "64"
    },
    {
      "code": "64.3",
      "name": "Verdipapirfond, investeringsselskaper o.l.",
      "shortName": "Verdipapirfond/invest.selskap o.l.",
      "level": 3,
      "parentCode": "64"
    },
    {
      "code": "64.9",
      "name": "Annen finansieringsvirksomhet",
      "shortName": "Annen finansieringsvirksomhet",
      "level": 3,
      "parentCode": "64"
    },
    {
      "code": "65.1",
      "name": "Forsikring",
      "shortName": "Forsikring",
      "level": 3,
      "parentCode": "65"
    },
    {
      "code": "65.2",
      "name": "Gjenforsikring",
      "shortName": "Gjenforsikring",
      "level": 3,
      "parentCode": "65"
    },
    {
      "code": "65.3",
      "name": "Pensjonskasser",
      "shortName": "Pensjonskasser",
      "level": 3,
      "parentCode": "65"
    },
    {
      "code": "66.1",
      "name": "Tjenester tilknyttet finansieringsvirksomhet",
      "shortName": "Tjen. tilkn. finansieringsvirks.",
      "level": 3,
      "parentCode": "66"
    },
    {
      "code": "66.2",
      "name": "Tjenester tilknyttet forsikringsvirksomhet og pensjonskasser",
      "shortName": "Tjen. til forsikr./pensjonskasser",
      "level": 3,
      "parentCode": "66"
    },
    {
      "code": "66.3",
      "name": "Fondsforvaltningsvirksomhet",
      "shortName": "Fondsforvaltningsvirksomhet",
      "level": 3,
      "parentCode": "66"
    },
    {
      "code": "68.1",
      "name": "Kjøp og salg av egen fast eiendom",
      "shortName": "Kjøp/salg av egen fast eiendom",
      "level": 3,
      "parentCode": "68"
    },
    {
      "code": "68.2",
      "name": "Utleie av egen eller leid fast eiendom",
      "shortName": "Utleie av egen/leid fast eiendom",
      "level": 3,
      "parentCode": "68"
    },
    {
      "code": "68.3",
      "name": "Omsetning og drift av fast eiendom på oppdrag",
      "shortName": "Oppdragsvirksomhet for fast eiendom",
      "level": 3,
      "parentCode": "68"
    },
    {
      "code": "69.1",
      "name": "Juridisk tjenesteyting",
      "shortName": "Juridisk tjenesteyting",
      "level": 3,
      "parentCode": "69"
    },
    {
      "code": "69.2",
      "name": "Regnskap, revisjon og skatterådgivning",
      "shortName": "Regnskap/revisjon/skatterådgiv.",
      "level": 3,
      "parentCode": "69"
    },
    {
      "code": "70.1",
      "name": "Hovedkontortjenester",
      "shortName": "Hovedkontortjenester",
      "level": 3,
      "parentCode": "70"
    },
    {
      "code": "70.2",
      "name": "Administrativ rådgivning",
      "shortName": "Administrativ rådgivning",
      "level": 3,
      "parentCode": "70"
    },
    {
      "code": "71.1",
      "name": "Arkitektvirksomhet og teknisk konsulentvirksomhet",
      "shortName": "Arkitekt- og tekn. konsulentvirks.",
      "level": 3,
      "parentCode": "71"
    },
    {
      "code": "71.2",
      "name": "Teknisk prøving og analyse",
      "shortName": "Teknisk prøving og analyse",
      "level": 3,
      "parentCode": "71"
    },
    {
      "code": "72.1",
      "name": "Forskning og utviklingsarbeid innen naturvitenskap og teknikk",
      "shortName": "Forskning naturvitenskap, teknikk",
      "level": 3,
      "parentCode": "72"
    },
    {
      "code": "72.2",
      "name": "Forskning og utviklingsarbeid innen samfunnsvitenskap og humanistiske fag",
      "shortName": "Forskning samfunnsvit., human. fag",
      "level": 3,
      "parentCode": "72"
    },
    {
      "code": "73.1",
      "name": "Annonse- og reklamevirksomhet",
      "shortName": "Annonse- og reklamevirksomhet",
      "level": 3,
      "parentCode": "73"
    },
    {
      "code": "73.2",
      "name": "Markeds- og opinionsundersøkelser",
      "shortName": "Markeds- og opinionsundersøkelser",
      "level": 3,
      "parentCode": "73"
    },
    {
      "code": "74.1",
      "name": "Spesialisert designvirksomhet",
      "shortName": "Spesialisert designvirksomhet",
      "level": 3,
      "parentCode": "74"
    },
    {
      "code": "74.2",
      "name": "Fotografvirksomhet",
      "shortName": "Fotografvirksomhet",
      "level": 3,
      "parentCode": "74"
    },
    {
      "code": "74.3",
      "name": "Oversettelses- og tolkevirksomhet",
      "shortName": "Oversettelses- og tolkevirksomhet",
      "level": 3,
      "parentCode": "74"
    },
    {
      "code": "74.9",
      "name": "Annen faglig, vitenskapelig og teknisk virksomhet",
      "shortName": "Annen faglig/vit.skap./tekn. virks.",
      "level": 3,
      "parentCode": "74"
    },
    {
      "code": "75.0",
      "name": "Veterinærtjenester",
      "shortName": "Veterinærtjenester",
      "level": 3,
      "parentCode": "75"
    },
    {
      "code": "77.1",
      "name": "Utleie og leasing av motorvogner",
      "shortName": "Bilutleie",
      "level": 3,
      "parentCode": "77"
    },
    {
      "code": "77.2",
      "name": "Utleie og leasing av husholdningsvarer og varer til personlig bruk",
      "shortName": "Utl. hush.varer og varer pers. bruk",
      "level": 3,
      "parentCode": "77"
    },
    {
      "code": "77.3",
      "name": "Utleie og leasing av andre maskiner, og annet utstyr og materiell",
      "shortName": "Utleie av maskiner og utstyr ellers",
      "level": 3,
      "parentCode": "77"
    },
    {
      "code": "77.4",
      "name": "Leasing av immateriell eiendom og lignende produkter, unntatt opphavsrettsbeskyttede verker",
      "shortName": "Leas. av immateriell eiendom mv.",
      "level": 3,
      "parentCode": "77"
    },
    {
      "code": "78.1",
      "name": "Rekruttering og formidling av arbeidskraft",
      "shortName": "Rekrutt./formidling av arbeidskraft",
      "level": 3,
      "parentCode": "78"
    },
    {
      "code": "78.2",
      "name": "Utleie av arbeidskraft",
      "shortName": "Utleie av arbeidskraft",
      "level": 3,
      "parentCode": "78"
    },
    {
      "code": "78.3",
      "name": "Andre personaladministrative tjenester",
      "shortName": "Andre personaladm. tjen.",
      "level": 3,
      "parentCode": "78"
    },
    {
      "code": "79.1",
      "name": "Reisebyrå- og reisearrangørvirksomhet",
      "shortName": "Reisebyrå- og reisearrangørvirks.",
      "level": 3,
      "parentCode": "79"
    },
    {
      "code": "79.9",
      "name": "Annen arrangørvirksomhet og tilknyttede tjenester",
      "shortName": "Annen arrangørvirks. og tilkn.tjen.",
      "level": 3,
      "parentCode": "79"
    },
    {
      "code": "80.1",
      "name": "Private vakttjenester",
      "shortName": "Private vakttjenester",
      "level": 3,
      "parentCode": "80"
    },
    {
      "code": "80.2",
      "name": "Tjenester tilknyttet vakttjenester",
      "shortName": "Tjenester tilknyttet vakttjenester",
      "level": 3,
      "parentCode": "80"
    },
    {
      "code": "80.3",
      "name": "Etterforsking",
      "shortName": "Etterforsking",
      "level": 3,
      "parentCode": "80"
    },
    {
      "code": "81.1",
      "name": "Kombinerte tjenester tilknyttet eiendomsdrift",
      "shortName": "Komb. tjen. tilkn. eiendomsdrift",
      "level": 3,
      "parentCode": "81"
    },
    {
      "code": "81.2",
      "name": "Rengjøringsvirksomhet",
      "shortName": "Rengjøringsvirksomhet",
      "level": 3,
      "parentCode": "81"
    },
    {
      "code": "81.3",
      "name": "Beplantning av hager og parkanlegg",
      "shortName": "Beplantning av hager og parkanl.",
      "level": 3,
      "parentCode": "81"
    },
    {
      "code": "82.1",
      "name": "Kontortjenester",
      "shortName": "Kontortjenester",
      "level": 3,
      "parentCode": "82"
    },
    {
      "code": "82.2",
      "name": "Telefonvakttjenester og telefonsalg",
      "shortName": "Telefonvakttjenester/telefonsalg",
      "level": 3,
      "parentCode": "82"
    },
    {
      "code": "82.3",
      "name": "Kongress-, messe- og utstillingsvirksomhet",
      "shortName": "Kongress-/messe-/utstillingsvirks.",
      "level": 3,
      "parentCode": "82"
    },
    {
      "code": "82.9",
      "name": "Forretningsmessig tjenesteyting ikke nevnt annet sted",
      "shortName": "Annen forretningsmessig tj.yting",
      "level": 3,
      "parentCode": "82"
    },
    {
      "code": "84.1",
      "name": "Offentlig administrasjon og forvaltning",
      "shortName": "Off. administrasjon, forvaltning",
      "level": 3,
      "parentCode": "84"
    },
    {
      "code": "84.2",
      "name": "Offentlig administrasjon tilknyttet utenriks- og sikkerhetssaker",
      "shortName": "Off.adm. utenriks-/sikkerhetssaker",
      "level": 3,
      "parentCode": "84"
    },
    {
      "code": "84.3",
      "name": "Trygdeordninger underlagt offentlig forvaltning",
      "shortName": "Sosialforsikring, trygd",
      "level": 3,
      "parentCode": "84"
    },
    {
      "code": "85.1",
      "name": "Førskoleundervisning",
      "shortName": "Førskoleundervisning",
      "level": 3,
      "parentCode": "85"
    },
    {
      "code": "85.2",
      "name": "Grunnskoleundervisning",
      "shortName": "Grunnskoleundervisning",
      "level": 3,
      "parentCode": "85"
    },
    {
      "code": "85.3",
      "name": "Undervisning på videregående skoles nivå",
      "shortName": "Undervisning videregående skoler",
      "level": 3,
      "parentCode": "85"
    },
    {
      "code": "85.4",
      "name": "Undervisning i høyere utdanning",
      "shortName": "Undervisning i høyere utdanning",
      "level": 3,
      "parentCode": "85"
    },
    {
      "code": "85.5",
      "name": "Annen undervisning",
      "shortName": "Annen undervisning",
      "level": 3,
      "parentCode": "85"
    },
    {
      "code": "85.6",
      "name": "Tjenester tilknyttet undervisning",
      "shortName": "Tjenester tilkn. undervisning",
      "level": 3,
      "parentCode": "85"
    },
    {
      "code": "86.1",
      "name": "Sykehustjenester",
      "shortName": "Sykehustjenester",
      "level": 3,
      "parentCode": "86"
    },
    {
      "code": "86.2",
      "name": "Lege- og tannlegetjenester",
      "shortName": "Lege- og tannlegetjenester",
      "level": 3,
      "parentCode": "86"
    },
    {
      "code": "86.9",
      "name": "Andre helsetjenester",
      "shortName": "Andre helsetjenester",
      "level": 3,
      "parentCode": "86"
    },
    {
      "code": "87.1",
      "name": "Pleie- og omsorgstjenester i institusjon",
      "shortName": "Pleie- og omsorg i institusjon",
      "level": 3,
      "parentCode": "87"
    },
    {
      "code": "87.2",
      "name": "Institusjoner og bofellesskap innen omsorg for psykisk utviklingshemmede, psykisk helsearbeid og rusmiddelomsorg",
      "shortName": "Inst./bof.skap psyk.utv.hem. mv.",
      "level": 3,
      "parentCode": "87"
    },
    {
      "code": "87.3",
      "name": "Institusjoner og bofellesskap innen omsorg for eldre og funksjonshemmede",
      "shortName": "Inst./bofellesskap eldre/funksj.hem.",
      "level": 3,
      "parentCode": "87"
    },
    {
      "code": "87.9",
      "name": "Andre omsorgsinstitusjoner",
      "shortName": "Andre omsorgsinstitusjoner",
      "level": 3,
      "parentCode": "87"
    },
    {
      "code": "88.1",
      "name": "Sosialtjenester uten botilbud for eldre og funksjonshemmede",
      "shortName": "Sosialtj. u/botilbud eldre/funksj.hem",
      "level": 3,
      "parentCode": "88"
    },
    {
      "code": "88.9",
      "name": "Andre sosialtjenester uten botilbud",
      "shortName": "Andre sosialtjen. uten botilbud",
      "level": 3,
      "parentCode": "88"
    },
    {
      "code": "90.0",
      "name": "Kunstnerisk virksomhet og underholdningsvirksomhet",
      "shortName": "Kunstnerisk virks. og underholdning",
      "level": 3,
      "parentCode": "90"
    },
    {
      "code": "91.0",
      "name": "Drift av biblioteker, arkiver, museer og annen kulturvirksomhet",
      "shortName": "Bibliotek, muséer o.a. kulturvirks.",
      "level": 3,
      "parentCode": "91"
    },
    {
      "code": "92.0",
      "name": "Lotteri og totalisatorspill",
      "shortName": "Lotteri og totalisatorspill",
      "level": 3,
      "parentCode": "92"
    },
    {
      "code": "93.1",
      "name": "Sportsaktiviteter",
      "shortName": "Sportsaktiviteter",
      "level": 3,
      "parentCode": "93"
    },
    {
      "code": "93.2",
      "name": "Fritidsaktiviteter og drift av fornøyelsesetablissementer",
      "shortName": "Fritidsaktiviteter, fornøyelsesetabl.",
      "level": 3,
      "parentCode": "93"
    },
    {
      "code": "94.1",
      "name": "Næringslivs- og arbeidsgiverorganisasjoner og yrkessammenslutninger",
      "shortName": "Næringslivs-/arbeidsgiverorg mv.",
      "level": 3,
      "parentCode": "94"
    },
    {
      "code": "94.2",
      "name": "Arbeidstakerorganisasjoner",
      "shortName": "Arbeidstakerorganisasjoner",
      "level": 3,
      "parentCode": "94"
    },
    {
      "code": "94.9",
      "name": "Aktiviteter i andre medlemsorganisasjoner",
      "shortName": "Aktiviteter i andre medlemsorg.",
      "level": 3,
      "parentCode": "94"
    },
    {
      "code": "95.1",
      "name": "Reparasjon av datamaskiner og kommunikasjonsutstyr",
      "shortName": "Rep. av datamaskiner og komm.utstyr",
      "level": 3,
      "parentCode": "95"
    },
    {
      "code": "95.2",
      "name": "Reparasjon av husholdningsvarer og varer til personlig bruk",
      "shortName": "Reparasjon varer personlig bruk",
      "level": 3,
      "parentCode": "95"
    },
    {
      "code": "96.0",
      "name": "Annen personlig tjenesteyting",
      "shortName": "Annen personlig tjenesteyting",
      "level": 3,
      "parentCode": "96"
    },
    {
      "code": "97.0",
      "name": "Lønnet arbeid i private husholdninger",
      "shortName": "Lønnet arbeid i private husholdn.",
      "level": 3,
      "parentCode": "97"
    },
    {
      "code": "99.0",
      "name": "Internasjonale organisasjoner og organer",
      "shortName": "Internasjonale organer",
      "level": 3,
      "parentCode": "99"
    },
    {
      "code": "01.11",
      "name": "Dyrking av korn (unntatt ris), belgvekster og oljeholdige vekster",
      "shortName": "Dyrking av korn, belgvekster mv.",
      "level": 4,
      "parentCode": "01.1"
    },
    {
      "code": "01.12",
      "name": "Dyrking av ris",
      "shortName": "Dyrking av ris",
      "level": 4,
      "parentCode": "01.1"
    },
    {
      "code": "01.13",
      "name": "Dyrking av grønnsaker, meloner, rot- og knollvekster",
      "shortName": "Dyrking av grønnsaker, poteter mv.",
      "level": 4,
      "parentCode": "01.1"
    },
    {
      "code": "01.14",
      "name": "Dyrking av sukkerrør",
      "shortName": "Dyrking av sukkerrør",
      "level": 4,
      "parentCode": "01.1"
    },
    {
      "code": "01.15",
      "name": "Dyrking av tobakk",
      "shortName": "Dyrking av tobakk",
      "level": 4,
      "parentCode": "01.1"
    },
    {
      "code": "01.16",
      "name": "Dyrking av fibervekster",
      "shortName": "Dyrking av fibervekster",
      "level": 4,
      "parentCode": "01.1"
    },
    {
      "code": "01.19",
      "name": "Dyrking av ettårige vekster ellers",
      "shortName": "Dyrking av ettårige vekster ellers",
      "level": 4,
      "parentCode": "01.1"
    },
    {
      "code": "01.21",
      "name": "Dyrking av druer",
      "shortName": "Dyrking av druer",
      "level": 4,
      "parentCode": "01.2"
    },
    {
      "code": "01.22",
      "name": "Dyrking av tropiske og subtropiske frukter",
      "shortName": "Dyrking av trop./subtrop. frukter",
      "level": 4,
      "parentCode": "01.2"
    },
    {
      "code": "01.23",
      "name": "Dyrking av sitrusfrukter",
      "shortName": "Dyrking av sitrusfrukter",
      "level": 4,
      "parentCode": "01.2"
    },
    {
      "code": "01.24",
      "name": "Dyrking av kjernefrukter og steinfrukter",
      "shortName": "Dyrking av kjerne- og steinfrukter",
      "level": 4,
      "parentCode": "01.2"
    },
    {
      "code": "01.25",
      "name": "Dyrking av annen frukt som vokser på trær eller busker samt nøtter",
      "shortName": "Dyrking av bær og nøtter mv.",
      "level": 4,
      "parentCode": "01.2"
    },
    {
      "code": "01.26",
      "name": "Dyrking av oljeholdige frukter",
      "shortName": "Dyrking av oljeholdige frukter",
      "level": 4,
      "parentCode": "01.2"
    },
    {
      "code": "01.27",
      "name": "Dyrking av vekster for produksjon av drikkevarer",
      "shortName": "Dyrk. vekster for prod. av drikkev.",
      "level": 4,
      "parentCode": "01.2"
    },
    {
      "code": "01.28",
      "name": "Dyrking av krydder og aromatiske, medisinske og farmasøytiske vekster",
      "shortName": "Dyrking av krydder mv.",
      "level": 4,
      "parentCode": "01.2"
    },
    {
      "code": "01.29",
      "name": "Dyrking av flerårige vekster ellers",
      "shortName": "Dyrking av flerårige vekster ellers",
      "level": 4,
      "parentCode": "01.2"
    },
    {
      "code": "01.30",
      "name": "Planteformering",
      "shortName": "Planteformering",
      "level": 4,
      "parentCode": "01.3"
    },
    {
      "code": "01.41",
      "name": "Melkeproduksjon på storfe",
      "shortName": "Melkeproduksjon på storfe",
      "level": 4,
      "parentCode": "01.4"
    },
    {
      "code": "01.42",
      "name": "Oppdrett av annet storfe",
      "shortName": "Oppdrett av annet storfe",
      "level": 4,
      "parentCode": "01.4"
    },
    {
      "code": "01.43",
      "name": "Oppdrett av hester og andre dyr av hestefamilien",
      "shortName": "Oppdrett av hester, esler o.l.",
      "level": 4,
      "parentCode": "01.4"
    },
    {
      "code": "01.44",
      "name": "Oppdrett av kameler og andre kameldyr",
      "shortName": "Oppdrett av kameler og kameldyr el.",
      "level": 4,
      "parentCode": "01.4"
    },
    {
      "code": "01.45",
      "name": "Saue- og geitehold",
      "shortName": "Saue- og geitehold",
      "level": 4,
      "parentCode": "01.4"
    },
    {
      "code": "01.46",
      "name": "Svinehold",
      "shortName": "Svinehold",
      "level": 4,
      "parentCode": "01.4"
    },
    {
      "code": "01.47",
      "name": "Fjørfehold",
      "shortName": "Fjørfehold",
      "level": 4,
      "parentCode": "01.4"
    },
    {
      "code": "01.49",
      "name": "Husdyrhold ellers",
      "shortName": "Husdyrhold ellers",
      "level": 4,
      "parentCode": "01.4"
    },
    {
      "code": "01.50",
      "name": "Kombinert husdyrhold og planteproduksjon",
      "shortName": "Komb. husdyrhold og planteprod.",
      "level": 4,
      "parentCode": "01.5"
    },
    {
      "code": "01.61",
      "name": "Tjenester tilknyttet planteproduksjon",
      "shortName": "Tjenester tilknyttet planteprod.",
      "level": 4,
      "parentCode": "01.6"
    },
    {
      "code": "01.62",
      "name": "Tjenester tilknyttet husdyrhold",
      "shortName": "Tjenester tilknyttet husdyrhold",
      "level": 4,
      "parentCode": "01.6"
    },
    {
      "code": "01.63",
      "name": "Etterbehandling av vekster etter innhøsting",
      "shortName": "Etterbeh. av vekster etter innhøst.",
      "level": 4,
      "parentCode": "01.6"
    },
    {
      "code": "01.64",
      "name": "Behandling av såfrø",
      "shortName": "Behandling av såfrø",
      "level": 4,
      "parentCode": "01.6"
    },
    {
      "code": "01.70",
      "name": "Jakt, viltstell og tjenester tilknyttet jakt og viltstell",
      "shortName": "Jakt, viltstell og tilkn. tjenester",
      "level": 4,
      "parentCode": "01.7"
    },
    {
      "code": "02.10",
      "name": "Skogskjøtsel og andre skogbruksaktiviteter",
      "shortName": "Skogskjøtsel, andre skogbruksakt.",
      "level": 4,
      "parentCode": "02.1"
    },
    {
      "code": "02.20",
      "name": "Avvirkning",
      "shortName": "Avvirkning",
      "level": 4,
      "parentCode": "02.2"
    },
    {
      "code": "02.30",
      "name": "Innsamling av viltvoksende produkter av annet enn tre",
      "shortName": "Innsaml. av sopp, bær, mose etc.",
      "level": 4,
      "parentCode": "02.3"
    },
    {
      "code": "02.40",
      "name": "Tjenester tilknyttet skogbruk",
      "shortName": "Tjenester tilknyttet skogbruk",
      "level": 4,
      "parentCode": "02.4"
    },
    {
      "code": "03.11",
      "name": "Hav- og kystfiske og fangst",
      "shortName": "Hav- og kystfiske og fangst",
      "level": 4,
      "parentCode": "03.1"
    },
    {
      "code": "03.12",
      "name": "Ferskvannsfiske",
      "shortName": "Ferskvannsfiske",
      "level": 4,
      "parentCode": "03.1"
    },
    {
      "code": "03.21",
      "name": "Hav- og kystbasert akvakultur",
      "shortName": "Hav- og kystbasert akvakultur",
      "level": 4,
      "parentCode": "03.2"
    },
    {
      "code": "03.22",
      "name": "Ferskvannsbasert akvakultur",
      "shortName": "Ferskvannsbasert akvakultur",
      "level": 4,
      "parentCode": "03.2"
    },
    {
      "code": "05.10",
      "name": "Bryting av steinkull",
      "shortName": "Bryting av steinkull",
      "level": 4,
      "parentCode": "05.1"
    },
    {
      "code": "05.20",
      "name": "Bryting av brunkull",
      "shortName": "Bryting av brunkull",
      "level": 4,
      "parentCode": "05.2"
    },
    {
      "code": "06.10",
      "name": "Utvinning av råolje",
      "shortName": "Utvinning av råolje",
      "level": 4,
      "parentCode": "06.1"
    },
    {
      "code": "06.20",
      "name": "Utvinning av naturgass",
      "shortName": "Utvinning av naturgass",
      "level": 4,
      "parentCode": "06.2"
    },
    {
      "code": "07.10",
      "name": "Bryting av jernmalm",
      "shortName": "Bryting av jernmalm",
      "level": 4,
      "parentCode": "07.1"
    },
    {
      "code": "07.21",
      "name": "Bryting av uran- og thoriummalm",
      "shortName": "Bryting av uran- og thoriummalm",
      "level": 4,
      "parentCode": "07.2"
    },
    {
      "code": "07.29",
      "name": "Bryting av ikke-jernholdig malm ellers",
      "shortName": "Bryting av annen ikke-jernh. malm",
      "level": 4,
      "parentCode": "07.2"
    },
    {
      "code": "08.11",
      "name": "Bryting av stein til bygge- og anleggsvirksomhet, kalkstein, gips, kritt og skifer",
      "shortName": "Bryt. bygn.-/kalkstein/skifer mv.",
      "level": 4,
      "parentCode": "08.1"
    },
    {
      "code": "08.12",
      "name": "Utvinning fra grus- og sandtak, og utvinning av leire og kaolin",
      "shortName": "Utv. fra grus- og sandtak, leire mv.",
      "level": 4,
      "parentCode": "08.1"
    },
    {
      "code": "08.91",
      "name": "Bryting og utvinning av kjemiske mineraler og gjødselsmineraler",
      "shortName": "Utv. kjem. mineraler/gjødselsmin.",
      "level": 4,
      "parentCode": "08.9"
    },
    {
      "code": "08.92",
      "name": "Stikking av torv",
      "shortName": "Stikking av torv",
      "level": 4,
      "parentCode": "08.9"
    },
    {
      "code": "08.93",
      "name": "Utvinning av salt",
      "shortName": "Utvinning av salt",
      "level": 4,
      "parentCode": "08.9"
    },
    {
      "code": "08.99",
      "name": "Annen bryting og utvinning ikke nevnt annet sted",
      "shortName": "Annen bryting og utvinning",
      "level": 4,
      "parentCode": "08.9"
    },
    {
      "code": "09.10",
      "name": "Tjenester tilknyttet utvinning av råolje og naturgass",
      "shortName": "Utvinningstjenester",
      "level": 4,
      "parentCode": "09.1"
    },
    {
      "code": "09.90",
      "name": "Tjenester tilknyttet annen bergverksdrift",
      "shortName": "Bergverkstjenester",
      "level": 4,
      "parentCode": "09.9"
    },
    {
      "code": "10.11",
      "name": "Bearbeiding og konservering av kjøtt",
      "shortName": "Kjøttbearbeiding og konservering",
      "level": 4,
      "parentCode": "10.1"
    },
    {
      "code": "10.12",
      "name": "Bearbeiding og konservering av fjørfekjøtt",
      "shortName": "Fjørfekjøttbearb. og konservering",
      "level": 4,
      "parentCode": "10.1"
    },
    {
      "code": "10.13",
      "name": "Produksjon av kjøtt- og fjørfevarer",
      "shortName": "Kjøtt- og fjørfevareproduksjon",
      "level": 4,
      "parentCode": "10.1"
    },
    {
      "code": "10.20",
      "name": "Bearbeiding og konservering av fisk, skalldyr og bløtdyr",
      "shortName": "Bearbeiding fisk, skalldyr, bløtdyr",
      "level": 4,
      "parentCode": "10.2"
    },
    {
      "code": "10.31",
      "name": "Bearbeiding og konservering av poteter",
      "shortName": "Potetbearbeiding",
      "level": 4,
      "parentCode": "10.3"
    },
    {
      "code": "10.32",
      "name": "Produksjon av juice av frukt og grønnsaker",
      "shortName": "Frukt- og grønnsakjuiceproduksjon",
      "level": 4,
      "parentCode": "10.3"
    },
    {
      "code": "10.39",
      "name": "Bearbeiding og konservering av frukt og grønnsaker ellers",
      "shortName": "Frukt- og grønnsakbearbeiding el.",
      "level": 4,
      "parentCode": "10.3"
    },
    {
      "code": "10.41",
      "name": "Produksjon av oljer og fettstoffer",
      "shortName": "Prod. av oljer og fettstoffer",
      "level": 4,
      "parentCode": "10.4"
    },
    {
      "code": "10.42",
      "name": "Produksjon av margarin og lignende spiselige fettstoffer",
      "shortName": "Margarinproduksjon m.m.",
      "level": 4,
      "parentCode": "10.4"
    },
    {
      "code": "10.51",
      "name": "Produksjon av meierivarer",
      "shortName": "Meierivareproduksjon",
      "level": 4,
      "parentCode": "10.5"
    },
    {
      "code": "10.52",
      "name": "Produksjon av iskrem",
      "shortName": "Iskremproduksjon",
      "level": 4,
      "parentCode": "10.5"
    },
    {
      "code": "10.61",
      "name": "Produksjon av kornvarer",
      "shortName": "Kornvareproduksjon",
      "level": 4,
      "parentCode": "10.6"
    },
    {
      "code": "10.62",
      "name": "Produksjon av stivelse og stivelsesprodukter",
      "shortName": "Prod. av stivelse og stivelseprod.",
      "level": 4,
      "parentCode": "10.6"
    },
    {
      "code": "10.71",
      "name": "Produksjon av brød og ferske konditorvarer",
      "shortName": "Brød og ferske konditorvarer",
      "level": 4,
      "parentCode": "10.7"
    },
    {
      "code": "10.72",
      "name": "Produksjon av kavringer, kjeks og konserverte konditorvarer",
      "shortName": "Kavring- og kjeksprod. mv.",
      "level": 4,
      "parentCode": "10.7"
    },
    {
      "code": "10.73",
      "name": "Produksjon av makaroni, nudler, couscous og lignende pastavarer",
      "shortName": "Pastavareproduksjon",
      "level": 4,
      "parentCode": "10.7"
    },
    {
      "code": "10.81",
      "name": "Produksjon av sukker",
      "shortName": "Sukkerproduksjon",
      "level": 4,
      "parentCode": "10.8"
    },
    {
      "code": "10.82",
      "name": "Produksjon av kakao, sjokolade og sukkervarer",
      "shortName": "Kakao-, sjokolade- og sukkervareprod.",
      "level": 4,
      "parentCode": "10.8"
    },
    {
      "code": "10.83",
      "name": "Bearbeiding av te og kaffe",
      "shortName": "Te- og kaffebearbeiding",
      "level": 4,
      "parentCode": "10.8"
    },
    {
      "code": "10.84",
      "name": "Produksjon av smakstilsettingsstoffer og krydderier",
      "shortName": "Smakstilsettingsstoffer og krydder",
      "level": 4,
      "parentCode": "10.8"
    },
    {
      "code": "10.85",
      "name": "Produksjon av ferdigmat",
      "shortName": "Ferdigmatproduksjon",
      "level": 4,
      "parentCode": "10.8"
    },
    {
      "code": "10.86",
      "name": "Produksjon av homogeniserte matprodukter og diettmat",
      "shortName": "Diettmat og homogeniserte matprod.",
      "level": 4,
      "parentCode": "10.8"
    },
    {
      "code": "10.89",
      "name": "Produksjon av næringsmidler ikke nevnt annet sted",
      "shortName": "Produksjon av næringsmidler el.",
      "level": 4,
      "parentCode": "10.8"
    },
    {
      "code": "10.91",
      "name": "Produksjon av fôrvarer til husdyrhold",
      "shortName": "Fôrvareproduksjon til husdyr",
      "level": 4,
      "parentCode": "10.9"
    },
    {
      "code": "10.92",
      "name": "Produksjon av fôrvarer til kjæledyr",
      "shortName": "Fôrvareproduksjon til kjæledyr",
      "level": 4,
      "parentCode": "10.9"
    },
    {
      "code": "11.01",
      "name": "Destillering, rektifisering og blanding av sprit",
      "shortName": "Destill. alkoholholdige drikkevarer",
      "level": 4,
      "parentCode": "11.0"
    },
    {
      "code": "11.02",
      "name": "Produksjon av vin",
      "shortName": "Vinproduksjon",
      "level": 4,
      "parentCode": "11.0"
    },
    {
      "code": "11.03",
      "name": "Produksjon av sider og annen fruktvin",
      "shortName": "Sider- og annen fruktvinproduksjon",
      "level": 4,
      "parentCode": "11.0"
    },
    {
      "code": "11.04",
      "name": "Produksjon av andre ikke-destillerte gjærede drikkevarer",
      "shortName": "Ikke-destill. gjærede drikkevarer",
      "level": 4,
      "parentCode": "11.0"
    },
    {
      "code": "11.05",
      "name": "Produksjon av øl",
      "shortName": "Ølproduksjon",
      "level": 4,
      "parentCode": "11.0"
    },
    {
      "code": "11.06",
      "name": "Produksjon av malt",
      "shortName": "Maltproduksjon",
      "level": 4,
      "parentCode": "11.0"
    },
    {
      "code": "11.07",
      "name": "Produksjon av mineralvann, leskedrikker og annet vann på flaske",
      "shortName": "Mineralvann- og leskedrikkproduksjon",
      "level": 4,
      "parentCode": "11.0"
    },
    {
      "code": "12.00",
      "name": "Produksjon av tobakksvarer",
      "shortName": "Tobakksindustri",
      "level": 4,
      "parentCode": "12.0"
    },
    {
      "code": "13.10",
      "name": "Bearbeiding og spinning av tekstilfibrer",
      "shortName": "Bearb./spinning av tekstilfibrer",
      "level": 4,
      "parentCode": "13.1"
    },
    {
      "code": "13.20",
      "name": "Veving av tekstiler",
      "shortName": "Veving av tekstiler",
      "level": 4,
      "parentCode": "13.2"
    },
    {
      "code": "13.30",
      "name": "Etterbehandling av tekstiler",
      "shortName": "Etterbehandling av tekstiler",
      "level": 4,
      "parentCode": "13.3"
    },
    {
      "code": "13.91",
      "name": "Produksjon av stoffer av trikotasje",
      "shortName": "Trikotasjestoffproduksjon",
      "level": 4,
      "parentCode": "13.9"
    },
    {
      "code": "13.92",
      "name": "Produksjon av tekstilvarer, unntatt klær",
      "shortName": "Tekstilvareproduksjon, unntatt klær",
      "level": 4,
      "parentCode": "13.9"
    },
    {
      "code": "13.93",
      "name": "Produksjon av gulvtepper, -matter og -ryer",
      "shortName": "Gulvteppe-, matte- og ryeproduksjon",
      "level": 4,
      "parentCode": "13.9"
    },
    {
      "code": "13.94",
      "name": "Produksjon av tauverk og nett",
      "shortName": "Tauverk- og nettproduksjon",
      "level": 4,
      "parentCode": "13.9"
    },
    {
      "code": "13.95",
      "name": "Produksjon av ikke-vevde tekstiler og tekstilvarer, unntatt klær",
      "shortName": "Fiberproduksjon mv.",
      "level": 4,
      "parentCode": "13.9"
    },
    {
      "code": "13.96",
      "name": "Produksjon av tekstiler til teknisk og industriell bruk",
      "shortName": "Tekstiler til tekn./industriell bruk",
      "level": 4,
      "parentCode": "13.9"
    },
    {
      "code": "13.99",
      "name": "Produksjon av tekstiler ikke nevnt annet sted",
      "shortName": "Tekstilproduksjon el.",
      "level": 4,
      "parentCode": "13.9"
    },
    {
      "code": "14.11",
      "name": "Produksjon av klær av lær",
      "shortName": "Produksjon av klær av lær",
      "level": 4,
      "parentCode": "14.1"
    },
    {
      "code": "14.12",
      "name": "Produksjon av arbeidstøy",
      "shortName": "Arbeidstøyproduksjon",
      "level": 4,
      "parentCode": "14.1"
    },
    {
      "code": "14.13",
      "name": "Produksjon av annet yttertøy",
      "shortName": "Annen yttertøyproduksjon",
      "level": 4,
      "parentCode": "14.1"
    },
    {
      "code": "14.14",
      "name": "Produksjon av undertøy og innertøy",
      "shortName": "Undertøy- og innertøyproduksjon",
      "level": 4,
      "parentCode": "14.1"
    },
    {
      "code": "14.19",
      "name": "Produksjon av klær og tilbehør ellers",
      "shortName": "Produksjon av klær og tilbehør el.",
      "level": 4,
      "parentCode": "14.1"
    },
    {
      "code": "14.20",
      "name": "Produksjon av pelsvarer",
      "shortName": "Produksjon av pelsvarer",
      "level": 4,
      "parentCode": "14.2"
    },
    {
      "code": "14.31",
      "name": "Produksjon av strømpevarer",
      "shortName": "Strømpevareproduksjon",
      "level": 4,
      "parentCode": "14.3"
    },
    {
      "code": "14.39",
      "name": "Produksjon av andre klær av trikotasje",
      "shortName": "Prod. av klær av trikotasje el.",
      "level": 4,
      "parentCode": "14.3"
    },
    {
      "code": "15.11",
      "name": "Beredning av lær, og beredning og farging av pelsskinn",
      "shortName": "Lærberedning",
      "level": 4,
      "parentCode": "15.1"
    },
    {
      "code": "15.12",
      "name": "Produksjon av reiseeffekter og salmakerartikler",
      "shortName": "Reiseeffekter og salmakerartikler",
      "level": 4,
      "parentCode": "15.1"
    },
    {
      "code": "15.20",
      "name": "Produksjon av skotøy",
      "shortName": "Produksjon av skotøy",
      "level": 4,
      "parentCode": "15.2"
    },
    {
      "code": "16.10",
      "name": "Saging, høvling og impregnering av tre",
      "shortName": "Saging, høvling mv. av tre",
      "level": 4,
      "parentCode": "16.1"
    },
    {
      "code": "16.21",
      "name": "Produksjon av finerplater og andre bygnings- og møbelplater av tre",
      "shortName": "Bygnings- og møbelplateproduksjon",
      "level": 4,
      "parentCode": "16.2"
    },
    {
      "code": "16.22",
      "name": "Produksjon av sammensatte parkettstaver",
      "shortName": "Sammensatte parkettstavprod.",
      "level": 4,
      "parentCode": "16.2"
    },
    {
      "code": "16.23",
      "name": "Produksjon av andre bygningsartikler",
      "shortName": "Annen bygningsartikkelprod.",
      "level": 4,
      "parentCode": "16.2"
    },
    {
      "code": "16.24",
      "name": "Produksjon av treemballasje",
      "shortName": "Treemballasjeproduksjon",
      "level": 4,
      "parentCode": "16.2"
    },
    {
      "code": "16.29",
      "name": "Produksjon av andre trevarer og varer av kork, strå og flettematerialer",
      "shortName": "Andre tre-, kork-, stråvarer mv.",
      "level": 4,
      "parentCode": "16.2"
    },
    {
      "code": "17.11",
      "name": "Produksjon av papirmasse",
      "shortName": "Produksjon av papirmasse",
      "level": 4,
      "parentCode": "17.1"
    },
    {
      "code": "17.12",
      "name": "Produksjon av papir og papp",
      "shortName": "Produksjon av papir og papp",
      "level": 4,
      "parentCode": "17.1"
    },
    {
      "code": "17.21",
      "name": "Produksjon av bølgepapp og emballasje av papir og papp",
      "shortName": "Bølgepapp, papir- og pappemballasje",
      "level": 4,
      "parentCode": "17.2"
    },
    {
      "code": "17.22",
      "name": "Produksjon av husholdnings-, sanitær- og toalettartikler av papir",
      "shortName": "Hushold.-/toalettartikler av papir",
      "level": 4,
      "parentCode": "17.2"
    },
    {
      "code": "17.23",
      "name": "Produksjon av kontorartikler av papir",
      "shortName": "Prod. av kontorartikler av papir",
      "level": 4,
      "parentCode": "17.2"
    },
    {
      "code": "17.24",
      "name": "Produksjon av tapeter",
      "shortName": "Tapetproduksjon",
      "level": 4,
      "parentCode": "17.2"
    },
    {
      "code": "17.29",
      "name": "Produksjon av varer av papir og papp ellers",
      "shortName": "Papir- og pappvareproduksjon el.",
      "level": 4,
      "parentCode": "17.2"
    },
    {
      "code": "18.11",
      "name": "Trykking av aviser",
      "shortName": "Trykking av aviser",
      "level": 4,
      "parentCode": "18.1"
    },
    {
      "code": "18.12",
      "name": "Trykking ellers",
      "shortName": "Trykking ellers",
      "level": 4,
      "parentCode": "18.1"
    },
    {
      "code": "18.13",
      "name": "Ferdiggjøring før trykking og publisering",
      "shortName": "Ferdiggjøring før trykking og publ.",
      "level": 4,
      "parentCode": "18.1"
    },
    {
      "code": "18.14",
      "name": "Bokbinding og tilknyttede tjenester",
      "shortName": "Bokbinding og tilkn. tjenester",
      "level": 4,
      "parentCode": "18.1"
    },
    {
      "code": "18.20",
      "name": "Reproduksjon av innspilte opptak",
      "shortName": "Reproduksjon av innspilte opptak",
      "level": 4,
      "parentCode": "18.2"
    },
    {
      "code": "19.10",
      "name": "Produksjon av kullprodukter",
      "shortName": "Produksjon av kullprodukter",
      "level": 4,
      "parentCode": "19.1"
    },
    {
      "code": "19.20",
      "name": "Produksjon av raffinerte petroleumsprodukter",
      "shortName": "Prod. raffinerte petroleumsprodukt",
      "level": 4,
      "parentCode": "19.2"
    },
    {
      "code": "20.11",
      "name": "Produksjon av industrigasser",
      "shortName": "Industrigassproduksjon",
      "level": 4,
      "parentCode": "20.1"
    },
    {
      "code": "20.12",
      "name": "Produksjon av fargestoffer og pigmenter",
      "shortName": "Fargestoff- og pigmentproduksjon",
      "level": 4,
      "parentCode": "20.1"
    },
    {
      "code": "20.13",
      "name": "Produksjon av andre uorganiske kjemikalier",
      "shortName": "Uorganisk kjemikalieproduksjon el.",
      "level": 4,
      "parentCode": "20.1"
    },
    {
      "code": "20.14",
      "name": "Produksjon av andre organiske kjemiske råvarer",
      "shortName": "Annen org. kjemisk råvareproduksjon",
      "level": 4,
      "parentCode": "20.1"
    },
    {
      "code": "20.15",
      "name": "Produksjon av gjødsel, nitrogenforbindelser og vekstjord",
      "shortName": "Gjødselproduksjon mv.",
      "level": 4,
      "parentCode": "20.1"
    },
    {
      "code": "20.16",
      "name": "Produksjon av basisplast",
      "shortName": "Basisplastproduksjon",
      "level": 4,
      "parentCode": "20.1"
    },
    {
      "code": "20.17",
      "name": "Produksjon av syntetisk gummi",
      "shortName": "Produksjon av syntetisk gummi",
      "level": 4,
      "parentCode": "20.1"
    },
    {
      "code": "20.20",
      "name": "Produksjon av plantevern- og skadedyrmidler og andre landbrukskjemiske produkter",
      "shortName": "Produksjon landbrukskjemiske prod.",
      "level": 4,
      "parentCode": "20.2"
    },
    {
      "code": "20.30",
      "name": "Produksjon av maling og lakk, trykkfarger og tetningsmidler",
      "shortName": "Produksjon maling, lakk mv.",
      "level": 4,
      "parentCode": "20.3"
    },
    {
      "code": "20.41",
      "name": "Produksjon av såpe og vaskemidler, rense- og polermidler",
      "shortName": "Såpe- og vaskemiddelprod. mv.",
      "level": 4,
      "parentCode": "20.4"
    },
    {
      "code": "20.42",
      "name": "Produksjon av parfyme og toalettartikler",
      "shortName": "Parfyme og toalettartikler",
      "level": 4,
      "parentCode": "20.4"
    },
    {
      "code": "20.51",
      "name": "Produksjon av eksplosiver",
      "shortName": "Produksjon av eksplosiver",
      "level": 4,
      "parentCode": "20.5"
    },
    {
      "code": "20.52",
      "name": "Produksjon av lim",
      "shortName": "Limproduksjon",
      "level": 4,
      "parentCode": "20.5"
    },
    {
      "code": "20.53",
      "name": "Produksjon av eteriske oljer",
      "shortName": "Produksjon av eteriske oljer",
      "level": 4,
      "parentCode": "20.5"
    },
    {
      "code": "20.59",
      "name": "Produksjon av kjemiske produkter ikke nevnt annet sted",
      "shortName": "Annen kjemisk produksjon",
      "level": 4,
      "parentCode": "20.5"
    },
    {
      "code": "20.60",
      "name": "Produksjon av kunstfibrer",
      "shortName": "Produksjon av kunstfibrer",
      "level": 4,
      "parentCode": "20.6"
    },
    {
      "code": "21.10",
      "name": "Produksjon av farmasøytiske råvarer",
      "shortName": "Farmasøytiske råvarer",
      "level": 4,
      "parentCode": "21.1"
    },
    {
      "code": "21.20",
      "name": "Produksjon av farmasøytiske preparater",
      "shortName": "Farmasøytiske preparater",
      "level": 4,
      "parentCode": "21.2"
    },
    {
      "code": "22.11",
      "name": "Produksjon av gummidekk og slanger til gummidekk, og regummiering og vulkanisering av gummidekk",
      "shortName": "Gummidekkprod., -regumm. og -vulk.",
      "level": 4,
      "parentCode": "22.1"
    },
    {
      "code": "22.19",
      "name": "Produksjon av gummiprodukter ellers",
      "shortName": "Produksjon av gummiprodukter el.",
      "level": 4,
      "parentCode": "22.1"
    },
    {
      "code": "22.21",
      "name": "Produksjon av halvfabrikater av plast",
      "shortName": "Prod. av halvfabrikater av plast",
      "level": 4,
      "parentCode": "22.2"
    },
    {
      "code": "22.22",
      "name": "Produksjon av plastemballasje",
      "shortName": "Plastemballasjeproduksjon",
      "level": 4,
      "parentCode": "22.2"
    },
    {
      "code": "22.23",
      "name": "Produksjon av byggevarer av plast",
      "shortName": "Byggevareprod. av plast",
      "level": 4,
      "parentCode": "22.2"
    },
    {
      "code": "22.29",
      "name": "Produksjon av plastprodukter ellers",
      "shortName": "Prod. av plastprodukter el.",
      "level": 4,
      "parentCode": "22.2"
    },
    {
      "code": "23.11",
      "name": "Produksjon av planglass",
      "shortName": "Planglassproduksjon",
      "level": 4,
      "parentCode": "23.1"
    },
    {
      "code": "23.12",
      "name": "Bearbeiding av planglass",
      "shortName": "Planglassbearbeiding",
      "level": 4,
      "parentCode": "23.1"
    },
    {
      "code": "23.13",
      "name": "Produksjon av emballasje og husholdningsartikler av glass og krystall",
      "shortName": "Emb. og hush.art. av glass/krystall",
      "level": 4,
      "parentCode": "23.1"
    },
    {
      "code": "23.14",
      "name": "Produksjon av glassfibrer",
      "shortName": "Glassfiberproduksjon",
      "level": 4,
      "parentCode": "23.1"
    },
    {
      "code": "23.19",
      "name": "Produksjon av teknisk glass og andre glassvarer",
      "shortName": "Tekn. glass- og annen glassvareprod.",
      "level": 4,
      "parentCode": "23.1"
    },
    {
      "code": "23.20",
      "name": "Produksjon av ildfaste produkter",
      "shortName": "Prod. av ildfaste produkter",
      "level": 4,
      "parentCode": "23.2"
    },
    {
      "code": "23.31",
      "name": "Produksjon av keramiske vegg- og gulvfliser",
      "shortName": "Keramisk byggematerialproduksjon",
      "level": 4,
      "parentCode": "23.3"
    },
    {
      "code": "23.32",
      "name": "Produksjon av murstein, teglstein og andre byggevarer av brent leire",
      "shortName": "Mur-, teglstein- o.a. byggevareprod.",
      "level": 4,
      "parentCode": "23.3"
    },
    {
      "code": "23.41",
      "name": "Produksjon av keramiske husholdningsartikler og dekorasjonsgjenstander",
      "shortName": "Keramiske husholdningsartikler mv.",
      "level": 4,
      "parentCode": "23.4"
    },
    {
      "code": "23.42",
      "name": "Produksjon av sanitærutstyr av keramisk materiale",
      "shortName": "Prod. av keramisk sanitærutstyr",
      "level": 4,
      "parentCode": "23.4"
    },
    {
      "code": "23.43",
      "name": "Produksjon av isolatorer og isoleringsdeler av keramisk materiale",
      "shortName": "Prod. av keramiske isoleringsdeler",
      "level": 4,
      "parentCode": "23.4"
    },
    {
      "code": "23.44",
      "name": "Produksjon av andre keramiske produkter for teknisk bruk",
      "shortName": "Prod. av keram. prod. for tekn. bruk",
      "level": 4,
      "parentCode": "23.4"
    },
    {
      "code": "23.49",
      "name": "Produksjon av andre keramiske produkter",
      "shortName": "Prod. av andre keramiske prod.",
      "level": 4,
      "parentCode": "23.4"
    },
    {
      "code": "23.51",
      "name": "Produksjon av sement",
      "shortName": "Sementproduksjon",
      "level": 4,
      "parentCode": "23.5"
    },
    {
      "code": "23.52",
      "name": "Produksjon av kalk og gips",
      "shortName": "Kalk- og gipsproduksjon",
      "level": 4,
      "parentCode": "23.5"
    },
    {
      "code": "23.61",
      "name": "Produksjon av betongprodukter for bygge- og anleggsvirksomhet",
      "shortName": "Betongprodukter for bygg og anlegg",
      "level": 4,
      "parentCode": "23.6"
    },
    {
      "code": "23.62",
      "name": "Produksjon av gipsprodukter for bygge- og anleggsvirksomhet",
      "shortName": "Gipsprodukter for bygg av anlegg",
      "level": 4,
      "parentCode": "23.6"
    },
    {
      "code": "23.63",
      "name": "Produksjon av ferdigblandet betong",
      "shortName": "Ferdigblandet betong",
      "level": 4,
      "parentCode": "23.6"
    },
    {
      "code": "23.64",
      "name": "Produksjon av mørtel",
      "shortName": "Mørtelproduksjon",
      "level": 4,
      "parentCode": "23.6"
    },
    {
      "code": "23.65",
      "name": "Produksjon av fibersement",
      "shortName": "Fibersementproduksjon",
      "level": 4,
      "parentCode": "23.6"
    },
    {
      "code": "23.69",
      "name": "Produksjon av betong-, sement- og gipsprodukter ellers",
      "shortName": "Annen betong-, sement- og gipsprod.",
      "level": 4,
      "parentCode": "23.6"
    },
    {
      "code": "23.70",
      "name": "Hogging og bearbeiding av monument- og bygningsstein",
      "shortName": "Hogg./bearb. av monum.-/bygn.stein",
      "level": 4,
      "parentCode": "23.7"
    },
    {
      "code": "23.91",
      "name": "Produksjon av slipestoffer",
      "shortName": "Slipestoffproduksjon",
      "level": 4,
      "parentCode": "23.9"
    },
    {
      "code": "23.99",
      "name": "Produksjon av ikke-metallholdige mineralprodukter ikke nevnt annet sted",
      "shortName": "Prod. av ikke-met. mineralprod. el.",
      "level": 4,
      "parentCode": "23.9"
    },
    {
      "code": "24.10",
      "name": "Produksjon av jern og stål, samt ferrolegeringer",
      "shortName": "Produksjon jern,  stål, ferroleger.",
      "level": 4,
      "parentCode": "24.1"
    },
    {
      "code": "24.20",
      "name": "Produksjon av andre rør og rørdeler av stål",
      "shortName": "Annen rør- og rørdelprod. av stål",
      "level": 4,
      "parentCode": "24.2"
    },
    {
      "code": "24.31",
      "name": "Kaldtrekking av stenger og profiler",
      "shortName": "Kaldtrekking av stenger og profiler",
      "level": 4,
      "parentCode": "24.3"
    },
    {
      "code": "24.32",
      "name": "Kaldvalsing av bånd",
      "shortName": "Kaldvalsing av bånd",
      "level": 4,
      "parentCode": "24.3"
    },
    {
      "code": "24.33",
      "name": "Kaldvalsing og pressing av profilerte plater og profiler",
      "shortName": "Kaldv./press. av prof. plater mv.",
      "level": 4,
      "parentCode": "24.3"
    },
    {
      "code": "24.34",
      "name": "Kaldtrekking av tråd",
      "shortName": "Kaldtrekking av tråd",
      "level": 4,
      "parentCode": "24.3"
    },
    {
      "code": "24.41",
      "name": "Produksjon av edelmetaller",
      "shortName": "Edelmetallproduksjon",
      "level": 4,
      "parentCode": "24.4"
    },
    {
      "code": "24.42",
      "name": "Produksjon av aluminium",
      "shortName": "Produksjon av aluminium",
      "level": 4,
      "parentCode": "24.4"
    },
    {
      "code": "24.43",
      "name": "Produksjon av bly, sink og tinn",
      "shortName": "Bly-, sink- og tinnproduksjon",
      "level": 4,
      "parentCode": "24.4"
    },
    {
      "code": "24.44",
      "name": "Produksjon av kobber",
      "shortName": "Kobberproduksjon",
      "level": 4,
      "parentCode": "24.4"
    },
    {
      "code": "24.45",
      "name": "Produksjon av ikke-jernholdige metaller ellers",
      "shortName": "Prod. ikke-jernhold. metaller ellers",
      "level": 4,
      "parentCode": "24.4"
    },
    {
      "code": "24.46",
      "name": "Produksjon av kjernebrensel",
      "shortName": "Kjernebrenselproduksjon",
      "level": 4,
      "parentCode": "24.4"
    },
    {
      "code": "24.51",
      "name": "Støping av jern",
      "shortName": "Støping av jern",
      "level": 4,
      "parentCode": "24.5"
    },
    {
      "code": "24.52",
      "name": "Støping av stål",
      "shortName": "Støping av stål",
      "level": 4,
      "parentCode": "24.5"
    },
    {
      "code": "24.53",
      "name": "Støping av lettmetaller",
      "shortName": "Støping av lettmetaller",
      "level": 4,
      "parentCode": "24.5"
    },
    {
      "code": "24.54",
      "name": "Støping av andre ikke-jernholdige metaller",
      "shortName": "Annen ikke-jernholdig metallstøp.",
      "level": 4,
      "parentCode": "24.5"
    },
    {
      "code": "25.11",
      "name": "Produksjon av metallkonstruksjoner og deler",
      "shortName": "Prod. av metallkonstruksj. og deler",
      "level": 4,
      "parentCode": "25.1"
    },
    {
      "code": "25.12",
      "name": "Produksjon av dører og vinduer av metall",
      "shortName": "Bygningsartikkelprod. av metall",
      "level": 4,
      "parentCode": "25.1"
    },
    {
      "code": "25.21",
      "name": "Produksjon av radiatorer og kjeler til sentralvarmeanlegg",
      "shortName": "Sentralv.kjeler- og radiatorprod.",
      "level": 4,
      "parentCode": "25.2"
    },
    {
      "code": "25.29",
      "name": "Produksjon av andre tanker, cisterner og beholdere av metall",
      "shortName": "Prod. av metallbeholdere",
      "level": 4,
      "parentCode": "25.2"
    },
    {
      "code": "25.30",
      "name": "Produksjon av dampkjeler, unntatt kjeler til sentralvarmeanlegg",
      "shortName": "Dampkjeler unnt. sentralvarmeanl.",
      "level": 4,
      "parentCode": "25.3"
    },
    {
      "code": "25.40",
      "name": "Produksjon av våpen og ammunisjon",
      "shortName": "Våpen- og ammunisjonsproduksjon",
      "level": 4,
      "parentCode": "25.4"
    },
    {
      "code": "25.50",
      "name": "Smiing, stansing og valsing av metall, og pulvermetallurgi",
      "shortName": "Stansing/valsing/pulvermetallurgi",
      "level": 4,
      "parentCode": "25.5"
    },
    {
      "code": "25.61",
      "name": "Overflatebehandling av metaller",
      "shortName": "Overflatebehandling av metaller",
      "level": 4,
      "parentCode": "25.6"
    },
    {
      "code": "25.62",
      "name": "Bearbeiding av metaller",
      "shortName": "Bearbeiding av metaller",
      "level": 4,
      "parentCode": "25.6"
    },
    {
      "code": "25.71",
      "name": "Produksjon av kjøkkenredskaper og skjære- og klipperedskaper",
      "shortName": "Kjøkkenredskapsproduksjon",
      "level": 4,
      "parentCode": "25.7"
    },
    {
      "code": "25.72",
      "name": "Produksjon av låser og beslag",
      "shortName": "Låse- og beslagproduksjon",
      "level": 4,
      "parentCode": "25.7"
    },
    {
      "code": "25.73",
      "name": "Produksjon av håndverktøy",
      "shortName": "Håndverktøyproduksjon",
      "level": 4,
      "parentCode": "25.7"
    },
    {
      "code": "25.91",
      "name": "Produksjon av stålfat og lignende beholdere av jern og stål",
      "shortName": "Prod. av behold. mv. av jern/stål",
      "level": 4,
      "parentCode": "25.9"
    },
    {
      "code": "25.92",
      "name": "Produksjon av emballasje av lettmetall",
      "shortName": "Prod. av lettmetallemballasje",
      "level": 4,
      "parentCode": "25.9"
    },
    {
      "code": "25.93",
      "name": "Produksjon av varer av metalltråd, kjetting og fjærer",
      "shortName": "Metalltrådvareproduksjon",
      "level": 4,
      "parentCode": "25.9"
    },
    {
      "code": "25.94",
      "name": "Produksjon av bolter og skruer",
      "shortName": "Bolte- og skrueproduksjon",
      "level": 4,
      "parentCode": "25.9"
    },
    {
      "code": "25.99",
      "name": "Produksjon av metallvarer ikke nevnt annet sted",
      "shortName": "Metallvareprod. el.",
      "level": 4,
      "parentCode": "25.9"
    },
    {
      "code": "26.11",
      "name": "Produksjon av elektroniske komponenter",
      "shortName": "Prod. av elektroniske komponenter",
      "level": 4,
      "parentCode": "26.1"
    },
    {
      "code": "26.12",
      "name": "Produksjon av kretskort",
      "shortName": "Produksjon av kretskort",
      "level": 4,
      "parentCode": "26.1"
    },
    {
      "code": "26.20",
      "name": "Produksjon av datamaskiner og tilleggsutstyr",
      "shortName": "Prod. datamaskiner og tilleggsutstyr",
      "level": 4,
      "parentCode": "26.2"
    },
    {
      "code": "26.30",
      "name": "Produksjon av kommunikasjonsutstyr",
      "shortName": "Prod. av kommunikasjonsutstyr",
      "level": 4,
      "parentCode": "26.3"
    },
    {
      "code": "26.40",
      "name": "Produksjon av elektronikk til husholdningsbruk",
      "shortName": "Prod. av husholdningselektronikk",
      "level": 4,
      "parentCode": "26.4"
    },
    {
      "code": "26.51",
      "name": "Produksjon av måle-, kontroll- og navigasjonsinstrumenter",
      "shortName": "Måle-, kontroll- og navig.instr.",
      "level": 4,
      "parentCode": "26.5"
    },
    {
      "code": "26.52",
      "name": "Produksjon av klokker og ur",
      "shortName": "Klokke- og urproduksjon",
      "level": 4,
      "parentCode": "26.5"
    },
    {
      "code": "26.60",
      "name": "Produksjon av strålingsutstyr, elektromedisinsk og elektroterapeutisk utstyr",
      "shortName": "Elektromed./elektroterap. utst. mv.",
      "level": 4,
      "parentCode": "26.6"
    },
    {
      "code": "26.70",
      "name": "Produksjon av optiske instrumenter og fotografisk utstyr",
      "shortName": "Optiske instr./fotografisk utstyr",
      "level": 4,
      "parentCode": "26.7"
    },
    {
      "code": "26.80",
      "name": "Produksjon av magnetiske og optiske media",
      "shortName": "Magnetiske/optiske media",
      "level": 4,
      "parentCode": "26.8"
    },
    {
      "code": "27.11",
      "name": "Produksjon av elektromotorer, generatorer og transformatorer",
      "shortName": "Elektromotor-, generatorprod. mv.",
      "level": 4,
      "parentCode": "27.1"
    },
    {
      "code": "27.12",
      "name": "Produksjon av elektriske fordelings- og kontrolltavler og paneler",
      "shortName": "Elektriske tavler, paneler mv.",
      "level": 4,
      "parentCode": "27.1"
    },
    {
      "code": "27.20",
      "name": "Produksjon av batterier og akkumulatorer",
      "shortName": "Batterier, akkumulatorer",
      "level": 4,
      "parentCode": "27.2"
    },
    {
      "code": "27.31",
      "name": "Produksjon av optiske fiberkabler",
      "shortName": "Prod. av optiske fiberkabler",
      "level": 4,
      "parentCode": "27.3"
    },
    {
      "code": "27.32",
      "name": "Produksjon av andre elektroniske og elektriske ledninger og kabler",
      "shortName": "Elektron./el. ledninger/kabler el.",
      "level": 4,
      "parentCode": "27.3"
    },
    {
      "code": "27.33",
      "name": "Produksjon av ledningsmateriell",
      "shortName": "Prod. av ledningsmateriell",
      "level": 4,
      "parentCode": "27.3"
    },
    {
      "code": "27.40",
      "name": "Produksjon av belysningsutstyr",
      "shortName": "Prod. av belysningsutstyr",
      "level": 4,
      "parentCode": "27.4"
    },
    {
      "code": "27.51",
      "name": "Produksjon av elektriske husholdningsmaskiner og apparater",
      "shortName": "Elektr. hush.maskin-/apparatprod.",
      "level": 4,
      "parentCode": "27.5"
    },
    {
      "code": "27.52",
      "name": "Produksjon av ikke-elektriske husholdningsmaskiner og apparater",
      "shortName": "Ikke-el. hush.mask.-/apparatprod.",
      "level": 4,
      "parentCode": "27.5"
    },
    {
      "code": "27.90",
      "name": "Produksjon av annet elektrisk utstyr",
      "shortName": "Produksjon elektrisk utstyr ellers",
      "level": 4,
      "parentCode": "27.9"
    },
    {
      "code": "28.11",
      "name": "Produksjon av motorer og turbiner, unntatt motorer til luftfartøyer og motorvogner",
      "shortName": "Skipsmotor-/motor- og turbinprod. el.",
      "level": 4,
      "parentCode": "28.1"
    },
    {
      "code": "28.12",
      "name": "Produksjon av komponenter til hydraulisk og pneumatisk utstyr",
      "shortName": "Komp. til hydraul./pneumatisk utstyr",
      "level": 4,
      "parentCode": "28.1"
    },
    {
      "code": "28.13",
      "name": "Produksjon av pumper og kompressorer ellers",
      "shortName": "Pumpe- og kompressorprod. el.",
      "level": 4,
      "parentCode": "28.1"
    },
    {
      "code": "28.14",
      "name": "Produksjon av kraner og ventiler ellers",
      "shortName": "Kran- og ventilproduksjon el.",
      "level": 4,
      "parentCode": "28.1"
    },
    {
      "code": "28.15",
      "name": "Produksjon av lagre, gir, tannhjulsutvekslinger og andre innretninger for kraftoverføring",
      "shortName": "Lager-, girproduksjon mv.",
      "level": 4,
      "parentCode": "28.1"
    },
    {
      "code": "28.21",
      "name": "Produksjon av industri- og laboratorieovner samt brennere",
      "shortName": "Industri- og laboratorieovnprod.",
      "level": 4,
      "parentCode": "28.2"
    },
    {
      "code": "28.22",
      "name": "Produksjon av løfte- og håndteringsutstyr",
      "shortName": "Løfte- og håndteringsutstyr",
      "level": 4,
      "parentCode": "28.2"
    },
    {
      "code": "28.23",
      "name": "Produksjon av kontormaskiner og utstyr (unntatt datamaskiner og tilleggsutstyr)",
      "shortName": "Kontormaskinproduksjon",
      "level": 4,
      "parentCode": "28.2"
    },
    {
      "code": "28.24",
      "name": "Produksjon av motordrevet håndverktøy",
      "shortName": "Prod. av motordrevet håndverktøy",
      "level": 4,
      "parentCode": "28.2"
    },
    {
      "code": "28.25",
      "name": "Produksjon av kjøle- og ventilasjonsanlegg, unntatt til husholdningsbruk",
      "shortName": "Kjøle- og ventilasjonsanleggprod.",
      "level": 4,
      "parentCode": "28.2"
    },
    {
      "code": "28.29",
      "name": "Produksjon av maskiner og utstyr til generell bruk, ikke nevnt annet sted",
      "shortName": "Maskiner og utstyr til gen. bruk el.",
      "level": 4,
      "parentCode": "28.2"
    },
    {
      "code": "28.30",
      "name": "Produksjon av jordbruks- og skogbruksmaskiner",
      "shortName": "Jord- og skogbruksmaskinproduksjon",
      "level": 4,
      "parentCode": "28.3"
    },
    {
      "code": "28.41",
      "name": "Produksjon av maskinverktøy til metallbearbeiding",
      "shortName": "Maskinverktøy til metallbearb.",
      "level": 4,
      "parentCode": "28.4"
    },
    {
      "code": "28.49",
      "name": "Produksjon av maskinverktøy ikke nevnt annet sted",
      "shortName": "Prod. av maskinverktøy el.",
      "level": 4,
      "parentCode": "28.4"
    },
    {
      "code": "28.91",
      "name": "Produksjon av maskiner og utstyr til metallurgisk industri",
      "shortName": "Mask./utstyr metallurgisk industri",
      "level": 4,
      "parentCode": "28.9"
    },
    {
      "code": "28.92",
      "name": "Produksjon av maskiner og utstyr til bergverksdrift og bygge- og anleggsvirksomhet",
      "shortName": "Mask./utstyr bergverk, bygg og anl.",
      "level": 4,
      "parentCode": "28.9"
    },
    {
      "code": "28.93",
      "name": "Produksjon av maskiner og utstyr til nærings- og nytelsesmiddelindustri",
      "shortName": "Mask./utstyr næringsmiddelindustri",
      "level": 4,
      "parentCode": "28.9"
    },
    {
      "code": "28.94",
      "name": "Produksjon av maskiner og utstyr til tekstil-, konfeksjons- og lærvareindustri",
      "shortName": "Mask./utstyr tekstilindustri",
      "level": 4,
      "parentCode": "28.9"
    },
    {
      "code": "28.95",
      "name": "Produksjon av maskiner og utstyr til papir- og pappvareindustri",
      "shortName": "Mask./utstyr papir- og pappvareindustri",
      "level": 4,
      "parentCode": "28.9"
    },
    {
      "code": "28.96",
      "name": "Produksjon av maskiner og utstyr til plast- og gummiindustri",
      "shortName": "Mask./utstyr plast- og gummiindustri",
      "level": 4,
      "parentCode": "28.9"
    },
    {
      "code": "28.99",
      "name": "Produksjon av spesialmaskiner ikke nevnt annet sted",
      "shortName": "Spesialmaskinproduksjon el.",
      "level": 4,
      "parentCode": "28.9"
    },
    {
      "code": "29.10",
      "name": "Produksjon av motorvogner",
      "shortName": "Motorvognproduksjon",
      "level": 4,
      "parentCode": "29.1"
    },
    {
      "code": "29.20",
      "name": "Produksjon av karosserier og tilhengere",
      "shortName": "Karosseri- og tilhengerproduksjon",
      "level": 4,
      "parentCode": "29.2"
    },
    {
      "code": "29.31",
      "name": "Produksjon av elektrisk og elektronisk utstyr til motorvogner",
      "shortName": "Elektrisk/elektron. utstyr motorv.",
      "level": 4,
      "parentCode": "29.3"
    },
    {
      "code": "29.32",
      "name": "Produksjon av andre deler og annet utstyr til motorvogner",
      "shortName": "Annet utstyr-/delprod. til motorv.",
      "level": 4,
      "parentCode": "29.3"
    },
    {
      "code": "30.11",
      "name": "Bygging av skip og flytende materiell",
      "shortName": "Bygg av skip og flytende materiell",
      "level": 4,
      "parentCode": "30.1"
    },
    {
      "code": "30.12",
      "name": "Bygging av fritidsbåter",
      "shortName": "Bygging av fritidsbåter",
      "level": 4,
      "parentCode": "30.1"
    },
    {
      "code": "30.20",
      "name": "Produksjon av lokomotiver og annet rullende materiell til jernbane og sporvei",
      "shortName": "Jernbane- og sporvognmateriell mv.",
      "level": 4,
      "parentCode": "30.2"
    },
    {
      "code": "30.30",
      "name": "Produksjon av luftfartøyer og romfartøyer og lignende utstyr",
      "shortName": "Prod. luft- og romfartøy og lignende",
      "level": 4,
      "parentCode": "30.3"
    },
    {
      "code": "30.40",
      "name": "Produksjon av militære stridskjøretøyer",
      "shortName": "Produksjon militære stridskjøretøy",
      "level": 4,
      "parentCode": "30.4"
    },
    {
      "code": "30.91",
      "name": "Produksjon av motorsykler",
      "shortName": "Motorsykkelproduksjon",
      "level": 4,
      "parentCode": "30.9"
    },
    {
      "code": "30.92",
      "name": "Produksjon av sykler og invalidevogner",
      "shortName": "Sykkel- og invalidevognprod.",
      "level": 4,
      "parentCode": "30.9"
    },
    {
      "code": "30.99",
      "name": "Produksjon av andre transportmidler ikke nevnt annet sted",
      "shortName": "Transportmiddelproduksjon el.",
      "level": 4,
      "parentCode": "30.9"
    },
    {
      "code": "31.01",
      "name": "Produksjon av kontor- og butikkmøbler",
      "shortName": "Kontor- og butikkmøbelprod.",
      "level": 4,
      "parentCode": "31.0"
    },
    {
      "code": "31.02",
      "name": "Produksjon av kjøkkenmøbler",
      "shortName": "Kjøkkenmøbelproduksjon",
      "level": 4,
      "parentCode": "31.0"
    },
    {
      "code": "31.03",
      "name": "Produksjon av madrasser",
      "shortName": "Madrassproduksjon",
      "level": 4,
      "parentCode": "31.0"
    },
    {
      "code": "31.09",
      "name": "Produksjon av møbler ellers",
      "shortName": "Møbelproduksjon el.",
      "level": 4,
      "parentCode": "31.0"
    },
    {
      "code": "32.11",
      "name": "Preging av mynter og medaljer",
      "shortName": "Mynt- og medaljepreging",
      "level": 4,
      "parentCode": "32.1"
    },
    {
      "code": "32.12",
      "name": "Produksjon av gull- og sølvvarer og lignende artikler",
      "shortName": "Gull- og sølvvareprod. mv.",
      "level": 4,
      "parentCode": "32.1"
    },
    {
      "code": "32.13",
      "name": "Produksjon av bijouteri og lignende artikler",
      "shortName": "Bijouterivareproduksjon mv.",
      "level": 4,
      "parentCode": "32.1"
    },
    {
      "code": "32.20",
      "name": "Produksjon av musikkinstrumenter",
      "shortName": "Musikkinstrumentproduksjon",
      "level": 4,
      "parentCode": "32.2"
    },
    {
      "code": "32.30",
      "name": "Produksjon av sportsartikler",
      "shortName": "Sportsartikkelproduksjon",
      "level": 4,
      "parentCode": "32.3"
    },
    {
      "code": "32.40",
      "name": "Produksjon av spill og leker",
      "shortName": "Spill- og leketøyproduksjon",
      "level": 4,
      "parentCode": "32.4"
    },
    {
      "code": "32.50",
      "name": "Produksjon av medisinske og tanntekniske instrumenter og utstyr",
      "shortName": "Medisinske og tanntekniske instr.",
      "level": 4,
      "parentCode": "32.5"
    },
    {
      "code": "32.91",
      "name": "Produksjon av koster og børster",
      "shortName": "Kost- og børsteproduksjon",
      "level": 4,
      "parentCode": "32.9"
    },
    {
      "code": "32.99",
      "name": "Annen industriproduksjon ikke nevnt annet sted",
      "shortName": "Industriproduksjon ellers",
      "level": 4,
      "parentCode": "32.9"
    },
    {
      "code": "33.11",
      "name": "Reparasjon av bearbeidede metallprodukter",
      "shortName": "Rep. av bearbeidede metallprodukter",
      "level": 4,
      "parentCode": "33.1"
    },
    {
      "code": "33.12",
      "name": "Reparasjon av maskiner",
      "shortName": "Reparasjon av maskiner",
      "level": 4,
      "parentCode": "33.1"
    },
    {
      "code": "33.13",
      "name": "Reparasjon av elektronisk og optisk utstyr",
      "shortName": "Rep. av elektronisk og optisk utstyr",
      "level": 4,
      "parentCode": "33.1"
    },
    {
      "code": "33.14",
      "name": "Reparasjon av elektrisk utstyr",
      "shortName": "Rep. av elektrisk utstyr",
      "level": 4,
      "parentCode": "33.1"
    },
    {
      "code": "33.15",
      "name": "Reparasjon og vedlikehold av skip og båter",
      "shortName": "Rep./vedlikehold av skip og båter",
      "level": 4,
      "parentCode": "33.1"
    },
    {
      "code": "33.16",
      "name": "Reparasjon og vedlikehold av luftfartøyer og romfartøyer",
      "shortName": "Rep./vedlikeh. luft- og romfartøyer",
      "level": 4,
      "parentCode": "33.1"
    },
    {
      "code": "33.17",
      "name": "Reparasjon og vedlikehold av andre transportmidler",
      "shortName": "Rep./vedlikeh. av andre transportmidler",
      "level": 4,
      "parentCode": "33.1"
    },
    {
      "code": "33.19",
      "name": "Reparasjon av annet utstyr",
      "shortName": "Rep. av annet utstyr",
      "level": 4,
      "parentCode": "33.1"
    },
    {
      "code": "33.20",
      "name": "Installasjon av industrimaskiner og -utstyr",
      "shortName": "Installasjon industrimask. og utstyr",
      "level": 4,
      "parentCode": "33.2"
    },
    {
      "code": "35.11",
      "name": "Produksjon av elektrisitet",
      "shortName": "Produksjon av elektrisitet",
      "level": 4,
      "parentCode": "35.1"
    },
    {
      "code": "35.12",
      "name": "Overføring av elektrisitet",
      "shortName": "Overføring av elektrisitet",
      "level": 4,
      "parentCode": "35.1"
    },
    {
      "code": "35.13",
      "name": "Distribusjon av elektrisitet",
      "shortName": "Distribusjon av elektrisitet",
      "level": 4,
      "parentCode": "35.1"
    },
    {
      "code": "35.14",
      "name": "Handel med elektrisitet",
      "shortName": "Handel med elektrisitet",
      "level": 4,
      "parentCode": "35.1"
    },
    {
      "code": "35.21",
      "name": "Produksjon av gass",
      "shortName": "Gassproduksjon",
      "level": 4,
      "parentCode": "35.2"
    },
    {
      "code": "35.22",
      "name": "Distribusjon av gass gjennom ledningsnett",
      "shortName": "Gassdistrib. via. ledningsnett",
      "level": 4,
      "parentCode": "35.2"
    },
    {
      "code": "35.23",
      "name": "Handel med gass gjennom ledningsnett",
      "shortName": "Handel med gass via ledningsnett",
      "level": 4,
      "parentCode": "35.2"
    },
    {
      "code": "35.30",
      "name": "Damp- og varmtvannsforsyning",
      "shortName": "Damp- og varmtvannsforsyning",
      "level": 4,
      "parentCode": "35.3"
    },
    {
      "code": "36.00",
      "name": "Uttak fra kilde, rensing og distribusjon av vann",
      "shortName": "Vannforsyning",
      "level": 4,
      "parentCode": "36.0"
    },
    {
      "code": "37.00",
      "name": "Oppsamling og behandling av avløpsvann",
      "shortName": "Håndtering av avløpsvann",
      "level": 4,
      "parentCode": "37.0"
    },
    {
      "code": "38.11",
      "name": "Innsamling av ikke-farlig avfall",
      "shortName": "Innsaml. av ikke-farlig avfall",
      "level": 4,
      "parentCode": "38.1"
    },
    {
      "code": "38.12",
      "name": "Innsamling av farlig avfall",
      "shortName": "Innsamling av farlig avfall",
      "level": 4,
      "parentCode": "38.1"
    },
    {
      "code": "38.21",
      "name": "Behandling og disponering av ikke-farlig avfall",
      "shortName": "Behandl. og disp. av ikke-farlig avfall",
      "level": 4,
      "parentCode": "38.2"
    },
    {
      "code": "38.22",
      "name": "Behandling og disponering av farlig avfall",
      "shortName": "Behandl. og disp. av farlig avfall",
      "level": 4,
      "parentCode": "38.2"
    },
    {
      "code": "38.31",
      "name": "Demontering av vrakede gjenstander",
      "shortName": "Demont. av vrakede gjenstander",
      "level": 4,
      "parentCode": "38.3"
    },
    {
      "code": "38.32",
      "name": "Sortering og bearbeiding av avfall for materialgjenvinning",
      "shortName": "Sort./bearb. avfall for matr.gjenv.",
      "level": 4,
      "parentCode": "38.3"
    },
    {
      "code": "39.00",
      "name": "Miljørydding, miljørensing og lignende virksomhet",
      "shortName": "Miljørydding og miljørensing",
      "level": 4,
      "parentCode": "39.0"
    },
    {
      "code": "41.10",
      "name": "Utvikling av byggeprosjekter",
      "shortName": "Utvikling av byggeprosjekter",
      "level": 4,
      "parentCode": "41.1"
    },
    {
      "code": "41.20",
      "name": "Oppføring av bygninger",
      "shortName": "Oppføring av bygninger",
      "level": 4,
      "parentCode": "41.2"
    },
    {
      "code": "42.11",
      "name": "Bygging av veier og motorveier",
      "shortName": "Bygging av veier og motorveier",
      "level": 4,
      "parentCode": "42.1"
    },
    {
      "code": "42.12",
      "name": "Bygging av jernbaner og undergrunnsbaner",
      "shortName": "Bygg. av jernbaner/undergrunnsbaner",
      "level": 4,
      "parentCode": "42.1"
    },
    {
      "code": "42.13",
      "name": "Bygging av bruer og tunneler",
      "shortName": "Bygging av bruer og tunneler",
      "level": 4,
      "parentCode": "42.1"
    },
    {
      "code": "42.21",
      "name": "Bygging av vann- og kloakkanlegg",
      "shortName": "Bygging av vann- og kloakkanl.",
      "level": 4,
      "parentCode": "42.2"
    },
    {
      "code": "42.22",
      "name": "Bygging av anlegg for elektrisitet og telekommunikasjon",
      "shortName": "Bygg. av el.anl. og telekomm.anl.",
      "level": 4,
      "parentCode": "42.2"
    },
    {
      "code": "42.91",
      "name": "Bygging av havne- og damanlegg",
      "shortName": "Bygging av havne- og damanlegg",
      "level": 4,
      "parentCode": "42.9"
    },
    {
      "code": "42.99",
      "name": "Bygging av andre anlegg ikke nevnt annet sted",
      "shortName": "Bygging av andre anlegg",
      "level": 4,
      "parentCode": "42.9"
    },
    {
      "code": "43.11",
      "name": "Riving av bygninger og andre konstruksjoner",
      "shortName": "Riv. av bygn./andre konstruksjoner",
      "level": 4,
      "parentCode": "43.1"
    },
    {
      "code": "43.12",
      "name": "Grunnarbeid",
      "shortName": "Grunnarbeid",
      "level": 4,
      "parentCode": "43.1"
    },
    {
      "code": "43.13",
      "name": "Prøveboring",
      "shortName": "Prøveboring",
      "level": 4,
      "parentCode": "43.1"
    },
    {
      "code": "43.21",
      "name": "Elektrisk installasjonsarbeid",
      "shortName": "Elektrisk installasjonsarbeid",
      "level": 4,
      "parentCode": "43.2"
    },
    {
      "code": "43.22",
      "name": "VVS-arbeid",
      "shortName": "VVS-arbeid",
      "level": 4,
      "parentCode": "43.2"
    },
    {
      "code": "43.29",
      "name": "Annet installasjonsarbeid",
      "shortName": "Annet installasjonsarbeid",
      "level": 4,
      "parentCode": "43.2"
    },
    {
      "code": "43.31",
      "name": "Stukkatørarbeid og pussing",
      "shortName": "Stukkatørarbeid og pussing",
      "level": 4,
      "parentCode": "43.3"
    },
    {
      "code": "43.32",
      "name": "Snekkerarbeid",
      "shortName": "Snekkerarbeid",
      "level": 4,
      "parentCode": "43.3"
    },
    {
      "code": "43.33",
      "name": "Gulvlegging og tapetsering",
      "shortName": "Gulvlegging og tapetsering",
      "level": 4,
      "parentCode": "43.3"
    },
    {
      "code": "43.34",
      "name": "Maler- og glassarbeid",
      "shortName": "Maler- og glassarbeid",
      "level": 4,
      "parentCode": "43.3"
    },
    {
      "code": "43.39",
      "name": "Annen ferdiggjøring av bygninger",
      "shortName": "Annen ferdiggjøring av bygninger",
      "level": 4,
      "parentCode": "43.3"
    },
    {
      "code": "43.91",
      "name": "Takarbeid",
      "shortName": "Takarbeid",
      "level": 4,
      "parentCode": "43.9"
    },
    {
      "code": "43.99",
      "name": "Annen spesialisert bygge- og anleggsvirksomhet",
      "shortName": "Annen spes. bygge- og anleggsvirks.",
      "level": 4,
      "parentCode": "43.9"
    },
    {
      "code": "45.11",
      "name": "Handel med biler og lette motorvogner, unntatt motorsykler",
      "shortName": "Handel med biler og lette motorv.",
      "level": 4,
      "parentCode": "45.1"
    },
    {
      "code": "45.19",
      "name": "Handel med andre motorvogner, unntatt motorsykler",
      "shortName": "Handel med andre motorvogner",
      "level": 4,
      "parentCode": "45.1"
    },
    {
      "code": "45.20",
      "name": "Vedlikehold og reparasjon av motorvogner, unntatt motorsykler",
      "shortName": "Rep. av motorvogner/unnt. motorsyk.",
      "level": 4,
      "parentCode": "45.2"
    },
    {
      "code": "45.31",
      "name": "Agentur- og engroshandel med deler og utstyr til motorvogner, unntatt motorsykler",
      "shortName": "Agent.-/engrosh. motorv./-deler mv.",
      "level": 4,
      "parentCode": "45.3"
    },
    {
      "code": "45.32",
      "name": "Detaljhandel med deler og utstyr til motorvogner, unntatt motorsykler",
      "shortName": "Detalj. deler/utstyr til motorvogn",
      "level": 4,
      "parentCode": "45.3"
    },
    {
      "code": "45.40",
      "name": "Handel med motorsykler, deler og utstyr. Vedlikehold og reparasjon av motorsykler",
      "shortName": "Motorsykkelhandel og -rep. mv.",
      "level": 4,
      "parentCode": "45.4"
    },
    {
      "code": "46.11",
      "name": "Agenturhandel med jordbruksråvarer, levende dyr, tekstilråvarer og innsatsvarer",
      "shortName": "Agentur jordbr. og tekstilråv. mv.",
      "level": 4,
      "parentCode": "46.1"
    },
    {
      "code": "46.12",
      "name": "Agenturhandel med brensel, drivstoff, malm, metaller og industrikjemikalier",
      "shortName": "Agentur brensel, drivstoff mv.",
      "level": 4,
      "parentCode": "46.1"
    },
    {
      "code": "46.13",
      "name": "Agenturhandel med tømmer, trelast og byggevarer",
      "shortName": "Agentur tømmer, trelast, byggev.",
      "level": 4,
      "parentCode": "46.1"
    },
    {
      "code": "46.14",
      "name": "Agenturhandel med maskiner, produksjonsutstyr, båter og luftfartøyer",
      "shortName": "Agentur maskiner, prod.utstyr mv.",
      "level": 4,
      "parentCode": "46.1"
    },
    {
      "code": "46.15",
      "name": "Agenturhandel med møbler, husholdningsvarer og jernvarer",
      "shortName": "Agentur møbler, hush.- og jernvarer",
      "level": 4,
      "parentCode": "46.1"
    },
    {
      "code": "46.16",
      "name": "Agenturhandel med tekstiler, klær, pelsskinn, skotøy og lærvarer",
      "shortName": "Agentur tekstiler/klær/skotøy mv.",
      "level": 4,
      "parentCode": "46.1"
    },
    {
      "code": "46.17",
      "name": "Agenturhandel med nærings- og nytelsesmidler",
      "shortName": "Agentur nærings- og nytelsesmidler",
      "level": 4,
      "parentCode": "46.1"
    },
    {
      "code": "46.18",
      "name": "Agenturhandel med spesialisert vareutvalg ellers",
      "shortName": "Agentur spesialisert vareutvalg el.",
      "level": 4,
      "parentCode": "46.1"
    },
    {
      "code": "46.19",
      "name": "Agenturhandel med bredt vareutvalg",
      "shortName": "Agentur bredt vareutvalg",
      "level": 4,
      "parentCode": "46.1"
    },
    {
      "code": "46.21",
      "name": "Engroshandel med korn, råtobakk, såvarer og fôrvarer",
      "shortName": "Engrosh. korn, såvarer og fôr",
      "level": 4,
      "parentCode": "46.2"
    },
    {
      "code": "46.22",
      "name": "Engroshandel med blomster og planter",
      "shortName": "Engrosh. blomster og planter",
      "level": 4,
      "parentCode": "46.2"
    },
    {
      "code": "46.23",
      "name": "Engroshandel med levende dyr",
      "shortName": "Engrosh. levende dyr",
      "level": 4,
      "parentCode": "46.2"
    },
    {
      "code": "46.24",
      "name": "Engroshandel med huder, skinn og lær",
      "shortName": "Engrosh. huder, skinn og lær",
      "level": 4,
      "parentCode": "46.2"
    },
    {
      "code": "46.31",
      "name": "Engroshandel med frukt og grønnsaker",
      "shortName": "Engrosh. frukt og grønnsaker",
      "level": 4,
      "parentCode": "46.3"
    },
    {
      "code": "46.32",
      "name": "Engroshandel med kjøtt og kjøttvarer",
      "shortName": "Engrosh. kjøtt og kjøttvarer",
      "level": 4,
      "parentCode": "46.3"
    },
    {
      "code": "46.33",
      "name": "Engroshandel med meierivarer, egg, matolje og -fett",
      "shortName": "Engrosh. meierivarer, egg mv.",
      "level": 4,
      "parentCode": "46.3"
    },
    {
      "code": "46.34",
      "name": "Engroshandel med drikkevarer",
      "shortName": "Engrosh. drikkevarer",
      "level": 4,
      "parentCode": "46.3"
    },
    {
      "code": "46.35",
      "name": "Engroshandel med tobakksvarer",
      "shortName": "Engrosh. tobakksvarer",
      "level": 4,
      "parentCode": "46.3"
    },
    {
      "code": "46.36",
      "name": "Engroshandel med sukker, sjokolade og sukkervarer",
      "shortName": "Engrosh. sukker, sjok. og sukkerv.",
      "level": 4,
      "parentCode": "46.3"
    },
    {
      "code": "46.37",
      "name": "Engroshandel med kaffe, te, kakao og krydder",
      "shortName": "Engrosh. kaffe, te, kakao mv.",
      "level": 4,
      "parentCode": "46.3"
    },
    {
      "code": "46.38",
      "name": "Engroshandel med andre næringsmidler, herunder fisk, skalldyr og bløtdyr",
      "shortName": "Engrosh. andre næringsmidler",
      "level": 4,
      "parentCode": "46.3"
    },
    {
      "code": "46.39",
      "name": "Engroshandel med bredt utvalg av nærings- og nytelsesmidler",
      "shortName": "Engrosh. bredt utv. nær.-/nyt. midl",
      "level": 4,
      "parentCode": "46.3"
    },
    {
      "code": "46.41",
      "name": "Engroshandel med tekstiler og utstyrsvarer",
      "shortName": "Engrosh. tekstiler og utstyrsvarer",
      "level": 4,
      "parentCode": "46.4"
    },
    {
      "code": "46.42",
      "name": "Engroshandel med klær og skotøy",
      "shortName": "Engrosh. klær og skotøy",
      "level": 4,
      "parentCode": "46.4"
    },
    {
      "code": "46.43",
      "name": "Engroshandel med elektriske husholdningsapparater",
      "shortName": "Engrosh. el. husholdningsapp. mv..",
      "level": 4,
      "parentCode": "46.4"
    },
    {
      "code": "46.44",
      "name": "Engroshandel med kjøkkenutstyr, glass, steintøy og rengjøringsmidler",
      "shortName": "Engrosh. kjøkkenutstyr, steintøy mv.",
      "level": 4,
      "parentCode": "46.4"
    },
    {
      "code": "46.45",
      "name": "Engroshandel med parfyme og kosmetikk",
      "shortName": "Engrosh. parfyme og kosmetikk",
      "level": 4,
      "parentCode": "46.4"
    },
    {
      "code": "46.46",
      "name": "Engroshandel med sykepleie- og apotekvarer",
      "shortName": "Engrosh. sykepleie- og apotekvarer",
      "level": 4,
      "parentCode": "46.4"
    },
    {
      "code": "46.47",
      "name": "Engroshandel med møbler, gulvbelegg, gulvtepper og belysningsutstyr",
      "shortName": "Engrosh. møbler og innredningsart.",
      "level": 4,
      "parentCode": "46.4"
    },
    {
      "code": "46.48",
      "name": "Engroshandel med klokker, ur, gull- og sølvvarer",
      "shortName": "Engrosh. klokker/ur/gull-/sølvvarer",
      "level": 4,
      "parentCode": "46.4"
    },
    {
      "code": "46.49",
      "name": "Engroshandel med husholdningsvarer og varer til personlig bruk ellers",
      "shortName": "Engrosh. husholdningsvarer m.m.",
      "level": 4,
      "parentCode": "46.4"
    },
    {
      "code": "46.51",
      "name": "Engroshandel med datamaskiner, tilleggsutstyr til datamaskiner samt programvare",
      "shortName": "Engrosh. datamask., programv. mv..",
      "level": 4,
      "parentCode": "46.5"
    },
    {
      "code": "46.52",
      "name": "Engroshandel med elektronikkutstyr og telekommunikasjonsutstyr samt deler",
      "shortName": "Engrosh. elektronikk-/telekomm.uts.",
      "level": 4,
      "parentCode": "46.5"
    },
    {
      "code": "46.61",
      "name": "Engroshandel med maskiner og utstyr til jordbruk og skogbruk",
      "shortName": "Engrosh. jordbr.-/skogbr.mask. mv.",
      "level": 4,
      "parentCode": "46.6"
    },
    {
      "code": "46.62",
      "name": "Engroshandel med maskinverktøy",
      "shortName": "Engrosh. maskinverktøy",
      "level": 4,
      "parentCode": "46.6"
    },
    {
      "code": "46.63",
      "name": "Engroshandel med maskiner og utstyr til bergverksdrift, olje- og gassutvinning og bygge- og anleggsvirksomhet",
      "shortName": "Engros mask bygg/anl./oljeutv. mv.",
      "level": 4,
      "parentCode": "46.6"
    },
    {
      "code": "46.64",
      "name": "Engroshandel med maskiner og utstyr til tekstilproduksjon",
      "shortName": "Engrosh. tekstilprod.maskiner mv.",
      "level": 4,
      "parentCode": "46.6"
    },
    {
      "code": "46.65",
      "name": "Engroshandel med kontormøbler",
      "shortName": "Engrosh. kontormøbler",
      "level": 4,
      "parentCode": "46.6"
    },
    {
      "code": "46.66",
      "name": "Engroshandel med maskiner og utstyr til kontor ellers",
      "shortName": "Engrosh. kontormask., -utstyr el.",
      "level": 4,
      "parentCode": "46.6"
    },
    {
      "code": "46.69",
      "name": "Engroshandel med maskiner og utstyr ellers",
      "shortName": "Engrosh. maskiner og utstyr el.",
      "level": 4,
      "parentCode": "46.6"
    },
    {
      "code": "46.71",
      "name": "Engroshandel med drivstoff og brensel",
      "shortName": "Engrosh. drivstoff og brensel",
      "level": 4,
      "parentCode": "46.7"
    },
    {
      "code": "46.72",
      "name": "Engroshandel med metaller og metallholdig malm",
      "shortName": "Engrosh. metaller og metallh. malm",
      "level": 4,
      "parentCode": "46.7"
    },
    {
      "code": "46.73",
      "name": "Engroshandel med tømmer, trelast, byggevarer og sanitærutstyr",
      "shortName": "Engrosh. tømmer/trelast/byggev. mv.",
      "level": 4,
      "parentCode": "46.7"
    },
    {
      "code": "46.74",
      "name": "Engroshandel med jernvarer, rørleggerartikler og oppvarmingsutstyr",
      "shortName": "Engrosh. jernv., rørleggerart. m.m.",
      "level": 4,
      "parentCode": "46.7"
    },
    {
      "code": "46.75",
      "name": "Engroshandel med kjemiske produkter",
      "shortName": "Engrosh. kjemiske produkter",
      "level": 4,
      "parentCode": "46.7"
    },
    {
      "code": "46.76",
      "name": "Engroshandel med innsatsvarer ellers",
      "shortName": "Engrosh. innsatsvarer el.",
      "level": 4,
      "parentCode": "46.7"
    },
    {
      "code": "46.77",
      "name": "Engroshandel med avfall og skrap",
      "shortName": "Engrosh. avfall og skrap",
      "level": 4,
      "parentCode": "46.7"
    },
    {
      "code": "46.90",
      "name": "Uspesifisert engroshandel",
      "shortName": "Uspesifisert engroshandel",
      "level": 4,
      "parentCode": "46.9"
    },
    {
      "code": "47.11",
      "name": "Butikkhandel med bredt vareutvalg med hovedvekt på nærings- og nytelsesmidler",
      "shortName": "Butikkh. bredt utvalg nær.midler mv.",
      "level": 4,
      "parentCode": "47.1"
    },
    {
      "code": "47.19",
      "name": "Butikkhandel med bredt vareutvalg ellers",
      "shortName": "Butikkh. bredt vareutvalg el.",
      "level": 4,
      "parentCode": "47.1"
    },
    {
      "code": "47.21",
      "name": "Butikkhandel med frukt og grønnsaker",
      "shortName": "Butikkh. frukt og grønnsaker",
      "level": 4,
      "parentCode": "47.2"
    },
    {
      "code": "47.22",
      "name": "Butikkhandel med kjøtt og kjøttvarer",
      "shortName": "Butikkh. kjøtt og kjøttvarer",
      "level": 4,
      "parentCode": "47.2"
    },
    {
      "code": "47.23",
      "name": "Butikkhandel med fisk, skalldyr og bløtdyr",
      "shortName": "Butikkh. fisk, skalldyr og bløtdyr",
      "level": 4,
      "parentCode": "47.2"
    },
    {
      "code": "47.24",
      "name": "Butikkhandel med bakervarer, konditorvarer og sukkervarer",
      "shortName": "Butikkh. baker-, konditorvarer mv.",
      "level": 4,
      "parentCode": "47.2"
    },
    {
      "code": "47.25",
      "name": "Butikkhandel med drikkevarer",
      "shortName": "Butikkh. drikkevarer",
      "level": 4,
      "parentCode": "47.2"
    },
    {
      "code": "47.26",
      "name": "Butikkhandel med tobakksvarer",
      "shortName": "Butikkh. tobakksvarer",
      "level": 4,
      "parentCode": "47.2"
    },
    {
      "code": "47.29",
      "name": "Butikkhandel med nærings- og nytelsesmidler ellers",
      "shortName": "Butikkh. nær.- og nytelsesmidler el.",
      "level": 4,
      "parentCode": "47.2"
    },
    {
      "code": "47.30",
      "name": "Detaljhandel med drivstoff til motorvogner",
      "shortName": "Detaljh. drivstoff til motorvogner",
      "level": 4,
      "parentCode": "47.3"
    },
    {
      "code": "47.41",
      "name": "Butikkhandel med datamaskiner og utstyr til datamaskiner",
      "shortName": "Butikkh. datamask. og tilleggsutst.",
      "level": 4,
      "parentCode": "47.4"
    },
    {
      "code": "47.42",
      "name": "Butikkhandel med telekommunikasjonsutstyr",
      "shortName": "Butikkh. telekommunikasjonsutstyr",
      "level": 4,
      "parentCode": "47.4"
    },
    {
      "code": "47.43",
      "name": "Butikkhandel med audio- og videoutstyr",
      "shortName": "Butikkh. audio- og videoutstyr",
      "level": 4,
      "parentCode": "47.4"
    },
    {
      "code": "47.51",
      "name": "Butikkhandel med tekstiler og utstyrsvarer",
      "shortName": "Butikkh. tekstiler og utstyrsvarer",
      "level": 4,
      "parentCode": "47.5"
    },
    {
      "code": "47.52",
      "name": "Butikkhandel med jernvarer, fargevarer og glass",
      "shortName": "Butikkh. jernv., fargev. og glass",
      "level": 4,
      "parentCode": "47.5"
    },
    {
      "code": "47.53",
      "name": "Butikkhandel med tapeter, gulvtepper og gardiner",
      "shortName": "Butikkh. tapet/gulvtepper/gardiner",
      "level": 4,
      "parentCode": "47.5"
    },
    {
      "code": "47.54",
      "name": "Butikkhandel med elektriske husholdningsapparater",
      "shortName": "Butikkh. el. hush.apparater",
      "level": 4,
      "parentCode": "47.5"
    },
    {
      "code": "47.59",
      "name": "Butikkhandel med møbler, belysningsutstyr og andre innredningsartikler",
      "shortName": "Butikkh. møbler/belys.utstyr mv.",
      "level": 4,
      "parentCode": "47.5"
    },
    {
      "code": "47.61",
      "name": "Butikkhandel med bøker",
      "shortName": "Butikkh. bøker",
      "level": 4,
      "parentCode": "47.6"
    },
    {
      "code": "47.62",
      "name": "Butikkhandel med aviser og papirvarer",
      "shortName": "Butikkh. aviser og papirvarer",
      "level": 4,
      "parentCode": "47.6"
    },
    {
      "code": "47.63",
      "name": "Butikkhandel med innspillinger av musikk og video",
      "shortName": "Butikkh. innspill. av musikk/video",
      "level": 4,
      "parentCode": "47.6"
    },
    {
      "code": "47.64",
      "name": "Butikkhandel med sportsutstyr",
      "shortName": "Butikkh. sportsutstyr",
      "level": 4,
      "parentCode": "47.6"
    },
    {
      "code": "47.65",
      "name": "Butikkhandel med spill og leker",
      "shortName": "Butikkh. spill og leker",
      "level": 4,
      "parentCode": "47.6"
    },
    {
      "code": "47.71",
      "name": "Butikkhandel med klær",
      "shortName": "Butikkh. klær",
      "level": 4,
      "parentCode": "47.7"
    },
    {
      "code": "47.72",
      "name": "Butikkhandel med skotøy og lærvarer",
      "shortName": "Butikkh. skotøy og lærvarer",
      "level": 4,
      "parentCode": "47.7"
    },
    {
      "code": "47.73",
      "name": "Butikkhandel med apotekvarer",
      "shortName": "Butikkh. apotekvarer",
      "level": 4,
      "parentCode": "47.7"
    },
    {
      "code": "47.74",
      "name": "Butikkhandel med medisinske og ortopediske artikler",
      "shortName": "Butikkh. medisinske/ortop. art.",
      "level": 4,
      "parentCode": "47.7"
    },
    {
      "code": "47.75",
      "name": "Butikkhandel med kosmetikk og toalettartikler",
      "shortName": "Butikkh. kosmetikk og toalettart.",
      "level": 4,
      "parentCode": "47.7"
    },
    {
      "code": "47.76",
      "name": "Butikkhandel med blomster og planter, kjæledyr og fôrvarer til kjæledyr",
      "shortName": "Butikkh. blomster/planter mv.",
      "level": 4,
      "parentCode": "47.7"
    },
    {
      "code": "47.77",
      "name": "Butikkhandel med ur, gull- og sølvvarer",
      "shortName": "Butikkh. ur, gull- og sølvvarer",
      "level": 4,
      "parentCode": "47.7"
    },
    {
      "code": "47.78",
      "name": "Annen butikkhandel med andre nye varer i spesialforretninger",
      "shortName": "Butikkh. nye varer i spes.forr. el.",
      "level": 4,
      "parentCode": "47.7"
    },
    {
      "code": "47.79",
      "name": "Butikkhandel med brukte varer",
      "shortName": "Butikkh. brukte varer",
      "level": 4,
      "parentCode": "47.7"
    },
    {
      "code": "47.81",
      "name": "Torghandel med næringsmidler, drikkevarer og tobakksvarer",
      "shortName": "Torgh. nær.midl./drikkev./tobakksv.",
      "level": 4,
      "parentCode": "47.8"
    },
    {
      "code": "47.82",
      "name": "Torghandel med tekstiler, klær, skotøy og utstyrsvarer",
      "shortName": "Torgh. tekstiler, klær, skotøy m.m.",
      "level": 4,
      "parentCode": "47.8"
    },
    {
      "code": "47.89",
      "name": "Torghandel med andre varer",
      "shortName": "Torgh. andre varer",
      "level": 4,
      "parentCode": "47.8"
    },
    {
      "code": "47.91",
      "name": "Postordrehandel og handel via Internett",
      "shortName": "Postordreh. og handel via Internett",
      "level": 4,
      "parentCode": "47.9"
    },
    {
      "code": "47.99",
      "name": "Detaljhandel utenom utsalgssted ellers",
      "shortName": "Detaljh. utenom utsalgssted el.",
      "level": 4,
      "parentCode": "47.9"
    },
    {
      "code": "49.10",
      "name": "Passasjertransport med jernbane",
      "shortName": "Passasjertransp. med jernbane",
      "level": 4,
      "parentCode": "49.1"
    },
    {
      "code": "49.20",
      "name": "Godstransport med jernbane",
      "shortName": "Godstransp. med jernbane",
      "level": 4,
      "parentCode": "49.2"
    },
    {
      "code": "49.31",
      "name": "Transport med rutebil og sporvei i by- og forstadsområde",
      "shortName": "Rutebil/sporvei i by-/forstadsomr.",
      "level": 4,
      "parentCode": "49.3"
    },
    {
      "code": "49.32",
      "name": "Drosjebiltransport",
      "shortName": "Drosjebiltransport",
      "level": 4,
      "parentCode": "49.3"
    },
    {
      "code": "49.39",
      "name": "Landtransport med passasjerer ikke nevnt annet sted",
      "shortName": "Landtr. med passasjerer el.",
      "level": 4,
      "parentCode": "49.3"
    },
    {
      "code": "49.41",
      "name": "Godstransport på vei",
      "shortName": "Godstransport på vei",
      "level": 4,
      "parentCode": "49.4"
    },
    {
      "code": "49.42",
      "name": "Flyttetransport",
      "shortName": "Flyttetransport",
      "level": 4,
      "parentCode": "49.4"
    },
    {
      "code": "49.50",
      "name": "Rørtransport",
      "shortName": "Rørtransport",
      "level": 4,
      "parentCode": "49.5"
    },
    {
      "code": "50.10",
      "name": "Sjøfart og kysttrafikk med passasjerer",
      "shortName": "Sjøfart og kysttraf. m/passasjerer",
      "level": 4,
      "parentCode": "50.1"
    },
    {
      "code": "50.20",
      "name": "Sjøfart og kysttrafikk med gods",
      "shortName": "Sjøfart og kysttrafikk med gods",
      "level": 4,
      "parentCode": "50.2"
    },
    {
      "code": "50.30",
      "name": "Passasjertransport på elver og innsjøer",
      "shortName": "Passasjertr. på elver og innsjøer",
      "level": 4,
      "parentCode": "50.3"
    },
    {
      "code": "50.40",
      "name": "Godstransport på elver og innsjøer",
      "shortName": "Godstransp. på elver og innsjøer",
      "level": 4,
      "parentCode": "50.4"
    },
    {
      "code": "51.10",
      "name": "Lufttransport med passasjerer",
      "shortName": "Lufttransp. med passasjerer",
      "level": 4,
      "parentCode": "51.1"
    },
    {
      "code": "51.21",
      "name": "Lufttransport med gods",
      "shortName": "Lufttransp. med gods",
      "level": 4,
      "parentCode": "51.2"
    },
    {
      "code": "51.22",
      "name": "Romfart",
      "shortName": "Romfart",
      "level": 4,
      "parentCode": "51.2"
    },
    {
      "code": "52.10",
      "name": "Lagring",
      "shortName": "Lagring",
      "level": 4,
      "parentCode": "52.1"
    },
    {
      "code": "52.21",
      "name": "Andre tjenester tilknyttet landtransport",
      "shortName": "Andre tjen. tilkn. landtransport",
      "level": 4,
      "parentCode": "52.2"
    },
    {
      "code": "52.22",
      "name": "Andre tjenester tilknyttet sjøtransport",
      "shortName": "Andre tjen. tilkn. sjøtransport",
      "level": 4,
      "parentCode": "52.2"
    },
    {
      "code": "52.23",
      "name": "Andre tjenester tilknyttet lufttransport",
      "shortName": "Andre tjen. tilkn. lufttransport",
      "level": 4,
      "parentCode": "52.2"
    },
    {
      "code": "52.24",
      "name": "Lasting og lossing",
      "shortName": "Lasting og lossing",
      "level": 4,
      "parentCode": "52.2"
    },
    {
      "code": "52.29",
      "name": "Andre tjenester tilknyttet transport",
      "shortName": "Andre tjenester tilknyttet transport",
      "level": 4,
      "parentCode": "52.2"
    },
    {
      "code": "53.10",
      "name": "Landsdekkende posttjenester",
      "shortName": "Landsdekkende posttjenester",
      "level": 4,
      "parentCode": "53.1"
    },
    {
      "code": "53.20",
      "name": "Andre post- og budtjenester",
      "shortName": "Andre post- og budtjenester",
      "level": 4,
      "parentCode": "53.2"
    },
    {
      "code": "55.10",
      "name": "Hotellvirksomhet",
      "shortName": "Hotellvirksomhet",
      "level": 4,
      "parentCode": "55.1"
    },
    {
      "code": "55.20",
      "name": "Drift av vandrerhjem og ferieleiligheter",
      "shortName": "Drift av vandrerhjem/ferieleil.",
      "level": 4,
      "parentCode": "55.2"
    },
    {
      "code": "55.30",
      "name": "Drift av campingplasser",
      "shortName": "Drift av campingplasser",
      "level": 4,
      "parentCode": "55.3"
    },
    {
      "code": "55.90",
      "name": "Annen overnatting",
      "shortName": "Annen overnatting",
      "level": 4,
      "parentCode": "55.9"
    },
    {
      "code": "56.10",
      "name": "Restaurantvirksomhet",
      "shortName": "Restaurantvirksomhet",
      "level": 4,
      "parentCode": "56.1"
    },
    {
      "code": "56.21",
      "name": "Cateringvirksomhet",
      "shortName": "Cateringvirksomhet",
      "level": 4,
      "parentCode": "56.2"
    },
    {
      "code": "56.29",
      "name": "Kantiner drevet som selvstendig virksomhet",
      "shortName": "Kantinedrift, selvst. virksomhet",
      "level": 4,
      "parentCode": "56.2"
    },
    {
      "code": "56.30",
      "name": "Drift av barer",
      "shortName": "Drift av barer",
      "level": 4,
      "parentCode": "56.3"
    },
    {
      "code": "58.11",
      "name": "Utgivelse av bøker",
      "shortName": "Utgivelse av bøker",
      "level": 4,
      "parentCode": "58.1"
    },
    {
      "code": "58.12",
      "name": "Utgivelse av kataloger og adresselister",
      "shortName": "Utgiv. av kataloger/adresselister",
      "level": 4,
      "parentCode": "58.1"
    },
    {
      "code": "58.13",
      "name": "Utgivelse av aviser",
      "shortName": "Utgivelse av aviser",
      "level": 4,
      "parentCode": "58.1"
    },
    {
      "code": "58.14",
      "name": "Utgivelse av blader og tidsskrifter",
      "shortName": "Utgivelse av blader og tidsskrifter",
      "level": 4,
      "parentCode": "58.1"
    },
    {
      "code": "58.19",
      "name": "Forlagsvirksomhet ellers",
      "shortName": "Forlagsvirksomhet ellers",
      "level": 4,
      "parentCode": "58.1"
    },
    {
      "code": "58.21",
      "name": "Utgivelse av programvare for dataspill",
      "shortName": "Utgiv. av programv. for dataspill",
      "level": 4,
      "parentCode": "58.2"
    },
    {
      "code": "58.29",
      "name": "Utgivelse av annen programvare",
      "shortName": "Utgiv. av annen programvare",
      "level": 4,
      "parentCode": "58.2"
    },
    {
      "code": "59.11",
      "name": "Produksjon av film, video og fjernsynsprogrammer",
      "shortName": "Prod. av film/video/fjernsynsprogr.",
      "level": 4,
      "parentCode": "59.1"
    },
    {
      "code": "59.12",
      "name": "Etterarbeid knyttet til produksjon av film, video og fjernsynsprogrammer",
      "shortName": "Etterarb. til film-/video-/TV-prod.",
      "level": 4,
      "parentCode": "59.1"
    },
    {
      "code": "59.13",
      "name": "Distribusjon av film, video og fjernsynsprogrammer",
      "shortName": "Distrib. film/video/fjernsynsprogr.",
      "level": 4,
      "parentCode": "59.1"
    },
    {
      "code": "59.14",
      "name": "Filmframvisning",
      "shortName": "Filmframvisning",
      "level": 4,
      "parentCode": "59.1"
    },
    {
      "code": "59.20",
      "name": "Produksjon og utgivelse av musikk- og lydopptak",
      "shortName": "Prod./utgiv. av musikk-/lydopptak",
      "level": 4,
      "parentCode": "59.2"
    },
    {
      "code": "60.10",
      "name": "Radiokringkasting",
      "shortName": "Radiokringkasting",
      "level": 4,
      "parentCode": "60.1"
    },
    {
      "code": "60.20",
      "name": "Fjernsynskringkasting",
      "shortName": "Fjernsynskringkasting",
      "level": 4,
      "parentCode": "60.2"
    },
    {
      "code": "61.10",
      "name": "Kabelbasert telekommunikasjon",
      "shortName": "Kabelbasert telekomm.",
      "level": 4,
      "parentCode": "61.1"
    },
    {
      "code": "61.20",
      "name": "Trådløs telekommunikasjon",
      "shortName": "Trådløs telekomm.",
      "level": 4,
      "parentCode": "61.2"
    },
    {
      "code": "61.30",
      "name": "Satellittbasert telekommunikasjon",
      "shortName": "Satellittbasert telekomm.",
      "level": 4,
      "parentCode": "61.3"
    },
    {
      "code": "61.90",
      "name": "Telekommunikasjon ellers",
      "shortName": "Telekommunikasjon ellers",
      "level": 4,
      "parentCode": "61.9"
    },
    {
      "code": "62.01",
      "name": "Programmeringstjenester",
      "shortName": "Programmeringstjenester",
      "level": 4,
      "parentCode": "62.0"
    },
    {
      "code": "62.02",
      "name": "Konsulentvirksomhet tilknyttet informasjonsteknologi",
      "shortName": "Kons.virks. tilkn. informasj.tekn.",
      "level": 4,
      "parentCode": "62.0"
    },
    {
      "code": "62.03",
      "name": "Forvaltning og drift av IT-systemer",
      "shortName": "Forvaltning og drift av IT-systemer",
      "level": 4,
      "parentCode": "62.0"
    },
    {
      "code": "62.09",
      "name": "Andre tjenester tilknyttet informasjonsteknologi",
      "shortName": "Tjen. tilkn. informasjonsteknologi el.",
      "level": 4,
      "parentCode": "62.0"
    },
    {
      "code": "63.11",
      "name": "Databehandling, datalagring og tilknyttede tjenester",
      "shortName": "Databeh./-lagring og tilkn. tjen.",
      "level": 4,
      "parentCode": "63.1"
    },
    {
      "code": "63.12",
      "name": "Drift av web-portaler",
      "shortName": "Drift av web-portaler",
      "level": 4,
      "parentCode": "63.1"
    },
    {
      "code": "63.91",
      "name": "Nyhetsbyråer",
      "shortName": "Nyhetsbyråer",
      "level": 4,
      "parentCode": "63.9"
    },
    {
      "code": "63.99",
      "name": "Andre informasjonstjenester ikke nevnt annet sted",
      "shortName": "Andre informasjonstjenester",
      "level": 4,
      "parentCode": "63.9"
    },
    {
      "code": "64.11",
      "name": "Sentralbankvirksomhet",
      "shortName": "Sentralbankvirksomhet",
      "level": 4,
      "parentCode": "64.1"
    },
    {
      "code": "64.19",
      "name": "Bankvirksomhet ellers",
      "shortName": "Bankvirksomhet ellers",
      "level": 4,
      "parentCode": "64.1"
    },
    {
      "code": "64.20",
      "name": "Holdingselskaper",
      "shortName": "Holdingselskaper",
      "level": 4,
      "parentCode": "64.2"
    },
    {
      "code": "64.30",
      "name": "Verdipapirfond, investeringsselskaper o.l.",
      "shortName": "Verdipapirfond/invest.selskap. o.l.",
      "level": 4,
      "parentCode": "64.3"
    },
    {
      "code": "64.91",
      "name": "Finansiell leasing",
      "shortName": "Finansiell leasing",
      "level": 4,
      "parentCode": "64.9"
    },
    {
      "code": "64.92",
      "name": "Annen kredittgivning",
      "shortName": "Annen kredittgivning",
      "level": 4,
      "parentCode": "64.9"
    },
    {
      "code": "64.99",
      "name": "Annen finansieringsvirksomhet ikke nevnt annet sted",
      "shortName": "Finansieringsvirksomhet el.",
      "level": 4,
      "parentCode": "64.9"
    },
    {
      "code": "65.11",
      "name": "Livsforsikring",
      "shortName": "Livsforsikring",
      "level": 4,
      "parentCode": "65.1"
    },
    {
      "code": "65.12",
      "name": "Skadeforsikring",
      "shortName": "Skadeforsikring",
      "level": 4,
      "parentCode": "65.1"
    },
    {
      "code": "65.20",
      "name": "Gjenforsikring",
      "shortName": "Gjenforsikring",
      "level": 4,
      "parentCode": "65.2"
    },
    {
      "code": "65.30",
      "name": "Pensjonskasser",
      "shortName": "Pensjonskasser",
      "level": 4,
      "parentCode": "65.3"
    },
    {
      "code": "66.11",
      "name": "Administrasjon av finansmarkeder",
      "shortName": "Administrasjon av finansmarkeder",
      "level": 4,
      "parentCode": "66.1"
    },
    {
      "code": "66.12",
      "name": "Verdipapirmegling",
      "shortName": "Verdipapirmegling",
      "level": 4,
      "parentCode": "66.1"
    },
    {
      "code": "66.19",
      "name": "Andre tjenester tilknyttet finansieringsvirksomhet",
      "shortName": "Tjen. tilkn. finansieringsvirks. el.",
      "level": 4,
      "parentCode": "66.1"
    },
    {
      "code": "66.21",
      "name": "Risiko- og skadevurdering",
      "shortName": "Risiko- og skadevurdering",
      "level": 4,
      "parentCode": "66.2"
    },
    {
      "code": "66.22",
      "name": "Forsikringsformidling",
      "shortName": "Forsikringsformidling",
      "level": 4,
      "parentCode": "66.2"
    },
    {
      "code": "66.29",
      "name": "Andre tjenester tilknyttet forsikringsvirksomhet og pensjonskasser",
      "shortName": "Tjen. fors.virks./pensj.kasser el.",
      "level": 4,
      "parentCode": "66.2"
    },
    {
      "code": "66.30",
      "name": "Fondsforvaltningsvirksomhet",
      "shortName": "Fondsforvaltningsvirksomhet",
      "level": 4,
      "parentCode": "66.3"
    },
    {
      "code": "68.10",
      "name": "Kjøp og salg av egen fast eiendom",
      "shortName": "Kjøp/salg av egen fast eiendom",
      "level": 4,
      "parentCode": "68.1"
    },
    {
      "code": "68.20",
      "name": "Utleie av egen eller leid fast eiendom",
      "shortName": "Utleie av egen/leid fast eiendom",
      "level": 4,
      "parentCode": "68.2"
    },
    {
      "code": "68.31",
      "name": "Eiendomsmegling",
      "shortName": "Eiendomsmegling",
      "level": 4,
      "parentCode": "68.3"
    },
    {
      "code": "68.32",
      "name": "Eiendomsforvaltning",
      "shortName": "Eiendomsforvaltning",
      "level": 4,
      "parentCode": "68.3"
    },
    {
      "code": "69.10",
      "name": "Juridisk tjenesteyting",
      "shortName": "Juridisk tjenesteyting",
      "level": 4,
      "parentCode": "69.1"
    },
    {
      "code": "69.20",
      "name": "Regnskap, revisjon og skatterådgivning",
      "shortName": "Regnskap/revisjon/skatterådgiv.",
      "level": 4,
      "parentCode": "69.2"
    },
    {
      "code": "70.10",
      "name": "Hovedkontortjenester",
      "shortName": "Hovedkontortjenester",
      "level": 4,
      "parentCode": "70.1"
    },
    {
      "code": "70.21",
      "name": "PR og kommunikasjonstjenester",
      "shortName": "PR og kommunikasjonstjenester",
      "level": 4,
      "parentCode": "70.2"
    },
    {
      "code": "70.22",
      "name": "Bedriftsrådgivning og annen administrativ rådgivning",
      "shortName": "Bedriftsrådgiv./annen adm. rådgiv.",
      "level": 4,
      "parentCode": "70.2"
    },
    {
      "code": "71.11",
      "name": "Arkitektvirksomhet",
      "shortName": "Arkitektvirksomhet",
      "level": 4,
      "parentCode": "71.1"
    },
    {
      "code": "71.12",
      "name": "Teknisk konsulentvirksomhet",
      "shortName": "Teknisk konsulentvirksomhet",
      "level": 4,
      "parentCode": "71.1"
    },
    {
      "code": "71.20",
      "name": "Teknisk prøving og analyse",
      "shortName": "Teknisk prøving og analyse",
      "level": 4,
      "parentCode": "71.2"
    },
    {
      "code": "72.11",
      "name": "Forskning og utviklingsarbeid innen bioteknologi",
      "shortName": "Forsk./utvikl.arb. innen bioteknologi",
      "level": 4,
      "parentCode": "72.1"
    },
    {
      "code": "72.19",
      "name": "Annen forskning og annet utviklingsarbeid innen naturvitenskap og teknikk",
      "shortName": "Annen forsk. innen naturvit. og teknikk",
      "level": 4,
      "parentCode": "72.1"
    },
    {
      "code": "72.20",
      "name": "Forskning og utviklingsarbeid innen samfunnsvitenskap og humanistiske fag",
      "shortName": "Forskning samfunnsvit., human. fag",
      "level": 4,
      "parentCode": "72.2"
    },
    {
      "code": "73.11",
      "name": "Reklamebyråer",
      "shortName": "Reklamebyråer",
      "level": 4,
      "parentCode": "73.1"
    },
    {
      "code": "73.12",
      "name": "Medieformidlingstjenester",
      "shortName": "Medieformidlingstjenester",
      "level": 4,
      "parentCode": "73.1"
    },
    {
      "code": "73.20",
      "name": "Markeds- og opinionsundersøkelser",
      "shortName": "Markeds- og opinionsundersøkelser",
      "level": 4,
      "parentCode": "73.2"
    },
    {
      "code": "74.10",
      "name": "Spesialisert designvirksomhet",
      "shortName": "Spesialisert designvirksomhet",
      "level": 4,
      "parentCode": "74.1"
    },
    {
      "code": "74.20",
      "name": "Fotografvirksomhet",
      "shortName": "Fotografvirksomhet",
      "level": 4,
      "parentCode": "74.2"
    },
    {
      "code": "74.30",
      "name": "Oversettelses- og tolkevirksomhet",
      "shortName": "Oversettelses- og tolkevirksomhet",
      "level": 4,
      "parentCode": "74.3"
    },
    {
      "code": "74.90",
      "name": "Annen faglig, vitenskapelig og teknisk virksomhet",
      "shortName": "Annen faglig/vit.skap./tekn. virks.",
      "level": 4,
      "parentCode": "74.9"
    },
    {
      "code": "75.00",
      "name": "Veterinærtjenester",
      "shortName": "Veterinærtjenester",
      "level": 4,
      "parentCode": "75.0"
    },
    {
      "code": "77.11",
      "name": "Utleie og leasing av biler og andre lette motorvogner",
      "shortName": "Utl./leas. biler/andre lette motorv.",
      "level": 4,
      "parentCode": "77.1"
    },
    {
      "code": "77.12",
      "name": "Utleie og leasing av lastebiler",
      "shortName": "Utleie og leasing av lastebiler",
      "level": 4,
      "parentCode": "77.1"
    },
    {
      "code": "77.21",
      "name": "Utleie og leasing av sports- og fritidsutstyr",
      "shortName": "Utl./leas. sports- og fritidsutstyr",
      "level": 4,
      "parentCode": "77.2"
    },
    {
      "code": "77.22",
      "name": "Utleie av videofilm, DVD og lignende",
      "shortName": "Utleie videofilm, DVD og lignende",
      "level": 4,
      "parentCode": "77.2"
    },
    {
      "code": "77.29",
      "name": "Utleie og leasing av andre husholdningsvarer og varer til personlig bruk",
      "shortName": "Utl./leas. husholdningsvarer el.",
      "level": 4,
      "parentCode": "77.2"
    },
    {
      "code": "77.31",
      "name": "Utleie og leasing av landbruksmaskiner og -utstyr",
      "shortName": "Utl./leas. landbruksmaskiner og -utstyr",
      "level": 4,
      "parentCode": "77.3"
    },
    {
      "code": "77.32",
      "name": "Utleie og leasing av bygge- og anleggsmaskiner og -utstyr",
      "shortName": "Utl./leas. bygge- og anleggsmask.",
      "level": 4,
      "parentCode": "77.3"
    },
    {
      "code": "77.33",
      "name": "Utleie og leasing av kontor- og datamaskiner",
      "shortName": "Utl./leas. kontor- og datamaskiner",
      "level": 4,
      "parentCode": "77.3"
    },
    {
      "code": "77.34",
      "name": "Utleie og leasing av sjøtransportmateriell",
      "shortName": "Utl./leas. sjøtransportmateriell",
      "level": 4,
      "parentCode": "77.3"
    },
    {
      "code": "77.35",
      "name": "Utleie og leasing av lufttransportmateriell",
      "shortName": "Utl./leas. lufttransportmateriell",
      "level": 4,
      "parentCode": "77.3"
    },
    {
      "code": "77.39",
      "name": "Utleie og leasing av andre maskiner og annet utstyr og materiell ikke nevnt annet sted",
      "shortName": "Utl./leas. andre mask./annet utstyr",
      "level": 4,
      "parentCode": "77.3"
    },
    {
      "code": "77.40",
      "name": "Leasing av immateriell eiendom og lignende produkter, unntatt opphavsrettsbeskyttede verker",
      "shortName": "Leas. av immateriell eiendom mv.",
      "level": 4,
      "parentCode": "77.4"
    },
    {
      "code": "78.10",
      "name": "Rekruttering og formidling av arbeidskraft",
      "shortName": "Rekrutt./formidling av arbeidskraft",
      "level": 4,
      "parentCode": "78.1"
    },
    {
      "code": "78.20",
      "name": "Utleie av arbeidskraft",
      "shortName": "Utleie av arbeidskraft",
      "level": 4,
      "parentCode": "78.2"
    },
    {
      "code": "78.30",
      "name": "Andre personaladministrative tjenester",
      "shortName": "Andre personaladm. tjen.",
      "level": 4,
      "parentCode": "78.3"
    },
    {
      "code": "79.11",
      "name": "Reisebyråvirksomhet",
      "shortName": "Reisebyråvirksomhet",
      "level": 4,
      "parentCode": "79.1"
    },
    {
      "code": "79.12",
      "name": "Reisearrangørvirksomhet",
      "shortName": "Reisearrangørvirksomhet",
      "level": 4,
      "parentCode": "79.1"
    },
    {
      "code": "79.90",
      "name": "Annen arrangørvirksomhet og tilknyttede tjenester",
      "shortName": "Annen arrangørvirks. og tilkn. tjen.",
      "level": 4,
      "parentCode": "79.9"
    },
    {
      "code": "80.10",
      "name": "Private vakttjenester",
      "shortName": "Private vakttjenester",
      "level": 4,
      "parentCode": "80.1"
    },
    {
      "code": "80.20",
      "name": "Tjenester tilknyttet vakttjenester",
      "shortName": "Tjenester tilknyttet vakttjenester",
      "level": 4,
      "parentCode": "80.2"
    },
    {
      "code": "80.30",
      "name": "Etterforsking",
      "shortName": "Etterforsking",
      "level": 4,
      "parentCode": "80.3"
    },
    {
      "code": "81.10",
      "name": "Kombinerte tjenester tilknyttet eiendomsdrift",
      "shortName": "Komb. tjen. tilkn. eiendomsdrift",
      "level": 4,
      "parentCode": "81.1"
    },
    {
      "code": "81.21",
      "name": "Rengjøring av bygninger",
      "shortName": "Rengjøring av bygninger",
      "level": 4,
      "parentCode": "81.2"
    },
    {
      "code": "81.22",
      "name": "Utvendig rengjøring av bygninger og industriell rengjøring",
      "shortName": "Utv. rengj. bygn./ind. rengjøring",
      "level": 4,
      "parentCode": "81.2"
    },
    {
      "code": "81.29",
      "name": "Annen rengjøringsvirksomhet",
      "shortName": "Annen rengjøringsvirksomhet",
      "level": 4,
      "parentCode": "81.2"
    },
    {
      "code": "81.30",
      "name": "Beplantning av hager og parkanlegg",
      "shortName": "Beplantning av hager og parkanl.",
      "level": 4,
      "parentCode": "81.3"
    },
    {
      "code": "82.11",
      "name": "Kombinerte kontortjenester",
      "shortName": "Kombinerte kontortjenester",
      "level": 4,
      "parentCode": "82.1"
    },
    {
      "code": "82.19",
      "name": "Fotokopiering, forberedelse av dokumenter og andre spesialiserte kontortjenester",
      "shortName": "Fotokopiering/spes. kontortjen. el.",
      "level": 4,
      "parentCode": "82.1"
    },
    {
      "code": "82.20",
      "name": "Telefonvakttjenester og telefonsalg",
      "shortName": "Telefonvakttjenester/telefonsalg",
      "level": 4,
      "parentCode": "82.2"
    },
    {
      "code": "82.30",
      "name": "Kongress-, messe- og utstillingsvirksomhet",
      "shortName": "Kongress-/messe-/utstillingsvirks.",
      "level": 4,
      "parentCode": "82.3"
    },
    {
      "code": "82.91",
      "name": "Inkasso- og kredittopplysningsvirksomhet",
      "shortName": "Inkasso- og kredittopplysningsvirks.",
      "level": 4,
      "parentCode": "82.9"
    },
    {
      "code": "82.92",
      "name": "Pakkevirksomhet",
      "shortName": "Pakkevirksomhet",
      "level": 4,
      "parentCode": "82.9"
    },
    {
      "code": "82.99",
      "name": "Annen forretningsmessig tjenesteyting ikke nevnt annet sted",
      "shortName": "Forr.messig tj.yting ikke nevnt el.",
      "level": 4,
      "parentCode": "82.9"
    },
    {
      "code": "84.11",
      "name": "Generell offentlig administrasjon",
      "shortName": "Generell offentlig administrasjon",
      "level": 4,
      "parentCode": "84.1"
    },
    {
      "code": "84.12",
      "name": "Offentlig administrasjon tilknyttet helsestell, sosial virksomhet, undervisning, kirke, kultur og miljøvern",
      "shortName": "Off.adm. helse, sos.virks. m.m.",
      "level": 4,
      "parentCode": "84.1"
    },
    {
      "code": "84.13",
      "name": "Offentlig administrasjon tilknyttet næringsvirksomhet og arbeidsmarked",
      "shortName": "Off.adm. nær.virks. og arb.marked",
      "level": 4,
      "parentCode": "84.1"
    },
    {
      "code": "84.21",
      "name": "Utenrikssaker",
      "shortName": "Utenrikssaker",
      "level": 4,
      "parentCode": "84.2"
    },
    {
      "code": "84.22",
      "name": "Forsvar",
      "shortName": "Forsvar",
      "level": 4,
      "parentCode": "84.2"
    },
    {
      "code": "84.23",
      "name": "Retts- og fengselsvesen",
      "shortName": "Retts- og fengselsvesen",
      "level": 4,
      "parentCode": "84.2"
    },
    {
      "code": "84.24",
      "name": "Politi- og påtalemyndighet",
      "shortName": "Politi- og påtalemyndighet",
      "level": 4,
      "parentCode": "84.2"
    },
    {
      "code": "84.25",
      "name": "Brannvern",
      "shortName": "Brannvern",
      "level": 4,
      "parentCode": "84.2"
    },
    {
      "code": "84.30",
      "name": "Trygdeordninger underlagt offentlig forvaltning",
      "shortName": "Sosialforsikring, trygd",
      "level": 4,
      "parentCode": "84.3"
    },
    {
      "code": "85.10",
      "name": "Førskoleundervisning",
      "shortName": "Førskoleundervisning",
      "level": 4,
      "parentCode": "85.1"
    },
    {
      "code": "85.20",
      "name": "Grunnskoleundervisning",
      "shortName": "Grunnskoleundervisning",
      "level": 4,
      "parentCode": "85.2"
    },
    {
      "code": "85.31",
      "name": "Videregående opplæring innen allmennfaglige studieretninger",
      "shortName": "Undervisning i allmennfag",
      "level": 4,
      "parentCode": "85.3"
    },
    {
      "code": "85.32",
      "name": "Videregående opplæring innen tekniske og andre yrkesfaglige studieretninger",
      "shortName": "Undervisn. i tekn./yrkesrettede fag",
      "level": 4,
      "parentCode": "85.3"
    },
    {
      "code": "85.41",
      "name": "Undervisning ved fagskoler",
      "shortName": "Undervisning ved fagskoler",
      "level": 4,
      "parentCode": "85.4"
    },
    {
      "code": "85.42",
      "name": "Undervisning på universitets- og høgskolenivå",
      "shortName": "Undervisning universitet, høgskoler",
      "level": 4,
      "parentCode": "85.4"
    },
    {
      "code": "85.51",
      "name": "Undervisning innen idrett og rekreasjon",
      "shortName": "Underv. innen idrett og rekreasjon",
      "level": 4,
      "parentCode": "85.5"
    },
    {
      "code": "85.52",
      "name": "Undervisning innen kultur",
      "shortName": "Undervisning innen kultur",
      "level": 4,
      "parentCode": "85.5"
    },
    {
      "code": "85.53",
      "name": "Trafikkskoleundervisning",
      "shortName": "Trafikkskoleundervisning",
      "level": 4,
      "parentCode": "85.5"
    },
    {
      "code": "85.59",
      "name": "Annen undervisning ikke nevnt annet sted",
      "shortName": "Undervisning el.",
      "level": 4,
      "parentCode": "85.5"
    },
    {
      "code": "85.60",
      "name": "Tjenester tilknyttet undervisning",
      "shortName": "Tjenester tilkn. undervisning",
      "level": 4,
      "parentCode": "85.6"
    },
    {
      "code": "86.10",
      "name": "Sykehustjenester",
      "shortName": "Sykehustjenester",
      "level": 4,
      "parentCode": "86.1"
    },
    {
      "code": "86.21",
      "name": "Legetjeneste",
      "shortName": "Legetjeneste",
      "level": 4,
      "parentCode": "86.2"
    },
    {
      "code": "86.22",
      "name": "Spesialisert legetjeneste",
      "shortName": "Spesialisert legetjeneste",
      "level": 4,
      "parentCode": "86.2"
    },
    {
      "code": "86.23",
      "name": "Tannhelsetjenester",
      "shortName": "Tannhelsetjenester",
      "level": 4,
      "parentCode": "86.2"
    },
    {
      "code": "86.90",
      "name": "Andre helsetjenester",
      "shortName": "Andre helsetjenester",
      "level": 4,
      "parentCode": "86.9"
    },
    {
      "code": "87.10",
      "name": "Pleie- og omsorgstjenester i institusjon",
      "shortName": "Pleie- og omsorg i institusjon",
      "level": 4,
      "parentCode": "87.1"
    },
    {
      "code": "87.20",
      "name": "Institusjoner og bofellesskap innen omsorg for psykisk utviklingshemmede, psykisk helsearbeid og rusmiddelomsorg",
      "shortName": "Inst./bof.skap psyk. utv.hem. mv.",
      "level": 4,
      "parentCode": "87.2"
    },
    {
      "code": "87.30",
      "name": "Institusjoner og bofellesskap innen omsorg for eldre og funksjonshemmede",
      "shortName": "Inst./bofellesskap eldre/funksj.hem.",
      "level": 4,
      "parentCode": "87.3"
    },
    {
      "code": "87.90",
      "name": "Andre omsorgsinstitusjoner",
      "shortName": "Andre omsorgsinstitusjoner",
      "level": 4,
      "parentCode": "87.9"
    },
    {
      "code": "88.10",
      "name": "Sosialtjenester uten botilbud for eldre og funksjonshemmede",
      "shortName": "Sosialtj. u/botilbud eldre/funksj.hem.",
      "level": 4,
      "parentCode": "88.1"
    },
    {
      "code": "88.91",
      "name": "Sosialtjenester uten botilbud for barn og ungdom",
      "shortName": "Sosialtj. u/botilbud barn/ungdom",
      "level": 4,
      "parentCode": "88.9"
    },
    {
      "code": "88.99",
      "name": "Andre sosialtjenester uten botilbud ikke nevnt annet sted",
      "shortName": "Sosialtjenester u/botilbud el.",
      "level": 4,
      "parentCode": "88.9"
    },
    {
      "code": "90.01",
      "name": "Utøvende kunstnere og underholdningsvirksomhet",
      "shortName": "Utøv. kunstnere og underhold.virks.",
      "level": 4,
      "parentCode": "90.0"
    },
    {
      "code": "90.02",
      "name": "Tjenester tilknyttet underholdningsvirksomhet",
      "shortName": "Tjen. tilkn. underholdningsvirks.",
      "level": 4,
      "parentCode": "90.0"
    },
    {
      "code": "90.03",
      "name": "Selvstendig kunstnerisk virksomhet",
      "shortName": "Selvstendig kunstnerisk virks.",
      "level": 4,
      "parentCode": "90.0"
    },
    {
      "code": "90.04",
      "name": "Drift av lokaler tilknyttet kunstnerisk virksomhet",
      "shortName": "Drift lokaler tilkn. kunst.virks.",
      "level": 4,
      "parentCode": "90.0"
    },
    {
      "code": "91.01",
      "name": "Drift av biblioteker og arkiver",
      "shortName": "Drift av biblioteker og arkiver",
      "level": 4,
      "parentCode": "91.0"
    },
    {
      "code": "91.02",
      "name": "Drift av museer",
      "shortName": "Drift av museer",
      "level": 4,
      "parentCode": "91.0"
    },
    {
      "code": "91.03",
      "name": "Drift av historiske steder og bygninger og lignende severdigheter",
      "shortName": "Drift av hist. steder og bygn. mv.",
      "level": 4,
      "parentCode": "91.0"
    },
    {
      "code": "91.04",
      "name": "Drift av botaniske og zoologiske hager og naturreservater",
      "shortName": "Drift av bot./zool. hager/naturres.",
      "level": 4,
      "parentCode": "91.0"
    },
    {
      "code": "92.00",
      "name": "Lotteri og totalisatorspill",
      "shortName": "Lotteri og totalisatorspill",
      "level": 4,
      "parentCode": "92.0"
    },
    {
      "code": "93.11",
      "name": "Drift av idrettsanlegg",
      "shortName": "Drift av idrettsanlegg",
      "level": 4,
      "parentCode": "93.1"
    },
    {
      "code": "93.12",
      "name": "Idrettslag og -klubber",
      "shortName": "Idrettslag og -klubber",
      "level": 4,
      "parentCode": "93.1"
    },
    {
      "code": "93.13",
      "name": "Treningssentre",
      "shortName": "Treningssentre",
      "level": 4,
      "parentCode": "93.1"
    },
    {
      "code": "93.19",
      "name": "Andre sportsaktiviteter",
      "shortName": "Andre sportsaktiviteter",
      "level": 4,
      "parentCode": "93.1"
    },
    {
      "code": "93.21",
      "name": "Drift av fornøyelses- og temaparker",
      "shortName": "Drift av fornøyelses- og temaparker",
      "level": 4,
      "parentCode": "93.2"
    },
    {
      "code": "93.29",
      "name": "Andre fritidsaktiviteter",
      "shortName": "Andre fritidsaktiviteter",
      "level": 4,
      "parentCode": "93.2"
    },
    {
      "code": "94.11",
      "name": "Næringslivs- og arbeidsgiverorganisasjoner",
      "shortName": "Næringslivs-/arbeidsgiverorg. mv.",
      "level": 4,
      "parentCode": "94.1"
    },
    {
      "code": "94.12",
      "name": "Yrkessammenslutninger",
      "shortName": "Yrkessammenslutninger",
      "level": 4,
      "parentCode": "94.1"
    },
    {
      "code": "94.20",
      "name": "Arbeidstakerorganisasjoner",
      "shortName": "Arbeidstakerorganisasjoner",
      "level": 4,
      "parentCode": "94.2"
    },
    {
      "code": "94.91",
      "name": "Religiøse organisasjoner",
      "shortName": "Religiøse organisasjoner",
      "level": 4,
      "parentCode": "94.9"
    },
    {
      "code": "94.92",
      "name": "Partipolitiske organisasjoner",
      "shortName": "Partipolitiske organisasjoner",
      "level": 4,
      "parentCode": "94.9"
    },
    {
      "code": "94.99",
      "name": "Aktiviteter i andre medlemsorganisasjoner ikke nevnt annet sted",
      "shortName": "Aktiviteter i andre medlemsorg. el.",
      "level": 4,
      "parentCode": "94.9"
    },
    {
      "code": "95.11",
      "name": "Reparasjon av datamaskiner og tilleggsutstyr",
      "shortName": "Rep. av datamask. og tilleggsutstyr",
      "level": 4,
      "parentCode": "95.1"
    },
    {
      "code": "95.12",
      "name": "Reparasjon av kommunikasjonsutstyr",
      "shortName": "Rep. av kommunikasjonsutstyr",
      "level": 4,
      "parentCode": "95.1"
    },
    {
      "code": "95.21",
      "name": "Reparasjon av elektronikk til husholdningsbruk",
      "shortName": "Rep. av elektronikk til hush.bruk",
      "level": 4,
      "parentCode": "95.2"
    },
    {
      "code": "95.22",
      "name": "Reparasjon av husholdningsvarer og hageredskaper",
      "shortName": "Rep. av hush.varer og hageredskaper",
      "level": 4,
      "parentCode": "95.2"
    },
    {
      "code": "95.23",
      "name": "Reparasjon av skotøy og lærvarer",
      "shortName": "Rep. av skotøy og lærvarer",
      "level": 4,
      "parentCode": "95.2"
    },
    {
      "code": "95.24",
      "name": "Reparasjon av møbler og boliginnredning",
      "shortName": "Rep. av møbler og boliginnredning",
      "level": 4,
      "parentCode": "95.2"
    },
    {
      "code": "95.25",
      "name": "Reparasjon av ur, gull- og sølvvarer",
      "shortName": "Rep. av ur, gull- og sølvvarer",
      "level": 4,
      "parentCode": "95.2"
    },
    {
      "code": "95.29",
      "name": "Reparasjon av andre husholdningsvarer og varer til personlig bruk",
      "shortName": "Rep. av husholdningsvarer el.",
      "level": 4,
      "parentCode": "95.2"
    },
    {
      "code": "96.01",
      "name": "Vaskeri- og renserivirksomhet",
      "shortName": "Vaskeri- og renserivirksomhet",
      "level": 4,
      "parentCode": "96.0"
    },
    {
      "code": "96.02",
      "name": "Frisering og annen skjønnhetspleie",
      "shortName": "Frisering og skjønnhetspleie el.",
      "level": 4,
      "parentCode": "96.0"
    },
    {
      "code": "96.03",
      "name": "Begravelsesbyråvirksomhet og drift av kirkegårder og krematorier",
      "shortName": "Begrav.byrå, kirkegårdsdrift mv.",
      "level": 4,
      "parentCode": "96.0"
    },
    {
      "code": "96.04",
      "name": "Virksomhet knyttet til kroppspleie og fysisk velvære",
      "shortName": "Helsestudiovirksomhet mv..",
      "level": 4,
      "parentCode": "96.0"
    },
    {
      "code": "96.09",
      "name": "Personlig tjenesteyting ikke nevnt annet sted",
      "shortName": "Personlig tjenesteyting el.",
      "level": 4,
      "parentCode": "96.0"
    },
    {
      "code": "97.00",
      "name": "Lønnet arbeid i private husholdninger",
      "shortName": "Lønnet arbeid i private husholdn.",
      "level": 4,
      "parentCode": "97.0"
    },
    {
      "code": "99.00",
      "name": "Internasjonale organisasjoner og organer",
      "shortName": "Internasjonale organer",
      "level": 4,
      "parentCode": "99.0"
    },
    {
      "code": "01.110",
      "name": "Dyrking av korn (unntatt ris), belgvekster og oljeholdige vekster",
      "shortName": "Dyrking av korn, belgvekster mv.",
      "level": 5,
      "parentCode": "01.11"
    },
    {
      "code": "01.120",
      "name": "Dyrking av ris",
      "shortName": "Dyrking av ris",
      "level": 5,
      "parentCode": "01.12"
    },
    {
      "code": "01.130",
      "name": "Dyrking av grønnsaker, meloner, rot- og knollvekster",
      "shortName": "Dyrking av grønnsaker, poteter mv.",
      "level": 5,
      "parentCode": "01.13"
    },
    {
      "code": "01.140",
      "name": "Dyrking av sukkerrør",
      "shortName": "Dyrking av sukkerrør",
      "level": 5,
      "parentCode": "01.14"
    },
    {
      "code": "01.150",
      "name": "Dyrking av tobakk",
      "shortName": "Dyrking av tobakk",
      "level": 5,
      "parentCode": "01.15"
    },
    {
      "code": "01.160",
      "name": "Dyrking av fibervekster",
      "shortName": "Dyrking av fibervekster",
      "level": 5,
      "parentCode": "01.16"
    },
    {
      "code": "01.190",
      "name": "Dyrking av ettårige vekster ellers",
      "shortName": "Dyrking av ettårige vekster ellers",
      "level": 5,
      "parentCode": "01.19"
    },
    {
      "code": "01.210",
      "name": "Dyrking av druer",
      "shortName": "Dyrking av druer",
      "level": 5,
      "parentCode": "01.21"
    },
    {
      "code": "01.220",
      "name": "Dyrking av tropiske og subtropiske frukter",
      "shortName": "Dyrking av trop./subtrop. frukter",
      "level": 5,
      "parentCode": "01.22"
    },
    {
      "code": "01.230",
      "name": "Dyrking av sitrusfrukter",
      "shortName": "Dyrking av sitrusfrukter",
      "level": 5,
      "parentCode": "01.23"
    },
    {
      "code": "01.240",
      "name": "Dyrking av kjernefrukter og steinfrukter",
      "shortName": "Dyrking av kjerne- og steinfrukter",
      "level": 5,
      "parentCode": "01.24"
    },
    {
      "code": "01.250",
      "name": "Dyrking av annen frukt som vokser på trær eller busker samt nøtter",
      "shortName": "Dyrking av bær og nøtter mv.",
      "level": 5,
      "parentCode": "01.25"
    },
    {
      "code": "01.260",
      "name": "Dyrking av oljeholdige frukter",
      "shortName": "Dyrking av oljeholdige frukter",
      "level": 5,
      "parentCode": "01.26"
    },
    {
      "code": "01.270",
      "name": "Dyrking av vekster for produksjon av drikkevarer",
      "shortName": "Dyrk. vekster for prod. av drikkev.",
      "level": 5,
      "parentCode": "01.27"
    },
    {
      "code": "01.280",
      "name": "Dyrking av krydder og aromatiske, medisinske og farmasøytiske vekster",
      "shortName": "Dyrking av krydder mv.",
      "level": 5,
      "parentCode": "01.28"
    },
    {
      "code": "01.290",
      "name": "Dyrking av flerårige vekster ellers",
      "shortName": "Dyrking av flerårige vekster ellers",
      "level": 5,
      "parentCode": "01.29"
    },
    {
      "code": "01.300",
      "name": "Planteformering",
      "shortName": "Planteformering",
      "level": 5,
      "parentCode": "01.30"
    },
    {
      "code": "01.410",
      "name": "Melkeproduksjon på storfe",
      "shortName": "Melkeproduksjon på storfe",
      "level": 5,
      "parentCode": "01.41"
    },
    {
      "code": "01.420",
      "name": "Oppdrett av annet storfe",
      "shortName": "Oppdrett av annet storfe",
      "level": 5,
      "parentCode": "01.42"
    },
    {
      "code": "01.430",
      "name": "Oppdrett av hester og andre dyr av hestefamilien",
      "shortName": "Oppdrett av hester, esler o.l.",
      "level": 5,
      "parentCode": "01.43"
    },
    {
      "code": "01.440",
      "name": "Oppdrett av kameler og andre kameldyr",
      "shortName": "Oppdrett av kameler og kameldyr el.",
      "level": 5,
      "parentCode": "01.44"
    },
    {
      "code": "01.451",
      "name": "Sauehold",
      "shortName": "Sauehold",
      "level": 5,
      "parentCode": "01.45"
    },
    {
      "code": "01.452",
      "name": "Geitehold",
      "shortName": "Geitehold",
      "level": 5,
      "parentCode": "01.45"
    },
    {
      "code": "01.460",
      "name": "Svinehold",
      "shortName": "Svinehold",
      "level": 5,
      "parentCode": "01.46"
    },
    {
      "code": "01.471",
      "name": "Hold av verpehøner for konsumeggproduksjon",
      "shortName": "Verpehøner for konsumeggprod.",
      "level": 5,
      "parentCode": "01.47"
    },
    {
      "code": "01.479",
      "name": "Annet fjørfehold",
      "shortName": "Annet fjørfehold",
      "level": 5,
      "parentCode": "01.47"
    },
    {
      "code": "01.490",
      "name": "Husdyrhold ellers",
      "shortName": "Husdyrhold ellers",
      "level": 5,
      "parentCode": "01.49"
    },
    {
      "code": "01.500",
      "name": "Kombinert husdyrhold og planteproduksjon",
      "shortName": "Komb. husdyrhold og planteprod.",
      "level": 5,
      "parentCode": "01.50"
    },
    {
      "code": "01.610",
      "name": "Tjenester tilknyttet planteproduksjon",
      "shortName": "Tjenester tilknyttet planteprod.",
      "level": 5,
      "parentCode": "01.61"
    },
    {
      "code": "01.620",
      "name": "Tjenester tilknyttet husdyrhold",
      "shortName": "Tjenester tilknyttet husdyrhold",
      "level": 5,
      "parentCode": "01.62"
    },
    {
      "code": "01.630",
      "name": "Etterbehandling av vekster etter innhøsting",
      "shortName": "Etterbeh. av vekster etter innhøst.",
      "level": 5,
      "parentCode": "01.63"
    },
    {
      "code": "01.640",
      "name": "Behandling av såfrø",
      "shortName": "Behandling av såfrø",
      "level": 5,
      "parentCode": "01.64"
    },
    {
      "code": "01.700",
      "name": "Jakt, viltstell og tjenester tilknyttet jakt og viltstell",
      "shortName": "Jakt, viltstell og tilkn. tjenester",
      "level": 5,
      "parentCode": "01.70"
    },
    {
      "code": "02.100",
      "name": "Skogskjøtsel og andre skogbruksaktiviteter",
      "shortName": "Skogskjøtsel, andre skogbruksakt.",
      "level": 5,
      "parentCode": "02.10"
    },
    {
      "code": "02.200",
      "name": "Avvirkning",
      "shortName": "Avvirkning",
      "level": 5,
      "parentCode": "02.20"
    },
    {
      "code": "02.300",
      "name": "Innsamling av viltvoksende produkter av annet enn tre",
      "shortName": "Innsaml. av sopp, bær, mose etc.",
      "level": 5,
      "parentCode": "02.30"
    },
    {
      "code": "02.400",
      "name": "Tjenester tilknyttet skogbruk",
      "shortName": "Tjenester tilknyttet skogbruk",
      "level": 5,
      "parentCode": "02.40"
    },
    {
      "code": "03.111",
      "name": "Hav- og kystfiske",
      "shortName": "Hav- og kystfiske",
      "level": 5,
      "parentCode": "03.11"
    },
    {
      "code": "03.112",
      "name": "Hvalfangst",
      "shortName": "Hvalfangst",
      "level": 5,
      "parentCode": "03.11"
    },
    {
      "code": "03.120",
      "name": "Ferskvannsfiske",
      "shortName": "Ferskvannsfiske",
      "level": 5,
      "parentCode": "03.12"
    },
    {
      "code": "03.211",
      "name": "Produksjon av matfisk, bløtdyr, krepsdyr og pigghuder i hav- og kystbasert akvakultur",
      "shortName": "Matfisk/krepsdyr mv. hav-/kystbas.",
      "level": 5,
      "parentCode": "03.21"
    },
    {
      "code": "03.212",
      "name": "Produksjon av yngel og settefisk i hav- og kystbasert akvakultur",
      "shortName": "Yngel, settefisk hav-/kystbas.",
      "level": 5,
      "parentCode": "03.21"
    },
    {
      "code": "03.213",
      "name": "Tjenester tilknyttet hav- og kystbasert akvakultur",
      "shortName": "Tjen. tilkn. hav-/kystbas. akvakult.",
      "level": 5,
      "parentCode": "03.21"
    },
    {
      "code": "03.221",
      "name": "Produksjon av matfisk, bløtdyr og krepsdyr i ferskvannsbasert akvakultur",
      "shortName": "Matfisk/krepsdyr mv. ferskvannsbas.",
      "level": 5,
      "parentCode": "03.22"
    },
    {
      "code": "03.222",
      "name": "Produksjon av yngel og settefisk i ferskvannsbasert akvakultur",
      "shortName": "Yngel, settefisk ferskvannsbasert",
      "level": 5,
      "parentCode": "03.22"
    },
    {
      "code": "03.223",
      "name": "Tjenester tilknyttet ferskvannsbasert akvakultur",
      "shortName": "Tjen. tilkn. ferskvannsbas. akvakult",
      "level": 5,
      "parentCode": "03.22"
    },
    {
      "code": "05.100",
      "name": "Bryting av steinkull",
      "shortName": "Bryting av steinkull",
      "level": 5,
      "parentCode": "05.10"
    },
    {
      "code": "05.200",
      "name": "Bryting av brunkull",
      "shortName": "Bryting av brunkull",
      "level": 5,
      "parentCode": "05.20"
    },
    {
      "code": "06.100",
      "name": "Utvinning av råolje",
      "shortName": "Utvinning av råolje",
      "level": 5,
      "parentCode": "06.10"
    },
    {
      "code": "06.200",
      "name": "Utvinning av naturgass",
      "shortName": "Utvinning av naturgass",
      "level": 5,
      "parentCode": "06.20"
    },
    {
      "code": "07.100",
      "name": "Bryting av jernmalm",
      "shortName": "Bryting av jernmalm",
      "level": 5,
      "parentCode": "07.10"
    },
    {
      "code": "07.210",
      "name": "Bryting av uran- og thoriummalm",
      "shortName": "Bryting av uran- og thoriummalm",
      "level": 5,
      "parentCode": "07.21"
    },
    {
      "code": "07.290",
      "name": "Bryting av ikke-jernholdig malm ellers",
      "shortName": "Bryting av annen ikke-jernh. malm",
      "level": 5,
      "parentCode": "07.29"
    },
    {
      "code": "08.111",
      "name": "Bryting av stein til bygge- og anleggsvirksomhet",
      "shortName": "Bryting stein til bygge- og anl.virks",
      "level": 5,
      "parentCode": "08.11"
    },
    {
      "code": "08.112",
      "name": "Bryting av kalkstein, gips og kritt",
      "shortName": "Bryting av kalkstein, gips og kritt",
      "level": 5,
      "parentCode": "08.11"
    },
    {
      "code": "08.113",
      "name": "Bryting av skifer",
      "shortName": "Bryting av skifer",
      "level": 5,
      "parentCode": "08.11"
    },
    {
      "code": "08.120",
      "name": "Utvinning fra grus- og sandtak, og utvinning av leire og kaolin",
      "shortName": "Utv. fra grus- og sandtak, leire mv.",
      "level": 5,
      "parentCode": "08.12"
    },
    {
      "code": "08.910",
      "name": "Bryting og utvinning av kjemiske mineraler og gjødselsmineraler",
      "shortName": "Utv. kjem. mineraler/gjødselsmin.",
      "level": 5,
      "parentCode": "08.91"
    },
    {
      "code": "08.920",
      "name": "Stikking av torv",
      "shortName": "Stikking av torv",
      "level": 5,
      "parentCode": "08.92"
    },
    {
      "code": "08.930",
      "name": "Utvinning av salt",
      "shortName": "Utvinning av salt",
      "level": 5,
      "parentCode": "08.93"
    },
    {
      "code": "08.990",
      "name": "Annen bryting og utvinning ikke nevnt annet sted",
      "shortName": "Annen bryting og utvinning",
      "level": 5,
      "parentCode": "08.99"
    },
    {
      "code": "09.101",
      "name": "Boretjenester tilknyttet utvinning av råolje og naturgass",
      "shortName": "Boretj. tilkn. utv. råolje/naturgass",
      "level": 5,
      "parentCode": "09.10"
    },
    {
      "code": "09.109",
      "name": "Andre tjenester tilknyttet utvinning av råolje og naturgass",
      "shortName": "Tjen. til utv. råolje/naturgass el.",
      "level": 5,
      "parentCode": "09.10"
    },
    {
      "code": "09.900",
      "name": "Tjenester tilknyttet annen bergverksdrift",
      "shortName": "Bergverkstjenester",
      "level": 5,
      "parentCode": "09.90"
    },
    {
      "code": "10.110",
      "name": "Bearbeiding og konservering av kjøtt",
      "shortName": "Kjøttbearbeiding og konservering",
      "level": 5,
      "parentCode": "10.11"
    },
    {
      "code": "10.120",
      "name": "Bearbeiding og konservering av fjørfekjøtt",
      "shortName": "Fjørfekjøttbearb. og konservering",
      "level": 5,
      "parentCode": "10.12"
    },
    {
      "code": "10.130",
      "name": "Produksjon av kjøtt- og fjørfevarer",
      "shortName": "Kjøtt- og fjørfevareproduksjon",
      "level": 5,
      "parentCode": "10.13"
    },
    {
      "code": "10.201",
      "name": "Produksjon av saltfisk, tørrfisk og klippfisk",
      "shortName": "Salt-, tørr- og klippfiskproduksjon",
      "level": 5,
      "parentCode": "10.20"
    },
    {
      "code": "10.202",
      "name": "Frysing av fisk, fiskefileter, skalldyr og bløtdyr",
      "shortName": "Frysing av fisk, fiskefileter mv.",
      "level": 5,
      "parentCode": "10.20"
    },
    {
      "code": "10.203",
      "name": "Produksjon av fiskehermetikk",
      "shortName": "Fiskehermetikkproduksjon",
      "level": 5,
      "parentCode": "10.20"
    },
    {
      "code": "10.209",
      "name": "Slakting, bearbeiding og konservering av fisk og fiskevarer ellers",
      "shortName": "Bearb. og konserv. av fisk/fiskev.",
      "level": 5,
      "parentCode": "10.20"
    },
    {
      "code": "10.310",
      "name": "Bearbeiding og konservering av poteter",
      "shortName": "Potetbearbeiding",
      "level": 5,
      "parentCode": "10.31"
    },
    {
      "code": "10.320",
      "name": "Produksjon av juice av frukt og grønnsaker",
      "shortName": "Frukt- og grønnsakjuiceproduksjon",
      "level": 5,
      "parentCode": "10.32"
    },
    {
      "code": "10.390",
      "name": "Bearbeiding og konservering av frukt og grønnsaker ellers",
      "shortName": "Frukt- og grønnsakbearbeiding el.",
      "level": 5,
      "parentCode": "10.39"
    },
    {
      "code": "10.411",
      "name": "Produksjon av rå fiskeoljer og fett",
      "shortName": "Prod. av rå fiskeoljer og fett",
      "level": 5,
      "parentCode": "10.41"
    },
    {
      "code": "10.412",
      "name": "Produksjon av andre uraffinerte oljer og fett",
      "shortName": "Prod. av andre uraff. oljer og fett",
      "level": 5,
      "parentCode": "10.41"
    },
    {
      "code": "10.413",
      "name": "Produksjon av raffinerte oljer og fett",
      "shortName": "Raffinert olje- og fettproduksjon",
      "level": 5,
      "parentCode": "10.41"
    },
    {
      "code": "10.420",
      "name": "Produksjon av margarin og lignende spiselige fettstoffer",
      "shortName": "Margarinproduksjon m.m.",
      "level": 5,
      "parentCode": "10.42"
    },
    {
      "code": "10.510",
      "name": "Produksjon av meierivarer",
      "shortName": "Meierivareproduksjon",
      "level": 5,
      "parentCode": "10.51"
    },
    {
      "code": "10.520",
      "name": "Produksjon av iskrem",
      "shortName": "Iskremproduksjon",
      "level": 5,
      "parentCode": "10.52"
    },
    {
      "code": "10.610",
      "name": "Produksjon av kornvarer",
      "shortName": "Kornvareproduksjon",
      "level": 5,
      "parentCode": "10.61"
    },
    {
      "code": "10.620",
      "name": "Produksjon av stivelse og stivelsesprodukter",
      "shortName": "Prod. av stivelse og stivelseprod.",
      "level": 5,
      "parentCode": "10.62"
    },
    {
      "code": "10.710",
      "name": "Produksjon av brød og ferske konditorvarer",
      "shortName": "Brød og ferske konditorvarer",
      "level": 5,
      "parentCode": "10.71"
    },
    {
      "code": "10.720",
      "name": "Produksjon av kavringer, kjeks og konserverte konditorvarer",
      "shortName": "Kavring- og kjeksprod. mv.",
      "level": 5,
      "parentCode": "10.72"
    },
    {
      "code": "10.730",
      "name": "Produksjon av makaroni, nudler, couscous og lignende pastavarer",
      "shortName": "Pastavareproduksjon",
      "level": 5,
      "parentCode": "10.73"
    },
    {
      "code": "10.810",
      "name": "Produksjon av sukker",
      "shortName": "Sukkerproduksjon",
      "level": 5,
      "parentCode": "10.81"
    },
    {
      "code": "10.820",
      "name": "Produksjon av kakao, sjokolade og sukkervarer",
      "shortName": "Kakao-, sjokolade- og sukkervareprod.",
      "level": 5,
      "parentCode": "10.82"
    },
    {
      "code": "10.830",
      "name": "Bearbeiding av te og kaffe",
      "shortName": "Te- og kaffebearbeiding",
      "level": 5,
      "parentCode": "10.83"
    },
    {
      "code": "10.840",
      "name": "Produksjon av smakstilsettingsstoffer og krydderier",
      "shortName": "Smakstilsettingsstoffer og krydder",
      "level": 5,
      "parentCode": "10.84"
    },
    {
      "code": "10.850",
      "name": "Produksjon av ferdigmat",
      "shortName": "Ferdigmatproduksjon",
      "level": 5,
      "parentCode": "10.85"
    },
    {
      "code": "10.860",
      "name": "Produksjon av homogeniserte matprodukter og diettmat",
      "shortName": "Diettmat og homogeniserte matprod.",
      "level": 5,
      "parentCode": "10.86"
    },
    {
      "code": "10.890",
      "name": "Produksjon av næringsmidler ikke nevnt annet sted",
      "shortName": "Produksjon av næringsmidler el.",
      "level": 5,
      "parentCode": "10.89"
    },
    {
      "code": "10.910",
      "name": "Produksjon av fôrvarer til husdyrhold",
      "shortName": "Fôrvareproduksjon til husdyr",
      "level": 5,
      "parentCode": "10.91"
    },
    {
      "code": "10.920",
      "name": "Produksjon av fôrvarer til kjæledyr",
      "shortName": "Fôrvareproduksjon til kjæledyr",
      "level": 5,
      "parentCode": "10.92"
    },
    {
      "code": "11.010",
      "name": "Destillering, rektifisering og blanding av sprit",
      "shortName": "Destill. alkoholholdige drikkevarer",
      "level": 5,
      "parentCode": "11.01"
    },
    {
      "code": "11.020",
      "name": "Produksjon av vin",
      "shortName": "Vinproduksjon",
      "level": 5,
      "parentCode": "11.02"
    },
    {
      "code": "11.030",
      "name": "Produksjon av sider og annen fruktvin",
      "shortName": "Sider- og annen fruktvinproduksjon",
      "level": 5,
      "parentCode": "11.03"
    },
    {
      "code": "11.040",
      "name": "Produksjon av andre ikke-destillerte gjærede drikkevarer",
      "shortName": "Ikke-destill. gjærede drikkevarer",
      "level": 5,
      "parentCode": "11.04"
    },
    {
      "code": "11.050",
      "name": "Produksjon av øl",
      "shortName": "Ølproduksjon",
      "level": 5,
      "parentCode": "11.05"
    },
    {
      "code": "11.060",
      "name": "Produksjon av malt",
      "shortName": "Maltproduksjon",
      "level": 5,
      "parentCode": "11.06"
    },
    {
      "code": "11.070",
      "name": "Produksjon av mineralvann, leskedrikker og annet vann på flaske",
      "shortName": "Mineralvann- og leskedrikkproduksjon",
      "level": 5,
      "parentCode": "11.07"
    },
    {
      "code": "12.000",
      "name": "Produksjon av tobakksvarer",
      "shortName": "Tobakksindustri",
      "level": 5,
      "parentCode": "12.00"
    },
    {
      "code": "13.100",
      "name": "Bearbeiding og spinning av tekstilfibrer",
      "shortName": "Bearb./spinning av tekstilfibrer",
      "level": 5,
      "parentCode": "13.10"
    },
    {
      "code": "13.200",
      "name": "Veving av tekstiler",
      "shortName": "Veving av tekstiler",
      "level": 5,
      "parentCode": "13.20"
    },
    {
      "code": "13.300",
      "name": "Etterbehandling av tekstiler",
      "shortName": "Etterbehandling av tekstiler",
      "level": 5,
      "parentCode": "13.30"
    },
    {
      "code": "13.910",
      "name": "Produksjon av stoffer av trikotasje",
      "shortName": "Trikotasjestoffproduksjon",
      "level": 5,
      "parentCode": "13.91"
    },
    {
      "code": "13.921",
      "name": "Produksjon av utstyrsvarer",
      "shortName": "Utstyrsvareproduksjon",
      "level": 5,
      "parentCode": "13.92"
    },
    {
      "code": "13.929",
      "name": "Produksjon av andre tekstilvarer, unntatt klær",
      "shortName": "Annen tekstilvareprod., unnt. klær",
      "level": 5,
      "parentCode": "13.92"
    },
    {
      "code": "13.930",
      "name": "Produksjon av gulvtepper, -matter og -ryer",
      "shortName": "Gulvteppe-, matte- og ryeproduksjon",
      "level": 5,
      "parentCode": "13.93"
    },
    {
      "code": "13.940",
      "name": "Produksjon av tauverk og nett",
      "shortName": "Tauverk- og nettproduksjon",
      "level": 5,
      "parentCode": "13.94"
    },
    {
      "code": "13.950",
      "name": "Produksjon av ikke-vevde tekstiler og tekstilvarer, unntatt klær",
      "shortName": "Fiberproduksjon mv.",
      "level": 5,
      "parentCode": "13.95"
    },
    {
      "code": "13.960",
      "name": "Produksjon av tekstiler til teknisk og industriell bruk",
      "shortName": "Tekstiler til tekn./industriell bruk",
      "level": 5,
      "parentCode": "13.96"
    },
    {
      "code": "13.990",
      "name": "Produksjon av tekstiler ikke nevnt annet sted",
      "shortName": "Tekstilproduksjon el.",
      "level": 5,
      "parentCode": "13.99"
    },
    {
      "code": "14.110",
      "name": "Produksjon av klær av lær",
      "shortName": "Produksjon av klær av lær",
      "level": 5,
      "parentCode": "14.11"
    },
    {
      "code": "14.120",
      "name": "Produksjon av arbeidstøy",
      "shortName": "Arbeidstøyproduksjon",
      "level": 5,
      "parentCode": "14.12"
    },
    {
      "code": "14.130",
      "name": "Produksjon av annet yttertøy",
      "shortName": "Annen yttertøyproduksjon",
      "level": 5,
      "parentCode": "14.13"
    },
    {
      "code": "14.140",
      "name": "Produksjon av undertøy og innertøy",
      "shortName": "Undertøy- og innertøyproduksjon",
      "level": 5,
      "parentCode": "14.14"
    },
    {
      "code": "14.190",
      "name": "Produksjon av klær og tilbehør ellers",
      "shortName": "Produksjon av klær og tilbehør el.",
      "level": 5,
      "parentCode": "14.19"
    },
    {
      "code": "14.200",
      "name": "Produksjon av pelsvarer",
      "shortName": "Produksjon av pelsvarer",
      "level": 5,
      "parentCode": "14.20"
    },
    {
      "code": "14.310",
      "name": "Produksjon av strømpevarer",
      "shortName": "Strømpevareproduksjon",
      "level": 5,
      "parentCode": "14.31"
    },
    {
      "code": "14.390",
      "name": "Produksjon av andre klær av trikotasje",
      "shortName": "Prod. av klær av trikotasje el.",
      "level": 5,
      "parentCode": "14.39"
    },
    {
      "code": "15.110",
      "name": "Beredning av lær, og beredning og farging av pelsskinn",
      "shortName": "Lærberedning",
      "level": 5,
      "parentCode": "15.11"
    },
    {
      "code": "15.120",
      "name": "Produksjon av reiseeffekter og salmakerartikler",
      "shortName": "Reiseeffekter og salmakerartikler",
      "level": 5,
      "parentCode": "15.12"
    },
    {
      "code": "15.200",
      "name": "Produksjon av skotøy",
      "shortName": "Produksjon av skotøy",
      "level": 5,
      "parentCode": "15.20"
    },
    {
      "code": "16.100",
      "name": "Saging, høvling og impregnering av tre",
      "shortName": "Saging, høvling mv. av tre",
      "level": 5,
      "parentCode": "16.10"
    },
    {
      "code": "16.210",
      "name": "Produksjon av finerplater og andre bygnings- og møbelplater av tre",
      "shortName": "Bygnings- og møbelplateproduksjon",
      "level": 5,
      "parentCode": "16.21"
    },
    {
      "code": "16.220",
      "name": "Produksjon av sammensatte parkettstaver",
      "shortName": "Sammensatte parkettstavprod.",
      "level": 5,
      "parentCode": "16.22"
    },
    {
      "code": "16.231",
      "name": "Produksjon av monteringsferdige hus",
      "shortName": "Ferdighusproduksjon",
      "level": 5,
      "parentCode": "16.23"
    },
    {
      "code": "16.232",
      "name": "Produksjon av bygningsartikler",
      "shortName": "Bygningsartikkelproduksjon",
      "level": 5,
      "parentCode": "16.23"
    },
    {
      "code": "16.240",
      "name": "Produksjon av treemballasje",
      "shortName": "Treemballasjeproduksjon",
      "level": 5,
      "parentCode": "16.24"
    },
    {
      "code": "16.290",
      "name": "Produksjon av andre trevarer og varer av kork, strå og flettematerialer",
      "shortName": "Andre tre-, kork-, stråvarer mv.",
      "level": 5,
      "parentCode": "16.29"
    },
    {
      "code": "17.110",
      "name": "Produksjon av papirmasse",
      "shortName": "Produksjon av papirmasse",
      "level": 5,
      "parentCode": "17.11"
    },
    {
      "code": "17.120",
      "name": "Produksjon av papir og papp",
      "shortName": "Produksjon av papir og papp",
      "level": 5,
      "parentCode": "17.12"
    },
    {
      "code": "17.210",
      "name": "Produksjon av bølgepapp og emballasje av papir og papp",
      "shortName": "Bølgepapp, papir- og pappemballasje",
      "level": 5,
      "parentCode": "17.21"
    },
    {
      "code": "17.220",
      "name": "Produksjon av husholdnings-, sanitær- og toalettartikler av papir",
      "shortName": "Hushold.-/toalettartikler av papir",
      "level": 5,
      "parentCode": "17.22"
    },
    {
      "code": "17.230",
      "name": "Produksjon av kontorartikler av papir",
      "shortName": "Prod. av kontorartikler av papir",
      "level": 5,
      "parentCode": "17.23"
    },
    {
      "code": "17.240",
      "name": "Produksjon av tapeter",
      "shortName": "Tapetproduksjon",
      "level": 5,
      "parentCode": "17.24"
    },
    {
      "code": "17.290",
      "name": "Produksjon av varer av papir og papp ellers",
      "shortName": "Papir- og pappvareproduksjon el.",
      "level": 5,
      "parentCode": "17.29"
    },
    {
      "code": "18.110",
      "name": "Trykking av aviser",
      "shortName": "Trykking av aviser",
      "level": 5,
      "parentCode": "18.11"
    },
    {
      "code": "18.120",
      "name": "Trykking ellers",
      "shortName": "Trykking ellers",
      "level": 5,
      "parentCode": "18.12"
    },
    {
      "code": "18.130",
      "name": "Ferdiggjøring før trykking og publisering",
      "shortName": "Ferdiggjøring før trykking og publ.",
      "level": 5,
      "parentCode": "18.13"
    },
    {
      "code": "18.140",
      "name": "Bokbinding og tilknyttede tjenester",
      "shortName": "Bokbinding og tilkn. tjenester",
      "level": 5,
      "parentCode": "18.14"
    },
    {
      "code": "18.200",
      "name": "Reproduksjon av innspilte opptak",
      "shortName": "Reproduksjon av innspilte opptak",
      "level": 5,
      "parentCode": "18.20"
    },
    {
      "code": "19.100",
      "name": "Produksjon av kullprodukter",
      "shortName": "Produksjon av kullprodukter",
      "level": 5,
      "parentCode": "19.10"
    },
    {
      "code": "19.200",
      "name": "Produksjon av raffinerte petroleumsprodukter",
      "shortName": "Prod. raffinerte petroleumsprodukt",
      "level": 5,
      "parentCode": "19.20"
    },
    {
      "code": "20.110",
      "name": "Produksjon av industrigasser",
      "shortName": "Industrigassproduksjon",
      "level": 5,
      "parentCode": "20.11"
    },
    {
      "code": "20.120",
      "name": "Produksjon av fargestoffer og pigmenter",
      "shortName": "Fargestoff- og pigmentproduksjon",
      "level": 5,
      "parentCode": "20.12"
    },
    {
      "code": "20.130",
      "name": "Produksjon av andre uorganiske kjemikalier",
      "shortName": "Uorganisk kjemikalieproduksjon el.",
      "level": 5,
      "parentCode": "20.13"
    },
    {
      "code": "20.140",
      "name": "Produksjon av andre organiske kjemiske råvarer",
      "shortName": "Annen org. kjemisk råvareproduksjon",
      "level": 5,
      "parentCode": "20.14"
    },
    {
      "code": "20.150",
      "name": "Produksjon av gjødsel, nitrogenforbindelser og vekstjord",
      "shortName": "Gjødselproduksjon mv.",
      "level": 5,
      "parentCode": "20.15"
    },
    {
      "code": "20.160",
      "name": "Produksjon av basisplast",
      "shortName": "Basisplastproduksjon",
      "level": 5,
      "parentCode": "20.16"
    },
    {
      "code": "20.170",
      "name": "Produksjon av syntetisk gummi",
      "shortName": "Produksjon av syntetisk gummi",
      "level": 5,
      "parentCode": "20.17"
    },
    {
      "code": "20.200",
      "name": "Produksjon av plantevern- og skadedyrmidler og andre landbrukskjemiske produkter",
      "shortName": "Produksjon landbrukskjemiske prod.",
      "level": 5,
      "parentCode": "20.20"
    },
    {
      "code": "20.300",
      "name": "Produksjon av maling og lakk, trykkfarger og tetningsmidler",
      "shortName": "Produksjon maling, lakk mv.",
      "level": 5,
      "parentCode": "20.30"
    },
    {
      "code": "20.410",
      "name": "Produksjon av såpe og vaskemidler, rense- og polermidler",
      "shortName": "Såpe- og vaskemiddelprod. mv.",
      "level": 5,
      "parentCode": "20.41"
    },
    {
      "code": "20.420",
      "name": "Produksjon av parfyme og toalettartikler",
      "shortName": "Parfyme og toalettartikler",
      "level": 5,
      "parentCode": "20.42"
    },
    {
      "code": "20.510",
      "name": "Produksjon av eksplosiver",
      "shortName": "Produksjon av eksplosiver",
      "level": 5,
      "parentCode": "20.51"
    },
    {
      "code": "20.520",
      "name": "Produksjon av lim",
      "shortName": "Limproduksjon",
      "level": 5,
      "parentCode": "20.52"
    },
    {
      "code": "20.530",
      "name": "Produksjon av eteriske oljer",
      "shortName": "Produksjon av eteriske oljer",
      "level": 5,
      "parentCode": "20.53"
    },
    {
      "code": "20.590",
      "name": "Produksjon av kjemiske produkter ikke nevnt annet sted",
      "shortName": "Annen kjemisk produksjon",
      "level": 5,
      "parentCode": "20.59"
    },
    {
      "code": "20.600",
      "name": "Produksjon av kunstfibrer",
      "shortName": "Produksjon av kunstfibrer",
      "level": 5,
      "parentCode": "20.60"
    },
    {
      "code": "21.100",
      "name": "Produksjon av farmasøytiske råvarer",
      "shortName": "Farmasøytiske råvarer",
      "level": 5,
      "parentCode": "21.10"
    },
    {
      "code": "21.200",
      "name": "Produksjon av farmasøytiske preparater",
      "shortName": "Farmasøytiske preparater",
      "level": 5,
      "parentCode": "21.20"
    },
    {
      "code": "22.110",
      "name": "Produksjon av gummidekk og slanger til gummidekk, og regummiering og vulkanisering av gummidekk",
      "shortName": "Gummidekkprod., -regumm. og -vulk",
      "level": 5,
      "parentCode": "22.11"
    },
    {
      "code": "22.190",
      "name": "Produksjon av gummiprodukter ellers",
      "shortName": "Produksjon av gummiprodukter el.",
      "level": 5,
      "parentCode": "22.19"
    },
    {
      "code": "22.210",
      "name": "Produksjon av halvfabrikater av plast",
      "shortName": "Prod. av halvfabrikater av plast",
      "level": 5,
      "parentCode": "22.21"
    },
    {
      "code": "22.220",
      "name": "Produksjon av plastemballasje",
      "shortName": "Plastemballasjeproduksjon",
      "level": 5,
      "parentCode": "22.22"
    },
    {
      "code": "22.230",
      "name": "Produksjon av byggevarer av plast",
      "shortName": "Byggevareprod. av plast",
      "level": 5,
      "parentCode": "22.23"
    },
    {
      "code": "22.290",
      "name": "Produksjon av plastprodukter ellers",
      "shortName": "Prod. av plastprodukter el.",
      "level": 5,
      "parentCode": "22.29"
    },
    {
      "code": "23.110",
      "name": "Produksjon av planglass",
      "shortName": "Planglassproduksjon",
      "level": 5,
      "parentCode": "23.11"
    },
    {
      "code": "23.120",
      "name": "Bearbeiding av planglass",
      "shortName": "Planglassbearbeiding",
      "level": 5,
      "parentCode": "23.12"
    },
    {
      "code": "23.130",
      "name": "Produksjon av emballasje og husholdningsartikler av glass og krystall",
      "shortName": "Emb. og hush.art. av glass/krystall",
      "level": 5,
      "parentCode": "23.13"
    },
    {
      "code": "23.140",
      "name": "Produksjon av glassfibrer",
      "shortName": "Glassfiberproduksjon",
      "level": 5,
      "parentCode": "23.14"
    },
    {
      "code": "23.190",
      "name": "Produksjon av teknisk glass og andre glassvarer",
      "shortName": "Tekn. glass- og annen glassvareprod.",
      "level": 5,
      "parentCode": "23.19"
    },
    {
      "code": "23.200",
      "name": "Produksjon av ildfaste produkter",
      "shortName": "Prod. av ildfaste produkter",
      "level": 5,
      "parentCode": "23.20"
    },
    {
      "code": "23.310",
      "name": "Produksjon av keramiske vegg- og gulvfliser",
      "shortName": "Keramisk byggematerialproduksjon",
      "level": 5,
      "parentCode": "23.31"
    },
    {
      "code": "23.320",
      "name": "Produksjon av murstein, teglstein og andre byggevarer av brent leire",
      "shortName": "Mur-, teglstein- o.a. byggevareprod.",
      "level": 5,
      "parentCode": "23.32"
    },
    {
      "code": "23.410",
      "name": "Produksjon av keramiske husholdningsartikler og dekorasjonsgjenstander",
      "shortName": "Keramiske husholdningsartikler mv.",
      "level": 5,
      "parentCode": "23.41"
    },
    {
      "code": "23.420",
      "name": "Produksjon av sanitærutstyr av keramisk materiale",
      "shortName": "Prod. av keramisk sanitærutstyr",
      "level": 5,
      "parentCode": "23.42"
    },
    {
      "code": "23.430",
      "name": "Produksjon av isolatorer og isoleringsdeler av keramisk materiale",
      "shortName": "Prod. av keramiske isoleringsdeler",
      "level": 5,
      "parentCode": "23.43"
    },
    {
      "code": "23.440",
      "name": "Produksjon av andre keramiske produkter for teknisk bruk",
      "shortName": "Prod. av keram. prod. for tekn. bruk",
      "level": 5,
      "parentCode": "23.44"
    },
    {
      "code": "23.490",
      "name": "Produksjon av andre keramiske produkter",
      "shortName": "Prod. av andre keram. prod.",
      "level": 5,
      "parentCode": "23.49"
    },
    {
      "code": "23.510",
      "name": "Produksjon av sement",
      "shortName": "Sementproduksjon",
      "level": 5,
      "parentCode": "23.51"
    },
    {
      "code": "23.520",
      "name": "Produksjon av kalk og gips",
      "shortName": "Kalk- og gipsproduksjon",
      "level": 5,
      "parentCode": "23.52"
    },
    {
      "code": "23.610",
      "name": "Produksjon av betongprodukter for bygge- og anleggsvirksomhet",
      "shortName": "Betongprodukter for bygg og anlegg",
      "level": 5,
      "parentCode": "23.61"
    },
    {
      "code": "23.620",
      "name": "Produksjon av gipsprodukter for bygge- og anleggsvirksomhet",
      "shortName": "Gipsprodukter for bygg og anlegg",
      "level": 5,
      "parentCode": "23.62"
    },
    {
      "code": "23.630",
      "name": "Produksjon av ferdigblandet betong",
      "shortName": "Ferdigblandet betong",
      "level": 5,
      "parentCode": "23.63"
    },
    {
      "code": "23.640",
      "name": "Produksjon av mørtel",
      "shortName": "Mørtelproduksjon",
      "level": 5,
      "parentCode": "23.64"
    },
    {
      "code": "23.650",
      "name": "Produksjon av fibersement",
      "shortName": "Fibersementproduksjon",
      "level": 5,
      "parentCode": "23.65"
    },
    {
      "code": "23.690",
      "name": "Produksjon av betong-, sement- og gipsprodukter ellers",
      "shortName": "Annen betong-, sement- og gipsprod.",
      "level": 5,
      "parentCode": "23.69"
    },
    {
      "code": "23.700",
      "name": "Hogging og bearbeiding av monument- og bygningsstein",
      "shortName": "Hogg./bearb. av monum.-/bygn.stein",
      "level": 5,
      "parentCode": "23.70"
    },
    {
      "code": "23.910",
      "name": "Produksjon av slipestoffer",
      "shortName": "Slipestoffproduksjon",
      "level": 5,
      "parentCode": "23.91"
    },
    {
      "code": "23.990",
      "name": "Produksjon av ikke-metallholdige mineralprodukter ikke nevnt annet sted",
      "shortName": "Prod. av ikke-met. mineralprod. el.",
      "level": 5,
      "parentCode": "23.99"
    },
    {
      "code": "24.101",
      "name": "Produksjon av jern og stål",
      "shortName": "Jern- og stålproduksjon",
      "level": 5,
      "parentCode": "24.10"
    },
    {
      "code": "24.102",
      "name": "Produksjon av ferrolegeringer",
      "shortName": "Prod. av ferrolegeringer",
      "level": 5,
      "parentCode": "24.10"
    },
    {
      "code": "24.200",
      "name": "Produksjon av andre rør og rørdeler av stål",
      "shortName": "Annen rør- og rørdelprod. av stål",
      "level": 5,
      "parentCode": "24.20"
    },
    {
      "code": "24.310",
      "name": "Kaldtrekking av stenger og profiler",
      "shortName": "Kaldtrekking av stenger og profiler",
      "level": 5,
      "parentCode": "24.31"
    },
    {
      "code": "24.320",
      "name": "Kaldvalsing av bånd",
      "shortName": "Kaldvalsing av bånd",
      "level": 5,
      "parentCode": "24.32"
    },
    {
      "code": "24.330",
      "name": "Kaldvalsing og pressing av profilerte plater og profiler",
      "shortName": "Kaldv./press. av prof. plater mv.",
      "level": 5,
      "parentCode": "24.33"
    },
    {
      "code": "24.340",
      "name": "Kaldtrekking av tråd",
      "shortName": "Kaldtrekking av tråd",
      "level": 5,
      "parentCode": "24.34"
    },
    {
      "code": "24.410",
      "name": "Produksjon av edelmetaller",
      "shortName": "Edelmetallproduksjon",
      "level": 5,
      "parentCode": "24.41"
    },
    {
      "code": "24.421",
      "name": "Produksjon av primæraluminium",
      "shortName": "Prod. av primæraluminium",
      "level": 5,
      "parentCode": "24.42"
    },
    {
      "code": "24.422",
      "name": "Produksjon av halvfabrikater av aluminium",
      "shortName": "Prod. av halvfabrikater av aluminium",
      "level": 5,
      "parentCode": "24.42"
    },
    {
      "code": "24.430",
      "name": "Produksjon av bly, sink og tinn",
      "shortName": "Bly-, sink- og tinnproduksjon",
      "level": 5,
      "parentCode": "24.43"
    },
    {
      "code": "24.440",
      "name": "Produksjon av kobber",
      "shortName": "Kobberproduksjon",
      "level": 5,
      "parentCode": "24.44"
    },
    {
      "code": "24.450",
      "name": "Produksjon av ikke-jernholdige metaller ellers",
      "shortName": "Prod. ikke-jernhold. metaller ellers",
      "level": 5,
      "parentCode": "24.45"
    },
    {
      "code": "24.460",
      "name": "Produksjon av kjernebrensel",
      "shortName": "Kjernebrenselproduksjon",
      "level": 5,
      "parentCode": "24.46"
    },
    {
      "code": "24.510",
      "name": "Støping av jern",
      "shortName": "Støping av jern",
      "level": 5,
      "parentCode": "24.51"
    },
    {
      "code": "24.520",
      "name": "Støping av stål",
      "shortName": "Støping av stål",
      "level": 5,
      "parentCode": "24.52"
    },
    {
      "code": "24.530",
      "name": "Støping av lettmetaller",
      "shortName": "Støping av lettmetaller",
      "level": 5,
      "parentCode": "24.53"
    },
    {
      "code": "24.540",
      "name": "Støping av andre ikke-jernholdige metaller",
      "shortName": "Annen ikke-jernholdig metallstøp.",
      "level": 5,
      "parentCode": "24.54"
    },
    {
      "code": "25.110",
      "name": "Produksjon av metallkonstruksjoner og deler",
      "shortName": "Prod. av metallkonstruksj. og deler",
      "level": 5,
      "parentCode": "25.11"
    },
    {
      "code": "25.120",
      "name": "Produksjon av dører og vinduer av metall",
      "shortName": "Bygningsartikkelprod. av metall",
      "level": 5,
      "parentCode": "25.12"
    },
    {
      "code": "25.210",
      "name": "Produksjon av radiatorer og kjeler til sentralvarmeanlegg",
      "shortName": "Sentralv.kjeler- og radiatorprod.",
      "level": 5,
      "parentCode": "25.21"
    },
    {
      "code": "25.290",
      "name": "Produksjon av andre tanker, cisterner og beholdere av metall",
      "shortName": "Prod. av metallbeholdere",
      "level": 5,
      "parentCode": "25.29"
    },
    {
      "code": "25.300",
      "name": "Produksjon av dampkjeler, unntatt kjeler til sentralvarmeanlegg",
      "shortName": "Dampkjeler unnt. sentralvarmeanl.",
      "level": 5,
      "parentCode": "25.30"
    },
    {
      "code": "25.400",
      "name": "Produksjon av våpen og ammunisjon",
      "shortName": "Våpen- og ammunisjonsproduksjon",
      "level": 5,
      "parentCode": "25.40"
    },
    {
      "code": "25.500",
      "name": "Smiing, stansing og valsing av metall, og pulvermetallurgi",
      "shortName": "Stansing/valsing/pulvermetallurgi",
      "level": 5,
      "parentCode": "25.50"
    },
    {
      "code": "25.610",
      "name": "Overflatebehandling av metaller",
      "shortName": "Overflatebehandling av metaller",
      "level": 5,
      "parentCode": "25.61"
    },
    {
      "code": "25.620",
      "name": "Bearbeiding av metaller",
      "shortName": "Bearbeiding av metaller",
      "level": 5,
      "parentCode": "25.62"
    },
    {
      "code": "25.710",
      "name": "Produksjon av kjøkkenredskaper og skjære- og klipperedskaper",
      "shortName": "Kjøkkenredskapsproduksjon",
      "level": 5,
      "parentCode": "25.71"
    },
    {
      "code": "25.720",
      "name": "Produksjon av låser og beslag",
      "shortName": "Låse- og beslagproduksjon",
      "level": 5,
      "parentCode": "25.72"
    },
    {
      "code": "25.730",
      "name": "Produksjon av håndverktøy",
      "shortName": "Håndverktøyproduksjon",
      "level": 5,
      "parentCode": "25.73"
    },
    {
      "code": "25.910",
      "name": "Produksjon av stålfat og lignende beholdere av jern og stål",
      "shortName": "Prod. av behold. mv. av jern/stål",
      "level": 5,
      "parentCode": "25.91"
    },
    {
      "code": "25.920",
      "name": "Produksjon av emballasje av lettmetall",
      "shortName": "Prod. av lettmetallemballasje",
      "level": 5,
      "parentCode": "25.92"
    },
    {
      "code": "25.930",
      "name": "Produksjon av varer av metalltråd, kjetting og fjærer",
      "shortName": "Metalltrådvareproduksjon",
      "level": 5,
      "parentCode": "25.93"
    },
    {
      "code": "25.940",
      "name": "Produksjon av bolter og skruer",
      "shortName": "Bolte- og skrueproduksjon",
      "level": 5,
      "parentCode": "25.94"
    },
    {
      "code": "25.990",
      "name": "Produksjon av metallvarer ikke nevnt annet sted",
      "shortName": "Metallvareprod. el.",
      "level": 5,
      "parentCode": "25.99"
    },
    {
      "code": "26.110",
      "name": "Produksjon av elektroniske komponenter",
      "shortName": "Prod. av elektroniske komponenter",
      "level": 5,
      "parentCode": "26.11"
    },
    {
      "code": "26.120",
      "name": "Produksjon av kretskort",
      "shortName": "Produksjon av kretskort",
      "level": 5,
      "parentCode": "26.12"
    },
    {
      "code": "26.200",
      "name": "Produksjon av datamaskiner og tilleggsutstyr",
      "shortName": "Prod. datamaskiner og tilleggsutstyr",
      "level": 5,
      "parentCode": "26.20"
    },
    {
      "code": "26.300",
      "name": "Produksjon av kommunikasjonsutstyr",
      "shortName": "Prod. av kommunikasjonsutstyr",
      "level": 5,
      "parentCode": "26.30"
    },
    {
      "code": "26.400",
      "name": "Produksjon av elektronikk til husholdningsbruk",
      "shortName": "Prod. av husholdningselektronikk",
      "level": 5,
      "parentCode": "26.40"
    },
    {
      "code": "26.510",
      "name": "Produksjon av måle-, kontroll- og navigasjonsinstrumenter",
      "shortName": "Måle-, kontroll- og navig.instr.",
      "level": 5,
      "parentCode": "26.51"
    },
    {
      "code": "26.520",
      "name": "Produksjon av klokker og ur",
      "shortName": "Klokke- og urproduksjon",
      "level": 5,
      "parentCode": "26.52"
    },
    {
      "code": "26.600",
      "name": "Produksjon av strålingsutstyr, elektromedisinsk og elektroterapeutisk utstyr",
      "shortName": "Elektromed./elektroterap. utst. mv.",
      "level": 5,
      "parentCode": "26.60"
    },
    {
      "code": "26.700",
      "name": "Produksjon av optiske instrumenter og fotografisk utstyr",
      "shortName": "Optiske instr./fotografisk utstyr",
      "level": 5,
      "parentCode": "26.70"
    },
    {
      "code": "26.800",
      "name": "Produksjon av magnetiske og optiske media",
      "shortName": "Magnetiske/optiske media",
      "level": 5,
      "parentCode": "26.80"
    },
    {
      "code": "27.110",
      "name": "Produksjon av elektromotorer, generatorer og transformatorer",
      "shortName": "Elektromotor-, generatorprod. mv.",
      "level": 5,
      "parentCode": "27.11"
    },
    {
      "code": "27.120",
      "name": "Produksjon av elektriske fordelings- og kontrolltavler og paneler",
      "shortName": "Elektriske tavler, paneler mv.",
      "level": 5,
      "parentCode": "27.12"
    },
    {
      "code": "27.200",
      "name": "Produksjon av batterier og akkumulatorer",
      "shortName": "Batterier, akkumulatorer",
      "level": 5,
      "parentCode": "27.20"
    },
    {
      "code": "27.310",
      "name": "Produksjon av optiske fiberkabler",
      "shortName": "Prod. av optiske fiberkabler",
      "level": 5,
      "parentCode": "27.31"
    },
    {
      "code": "27.320",
      "name": "Produksjon av andre elektroniske og elektriske ledninger og kabler",
      "shortName": "Elektron./el. ledninger/kabler el.",
      "level": 5,
      "parentCode": "27.32"
    },
    {
      "code": "27.330",
      "name": "Produksjon av ledningsmateriell",
      "shortName": "Prod. av ledningsmateriell",
      "level": 5,
      "parentCode": "27.33"
    },
    {
      "code": "27.400",
      "name": "Produksjon av belysningsutstyr",
      "shortName": "Prod. av belysningsutstyr",
      "level": 5,
      "parentCode": "27.40"
    },
    {
      "code": "27.510",
      "name": "Produksjon av elektriske husholdningsmaskiner og apparater",
      "shortName": "Elektr. hush.maskin-/apparatprod.",
      "level": 5,
      "parentCode": "27.51"
    },
    {
      "code": "27.520",
      "name": "Produksjon av ikke-elektriske husholdningsmaskiner og apparater",
      "shortName": "Ikke-el. hush.mask.-/apparatprod.",
      "level": 5,
      "parentCode": "27.52"
    },
    {
      "code": "27.900",
      "name": "Produksjon av annet elektrisk utstyr",
      "shortName": "Produksjon elektrisk utstyr ellers",
      "level": 5,
      "parentCode": "27.90"
    },
    {
      "code": "28.110",
      "name": "Produksjon av motorer og turbiner, unntatt motorer til luftfartøyer og motorvogner",
      "shortName": "Skipsmotor-/motor- og turbinprod. el.",
      "level": 5,
      "parentCode": "28.11"
    },
    {
      "code": "28.120",
      "name": "Produksjon av komponenter til hydraulisk og pneumatisk utstyr",
      "shortName": "Komp. til hydraul./pneumatisk utstyr",
      "level": 5,
      "parentCode": "28.12"
    },
    {
      "code": "28.130",
      "name": "Produksjon av pumper og kompressorer ellers",
      "shortName": "Pumpe- og kompressorprod. el.",
      "level": 5,
      "parentCode": "28.13"
    },
    {
      "code": "28.140",
      "name": "Produksjon av kraner og ventiler ellers",
      "shortName": "Kran- og ventilproduksjon el.",
      "level": 5,
      "parentCode": "28.14"
    },
    {
      "code": "28.150",
      "name": "Produksjon av lagre, gir, tannhjulsutvekslinger og andre innretninger for kraftoverføring",
      "shortName": "Lager-, girproduksjon mv.",
      "level": 5,
      "parentCode": "28.15"
    },
    {
      "code": "28.210",
      "name": "Produksjon av industri- og laboratorieovner samt brennere",
      "shortName": "Industri- og laboratorieovnprod.",
      "level": 5,
      "parentCode": "28.21"
    },
    {
      "code": "28.221",
      "name": "Produksjon av løfte- og håndteringsutstyr til skip og båter",
      "shortName": "Løfteutstyr m.m. for skip og båter",
      "level": 5,
      "parentCode": "28.22"
    },
    {
      "code": "28.229",
      "name": "Produksjon av løfte- og håndteringsutstyr ellers",
      "shortName": "Løfte- og håndteringsutstyr el.",
      "level": 5,
      "parentCode": "28.22"
    },
    {
      "code": "28.230",
      "name": "Produksjon av kontormaskiner og utstyr (unntatt datamaskiner og tilleggsutstyr)",
      "shortName": "Kontormaskinproduksjon",
      "level": 5,
      "parentCode": "28.23"
    },
    {
      "code": "28.240",
      "name": "Produksjon av motordrevet håndverktøy",
      "shortName": "Prod. av motordrevet håndverktøy",
      "level": 5,
      "parentCode": "28.24"
    },
    {
      "code": "28.250",
      "name": "Produksjon av kjøle- og ventilasjonsanlegg, unntatt til husholdningsbruk",
      "shortName": "Kjøle- og ventilasjonsanleggprod.",
      "level": 5,
      "parentCode": "28.25"
    },
    {
      "code": "28.290",
      "name": "Produksjon av maskiner og utstyr til generell bruk, ikke nevnt annet sted",
      "shortName": "Maskiner og utstyr til gen. bruk el.",
      "level": 5,
      "parentCode": "28.29"
    },
    {
      "code": "28.300",
      "name": "Produksjon av jordbruks- og skogbruksmaskiner",
      "shortName": "Jord- og skogbruksmaskinproduksjon",
      "level": 5,
      "parentCode": "28.30"
    },
    {
      "code": "28.410",
      "name": "Produksjon av maskinverktøy til metallbearbeiding",
      "shortName": "Maskinverktøy til metallbearb.",
      "level": 5,
      "parentCode": "28.41"
    },
    {
      "code": "28.490",
      "name": "Produksjon av maskinverktøy ikke nevnt annet sted",
      "shortName": "Prod. av maskinverktøy el.",
      "level": 5,
      "parentCode": "28.49"
    },
    {
      "code": "28.910",
      "name": "Produksjon av maskiner og utstyr til metallurgisk industri",
      "shortName": "Mask./utstyr metallurgisk industri",
      "level": 5,
      "parentCode": "28.91"
    },
    {
      "code": "28.920",
      "name": "Produksjon av maskiner og utstyr til bergverksdrift og bygge- og anleggsvirksomhet",
      "shortName": "Mask./utstyr bergverk, bygg og anl.",
      "level": 5,
      "parentCode": "28.92"
    },
    {
      "code": "28.930",
      "name": "Produksjon av maskiner og utstyr til nærings- og nytelsesmiddelindustri",
      "shortName": "Mask./utstyr næringsmiddelindustri",
      "level": 5,
      "parentCode": "28.93"
    },
    {
      "code": "28.940",
      "name": "Produksjon av maskiner og utstyr til tekstil-, konfeksjons- og lærvareindustri",
      "shortName": "Mask./utstyr tekstilindustri",
      "level": 5,
      "parentCode": "28.94"
    },
    {
      "code": "28.950",
      "name": "Produksjon av maskiner og utstyr til papir- og pappvareindustri",
      "shortName": "Mask./utstyr papir- og pappvareindustri",
      "level": 5,
      "parentCode": "28.95"
    },
    {
      "code": "28.960",
      "name": "Produksjon av maskiner og utstyr til plast- og gummiindustri",
      "shortName": "Mask./utstyr plast- og gummiindustri",
      "level": 5,
      "parentCode": "28.96"
    },
    {
      "code": "28.990",
      "name": "Produksjon av spesialmaskiner ikke nevnt annet sted",
      "shortName": "Spesialmaskinproduksjon el.",
      "level": 5,
      "parentCode": "28.99"
    },
    {
      "code": "29.100",
      "name": "Produksjon av motorvogner",
      "shortName": "Motorvognproduksjon",
      "level": 5,
      "parentCode": "29.10"
    },
    {
      "code": "29.200",
      "name": "Produksjon av karosserier og tilhengere",
      "shortName": "Karosseri- og tilhengerproduksjon",
      "level": 5,
      "parentCode": "29.20"
    },
    {
      "code": "29.310",
      "name": "Produksjon av elektrisk og elektronisk utstyr til motorvogner",
      "shortName": "Elektrisk/elektron. utstyr motorv.",
      "level": 5,
      "parentCode": "29.31"
    },
    {
      "code": "29.320",
      "name": "Produksjon av andre deler og annet utstyr til motorvogner",
      "shortName": "Annet utstyr-/delprod. til motorv.",
      "level": 5,
      "parentCode": "29.32"
    },
    {
      "code": "30.111",
      "name": "Bygging av skip og skrog over 100 br.tonn",
      "shortName": "Bygg. av skip/skrog over 100 br.tonn",
      "level": 5,
      "parentCode": "30.11"
    },
    {
      "code": "30.112",
      "name": "Bygging av skip under 100 br.tonn",
      "shortName": "Bygg. av skip under 100 br.tonn",
      "level": 5,
      "parentCode": "30.11"
    },
    {
      "code": "30.113",
      "name": "Bygging av oljeplattformer og moduler",
      "shortName": "Bygging oljeplattformer, moduler",
      "level": 5,
      "parentCode": "30.11"
    },
    {
      "code": "30.114",
      "name": "Produksjon av annet flytende materiell",
      "shortName": "Annen flytende materiellproduksjon",
      "level": 5,
      "parentCode": "30.11"
    },
    {
      "code": "30.115",
      "name": "Innrednings- og installasjonsarbeid utført på skip over 100 br.tonn",
      "shortName": "Install. m.m. på skip over 100 br.t.",
      "level": 5,
      "parentCode": "30.11"
    },
    {
      "code": "30.116",
      "name": "Innrednings- og installasjonsarbeid utført på oljeplattformer og moduler",
      "shortName": "Install. m.m. på oljepl./moduler",
      "level": 5,
      "parentCode": "30.11"
    },
    {
      "code": "30.120",
      "name": "Bygging av fritidsbåter",
      "shortName": "Bygging av fritidsbåter",
      "level": 5,
      "parentCode": "30.12"
    },
    {
      "code": "30.200",
      "name": "Produksjon av lokomotiver og annet rullende materiell til jernbane og sporvei",
      "shortName": "Jernbane- og sporvognmateriell mv.",
      "level": 5,
      "parentCode": "30.20"
    },
    {
      "code": "30.300",
      "name": "Produksjon av luftfartøyer og romfartøyer og lignende utstyr",
      "shortName": "Prod. luft- og romfartøy og lignende",
      "level": 5,
      "parentCode": "30.30"
    },
    {
      "code": "30.400",
      "name": "Produksjon av militære stridskjøretøyer",
      "shortName": "Produksjon militære stridskjøretøy",
      "level": 5,
      "parentCode": "30.40"
    },
    {
      "code": "30.910",
      "name": "Produksjon av motorsykler",
      "shortName": "Motorsykkelproduksjon",
      "level": 5,
      "parentCode": "30.91"
    },
    {
      "code": "30.920",
      "name": "Produksjon av sykler og invalidevogner",
      "shortName": "Sykkel- og invalidevognprod.",
      "level": 5,
      "parentCode": "30.92"
    },
    {
      "code": "30.990",
      "name": "Produksjon av andre transportmidler ikke nevnt annet sted",
      "shortName": "Transportmiddelproduksjon el.",
      "level": 5,
      "parentCode": "30.99"
    },
    {
      "code": "31.010",
      "name": "Produksjon av kontor- og butikkmøbler",
      "shortName": "Kontor- og butikkmøbelprod.",
      "level": 5,
      "parentCode": "31.01"
    },
    {
      "code": "31.020",
      "name": "Produksjon av kjøkkenmøbler",
      "shortName": "Kjøkkenmøbelproduksjon",
      "level": 5,
      "parentCode": "31.02"
    },
    {
      "code": "31.030",
      "name": "Produksjon av madrasser",
      "shortName": "Madrassproduksjon",
      "level": 5,
      "parentCode": "31.03"
    },
    {
      "code": "31.090",
      "name": "Produksjon av møbler ellers",
      "shortName": "Møbelproduksjon el.",
      "level": 5,
      "parentCode": "31.09"
    },
    {
      "code": "32.110",
      "name": "Preging av mynter og medaljer",
      "shortName": "Mynt- og medaljepreging",
      "level": 5,
      "parentCode": "32.11"
    },
    {
      "code": "32.120",
      "name": "Produksjon av gull- og sølvvarer og lignende artikler",
      "shortName": "Gull- og sølvvareprod. mv.",
      "level": 5,
      "parentCode": "32.12"
    },
    {
      "code": "32.130",
      "name": "Produksjon av bijouteri og lignende artikler",
      "shortName": "Bijouterivareproduksjon mv.",
      "level": 5,
      "parentCode": "32.13"
    },
    {
      "code": "32.200",
      "name": "Produksjon av musikkinstrumenter",
      "shortName": "Musikkinstrumentproduksjon",
      "level": 5,
      "parentCode": "32.20"
    },
    {
      "code": "32.300",
      "name": "Produksjon av sportsartikler",
      "shortName": "Sportsartikkelproduksjon",
      "level": 5,
      "parentCode": "32.30"
    },
    {
      "code": "32.400",
      "name": "Produksjon av spill og leker",
      "shortName": "Spill- og leketøyproduksjon",
      "level": 5,
      "parentCode": "32.40"
    },
    {
      "code": "32.500",
      "name": "Produksjon av medisinske og tanntekniske instrumenter og utstyr",
      "shortName": "Medisinske og tanntekniske instr.",
      "level": 5,
      "parentCode": "32.50"
    },
    {
      "code": "32.910",
      "name": "Produksjon av koster og børster",
      "shortName": "Kost- og børsteproduksjon",
      "level": 5,
      "parentCode": "32.91"
    },
    {
      "code": "32.990",
      "name": "Annen industriproduksjon ikke nevnt annet sted",
      "shortName": "Industriproduksjon ellers",
      "level": 5,
      "parentCode": "32.99"
    },
    {
      "code": "33.110",
      "name": "Reparasjon av bearbeidede metallprodukter",
      "shortName": "Rep. av bearbeidede metallprodukter",
      "level": 5,
      "parentCode": "33.11"
    },
    {
      "code": "33.120",
      "name": "Reparasjon av maskiner",
      "shortName": "Reparasjon av maskiner",
      "level": 5,
      "parentCode": "33.12"
    },
    {
      "code": "33.130",
      "name": "Reparasjon av elektronisk og optisk utstyr",
      "shortName": "Rep. av elektronisk og optisk utstyr",
      "level": 5,
      "parentCode": "33.13"
    },
    {
      "code": "33.140",
      "name": "Reparasjon av elektrisk utstyr",
      "shortName": "Rep. av elektrisk utstyr",
      "level": 5,
      "parentCode": "33.14"
    },
    {
      "code": "33.150",
      "name": "Reparasjon og vedlikehold av skip og båter",
      "shortName": "Rep./vedlikehold av skip og båter",
      "level": 5,
      "parentCode": "33.15"
    },
    {
      "code": "33.160",
      "name": "Reparasjon og vedlikehold av luftfartøyer og romfartøyer",
      "shortName": "Rep./vedlikeh. luft- og romfartøyer",
      "level": 5,
      "parentCode": "33.16"
    },
    {
      "code": "33.170",
      "name": "Reparasjon og vedlikehold av andre transportmidler",
      "shortName": "Rep./vedlikeh. av andre transportmidler",
      "level": 5,
      "parentCode": "33.17"
    },
    {
      "code": "33.190",
      "name": "Reparasjon av annet utstyr",
      "shortName": "Rep. av annet utstyr",
      "level": 5,
      "parentCode": "33.19"
    },
    {
      "code": "33.200",
      "name": "Installasjon av industrimaskiner og -utstyr",
      "shortName": "Installasjon industrimask. og utstyr",
      "level": 5,
      "parentCode": "33.20"
    },
    {
      "code": "35.111",
      "name": "Produksjon av elektrisitet fra vannkraft",
      "shortName": "Elektrisitetsprod. fra vannkraft",
      "level": 5,
      "parentCode": "35.11"
    },
    {
      "code": "35.112",
      "name": "Produksjon av elektrisitet fra vindkraft",
      "shortName": "Elektrisitetsprod. fra vindkraft",
      "level": 5,
      "parentCode": "35.11"
    },
    {
      "code": "35.113",
      "name": "Produksjon av elektrisitet fra biobrensel",
      "shortName": "El. fra biobrensel",
      "level": 5,
      "parentCode": "35.11"
    },
    {
      "code": "35.114",
      "name": "Produksjon av elektrisitet fra naturgass",
      "shortName": "Elektrisitetsprod. fra naturgass",
      "level": 5,
      "parentCode": "35.11"
    },
    {
      "code": "35.119",
      "name": "Produksjon av elektrisitet ellers",
      "shortName": "Elektrisitetsprod. ellers",
      "level": 5,
      "parentCode": "35.11"
    },
    {
      "code": "35.120",
      "name": "Overføring av elektrisitet",
      "shortName": "Overføring av elektrisitet",
      "level": 5,
      "parentCode": "35.12"
    },
    {
      "code": "35.130",
      "name": "Distribusjon av elektrisitet",
      "shortName": "Distribusjon av elektrisitet",
      "level": 5,
      "parentCode": "35.13"
    },
    {
      "code": "35.140",
      "name": "Handel med elektrisitet",
      "shortName": "Handel med elektrisitet",
      "level": 5,
      "parentCode": "35.14"
    },
    {
      "code": "35.210",
      "name": "Produksjon av gass",
      "shortName": "Gassproduksjon",
      "level": 5,
      "parentCode": "35.21"
    },
    {
      "code": "35.220",
      "name": "Distribusjon av gass gjennom ledningsnett",
      "shortName": "Gassdistrib. via ledningsnett",
      "level": 5,
      "parentCode": "35.22"
    },
    {
      "code": "35.230",
      "name": "Handel med gass gjennom ledningsnett",
      "shortName": "Handel med gass via ledningsnett",
      "level": 5,
      "parentCode": "35.23"
    },
    {
      "code": "35.300",
      "name": "Damp- og varmtvannsforsyning",
      "shortName": "Damp- og varmtvannsforsyning",
      "level": 5,
      "parentCode": "35.30"
    },
    {
      "code": "36.000",
      "name": "Uttak fra kilde, rensing og distribusjon av vann",
      "shortName": "Vannforsyning",
      "level": 5,
      "parentCode": "36.00"
    },
    {
      "code": "37.000",
      "name": "Oppsamling og behandling av avløpsvann",
      "shortName": "Håndtering av avløpsvann",
      "level": 5,
      "parentCode": "37.00"
    },
    {
      "code": "38.110",
      "name": "Innsamling av ikke-farlig avfall",
      "shortName": "Innsaml. av ikke-farlig avfall",
      "level": 5,
      "parentCode": "38.11"
    },
    {
      "code": "38.120",
      "name": "Innsamling av farlig avfall",
      "shortName": "Innsamling av farlig avfall",
      "level": 5,
      "parentCode": "38.12"
    },
    {
      "code": "38.210",
      "name": "Behandling og disponering av ikke-farlig avfall",
      "shortName": "Behandl. og disp. av ikke-farlig avfall",
      "level": 5,
      "parentCode": "38.21"
    },
    {
      "code": "38.220",
      "name": "Behandling og disponering av farlig avfall",
      "shortName": "Behandl. og disp. av farlig avfall",
      "level": 5,
      "parentCode": "38.22"
    },
    {
      "code": "38.310",
      "name": "Demontering av vrakede gjenstander",
      "shortName": "Demont. av vrakede gjenstander",
      "level": 5,
      "parentCode": "38.31"
    },
    {
      "code": "38.320",
      "name": "Sortering og bearbeiding av avfall for materialgjenvinning",
      "shortName": "Sort./bearb. avfall for matr.gjenv.",
      "level": 5,
      "parentCode": "38.32"
    },
    {
      "code": "39.000",
      "name": "Miljørydding, miljørensing og lignende virksomhet",
      "shortName": "Miljørydding og miljørensing",
      "level": 5,
      "parentCode": "39.00"
    },
    {
      "code": "41.101",
      "name": "Boligbyggelag",
      "shortName": "Boligbyggelag",
      "level": 5,
      "parentCode": "41.10"
    },
    {
      "code": "41.109",
      "name": "Utvikling og salg av egen fast eiendom ellers",
      "shortName": "Utvikl./salg av egen fast eiendom",
      "level": 5,
      "parentCode": "41.10"
    },
    {
      "code": "41.200",
      "name": "Oppføring av bygninger",
      "shortName": "Oppføring av bygninger",
      "level": 5,
      "parentCode": "41.20"
    },
    {
      "code": "42.110",
      "name": "Bygging av veier og motorveier",
      "shortName": "Bygging av veier og motorveier",
      "level": 5,
      "parentCode": "42.11"
    },
    {
      "code": "42.120",
      "name": "Bygging av jernbaner og undergrunnsbaner",
      "shortName": "Bygg. av jernbaner/undergrunnsbaner",
      "level": 5,
      "parentCode": "42.12"
    },
    {
      "code": "42.130",
      "name": "Bygging av bruer og tunneler",
      "shortName": "Bygging av bruer og tunneler",
      "level": 5,
      "parentCode": "42.13"
    },
    {
      "code": "42.210",
      "name": "Bygging av vann- og kloakkanlegg",
      "shortName": "Bygging av vann- og kloakkanl.",
      "level": 5,
      "parentCode": "42.21"
    },
    {
      "code": "42.220",
      "name": "Bygging av anlegg for elektrisitet og telekommunikasjon",
      "shortName": "Bygg. av el.anl. og telekomm.anl.",
      "level": 5,
      "parentCode": "42.22"
    },
    {
      "code": "42.910",
      "name": "Bygging av havne- og damanlegg",
      "shortName": "Bygging av havne- og damanlegg",
      "level": 5,
      "parentCode": "42.91"
    },
    {
      "code": "42.990",
      "name": "Bygging av andre anlegg ikke nevnt annet sted",
      "shortName": "Bygging av andre anlegg",
      "level": 5,
      "parentCode": "42.99"
    },
    {
      "code": "43.110",
      "name": "Riving av bygninger og andre konstruksjoner",
      "shortName": "Riv. av bygn./andre konstruksjoner",
      "level": 5,
      "parentCode": "43.11"
    },
    {
      "code": "43.120",
      "name": "Grunnarbeid",
      "shortName": "Grunnarbeid",
      "level": 5,
      "parentCode": "43.12"
    },
    {
      "code": "43.130",
      "name": "Prøveboring",
      "shortName": "Prøveboring",
      "level": 5,
      "parentCode": "43.13"
    },
    {
      "code": "43.210",
      "name": "Elektrisk installasjonsarbeid",
      "shortName": "Elektrisk installasjonsarbeid",
      "level": 5,
      "parentCode": "43.21"
    },
    {
      "code": "43.221",
      "name": "Rørleggerarbeid",
      "shortName": "Rørleggerarbeid",
      "level": 5,
      "parentCode": "43.22"
    },
    {
      "code": "43.222",
      "name": "Kuldeanlegg- og varmepumpearbeid",
      "shortName": "Kuldeanlegg- og varmepumpearbeid",
      "level": 5,
      "parentCode": "43.22"
    },
    {
      "code": "43.223",
      "name": "Ventilasjonsarbeid",
      "shortName": "Ventilasjonsarbeid",
      "level": 5,
      "parentCode": "43.22"
    },
    {
      "code": "43.290",
      "name": "Annet installasjonsarbeid",
      "shortName": "Annet installasjonsarbeid",
      "level": 5,
      "parentCode": "43.29"
    },
    {
      "code": "43.310",
      "name": "Stukkatørarbeid og pussing",
      "shortName": "Stukkatørarbeid og pussing",
      "level": 5,
      "parentCode": "43.31"
    },
    {
      "code": "43.320",
      "name": "Snekkerarbeid",
      "shortName": "Snekkerarbeid",
      "level": 5,
      "parentCode": "43.32"
    },
    {
      "code": "43.330",
      "name": "Gulvlegging og tapetsering",
      "shortName": "Gulvlegging og tapetsering",
      "level": 5,
      "parentCode": "43.33"
    },
    {
      "code": "43.341",
      "name": "Malerarbeid",
      "shortName": "Malerarbeid",
      "level": 5,
      "parentCode": "43.34"
    },
    {
      "code": "43.342",
      "name": "Glassarbeid",
      "shortName": "Glassarbeid",
      "level": 5,
      "parentCode": "43.34"
    },
    {
      "code": "43.390",
      "name": "Annen ferdiggjøring av bygninger",
      "shortName": "Annen ferdiggjøring av bygninger",
      "level": 5,
      "parentCode": "43.39"
    },
    {
      "code": "43.911",
      "name": "Blikkenslagerarbeid",
      "shortName": "Blikkenslagerarbeid",
      "level": 5,
      "parentCode": "43.91"
    },
    {
      "code": "43.919",
      "name": "Takarbeid ellers",
      "shortName": "Takarbeid ellers",
      "level": 5,
      "parentCode": "43.91"
    },
    {
      "code": "43.990",
      "name": "Annen spesialisert bygge- og anleggsvirksomhet",
      "shortName": "Annen spes. bygge- og anleggsvirks.",
      "level": 5,
      "parentCode": "43.99"
    },
    {
      "code": "45.111",
      "name": "Agentur- og engroshandel med biler og lette motorvogner, unntatt motorsykler",
      "shortName": "Agentur/engros biler/unnt. motorsyk",
      "level": 5,
      "parentCode": "45.11"
    },
    {
      "code": "45.112",
      "name": "Detaljhandel med biler og lette motorvogner, unntatt motorsykler",
      "shortName": "Detaljh. biler, unnt. motorsykler",
      "level": 5,
      "parentCode": "45.11"
    },
    {
      "code": "45.191",
      "name": "Agentur- og engroshandel med andre motorvogner, unntatt motorsykler",
      "shortName": "Agentur/engros motorvogner el.",
      "level": 5,
      "parentCode": "45.19"
    },
    {
      "code": "45.192",
      "name": "Detaljhandel med andre motorvogner, unntatt motorsykler",
      "shortName": "Detaljh. motorvogner el.",
      "level": 5,
      "parentCode": "45.19"
    },
    {
      "code": "45.200",
      "name": "Vedlikehold og reparasjon av motorvogner, unntatt motorsykler",
      "shortName": "Rep. av motorvogner/unnt. motorsyk.",
      "level": 5,
      "parentCode": "45.20"
    },
    {
      "code": "45.310",
      "name": "Agentur- og engroshandel med deler og utstyr til motorvogner, unntatt motorsykler",
      "shortName": "Agent.-/engrosh. motorv./-deler mv.",
      "level": 5,
      "parentCode": "45.31"
    },
    {
      "code": "45.320",
      "name": "Detaljhandel med deler og utstyr til motorvogner, unntatt motorsykler",
      "shortName": "Detalj. deler/utstyr til motorvogn",
      "level": 5,
      "parentCode": "45.32"
    },
    {
      "code": "45.401",
      "name": "Agentur- og engroshandel med motorsykler, deler og utstyr",
      "shortName": "Agentur-/engrosh. motorsykler",
      "level": 5,
      "parentCode": "45.40"
    },
    {
      "code": "45.402",
      "name": "Detaljhandel med motorsykler, deler og utstyr",
      "shortName": "Detaljh. motorsykler mv.",
      "level": 5,
      "parentCode": "45.40"
    },
    {
      "code": "45.403",
      "name": "Vedlikehold og reparasjon av motorsykler",
      "shortName": "Motorsykkelvedlikehold og -rep.",
      "level": 5,
      "parentCode": "45.40"
    },
    {
      "code": "46.110",
      "name": "Agenturhandel med jordbruksråvarer, levende dyr, tekstilråvarer og innsatsvarer",
      "shortName": "Agentur jordbr. og tekstilråv. mv.",
      "level": 5,
      "parentCode": "46.11"
    },
    {
      "code": "46.120",
      "name": "Agenturhandel med brensel, drivstoff, malm, metaller og industrikjemikalier",
      "shortName": "Agentur brensel, drivstoff mv.",
      "level": 5,
      "parentCode": "46.12"
    },
    {
      "code": "46.130",
      "name": "Agenturhandel med tømmer, trelast og byggevarer",
      "shortName": "Agentur tømmer. trelast, byggev.",
      "level": 5,
      "parentCode": "46.13"
    },
    {
      "code": "46.140",
      "name": "Agenturhandel med maskiner, produksjonsutstyr, båter og luftfartøyer",
      "shortName": "Agentur maskiner, prod.utstyr mv.",
      "level": 5,
      "parentCode": "46.14"
    },
    {
      "code": "46.150",
      "name": "Agenturhandel med møbler, husholdningsvarer og jernvarer",
      "shortName": "Agentur møbler, hush.- og jernvarer",
      "level": 5,
      "parentCode": "46.15"
    },
    {
      "code": "46.160",
      "name": "Agenturhandel med tekstiler, klær, pelsskinn, skotøy og lærvarer",
      "shortName": "Agentur tekstiler/klær/skotøy mv.",
      "level": 5,
      "parentCode": "46.16"
    },
    {
      "code": "46.170",
      "name": "Agenturhandel med nærings- og nytelsesmidler",
      "shortName": "Agentur nærings- og nytelsesmidler",
      "level": 5,
      "parentCode": "46.17"
    },
    {
      "code": "46.180",
      "name": "Agenturhandel med spesialisert vareutvalg ellers",
      "shortName": "Agentur spesialisert vareutvalg el.",
      "level": 5,
      "parentCode": "46.18"
    },
    {
      "code": "46.190",
      "name": "Agenturhandel med bredt vareutvalg",
      "shortName": "Agentur bredt vareutvalg",
      "level": 5,
      "parentCode": "46.19"
    },
    {
      "code": "46.210",
      "name": "Engroshandel med korn, råtobakk, såvarer og fôrvarer",
      "shortName": "Engrosh. korn, såvarer og fôr",
      "level": 5,
      "parentCode": "46.21"
    },
    {
      "code": "46.220",
      "name": "Engroshandel med blomster og planter",
      "shortName": "Engrosh. blomster og planter",
      "level": 5,
      "parentCode": "46.22"
    },
    {
      "code": "46.230",
      "name": "Engroshandel med levende dyr",
      "shortName": "Engrosh. levende dyr",
      "level": 5,
      "parentCode": "46.23"
    },
    {
      "code": "46.240",
      "name": "Engroshandel med huder, skinn og lær",
      "shortName": "Engrosh. huder, skinn og lær",
      "level": 5,
      "parentCode": "46.24"
    },
    {
      "code": "46.310",
      "name": "Engroshandel med frukt og grønnsaker",
      "shortName": "Engrosh. frukt og grønnsaker",
      "level": 5,
      "parentCode": "46.31"
    },
    {
      "code": "46.320",
      "name": "Engroshandel med kjøtt og kjøttvarer",
      "shortName": "Engrosh. kjøtt og kjøttvarer",
      "level": 5,
      "parentCode": "46.32"
    },
    {
      "code": "46.330",
      "name": "Engroshandel med meierivarer, egg, matolje og -fett",
      "shortName": "Engrosh. meierivarer, egg mv.",
      "level": 5,
      "parentCode": "46.33"
    },
    {
      "code": "46.341",
      "name": "Engroshandel med vin og brennevin",
      "shortName": "Engrosh. vin og brennevin",
      "level": 5,
      "parentCode": "46.34"
    },
    {
      "code": "46.349",
      "name": "Engroshandel med drikkevarer ellers",
      "shortName": "Engrosh. drikkevarer el.",
      "level": 5,
      "parentCode": "46.34"
    },
    {
      "code": "46.350",
      "name": "Engroshandel med tobakksvarer",
      "shortName": "Engrosh. tobakksvarer",
      "level": 5,
      "parentCode": "46.35"
    },
    {
      "code": "46.360",
      "name": "Engroshandel med sukker, sjokolade og sukkervarer",
      "shortName": "Engrosh. sukker, sjok. og sukkerv.",
      "level": 5,
      "parentCode": "46.36"
    },
    {
      "code": "46.370",
      "name": "Engroshandel med kaffe, te, kakao og krydder",
      "shortName": "Engrosh. kaffe, te, kakao mv.",
      "level": 5,
      "parentCode": "46.37"
    },
    {
      "code": "46.381",
      "name": "Engroshandel med fisk, skalldyr og bløtdyr",
      "shortName": "Engrosh. fisk og skalldyr",
      "level": 5,
      "parentCode": "46.38"
    },
    {
      "code": "46.389",
      "name": "Engroshandel med spesialisert utvalg av nærings- og nytelsesmidler ikke nevnt annet sted",
      "shortName": "Engrosh. spes. utv. nær.-/nyt.midl.",
      "level": 5,
      "parentCode": "46.38"
    },
    {
      "code": "46.390",
      "name": "Engroshandel med bredt utvalg av nærings- og nytelsesmidler",
      "shortName": "Engrosh. bredt utv. nær.-/nyt.midl.",
      "level": 5,
      "parentCode": "46.39"
    },
    {
      "code": "46.410",
      "name": "Engroshandel med tekstiler og utstyrsvarer",
      "shortName": "Engrosh. tekstiler og utstyrsvarer",
      "level": 5,
      "parentCode": "46.41"
    },
    {
      "code": "46.421",
      "name": "Engroshandel med klær",
      "shortName": "Engrosh. klær",
      "level": 5,
      "parentCode": "46.42"
    },
    {
      "code": "46.422",
      "name": "Engroshandel med skotøy",
      "shortName": "Engrosh. skotøy",
      "level": 5,
      "parentCode": "46.42"
    },
    {
      "code": "46.431",
      "name": "Engroshandel med elektriske husholdningsapparater og -maskiner",
      "shortName": "Engrosh. el.hush.app. og -maskiner",
      "level": 5,
      "parentCode": "46.43"
    },
    {
      "code": "46.432",
      "name": "Engroshandel med radio og fjernsyn",
      "shortName": "Engrosh. radio og fjernsyn",
      "level": 5,
      "parentCode": "46.43"
    },
    {
      "code": "46.433",
      "name": "Engroshandel med plater, musikk- og videokassetter og CD- og DVD-plater",
      "shortName": "Engrosh. musikk-,videokass.,CD,DVD",
      "level": 5,
      "parentCode": "46.43"
    },
    {
      "code": "46.434",
      "name": "Engroshandel med fotoutstyr",
      "shortName": "Engrosh. fotoutstyr",
      "level": 5,
      "parentCode": "46.43"
    },
    {
      "code": "46.435",
      "name": "Engroshandel med optiske artikler",
      "shortName": "Engrosh. optiske artikler",
      "level": 5,
      "parentCode": "46.43"
    },
    {
      "code": "46.441",
      "name": "Engroshandel med kjøkkenutstyr, glass og steintøy",
      "shortName": "Engrosh. kjøkkenutstyr, steintøy mv.",
      "level": 5,
      "parentCode": "46.44"
    },
    {
      "code": "46.442",
      "name": "Engroshandel med rengjøringsmidler",
      "shortName": "Engrosh. rengjøringsmidler",
      "level": 5,
      "parentCode": "46.44"
    },
    {
      "code": "46.450",
      "name": "Engroshandel med parfyme og kosmetikk",
      "shortName": "Engrosh. parfyme og kosmetikk",
      "level": 5,
      "parentCode": "46.45"
    },
    {
      "code": "46.460",
      "name": "Engroshandel med sykepleie- og apotekvarer",
      "shortName": "Engrosh. sykepleie- og apotekvarer",
      "level": 5,
      "parentCode": "46.46"
    },
    {
      "code": "46.471",
      "name": "Engroshandel med møbler",
      "shortName": "Engrosh. møbler",
      "level": 5,
      "parentCode": "46.47"
    },
    {
      "code": "46.472",
      "name": "Engroshandel med gulvtepper",
      "shortName": "Engrosh. gulvtepper",
      "level": 5,
      "parentCode": "46.47"
    },
    {
      "code": "46.473",
      "name": "Engroshandel med belysningsutstyr",
      "shortName": "Engrosh. belysningsutstyr",
      "level": 5,
      "parentCode": "46.47"
    },
    {
      "code": "46.481",
      "name": "Engroshandel med klokker og ur",
      "shortName": "Engrosh. klokker og ur",
      "level": 5,
      "parentCode": "46.48"
    },
    {
      "code": "46.482",
      "name": "Engroshandel med gull- og sølvvarer",
      "shortName": "Engrosh. gull- og sølvvarer",
      "level": 5,
      "parentCode": "46.48"
    },
    {
      "code": "46.491",
      "name": "Engroshandel med bøker, aviser og blader",
      "shortName": "Engrosh. bøker, aviser og blader",
      "level": 5,
      "parentCode": "46.49"
    },
    {
      "code": "46.492",
      "name": "Engroshandel med reiseeffekter og lærvarer",
      "shortName": "Engrosh. reiseeffekter og lærvarer",
      "level": 5,
      "parentCode": "46.49"
    },
    {
      "code": "46.493",
      "name": "Engroshandel med fritidsbåter og -utstyr",
      "shortName": "Engrosh. fritidsbåter og -utstyr",
      "level": 5,
      "parentCode": "46.49"
    },
    {
      "code": "46.494",
      "name": "Engroshandel med sportsutstyr",
      "shortName": "Engrosh. sportsutstyr",
      "level": 5,
      "parentCode": "46.49"
    },
    {
      "code": "46.495",
      "name": "Engroshandel med spill og leker",
      "shortName": "Engrosh. spill og leker",
      "level": 5,
      "parentCode": "46.49"
    },
    {
      "code": "46.499",
      "name": "Engroshandel med husholdningsvarer og varer til personlig bruk ikke nevnt annet sted",
      "shortName": "Engrosh. hush.varer ellers",
      "level": 5,
      "parentCode": "46.49"
    },
    {
      "code": "46.510",
      "name": "Engroshandel med datamaskiner, tilleggsutstyr til datamaskiner samt programvare",
      "shortName": "Engrosh. datamask., programv. mv.",
      "level": 5,
      "parentCode": "46.51"
    },
    {
      "code": "46.520",
      "name": "Engroshandel med elektronikkutstyr og telekommunikasjonsutstyr samt deler",
      "shortName": "Engrosh. elektronikk-/telekomm.uts.",
      "level": 5,
      "parentCode": "46.52"
    },
    {
      "code": "46.610",
      "name": "Engroshandel med maskiner og utstyr til jordbruk og skogbruk",
      "shortName": "Engrosh. jordbr.-/skogbr.mask. mv.",
      "level": 5,
      "parentCode": "46.61"
    },
    {
      "code": "46.620",
      "name": "Engroshandel med maskinverktøy",
      "shortName": "Engrosh. maskinverktøy",
      "level": 5,
      "parentCode": "46.62"
    },
    {
      "code": "46.630",
      "name": "Engroshandel med maskiner og utstyr til bergverksdrift, olje- og gassutvinning og bygge- og anleggsvirksomhet",
      "shortName": "Engros mask bygg/anl./oljeutv. mv.",
      "level": 5,
      "parentCode": "46.63"
    },
    {
      "code": "46.640",
      "name": "Engroshandel med maskiner og utstyr til tekstilproduksjon",
      "shortName": "Engrosh. tekstilprod.maskiner mv.",
      "level": 5,
      "parentCode": "46.64"
    },
    {
      "code": "46.650",
      "name": "Engroshandel med kontormøbler",
      "shortName": "Engrosh. kontormøbler",
      "level": 5,
      "parentCode": "46.65"
    },
    {
      "code": "46.660",
      "name": "Engroshandel med maskiner og utstyr til kontor ellers",
      "shortName": "Engrosh. kontormask., -utstyr el.",
      "level": 5,
      "parentCode": "46.66"
    },
    {
      "code": "46.691",
      "name": "Engroshandel med maskiner og utstyr til kraftproduksjon og installasjon",
      "shortName": "Engrosh. kraftprod.-,install.utstyr",
      "level": 5,
      "parentCode": "46.69"
    },
    {
      "code": "46.692",
      "name": "Engroshandel med skipsutstyr og fiskeredskap",
      "shortName": "Engrosh. skipsutstyr og fiskeredsk.",
      "level": 5,
      "parentCode": "46.69"
    },
    {
      "code": "46.693",
      "name": "Engroshandel med maskiner og utstyr til industri ellers",
      "shortName": "Engrosh. utstyr industri ellers",
      "level": 5,
      "parentCode": "46.69"
    },
    {
      "code": "46.694",
      "name": "Engroshandel med maskiner og utstyr til handel, transport og tjenesteyting ellers",
      "shortName": "Engrosh. utstyr handel, transp. mv.",
      "level": 5,
      "parentCode": "46.69"
    },
    {
      "code": "46.710",
      "name": "Engroshandel med drivstoff og brensel",
      "shortName": "Engrosh. drivstoff og brensel",
      "level": 5,
      "parentCode": "46.71"
    },
    {
      "code": "46.720",
      "name": "Engroshandel med metaller og metallholdig malm",
      "shortName": "Engrosh. metaller og metallh. malm",
      "level": 5,
      "parentCode": "46.72"
    },
    {
      "code": "46.731",
      "name": "Engroshandel med tømmer",
      "shortName": "Engrosh. tømmer",
      "level": 5,
      "parentCode": "46.73"
    },
    {
      "code": "46.732",
      "name": "Engroshandel med trelast",
      "shortName": "Engrosh. trelast",
      "level": 5,
      "parentCode": "46.73"
    },
    {
      "code": "46.733",
      "name": "Engroshandel med fargevarer",
      "shortName": "Engrosh. fargevarer",
      "level": 5,
      "parentCode": "46.73"
    },
    {
      "code": "46.739",
      "name": "Engroshandel med byggevarer ikke nevnt annet sted",
      "shortName": "Engrosh. byggevarer el.",
      "level": 5,
      "parentCode": "46.73"
    },
    {
      "code": "46.740",
      "name": "Engroshandel med jernvarer, rørleggerartikler og oppvarmingsutstyr",
      "shortName": "Engrosh. jernv., rørleggerart. m.m.",
      "level": 5,
      "parentCode": "46.74"
    },
    {
      "code": "46.750",
      "name": "Engroshandel med kjemiske produkter",
      "shortName": "Engrosh. kjemiske produkter",
      "level": 5,
      "parentCode": "46.75"
    },
    {
      "code": "46.761",
      "name": "Engroshandel med papir og papp",
      "shortName": "Engrosh. papir og papp",
      "level": 5,
      "parentCode": "46.76"
    },
    {
      "code": "46.769",
      "name": "Engroshandel med innsatsvarer ikke nevnt annet sted",
      "shortName": "Engrosh innsatsvarer el.",
      "level": 5,
      "parentCode": "46.76"
    },
    {
      "code": "46.770",
      "name": "Engroshandel med avfall og skrap",
      "shortName": "Engrosh. avfall og skrap",
      "level": 5,
      "parentCode": "46.77"
    },
    {
      "code": "46.900",
      "name": "Uspesifisert engroshandel",
      "shortName": "Uspesifisert engroshandel",
      "level": 5,
      "parentCode": "46.90"
    },
    {
      "code": "47.111",
      "name": "Butikkhandel med bredt vareutvalg med hovedvekt på nærings- og nytelsesmidler",
      "shortName": "Butikkh. bredt utvalg nær.midler mv.",
      "level": 5,
      "parentCode": "47.11"
    },
    {
      "code": "47.112",
      "name": "Kioskhandel med bredt vareutvalg med hovedvekt på nærings- og nytelsesmidler",
      "shortName": "Kioskh. bredt utvalg nær.midler mv.",
      "level": 5,
      "parentCode": "47.11"
    },
    {
      "code": "47.190",
      "name": "Butikkhandel med bredt vareutvalg ellers",
      "shortName": "Butikkh. bredt vareutvalg el.",
      "level": 5,
      "parentCode": "47.19"
    },
    {
      "code": "47.210",
      "name": "Butikkhandel med frukt og grønnsaker",
      "shortName": "Butikkh. frukt og grønnsaker",
      "level": 5,
      "parentCode": "47.21"
    },
    {
      "code": "47.220",
      "name": "Butikkhandel med kjøtt og kjøttvarer",
      "shortName": "Butikkh. kjøtt og kjøttvarer",
      "level": 5,
      "parentCode": "47.22"
    },
    {
      "code": "47.230",
      "name": "Butikkhandel med fisk, skalldyr og bløtdyr",
      "shortName": "Butikkh. fisk, skalldyr og bløtdyr",
      "level": 5,
      "parentCode": "47.23"
    },
    {
      "code": "47.241",
      "name": "Butikkhandel med bakervarer og konditorvarer",
      "shortName": "Butikkh. baker- og konditorvarer",
      "level": 5,
      "parentCode": "47.24"
    },
    {
      "code": "47.242",
      "name": "Butikkhandel med sukkervarer",
      "shortName": "Butikkh. sukkervarer",
      "level": 5,
      "parentCode": "47.24"
    },
    {
      "code": "47.251",
      "name": "Butikkhandel med vin og brennevin",
      "shortName": "Butikkh. vin og brennevin",
      "level": 5,
      "parentCode": "47.25"
    },
    {
      "code": "47.259",
      "name": "Butikkhandel med drikkevarer ellers",
      "shortName": "Butikkh. drikkevarer el.",
      "level": 5,
      "parentCode": "47.25"
    },
    {
      "code": "47.260",
      "name": "Butikkhandel med tobakksvarer",
      "shortName": "Butikkh. tobakksvarer",
      "level": 5,
      "parentCode": "47.26"
    },
    {
      "code": "47.291",
      "name": "Butikkhandel med helsekost",
      "shortName": "Butikkh. helsekost",
      "level": 5,
      "parentCode": "47.29"
    },
    {
      "code": "47.292",
      "name": "Butikkhandel med kaffe og te",
      "shortName": "Butikkh. kaffe og te",
      "level": 5,
      "parentCode": "47.29"
    },
    {
      "code": "47.299",
      "name": "Butikkhandel med nærings- og nytelsesmidler ikke nevnt annet sted",
      "shortName": "Butikkh. nær.- og nytelsesmidler el.",
      "level": 5,
      "parentCode": "47.29"
    },
    {
      "code": "47.300",
      "name": "Detaljhandel med drivstoff til motorvogner",
      "shortName": "Detaljh. drivstoff til motorvogner",
      "level": 5,
      "parentCode": "47.30"
    },
    {
      "code": "47.410",
      "name": "Butikkhandel med datamaskiner og utstyr til datamaskiner",
      "shortName": "Butikkh. datamask. og tilleggsutst.",
      "level": 5,
      "parentCode": "47.41"
    },
    {
      "code": "47.420",
      "name": "Butikkhandel med telekommunikasjonsutstyr",
      "shortName": "Butikkh. telekommunikasjonsutstyr",
      "level": 5,
      "parentCode": "47.42"
    },
    {
      "code": "47.430",
      "name": "Butikkhandel med audio- og videoutstyr",
      "shortName": "Butikkh. audio- og videoutstyr",
      "level": 5,
      "parentCode": "47.43"
    },
    {
      "code": "47.510",
      "name": "Butikkhandel med tekstiler og utstyrsvarer",
      "shortName": "Butikkh. tekstiler og utstyrsvarer",
      "level": 5,
      "parentCode": "47.51"
    },
    {
      "code": "47.521",
      "name": "Butikkhandel med bredt utvalg av jernvarer, fargevarer og andre byggevarer",
      "shortName": "Byggvarehus m.m.",
      "level": 5,
      "parentCode": "47.52"
    },
    {
      "code": "47.522",
      "name": "Butikkhandel med jernvarer",
      "shortName": "Butikkh. jernvarer",
      "level": 5,
      "parentCode": "47.52"
    },
    {
      "code": "47.523",
      "name": "Butikkhandel med fargevarer",
      "shortName": "Butikkh. fargevarer",
      "level": 5,
      "parentCode": "47.52"
    },
    {
      "code": "47.524",
      "name": "Butikkhandel med trelast",
      "shortName": "Butikkh. trelast",
      "level": 5,
      "parentCode": "47.52"
    },
    {
      "code": "47.529",
      "name": "Butikkhandel med byggevarer ikke nevnt annet sted",
      "shortName": "Butikkh. byggevarer el.",
      "level": 5,
      "parentCode": "47.52"
    },
    {
      "code": "47.531",
      "name": "Butikkhandel med tapeter og gulvbelegg",
      "shortName": "Butikkh. tapeter og gulvbelegg",
      "level": 5,
      "parentCode": "47.53"
    },
    {
      "code": "47.532",
      "name": "Butikkhandel med tepper",
      "shortName": "Butikkh. tepper",
      "level": 5,
      "parentCode": "47.53"
    },
    {
      "code": "47.533",
      "name": "Butikkhandel med gardiner",
      "shortName": "Butikkh. gardiner",
      "level": 5,
      "parentCode": "47.53"
    },
    {
      "code": "47.540",
      "name": "Butikkhandel med elektriske husholdningsapparater",
      "shortName": "Butikkh. el. hush.apparater",
      "level": 5,
      "parentCode": "47.54"
    },
    {
      "code": "47.591",
      "name": "Butikkhandel med møbler",
      "shortName": "Butikkh. møbler",
      "level": 5,
      "parentCode": "47.59"
    },
    {
      "code": "47.592",
      "name": "Butikkhandel med belysningsutstyr",
      "shortName": "Butikkh. belysningsutstyr",
      "level": 5,
      "parentCode": "47.59"
    },
    {
      "code": "47.593",
      "name": "Butikkhandel med kjøkkenutstyr, glass og steintøy",
      "shortName": "Butikkh. kjøkkenutstyr/steintøy mv.",
      "level": 5,
      "parentCode": "47.59"
    },
    {
      "code": "47.594",
      "name": "Butikkhandel med musikkinstrumenter og noter",
      "shortName": "Butikkh. musikkinstr. og noter",
      "level": 5,
      "parentCode": "47.59"
    },
    {
      "code": "47.599",
      "name": "Butikkhandel med innredningsartikler ikke nevnt annet sted",
      "shortName": "Butikkh. innredningsartikler el.",
      "level": 5,
      "parentCode": "47.59"
    },
    {
      "code": "47.610",
      "name": "Butikkhandel med bøker",
      "shortName": "Butikkh. bøker",
      "level": 5,
      "parentCode": "47.61"
    },
    {
      "code": "47.620",
      "name": "Butikkhandel med aviser og papirvarer",
      "shortName": "Butikkh. aviser og papirvarer",
      "level": 5,
      "parentCode": "47.62"
    },
    {
      "code": "47.630",
      "name": "Butikkhandel med innspillinger av musikk og video",
      "shortName": "Butikkh. innspill. av musikk/video",
      "level": 5,
      "parentCode": "47.63"
    },
    {
      "code": "47.641",
      "name": "Butikkhandel med sportsutstyr",
      "shortName": "Butikkh. sportsutstyr",
      "level": 5,
      "parentCode": "47.64"
    },
    {
      "code": "47.642",
      "name": "Butikkhandel med fritidsbåter og -utstyr",
      "shortName": "Butikkh. fritidsbåter og -utstyr",
      "level": 5,
      "parentCode": "47.64"
    },
    {
      "code": "47.650",
      "name": "Butikkhandel med spill og leker",
      "shortName": "Butikkh. spill og leker",
      "level": 5,
      "parentCode": "47.65"
    },
    {
      "code": "47.710",
      "name": "Butikkhandel med klær",
      "shortName": "Butikkh. klær",
      "level": 5,
      "parentCode": "47.71"
    },
    {
      "code": "47.721",
      "name": "Butikkhandel med skotøy",
      "shortName": "Butikkh. skotøy",
      "level": 5,
      "parentCode": "47.72"
    },
    {
      "code": "47.722",
      "name": "Butikkhandel med reiseeffekter av lær og lærimitasjoner og varer av lær",
      "shortName": "Butikkh. reiseeff. og andre lærvarer",
      "level": 5,
      "parentCode": "47.72"
    },
    {
      "code": "47.730",
      "name": "Butikkhandel med apotekvarer",
      "shortName": "Butikkh. apotekvarer",
      "level": 5,
      "parentCode": "47.73"
    },
    {
      "code": "47.740",
      "name": "Butikkhandel med medisinske og ortopediske artikler",
      "shortName": "Butikkh. medisinske/ortop. art.",
      "level": 5,
      "parentCode": "47.74"
    },
    {
      "code": "47.750",
      "name": "Butikkhandel med kosmetikk og toalettartikler",
      "shortName": "Butikkh. kosmetikk og toalettart.",
      "level": 5,
      "parentCode": "47.75"
    },
    {
      "code": "47.761",
      "name": "Butikkhandel med blomster og planter",
      "shortName": "Butikkh. blomster og planter",
      "level": 5,
      "parentCode": "47.76"
    },
    {
      "code": "47.762",
      "name": "Butikkhandel med kjæledyr og fôrvarer til kjæledyr",
      "shortName": "Butikkh. kjæledyr mv.",
      "level": 5,
      "parentCode": "47.76"
    },
    {
      "code": "47.771",
      "name": "Butikkhandel med ur og klokker",
      "shortName": "Butikkh. ur og klokker",
      "level": 5,
      "parentCode": "47.77"
    },
    {
      "code": "47.772",
      "name": "Butikkhandel med gull- og sølvvarer",
      "shortName": "Butikkh. gull- og sølvvarer",
      "level": 5,
      "parentCode": "47.77"
    },
    {
      "code": "47.781",
      "name": "Butikkhandel med fotoutstyr",
      "shortName": "Butikkh. fotoutstyr",
      "level": 5,
      "parentCode": "47.78"
    },
    {
      "code": "47.782",
      "name": "Butikkhandel med optiske artikler",
      "shortName": "Butikkh. optiske artikler",
      "level": 5,
      "parentCode": "47.78"
    },
    {
      "code": "47.789",
      "name": "Butikkhandel ikke nevnt annet sted",
      "shortName": "Butikkh. el.",
      "level": 5,
      "parentCode": "47.78"
    },
    {
      "code": "47.791",
      "name": "Butikkhandel med antikviteter",
      "shortName": "Butikkh. antikviteter",
      "level": 5,
      "parentCode": "47.79"
    },
    {
      "code": "47.792",
      "name": "Butikkhandel med brukte klær",
      "shortName": "Butikkh. brukte klær",
      "level": 5,
      "parentCode": "47.79"
    },
    {
      "code": "47.799",
      "name": "Butikkhandel med brukte varer ellers",
      "shortName": "Butikkh. brukte varer el.",
      "level": 5,
      "parentCode": "47.79"
    },
    {
      "code": "47.810",
      "name": "Torghandel med næringsmidler, drikkevarer og tobakksvarer",
      "shortName": "Torgh. nær.midl./drikkev./tobakksv",
      "level": 5,
      "parentCode": "47.81"
    },
    {
      "code": "47.820",
      "name": "Torghandel med tekstiler, klær, skotøy og utstyrsvarer",
      "shortName": "Torgh. tekstiler, klær, skotøy m.m.",
      "level": 5,
      "parentCode": "47.82"
    },
    {
      "code": "47.890",
      "name": "Torghandel med andre varer",
      "shortName": "Torghandel med andre varer",
      "level": 5,
      "parentCode": "47.89"
    },
    {
      "code": "47.911",
      "name": "Postordre-/Internetthandel med bredt vareutvalg",
      "shortName": "Postord.-/Internetth. br. vareutv.",
      "level": 5,
      "parentCode": "47.91"
    },
    {
      "code": "47.912",
      "name": "Postordre-/Internetthandel med tekstiler, utstyrsvarer, klær, skotøy, reiseeffekter og lærvarer",
      "shortName": "Postord.-/Internetth. tekstiler mv.",
      "level": 5,
      "parentCode": "47.91"
    },
    {
      "code": "47.913",
      "name": "Postordre-/Internetthandel med belysningsutstyr, kjøkkenutstyr, møbler og innredningsartikler",
      "shortName": "Postord.-/Internetth. møbler mv.",
      "level": 5,
      "parentCode": "47.91"
    },
    {
      "code": "47.914",
      "name": "Postordre-/Internetthandel med elektriske husholdningsapparater, radio, fjernsyn, plater, kassetter og musikkinstrumenter",
      "shortName": "Post.-/Internetth. el.hush.app. mv.",
      "level": 5,
      "parentCode": "47.91"
    },
    {
      "code": "47.915",
      "name": "Postordre-/internetthandel med bøker, papir, aviser og blader",
      "shortName": "Postord.-/Internetth. bøker mv.",
      "level": 5,
      "parentCode": "47.91"
    },
    {
      "code": "47.916",
      "name": "Postordre-/Internetthandel med IKT-utstyr",
      "shortName": "Postord.-/Internetth. IKT-utstyr",
      "level": 5,
      "parentCode": "47.91"
    },
    {
      "code": "47.917",
      "name": "Postordre-/Internetthandel med helsekost",
      "shortName": "Postord.-/Internetth. helsekost",
      "level": 5,
      "parentCode": "47.91"
    },
    {
      "code": "47.919",
      "name": "Postordre-/Internetthandel med annet spesialisert vareutvalg",
      "shortName": "Postord.-/Internetth. ellers",
      "level": 5,
      "parentCode": "47.91"
    },
    {
      "code": "47.990",
      "name": "Detaljhandel utenom utsalgssted ellers",
      "shortName": "Detaljh. utenom utsalgssted el.",
      "level": 5,
      "parentCode": "47.99"
    },
    {
      "code": "49.100",
      "name": "Passasjertransport med jernbane",
      "shortName": "Passasjertransp. med jernbane",
      "level": 5,
      "parentCode": "49.10"
    },
    {
      "code": "49.200",
      "name": "Godstransport med jernbane",
      "shortName": "Godstransp. med jernbane",
      "level": 5,
      "parentCode": "49.20"
    },
    {
      "code": "49.311",
      "name": "Rutebiltransport i by- og forstadsområde",
      "shortName": "Rutebiltransp. by-/forstadsområde",
      "level": 5,
      "parentCode": "49.31"
    },
    {
      "code": "49.312",
      "name": "Transport med sporveis- og forstadsbane",
      "shortName": "Transp. sporveis-/forstadsbane",
      "level": 5,
      "parentCode": "49.31"
    },
    {
      "code": "49.320",
      "name": "Drosjebiltransport",
      "shortName": "Drosjebiltransport",
      "level": 5,
      "parentCode": "49.32"
    },
    {
      "code": "49.391",
      "name": "Rutebiltransport utenfor by- og forstadsområde",
      "shortName": "Rutebiltr. utenfor by-/forstadsomr.",
      "level": 5,
      "parentCode": "49.39"
    },
    {
      "code": "49.392",
      "name": "Turbiltransport",
      "shortName": "Turbiltransport",
      "level": 5,
      "parentCode": "49.39"
    },
    {
      "code": "49.393",
      "name": "Transport med taubaner, kabelbaner og skiheiser",
      "shortName": "Transp. tau-/kabelbaner/skiheiser",
      "level": 5,
      "parentCode": "49.39"
    },
    {
      "code": "49.410",
      "name": "Godstransport på vei",
      "shortName": "Godstransport på vei",
      "level": 5,
      "parentCode": "49.41"
    },
    {
      "code": "49.420",
      "name": "Flyttetransport",
      "shortName": "Flyttetransport",
      "level": 5,
      "parentCode": "49.42"
    },
    {
      "code": "49.500",
      "name": "Rørtransport",
      "shortName": "Rørtransport",
      "level": 5,
      "parentCode": "49.50"
    },
    {
      "code": "50.101",
      "name": "Utenriks sjøfart med passasjerer",
      "shortName": "Utenriks sjøfart med passasjerer",
      "level": 5,
      "parentCode": "50.10"
    },
    {
      "code": "50.102",
      "name": "Innenlandske kystruter med passasjerer",
      "shortName": "Innenl. kystruter med passasjerer",
      "level": 5,
      "parentCode": "50.10"
    },
    {
      "code": "50.109",
      "name": "Kysttrafikk ellers med passasjerer",
      "shortName": "Kysttrafikk ellers med passasjerer",
      "level": 5,
      "parentCode": "50.10"
    },
    {
      "code": "50.201",
      "name": "Utenriks sjøfart med gods",
      "shortName": "Utenriks sjøfart med gods",
      "level": 5,
      "parentCode": "50.20"
    },
    {
      "code": "50.202",
      "name": "Innenriks sjøfart med gods",
      "shortName": "Innenriks sjøfart med gods",
      "level": 5,
      "parentCode": "50.20"
    },
    {
      "code": "50.203",
      "name": "Slepebåter",
      "shortName": "Slepebåter",
      "level": 5,
      "parentCode": "50.20"
    },
    {
      "code": "50.204",
      "name": "Forsyning og andre sjøtransporttjenester for offshore",
      "shortName": "Forsyn./andre sjøtr.tj. for offshore",
      "level": 5,
      "parentCode": "50.20"
    },
    {
      "code": "50.300",
      "name": "Passasjertransport på elver og innsjøer",
      "shortName": "Passasjertr. på elver og innsjøer",
      "level": 5,
      "parentCode": "50.30"
    },
    {
      "code": "50.400",
      "name": "Godstransport på elver og innsjøer",
      "shortName": "Godstransp. på elver og innsjøer",
      "level": 5,
      "parentCode": "50.40"
    },
    {
      "code": "51.100",
      "name": "Lufttransport med passasjerer",
      "shortName": "Lufttransp. med passasjerer",
      "level": 5,
      "parentCode": "51.10"
    },
    {
      "code": "51.210",
      "name": "Lufttransport med gods",
      "shortName": "Lufttransp. med gods",
      "level": 5,
      "parentCode": "51.21"
    },
    {
      "code": "51.220",
      "name": "Romfart",
      "shortName": "Romfart",
      "level": 5,
      "parentCode": "51.22"
    },
    {
      "code": "52.100",
      "name": "Lagring",
      "shortName": "Lagring",
      "level": 5,
      "parentCode": "52.10"
    },
    {
      "code": "52.211",
      "name": "Drift av gods- og transportsentraler",
      "shortName": "Drift av gods- og transportsentraler",
      "level": 5,
      "parentCode": "52.21"
    },
    {
      "code": "52.212",
      "name": "Drift av parkeringsplasser og parkeringshus",
      "shortName": "Drift av parkeringsplasser og -hus",
      "level": 5,
      "parentCode": "52.21"
    },
    {
      "code": "52.213",
      "name": "Drift av bomstasjoner",
      "shortName": "Drift av bomstasjoner",
      "level": 5,
      "parentCode": "52.21"
    },
    {
      "code": "52.214",
      "name": "Drift av taxisentraler og annen formidling av persontransport",
      "shortName": "Drift av taxisentraler m.m.",
      "level": 5,
      "parentCode": "52.21"
    },
    {
      "code": "52.216",
      "name": "Kondensering av gass med henblikk på transport",
      "shortName": "Kondensering av gass mtp. transport",
      "level": 5,
      "parentCode": "52.21"
    },
    {
      "code": "52.219",
      "name": "Tjenester tilknyttet landtransport ellers",
      "shortName": "Tjen. tilkn. landtransport el.",
      "level": 5,
      "parentCode": "52.21"
    },
    {
      "code": "52.221",
      "name": "Drift av havne- og kaianlegg",
      "shortName": "Drift av havne- og kaianlegg",
      "level": 5,
      "parentCode": "52.22"
    },
    {
      "code": "52.222",
      "name": "Redningstjeneste",
      "shortName": "Redningstjeneste",
      "level": 5,
      "parentCode": "52.22"
    },
    {
      "code": "52.223",
      "name": "Forsyningsbaser",
      "shortName": "Forsyningsbaser",
      "level": 5,
      "parentCode": "52.22"
    },
    {
      "code": "52.229",
      "name": "Tjenester tilknyttet sjøtransport ellers",
      "shortName": "Tjen. tilkn. sjøtransport el.",
      "level": 5,
      "parentCode": "52.22"
    },
    {
      "code": "52.230",
      "name": "Andre tjenester tilknyttet lufttransport",
      "shortName": "Andre tjen. tilkn. lufttransport",
      "level": 5,
      "parentCode": "52.23"
    },
    {
      "code": "52.240",
      "name": "Lasting og lossing",
      "shortName": "Lasting og lossing",
      "level": 5,
      "parentCode": "52.24"
    },
    {
      "code": "52.291",
      "name": "Spedisjon",
      "shortName": "Spedisjon",
      "level": 5,
      "parentCode": "52.29"
    },
    {
      "code": "52.292",
      "name": "Skipsmegling",
      "shortName": "Skipsmegling",
      "level": 5,
      "parentCode": "52.29"
    },
    {
      "code": "52.293",
      "name": "Flymegling",
      "shortName": "Flymegling",
      "level": 5,
      "parentCode": "52.29"
    },
    {
      "code": "52.299",
      "name": "Transportformidling ellers",
      "shortName": "Transportformidling ellers",
      "level": 5,
      "parentCode": "52.29"
    },
    {
      "code": "53.100",
      "name": "Landsdekkende posttjenester",
      "shortName": "Landsdekkende posttjenester",
      "level": 5,
      "parentCode": "53.10"
    },
    {
      "code": "53.200",
      "name": "Andre post- og budtjenester",
      "shortName": "Andre post- og budtjenester",
      "level": 5,
      "parentCode": "53.20"
    },
    {
      "code": "55.101",
      "name": "Drift av hoteller, pensjonater og moteller med restaurant",
      "shortName": "Drift av hoteller med restaurant",
      "level": 5,
      "parentCode": "55.10"
    },
    {
      "code": "55.102",
      "name": "Drift av hoteller, pensjonater og moteller uten restaurant",
      "shortName": "Drift av hoteller uten restaurant",
      "level": 5,
      "parentCode": "55.10"
    },
    {
      "code": "55.201",
      "name": "Drift av vandrerhjem",
      "shortName": "Drift av vandrerhjem",
      "level": 5,
      "parentCode": "55.20"
    },
    {
      "code": "55.202",
      "name": "Drift av ferieleiligheter",
      "shortName": "Drift av ferieleiligheter",
      "level": 5,
      "parentCode": "55.20"
    },
    {
      "code": "55.300",
      "name": "Drift av campingplasser",
      "shortName": "Drift av campingplasser",
      "level": 5,
      "parentCode": "55.30"
    },
    {
      "code": "55.900",
      "name": "Annen overnatting",
      "shortName": "Annen overnatting",
      "level": 5,
      "parentCode": "55.90"
    },
    {
      "code": "56.101",
      "name": "Drift av restauranter og kafeer",
      "shortName": "Drift av restauranter og kafeer",
      "level": 5,
      "parentCode": "56.10"
    },
    {
      "code": "56.102",
      "name": "Drift av gatekjøkken",
      "shortName": "Drift av gatekjøkken",
      "level": 5,
      "parentCode": "56.10"
    },
    {
      "code": "56.210",
      "name": "Cateringvirksomhet",
      "shortName": "Cateringvirksomhet",
      "level": 5,
      "parentCode": "56.21"
    },
    {
      "code": "56.290",
      "name": "Kantiner drevet som selvstendig virksomhet",
      "shortName": "Kantinedrift, selvst. virksomhet",
      "level": 5,
      "parentCode": "56.29"
    },
    {
      "code": "56.301",
      "name": "Drift av puber",
      "shortName": "Drift av puber",
      "level": 5,
      "parentCode": "56.30"
    },
    {
      "code": "56.309",
      "name": "Drift av barer ellers",
      "shortName": "Drift av barer ellers",
      "level": 5,
      "parentCode": "56.30"
    },
    {
      "code": "58.110",
      "name": "Utgivelse av bøker",
      "shortName": "Utgivelse av bøker",
      "level": 5,
      "parentCode": "58.11"
    },
    {
      "code": "58.120",
      "name": "Utgivelse av kataloger og adresselister",
      "shortName": "Utgiv. av kataloger/adresselister",
      "level": 5,
      "parentCode": "58.12"
    },
    {
      "code": "58.130",
      "name": "Utgivelse av aviser",
      "shortName": "Utgivelse av aviser",
      "level": 5,
      "parentCode": "58.13"
    },
    {
      "code": "58.140",
      "name": "Utgivelse av blader og tidsskrifter",
      "shortName": "Utgivelse av blader og tidsskrifter",
      "level": 5,
      "parentCode": "58.14"
    },
    {
      "code": "58.190",
      "name": "Forlagsvirksomhet ellers",
      "shortName": "Forlagsvirksomhet ellers",
      "level": 5,
      "parentCode": "58.19"
    },
    {
      "code": "58.210",
      "name": "Utgivelse av programvare for dataspill",
      "shortName": "Utgiv. av programv. for dataspill",
      "level": 5,
      "parentCode": "58.21"
    },
    {
      "code": "58.290",
      "name": "Utgivelse av annen programvare",
      "shortName": "Utgiv. av annen programvare",
      "level": 5,
      "parentCode": "58.29"
    },
    {
      "code": "59.110",
      "name": "Produksjon av film, video og fjernsynsprogrammer",
      "shortName": "Prod. av film/video/fjernsynsprogr.",
      "level": 5,
      "parentCode": "59.11"
    },
    {
      "code": "59.120",
      "name": "Etterarbeid knyttet til produksjon av film, video og fjernsynsprogrammer",
      "shortName": "Etterarb. til film-/video-/TV-prod.",
      "level": 5,
      "parentCode": "59.12"
    },
    {
      "code": "59.130",
      "name": "Distribusjon av film, video og fjernsynsprogrammer",
      "shortName": "Distrib. film/video/fjernsynsprogr.",
      "level": 5,
      "parentCode": "59.13"
    },
    {
      "code": "59.140",
      "name": "Filmframvisning",
      "shortName": "Filmframvisning",
      "level": 5,
      "parentCode": "59.14"
    },
    {
      "code": "59.200",
      "name": "Produksjon og utgivelse av musikk- og lydopptak",
      "shortName": "Prod./utgiv. av musikk-/lydopptak",
      "level": 5,
      "parentCode": "59.20"
    },
    {
      "code": "60.100",
      "name": "Radiokringkasting",
      "shortName": "Radiokringkasting",
      "level": 5,
      "parentCode": "60.10"
    },
    {
      "code": "60.200",
      "name": "Fjernsynskringkasting",
      "shortName": "Fjernsynskringkasting",
      "level": 5,
      "parentCode": "60.20"
    },
    {
      "code": "61.100",
      "name": "Kabelbasert telekommunikasjon",
      "shortName": "Kabelbasert telekomm.",
      "level": 5,
      "parentCode": "61.10"
    },
    {
      "code": "61.200",
      "name": "Trådløs telekommunikasjon",
      "shortName": "Trådløs telekomm.",
      "level": 5,
      "parentCode": "61.20"
    },
    {
      "code": "61.300",
      "name": "Satellittbasert telekommunikasjon",
      "shortName": "Satellittbasert telekomm.",
      "level": 5,
      "parentCode": "61.30"
    },
    {
      "code": "61.900",
      "name": "Telekommunikasjon ellers",
      "shortName": "Telekommunikasjon ellers",
      "level": 5,
      "parentCode": "61.90"
    },
    {
      "code": "62.010",
      "name": "Programmeringstjenester",
      "shortName": "Programmeringstjenester",
      "level": 5,
      "parentCode": "62.01"
    },
    {
      "code": "62.020",
      "name": "Konsulentvirksomhet tilknyttet informasjonsteknologi",
      "shortName": "Kons.virks. tilkn. informasj.tekn.",
      "level": 5,
      "parentCode": "62.02"
    },
    {
      "code": "62.030",
      "name": "Forvaltning og drift av IT-systemer",
      "shortName": "Forvaltning og drift av IT-systemer",
      "level": 5,
      "parentCode": "62.03"
    },
    {
      "code": "62.090",
      "name": "Andre tjenester tilknyttet informasjonsteknologi",
      "shortName": "Tjen. tilkn. informasjonsteknologi el.",
      "level": 5,
      "parentCode": "62.09"
    },
    {
      "code": "63.110",
      "name": "Databehandling, datalagring og tilknyttede tjenester",
      "shortName": "Databeh./-lagring og tilkn. tjen.",
      "level": 5,
      "parentCode": "63.11"
    },
    {
      "code": "63.120",
      "name": "Drift av web-portaler",
      "shortName": "Drift av web-portaler",
      "level": 5,
      "parentCode": "63.12"
    },
    {
      "code": "63.910",
      "name": "Nyhetsbyråer",
      "shortName": "Nyhetsbyråer",
      "level": 5,
      "parentCode": "63.91"
    },
    {
      "code": "63.990",
      "name": "Andre informasjonstjenester ikke nevnt annet sted",
      "shortName": "Andre informasjonstjenester",
      "level": 5,
      "parentCode": "63.99"
    },
    {
      "code": "64.110",
      "name": "Sentralbankvirksomhet",
      "shortName": "Sentralbankvirksomhet",
      "level": 5,
      "parentCode": "64.11"
    },
    {
      "code": "64.190",
      "name": "Bankvirksomhet ellers",
      "shortName": "Bankvirksomhet ellers",
      "level": 5,
      "parentCode": "64.19"
    },
    {
      "code": "64.201",
      "name": "Finansielle holdingselskaper",
      "shortName": "Finansielle holdingselskaper",
      "level": 5,
      "parentCode": "64.20"
    },
    {
      "code": "64.202",
      "name": "Spesielle holdingselskaper",
      "shortName": "Spesielle holdingselskaper",
      "level": 5,
      "parentCode": "64.20"
    },
    {
      "code": "64.301",
      "name": "Verdipapirfond",
      "shortName": "Verdipapirfond",
      "level": 5,
      "parentCode": "64.30"
    },
    {
      "code": "64.302",
      "name": "Alternative investeringsfond (AIF) som ikke er verdipapirfond",
      "shortName": "Alternative investeringsfond AIF",
      "level": 5,
      "parentCode": "64.30"
    },
    {
      "code": "64.305",
      "name": "Finansstiftelser",
      "shortName": "Finansstiftelser",
      "level": 5,
      "parentCode": "64.30"
    },
    {
      "code": "64.306",
      "name": "Egeninvesteringsselskaper i finansielle konsern og for offentlig forvaltning",
      "shortName": "Egeninvesteringsselskaper i finansielle konsern og for offentlig forvaltning",
      "level": 5,
      "parentCode": "64.30"
    },
    {
      "code": "64.308",
      "name": "Familieeide egeninvesteringsselskaper",
      "shortName": "Familieide egeninvesteringsselskaper",
      "level": 5,
      "parentCode": "64.30"
    },
    {
      "code": "64.910",
      "name": "Finansiell leasing",
      "shortName": "Finansiell leasing",
      "level": 5,
      "parentCode": "64.91"
    },
    {
      "code": "64.920",
      "name": "Annen kredittgivning",
      "shortName": "Annen kredittgiving",
      "level": 5,
      "parentCode": "64.92"
    },
    {
      "code": "64.990",
      "name": "Annen finansieringsvirksomhet ikke nevnt annet sted",
      "shortName": "Finansieringsvirksomhet el.",
      "level": 5,
      "parentCode": "64.99"
    },
    {
      "code": "65.110",
      "name": "Livsforsikring",
      "shortName": "Livsforsikring",
      "level": 5,
      "parentCode": "65.11"
    },
    {
      "code": "65.120",
      "name": "Skadeforsikring",
      "shortName": "Skadeforsikring",
      "level": 5,
      "parentCode": "65.12"
    },
    {
      "code": "65.200",
      "name": "Gjenforsikring",
      "shortName": "Gjenforsikring",
      "level": 5,
      "parentCode": "65.20"
    },
    {
      "code": "65.300",
      "name": "Pensjonskasser",
      "shortName": "Pensjonskasser",
      "level": 5,
      "parentCode": "65.30"
    },
    {
      "code": "66.110",
      "name": "Administrasjon av finansmarkeder",
      "shortName": "Administrasjon av finansmarkeder",
      "level": 5,
      "parentCode": "66.11"
    },
    {
      "code": "66.120",
      "name": "Verdipapirmegling",
      "shortName": "Verdipapirmegling",
      "level": 5,
      "parentCode": "66.12"
    },
    {
      "code": "66.190",
      "name": "Andre tjenester tilknyttet finansieringsvirksomhet",
      "shortName": "Tjen. tilkn. finansieringsvirks. el.",
      "level": 5,
      "parentCode": "66.19"
    },
    {
      "code": "66.210",
      "name": "Risiko- og skadevurdering",
      "shortName": "Risiko- og skadevurdering",
      "level": 5,
      "parentCode": "66.21"
    },
    {
      "code": "66.220",
      "name": "Forsikringsformidling",
      "shortName": "Forsikringsformidling",
      "level": 5,
      "parentCode": "66.22"
    },
    {
      "code": "66.290",
      "name": "Andre tjenester tilknyttet forsikringsvirksomhet og pensjonskasser",
      "shortName": "Tjen. fors.virks./pensj.kasser el.",
      "level": 5,
      "parentCode": "66.29"
    },
    {
      "code": "66.300",
      "name": "Fondsforvaltningsvirksomhet",
      "shortName": "Fondsforvaltningsvirksomhet",
      "level": 5,
      "parentCode": "66.30"
    },
    {
      "code": "68.100",
      "name": "Kjøp og salg av egen fast eiendom",
      "shortName": "Kjøp/salg av egen fast eiendom",
      "level": 5,
      "parentCode": "68.10"
    },
    {
      "code": "68.201",
      "name": "Borettslag",
      "shortName": "Borettslag",
      "level": 5,
      "parentCode": "68.20"
    },
    {
      "code": "68.209",
      "name": "Utleie av egen eller leid fast eiendom ellers",
      "shortName": "Utl. av egen/leid fast eiendom el.",
      "level": 5,
      "parentCode": "68.20"
    },
    {
      "code": "68.310",
      "name": "Eiendomsmegling",
      "shortName": "Eiendomsmegling",
      "level": 5,
      "parentCode": "68.31"
    },
    {
      "code": "68.320",
      "name": "Eiendomsforvaltning",
      "shortName": "Eiendomsforvaltning",
      "level": 5,
      "parentCode": "68.32"
    },
    {
      "code": "69.100",
      "name": "Juridisk tjenesteyting",
      "shortName": "Juridisk tjenesteyting",
      "level": 5,
      "parentCode": "69.10"
    },
    {
      "code": "69.201",
      "name": "Regnskap og bokføring",
      "shortName": "Regnskap og bokføring",
      "level": 5,
      "parentCode": "69.20"
    },
    {
      "code": "69.202",
      "name": "Revisjon",
      "shortName": "Revisjon",
      "level": 5,
      "parentCode": "69.20"
    },
    {
      "code": "69.203",
      "name": "Skatterådgivning",
      "shortName": "Skatterådgivning",
      "level": 5,
      "parentCode": "69.20"
    },
    {
      "code": "70.100",
      "name": "Hovedkontortjenester",
      "shortName": "Hovedkontortjenester",
      "level": 5,
      "parentCode": "70.10"
    },
    {
      "code": "70.210",
      "name": "PR og kommunikasjonstjenester",
      "shortName": "PR og kommunikasjonstjenester",
      "level": 5,
      "parentCode": "70.21"
    },
    {
      "code": "70.220",
      "name": "Bedriftsrådgivning og annen administrativ rådgivning",
      "shortName": "Bedriftsrådgiv./annen adm. rådgiv.",
      "level": 5,
      "parentCode": "70.22"
    },
    {
      "code": "71.111",
      "name": "Plan- og reguleringsarbeid",
      "shortName": "Plan- og reguleringsarbeid",
      "level": 5,
      "parentCode": "71.11"
    },
    {
      "code": "71.112",
      "name": "Arkitekttjenester vedrørende byggverk",
      "shortName": "Arkitekttjen. vedr. byggverk",
      "level": 5,
      "parentCode": "71.11"
    },
    {
      "code": "71.113",
      "name": "Landskapsarkitekttjenester",
      "shortName": "Landskapsarkitekttjenester",
      "level": 5,
      "parentCode": "71.11"
    },
    {
      "code": "71.121",
      "name": "Byggeteknisk konsulentvirksomhet",
      "shortName": "Byggeteknisk konsulentvirks.",
      "level": 5,
      "parentCode": "71.12"
    },
    {
      "code": "71.122",
      "name": "Geologiske undersøkelser",
      "shortName": "Geologiske undersøkelser",
      "level": 5,
      "parentCode": "71.12"
    },
    {
      "code": "71.123",
      "name": "Kart og oppmåling",
      "shortName": "Kart og oppmåling",
      "level": 5,
      "parentCode": "71.12"
    },
    {
      "code": "71.129",
      "name": "Annen teknisk konsulentvirksomhet",
      "shortName": "Annen teknisk konsulentvirks.",
      "level": 5,
      "parentCode": "71.12"
    },
    {
      "code": "71.200",
      "name": "Teknisk prøving og analyse",
      "shortName": "Teknisk prøving og analyse",
      "level": 5,
      "parentCode": "71.20"
    },
    {
      "code": "72.110",
      "name": "Forskning og utviklingsarbeid innen bioteknologi",
      "shortName": "Forsk./utvikl.arb. innen bioteknologi",
      "level": 5,
      "parentCode": "72.11"
    },
    {
      "code": "72.190",
      "name": "Annen forskning og annet utviklingsarbeid innen naturvitenskap og teknikk",
      "shortName": "Annen forsk. innen naturvit. og teknikk",
      "level": 5,
      "parentCode": "72.19"
    },
    {
      "code": "72.200",
      "name": "Forskning og utviklingsarbeid innen samfunnsvitenskap og humanistiske fag",
      "shortName": "Forskning samfunnsvit., human. fag",
      "level": 5,
      "parentCode": "72.20"
    },
    {
      "code": "73.110",
      "name": "Reklamebyråer",
      "shortName": "Reklamebyråer",
      "level": 5,
      "parentCode": "73.11"
    },
    {
      "code": "73.120",
      "name": "Medieformidlingstjenester",
      "shortName": "Medieformidlingstjenester",
      "level": 5,
      "parentCode": "73.12"
    },
    {
      "code": "73.200",
      "name": "Markeds- og opinionsundersøkelser",
      "shortName": "Markeds- og opinionsundersøkelser",
      "level": 5,
      "parentCode": "73.20"
    },
    {
      "code": "74.101",
      "name": "Industridesign, produktdesign og annen teknisk designvirksomhet",
      "shortName": "Ind.-/produkt-/tekn.designvirks el",
      "level": 5,
      "parentCode": "74.10"
    },
    {
      "code": "74.102",
      "name": "Grafisk og visuell kommunikasjonsdesign",
      "shortName": "Grafisk/visuell kommunikasj.design",
      "level": 5,
      "parentCode": "74.10"
    },
    {
      "code": "74.103",
      "name": "Interiørarkitekt-, interiørdesign- og interiørkonsulentvirksomhet",
      "shortName": "Interiørark./-design/interiørkons.",
      "level": 5,
      "parentCode": "74.10"
    },
    {
      "code": "74.200",
      "name": "Fotografvirksomhet",
      "shortName": "Fotografvirksomhet",
      "level": 5,
      "parentCode": "74.20"
    },
    {
      "code": "74.300",
      "name": "Oversettelses- og tolkevirksomhet",
      "shortName": "Oversettelses- og tolkevirksomhet",
      "level": 5,
      "parentCode": "74.30"
    },
    {
      "code": "74.901",
      "name": "Takseringsvirksomhet",
      "shortName": "Takseringsvirksomhet",
      "level": 5,
      "parentCode": "74.90"
    },
    {
      "code": "74.902",
      "name": "Modellbyråvirksomhet",
      "shortName": "Modellbyråvirksomhet",
      "level": 5,
      "parentCode": "74.90"
    },
    {
      "code": "74.903",
      "name": "Impresariovirksomhet",
      "shortName": "Impresariovirksomhet",
      "level": 5,
      "parentCode": "74.90"
    },
    {
      "code": "74.909",
      "name": "Annen faglig, vitenskapelig og teknisk virksomhet ikke nevnt annet sted",
      "shortName": "Faglig/vit.skapelig/tekn.virks. el.",
      "level": 5,
      "parentCode": "74.90"
    },
    {
      "code": "75.000",
      "name": "Veterinærtjenester",
      "shortName": "Veterinærtjenester",
      "level": 5,
      "parentCode": "75.00"
    },
    {
      "code": "77.110",
      "name": "Utleie og leasing av biler og andre lette motorvogner",
      "shortName": "Utl./leas. biler/andre lette motorv.",
      "level": 5,
      "parentCode": "77.11"
    },
    {
      "code": "77.120",
      "name": "Utleie og leasing av lastebiler",
      "shortName": "Utleie og leasing av lastebiler",
      "level": 5,
      "parentCode": "77.12"
    },
    {
      "code": "77.210",
      "name": "Utleie og leasing av sports- og fritidsutstyr",
      "shortName": "Utl./leas. sports- og fritidsutstyr",
      "level": 5,
      "parentCode": "77.21"
    },
    {
      "code": "77.220",
      "name": "Utleie av videofilm, DVD og lignende",
      "shortName": "Utleie videofilm, DVD og lignende",
      "level": 5,
      "parentCode": "77.22"
    },
    {
      "code": "77.290",
      "name": "Utleie og leasing av andre husholdningsvarer og varer til personlig bruk",
      "shortName": "Utl./leas. husholdningsvarer el.",
      "level": 5,
      "parentCode": "77.29"
    },
    {
      "code": "77.310",
      "name": "Utleie og leasing av landbruksmaskiner og -utstyr",
      "shortName": "Utl./leas. landbruksmaskiner og -utstyr",
      "level": 5,
      "parentCode": "77.31"
    },
    {
      "code": "77.320",
      "name": "Utleie og leasing av bygge- og anleggsmaskiner og -utstyr",
      "shortName": "Utl./leas. bygge- og anleggsmask.",
      "level": 5,
      "parentCode": "77.32"
    },
    {
      "code": "77.330",
      "name": "Utleie og leasing av kontor- og datamaskiner",
      "shortName": "Utl./leas. kontor- og datamaskiner",
      "level": 5,
      "parentCode": "77.33"
    },
    {
      "code": "77.340",
      "name": "Utleie og leasing av sjøtransportmateriell",
      "shortName": "Utl./leas. sjøtransportmateriell",
      "level": 5,
      "parentCode": "77.34"
    },
    {
      "code": "77.350",
      "name": "Utleie og leasing av lufttransportmateriell",
      "shortName": "Utl./leas. lufttransportmateriell",
      "level": 5,
      "parentCode": "77.35"
    },
    {
      "code": "77.390",
      "name": "Utleie og leasing av andre maskiner og annet utstyr og materiell ikke nevnt annet sted",
      "shortName": "Utl./leas. andre mask./annet utstyr",
      "level": 5,
      "parentCode": "77.39"
    },
    {
      "code": "77.400",
      "name": "Leasing av immateriell eiendom og lignende produkter, unntatt opphavsrettsbeskyttede verker",
      "shortName": "Leas. av immateriell eiendom mv.",
      "level": 5,
      "parentCode": "77.40"
    },
    {
      "code": "78.100",
      "name": "Rekruttering og formidling av arbeidskraft",
      "shortName": "Rekrutt./formidling av arbeidskraft",
      "level": 5,
      "parentCode": "78.10"
    },
    {
      "code": "78.200",
      "name": "Utleie av arbeidskraft",
      "shortName": "Utleie av arbeidskraft",
      "level": 5,
      "parentCode": "78.20"
    },
    {
      "code": "78.300",
      "name": "Andre personaladministrative tjenester",
      "shortName": "Andre personaladm. tjen.",
      "level": 5,
      "parentCode": "78.30"
    },
    {
      "code": "79.110",
      "name": "Reisebyråvirksomhet",
      "shortName": "Reisebyråvirksomhet",
      "level": 5,
      "parentCode": "79.11"
    },
    {
      "code": "79.120",
      "name": "Reisearrangørvirksomhet",
      "shortName": "Reisearrangørvirksomhet",
      "level": 5,
      "parentCode": "79.12"
    },
    {
      "code": "79.901",
      "name": "Turistkontorvirksomhet og destinasjonsselskaper",
      "shortName": "Turistkontorvirks./destinasj.selsk.",
      "level": 5,
      "parentCode": "79.90"
    },
    {
      "code": "79.902",
      "name": "Guider og reiseledere",
      "shortName": "Guider og reiseledere",
      "level": 5,
      "parentCode": "79.90"
    },
    {
      "code": "79.903",
      "name": "Opplevelses-, arrangements- og aktivitetsarrangørvirksomhet",
      "shortName": "Opplevelses-/arrangementsvirks.m.m.",
      "level": 5,
      "parentCode": "79.90"
    },
    {
      "code": "79.909",
      "name": "Turistrelaterte tjenester ikke nevnt annet sted",
      "shortName": "Turistrelaterte tjenester el.",
      "level": 5,
      "parentCode": "79.90"
    },
    {
      "code": "80.100",
      "name": "Private vakttjenester",
      "shortName": "Private vakttjenester",
      "level": 5,
      "parentCode": "80.10"
    },
    {
      "code": "80.200",
      "name": "Tjenester tilknyttet vakttjenester",
      "shortName": "Tjenester tilknyttet vakttjenester",
      "level": 5,
      "parentCode": "80.20"
    },
    {
      "code": "80.300",
      "name": "Etterforsking",
      "shortName": "Etterforsking",
      "level": 5,
      "parentCode": "80.30"
    },
    {
      "code": "81.101",
      "name": "Vaktmestertjenester",
      "shortName": "Vaktmestertjenester",
      "level": 5,
      "parentCode": "81.10"
    },
    {
      "code": "81.109",
      "name": "Andre kombinerte tjenester tilknyttet eiendomsdrift",
      "shortName": "Andre komb. tjen. tilkn. eiendomsdr.",
      "level": 5,
      "parentCode": "81.10"
    },
    {
      "code": "81.210",
      "name": "Rengjøring av bygninger",
      "shortName": "Rengjøring av bygninger",
      "level": 5,
      "parentCode": "81.21"
    },
    {
      "code": "81.220",
      "name": "Utvendig rengjøring av bygninger og industriell rengjøring",
      "shortName": "Utv. rengj. bygn./ind. rengjøring",
      "level": 5,
      "parentCode": "81.22"
    },
    {
      "code": "81.291",
      "name": "Skadedyrkontroll",
      "shortName": "Skadedyrkontroll",
      "level": 5,
      "parentCode": "81.29"
    },
    {
      "code": "81.299",
      "name": "Annen rengjøringsvirksomhet ikke nevnt annet sted",
      "shortName": "Rengjøringsvirksomhet ellers",
      "level": 5,
      "parentCode": "81.29"
    },
    {
      "code": "81.300",
      "name": "Beplantning av hager og parkanlegg",
      "shortName": "Beplantning av hager og parkanl.",
      "level": 5,
      "parentCode": "81.30"
    },
    {
      "code": "82.110",
      "name": "Kombinerte kontortjenester",
      "shortName": "Kombinerte kontortjenester",
      "level": 5,
      "parentCode": "82.11"
    },
    {
      "code": "82.190",
      "name": "Fotokopiering, forberedelse av dokumenter og andre spesialiserte kontortjenester",
      "shortName": "Fotokopiering/spes. kontortjen. el.",
      "level": 5,
      "parentCode": "82.19"
    },
    {
      "code": "82.201",
      "name": "Telefonvakttjenester",
      "shortName": "Telefonvakttjenester",
      "level": 5,
      "parentCode": "82.20"
    },
    {
      "code": "82.202",
      "name": "Telefonsalg",
      "shortName": "Telefonsalg",
      "level": 5,
      "parentCode": "82.20"
    },
    {
      "code": "82.300",
      "name": "Kongress-, messe- og utstillingsvirksomhet",
      "shortName": "Kongress-/messe-/utstillingsvirks.",
      "level": 5,
      "parentCode": "82.30"
    },
    {
      "code": "82.910",
      "name": "Inkasso- og kredittopplysningsvirksomhet",
      "shortName": "Inkasso- og kredittopplysningsvirks.",
      "level": 5,
      "parentCode": "82.91"
    },
    {
      "code": "82.920",
      "name": "Pakkevirksomhet",
      "shortName": "Pakkevirksomhet",
      "level": 5,
      "parentCode": "82.92"
    },
    {
      "code": "82.990",
      "name": "Annen forretningsmessig tjenesteyting ikke nevnt annet sted",
      "shortName": "Forr.messig tj.yting ikke nevnt el.",
      "level": 5,
      "parentCode": "82.99"
    },
    {
      "code": "84.110",
      "name": "Generell offentlig administrasjon",
      "shortName": "Generell offentlig administrasjon",
      "level": 5,
      "parentCode": "84.11"
    },
    {
      "code": "84.120",
      "name": "Offentlig administrasjon tilknyttet helsestell, sosial virksomhet, undervisning, kirke, kultur og miljøvern",
      "shortName": "Off.adm. helse, sos.virks. m.m.",
      "level": 5,
      "parentCode": "84.12"
    },
    {
      "code": "84.130",
      "name": "Offentlig administrasjon tilknyttet næringsvirksomhet og arbeidsmarked",
      "shortName": "Off.adm. nær.virks. og arb.marked",
      "level": 5,
      "parentCode": "84.13"
    },
    {
      "code": "84.210",
      "name": "Utenrikssaker",
      "shortName": "Utenrikssaker",
      "level": 5,
      "parentCode": "84.21"
    },
    {
      "code": "84.220",
      "name": "Forsvar",
      "shortName": "Forsvar",
      "level": 5,
      "parentCode": "84.22"
    },
    {
      "code": "84.230",
      "name": "Retts- og fengselsvesen",
      "shortName": "Retts- og fengselsvesen",
      "level": 5,
      "parentCode": "84.23"
    },
    {
      "code": "84.240",
      "name": "Politi- og påtalemyndighet",
      "shortName": "Politi- og påtalemyndighet",
      "level": 5,
      "parentCode": "84.24"
    },
    {
      "code": "84.250",
      "name": "Brannvern",
      "shortName": "Brannvern",
      "level": 5,
      "parentCode": "84.25"
    },
    {
      "code": "84.300",
      "name": "Trygdeordninger underlagt offentlig forvaltning",
      "shortName": "Sosialforsikring, trygd",
      "level": 5,
      "parentCode": "84.30"
    },
    {
      "code": "85.100",
      "name": "Førskoleundervisning",
      "shortName": "Førskoleundervisning",
      "level": 5,
      "parentCode": "85.10"
    },
    {
      "code": "85.201",
      "name": "Ordinær grunnskoleundervisning",
      "shortName": "Ordinær grunnskoleundervisning",
      "level": 5,
      "parentCode": "85.20"
    },
    {
      "code": "85.202",
      "name": "Spesialskoleundervisning for funksjonshemmede",
      "shortName": "Spes.undervisn. for funksj.hemmede",
      "level": 5,
      "parentCode": "85.20"
    },
    {
      "code": "85.203",
      "name": "Kompetansesentra og annen spesialundervisning",
      "shortName": "Kompetansesentra og lignende",
      "level": 5,
      "parentCode": "85.20"
    },
    {
      "code": "85.310",
      "name": "Videregående opplæring innen allmennfaglige studieretninger",
      "shortName": "Undervisning i allmennfag",
      "level": 5,
      "parentCode": "85.31"
    },
    {
      "code": "85.320",
      "name": "Videregående opplæring innen tekniske og andre yrkesfaglige studieretninger",
      "shortName": "Undervisn. i tekn./yrkesrettede fag",
      "level": 5,
      "parentCode": "85.32"
    },
    {
      "code": "85.410",
      "name": "Undervisning ved fagskoler",
      "shortName": "Undervisning ved fagskoler",
      "level": 5,
      "parentCode": "85.41"
    },
    {
      "code": "85.421",
      "name": "Undervisning ved universiteter",
      "shortName": "Undervisning ved universiteter",
      "level": 5,
      "parentCode": "85.42"
    },
    {
      "code": "85.422",
      "name": "Undervisning ved vitenskapelige høgskoler",
      "shortName": "Underv. ved vit.skap høgskoler",
      "level": 5,
      "parentCode": "85.42"
    },
    {
      "code": "85.423",
      "name": "Undervisning ved statlige høgskoler",
      "shortName": "Underv. ved statlige høgskoler",
      "level": 5,
      "parentCode": "85.42"
    },
    {
      "code": "85.424",
      "name": "Undervisning ved militære høgskoler",
      "shortName": "Underv. ved militære høgskoler",
      "level": 5,
      "parentCode": "85.42"
    },
    {
      "code": "85.429",
      "name": "Undervisning ved andre høgskoler",
      "shortName": "Underv. ved andre høgskoler",
      "level": 5,
      "parentCode": "85.42"
    },
    {
      "code": "85.510",
      "name": "Undervisning innen idrett og rekreasjon",
      "shortName": "Underv. innen idrett og rekreasjon",
      "level": 5,
      "parentCode": "85.51"
    },
    {
      "code": "85.521",
      "name": "Kommunal kulturskoleundervisning",
      "shortName": "Kommunal kulturskoleunderv.",
      "level": 5,
      "parentCode": "85.52"
    },
    {
      "code": "85.522",
      "name": "Undervisning i kunstfag",
      "shortName": "Undervisning i kunstfag",
      "level": 5,
      "parentCode": "85.52"
    },
    {
      "code": "85.529",
      "name": "Annen undervisning innen kultur",
      "shortName": "Annen undervisning innen kultur",
      "level": 5,
      "parentCode": "85.52"
    },
    {
      "code": "85.530",
      "name": "Trafikkskoleundervisning",
      "shortName": "Trafikkskoleundervisning",
      "level": 5,
      "parentCode": "85.53"
    },
    {
      "code": "85.591",
      "name": "Folkehøgskoleundervisning",
      "shortName": "Folkehøgskoleundervisning",
      "level": 5,
      "parentCode": "85.59"
    },
    {
      "code": "85.592",
      "name": "Arbeidsmarkedskurs",
      "shortName": "Arbeidsmarkedkurs",
      "level": 5,
      "parentCode": "85.59"
    },
    {
      "code": "85.593",
      "name": "Studieforbunds- og frivillige organisasjoners kurs",
      "shortName": "Studieforb.- og friv. organ kurs",
      "level": 5,
      "parentCode": "85.59"
    },
    {
      "code": "85.594",
      "name": "Voksenopplæringssentre",
      "shortName": "Voksenopplæringssentre",
      "level": 5,
      "parentCode": "85.59"
    },
    {
      "code": "85.595",
      "name": "Timelærervirksomhet",
      "shortName": "Timelærervirksomhet",
      "level": 5,
      "parentCode": "85.59"
    },
    {
      "code": "85.596",
      "name": "Undervisning innen religion",
      "shortName": "Undervisning innen religion",
      "level": 5,
      "parentCode": "85.59"
    },
    {
      "code": "85.599",
      "name": "Annen undervisning ikke nevnt annet sted",
      "shortName": "Undervisning ellers",
      "level": 5,
      "parentCode": "85.59"
    },
    {
      "code": "85.601",
      "name": "Pedagogisk-psykologisk rådgivningstjeneste",
      "shortName": "Pedag./psyk. rådgivningstjeneste",
      "level": 5,
      "parentCode": "85.60"
    },
    {
      "code": "85.609",
      "name": "Andre tjenester tilknyttet undervisning",
      "shortName": "Tjenester tilkn. undervisning el.",
      "level": 5,
      "parentCode": "85.60"
    },
    {
      "code": "86.101",
      "name": "Alminnelige somatiske sykehus",
      "shortName": "Alminnelige somatiske sykehus",
      "level": 5,
      "parentCode": "86.10"
    },
    {
      "code": "86.102",
      "name": "Somatiske spesialsykehus",
      "shortName": "Somatiske spesialsykehus",
      "level": 5,
      "parentCode": "86.10"
    },
    {
      "code": "86.103",
      "name": "Andre somatiske spesialinstitusjoner",
      "shortName": "Andre somat. spesialinstitusjoner",
      "level": 5,
      "parentCode": "86.10"
    },
    {
      "code": "86.104",
      "name": "Institusjoner i psykisk helsevern for voksne",
      "shortName": "Inst. i psyk helsevern voksne",
      "level": 5,
      "parentCode": "86.10"
    },
    {
      "code": "86.105",
      "name": "Institusjoner i psykisk helsevern for barn og unge",
      "shortName": "Inst. psyk. helsevern barn/unge",
      "level": 5,
      "parentCode": "86.10"
    },
    {
      "code": "86.106",
      "name": "Rusmiddelinstitusjoner",
      "shortName": "Rusmiddelinstitusjoner",
      "level": 5,
      "parentCode": "86.10"
    },
    {
      "code": "86.107",
      "name": "Rehabiliterings- og opptreningsinstitusjoner",
      "shortName": "Rehab.- og opptreningsinstitusjoner",
      "level": 5,
      "parentCode": "86.10"
    },
    {
      "code": "86.211",
      "name": "Allmenn legetjeneste",
      "shortName": "Allmenn legetjeneste",
      "level": 5,
      "parentCode": "86.21"
    },
    {
      "code": "86.212",
      "name": "Somatiske poliklinikker",
      "shortName": "Somatiske poliklinikker",
      "level": 5,
      "parentCode": "86.21"
    },
    {
      "code": "86.221",
      "name": "Spesialisert legetjeneste, unntatt psykiatrisk legetjeneste",
      "shortName": "Spes.legetj., unnt. psykiatrisk",
      "level": 5,
      "parentCode": "86.22"
    },
    {
      "code": "86.222",
      "name": "Legetjenester innen psykisk helsevern",
      "shortName": "Legetj. innen psykisk helsevern",
      "level": 5,
      "parentCode": "86.22"
    },
    {
      "code": "86.223",
      "name": "Poliklinikker i psykisk helsevern for voksne",
      "shortName": "Poliklin. i psyk. helsevern voksne",
      "level": 5,
      "parentCode": "86.22"
    },
    {
      "code": "86.224",
      "name": "Poliklinikker i psykisk helsevern for barn og unge",
      "shortName": "Poliklin. i psyk. helsev. barn/unge",
      "level": 5,
      "parentCode": "86.22"
    },
    {
      "code": "86.225",
      "name": "Rusmiddelpoliklinikker",
      "shortName": "Rusmiddelpoliklinikker",
      "level": 5,
      "parentCode": "86.22"
    },
    {
      "code": "86.230",
      "name": "Tannhelsetjenester",
      "shortName": "Tannhelsetjenester",
      "level": 5,
      "parentCode": "86.23"
    },
    {
      "code": "86.901",
      "name": "Hjemmesykepleie",
      "shortName": "Hjemmesykepleie",
      "level": 5,
      "parentCode": "86.90"
    },
    {
      "code": "86.902",
      "name": "Fysioterapitjeneste",
      "shortName": "Fysioterapitjeneste",
      "level": 5,
      "parentCode": "86.90"
    },
    {
      "code": "86.903",
      "name": "Helsestasjons- og skolehelsetjeneste",
      "shortName": "Helsestasjons- og skolehelsetjeneste",
      "level": 5,
      "parentCode": "86.90"
    },
    {
      "code": "86.904",
      "name": "Annen forebyggende helsetjeneste",
      "shortName": "Annen forebyggende helsetjeneste",
      "level": 5,
      "parentCode": "86.90"
    },
    {
      "code": "86.905",
      "name": "Klinisk psykologtjeneste",
      "shortName": "Klinisk psykologtjeneste",
      "level": 5,
      "parentCode": "86.90"
    },
    {
      "code": "86.906",
      "name": "Medisinske laboratorietjenester",
      "shortName": "Medisinske laboratorietjenester",
      "level": 5,
      "parentCode": "86.90"
    },
    {
      "code": "86.907",
      "name": "Ambulansetjenester",
      "shortName": "Ambulansetjenester",
      "level": 5,
      "parentCode": "86.90"
    },
    {
      "code": "86.909",
      "name": "Andre helsetjenester",
      "shortName": "Andre helsetjenester",
      "level": 5,
      "parentCode": "86.90"
    },
    {
      "code": "87.101",
      "name": "Somatiske spesialsykehjem",
      "shortName": "Somatiske spesialsykehjem",
      "level": 5,
      "parentCode": "87.10"
    },
    {
      "code": "87.102",
      "name": "Somatiske sykehjem",
      "shortName": "Somatiske sykehjem",
      "level": 5,
      "parentCode": "87.10"
    },
    {
      "code": "87.201",
      "name": "Psykiatriske sykehjem",
      "shortName": "Psykiatriske sykehjem",
      "level": 5,
      "parentCode": "87.20"
    },
    {
      "code": "87.202",
      "name": "Omsorgsinstitusjoner for rusmiddelmisbrukere",
      "shortName": "Omsorgsinst. for rusmiddelmisbruk.",
      "level": 5,
      "parentCode": "87.20"
    },
    {
      "code": "87.203",
      "name": "Bofellesskap for psykisk utviklingshemmede",
      "shortName": "Bofellesskap for psyk utv.hemmede",
      "level": 5,
      "parentCode": "87.20"
    },
    {
      "code": "87.301",
      "name": "Aldershjem",
      "shortName": "Aldershjem",
      "level": 5,
      "parentCode": "87.30"
    },
    {
      "code": "87.302",
      "name": "Bofellesskap for eldre og funksjonshemmede med fast tilknyttet personell hele døgnet",
      "shortName": "Heldøgns pleie eldre/funksjonshem.",
      "level": 5,
      "parentCode": "87.30"
    },
    {
      "code": "87.303",
      "name": "Bofellesskap for eldre og funksjonshemmede med fast tilknyttet personell deler av døgnet",
      "shortName": "Deldøgns pleie eldre /funksj.hem.",
      "level": 5,
      "parentCode": "87.30"
    },
    {
      "code": "87.304",
      "name": "Avlastningsboliger/-institusjoner",
      "shortName": "Avlastningsboliger/-institusjoner",
      "level": 5,
      "parentCode": "87.30"
    },
    {
      "code": "87.305",
      "name": "Barneboliger",
      "shortName": "Barneboliger",
      "level": 5,
      "parentCode": "87.30"
    },
    {
      "code": "87.901",
      "name": "Institusjoner innen barne- og ungdomsvern",
      "shortName": "Inst for barne- og ungdomsvern",
      "level": 5,
      "parentCode": "87.90"
    },
    {
      "code": "87.909",
      "name": "Omsorgsinstitusjoner ellers",
      "shortName": "Omsorgsinstitusjoner ellers",
      "level": 5,
      "parentCode": "87.90"
    },
    {
      "code": "88.101",
      "name": "Hjemmehjelp",
      "shortName": "Hjemmehjelp",
      "level": 5,
      "parentCode": "88.10"
    },
    {
      "code": "88.102",
      "name": "Dagsentra/aktivitetssentra for eldre og funksjonshemmede",
      "shortName": "Akt.sentra eldre og funksjonshem.",
      "level": 5,
      "parentCode": "88.10"
    },
    {
      "code": "88.103",
      "name": "Eldresentre",
      "shortName": "Eldresentre",
      "level": 5,
      "parentCode": "88.10"
    },
    {
      "code": "88.911",
      "name": "Barnehager",
      "shortName": "Barnehager",
      "level": 5,
      "parentCode": "88.91"
    },
    {
      "code": "88.912",
      "name": "Barneparker og dagmammaer",
      "shortName": "Barneparker og dagmammaer",
      "level": 5,
      "parentCode": "88.91"
    },
    {
      "code": "88.913",
      "name": "Skolefritidsordninger",
      "shortName": "Skolefritidsordninger",
      "level": 5,
      "parentCode": "88.91"
    },
    {
      "code": "88.914",
      "name": "Fritidsklubber for barn og ungdom",
      "shortName": "Fritidsklubber for barn og ungdom",
      "level": 5,
      "parentCode": "88.91"
    },
    {
      "code": "88.991",
      "name": "Barneverntjenester",
      "shortName": "Barneverntjenester",
      "level": 5,
      "parentCode": "88.99"
    },
    {
      "code": "88.992",
      "name": "Familieverntjenester",
      "shortName": "Familieverntjenester",
      "level": 5,
      "parentCode": "88.99"
    },
    {
      "code": "88.993",
      "name": "Arbeidstrening for ordinært arbeidsmarked",
      "shortName": "Arb.trening for ordinært arb.marked",
      "level": 5,
      "parentCode": "88.99"
    },
    {
      "code": "88.994",
      "name": "Varig tilrettelagt arbeid",
      "shortName": "Varig tilrettelagt arbeid",
      "level": 5,
      "parentCode": "88.99"
    },
    {
      "code": "88.995",
      "name": "Sosiale velferdsorganisasjoner",
      "shortName": "Sosiale velferdsorganisasjoner",
      "level": 5,
      "parentCode": "88.99"
    },
    {
      "code": "88.996",
      "name": "Asylmottak",
      "shortName": "Asylmottak",
      "level": 5,
      "parentCode": "88.99"
    },
    {
      "code": "88.997",
      "name": "Sosialtjenester for rusmiddelmisbrukere uten botilbud",
      "shortName": "Sos.tj. rusmisbr. uten botilbud",
      "level": 5,
      "parentCode": "88.99"
    },
    {
      "code": "88.998",
      "name": "Kommunale sosialkontortjenester",
      "shortName": "Kommunale sosialkontortjenester",
      "level": 5,
      "parentCode": "88.99"
    },
    {
      "code": "88.999",
      "name": "Andre sosialtjenester uten botilbud",
      "shortName": "Andre sosialtjenester uten botilbud",
      "level": 5,
      "parentCode": "88.99"
    },
    {
      "code": "90.011",
      "name": "Utøvende kunstnere og underholdningsvirksomhet innen musikk",
      "shortName": "Utøv. kunstnere innen musikk",
      "level": 5,
      "parentCode": "90.01"
    },
    {
      "code": "90.012",
      "name": "Utøvende kunstnere og underholdningsvirksomhet innen scenekunst",
      "shortName": "Utøv. kunstnere innen scenekunst",
      "level": 5,
      "parentCode": "90.01"
    },
    {
      "code": "90.019",
      "name": "Utøvende kunstnere og underholdningsvirksomhet ikke nevnt annet sted",
      "shortName": "Utøv. kunstnere ellers",
      "level": 5,
      "parentCode": "90.01"
    },
    {
      "code": "90.020",
      "name": "Tjenester tilknyttet underholdningsvirksomhet",
      "shortName": "Tjen. tilkn. underholdningsvirks.",
      "level": 5,
      "parentCode": "90.02"
    },
    {
      "code": "90.031",
      "name": "Selvstendig kunstnerisk virksomhet innen visuell kunst",
      "shortName": "Selvst. kunst.virks. visuell kunst",
      "level": 5,
      "parentCode": "90.03"
    },
    {
      "code": "90.032",
      "name": "Selvstendig kunstnerisk virksomhet innen musikk",
      "shortName": "Selvst. kunst.virks. innen musikk",
      "level": 5,
      "parentCode": "90.03"
    },
    {
      "code": "90.033",
      "name": "Selvstendig kunstnerisk virksomhet innen scenekunst",
      "shortName": "Selvst. kunst.virks. scenekunst",
      "level": 5,
      "parentCode": "90.03"
    },
    {
      "code": "90.034",
      "name": "Selvstendig kunstnerisk virksomhet innen litteratur",
      "shortName": "Selvst. kunst.virks. litteratur",
      "level": 5,
      "parentCode": "90.03"
    },
    {
      "code": "90.035",
      "name": "Selvstendig kunstnerisk virksomhet innen blogging ",
      "shortName": "Selvstendig kunstnerisk virksomhet innen blogging ",
      "level": 5,
      "parentCode": "90.03"
    },
    {
      "code": "90.039",
      "name": "Selvstendig kunstnerisk virksomhet ikke nevnt annet sted",
      "shortName": "Annen selvst. kunstnerisk virks.",
      "level": 5,
      "parentCode": "90.03"
    },
    {
      "code": "90.040",
      "name": "Drift av lokaler tilknyttet kunstnerisk virksomhet",
      "shortName": "Drift lokaler tilkn. kunst.virks.",
      "level": 5,
      "parentCode": "90.04"
    },
    {
      "code": "91.011",
      "name": "Drift av folkebiblioteker",
      "shortName": "Drift av folkebiblioteker",
      "level": 5,
      "parentCode": "91.01"
    },
    {
      "code": "91.012",
      "name": "Drift av fag- og forskningsbiblioteker",
      "shortName": "Drift av fag-/forskningsbiblioteker",
      "level": 5,
      "parentCode": "91.01"
    },
    {
      "code": "91.013",
      "name": "Drift av arkiver",
      "shortName": "Drift av arkiver",
      "level": 5,
      "parentCode": "91.01"
    },
    {
      "code": "91.021",
      "name": "Drift av kunst- og kunstindustrimuseer",
      "shortName": "Drift av kunst-/kunstindustrimuseer",
      "level": 5,
      "parentCode": "91.02"
    },
    {
      "code": "91.022",
      "name": "Drift av kulturhistoriske museer",
      "shortName": "Drift av kulturhistoriske museer",
      "level": 5,
      "parentCode": "91.02"
    },
    {
      "code": "91.023",
      "name": "Drift av naturhistoriske museer",
      "shortName": "Drift av naturhistoriske museer",
      "level": 5,
      "parentCode": "91.02"
    },
    {
      "code": "91.029",
      "name": "Drift av museer ikke nevnt annet sted",
      "shortName": "Drift av museer ellers",
      "level": 5,
      "parentCode": "91.02"
    },
    {
      "code": "91.030",
      "name": "Drift av historiske steder og bygninger og lignende severdigheter",
      "shortName": "Drift av hist. steder og bygn. mv.",
      "level": 5,
      "parentCode": "91.03"
    },
    {
      "code": "91.040",
      "name": "Drift av botaniske og zoologiske hager og naturreservater",
      "shortName": "Drift av bot./zool. hager/naturres.",
      "level": 5,
      "parentCode": "91.04"
    },
    {
      "code": "92.000",
      "name": "Lotteri og totalisatorspill",
      "shortName": "Lotteri og totalisatorspill",
      "level": 5,
      "parentCode": "92.00"
    },
    {
      "code": "93.110",
      "name": "Drift av idrettsanlegg",
      "shortName": "Drift av idrettsanlegg",
      "level": 5,
      "parentCode": "93.11"
    },
    {
      "code": "93.120",
      "name": "Idrettslag og -klubber",
      "shortName": "Idrettslag og -klubber",
      "level": 5,
      "parentCode": "93.12"
    },
    {
      "code": "93.130",
      "name": "Treningssentre",
      "shortName": "Treningssentre",
      "level": 5,
      "parentCode": "93.13"
    },
    {
      "code": "93.190",
      "name": "Andre sportsaktiviteter",
      "shortName": "Andre sportsaktiviteter",
      "level": 5,
      "parentCode": "93.19"
    },
    {
      "code": "93.210",
      "name": "Drift av fornøyelses- og temaparker",
      "shortName": "Drift av fornøyelses- og temaparker",
      "level": 5,
      "parentCode": "93.21"
    },
    {
      "code": "93.291",
      "name": "Opplevelsesaktiviteter",
      "shortName": "Opplevelsesaktiviteter",
      "level": 5,
      "parentCode": "93.29"
    },
    {
      "code": "93.292",
      "name": "Fritidsetablissement",
      "shortName": "Fritidsetablissement",
      "level": 5,
      "parentCode": "93.29"
    },
    {
      "code": "93.299",
      "name": "Fritidsvirksomhet ellers",
      "shortName": "Firtidsvirksomhet ellers",
      "level": 5,
      "parentCode": "93.29"
    },
    {
      "code": "94.110",
      "name": "Næringslivs- og arbeidsgiverorganisasjoner",
      "shortName": "Næringslivs-/arbeidsgiverorg. mv.",
      "level": 5,
      "parentCode": "94.11"
    },
    {
      "code": "94.120",
      "name": "Yrkessammenslutninger",
      "shortName": "Yrkessammenslutninger",
      "level": 5,
      "parentCode": "94.12"
    },
    {
      "code": "94.200",
      "name": "Arbeidstakerorganisasjoner",
      "shortName": "Arbeidstakerorganisasjoner",
      "level": 5,
      "parentCode": "94.20"
    },
    {
      "code": "94.910",
      "name": "Religiøse organisasjoner",
      "shortName": "Religiøse organisasjoner",
      "level": 5,
      "parentCode": "94.91"
    },
    {
      "code": "94.920",
      "name": "Partipolitiske organisasjoner",
      "shortName": "Partipolitiske organisasjoner",
      "level": 5,
      "parentCode": "94.92"
    },
    {
      "code": "94.991",
      "name": "Aktiviteter i andre interesseorganisasjoner ikke nevnt annet sted",
      "shortName": "Interesseorganisasjoner ellers",
      "level": 5,
      "parentCode": "94.99"
    },
    {
      "code": "94.992",
      "name": "Fond/legat som støtter veldedige og allmennyttige formål",
      "shortName": "Fond/legat allmennyttige formål",
      "level": 5,
      "parentCode": "94.99"
    },
    {
      "code": "95.110",
      "name": "Reparasjon av datamaskiner og tilleggsutstyr",
      "shortName": "Rep. av datamask. og tilleggsutstyr",
      "level": 5,
      "parentCode": "95.11"
    },
    {
      "code": "95.120",
      "name": "Reparasjon av kommunikasjonsutstyr",
      "shortName": "Rep. av kommunikasjonsutstyr",
      "level": 5,
      "parentCode": "95.12"
    },
    {
      "code": "95.210",
      "name": "Reparasjon av elektronikk til husholdningsbruk",
      "shortName": "Rep. av elektronikk til hush.bruk",
      "level": 5,
      "parentCode": "95.21"
    },
    {
      "code": "95.220",
      "name": "Reparasjon av husholdningsvarer og hageredskaper",
      "shortName": "Rep. av hush.varer og hageredskaper",
      "level": 5,
      "parentCode": "95.22"
    },
    {
      "code": "95.230",
      "name": "Reparasjon av skotøy og lærvarer",
      "shortName": "Rep. av skotøy og lærvarer",
      "level": 5,
      "parentCode": "95.23"
    },
    {
      "code": "95.240",
      "name": "Reparasjon av møbler og boliginnredning",
      "shortName": "Rep. av møbler og boliginnredning",
      "level": 5,
      "parentCode": "95.24"
    },
    {
      "code": "95.250",
      "name": "Reparasjon av ur, gull- og sølvvarer",
      "shortName": "Rep. av ur, gull- og sølvvarer",
      "level": 5,
      "parentCode": "95.25"
    },
    {
      "code": "95.290",
      "name": "Reparasjon av andre husholdningsvarer og varer til personlig bruk",
      "shortName": "Rep. av husholdningsvarer el.",
      "level": 5,
      "parentCode": "95.29"
    },
    {
      "code": "96.010",
      "name": "Vaskeri- og renserivirksomhet",
      "shortName": "Vaskeri- og renserivirksomhet",
      "level": 5,
      "parentCode": "96.01"
    },
    {
      "code": "96.020",
      "name": "Frisering og annen skjønnhetspleie",
      "shortName": "Frisering og skjønnhetspleie el.",
      "level": 5,
      "parentCode": "96.02"
    },
    {
      "code": "96.030",
      "name": "Begravelsesbyråvirksomhet og drift av kirkegårder og krematorier",
      "shortName": "Begrav.byrå, kirkegårdsdrift mv..",
      "level": 5,
      "parentCode": "96.03"
    },
    {
      "code": "96.040",
      "name": "Virksomhet knyttet til kroppspleie og fysisk velvære",
      "shortName": "Helsestudiovirksomhet mv.",
      "level": 5,
      "parentCode": "96.04"
    },
    {
      "code": "96.090",
      "name": "Personlig tjenesteyting ikke nevnt annet sted",
      "shortName": "Personlig tjenesteyting el.",
      "level": 5,
      "parentCode": "96.09"
    },
    {
      "code": "97.000",
      "name": "Lønnet arbeid i private husholdninger",
      "shortName": "Lønnet arbeid i private husholdn.",
      "level": 5,
      "parentCode": "97.00"
    },
    {
      "code": "99.000",
      "name": "Internasjonale organisasjoner og organer",
      "shortName": "Internasjonale organer",
      "level": 5,
      "parentCode": "99.00"
    }
  ]
};

export const hierarchicalCodes: IndustryCode[] = [
  {
    "code": "A",
    "name": "Jordbruk, skogbruk og fiske",
    "shortName": "Jordbruk, skogbruk og fiske",
    "level": 1,
    "parentCode": "",
    "children": [
      {
        "code": "01",
        "name": "Jordbruk og tjenester tilknyttet jordbruk, jakt og viltstell",
        "shortName": "Jordbruk, tilhør. tjenester, jakt",
        "level": 2,
        "parentCode": "A",
        "children": [
          {
            "code": "01.1",
            "name": "Dyrking av ettårige vekster",
            "shortName": "Dyrking av ettårige vekster",
            "level": 3,
            "parentCode": "01",
            "children": [
              {
                "code": "01.11",
                "name": "Dyrking av korn (unntatt ris), belgvekster og oljeholdige vekster",
                "shortName": "Dyrking av korn, belgvekster mv.",
                "level": 4,
                "parentCode": "01.1",
                "children": [
                  {
                    "code": "01.110",
                    "name": "Dyrking av korn (unntatt ris), belgvekster og oljeholdige vekster",
                    "shortName": "Dyrking av korn, belgvekster mv.",
                    "level": 5,
                    "parentCode": "01.11"
                  }
                ]
              },
              {
                "code": "01.12",
                "name": "Dyrking av ris",
                "shortName": "Dyrking av ris",
                "level": 4,
                "parentCode": "01.1",
                "children": [
                  {
                    "code": "01.120",
                    "name": "Dyrking av ris",
                    "shortName": "Dyrking av ris",
                    "level": 5,
                    "parentCode": "01.12"
                  }
                ]
              },
              {
                "code": "01.13",
                "name": "Dyrking av grønnsaker, meloner, rot- og knollvekster",
                "shortName": "Dyrking av grønnsaker, poteter mv.",
                "level": 4,
                "parentCode": "01.1",
                "children": [
                  {
                    "code": "01.130",
                    "name": "Dyrking av grønnsaker, meloner, rot- og knollvekster",
                    "shortName": "Dyrking av grønnsaker, poteter mv.",
                    "level": 5,
                    "parentCode": "01.13"
                  }
                ]
              },
              {
                "code": "01.14",
                "name": "Dyrking av sukkerrør",
                "shortName": "Dyrking av sukkerrør",
                "level": 4,
                "parentCode": "01.1",
                "children": [
                  {
                    "code": "01.140",
                    "name": "Dyrking av sukkerrør",
                    "shortName": "Dyrking av sukkerrør",
                    "level": 5,
                    "parentCode": "01.14"
                  }
                ]
              },
              {
                "code": "01.15",
                "name": "Dyrking av tobakk",
                "shortName": "Dyrking av tobakk",
                "level": 4,
                "parentCode": "01.1",
                "children": [
                  {
                    "code": "01.150",
                    "name": "Dyrking av tobakk",
                    "shortName": "Dyrking av tobakk",
                    "level": 5,
                    "parentCode": "01.15"
                  }
                ]
              },
              {
                "code": "01.16",
                "name": "Dyrking av fibervekster",
                "shortName": "Dyrking av fibervekster",
                "level": 4,
                "parentCode": "01.1",
                "children": [
                  {
                    "code": "01.160",
                    "name": "Dyrking av fibervekster",
                    "shortName": "Dyrking av fibervekster",
                    "level": 5,
                    "parentCode": "01.16"
                  }
                ]
              },
              {
                "code": "01.19",
                "name": "Dyrking av ettårige vekster ellers",
                "shortName": "Dyrking av ettårige vekster ellers",
                "level": 4,
                "parentCode": "01.1",
                "children": [
                  {
                    "code": "01.190",
                    "name": "Dyrking av ettårige vekster ellers",
                    "shortName": "Dyrking av ettårige vekster ellers",
                    "level": 5,
                    "parentCode": "01.19"
                  }
                ]
              }
            ]
          },
          {
            "code": "01.2",
            "name": "Dyrking av flerårige vekster",
            "shortName": "Dyrking av flerårige vekster",
            "level": 3,
            "parentCode": "01",
            "children": [
              {
                "code": "01.21",
                "name": "Dyrking av druer",
                "shortName": "Dyrking av druer",
                "level": 4,
                "parentCode": "01.2",
                "children": [
                  {
                    "code": "01.210",
                    "name": "Dyrking av druer",
                    "shortName": "Dyrking av druer",
                    "level": 5,
                    "parentCode": "01.21"
                  }
                ]
              },
              {
                "code": "01.22",
                "name": "Dyrking av tropiske og subtropiske frukter",
                "shortName": "Dyrking av trop./subtrop. frukter",
                "level": 4,
                "parentCode": "01.2",
                "children": [
                  {
                    "code": "01.220",
                    "name": "Dyrking av tropiske og subtropiske frukter",
                    "shortName": "Dyrking av trop./subtrop. frukter",
                    "level": 5,
                    "parentCode": "01.22"
                  }
                ]
              },
              {
                "code": "01.23",
                "name": "Dyrking av sitrusfrukter",
                "shortName": "Dyrking av sitrusfrukter",
                "level": 4,
                "parentCode": "01.2",
                "children": [
                  {
                    "code": "01.230",
                    "name": "Dyrking av sitrusfrukter",
                    "shortName": "Dyrking av sitrusfrukter",
                    "level": 5,
                    "parentCode": "01.23"
                  }
                ]
              },
              {
                "code": "01.24",
                "name": "Dyrking av kjernefrukter og steinfrukter",
                "shortName": "Dyrking av kjerne- og steinfrukter",
                "level": 4,
                "parentCode": "01.2",
                "children": [
                  {
                    "code": "01.240",
                    "name": "Dyrking av kjernefrukter og steinfrukter",
                    "shortName": "Dyrking av kjerne- og steinfrukter",
                    "level": 5,
                    "parentCode": "01.24"
                  }
                ]
              },
              {
                "code": "01.25",
                "name": "Dyrking av annen frukt som vokser på trær eller busker samt nøtter",
                "shortName": "Dyrking av bær og nøtter mv.",
                "level": 4,
                "parentCode": "01.2",
                "children": [
                  {
                    "code": "01.250",
                    "name": "Dyrking av annen frukt som vokser på trær eller busker samt nøtter",
                    "shortName": "Dyrking av bær og nøtter mv.",
                    "level": 5,
                    "parentCode": "01.25"
                  }
                ]
              },
              {
                "code": "01.26",
                "name": "Dyrking av oljeholdige frukter",
                "shortName": "Dyrking av oljeholdige frukter",
                "level": 4,
                "parentCode": "01.2",
                "children": [
                  {
                    "code": "01.260",
                    "name": "Dyrking av oljeholdige frukter",
                    "shortName": "Dyrking av oljeholdige frukter",
                    "level": 5,
                    "parentCode": "01.26"
                  }
                ]
              },
              {
                "code": "01.27",
                "name": "Dyrking av vekster for produksjon av drikkevarer",
                "shortName": "Dyrk. vekster for prod. av drikkev.",
                "level": 4,
                "parentCode": "01.2",
                "children": [
                  {
                    "code": "01.270",
                    "name": "Dyrking av vekster for produksjon av drikkevarer",
                    "shortName": "Dyrk. vekster for prod. av drikkev.",
                    "level": 5,
                    "parentCode": "01.27"
                  }
                ]
              },
              {
                "code": "01.28",
                "name": "Dyrking av krydder og aromatiske, medisinske og farmasøytiske vekster",
                "shortName": "Dyrking av krydder mv.",
                "level": 4,
                "parentCode": "01.2",
                "children": [
                  {
                    "code": "01.280",
                    "name": "Dyrking av krydder og aromatiske, medisinske og farmasøytiske vekster",
                    "shortName": "Dyrking av krydder mv.",
                    "level": 5,
                    "parentCode": "01.28"
                  }
                ]
              },
              {
                "code": "01.29",
                "name": "Dyrking av flerårige vekster ellers",
                "shortName": "Dyrking av flerårige vekster ellers",
                "level": 4,
                "parentCode": "01.2",
                "children": [
                  {
                    "code": "01.290",
                    "name": "Dyrking av flerårige vekster ellers",
                    "shortName": "Dyrking av flerårige vekster ellers",
                    "level": 5,
                    "parentCode": "01.29"
                  }
                ]
              }
            ]
          },
          {
            "code": "01.3",
            "name": "Planteformering",
            "shortName": "Planteformering",
            "level": 3,
            "parentCode": "01",
            "children": [
              {
                "code": "01.30",
                "name": "Planteformering",
                "shortName": "Planteformering",
                "level": 4,
                "parentCode": "01.3",
                "children": [
                  {
                    "code": "01.300",
                    "name": "Planteformering",
                    "shortName": "Planteformering",
                    "level": 5,
                    "parentCode": "01.30"
                  }
                ]
              }
            ]
          },
          {
            "code": "01.4",
            "name": "Husdyrhold",
            "shortName": "Husdyrhold",
            "level": 3,
            "parentCode": "01",
            "children": [
              {
                "code": "01.41",
                "name": "Melkeproduksjon på storfe",
                "shortName": "Melkeproduksjon på storfe",
                "level": 4,
                "parentCode": "01.4",
                "children": [
                  {
                    "code": "01.410",
                    "name": "Melkeproduksjon på storfe",
                    "shortName": "Melkeproduksjon på storfe",
                    "level": 5,
                    "parentCode": "01.41"
                  }
                ]
              },
              {
                "code": "01.42",
                "name": "Oppdrett av annet storfe",
                "shortName": "Oppdrett av annet storfe",
                "level": 4,
                "parentCode": "01.4",
                "children": [
                  {
                    "code": "01.420",
                    "name": "Oppdrett av annet storfe",
                    "shortName": "Oppdrett av annet storfe",
                    "level": 5,
                    "parentCode": "01.42"
                  }
                ]
              },
              {
                "code": "01.43",
                "name": "Oppdrett av hester og andre dyr av hestefamilien",
                "shortName": "Oppdrett av hester, esler o.l.",
                "level": 4,
                "parentCode": "01.4",
                "children": [
                  {
                    "code": "01.430",
                    "name": "Oppdrett av hester og andre dyr av hestefamilien",
                    "shortName": "Oppdrett av hester, esler o.l.",
                    "level": 5,
                    "parentCode": "01.43"
                  }
                ]
              },
              {
                "code": "01.44",
                "name": "Oppdrett av kameler og andre kameldyr",
                "shortName": "Oppdrett av kameler og kameldyr el.",
                "level": 4,
                "parentCode": "01.4",
                "children": [
                  {
                    "code": "01.440",
                    "name": "Oppdrett av kameler og andre kameldyr",
                    "shortName": "Oppdrett av kameler og kameldyr el.",
                    "level": 5,
                    "parentCode": "01.44"
                  }
                ]
              },
              {
                "code": "01.45",
                "name": "Saue- og geitehold",
                "shortName": "Saue- og geitehold",
                "level": 4,
                "parentCode": "01.4",
                "children": [
                  {
                    "code": "01.451",
                    "name": "Sauehold",
                    "shortName": "Sauehold",
                    "level": 5,
                    "parentCode": "01.45"
                  },
                  {
                    "code": "01.452",
                    "name": "Geitehold",
                    "shortName": "Geitehold",
                    "level": 5,
                    "parentCode": "01.45"
                  }
                ]
              },
              {
                "code": "01.46",
                "name": "Svinehold",
                "shortName": "Svinehold",
                "level": 4,
                "parentCode": "01.4",
                "children": [
                  {
                    "code": "01.460",
                    "name": "Svinehold",
                    "shortName": "Svinehold",
                    "level": 5,
                    "parentCode": "01.46"
                  }
                ]
              },
              {
                "code": "01.47",
                "name": "Fjørfehold",
                "shortName": "Fjørfehold",
                "level": 4,
                "parentCode": "01.4",
                "children": [
                  {
                    "code": "01.471",
                    "name": "Hold av verpehøner for konsumeggproduksjon",
                    "shortName": "Verpehøner for konsumeggprod.",
                    "level": 5,
                    "parentCode": "01.47"
                  },
                  {
                    "code": "01.479",
                    "name": "Annet fjørfehold",
                    "shortName": "Annet fjørfehold",
                    "level": 5,
                    "parentCode": "01.47"
                  }
                ]
              },
              {
                "code": "01.49",
                "name": "Husdyrhold ellers",
                "shortName": "Husdyrhold ellers",
                "level": 4,
                "parentCode": "01.4",
                "children": [
                  {
                    "code": "01.490",
                    "name": "Husdyrhold ellers",
                    "shortName": "Husdyrhold ellers",
                    "level": 5,
                    "parentCode": "01.49"
                  }
                ]
              }
            ]
          },
          {
            "code": "01.5",
            "name": "Kombinert husdyrhold og planteproduksjon",
            "shortName": "Komb. husdyrhold og planteprod.",
            "level": 3,
            "parentCode": "01",
            "children": [
              {
                "code": "01.50",
                "name": "Kombinert husdyrhold og planteproduksjon",
                "shortName": "Komb. husdyrhold og planteprod.",
                "level": 4,
                "parentCode": "01.5",
                "children": [
                  {
                    "code": "01.500",
                    "name": "Kombinert husdyrhold og planteproduksjon",
                    "shortName": "Komb. husdyrhold og planteprod.",
                    "level": 5,
                    "parentCode": "01.50"
                  }
                ]
              }
            ]
          },
          {
            "code": "01.6",
            "name": "Tjenester tilknyttet jordbruk og etterbehandling av vekster etter innhøsting",
            "shortName": "Tjenester tilknyttet jordbruk",
            "level": 3,
            "parentCode": "01",
            "children": [
              {
                "code": "01.61",
                "name": "Tjenester tilknyttet planteproduksjon",
                "shortName": "Tjenester tilknyttet planteprod.",
                "level": 4,
                "parentCode": "01.6",
                "children": [
                  {
                    "code": "01.610",
                    "name": "Tjenester tilknyttet planteproduksjon",
                    "shortName": "Tjenester tilknyttet planteprod.",
                    "level": 5,
                    "parentCode": "01.61"
                  }
                ]
              },
              {
                "code": "01.62",
                "name": "Tjenester tilknyttet husdyrhold",
                "shortName": "Tjenester tilknyttet husdyrhold",
                "level": 4,
                "parentCode": "01.6",
                "children": [
                  {
                    "code": "01.620",
                    "name": "Tjenester tilknyttet husdyrhold",
                    "shortName": "Tjenester tilknyttet husdyrhold",
                    "level": 5,
                    "parentCode": "01.62"
                  }
                ]
              },
              {
                "code": "01.63",
                "name": "Etterbehandling av vekster etter innhøsting",
                "shortName": "Etterbeh. av vekster etter innhøst.",
                "level": 4,
                "parentCode": "01.6",
                "children": [
                  {
                    "code": "01.630",
                    "name": "Etterbehandling av vekster etter innhøsting",
                    "shortName": "Etterbeh. av vekster etter innhøst.",
                    "level": 5,
                    "parentCode": "01.63"
                  }
                ]
              },
              {
                "code": "01.64",
                "name": "Behandling av såfrø",
                "shortName": "Behandling av såfrø",
                "level": 4,
                "parentCode": "01.6",
                "children": [
                  {
                    "code": "01.640",
                    "name": "Behandling av såfrø",
                    "shortName": "Behandling av såfrø",
                    "level": 5,
                    "parentCode": "01.64"
                  }
                ]
              }
            ]
          },
          {
            "code": "01.7",
            "name": "Jakt, viltstell og tjenester tilknyttet jakt og viltstell",
            "shortName": "Jakt, viltstell og tilkn. tjenester",
            "level": 3,
            "parentCode": "01",
            "children": [
              {
                "code": "01.70",
                "name": "Jakt, viltstell og tjenester tilknyttet jakt og viltstell",
                "shortName": "Jakt, viltstell og tilkn. tjenester",
                "level": 4,
                "parentCode": "01.7",
                "children": [
                  {
                    "code": "01.700",
                    "name": "Jakt, viltstell og tjenester tilknyttet jakt og viltstell",
                    "shortName": "Jakt, viltstell og tilkn. tjenester",
                    "level": 5,
                    "parentCode": "01.70"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "02",
        "name": "Skogbruk og tjenester tilknyttet skogbruk",
        "shortName": "Skogbruk og tilhørende tjenester",
        "level": 2,
        "parentCode": "A",
        "children": [
          {
            "code": "02.1",
            "name": "Skogskjøtsel og andre skogbruksaktiviteter",
            "shortName": "Skogskjøtsel, andre skogbruksakt.",
            "level": 3,
            "parentCode": "02",
            "children": [
              {
                "code": "02.10",
                "name": "Skogskjøtsel og andre skogbruksaktiviteter",
                "shortName": "Skogskjøtsel, andre skogbruksakt.",
                "level": 4,
                "parentCode": "02.1",
                "children": [
                  {
                    "code": "02.100",
                    "name": "Skogskjøtsel og andre skogbruksaktiviteter",
                    "shortName": "Skogskjøtsel, andre skogbruksakt.",
                    "level": 5,
                    "parentCode": "02.10"
                  }
                ]
              }
            ]
          },
          {
            "code": "02.2",
            "name": "Avvirkning",
            "shortName": "Avvirkning",
            "level": 3,
            "parentCode": "02",
            "children": [
              {
                "code": "02.20",
                "name": "Avvirkning",
                "shortName": "Avvirkning",
                "level": 4,
                "parentCode": "02.2",
                "children": [
                  {
                    "code": "02.200",
                    "name": "Avvirkning",
                    "shortName": "Avvirkning",
                    "level": 5,
                    "parentCode": "02.20"
                  }
                ]
              }
            ]
          },
          {
            "code": "02.3",
            "name": "Innsamling av viltvoksende produkter av annet enn tre",
            "shortName": "Innsaml. av sopp, bær, mose etc.",
            "level": 3,
            "parentCode": "02",
            "children": [
              {
                "code": "02.30",
                "name": "Innsamling av viltvoksende produkter av annet enn tre",
                "shortName": "Innsaml. av sopp, bær, mose etc.",
                "level": 4,
                "parentCode": "02.3",
                "children": [
                  {
                    "code": "02.300",
                    "name": "Innsamling av viltvoksende produkter av annet enn tre",
                    "shortName": "Innsaml. av sopp, bær, mose etc.",
                    "level": 5,
                    "parentCode": "02.30"
                  }
                ]
              }
            ]
          },
          {
            "code": "02.4",
            "name": "Tjenester tilknyttet skogbruk",
            "shortName": "Tjenester tilknyttet skogbruk",
            "level": 3,
            "parentCode": "02",
            "children": [
              {
                "code": "02.40",
                "name": "Tjenester tilknyttet skogbruk",
                "shortName": "Tjenester tilknyttet skogbruk",
                "level": 4,
                "parentCode": "02.4",
                "children": [
                  {
                    "code": "02.400",
                    "name": "Tjenester tilknyttet skogbruk",
                    "shortName": "Tjenester tilknyttet skogbruk",
                    "level": 5,
                    "parentCode": "02.40"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "03",
        "name": "Fiske, fangst og akvakultur",
        "shortName": "Fiske, fangst og akvakultur",
        "level": 2,
        "parentCode": "A",
        "children": [
          {
            "code": "03.1",
            "name": "Fiske og fangst",
            "shortName": "Fiske og fangst",
            "level": 3,
            "parentCode": "03",
            "children": [
              {
                "code": "03.11",
                "name": "Hav- og kystfiske og fangst",
                "shortName": "Hav- og kystfiske og fangst",
                "level": 4,
                "parentCode": "03.1",
                "children": [
                  {
                    "code": "03.111",
                    "name": "Hav- og kystfiske",
                    "shortName": "Hav- og kystfiske",
                    "level": 5,
                    "parentCode": "03.11"
                  },
                  {
                    "code": "03.112",
                    "name": "Hvalfangst",
                    "shortName": "Hvalfangst",
                    "level": 5,
                    "parentCode": "03.11"
                  }
                ]
              },
              {
                "code": "03.12",
                "name": "Ferskvannsfiske",
                "shortName": "Ferskvannsfiske",
                "level": 4,
                "parentCode": "03.1",
                "children": [
                  {
                    "code": "03.120",
                    "name": "Ferskvannsfiske",
                    "shortName": "Ferskvannsfiske",
                    "level": 5,
                    "parentCode": "03.12"
                  }
                ]
              }
            ]
          },
          {
            "code": "03.2",
            "name": "Akvakultur",
            "shortName": "Akvakultur",
            "level": 3,
            "parentCode": "03",
            "children": [
              {
                "code": "03.21",
                "name": "Hav- og kystbasert akvakultur",
                "shortName": "Hav- og kystbasert akvakultur",
                "level": 4,
                "parentCode": "03.2",
                "children": [
                  {
                    "code": "03.211",
                    "name": "Produksjon av matfisk, bløtdyr, krepsdyr og pigghuder i hav- og kystbasert akvakultur",
                    "shortName": "Matfisk/krepsdyr mv. hav-/kystbas.",
                    "level": 5,
                    "parentCode": "03.21"
                  },
                  {
                    "code": "03.212",
                    "name": "Produksjon av yngel og settefisk i hav- og kystbasert akvakultur",
                    "shortName": "Yngel, settefisk hav-/kystbas.",
                    "level": 5,
                    "parentCode": "03.21"
                  },
                  {
                    "code": "03.213",
                    "name": "Tjenester tilknyttet hav- og kystbasert akvakultur",
                    "shortName": "Tjen. tilkn. hav-/kystbas. akvakult.",
                    "level": 5,
                    "parentCode": "03.21"
                  }
                ]
              },
              {
                "code": "03.22",
                "name": "Ferskvannsbasert akvakultur",
                "shortName": "Ferskvannsbasert akvakultur",
                "level": 4,
                "parentCode": "03.2",
                "children": [
                  {
                    "code": "03.221",
                    "name": "Produksjon av matfisk, bløtdyr og krepsdyr i ferskvannsbasert akvakultur",
                    "shortName": "Matfisk/krepsdyr mv. ferskvannsbas.",
                    "level": 5,
                    "parentCode": "03.22"
                  },
                  {
                    "code": "03.222",
                    "name": "Produksjon av yngel og settefisk i ferskvannsbasert akvakultur",
                    "shortName": "Yngel, settefisk ferskvannsbasert",
                    "level": 5,
                    "parentCode": "03.22"
                  },
                  {
                    "code": "03.223",
                    "name": "Tjenester tilknyttet ferskvannsbasert akvakultur",
                    "shortName": "Tjen. tilkn. ferskvannsbas. akvakult",
                    "level": 5,
                    "parentCode": "03.22"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "code": "B",
    "name": "Bergverksdrift og utvinning",
    "shortName": "Bergverksdrift og utvinning",
    "level": 1,
    "parentCode": "",
    "children": [
      {
        "code": "05",
        "name": "Bryting av steinkull og brunkull",
        "shortName": "Bryting av steinkull og brunkull",
        "level": 2,
        "parentCode": "B",
        "children": [
          {
            "code": "05.1",
            "name": "Bryting av steinkull",
            "shortName": "Bryting av steinkull",
            "level": 3,
            "parentCode": "05",
            "children": [
              {
                "code": "05.10",
                "name": "Bryting av steinkull",
                "shortName": "Bryting av steinkull",
                "level": 4,
                "parentCode": "05.1",
                "children": [
                  {
                    "code": "05.100",
                    "name": "Bryting av steinkull",
                    "shortName": "Bryting av steinkull",
                    "level": 5,
                    "parentCode": "05.10"
                  }
                ]
              }
            ]
          },
          {
            "code": "05.2",
            "name": "Bryting av brunkull",
            "shortName": "Bryting av brunkull",
            "level": 3,
            "parentCode": "05",
            "children": [
              {
                "code": "05.20",
                "name": "Bryting av brunkull",
                "shortName": "Bryting av brunkull",
                "level": 4,
                "parentCode": "05.2",
                "children": [
                  {
                    "code": "05.200",
                    "name": "Bryting av brunkull",
                    "shortName": "Bryting av brunkull",
                    "level": 5,
                    "parentCode": "05.20"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "06",
        "name": "Utvinning av råolje og naturgass",
        "shortName": "Utvinning av råolje og naturgass",
        "level": 2,
        "parentCode": "B",
        "children": [
          {
            "code": "06.1",
            "name": "Utvinning av råolje",
            "shortName": "Utvinning av råolje",
            "level": 3,
            "parentCode": "06",
            "children": [
              {
                "code": "06.10",
                "name": "Utvinning av råolje",
                "shortName": "Utvinning av råolje",
                "level": 4,
                "parentCode": "06.1",
                "children": [
                  {
                    "code": "06.100",
                    "name": "Utvinning av råolje",
                    "shortName": "Utvinning av råolje",
                    "level": 5,
                    "parentCode": "06.10"
                  }
                ]
              }
            ]
          },
          {
            "code": "06.2",
            "name": "Utvinning av naturgass",
            "shortName": "Utvinning av naturgass",
            "level": 3,
            "parentCode": "06",
            "children": [
              {
                "code": "06.20",
                "name": "Utvinning av naturgass",
                "shortName": "Utvinning av naturgass",
                "level": 4,
                "parentCode": "06.2",
                "children": [
                  {
                    "code": "06.200",
                    "name": "Utvinning av naturgass",
                    "shortName": "Utvinning av naturgass",
                    "level": 5,
                    "parentCode": "06.20"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "07",
        "name": "Bryting av metallholdig malm",
        "shortName": "Bryting av metallholdig malm",
        "level": 2,
        "parentCode": "B",
        "children": [
          {
            "code": "07.1",
            "name": "Bryting av jernmalm",
            "shortName": "Bryting av jernmalm",
            "level": 3,
            "parentCode": "07",
            "children": [
              {
                "code": "07.10",
                "name": "Bryting av jernmalm",
                "shortName": "Bryting av jernmalm",
                "level": 4,
                "parentCode": "07.1",
                "children": [
                  {
                    "code": "07.100",
                    "name": "Bryting av jernmalm",
                    "shortName": "Bryting av jernmalm",
                    "level": 5,
                    "parentCode": "07.10"
                  }
                ]
              }
            ]
          },
          {
            "code": "07.2",
            "name": "Bryting av ikke-jernholdig malm",
            "shortName": "Bryting av ikke-jernholdig malm",
            "level": 3,
            "parentCode": "07",
            "children": [
              {
                "code": "07.21",
                "name": "Bryting av uran- og thoriummalm",
                "shortName": "Bryting av uran- og thoriummalm",
                "level": 4,
                "parentCode": "07.2",
                "children": [
                  {
                    "code": "07.210",
                    "name": "Bryting av uran- og thoriummalm",
                    "shortName": "Bryting av uran- og thoriummalm",
                    "level": 5,
                    "parentCode": "07.21"
                  }
                ]
              },
              {
                "code": "07.29",
                "name": "Bryting av ikke-jernholdig malm ellers",
                "shortName": "Bryting av annen ikke-jernh. malm",
                "level": 4,
                "parentCode": "07.2",
                "children": [
                  {
                    "code": "07.290",
                    "name": "Bryting av ikke-jernholdig malm ellers",
                    "shortName": "Bryting av annen ikke-jernh. malm",
                    "level": 5,
                    "parentCode": "07.29"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "08",
        "name": "Bryting og bergverksdrift ellers",
        "shortName": "Bryting og bergverksdrift ellers",
        "level": 2,
        "parentCode": "B",
        "children": [
          {
            "code": "08.1",
            "name": "Bryting av stein, utvinning av sand og leire",
            "shortName": "Bryt. av stein, utv. av sand, leire",
            "level": 3,
            "parentCode": "08",
            "children": [
              {
                "code": "08.11",
                "name": "Bryting av stein til bygge- og anleggsvirksomhet, kalkstein, gips, kritt og skifer",
                "shortName": "Bryt. bygn.-/kalkstein/skifer mv.",
                "level": 4,
                "parentCode": "08.1",
                "children": [
                  {
                    "code": "08.111",
                    "name": "Bryting av stein til bygge- og anleggsvirksomhet",
                    "shortName": "Bryting stein til bygge- og anl.virks",
                    "level": 5,
                    "parentCode": "08.11"
                  },
                  {
                    "code": "08.112",
                    "name": "Bryting av kalkstein, gips og kritt",
                    "shortName": "Bryting av kalkstein, gips og kritt",
                    "level": 5,
                    "parentCode": "08.11"
                  },
                  {
                    "code": "08.113",
                    "name": "Bryting av skifer",
                    "shortName": "Bryting av skifer",
                    "level": 5,
                    "parentCode": "08.11"
                  }
                ]
              },
              {
                "code": "08.12",
                "name": "Utvinning fra grus- og sandtak, og utvinning av leire og kaolin",
                "shortName": "Utv. fra grus- og sandtak, leire mv.",
                "level": 4,
                "parentCode": "08.1",
                "children": [
                  {
                    "code": "08.120",
                    "name": "Utvinning fra grus- og sandtak, og utvinning av leire og kaolin",
                    "shortName": "Utv. fra grus- og sandtak, leire mv.",
                    "level": 5,
                    "parentCode": "08.12"
                  }
                ]
              }
            ]
          },
          {
            "code": "08.9",
            "name": "Annen bryting og utvinning",
            "shortName": "Annen bryting og utvinning",
            "level": 3,
            "parentCode": "08",
            "children": [
              {
                "code": "08.91",
                "name": "Bryting og utvinning av kjemiske mineraler og gjødselsmineraler",
                "shortName": "Utv. kjem. mineraler/gjødselsmin.",
                "level": 4,
                "parentCode": "08.9",
                "children": [
                  {
                    "code": "08.910",
                    "name": "Bryting og utvinning av kjemiske mineraler og gjødselsmineraler",
                    "shortName": "Utv. kjem. mineraler/gjødselsmin.",
                    "level": 5,
                    "parentCode": "08.91"
                  }
                ]
              },
              {
                "code": "08.92",
                "name": "Stikking av torv",
                "shortName": "Stikking av torv",
                "level": 4,
                "parentCode": "08.9",
                "children": [
                  {
                    "code": "08.920",
                    "name": "Stikking av torv",
                    "shortName": "Stikking av torv",
                    "level": 5,
                    "parentCode": "08.92"
                  }
                ]
              },
              {
                "code": "08.93",
                "name": "Utvinning av salt",
                "shortName": "Utvinning av salt",
                "level": 4,
                "parentCode": "08.9",
                "children": [
                  {
                    "code": "08.930",
                    "name": "Utvinning av salt",
                    "shortName": "Utvinning av salt",
                    "level": 5,
                    "parentCode": "08.93"
                  }
                ]
              },
              {
                "code": "08.99",
                "name": "Annen bryting og utvinning ikke nevnt annet sted",
                "shortName": "Annen bryting og utvinning",
                "level": 4,
                "parentCode": "08.9",
                "children": [
                  {
                    "code": "08.990",
                    "name": "Annen bryting og utvinning ikke nevnt annet sted",
                    "shortName": "Annen bryting og utvinning",
                    "level": 5,
                    "parentCode": "08.99"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "09",
        "name": "Tjenester tilknyttet bergverksdrift og utvinning",
        "shortName": "Tjenester til bergverk og utvinning",
        "level": 2,
        "parentCode": "B",
        "children": [
          {
            "code": "09.1",
            "name": "Tjenester tilknyttet utvinning av råolje og naturgass",
            "shortName": "Utvinningstjenester",
            "level": 3,
            "parentCode": "09",
            "children": [
              {
                "code": "09.10",
                "name": "Tjenester tilknyttet utvinning av råolje og naturgass",
                "shortName": "Utvinningstjenester",
                "level": 4,
                "parentCode": "09.1",
                "children": [
                  {
                    "code": "09.101",
                    "name": "Boretjenester tilknyttet utvinning av råolje og naturgass",
                    "shortName": "Boretj. tilkn. utv. råolje/naturgass",
                    "level": 5,
                    "parentCode": "09.10"
                  },
                  {
                    "code": "09.109",
                    "name": "Andre tjenester tilknyttet utvinning av råolje og naturgass",
                    "shortName": "Tjen. til utv. råolje/naturgass el.",
                    "level": 5,
                    "parentCode": "09.10"
                  }
                ]
              }
            ]
          },
          {
            "code": "09.9",
            "name": "Tjenester tilknyttet annen bergverksdrift",
            "shortName": "Bergverkstjenester",
            "level": 3,
            "parentCode": "09",
            "children": [
              {
                "code": "09.90",
                "name": "Tjenester tilknyttet annen bergverksdrift",
                "shortName": "Bergverkstjenester",
                "level": 4,
                "parentCode": "09.9",
                "children": [
                  {
                    "code": "09.900",
                    "name": "Tjenester tilknyttet annen bergverksdrift",
                    "shortName": "Bergverkstjenester",
                    "level": 5,
                    "parentCode": "09.90"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "code": "C",
    "name": "Industri",
    "shortName": "Industri",
    "level": 1,
    "parentCode": "",
    "children": [
      {
        "code": "10",
        "name": "Produksjon av nærings- og nytelsesmidler",
        "shortName": "Næringsmiddelindustri",
        "level": 2,
        "parentCode": "C",
        "children": [
          {
            "code": "10.1",
            "name": "Produksjon, bearbeiding og konservering av kjøtt og kjøttvarer",
            "shortName": "Bearbeiding kjøtt og kjøttvarer",
            "level": 3,
            "parentCode": "10",
            "children": [
              {
                "code": "10.11",
                "name": "Bearbeiding og konservering av kjøtt",
                "shortName": "Kjøttbearbeiding og konservering",
                "level": 4,
                "parentCode": "10.1",
                "children": [
                  {
                    "code": "10.110",
                    "name": "Bearbeiding og konservering av kjøtt",
                    "shortName": "Kjøttbearbeiding og konservering",
                    "level": 5,
                    "parentCode": "10.11"
                  }
                ]
              },
              {
                "code": "10.12",
                "name": "Bearbeiding og konservering av fjørfekjøtt",
                "shortName": "Fjørfekjøttbearb. og konservering",
                "level": 4,
                "parentCode": "10.1",
                "children": [
                  {
                    "code": "10.120",
                    "name": "Bearbeiding og konservering av fjørfekjøtt",
                    "shortName": "Fjørfekjøttbearb. og konservering",
                    "level": 5,
                    "parentCode": "10.12"
                  }
                ]
              },
              {
                "code": "10.13",
                "name": "Produksjon av kjøtt- og fjørfevarer",
                "shortName": "Kjøtt- og fjørfevareproduksjon",
                "level": 4,
                "parentCode": "10.1",
                "children": [
                  {
                    "code": "10.130",
                    "name": "Produksjon av kjøtt- og fjørfevarer",
                    "shortName": "Kjøtt- og fjørfevareproduksjon",
                    "level": 5,
                    "parentCode": "10.13"
                  }
                ]
              }
            ]
          },
          {
            "code": "10.2",
            "name": "Bearbeiding og konservering av fisk, skalldyr og bløtdyr",
            "shortName": "Bearbeiding fisk, skalldyr, bløtdyr",
            "level": 3,
            "parentCode": "10",
            "children": [
              {
                "code": "10.20",
                "name": "Bearbeiding og konservering av fisk, skalldyr og bløtdyr",
                "shortName": "Bearbeiding fisk, skalldyr, bløtdyr",
                "level": 4,
                "parentCode": "10.2",
                "children": [
                  {
                    "code": "10.201",
                    "name": "Produksjon av saltfisk, tørrfisk og klippfisk",
                    "shortName": "Salt-, tørr- og klippfiskproduksjon",
                    "level": 5,
                    "parentCode": "10.20"
                  },
                  {
                    "code": "10.202",
                    "name": "Frysing av fisk, fiskefileter, skalldyr og bløtdyr",
                    "shortName": "Frysing av fisk, fiskefileter mv.",
                    "level": 5,
                    "parentCode": "10.20"
                  },
                  {
                    "code": "10.203",
                    "name": "Produksjon av fiskehermetikk",
                    "shortName": "Fiskehermetikkproduksjon",
                    "level": 5,
                    "parentCode": "10.20"
                  },
                  {
                    "code": "10.209",
                    "name": "Slakting, bearbeiding og konservering av fisk og fiskevarer ellers",
                    "shortName": "Bearb. og konserv. av fisk/fiskev.",
                    "level": 5,
                    "parentCode": "10.20"
                  }
                ]
              }
            ]
          },
          {
            "code": "10.3",
            "name": "Bearbeiding og konservering av frukt og grønnsaker",
            "shortName": "Bearbeiding frukt og grønnsaker",
            "level": 3,
            "parentCode": "10",
            "children": [
              {
                "code": "10.31",
                "name": "Bearbeiding og konservering av poteter",
                "shortName": "Potetbearbeiding",
                "level": 4,
                "parentCode": "10.3",
                "children": [
                  {
                    "code": "10.310",
                    "name": "Bearbeiding og konservering av poteter",
                    "shortName": "Potetbearbeiding",
                    "level": 5,
                    "parentCode": "10.31"
                  }
                ]
              },
              {
                "code": "10.32",
                "name": "Produksjon av juice av frukt og grønnsaker",
                "shortName": "Frukt- og grønnsakjuiceproduksjon",
                "level": 4,
                "parentCode": "10.3",
                "children": [
                  {
                    "code": "10.320",
                    "name": "Produksjon av juice av frukt og grønnsaker",
                    "shortName": "Frukt- og grønnsakjuiceproduksjon",
                    "level": 5,
                    "parentCode": "10.32"
                  }
                ]
              },
              {
                "code": "10.39",
                "name": "Bearbeiding og konservering av frukt og grønnsaker ellers",
                "shortName": "Frukt- og grønnsakbearbeiding el.",
                "level": 4,
                "parentCode": "10.3",
                "children": [
                  {
                    "code": "10.390",
                    "name": "Bearbeiding og konservering av frukt og grønnsaker ellers",
                    "shortName": "Frukt- og grønnsakbearbeiding el.",
                    "level": 5,
                    "parentCode": "10.39"
                  }
                ]
              }
            ]
          },
          {
            "code": "10.4",
            "name": "Produksjon av vegetabilske og animalske oljer og fettstoffer",
            "shortName": "Produksjon oljer og fettstoff",
            "level": 3,
            "parentCode": "10",
            "children": [
              {
                "code": "10.41",
                "name": "Produksjon av oljer og fettstoffer",
                "shortName": "Prod. av oljer og fettstoffer",
                "level": 4,
                "parentCode": "10.4",
                "children": [
                  {
                    "code": "10.411",
                    "name": "Produksjon av rå fiskeoljer og fett",
                    "shortName": "Prod. av rå fiskeoljer og fett",
                    "level": 5,
                    "parentCode": "10.41"
                  },
                  {
                    "code": "10.412",
                    "name": "Produksjon av andre uraffinerte oljer og fett",
                    "shortName": "Prod. av andre uraff. oljer og fett",
                    "level": 5,
                    "parentCode": "10.41"
                  },
                  {
                    "code": "10.413",
                    "name": "Produksjon av raffinerte oljer og fett",
                    "shortName": "Raffinert olje- og fettproduksjon",
                    "level": 5,
                    "parentCode": "10.41"
                  }
                ]
              },
              {
                "code": "10.42",
                "name": "Produksjon av margarin og lignende spiselige fettstoffer",
                "shortName": "Margarinproduksjon m.m.",
                "level": 4,
                "parentCode": "10.4",
                "children": [
                  {
                    "code": "10.420",
                    "name": "Produksjon av margarin og lignende spiselige fettstoffer",
                    "shortName": "Margarinproduksjon m.m.",
                    "level": 5,
                    "parentCode": "10.42"
                  }
                ]
              }
            ]
          },
          {
            "code": "10.5",
            "name": "Produksjon av meierivarer og iskrem",
            "shortName": "Produksjon av meierivarer og iskrem",
            "level": 3,
            "parentCode": "10",
            "children": [
              {
                "code": "10.51",
                "name": "Produksjon av meierivarer",
                "shortName": "Meierivareproduksjon",
                "level": 4,
                "parentCode": "10.5",
                "children": [
                  {
                    "code": "10.510",
                    "name": "Produksjon av meierivarer",
                    "shortName": "Meierivareproduksjon",
                    "level": 5,
                    "parentCode": "10.51"
                  }
                ]
              },
              {
                "code": "10.52",
                "name": "Produksjon av iskrem",
                "shortName": "Iskremproduksjon",
                "level": 4,
                "parentCode": "10.5",
                "children": [
                  {
                    "code": "10.520",
                    "name": "Produksjon av iskrem",
                    "shortName": "Iskremproduksjon",
                    "level": 5,
                    "parentCode": "10.52"
                  }
                ]
              }
            ]
          },
          {
            "code": "10.6",
            "name": "Produksjon av kornvarer, stivelse og stivelsesprodukter",
            "shortName": "Produksjon kornvarer, stivelse mv.",
            "level": 3,
            "parentCode": "10",
            "children": [
              {
                "code": "10.61",
                "name": "Produksjon av kornvarer",
                "shortName": "Kornvareproduksjon",
                "level": 4,
                "parentCode": "10.6",
                "children": [
                  {
                    "code": "10.610",
                    "name": "Produksjon av kornvarer",
                    "shortName": "Kornvareproduksjon",
                    "level": 5,
                    "parentCode": "10.61"
                  }
                ]
              },
              {
                "code": "10.62",
                "name": "Produksjon av stivelse og stivelsesprodukter",
                "shortName": "Prod. av stivelse og stivelseprod.",
                "level": 4,
                "parentCode": "10.6",
                "children": [
                  {
                    "code": "10.620",
                    "name": "Produksjon av stivelse og stivelsesprodukter",
                    "shortName": "Prod. av stivelse og stivelseprod.",
                    "level": 5,
                    "parentCode": "10.62"
                  }
                ]
              }
            ]
          },
          {
            "code": "10.7",
            "name": "Produksjon av bakeri- og pastavarer",
            "shortName": "Produksjon av bakeri- og pastavarer",
            "level": 3,
            "parentCode": "10",
            "children": [
              {
                "code": "10.71",
                "name": "Produksjon av brød og ferske konditorvarer",
                "shortName": "Brød og ferske konditorvarer",
                "level": 4,
                "parentCode": "10.7",
                "children": [
                  {
                    "code": "10.710",
                    "name": "Produksjon av brød og ferske konditorvarer",
                    "shortName": "Brød og ferske konditorvarer",
                    "level": 5,
                    "parentCode": "10.71"
                  }
                ]
              },
              {
                "code": "10.72",
                "name": "Produksjon av kavringer, kjeks og konserverte konditorvarer",
                "shortName": "Kavring- og kjeksprod. mv.",
                "level": 4,
                "parentCode": "10.7",
                "children": [
                  {
                    "code": "10.720",
                    "name": "Produksjon av kavringer, kjeks og konserverte konditorvarer",
                    "shortName": "Kavring- og kjeksprod. mv.",
                    "level": 5,
                    "parentCode": "10.72"
                  }
                ]
              },
              {
                "code": "10.73",
                "name": "Produksjon av makaroni, nudler, couscous og lignende pastavarer",
                "shortName": "Pastavareproduksjon",
                "level": 4,
                "parentCode": "10.7",
                "children": [
                  {
                    "code": "10.730",
                    "name": "Produksjon av makaroni, nudler, couscous og lignende pastavarer",
                    "shortName": "Pastavareproduksjon",
                    "level": 5,
                    "parentCode": "10.73"
                  }
                ]
              }
            ]
          },
          {
            "code": "10.8",
            "name": "Produksjon av andre næringsmidler",
            "shortName": "Produksjon av andre næringsmidler",
            "level": 3,
            "parentCode": "10",
            "children": [
              {
                "code": "10.81",
                "name": "Produksjon av sukker",
                "shortName": "Sukkerproduksjon",
                "level": 4,
                "parentCode": "10.8",
                "children": [
                  {
                    "code": "10.810",
                    "name": "Produksjon av sukker",
                    "shortName": "Sukkerproduksjon",
                    "level": 5,
                    "parentCode": "10.81"
                  }
                ]
              },
              {
                "code": "10.82",
                "name": "Produksjon av kakao, sjokolade og sukkervarer",
                "shortName": "Kakao-, sjokolade- og sukkervareprod.",
                "level": 4,
                "parentCode": "10.8",
                "children": [
                  {
                    "code": "10.820",
                    "name": "Produksjon av kakao, sjokolade og sukkervarer",
                    "shortName": "Kakao-, sjokolade- og sukkervareprod.",
                    "level": 5,
                    "parentCode": "10.82"
                  }
                ]
              },
              {
                "code": "10.83",
                "name": "Bearbeiding av te og kaffe",
                "shortName": "Te- og kaffebearbeiding",
                "level": 4,
                "parentCode": "10.8",
                "children": [
                  {
                    "code": "10.830",
                    "name": "Bearbeiding av te og kaffe",
                    "shortName": "Te- og kaffebearbeiding",
                    "level": 5,
                    "parentCode": "10.83"
                  }
                ]
              },
              {
                "code": "10.84",
                "name": "Produksjon av smakstilsettingsstoffer og krydderier",
                "shortName": "Smakstilsettingsstoffer og krydder",
                "level": 4,
                "parentCode": "10.8",
                "children": [
                  {
                    "code": "10.840",
                    "name": "Produksjon av smakstilsettingsstoffer og krydderier",
                    "shortName": "Smakstilsettingsstoffer og krydder",
                    "level": 5,
                    "parentCode": "10.84"
                  }
                ]
              },
              {
                "code": "10.85",
                "name": "Produksjon av ferdigmat",
                "shortName": "Ferdigmatproduksjon",
                "level": 4,
                "parentCode": "10.8",
                "children": [
                  {
                    "code": "10.850",
                    "name": "Produksjon av ferdigmat",
                    "shortName": "Ferdigmatproduksjon",
                    "level": 5,
                    "parentCode": "10.85"
                  }
                ]
              },
              {
                "code": "10.86",
                "name": "Produksjon av homogeniserte matprodukter og diettmat",
                "shortName": "Diettmat og homogeniserte matprod.",
                "level": 4,
                "parentCode": "10.8",
                "children": [
                  {
                    "code": "10.860",
                    "name": "Produksjon av homogeniserte matprodukter og diettmat",
                    "shortName": "Diettmat og homogeniserte matprod.",
                    "level": 5,
                    "parentCode": "10.86"
                  }
                ]
              },
              {
                "code": "10.89",
                "name": "Produksjon av næringsmidler ikke nevnt annet sted",
                "shortName": "Produksjon av næringsmidler el.",
                "level": 4,
                "parentCode": "10.8",
                "children": [
                  {
                    "code": "10.890",
                    "name": "Produksjon av næringsmidler ikke nevnt annet sted",
                    "shortName": "Produksjon av næringsmidler el.",
                    "level": 5,
                    "parentCode": "10.89"
                  }
                ]
              }
            ]
          },
          {
            "code": "10.9",
            "name": "Produksjon av fôrvarer",
            "shortName": "Produksjon av fôrvarer",
            "level": 3,
            "parentCode": "10",
            "children": [
              {
                "code": "10.91",
                "name": "Produksjon av fôrvarer til husdyrhold",
                "shortName": "Fôrvareproduksjon til husdyr",
                "level": 4,
                "parentCode": "10.9",
                "children": [
                  {
                    "code": "10.910",
                    "name": "Produksjon av fôrvarer til husdyrhold",
                    "shortName": "Fôrvareproduksjon til husdyr",
                    "level": 5,
                    "parentCode": "10.91"
                  }
                ]
              },
              {
                "code": "10.92",
                "name": "Produksjon av fôrvarer til kjæledyr",
                "shortName": "Fôrvareproduksjon til kjæledyr",
                "level": 4,
                "parentCode": "10.9",
                "children": [
                  {
                    "code": "10.920",
                    "name": "Produksjon av fôrvarer til kjæledyr",
                    "shortName": "Fôrvareproduksjon til kjæledyr",
                    "level": 5,
                    "parentCode": "10.92"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "11",
        "name": "Produksjon av drikkevarer",
        "shortName": "Drikkevareindustri",
        "level": 2,
        "parentCode": "C",
        "children": [
          {
            "code": "11.0",
            "name": "Produksjon av drikkevarer",
            "shortName": "Produksjon av drikkevarer",
            "level": 3,
            "parentCode": "11",
            "children": [
              {
                "code": "11.01",
                "name": "Destillering, rektifisering og blanding av sprit",
                "shortName": "Destill. alkoholholdige drikkevarer",
                "level": 4,
                "parentCode": "11.0",
                "children": [
                  {
                    "code": "11.010",
                    "name": "Destillering, rektifisering og blanding av sprit",
                    "shortName": "Destill. alkoholholdige drikkevarer",
                    "level": 5,
                    "parentCode": "11.01"
                  }
                ]
              },
              {
                "code": "11.02",
                "name": "Produksjon av vin",
                "shortName": "Vinproduksjon",
                "level": 4,
                "parentCode": "11.0",
                "children": [
                  {
                    "code": "11.020",
                    "name": "Produksjon av vin",
                    "shortName": "Vinproduksjon",
                    "level": 5,
                    "parentCode": "11.02"
                  }
                ]
              },
              {
                "code": "11.03",
                "name": "Produksjon av sider og annen fruktvin",
                "shortName": "Sider- og annen fruktvinproduksjon",
                "level": 4,
                "parentCode": "11.0",
                "children": [
                  {
                    "code": "11.030",
                    "name": "Produksjon av sider og annen fruktvin",
                    "shortName": "Sider- og annen fruktvinproduksjon",
                    "level": 5,
                    "parentCode": "11.03"
                  }
                ]
              },
              {
                "code": "11.04",
                "name": "Produksjon av andre ikke-destillerte gjærede drikkevarer",
                "shortName": "Ikke-destill. gjærede drikkevarer",
                "level": 4,
                "parentCode": "11.0",
                "children": [
                  {
                    "code": "11.040",
                    "name": "Produksjon av andre ikke-destillerte gjærede drikkevarer",
                    "shortName": "Ikke-destill. gjærede drikkevarer",
                    "level": 5,
                    "parentCode": "11.04"
                  }
                ]
              },
              {
                "code": "11.05",
                "name": "Produksjon av øl",
                "shortName": "Ølproduksjon",
                "level": 4,
                "parentCode": "11.0",
                "children": [
                  {
                    "code": "11.050",
                    "name": "Produksjon av øl",
                    "shortName": "Ølproduksjon",
                    "level": 5,
                    "parentCode": "11.05"
                  }
                ]
              },
              {
                "code": "11.06",
                "name": "Produksjon av malt",
                "shortName": "Maltproduksjon",
                "level": 4,
                "parentCode": "11.0",
                "children": [
                  {
                    "code": "11.060",
                    "name": "Produksjon av malt",
                    "shortName": "Maltproduksjon",
                    "level": 5,
                    "parentCode": "11.06"
                  }
                ]
              },
              {
                "code": "11.07",
                "name": "Produksjon av mineralvann, leskedrikker og annet vann på flaske",
                "shortName": "Mineralvann- og leskedrikkproduksjon",
                "level": 4,
                "parentCode": "11.0",
                "children": [
                  {
                    "code": "11.070",
                    "name": "Produksjon av mineralvann, leskedrikker og annet vann på flaske",
                    "shortName": "Mineralvann- og leskedrikkproduksjon",
                    "level": 5,
                    "parentCode": "11.07"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "12",
        "name": "Produksjon av tobakksvarer",
        "shortName": "Tobakksindustri",
        "level": 2,
        "parentCode": "C",
        "children": [
          {
            "code": "12.0",
            "name": "Produksjon av tobakksvarer",
            "shortName": "Tobakksindustri",
            "level": 3,
            "parentCode": "12",
            "children": [
              {
                "code": "12.00",
                "name": "Produksjon av tobakksvarer",
                "shortName": "Tobakksindustri",
                "level": 4,
                "parentCode": "12.0",
                "children": [
                  {
                    "code": "12.000",
                    "name": "Produksjon av tobakksvarer",
                    "shortName": "Tobakksindustri",
                    "level": 5,
                    "parentCode": "12.00"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "13",
        "name": "Produksjon av tekstiler",
        "shortName": "Tekstilindustri",
        "level": 2,
        "parentCode": "C",
        "children": [
          {
            "code": "13.1",
            "name": "Bearbeiding og spinning av tekstilfibrer",
            "shortName": "Bearb./spinning av tekstilfibrer",
            "level": 3,
            "parentCode": "13",
            "children": [
              {
                "code": "13.10",
                "name": "Bearbeiding og spinning av tekstilfibrer",
                "shortName": "Bearb./spinning av tekstilfibrer",
                "level": 4,
                "parentCode": "13.1",
                "children": [
                  {
                    "code": "13.100",
                    "name": "Bearbeiding og spinning av tekstilfibrer",
                    "shortName": "Bearb./spinning av tekstilfibrer",
                    "level": 5,
                    "parentCode": "13.10"
                  }
                ]
              }
            ]
          },
          {
            "code": "13.2",
            "name": "Veving av tekstiler",
            "shortName": "Veving av tekstiler",
            "level": 3,
            "parentCode": "13",
            "children": [
              {
                "code": "13.20",
                "name": "Veving av tekstiler",
                "shortName": "Veving av tekstiler",
                "level": 4,
                "parentCode": "13.2",
                "children": [
                  {
                    "code": "13.200",
                    "name": "Veving av tekstiler",
                    "shortName": "Veving av tekstiler",
                    "level": 5,
                    "parentCode": "13.20"
                  }
                ]
              }
            ]
          },
          {
            "code": "13.3",
            "name": "Etterbehandling av tekstiler",
            "shortName": "Etterbehandling av tekstiler",
            "level": 3,
            "parentCode": "13",
            "children": [
              {
                "code": "13.30",
                "name": "Etterbehandling av tekstiler",
                "shortName": "Etterbehandling av tekstiler",
                "level": 4,
                "parentCode": "13.3",
                "children": [
                  {
                    "code": "13.300",
                    "name": "Etterbehandling av tekstiler",
                    "shortName": "Etterbehandling av tekstiler",
                    "level": 5,
                    "parentCode": "13.30"
                  }
                ]
              }
            ]
          },
          {
            "code": "13.9",
            "name": "Produksjon av andre tekstiler",
            "shortName": "Produksjon av andre tekstiler",
            "level": 3,
            "parentCode": "13",
            "children": [
              {
                "code": "13.91",
                "name": "Produksjon av stoffer av trikotasje",
                "shortName": "Trikotasjestoffproduksjon",
                "level": 4,
                "parentCode": "13.9",
                "children": [
                  {
                    "code": "13.910",
                    "name": "Produksjon av stoffer av trikotasje",
                    "shortName": "Trikotasjestoffproduksjon",
                    "level": 5,
                    "parentCode": "13.91"
                  }
                ]
              },
              {
                "code": "13.92",
                "name": "Produksjon av tekstilvarer, unntatt klær",
                "shortName": "Tekstilvareproduksjon, unntatt klær",
                "level": 4,
                "parentCode": "13.9",
                "children": [
                  {
                    "code": "13.921",
                    "name": "Produksjon av utstyrsvarer",
                    "shortName": "Utstyrsvareproduksjon",
                    "level": 5,
                    "parentCode": "13.92"
                  },
                  {
                    "code": "13.929",
                    "name": "Produksjon av andre tekstilvarer, unntatt klær",
                    "shortName": "Annen tekstilvareprod., unnt. klær",
                    "level": 5,
                    "parentCode": "13.92"
                  }
                ]
              },
              {
                "code": "13.93",
                "name": "Produksjon av gulvtepper, -matter og -ryer",
                "shortName": "Gulvteppe-, matte- og ryeproduksjon",
                "level": 4,
                "parentCode": "13.9",
                "children": [
                  {
                    "code": "13.930",
                    "name": "Produksjon av gulvtepper, -matter og -ryer",
                    "shortName": "Gulvteppe-, matte- og ryeproduksjon",
                    "level": 5,
                    "parentCode": "13.93"
                  }
                ]
              },
              {
                "code": "13.94",
                "name": "Produksjon av tauverk og nett",
                "shortName": "Tauverk- og nettproduksjon",
                "level": 4,
                "parentCode": "13.9",
                "children": [
                  {
                    "code": "13.940",
                    "name": "Produksjon av tauverk og nett",
                    "shortName": "Tauverk- og nettproduksjon",
                    "level": 5,
                    "parentCode": "13.94"
                  }
                ]
              },
              {
                "code": "13.95",
                "name": "Produksjon av ikke-vevde tekstiler og tekstilvarer, unntatt klær",
                "shortName": "Fiberproduksjon mv.",
                "level": 4,
                "parentCode": "13.9",
                "children": [
                  {
                    "code": "13.950",
                    "name": "Produksjon av ikke-vevde tekstiler og tekstilvarer, unntatt klær",
                    "shortName": "Fiberproduksjon mv.",
                    "level": 5,
                    "parentCode": "13.95"
                  }
                ]
              },
              {
                "code": "13.96",
                "name": "Produksjon av tekstiler til teknisk og industriell bruk",
                "shortName": "Tekstiler til tekn./industriell bruk",
                "level": 4,
                "parentCode": "13.9",
                "children": [
                  {
                    "code": "13.960",
                    "name": "Produksjon av tekstiler til teknisk og industriell bruk",
                    "shortName": "Tekstiler til tekn./industriell bruk",
                    "level": 5,
                    "parentCode": "13.96"
                  }
                ]
              },
              {
                "code": "13.99",
                "name": "Produksjon av tekstiler ikke nevnt annet sted",
                "shortName": "Tekstilproduksjon el.",
                "level": 4,
                "parentCode": "13.9",
                "children": [
                  {
                    "code": "13.990",
                    "name": "Produksjon av tekstiler ikke nevnt annet sted",
                    "shortName": "Tekstilproduksjon el.",
                    "level": 5,
                    "parentCode": "13.99"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "14",
        "name": "Produksjon av klær",
        "shortName": "Bekledningsindustri",
        "level": 2,
        "parentCode": "C",
        "children": [
          {
            "code": "14.1",
            "name": "Produksjon av klær, unntatt pelsvarer",
            "shortName": "Produksjon av klær, unnt. pelsvarer",
            "level": 3,
            "parentCode": "14",
            "children": [
              {
                "code": "14.11",
                "name": "Produksjon av klær av lær",
                "shortName": "Produksjon av klær av lær",
                "level": 4,
                "parentCode": "14.1",
                "children": [
                  {
                    "code": "14.110",
                    "name": "Produksjon av klær av lær",
                    "shortName": "Produksjon av klær av lær",
                    "level": 5,
                    "parentCode": "14.11"
                  }
                ]
              },
              {
                "code": "14.12",
                "name": "Produksjon av arbeidstøy",
                "shortName": "Arbeidstøyproduksjon",
                "level": 4,
                "parentCode": "14.1",
                "children": [
                  {
                    "code": "14.120",
                    "name": "Produksjon av arbeidstøy",
                    "shortName": "Arbeidstøyproduksjon",
                    "level": 5,
                    "parentCode": "14.12"
                  }
                ]
              },
              {
                "code": "14.13",
                "name": "Produksjon av annet yttertøy",
                "shortName": "Annen yttertøyproduksjon",
                "level": 4,
                "parentCode": "14.1",
                "children": [
                  {
                    "code": "14.130",
                    "name": "Produksjon av annet yttertøy",
                    "shortName": "Annen yttertøyproduksjon",
                    "level": 5,
                    "parentCode": "14.13"
                  }
                ]
              },
              {
                "code": "14.14",
                "name": "Produksjon av undertøy og innertøy",
                "shortName": "Undertøy- og innertøyproduksjon",
                "level": 4,
                "parentCode": "14.1",
                "children": [
                  {
                    "code": "14.140",
                    "name": "Produksjon av undertøy og innertøy",
                    "shortName": "Undertøy- og innertøyproduksjon",
                    "level": 5,
                    "parentCode": "14.14"
                  }
                ]
              },
              {
                "code": "14.19",
                "name": "Produksjon av klær og tilbehør ellers",
                "shortName": "Produksjon av klær og tilbehør el.",
                "level": 4,
                "parentCode": "14.1",
                "children": [
                  {
                    "code": "14.190",
                    "name": "Produksjon av klær og tilbehør ellers",
                    "shortName": "Produksjon av klær og tilbehør el.",
                    "level": 5,
                    "parentCode": "14.19"
                  }
                ]
              }
            ]
          },
          {
            "code": "14.2",
            "name": "Produksjon av pelsvarer",
            "shortName": "Produksjon av pelsvarer",
            "level": 3,
            "parentCode": "14",
            "children": [
              {
                "code": "14.20",
                "name": "Produksjon av pelsvarer",
                "shortName": "Produksjon av pelsvarer",
                "level": 4,
                "parentCode": "14.2",
                "children": [
                  {
                    "code": "14.200",
                    "name": "Produksjon av pelsvarer",
                    "shortName": "Produksjon av pelsvarer",
                    "level": 5,
                    "parentCode": "14.20"
                  }
                ]
              }
            ]
          },
          {
            "code": "14.3",
            "name": "Produksjon av klær av trikotasje",
            "shortName": "Prod. av klær av trikotasje",
            "level": 3,
            "parentCode": "14",
            "children": [
              {
                "code": "14.31",
                "name": "Produksjon av strømpevarer",
                "shortName": "Strømpevareproduksjon",
                "level": 4,
                "parentCode": "14.3",
                "children": [
                  {
                    "code": "14.310",
                    "name": "Produksjon av strømpevarer",
                    "shortName": "Strømpevareproduksjon",
                    "level": 5,
                    "parentCode": "14.31"
                  }
                ]
              },
              {
                "code": "14.39",
                "name": "Produksjon av andre klær av trikotasje",
                "shortName": "Prod. av klær av trikotasje el.",
                "level": 4,
                "parentCode": "14.3",
                "children": [
                  {
                    "code": "14.390",
                    "name": "Produksjon av andre klær av trikotasje",
                    "shortName": "Prod. av klær av trikotasje el.",
                    "level": 5,
                    "parentCode": "14.39"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "15",
        "name": "Produksjon av lær og lærvarer",
        "shortName": "Lær- og lærvareindustri",
        "level": 2,
        "parentCode": "C",
        "children": [
          {
            "code": "15.1",
            "name": "Beredning av lær, produksjon av reiseeffekter og salmakerartikler og beredning og farging av pelsskinn",
            "shortName": "Bered. lær, prod. av reiseeff. mv.",
            "level": 3,
            "parentCode": "15",
            "children": [
              {
                "code": "15.11",
                "name": "Beredning av lær, og beredning og farging av pelsskinn",
                "shortName": "Lærberedning",
                "level": 4,
                "parentCode": "15.1",
                "children": [
                  {
                    "code": "15.110",
                    "name": "Beredning av lær, og beredning og farging av pelsskinn",
                    "shortName": "Lærberedning",
                    "level": 5,
                    "parentCode": "15.11"
                  }
                ]
              },
              {
                "code": "15.12",
                "name": "Produksjon av reiseeffekter og salmakerartikler",
                "shortName": "Reiseeffekter og salmakerartikler",
                "level": 4,
                "parentCode": "15.1",
                "children": [
                  {
                    "code": "15.120",
                    "name": "Produksjon av reiseeffekter og salmakerartikler",
                    "shortName": "Reiseeffekter og salmakerartikler",
                    "level": 5,
                    "parentCode": "15.12"
                  }
                ]
              }
            ]
          },
          {
            "code": "15.2",
            "name": "Produksjon av skotøy",
            "shortName": "Produksjon av skotøy",
            "level": 3,
            "parentCode": "15",
            "children": [
              {
                "code": "15.20",
                "name": "Produksjon av skotøy",
                "shortName": "Produksjon av skotøy",
                "level": 4,
                "parentCode": "15.2",
                "children": [
                  {
                    "code": "15.200",
                    "name": "Produksjon av skotøy",
                    "shortName": "Produksjon av skotøy",
                    "level": 5,
                    "parentCode": "15.20"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "16",
        "name": "Produksjon av trelast og varer av tre, kork, strå og flettematerialer, unntatt møbler",
        "shortName": "Trelast- og trevareindustri",
        "level": 2,
        "parentCode": "C",
        "children": [
          {
            "code": "16.1",
            "name": "Saging, høvling og impregnering av tre",
            "shortName": "Saging, høvling mv. av tre",
            "level": 3,
            "parentCode": "16",
            "children": [
              {
                "code": "16.10",
                "name": "Saging, høvling og impregnering av tre",
                "shortName": "Saging, høvling mv. av tre",
                "level": 4,
                "parentCode": "16.1",
                "children": [
                  {
                    "code": "16.100",
                    "name": "Saging, høvling og impregnering av tre",
                    "shortName": "Saging, høvling mv. av tre",
                    "level": 5,
                    "parentCode": "16.10"
                  }
                ]
              }
            ]
          },
          {
            "code": "16.2",
            "name": "Produksjon av varer av tre, kork, strå og flettematerialer",
            "shortName": "Produksjon trevarer, kork mv.",
            "level": 3,
            "parentCode": "16",
            "children": [
              {
                "code": "16.21",
                "name": "Produksjon av finerplater og andre bygnings- og møbelplater av tre",
                "shortName": "Bygnings- og møbelplateproduksjon",
                "level": 4,
                "parentCode": "16.2",
                "children": [
                  {
                    "code": "16.210",
                    "name": "Produksjon av finerplater og andre bygnings- og møbelplater av tre",
                    "shortName": "Bygnings- og møbelplateproduksjon",
                    "level": 5,
                    "parentCode": "16.21"
                  }
                ]
              },
              {
                "code": "16.22",
                "name": "Produksjon av sammensatte parkettstaver",
                "shortName": "Sammensatte parkettstavprod.",
                "level": 4,
                "parentCode": "16.2",
                "children": [
                  {
                    "code": "16.220",
                    "name": "Produksjon av sammensatte parkettstaver",
                    "shortName": "Sammensatte parkettstavprod.",
                    "level": 5,
                    "parentCode": "16.22"
                  }
                ]
              },
              {
                "code": "16.23",
                "name": "Produksjon av andre bygningsartikler",
                "shortName": "Annen bygningsartikkelprod.",
                "level": 4,
                "parentCode": "16.2",
                "children": [
                  {
                    "code": "16.231",
                    "name": "Produksjon av monteringsferdige hus",
                    "shortName": "Ferdighusproduksjon",
                    "level": 5,
                    "parentCode": "16.23"
                  },
                  {
                    "code": "16.232",
                    "name": "Produksjon av bygningsartikler",
                    "shortName": "Bygningsartikkelproduksjon",
                    "level": 5,
                    "parentCode": "16.23"
                  }
                ]
              },
              {
                "code": "16.24",
                "name": "Produksjon av treemballasje",
                "shortName": "Treemballasjeproduksjon",
                "level": 4,
                "parentCode": "16.2",
                "children": [
                  {
                    "code": "16.240",
                    "name": "Produksjon av treemballasje",
                    "shortName": "Treemballasjeproduksjon",
                    "level": 5,
                    "parentCode": "16.24"
                  }
                ]
              },
              {
                "code": "16.29",
                "name": "Produksjon av andre trevarer og varer av kork, strå og flettematerialer",
                "shortName": "Andre tre-, kork-, stråvarer mv.",
                "level": 4,
                "parentCode": "16.2",
                "children": [
                  {
                    "code": "16.290",
                    "name": "Produksjon av andre trevarer og varer av kork, strå og flettematerialer",
                    "shortName": "Andre tre-, kork-, stråvarer mv.",
                    "level": 5,
                    "parentCode": "16.29"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "17",
        "name": "Produksjon av papir og papirvarer",
        "shortName": "Papir- og papirvareindustri",
        "level": 2,
        "parentCode": "C",
        "children": [
          {
            "code": "17.1",
            "name": "Produksjon av papirmasse, papir og papp",
            "shortName": "Prod. av papirmasse, papir og papp",
            "level": 3,
            "parentCode": "17",
            "children": [
              {
                "code": "17.11",
                "name": "Produksjon av papirmasse",
                "shortName": "Produksjon av papirmasse",
                "level": 4,
                "parentCode": "17.1",
                "children": [
                  {
                    "code": "17.110",
                    "name": "Produksjon av papirmasse",
                    "shortName": "Produksjon av papirmasse",
                    "level": 5,
                    "parentCode": "17.11"
                  }
                ]
              },
              {
                "code": "17.12",
                "name": "Produksjon av papir og papp",
                "shortName": "Produksjon av papir og papp",
                "level": 4,
                "parentCode": "17.1",
                "children": [
                  {
                    "code": "17.120",
                    "name": "Produksjon av papir og papp",
                    "shortName": "Produksjon av papir og papp",
                    "level": 5,
                    "parentCode": "17.12"
                  }
                ]
              }
            ]
          },
          {
            "code": "17.2",
            "name": "Produksjon av varer av papir og papp",
            "shortName": "Produksjon av varer av papir og papp",
            "level": 3,
            "parentCode": "17",
            "children": [
              {
                "code": "17.21",
                "name": "Produksjon av bølgepapp og emballasje av papir og papp",
                "shortName": "Bølgepapp, papir- og pappemballasje",
                "level": 4,
                "parentCode": "17.2",
                "children": [
                  {
                    "code": "17.210",
                    "name": "Produksjon av bølgepapp og emballasje av papir og papp",
                    "shortName": "Bølgepapp, papir- og pappemballasje",
                    "level": 5,
                    "parentCode": "17.21"
                  }
                ]
              },
              {
                "code": "17.22",
                "name": "Produksjon av husholdnings-, sanitær- og toalettartikler av papir",
                "shortName": "Hushold.-/toalettartikler av papir",
                "level": 4,
                "parentCode": "17.2",
                "children": [
                  {
                    "code": "17.220",
                    "name": "Produksjon av husholdnings-, sanitær- og toalettartikler av papir",
                    "shortName": "Hushold.-/toalettartikler av papir",
                    "level": 5,
                    "parentCode": "17.22"
                  }
                ]
              },
              {
                "code": "17.23",
                "name": "Produksjon av kontorartikler av papir",
                "shortName": "Prod. av kontorartikler av papir",
                "level": 4,
                "parentCode": "17.2",
                "children": [
                  {
                    "code": "17.230",
                    "name": "Produksjon av kontorartikler av papir",
                    "shortName": "Prod. av kontorartikler av papir",
                    "level": 5,
                    "parentCode": "17.23"
                  }
                ]
              },
              {
                "code": "17.24",
                "name": "Produksjon av tapeter",
                "shortName": "Tapetproduksjon",
                "level": 4,
                "parentCode": "17.2",
                "children": [
                  {
                    "code": "17.240",
                    "name": "Produksjon av tapeter",
                    "shortName": "Tapetproduksjon",
                    "level": 5,
                    "parentCode": "17.24"
                  }
                ]
              },
              {
                "code": "17.29",
                "name": "Produksjon av varer av papir og papp ellers",
                "shortName": "Papir- og pappvareproduksjon el.",
                "level": 4,
                "parentCode": "17.2",
                "children": [
                  {
                    "code": "17.290",
                    "name": "Produksjon av varer av papir og papp ellers",
                    "shortName": "Papir- og pappvareproduksjon el.",
                    "level": 5,
                    "parentCode": "17.29"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "18",
        "name": "Trykking og reproduksjon av innspilte opptak",
        "shortName": "Trykking, grafisk industri",
        "level": 2,
        "parentCode": "C",
        "children": [
          {
            "code": "18.1",
            "name": "Trykking og tjenester tilknyttet trykking",
            "shortName": "Trykking, tilhørende tjenester",
            "level": 3,
            "parentCode": "18",
            "children": [
              {
                "code": "18.11",
                "name": "Trykking av aviser",
                "shortName": "Trykking av aviser",
                "level": 4,
                "parentCode": "18.1",
                "children": [
                  {
                    "code": "18.110",
                    "name": "Trykking av aviser",
                    "shortName": "Trykking av aviser",
                    "level": 5,
                    "parentCode": "18.11"
                  }
                ]
              },
              {
                "code": "18.12",
                "name": "Trykking ellers",
                "shortName": "Trykking ellers",
                "level": 4,
                "parentCode": "18.1",
                "children": [
                  {
                    "code": "18.120",
                    "name": "Trykking ellers",
                    "shortName": "Trykking ellers",
                    "level": 5,
                    "parentCode": "18.12"
                  }
                ]
              },
              {
                "code": "18.13",
                "name": "Ferdiggjøring før trykking og publisering",
                "shortName": "Ferdiggjøring før trykking og publ.",
                "level": 4,
                "parentCode": "18.1",
                "children": [
                  {
                    "code": "18.130",
                    "name": "Ferdiggjøring før trykking og publisering",
                    "shortName": "Ferdiggjøring før trykking og publ.",
                    "level": 5,
                    "parentCode": "18.13"
                  }
                ]
              },
              {
                "code": "18.14",
                "name": "Bokbinding og tilknyttede tjenester",
                "shortName": "Bokbinding og tilkn. tjenester",
                "level": 4,
                "parentCode": "18.1",
                "children": [
                  {
                    "code": "18.140",
                    "name": "Bokbinding og tilknyttede tjenester",
                    "shortName": "Bokbinding og tilkn. tjenester",
                    "level": 5,
                    "parentCode": "18.14"
                  }
                ]
              }
            ]
          },
          {
            "code": "18.2",
            "name": "Reproduksjon av innspilte opptak",
            "shortName": "Reproduksjon av innspilte opptak",
            "level": 3,
            "parentCode": "18",
            "children": [
              {
                "code": "18.20",
                "name": "Reproduksjon av innspilte opptak",
                "shortName": "Reproduksjon av innspilte opptak",
                "level": 4,
                "parentCode": "18.2",
                "children": [
                  {
                    "code": "18.200",
                    "name": "Reproduksjon av innspilte opptak",
                    "shortName": "Reproduksjon av innspilte opptak",
                    "level": 5,
                    "parentCode": "18.20"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "19",
        "name": "Produksjon av kull- og raffinerte petroleumsprodukter",
        "shortName": "Petroleums- og kullvareindustri",
        "level": 2,
        "parentCode": "C",
        "children": [
          {
            "code": "19.1",
            "name": "Produksjon av kullprodukter",
            "shortName": "Produksjon av kullprodukter",
            "level": 3,
            "parentCode": "19",
            "children": [
              {
                "code": "19.10",
                "name": "Produksjon av kullprodukter",
                "shortName": "Produksjon av kullprodukter",
                "level": 4,
                "parentCode": "19.1",
                "children": [
                  {
                    "code": "19.100",
                    "name": "Produksjon av kullprodukter",
                    "shortName": "Produksjon av kullprodukter",
                    "level": 5,
                    "parentCode": "19.10"
                  }
                ]
              }
            ]
          },
          {
            "code": "19.2",
            "name": "Produksjon av raffinerte petroleumsprodukter",
            "shortName": "Prod. raffinerte petroleumsprodukt",
            "level": 3,
            "parentCode": "19",
            "children": [
              {
                "code": "19.20",
                "name": "Produksjon av raffinerte petroleumsprodukter",
                "shortName": "Prod. raffinerte petroleumsprodukt",
                "level": 4,
                "parentCode": "19.2",
                "children": [
                  {
                    "code": "19.200",
                    "name": "Produksjon av raffinerte petroleumsprodukter",
                    "shortName": "Prod. raffinerte petroleumsprodukt",
                    "level": 5,
                    "parentCode": "19.20"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "20",
        "name": "Produksjon av kjemikalier og kjemiske produkter",
        "shortName": "Kjemisk industri",
        "level": 2,
        "parentCode": "C",
        "children": [
          {
            "code": "20.1",
            "name": "Produksjon av kjemiske råvarer, gjødsel og nitrogenforbindelser, basisplast og syntetisk gummi",
            "shortName": "Produksjon kjemiske råvarer mv.",
            "level": 3,
            "parentCode": "20",
            "children": [
              {
                "code": "20.11",
                "name": "Produksjon av industrigasser",
                "shortName": "Industrigassproduksjon",
                "level": 4,
                "parentCode": "20.1",
                "children": [
                  {
                    "code": "20.110",
                    "name": "Produksjon av industrigasser",
                    "shortName": "Industrigassproduksjon",
                    "level": 5,
                    "parentCode": "20.11"
                  }
                ]
              },
              {
                "code": "20.12",
                "name": "Produksjon av fargestoffer og pigmenter",
                "shortName": "Fargestoff- og pigmentproduksjon",
                "level": 4,
                "parentCode": "20.1",
                "children": [
                  {
                    "code": "20.120",
                    "name": "Produksjon av fargestoffer og pigmenter",
                    "shortName": "Fargestoff- og pigmentproduksjon",
                    "level": 5,
                    "parentCode": "20.12"
                  }
                ]
              },
              {
                "code": "20.13",
                "name": "Produksjon av andre uorganiske kjemikalier",
                "shortName": "Uorganisk kjemikalieproduksjon el.",
                "level": 4,
                "parentCode": "20.1",
                "children": [
                  {
                    "code": "20.130",
                    "name": "Produksjon av andre uorganiske kjemikalier",
                    "shortName": "Uorganisk kjemikalieproduksjon el.",
                    "level": 5,
                    "parentCode": "20.13"
                  }
                ]
              },
              {
                "code": "20.14",
                "name": "Produksjon av andre organiske kjemiske råvarer",
                "shortName": "Annen org. kjemisk råvareproduksjon",
                "level": 4,
                "parentCode": "20.1",
                "children": [
                  {
                    "code": "20.140",
                    "name": "Produksjon av andre organiske kjemiske råvarer",
                    "shortName": "Annen org. kjemisk råvareproduksjon",
                    "level": 5,
                    "parentCode": "20.14"
                  }
                ]
              },
              {
                "code": "20.15",
                "name": "Produksjon av gjødsel, nitrogenforbindelser og vekstjord",
                "shortName": "Gjødselproduksjon mv.",
                "level": 4,
                "parentCode": "20.1",
                "children": [
                  {
                    "code": "20.150",
                    "name": "Produksjon av gjødsel, nitrogenforbindelser og vekstjord",
                    "shortName": "Gjødselproduksjon mv.",
                    "level": 5,
                    "parentCode": "20.15"
                  }
                ]
              },
              {
                "code": "20.16",
                "name": "Produksjon av basisplast",
                "shortName": "Basisplastproduksjon",
                "level": 4,
                "parentCode": "20.1",
                "children": [
                  {
                    "code": "20.160",
                    "name": "Produksjon av basisplast",
                    "shortName": "Basisplastproduksjon",
                    "level": 5,
                    "parentCode": "20.16"
                  }
                ]
              },
              {
                "code": "20.17",
                "name": "Produksjon av syntetisk gummi",
                "shortName": "Produksjon av syntetisk gummi",
                "level": 4,
                "parentCode": "20.1",
                "children": [
                  {
                    "code": "20.170",
                    "name": "Produksjon av syntetisk gummi",
                    "shortName": "Produksjon av syntetisk gummi",
                    "level": 5,
                    "parentCode": "20.17"
                  }
                ]
              }
            ]
          },
          {
            "code": "20.2",
            "name": "Produksjon av plantevern- og skadedyrmidler og andre landbrukskjemiske produkter",
            "shortName": "Produksjon landbrukskjemiske prod.",
            "level": 3,
            "parentCode": "20",
            "children": [
              {
                "code": "20.20",
                "name": "Produksjon av plantevern- og skadedyrmidler og andre landbrukskjemiske produkter",
                "shortName": "Produksjon landbrukskjemiske prod.",
                "level": 4,
                "parentCode": "20.2",
                "children": [
                  {
                    "code": "20.200",
                    "name": "Produksjon av plantevern- og skadedyrmidler og andre landbrukskjemiske produkter",
                    "shortName": "Produksjon landbrukskjemiske prod.",
                    "level": 5,
                    "parentCode": "20.20"
                  }
                ]
              }
            ]
          },
          {
            "code": "20.3",
            "name": "Produksjon av maling og lakk, trykkfarger og tetningsmidler",
            "shortName": "Produksjon maling, lakk mv.",
            "level": 3,
            "parentCode": "20",
            "children": [
              {
                "code": "20.30",
                "name": "Produksjon av maling og lakk, trykkfarger og tetningsmidler",
                "shortName": "Produksjon maling, lakk mv.",
                "level": 4,
                "parentCode": "20.3",
                "children": [
                  {
                    "code": "20.300",
                    "name": "Produksjon av maling og lakk, trykkfarger og tetningsmidler",
                    "shortName": "Produksjon maling, lakk mv.",
                    "level": 5,
                    "parentCode": "20.30"
                  }
                ]
              }
            ]
          },
          {
            "code": "20.4",
            "name": "Produksjon av såpe og vaskemidler, rense- og polermidler, parfyme og toalettartikler",
            "shortName": "Produksjon vaske- og toalettartikler",
            "level": 3,
            "parentCode": "20",
            "children": [
              {
                "code": "20.41",
                "name": "Produksjon av såpe og vaskemidler, rense- og polermidler",
                "shortName": "Såpe- og vaskemiddelprod. mv.",
                "level": 4,
                "parentCode": "20.4",
                "children": [
                  {
                    "code": "20.410",
                    "name": "Produksjon av såpe og vaskemidler, rense- og polermidler",
                    "shortName": "Såpe- og vaskemiddelprod. mv.",
                    "level": 5,
                    "parentCode": "20.41"
                  }
                ]
              },
              {
                "code": "20.42",
                "name": "Produksjon av parfyme og toalettartikler",
                "shortName": "Parfyme og toalettartikler",
                "level": 4,
                "parentCode": "20.4",
                "children": [
                  {
                    "code": "20.420",
                    "name": "Produksjon av parfyme og toalettartikler",
                    "shortName": "Parfyme og toalettartikler",
                    "level": 5,
                    "parentCode": "20.42"
                  }
                ]
              }
            ]
          },
          {
            "code": "20.5",
            "name": "Produksjon av andre kjemiske produkter",
            "shortName": "Produksjon andre kjemiske prod.",
            "level": 3,
            "parentCode": "20",
            "children": [
              {
                "code": "20.51",
                "name": "Produksjon av eksplosiver",
                "shortName": "Produksjon av eksplosiver",
                "level": 4,
                "parentCode": "20.5",
                "children": [
                  {
                    "code": "20.510",
                    "name": "Produksjon av eksplosiver",
                    "shortName": "Produksjon av eksplosiver",
                    "level": 5,
                    "parentCode": "20.51"
                  }
                ]
              },
              {
                "code": "20.52",
                "name": "Produksjon av lim",
                "shortName": "Limproduksjon",
                "level": 4,
                "parentCode": "20.5",
                "children": [
                  {
                    "code": "20.520",
                    "name": "Produksjon av lim",
                    "shortName": "Limproduksjon",
                    "level": 5,
                    "parentCode": "20.52"
                  }
                ]
              },
              {
                "code": "20.53",
                "name": "Produksjon av eteriske oljer",
                "shortName": "Produksjon av eteriske oljer",
                "level": 4,
                "parentCode": "20.5",
                "children": [
                  {
                    "code": "20.530",
                    "name": "Produksjon av eteriske oljer",
                    "shortName": "Produksjon av eteriske oljer",
                    "level": 5,
                    "parentCode": "20.53"
                  }
                ]
              },
              {
                "code": "20.59",
                "name": "Produksjon av kjemiske produkter ikke nevnt annet sted",
                "shortName": "Annen kjemisk produksjon",
                "level": 4,
                "parentCode": "20.5",
                "children": [
                  {
                    "code": "20.590",
                    "name": "Produksjon av kjemiske produkter ikke nevnt annet sted",
                    "shortName": "Annen kjemisk produksjon",
                    "level": 5,
                    "parentCode": "20.59"
                  }
                ]
              }
            ]
          },
          {
            "code": "20.6",
            "name": "Produksjon av kunstfibrer",
            "shortName": "Produksjon av kunstfibrer",
            "level": 3,
            "parentCode": "20",
            "children": [
              {
                "code": "20.60",
                "name": "Produksjon av kunstfibrer",
                "shortName": "Produksjon av kunstfibrer",
                "level": 4,
                "parentCode": "20.6",
                "children": [
                  {
                    "code": "20.600",
                    "name": "Produksjon av kunstfibrer",
                    "shortName": "Produksjon av kunstfibrer",
                    "level": 5,
                    "parentCode": "20.60"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "21",
        "name": "Produksjon av farmasøytiske råvarer og preparater",
        "shortName": "Farmasøytisk industri",
        "level": 2,
        "parentCode": "C",
        "children": [
          {
            "code": "21.1",
            "name": "Produksjon av farmasøytiske råvarer",
            "shortName": "Farmasøytiske råvarer",
            "level": 3,
            "parentCode": "21",
            "children": [
              {
                "code": "21.10",
                "name": "Produksjon av farmasøytiske råvarer",
                "shortName": "Farmasøytiske råvarer",
                "level": 4,
                "parentCode": "21.1",
                "children": [
                  {
                    "code": "21.100",
                    "name": "Produksjon av farmasøytiske råvarer",
                    "shortName": "Farmasøytiske råvarer",
                    "level": 5,
                    "parentCode": "21.10"
                  }
                ]
              }
            ]
          },
          {
            "code": "21.2",
            "name": "Produksjon av farmasøytiske preparater",
            "shortName": "Farmasøytiske preparater",
            "level": 3,
            "parentCode": "21",
            "children": [
              {
                "code": "21.20",
                "name": "Produksjon av farmasøytiske preparater",
                "shortName": "Farmasøytiske preparater",
                "level": 4,
                "parentCode": "21.2",
                "children": [
                  {
                    "code": "21.200",
                    "name": "Produksjon av farmasøytiske preparater",
                    "shortName": "Farmasøytiske preparater",
                    "level": 5,
                    "parentCode": "21.20"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "22",
        "name": "Produksjon av gummi- og plastprodukter",
        "shortName": "Gummivare- og plastindustri",
        "level": 2,
        "parentCode": "C",
        "children": [
          {
            "code": "22.1",
            "name": "Produksjon av gummiprodukter",
            "shortName": "Produksjon av gummiprodukter",
            "level": 3,
            "parentCode": "22",
            "children": [
              {
                "code": "22.11",
                "name": "Produksjon av gummidekk og slanger til gummidekk, og regummiering og vulkanisering av gummidekk",
                "shortName": "Gummidekkprod., -regumm. og -vulk.",
                "level": 4,
                "parentCode": "22.1",
                "children": [
                  {
                    "code": "22.110",
                    "name": "Produksjon av gummidekk og slanger til gummidekk, og regummiering og vulkanisering av gummidekk",
                    "shortName": "Gummidekkprod., -regumm. og -vulk",
                    "level": 5,
                    "parentCode": "22.11"
                  }
                ]
              },
              {
                "code": "22.19",
                "name": "Produksjon av gummiprodukter ellers",
                "shortName": "Produksjon av gummiprodukter el.",
                "level": 4,
                "parentCode": "22.1",
                "children": [
                  {
                    "code": "22.190",
                    "name": "Produksjon av gummiprodukter ellers",
                    "shortName": "Produksjon av gummiprodukter el.",
                    "level": 5,
                    "parentCode": "22.19"
                  }
                ]
              }
            ]
          },
          {
            "code": "22.2",
            "name": "Produksjon av plastprodukter",
            "shortName": "Produksjon av plastprodukter",
            "level": 3,
            "parentCode": "22",
            "children": [
              {
                "code": "22.21",
                "name": "Produksjon av halvfabrikater av plast",
                "shortName": "Prod. av halvfabrikater av plast",
                "level": 4,
                "parentCode": "22.2",
                "children": [
                  {
                    "code": "22.210",
                    "name": "Produksjon av halvfabrikater av plast",
                    "shortName": "Prod. av halvfabrikater av plast",
                    "level": 5,
                    "parentCode": "22.21"
                  }
                ]
              },
              {
                "code": "22.22",
                "name": "Produksjon av plastemballasje",
                "shortName": "Plastemballasjeproduksjon",
                "level": 4,
                "parentCode": "22.2",
                "children": [
                  {
                    "code": "22.220",
                    "name": "Produksjon av plastemballasje",
                    "shortName": "Plastemballasjeproduksjon",
                    "level": 5,
                    "parentCode": "22.22"
                  }
                ]
              },
              {
                "code": "22.23",
                "name": "Produksjon av byggevarer av plast",
                "shortName": "Byggevareprod. av plast",
                "level": 4,
                "parentCode": "22.2",
                "children": [
                  {
                    "code": "22.230",
                    "name": "Produksjon av byggevarer av plast",
                    "shortName": "Byggevareprod. av plast",
                    "level": 5,
                    "parentCode": "22.23"
                  }
                ]
              },
              {
                "code": "22.29",
                "name": "Produksjon av plastprodukter ellers",
                "shortName": "Prod. av plastprodukter el.",
                "level": 4,
                "parentCode": "22.2",
                "children": [
                  {
                    "code": "22.290",
                    "name": "Produksjon av plastprodukter ellers",
                    "shortName": "Prod. av plastprodukter el.",
                    "level": 5,
                    "parentCode": "22.29"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "23",
        "name": "Produksjon av andre ikke-metallholdige mineralprodukter",
        "shortName": "Mineralproduktindustri",
        "level": 2,
        "parentCode": "C",
        "children": [
          {
            "code": "23.1",
            "name": "Produksjon av glass og glassprodukter",
            "shortName": "Produksjon av glass og glassprodukter",
            "level": 3,
            "parentCode": "23",
            "children": [
              {
                "code": "23.11",
                "name": "Produksjon av planglass",
                "shortName": "Planglassproduksjon",
                "level": 4,
                "parentCode": "23.1",
                "children": [
                  {
                    "code": "23.110",
                    "name": "Produksjon av planglass",
                    "shortName": "Planglassproduksjon",
                    "level": 5,
                    "parentCode": "23.11"
                  }
                ]
              },
              {
                "code": "23.12",
                "name": "Bearbeiding av planglass",
                "shortName": "Planglassbearbeiding",
                "level": 4,
                "parentCode": "23.1",
                "children": [
                  {
                    "code": "23.120",
                    "name": "Bearbeiding av planglass",
                    "shortName": "Planglassbearbeiding",
                    "level": 5,
                    "parentCode": "23.12"
                  }
                ]
              },
              {
                "code": "23.13",
                "name": "Produksjon av emballasje og husholdningsartikler av glass og krystall",
                "shortName": "Emb. og hush.art. av glass/krystall",
                "level": 4,
                "parentCode": "23.1",
                "children": [
                  {
                    "code": "23.130",
                    "name": "Produksjon av emballasje og husholdningsartikler av glass og krystall",
                    "shortName": "Emb. og hush.art. av glass/krystall",
                    "level": 5,
                    "parentCode": "23.13"
                  }
                ]
              },
              {
                "code": "23.14",
                "name": "Produksjon av glassfibrer",
                "shortName": "Glassfiberproduksjon",
                "level": 4,
                "parentCode": "23.1",
                "children": [
                  {
                    "code": "23.140",
                    "name": "Produksjon av glassfibrer",
                    "shortName": "Glassfiberproduksjon",
                    "level": 5,
                    "parentCode": "23.14"
                  }
                ]
              },
              {
                "code": "23.19",
                "name": "Produksjon av teknisk glass og andre glassvarer",
                "shortName": "Tekn. glass- og annen glassvareprod.",
                "level": 4,
                "parentCode": "23.1",
                "children": [
                  {
                    "code": "23.190",
                    "name": "Produksjon av teknisk glass og andre glassvarer",
                    "shortName": "Tekn. glass- og annen glassvareprod.",
                    "level": 5,
                    "parentCode": "23.19"
                  }
                ]
              }
            ]
          },
          {
            "code": "23.2",
            "name": "Produksjon av ildfaste produkter",
            "shortName": "Prod. av ildfaste produkter",
            "level": 3,
            "parentCode": "23",
            "children": [
              {
                "code": "23.20",
                "name": "Produksjon av ildfaste produkter",
                "shortName": "Prod. av ildfaste produkter",
                "level": 4,
                "parentCode": "23.2",
                "children": [
                  {
                    "code": "23.200",
                    "name": "Produksjon av ildfaste produkter",
                    "shortName": "Prod. av ildfaste produkter",
                    "level": 5,
                    "parentCode": "23.20"
                  }
                ]
              }
            ]
          },
          {
            "code": "23.3",
            "name": "Produksjon av byggevarer av brent leire",
            "shortName": "Prod. av byggevarer av brent leire",
            "level": 3,
            "parentCode": "23",
            "children": [
              {
                "code": "23.31",
                "name": "Produksjon av keramiske vegg- og gulvfliser",
                "shortName": "Keramisk byggematerialproduksjon",
                "level": 4,
                "parentCode": "23.3",
                "children": [
                  {
                    "code": "23.310",
                    "name": "Produksjon av keramiske vegg- og gulvfliser",
                    "shortName": "Keramisk byggematerialproduksjon",
                    "level": 5,
                    "parentCode": "23.31"
                  }
                ]
              },
              {
                "code": "23.32",
                "name": "Produksjon av murstein, teglstein og andre byggevarer av brent leire",
                "shortName": "Mur-, teglstein- o.a. byggevareprod.",
                "level": 4,
                "parentCode": "23.3",
                "children": [
                  {
                    "code": "23.320",
                    "name": "Produksjon av murstein, teglstein og andre byggevarer av brent leire",
                    "shortName": "Mur-, teglstein- o.a. byggevareprod.",
                    "level": 5,
                    "parentCode": "23.32"
                  }
                ]
              }
            ]
          },
          {
            "code": "23.4",
            "name": "Produksjon av andre porselensprodukter og keramiske produkter",
            "shortName": "Prod. av porselens-/keram.prod. el.",
            "level": 3,
            "parentCode": "23",
            "children": [
              {
                "code": "23.41",
                "name": "Produksjon av keramiske husholdningsartikler og dekorasjonsgjenstander",
                "shortName": "Keramiske husholdningsartikler mv.",
                "level": 4,
                "parentCode": "23.4",
                "children": [
                  {
                    "code": "23.410",
                    "name": "Produksjon av keramiske husholdningsartikler og dekorasjonsgjenstander",
                    "shortName": "Keramiske husholdningsartikler mv.",
                    "level": 5,
                    "parentCode": "23.41"
                  }
                ]
              },
              {
                "code": "23.42",
                "name": "Produksjon av sanitærutstyr av keramisk materiale",
                "shortName": "Prod. av keramisk sanitærutstyr",
                "level": 4,
                "parentCode": "23.4",
                "children": [
                  {
                    "code": "23.420",
                    "name": "Produksjon av sanitærutstyr av keramisk materiale",
                    "shortName": "Prod. av keramisk sanitærutstyr",
                    "level": 5,
                    "parentCode": "23.42"
                  }
                ]
              },
              {
                "code": "23.43",
                "name": "Produksjon av isolatorer og isoleringsdeler av keramisk materiale",
                "shortName": "Prod. av keramiske isoleringsdeler",
                "level": 4,
                "parentCode": "23.4",
                "children": [
                  {
                    "code": "23.430",
                    "name": "Produksjon av isolatorer og isoleringsdeler av keramisk materiale",
                    "shortName": "Prod. av keramiske isoleringsdeler",
                    "level": 5,
                    "parentCode": "23.43"
                  }
                ]
              },
              {
                "code": "23.44",
                "name": "Produksjon av andre keramiske produkter for teknisk bruk",
                "shortName": "Prod. av keram. prod. for tekn. bruk",
                "level": 4,
                "parentCode": "23.4",
                "children": [
                  {
                    "code": "23.440",
                    "name": "Produksjon av andre keramiske produkter for teknisk bruk",
                    "shortName": "Prod. av keram. prod. for tekn. bruk",
                    "level": 5,
                    "parentCode": "23.44"
                  }
                ]
              },
              {
                "code": "23.49",
                "name": "Produksjon av andre keramiske produkter",
                "shortName": "Prod. av andre keramiske prod.",
                "level": 4,
                "parentCode": "23.4",
                "children": [
                  {
                    "code": "23.490",
                    "name": "Produksjon av andre keramiske produkter",
                    "shortName": "Prod. av andre keram. prod.",
                    "level": 5,
                    "parentCode": "23.49"
                  }
                ]
              }
            ]
          },
          {
            "code": "23.5",
            "name": "Produksjon av sement, kalk og gips",
            "shortName": "Produksjon av sement, kalk og gips",
            "level": 3,
            "parentCode": "23",
            "children": [
              {
                "code": "23.51",
                "name": "Produksjon av sement",
                "shortName": "Sementproduksjon",
                "level": 4,
                "parentCode": "23.5",
                "children": [
                  {
                    "code": "23.510",
                    "name": "Produksjon av sement",
                    "shortName": "Sementproduksjon",
                    "level": 5,
                    "parentCode": "23.51"
                  }
                ]
              },
              {
                "code": "23.52",
                "name": "Produksjon av kalk og gips",
                "shortName": "Kalk- og gipsproduksjon",
                "level": 4,
                "parentCode": "23.5",
                "children": [
                  {
                    "code": "23.520",
                    "name": "Produksjon av kalk og gips",
                    "shortName": "Kalk- og gipsproduksjon",
                    "level": 5,
                    "parentCode": "23.52"
                  }
                ]
              }
            ]
          },
          {
            "code": "23.6",
            "name": "Produksjon av betong-, sement- og gipsprodukter",
            "shortName": "Prod. av betong-/sement-/gipsprod.",
            "level": 3,
            "parentCode": "23",
            "children": [
              {
                "code": "23.61",
                "name": "Produksjon av betongprodukter for bygge- og anleggsvirksomhet",
                "shortName": "Betongprodukter for bygg og anlegg",
                "level": 4,
                "parentCode": "23.6",
                "children": [
                  {
                    "code": "23.610",
                    "name": "Produksjon av betongprodukter for bygge- og anleggsvirksomhet",
                    "shortName": "Betongprodukter for bygg og anlegg",
                    "level": 5,
                    "parentCode": "23.61"
                  }
                ]
              },
              {
                "code": "23.62",
                "name": "Produksjon av gipsprodukter for bygge- og anleggsvirksomhet",
                "shortName": "Gipsprodukter for bygg av anlegg",
                "level": 4,
                "parentCode": "23.6",
                "children": [
                  {
                    "code": "23.620",
                    "name": "Produksjon av gipsprodukter for bygge- og anleggsvirksomhet",
                    "shortName": "Gipsprodukter for bygg og anlegg",
                    "level": 5,
                    "parentCode": "23.62"
                  }
                ]
              },
              {
                "code": "23.63",
                "name": "Produksjon av ferdigblandet betong",
                "shortName": "Ferdigblandet betong",
                "level": 4,
                "parentCode": "23.6",
                "children": [
                  {
                    "code": "23.630",
                    "name": "Produksjon av ferdigblandet betong",
                    "shortName": "Ferdigblandet betong",
                    "level": 5,
                    "parentCode": "23.63"
                  }
                ]
              },
              {
                "code": "23.64",
                "name": "Produksjon av mørtel",
                "shortName": "Mørtelproduksjon",
                "level": 4,
                "parentCode": "23.6",
                "children": [
                  {
                    "code": "23.640",
                    "name": "Produksjon av mørtel",
                    "shortName": "Mørtelproduksjon",
                    "level": 5,
                    "parentCode": "23.64"
                  }
                ]
              },
              {
                "code": "23.65",
                "name": "Produksjon av fibersement",
                "shortName": "Fibersementproduksjon",
                "level": 4,
                "parentCode": "23.6",
                "children": [
                  {
                    "code": "23.650",
                    "name": "Produksjon av fibersement",
                    "shortName": "Fibersementproduksjon",
                    "level": 5,
                    "parentCode": "23.65"
                  }
                ]
              },
              {
                "code": "23.69",
                "name": "Produksjon av betong-, sement- og gipsprodukter ellers",
                "shortName": "Annen betong-, sement- og gipsprod.",
                "level": 4,
                "parentCode": "23.6",
                "children": [
                  {
                    "code": "23.690",
                    "name": "Produksjon av betong-, sement- og gipsprodukter ellers",
                    "shortName": "Annen betong-, sement- og gipsprod.",
                    "level": 5,
                    "parentCode": "23.69"
                  }
                ]
              }
            ]
          },
          {
            "code": "23.7",
            "name": "Hogging og bearbeiding av monument- og bygningsstein",
            "shortName": "Hogg./bearb. av monum.-/bygn.stein",
            "level": 3,
            "parentCode": "23",
            "children": [
              {
                "code": "23.70",
                "name": "Hogging og bearbeiding av monument- og bygningsstein",
                "shortName": "Hogg./bearb. av monum.-/bygn.stein",
                "level": 4,
                "parentCode": "23.7",
                "children": [
                  {
                    "code": "23.700",
                    "name": "Hogging og bearbeiding av monument- og bygningsstein",
                    "shortName": "Hogg./bearb. av monum.-/bygn.stein",
                    "level": 5,
                    "parentCode": "23.70"
                  }
                ]
              }
            ]
          },
          {
            "code": "23.9",
            "name": "Produksjon av ikke-metallholdige mineralprodukter ikke nevnt annet sted",
            "shortName": "Prod. ikke-metallholdige mineralprod.",
            "level": 3,
            "parentCode": "23",
            "children": [
              {
                "code": "23.91",
                "name": "Produksjon av slipestoffer",
                "shortName": "Slipestoffproduksjon",
                "level": 4,
                "parentCode": "23.9",
                "children": [
                  {
                    "code": "23.910",
                    "name": "Produksjon av slipestoffer",
                    "shortName": "Slipestoffproduksjon",
                    "level": 5,
                    "parentCode": "23.91"
                  }
                ]
              },
              {
                "code": "23.99",
                "name": "Produksjon av ikke-metallholdige mineralprodukter ikke nevnt annet sted",
                "shortName": "Prod. av ikke-met. mineralprod. el.",
                "level": 4,
                "parentCode": "23.9",
                "children": [
                  {
                    "code": "23.990",
                    "name": "Produksjon av ikke-metallholdige mineralprodukter ikke nevnt annet sted",
                    "shortName": "Prod. av ikke-met. mineralprod. el.",
                    "level": 5,
                    "parentCode": "23.99"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "24",
        "name": "Produksjon av metaller",
        "shortName": "Metallindustri",
        "level": 2,
        "parentCode": "C",
        "children": [
          {
            "code": "24.1",
            "name": "Produksjon av jern og stål, samt ferrolegeringer",
            "shortName": "Produksjon jern, stål, ferroleger.",
            "level": 3,
            "parentCode": "24",
            "children": [
              {
                "code": "24.10",
                "name": "Produksjon av jern og stål, samt ferrolegeringer",
                "shortName": "Produksjon jern,  stål, ferroleger.",
                "level": 4,
                "parentCode": "24.1",
                "children": [
                  {
                    "code": "24.101",
                    "name": "Produksjon av jern og stål",
                    "shortName": "Jern- og stålproduksjon",
                    "level": 5,
                    "parentCode": "24.10"
                  },
                  {
                    "code": "24.102",
                    "name": "Produksjon av ferrolegeringer",
                    "shortName": "Prod. av ferrolegeringer",
                    "level": 5,
                    "parentCode": "24.10"
                  }
                ]
              }
            ]
          },
          {
            "code": "24.2",
            "name": "Produksjon av andre rør og rørdeler av stål",
            "shortName": "Annen rør- og rørdelprod. av stål",
            "level": 3,
            "parentCode": "24",
            "children": [
              {
                "code": "24.20",
                "name": "Produksjon av andre rør og rørdeler av stål",
                "shortName": "Annen rør- og rørdelprod. av stål",
                "level": 4,
                "parentCode": "24.2",
                "children": [
                  {
                    "code": "24.200",
                    "name": "Produksjon av andre rør og rørdeler av stål",
                    "shortName": "Annen rør- og rørdelprod. av stål",
                    "level": 5,
                    "parentCode": "24.20"
                  }
                ]
              }
            ]
          },
          {
            "code": "24.3",
            "name": "Annen bearbeiding av jern og stål",
            "shortName": "Annen bearbeiding av jern og stål",
            "level": 3,
            "parentCode": "24",
            "children": [
              {
                "code": "24.31",
                "name": "Kaldtrekking av stenger og profiler",
                "shortName": "Kaldtrekking av stenger og profiler",
                "level": 4,
                "parentCode": "24.3",
                "children": [
                  {
                    "code": "24.310",
                    "name": "Kaldtrekking av stenger og profiler",
                    "shortName": "Kaldtrekking av stenger og profiler",
                    "level": 5,
                    "parentCode": "24.31"
                  }
                ]
              },
              {
                "code": "24.32",
                "name": "Kaldvalsing av bånd",
                "shortName": "Kaldvalsing av bånd",
                "level": 4,
                "parentCode": "24.3",
                "children": [
                  {
                    "code": "24.320",
                    "name": "Kaldvalsing av bånd",
                    "shortName": "Kaldvalsing av bånd",
                    "level": 5,
                    "parentCode": "24.32"
                  }
                ]
              },
              {
                "code": "24.33",
                "name": "Kaldvalsing og pressing av profilerte plater og profiler",
                "shortName": "Kaldv./press. av prof. plater mv.",
                "level": 4,
                "parentCode": "24.3",
                "children": [
                  {
                    "code": "24.330",
                    "name": "Kaldvalsing og pressing av profilerte plater og profiler",
                    "shortName": "Kaldv./press. av prof. plater mv.",
                    "level": 5,
                    "parentCode": "24.33"
                  }
                ]
              },
              {
                "code": "24.34",
                "name": "Kaldtrekking av tråd",
                "shortName": "Kaldtrekking av tråd",
                "level": 4,
                "parentCode": "24.3",
                "children": [
                  {
                    "code": "24.340",
                    "name": "Kaldtrekking av tråd",
                    "shortName": "Kaldtrekking av tråd",
                    "level": 5,
                    "parentCode": "24.34"
                  }
                ]
              }
            ]
          },
          {
            "code": "24.4",
            "name": "Produksjon av ikke-jernholdige metaller",
            "shortName": "Prod. av ikke-jernh. metaller",
            "level": 3,
            "parentCode": "24",
            "children": [
              {
                "code": "24.41",
                "name": "Produksjon av edelmetaller",
                "shortName": "Edelmetallproduksjon",
                "level": 4,
                "parentCode": "24.4",
                "children": [
                  {
                    "code": "24.410",
                    "name": "Produksjon av edelmetaller",
                    "shortName": "Edelmetallproduksjon",
                    "level": 5,
                    "parentCode": "24.41"
                  }
                ]
              },
              {
                "code": "24.42",
                "name": "Produksjon av aluminium",
                "shortName": "Produksjon av aluminium",
                "level": 4,
                "parentCode": "24.4",
                "children": [
                  {
                    "code": "24.421",
                    "name": "Produksjon av primæraluminium",
                    "shortName": "Prod. av primæraluminium",
                    "level": 5,
                    "parentCode": "24.42"
                  },
                  {
                    "code": "24.422",
                    "name": "Produksjon av halvfabrikater av aluminium",
                    "shortName": "Prod. av halvfabrikater av aluminium",
                    "level": 5,
                    "parentCode": "24.42"
                  }
                ]
              },
              {
                "code": "24.43",
                "name": "Produksjon av bly, sink og tinn",
                "shortName": "Bly-, sink- og tinnproduksjon",
                "level": 4,
                "parentCode": "24.4",
                "children": [
                  {
                    "code": "24.430",
                    "name": "Produksjon av bly, sink og tinn",
                    "shortName": "Bly-, sink- og tinnproduksjon",
                    "level": 5,
                    "parentCode": "24.43"
                  }
                ]
              },
              {
                "code": "24.44",
                "name": "Produksjon av kobber",
                "shortName": "Kobberproduksjon",
                "level": 4,
                "parentCode": "24.4",
                "children": [
                  {
                    "code": "24.440",
                    "name": "Produksjon av kobber",
                    "shortName": "Kobberproduksjon",
                    "level": 5,
                    "parentCode": "24.44"
                  }
                ]
              },
              {
                "code": "24.45",
                "name": "Produksjon av ikke-jernholdige metaller ellers",
                "shortName": "Prod. ikke-jernhold. metaller ellers",
                "level": 4,
                "parentCode": "24.4",
                "children": [
                  {
                    "code": "24.450",
                    "name": "Produksjon av ikke-jernholdige metaller ellers",
                    "shortName": "Prod. ikke-jernhold. metaller ellers",
                    "level": 5,
                    "parentCode": "24.45"
                  }
                ]
              },
              {
                "code": "24.46",
                "name": "Produksjon av kjernebrensel",
                "shortName": "Kjernebrenselproduksjon",
                "level": 4,
                "parentCode": "24.4",
                "children": [
                  {
                    "code": "24.460",
                    "name": "Produksjon av kjernebrensel",
                    "shortName": "Kjernebrenselproduksjon",
                    "level": 5,
                    "parentCode": "24.46"
                  }
                ]
              }
            ]
          },
          {
            "code": "24.5",
            "name": "Støping av metaller",
            "shortName": "Støping av metaller",
            "level": 3,
            "parentCode": "24",
            "children": [
              {
                "code": "24.51",
                "name": "Støping av jern",
                "shortName": "Støping av jern",
                "level": 4,
                "parentCode": "24.5",
                "children": [
                  {
                    "code": "24.510",
                    "name": "Støping av jern",
                    "shortName": "Støping av jern",
                    "level": 5,
                    "parentCode": "24.51"
                  }
                ]
              },
              {
                "code": "24.52",
                "name": "Støping av stål",
                "shortName": "Støping av stål",
                "level": 4,
                "parentCode": "24.5",
                "children": [
                  {
                    "code": "24.520",
                    "name": "Støping av stål",
                    "shortName": "Støping av stål",
                    "level": 5,
                    "parentCode": "24.52"
                  }
                ]
              },
              {
                "code": "24.53",
                "name": "Støping av lettmetaller",
                "shortName": "Støping av lettmetaller",
                "level": 4,
                "parentCode": "24.5",
                "children": [
                  {
                    "code": "24.530",
                    "name": "Støping av lettmetaller",
                    "shortName": "Støping av lettmetaller",
                    "level": 5,
                    "parentCode": "24.53"
                  }
                ]
              },
              {
                "code": "24.54",
                "name": "Støping av andre ikke-jernholdige metaller",
                "shortName": "Annen ikke-jernholdig metallstøp.",
                "level": 4,
                "parentCode": "24.5",
                "children": [
                  {
                    "code": "24.540",
                    "name": "Støping av andre ikke-jernholdige metaller",
                    "shortName": "Annen ikke-jernholdig metallstøp.",
                    "level": 5,
                    "parentCode": "24.54"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "25",
        "name": "Produksjon av metallvarer, unntatt maskiner og utstyr",
        "shortName": "Metallvareindustri",
        "level": 2,
        "parentCode": "C",
        "children": [
          {
            "code": "25.1",
            "name": "Produksjon av metallkonstruksjoner",
            "shortName": "Produksjon av metallkonstruksjoner",
            "level": 3,
            "parentCode": "25",
            "children": [
              {
                "code": "25.11",
                "name": "Produksjon av metallkonstruksjoner og deler",
                "shortName": "Prod. av metallkonstruksj. og deler",
                "level": 4,
                "parentCode": "25.1",
                "children": [
                  {
                    "code": "25.110",
                    "name": "Produksjon av metallkonstruksjoner og deler",
                    "shortName": "Prod. av metallkonstruksj. og deler",
                    "level": 5,
                    "parentCode": "25.11"
                  }
                ]
              },
              {
                "code": "25.12",
                "name": "Produksjon av dører og vinduer av metall",
                "shortName": "Bygningsartikkelprod. av metall",
                "level": 4,
                "parentCode": "25.1",
                "children": [
                  {
                    "code": "25.120",
                    "name": "Produksjon av dører og vinduer av metall",
                    "shortName": "Bygningsartikkelprod. av metall",
                    "level": 5,
                    "parentCode": "25.12"
                  }
                ]
              }
            ]
          },
          {
            "code": "25.2",
            "name": "Produksjon av tanker, cisterner og andre beholdere av metall",
            "shortName": "Tanker, cisterner, sentralvarmeanl.",
            "level": 3,
            "parentCode": "25",
            "children": [
              {
                "code": "25.21",
                "name": "Produksjon av radiatorer og kjeler til sentralvarmeanlegg",
                "shortName": "Sentralv.kjeler- og radiatorprod.",
                "level": 4,
                "parentCode": "25.2",
                "children": [
                  {
                    "code": "25.210",
                    "name": "Produksjon av radiatorer og kjeler til sentralvarmeanlegg",
                    "shortName": "Sentralv.kjeler- og radiatorprod.",
                    "level": 5,
                    "parentCode": "25.21"
                  }
                ]
              },
              {
                "code": "25.29",
                "name": "Produksjon av andre tanker, cisterner og beholdere av metall",
                "shortName": "Prod. av metallbeholdere",
                "level": 4,
                "parentCode": "25.2",
                "children": [
                  {
                    "code": "25.290",
                    "name": "Produksjon av andre tanker, cisterner og beholdere av metall",
                    "shortName": "Prod. av metallbeholdere",
                    "level": 5,
                    "parentCode": "25.29"
                  }
                ]
              }
            ]
          },
          {
            "code": "25.3",
            "name": "Produksjon av dampkjeler, unntatt kjeler til sentralvarmeanlegg",
            "shortName": "Dampkjeler unnt. sentralvarmeanl",
            "level": 3,
            "parentCode": "25",
            "children": [
              {
                "code": "25.30",
                "name": "Produksjon av dampkjeler, unntatt kjeler til sentralvarmeanlegg",
                "shortName": "Dampkjeler unnt. sentralvarmeanl.",
                "level": 4,
                "parentCode": "25.3",
                "children": [
                  {
                    "code": "25.300",
                    "name": "Produksjon av dampkjeler, unntatt kjeler til sentralvarmeanlegg",
                    "shortName": "Dampkjeler unnt. sentralvarmeanl.",
                    "level": 5,
                    "parentCode": "25.30"
                  }
                ]
              }
            ]
          },
          {
            "code": "25.4",
            "name": "Produksjon av våpen og ammunisjon",
            "shortName": "Våpen- og ammunisjonsproduksjon",
            "level": 3,
            "parentCode": "25",
            "children": [
              {
                "code": "25.40",
                "name": "Produksjon av våpen og ammunisjon",
                "shortName": "Våpen- og ammunisjonsproduksjon",
                "level": 4,
                "parentCode": "25.4",
                "children": [
                  {
                    "code": "25.400",
                    "name": "Produksjon av våpen og ammunisjon",
                    "shortName": "Våpen- og ammunisjonsproduksjon",
                    "level": 5,
                    "parentCode": "25.40"
                  }
                ]
              }
            ]
          },
          {
            "code": "25.5",
            "name": "Smiing, stansing og valsing av metall, og pulvermetallurgi",
            "shortName": "Stansing/valsing/pulvermetallurgi",
            "level": 3,
            "parentCode": "25",
            "children": [
              {
                "code": "25.50",
                "name": "Smiing, stansing og valsing av metall, og pulvermetallurgi",
                "shortName": "Stansing/valsing/pulvermetallurgi",
                "level": 4,
                "parentCode": "25.5",
                "children": [
                  {
                    "code": "25.500",
                    "name": "Smiing, stansing og valsing av metall, og pulvermetallurgi",
                    "shortName": "Stansing/valsing/pulvermetallurgi",
                    "level": 5,
                    "parentCode": "25.50"
                  }
                ]
              }
            ]
          },
          {
            "code": "25.6",
            "name": "Overflatebehandling og bearbeiding av metaller",
            "shortName": "Overflatebeh./bearb. av metaller",
            "level": 3,
            "parentCode": "25",
            "children": [
              {
                "code": "25.61",
                "name": "Overflatebehandling av metaller",
                "shortName": "Overflatebehandling av metaller",
                "level": 4,
                "parentCode": "25.6",
                "children": [
                  {
                    "code": "25.610",
                    "name": "Overflatebehandling av metaller",
                    "shortName": "Overflatebehandling av metaller",
                    "level": 5,
                    "parentCode": "25.61"
                  }
                ]
              },
              {
                "code": "25.62",
                "name": "Bearbeiding av metaller",
                "shortName": "Bearbeiding av metaller",
                "level": 4,
                "parentCode": "25.6",
                "children": [
                  {
                    "code": "25.620",
                    "name": "Bearbeiding av metaller",
                    "shortName": "Bearbeiding av metaller",
                    "level": 5,
                    "parentCode": "25.62"
                  }
                ]
              }
            ]
          },
          {
            "code": "25.7",
            "name": "Produksjon av kjøkkenredskaper, skjære- og klipperedskaper, håndverktøy og andre jernvarer",
            "shortName": "Produksjon redskaper, andre jernvarer",
            "level": 3,
            "parentCode": "25",
            "children": [
              {
                "code": "25.71",
                "name": "Produksjon av kjøkkenredskaper og skjære- og klipperedskaper",
                "shortName": "Kjøkkenredskapsproduksjon",
                "level": 4,
                "parentCode": "25.7",
                "children": [
                  {
                    "code": "25.710",
                    "name": "Produksjon av kjøkkenredskaper og skjære- og klipperedskaper",
                    "shortName": "Kjøkkenredskapsproduksjon",
                    "level": 5,
                    "parentCode": "25.71"
                  }
                ]
              },
              {
                "code": "25.72",
                "name": "Produksjon av låser og beslag",
                "shortName": "Låse- og beslagproduksjon",
                "level": 4,
                "parentCode": "25.7",
                "children": [
                  {
                    "code": "25.720",
                    "name": "Produksjon av låser og beslag",
                    "shortName": "Låse- og beslagproduksjon",
                    "level": 5,
                    "parentCode": "25.72"
                  }
                ]
              },
              {
                "code": "25.73",
                "name": "Produksjon av håndverktøy",
                "shortName": "Håndverktøyproduksjon",
                "level": 4,
                "parentCode": "25.7",
                "children": [
                  {
                    "code": "25.730",
                    "name": "Produksjon av håndverktøy",
                    "shortName": "Håndverktøyproduksjon",
                    "level": 5,
                    "parentCode": "25.73"
                  }
                ]
              }
            ]
          },
          {
            "code": "25.9",
            "name": "Produksjon av andre metallvarer",
            "shortName": "Produksjon av andre metallvarer",
            "level": 3,
            "parentCode": "25",
            "children": [
              {
                "code": "25.91",
                "name": "Produksjon av stålfat og lignende beholdere av jern og stål",
                "shortName": "Prod. av behold. mv. av jern/stål",
                "level": 4,
                "parentCode": "25.9",
                "children": [
                  {
                    "code": "25.910",
                    "name": "Produksjon av stålfat og lignende beholdere av jern og stål",
                    "shortName": "Prod. av behold. mv. av jern/stål",
                    "level": 5,
                    "parentCode": "25.91"
                  }
                ]
              },
              {
                "code": "25.92",
                "name": "Produksjon av emballasje av lettmetall",
                "shortName": "Prod. av lettmetallemballasje",
                "level": 4,
                "parentCode": "25.9",
                "children": [
                  {
                    "code": "25.920",
                    "name": "Produksjon av emballasje av lettmetall",
                    "shortName": "Prod. av lettmetallemballasje",
                    "level": 5,
                    "parentCode": "25.92"
                  }
                ]
              },
              {
                "code": "25.93",
                "name": "Produksjon av varer av metalltråd, kjetting og fjærer",
                "shortName": "Metalltrådvareproduksjon",
                "level": 4,
                "parentCode": "25.9",
                "children": [
                  {
                    "code": "25.930",
                    "name": "Produksjon av varer av metalltråd, kjetting og fjærer",
                    "shortName": "Metalltrådvareproduksjon",
                    "level": 5,
                    "parentCode": "25.93"
                  }
                ]
              },
              {
                "code": "25.94",
                "name": "Produksjon av bolter og skruer",
                "shortName": "Bolte- og skrueproduksjon",
                "level": 4,
                "parentCode": "25.9",
                "children": [
                  {
                    "code": "25.940",
                    "name": "Produksjon av bolter og skruer",
                    "shortName": "Bolte- og skrueproduksjon",
                    "level": 5,
                    "parentCode": "25.94"
                  }
                ]
              },
              {
                "code": "25.99",
                "name": "Produksjon av metallvarer ikke nevnt annet sted",
                "shortName": "Metallvareprod. el.",
                "level": 4,
                "parentCode": "25.9",
                "children": [
                  {
                    "code": "25.990",
                    "name": "Produksjon av metallvarer ikke nevnt annet sted",
                    "shortName": "Metallvareprod. el.",
                    "level": 5,
                    "parentCode": "25.99"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "26",
        "name": "Produksjon av datamaskiner og elektroniske og optiske produkter",
        "shortName": "Data- og elektronisk industri",
        "level": 2,
        "parentCode": "C",
        "children": [
          {
            "code": "26.1",
            "name": "Produksjon av elektroniske komponenter og kretskort",
            "shortName": "Elek. komponenter, kretskort",
            "level": 3,
            "parentCode": "26",
            "children": [
              {
                "code": "26.11",
                "name": "Produksjon av elektroniske komponenter",
                "shortName": "Prod. av elektroniske komponenter",
                "level": 4,
                "parentCode": "26.1",
                "children": [
                  {
                    "code": "26.110",
                    "name": "Produksjon av elektroniske komponenter",
                    "shortName": "Prod. av elektroniske komponenter",
                    "level": 5,
                    "parentCode": "26.11"
                  }
                ]
              },
              {
                "code": "26.12",
                "name": "Produksjon av kretskort",
                "shortName": "Produksjon av kretskort",
                "level": 4,
                "parentCode": "26.1",
                "children": [
                  {
                    "code": "26.120",
                    "name": "Produksjon av kretskort",
                    "shortName": "Produksjon av kretskort",
                    "level": 5,
                    "parentCode": "26.12"
                  }
                ]
              }
            ]
          },
          {
            "code": "26.2",
            "name": "Produksjon av datamaskiner og tilleggsutstyr",
            "shortName": "Prod. datamaskiner og tilleggsutstyr",
            "level": 3,
            "parentCode": "26",
            "children": [
              {
                "code": "26.20",
                "name": "Produksjon av datamaskiner og tilleggsutstyr",
                "shortName": "Prod. datamaskiner og tilleggsutstyr",
                "level": 4,
                "parentCode": "26.2",
                "children": [
                  {
                    "code": "26.200",
                    "name": "Produksjon av datamaskiner og tilleggsutstyr",
                    "shortName": "Prod. datamaskiner og tilleggsutstyr",
                    "level": 5,
                    "parentCode": "26.20"
                  }
                ]
              }
            ]
          },
          {
            "code": "26.3",
            "name": "Produksjon av kommunikasjonsutstyr",
            "shortName": "Prod. av kommunikasjonsutstyr",
            "level": 3,
            "parentCode": "26",
            "children": [
              {
                "code": "26.30",
                "name": "Produksjon av kommunikasjonsutstyr",
                "shortName": "Prod. av kommunikasjonsutstyr",
                "level": 4,
                "parentCode": "26.3",
                "children": [
                  {
                    "code": "26.300",
                    "name": "Produksjon av kommunikasjonsutstyr",
                    "shortName": "Prod. av kommunikasjonsutstyr",
                    "level": 5,
                    "parentCode": "26.30"
                  }
                ]
              }
            ]
          },
          {
            "code": "26.4",
            "name": "Produksjon av elektronikk til husholdningsbruk",
            "shortName": "Prod. av husholdningselektronikk",
            "level": 3,
            "parentCode": "26",
            "children": [
              {
                "code": "26.40",
                "name": "Produksjon av elektronikk til husholdningsbruk",
                "shortName": "Prod. av husholdningselektronikk",
                "level": 4,
                "parentCode": "26.4",
                "children": [
                  {
                    "code": "26.400",
                    "name": "Produksjon av elektronikk til husholdningsbruk",
                    "shortName": "Prod. av husholdningselektronikk",
                    "level": 5,
                    "parentCode": "26.40"
                  }
                ]
              }
            ]
          },
          {
            "code": "26.5",
            "name": "Produksjon av måle-, kontroll- og navigasjonsinstrumenter, og klokker og ur",
            "shortName": "Måle- og kontrollinstrumenter",
            "level": 3,
            "parentCode": "26",
            "children": [
              {
                "code": "26.51",
                "name": "Produksjon av måle-, kontroll- og navigasjonsinstrumenter",
                "shortName": "Måle-, kontroll- og navig.instr.",
                "level": 4,
                "parentCode": "26.5",
                "children": [
                  {
                    "code": "26.510",
                    "name": "Produksjon av måle-, kontroll- og navigasjonsinstrumenter",
                    "shortName": "Måle-, kontroll- og navig.instr.",
                    "level": 5,
                    "parentCode": "26.51"
                  }
                ]
              },
              {
                "code": "26.52",
                "name": "Produksjon av klokker og ur",
                "shortName": "Klokke- og urproduksjon",
                "level": 4,
                "parentCode": "26.5",
                "children": [
                  {
                    "code": "26.520",
                    "name": "Produksjon av klokker og ur",
                    "shortName": "Klokke- og urproduksjon",
                    "level": 5,
                    "parentCode": "26.52"
                  }
                ]
              }
            ]
          },
          {
            "code": "26.6",
            "name": "Produksjon av strålingsutstyr, elektromedisinsk og elektroterapeutisk utstyr",
            "shortName": "Elektromed./elektroterap. utst. mv.",
            "level": 3,
            "parentCode": "26",
            "children": [
              {
                "code": "26.60",
                "name": "Produksjon av strålingsutstyr, elektromedisinsk og elektroterapeutisk utstyr",
                "shortName": "Elektromed./elektroterap. utst. mv.",
                "level": 4,
                "parentCode": "26.6",
                "children": [
                  {
                    "code": "26.600",
                    "name": "Produksjon av strålingsutstyr, elektromedisinsk og elektroterapeutisk utstyr",
                    "shortName": "Elektromed./elektroterap. utst. mv.",
                    "level": 5,
                    "parentCode": "26.60"
                  }
                ]
              }
            ]
          },
          {
            "code": "26.7",
            "name": "Produksjon av optiske instrumenter og fotografisk utstyr",
            "shortName": "Optiske instr./fotografisk utstyr",
            "level": 3,
            "parentCode": "26",
            "children": [
              {
                "code": "26.70",
                "name": "Produksjon av optiske instrumenter og fotografisk utstyr",
                "shortName": "Optiske instr./fotografisk utstyr",
                "level": 4,
                "parentCode": "26.7",
                "children": [
                  {
                    "code": "26.700",
                    "name": "Produksjon av optiske instrumenter og fotografisk utstyr",
                    "shortName": "Optiske instr./fotografisk utstyr",
                    "level": 5,
                    "parentCode": "26.70"
                  }
                ]
              }
            ]
          },
          {
            "code": "26.8",
            "name": "Produksjon av magnetiske og optiske media",
            "shortName": "Magnetiske/optiske media",
            "level": 3,
            "parentCode": "26",
            "children": [
              {
                "code": "26.80",
                "name": "Produksjon av magnetiske og optiske media",
                "shortName": "Magnetiske/optiske media",
                "level": 4,
                "parentCode": "26.8",
                "children": [
                  {
                    "code": "26.800",
                    "name": "Produksjon av magnetiske og optiske media",
                    "shortName": "Magnetiske/optiske media",
                    "level": 5,
                    "parentCode": "26.80"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "27",
        "name": "Produksjon av elektrisk utstyr",
        "shortName": "Elektroteknisk industri",
        "level": 2,
        "parentCode": "C",
        "children": [
          {
            "code": "27.1",
            "name": "Produksjon av elektromotorer, generatorer, transformatorer og elektriske fordelings- og kontrolltavler og paneler",
            "shortName": "Elektromotorer, generatorer mv.",
            "level": 3,
            "parentCode": "27",
            "children": [
              {
                "code": "27.11",
                "name": "Produksjon av elektromotorer, generatorer og transformatorer",
                "shortName": "Elektromotor-, generatorprod. mv.",
                "level": 4,
                "parentCode": "27.1",
                "children": [
                  {
                    "code": "27.110",
                    "name": "Produksjon av elektromotorer, generatorer og transformatorer",
                    "shortName": "Elektromotor-, generatorprod. mv.",
                    "level": 5,
                    "parentCode": "27.11"
                  }
                ]
              },
              {
                "code": "27.12",
                "name": "Produksjon av elektriske fordelings- og kontrolltavler og paneler",
                "shortName": "Elektriske tavler, paneler mv.",
                "level": 4,
                "parentCode": "27.1",
                "children": [
                  {
                    "code": "27.120",
                    "name": "Produksjon av elektriske fordelings- og kontrolltavler og paneler",
                    "shortName": "Elektriske tavler, paneler mv.",
                    "level": 5,
                    "parentCode": "27.12"
                  }
                ]
              }
            ]
          },
          {
            "code": "27.2",
            "name": "Produksjon av batterier og akkumulatorer",
            "shortName": "Batterier, akkumulatorer",
            "level": 3,
            "parentCode": "27",
            "children": [
              {
                "code": "27.20",
                "name": "Produksjon av batterier og akkumulatorer",
                "shortName": "Batterier, akkumulatorer",
                "level": 4,
                "parentCode": "27.2",
                "children": [
                  {
                    "code": "27.200",
                    "name": "Produksjon av batterier og akkumulatorer",
                    "shortName": "Batterier, akkumulatorer",
                    "level": 5,
                    "parentCode": "27.20"
                  }
                ]
              }
            ]
          },
          {
            "code": "27.3",
            "name": "Produksjon av ledninger og ledningsmateriell",
            "shortName": "Ledninger og ledningsmateriell",
            "level": 3,
            "parentCode": "27",
            "children": [
              {
                "code": "27.31",
                "name": "Produksjon av optiske fiberkabler",
                "shortName": "Prod. av optiske fiberkabler",
                "level": 4,
                "parentCode": "27.3",
                "children": [
                  {
                    "code": "27.310",
                    "name": "Produksjon av optiske fiberkabler",
                    "shortName": "Prod. av optiske fiberkabler",
                    "level": 5,
                    "parentCode": "27.31"
                  }
                ]
              },
              {
                "code": "27.32",
                "name": "Produksjon av andre elektroniske og elektriske ledninger og kabler",
                "shortName": "Elektron./el. ledninger/kabler el.",
                "level": 4,
                "parentCode": "27.3",
                "children": [
                  {
                    "code": "27.320",
                    "name": "Produksjon av andre elektroniske og elektriske ledninger og kabler",
                    "shortName": "Elektron./el. ledninger/kabler el.",
                    "level": 5,
                    "parentCode": "27.32"
                  }
                ]
              },
              {
                "code": "27.33",
                "name": "Produksjon av ledningsmateriell",
                "shortName": "Prod. av ledningsmateriell",
                "level": 4,
                "parentCode": "27.3",
                "children": [
                  {
                    "code": "27.330",
                    "name": "Produksjon av ledningsmateriell",
                    "shortName": "Prod. av ledningsmateriell",
                    "level": 5,
                    "parentCode": "27.33"
                  }
                ]
              }
            ]
          },
          {
            "code": "27.4",
            "name": "Produksjon av belysningsutstyr",
            "shortName": "Prod. av belysningsutstyr",
            "level": 3,
            "parentCode": "27",
            "children": [
              {
                "code": "27.40",
                "name": "Produksjon av belysningsutstyr",
                "shortName": "Prod. av belysningsutstyr",
                "level": 4,
                "parentCode": "27.4",
                "children": [
                  {
                    "code": "27.400",
                    "name": "Produksjon av belysningsutstyr",
                    "shortName": "Prod. av belysningsutstyr",
                    "level": 5,
                    "parentCode": "27.40"
                  }
                ]
              }
            ]
          },
          {
            "code": "27.5",
            "name": "Produksjon av husholdningsmaskiner og -apparater",
            "shortName": "Husholdningsmaskinproduksjon",
            "level": 3,
            "parentCode": "27",
            "children": [
              {
                "code": "27.51",
                "name": "Produksjon av elektriske husholdningsmaskiner og apparater",
                "shortName": "Elektr. hush.maskin-/apparatprod.",
                "level": 4,
                "parentCode": "27.5",
                "children": [
                  {
                    "code": "27.510",
                    "name": "Produksjon av elektriske husholdningsmaskiner og apparater",
                    "shortName": "Elektr. hush.maskin-/apparatprod.",
                    "level": 5,
                    "parentCode": "27.51"
                  }
                ]
              },
              {
                "code": "27.52",
                "name": "Produksjon av ikke-elektriske husholdningsmaskiner og apparater",
                "shortName": "Ikke-el. hush.mask.-/apparatprod.",
                "level": 4,
                "parentCode": "27.5",
                "children": [
                  {
                    "code": "27.520",
                    "name": "Produksjon av ikke-elektriske husholdningsmaskiner og apparater",
                    "shortName": "Ikke-el. hush.mask.-/apparatprod.",
                    "level": 5,
                    "parentCode": "27.52"
                  }
                ]
              }
            ]
          },
          {
            "code": "27.9",
            "name": "Produksjon av annet elektrisk utstyr",
            "shortName": "Produksjon elektrisk utstyr ellers",
            "level": 3,
            "parentCode": "27",
            "children": [
              {
                "code": "27.90",
                "name": "Produksjon av annet elektrisk utstyr",
                "shortName": "Produksjon elektrisk utstyr ellers",
                "level": 4,
                "parentCode": "27.9",
                "children": [
                  {
                    "code": "27.900",
                    "name": "Produksjon av annet elektrisk utstyr",
                    "shortName": "Produksjon elektrisk utstyr ellers",
                    "level": 5,
                    "parentCode": "27.90"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "28",
        "name": "Produksjon av maskiner og utstyr til generell bruk, ikke nevnt annet sted",
        "shortName": "Maskinindustri",
        "level": 2,
        "parentCode": "C",
        "children": [
          {
            "code": "28.1",
            "name": "Produksjon av maskiner og utstyr til generell bruk",
            "shortName": "Prod. mask. og utstyr generell bruk",
            "level": 3,
            "parentCode": "28",
            "children": [
              {
                "code": "28.11",
                "name": "Produksjon av motorer og turbiner, unntatt motorer til luftfartøyer og motorvogner",
                "shortName": "Skipsmotor-/motor- og turbinprod. el.",
                "level": 4,
                "parentCode": "28.1",
                "children": [
                  {
                    "code": "28.110",
                    "name": "Produksjon av motorer og turbiner, unntatt motorer til luftfartøyer og motorvogner",
                    "shortName": "Skipsmotor-/motor- og turbinprod. el.",
                    "level": 5,
                    "parentCode": "28.11"
                  }
                ]
              },
              {
                "code": "28.12",
                "name": "Produksjon av komponenter til hydraulisk og pneumatisk utstyr",
                "shortName": "Komp. til hydraul./pneumatisk utstyr",
                "level": 4,
                "parentCode": "28.1",
                "children": [
                  {
                    "code": "28.120",
                    "name": "Produksjon av komponenter til hydraulisk og pneumatisk utstyr",
                    "shortName": "Komp. til hydraul./pneumatisk utstyr",
                    "level": 5,
                    "parentCode": "28.12"
                  }
                ]
              },
              {
                "code": "28.13",
                "name": "Produksjon av pumper og kompressorer ellers",
                "shortName": "Pumpe- og kompressorprod. el.",
                "level": 4,
                "parentCode": "28.1",
                "children": [
                  {
                    "code": "28.130",
                    "name": "Produksjon av pumper og kompressorer ellers",
                    "shortName": "Pumpe- og kompressorprod. el.",
                    "level": 5,
                    "parentCode": "28.13"
                  }
                ]
              },
              {
                "code": "28.14",
                "name": "Produksjon av kraner og ventiler ellers",
                "shortName": "Kran- og ventilproduksjon el.",
                "level": 4,
                "parentCode": "28.1",
                "children": [
                  {
                    "code": "28.140",
                    "name": "Produksjon av kraner og ventiler ellers",
                    "shortName": "Kran- og ventilproduksjon el.",
                    "level": 5,
                    "parentCode": "28.14"
                  }
                ]
              },
              {
                "code": "28.15",
                "name": "Produksjon av lagre, gir, tannhjulsutvekslinger og andre innretninger for kraftoverføring",
                "shortName": "Lager-, girproduksjon mv.",
                "level": 4,
                "parentCode": "28.1",
                "children": [
                  {
                    "code": "28.150",
                    "name": "Produksjon av lagre, gir, tannhjulsutvekslinger og andre innretninger for kraftoverføring",
                    "shortName": "Lager-, girproduksjon mv.",
                    "level": 5,
                    "parentCode": "28.15"
                  }
                ]
              }
            ]
          },
          {
            "code": "28.2",
            "name": "Produksjon av andre maskiner og annet utstyr til generell bruk",
            "shortName": "Annen maskinprod. for generell bruk",
            "level": 3,
            "parentCode": "28",
            "children": [
              {
                "code": "28.21",
                "name": "Produksjon av industri- og laboratorieovner samt brennere",
                "shortName": "Industri- og laboratorieovnprod.",
                "level": 4,
                "parentCode": "28.2",
                "children": [
                  {
                    "code": "28.210",
                    "name": "Produksjon av industri- og laboratorieovner samt brennere",
                    "shortName": "Industri- og laboratorieovnprod.",
                    "level": 5,
                    "parentCode": "28.21"
                  }
                ]
              },
              {
                "code": "28.22",
                "name": "Produksjon av løfte- og håndteringsutstyr",
                "shortName": "Løfte- og håndteringsutstyr",
                "level": 4,
                "parentCode": "28.2",
                "children": [
                  {
                    "code": "28.221",
                    "name": "Produksjon av løfte- og håndteringsutstyr til skip og båter",
                    "shortName": "Løfteutstyr m.m. for skip og båter",
                    "level": 5,
                    "parentCode": "28.22"
                  },
                  {
                    "code": "28.229",
                    "name": "Produksjon av løfte- og håndteringsutstyr ellers",
                    "shortName": "Løfte- og håndteringsutstyr el.",
                    "level": 5,
                    "parentCode": "28.22"
                  }
                ]
              },
              {
                "code": "28.23",
                "name": "Produksjon av kontormaskiner og utstyr (unntatt datamaskiner og tilleggsutstyr)",
                "shortName": "Kontormaskinproduksjon",
                "level": 4,
                "parentCode": "28.2",
                "children": [
                  {
                    "code": "28.230",
                    "name": "Produksjon av kontormaskiner og utstyr (unntatt datamaskiner og tilleggsutstyr)",
                    "shortName": "Kontormaskinproduksjon",
                    "level": 5,
                    "parentCode": "28.23"
                  }
                ]
              },
              {
                "code": "28.24",
                "name": "Produksjon av motordrevet håndverktøy",
                "shortName": "Prod. av motordrevet håndverktøy",
                "level": 4,
                "parentCode": "28.2",
                "children": [
                  {
                    "code": "28.240",
                    "name": "Produksjon av motordrevet håndverktøy",
                    "shortName": "Prod. av motordrevet håndverktøy",
                    "level": 5,
                    "parentCode": "28.24"
                  }
                ]
              },
              {
                "code": "28.25",
                "name": "Produksjon av kjøle- og ventilasjonsanlegg, unntatt til husholdningsbruk",
                "shortName": "Kjøle- og ventilasjonsanleggprod.",
                "level": 4,
                "parentCode": "28.2",
                "children": [
                  {
                    "code": "28.250",
                    "name": "Produksjon av kjøle- og ventilasjonsanlegg, unntatt til husholdningsbruk",
                    "shortName": "Kjøle- og ventilasjonsanleggprod.",
                    "level": 5,
                    "parentCode": "28.25"
                  }
                ]
              },
              {
                "code": "28.29",
                "name": "Produksjon av maskiner og utstyr til generell bruk, ikke nevnt annet sted",
                "shortName": "Maskiner og utstyr til gen. bruk el.",
                "level": 4,
                "parentCode": "28.2",
                "children": [
                  {
                    "code": "28.290",
                    "name": "Produksjon av maskiner og utstyr til generell bruk, ikke nevnt annet sted",
                    "shortName": "Maskiner og utstyr til gen. bruk el.",
                    "level": 5,
                    "parentCode": "28.29"
                  }
                ]
              }
            ]
          },
          {
            "code": "28.3",
            "name": "Produksjon av jordbruks- og skogbruksmaskiner",
            "shortName": "Jord- og skogbruksmaskinproduksjon",
            "level": 3,
            "parentCode": "28",
            "children": [
              {
                "code": "28.30",
                "name": "Produksjon av jordbruks- og skogbruksmaskiner",
                "shortName": "Jord- og skogbruksmaskinproduksjon",
                "level": 4,
                "parentCode": "28.3",
                "children": [
                  {
                    "code": "28.300",
                    "name": "Produksjon av jordbruks- og skogbruksmaskiner",
                    "shortName": "Jord- og skogbruksmaskinproduksjon",
                    "level": 5,
                    "parentCode": "28.30"
                  }
                ]
              }
            ]
          },
          {
            "code": "28.4",
            "name": "Produksjon av maskiner til metallbearbeiding og annet maskinverktøy",
            "shortName": "Mask.verktøy til metallbearb. mv.",
            "level": 3,
            "parentCode": "28",
            "children": [
              {
                "code": "28.41",
                "name": "Produksjon av maskinverktøy til metallbearbeiding",
                "shortName": "Maskinverktøy til metallbearb.",
                "level": 4,
                "parentCode": "28.4",
                "children": [
                  {
                    "code": "28.410",
                    "name": "Produksjon av maskinverktøy til metallbearbeiding",
                    "shortName": "Maskinverktøy til metallbearb.",
                    "level": 5,
                    "parentCode": "28.41"
                  }
                ]
              },
              {
                "code": "28.49",
                "name": "Produksjon av maskinverktøy ikke nevnt annet sted",
                "shortName": "Prod. av maskinverktøy el.",
                "level": 4,
                "parentCode": "28.4",
                "children": [
                  {
                    "code": "28.490",
                    "name": "Produksjon av maskinverktøy ikke nevnt annet sted",
                    "shortName": "Prod. av maskinverktøy el.",
                    "level": 5,
                    "parentCode": "28.49"
                  }
                ]
              }
            ]
          },
          {
            "code": "28.9",
            "name": "Produksjon av andre spesialmaskiner",
            "shortName": "Produksjon av andre spesialmaskiner",
            "level": 3,
            "parentCode": "28",
            "children": [
              {
                "code": "28.91",
                "name": "Produksjon av maskiner og utstyr til metallurgisk industri",
                "shortName": "Mask./utstyr metallurgisk industri",
                "level": 4,
                "parentCode": "28.9",
                "children": [
                  {
                    "code": "28.910",
                    "name": "Produksjon av maskiner og utstyr til metallurgisk industri",
                    "shortName": "Mask./utstyr metallurgisk industri",
                    "level": 5,
                    "parentCode": "28.91"
                  }
                ]
              },
              {
                "code": "28.92",
                "name": "Produksjon av maskiner og utstyr til bergverksdrift og bygge- og anleggsvirksomhet",
                "shortName": "Mask./utstyr bergverk, bygg og anl.",
                "level": 4,
                "parentCode": "28.9",
                "children": [
                  {
                    "code": "28.920",
                    "name": "Produksjon av maskiner og utstyr til bergverksdrift og bygge- og anleggsvirksomhet",
                    "shortName": "Mask./utstyr bergverk, bygg og anl.",
                    "level": 5,
                    "parentCode": "28.92"
                  }
                ]
              },
              {
                "code": "28.93",
                "name": "Produksjon av maskiner og utstyr til nærings- og nytelsesmiddelindustri",
                "shortName": "Mask./utstyr næringsmiddelindustri",
                "level": 4,
                "parentCode": "28.9",
                "children": [
                  {
                    "code": "28.930",
                    "name": "Produksjon av maskiner og utstyr til nærings- og nytelsesmiddelindustri",
                    "shortName": "Mask./utstyr næringsmiddelindustri",
                    "level": 5,
                    "parentCode": "28.93"
                  }
                ]
              },
              {
                "code": "28.94",
                "name": "Produksjon av maskiner og utstyr til tekstil-, konfeksjons- og lærvareindustri",
                "shortName": "Mask./utstyr tekstilindustri",
                "level": 4,
                "parentCode": "28.9",
                "children": [
                  {
                    "code": "28.940",
                    "name": "Produksjon av maskiner og utstyr til tekstil-, konfeksjons- og lærvareindustri",
                    "shortName": "Mask./utstyr tekstilindustri",
                    "level": 5,
                    "parentCode": "28.94"
                  }
                ]
              },
              {
                "code": "28.95",
                "name": "Produksjon av maskiner og utstyr til papir- og pappvareindustri",
                "shortName": "Mask./utstyr papir- og pappvareindustri",
                "level": 4,
                "parentCode": "28.9",
                "children": [
                  {
                    "code": "28.950",
                    "name": "Produksjon av maskiner og utstyr til papir- og pappvareindustri",
                    "shortName": "Mask./utstyr papir- og pappvareindustri",
                    "level": 5,
                    "parentCode": "28.95"
                  }
                ]
              },
              {
                "code": "28.96",
                "name": "Produksjon av maskiner og utstyr til plast- og gummiindustri",
                "shortName": "Mask./utstyr plast- og gummiindustri",
                "level": 4,
                "parentCode": "28.9",
                "children": [
                  {
                    "code": "28.960",
                    "name": "Produksjon av maskiner og utstyr til plast- og gummiindustri",
                    "shortName": "Mask./utstyr plast- og gummiindustri",
                    "level": 5,
                    "parentCode": "28.96"
                  }
                ]
              },
              {
                "code": "28.99",
                "name": "Produksjon av spesialmaskiner ikke nevnt annet sted",
                "shortName": "Spesialmaskinproduksjon el.",
                "level": 4,
                "parentCode": "28.9",
                "children": [
                  {
                    "code": "28.990",
                    "name": "Produksjon av spesialmaskiner ikke nevnt annet sted",
                    "shortName": "Spesialmaskinproduksjon el.",
                    "level": 5,
                    "parentCode": "28.99"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "29",
        "name": "Produksjon av motorvogner og tilhengere",
        "shortName": "Motorkjøretøyindustri",
        "level": 2,
        "parentCode": "C",
        "children": [
          {
            "code": "29.1",
            "name": "Produksjon av motorvogner",
            "shortName": "Motorvognproduksjon",
            "level": 3,
            "parentCode": "29",
            "children": [
              {
                "code": "29.10",
                "name": "Produksjon av motorvogner",
                "shortName": "Motorvognproduksjon",
                "level": 4,
                "parentCode": "29.1",
                "children": [
                  {
                    "code": "29.100",
                    "name": "Produksjon av motorvogner",
                    "shortName": "Motorvognproduksjon",
                    "level": 5,
                    "parentCode": "29.10"
                  }
                ]
              }
            ]
          },
          {
            "code": "29.2",
            "name": "Produksjon av karosserier og tilhengere",
            "shortName": "Karosseri- og tilhengerproduksjon",
            "level": 3,
            "parentCode": "29",
            "children": [
              {
                "code": "29.20",
                "name": "Produksjon av karosserier og tilhengere",
                "shortName": "Karosseri- og tilhengerproduksjon",
                "level": 4,
                "parentCode": "29.2",
                "children": [
                  {
                    "code": "29.200",
                    "name": "Produksjon av karosserier og tilhengere",
                    "shortName": "Karosseri- og tilhengerproduksjon",
                    "level": 5,
                    "parentCode": "29.20"
                  }
                ]
              }
            ]
          },
          {
            "code": "29.3",
            "name": "Produksjon av deler og utstyr til motorvogner",
            "shortName": "Utstyr- og delprod. motorvogner",
            "level": 3,
            "parentCode": "29",
            "children": [
              {
                "code": "29.31",
                "name": "Produksjon av elektrisk og elektronisk utstyr til motorvogner",
                "shortName": "Elektrisk/elektron. utstyr motorv.",
                "level": 4,
                "parentCode": "29.3",
                "children": [
                  {
                    "code": "29.310",
                    "name": "Produksjon av elektrisk og elektronisk utstyr til motorvogner",
                    "shortName": "Elektrisk/elektron. utstyr motorv.",
                    "level": 5,
                    "parentCode": "29.31"
                  }
                ]
              },
              {
                "code": "29.32",
                "name": "Produksjon av andre deler og annet utstyr til motorvogner",
                "shortName": "Annet utstyr-/delprod. til motorv.",
                "level": 4,
                "parentCode": "29.3",
                "children": [
                  {
                    "code": "29.320",
                    "name": "Produksjon av andre deler og annet utstyr til motorvogner",
                    "shortName": "Annet utstyr-/delprod. til motorv.",
                    "level": 5,
                    "parentCode": "29.32"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "30",
        "name": "Produksjon av andre transportmidler",
        "shortName": "Transportmiddelindustri ellers",
        "level": 2,
        "parentCode": "C",
        "children": [
          {
            "code": "30.1",
            "name": "Bygging av skip og båter",
            "shortName": "Bygging av skip og oljeplattformer",
            "level": 3,
            "parentCode": "30",
            "children": [
              {
                "code": "30.11",
                "name": "Bygging av skip og flytende materiell",
                "shortName": "Bygg av skip og flytende materiell",
                "level": 4,
                "parentCode": "30.1",
                "children": [
                  {
                    "code": "30.111",
                    "name": "Bygging av skip og skrog over 100 br.tonn",
                    "shortName": "Bygg. av skip/skrog over 100 br.tonn",
                    "level": 5,
                    "parentCode": "30.11"
                  },
                  {
                    "code": "30.112",
                    "name": "Bygging av skip under 100 br.tonn",
                    "shortName": "Bygg. av skip under 100 br.tonn",
                    "level": 5,
                    "parentCode": "30.11"
                  },
                  {
                    "code": "30.113",
                    "name": "Bygging av oljeplattformer og moduler",
                    "shortName": "Bygging oljeplattformer, moduler",
                    "level": 5,
                    "parentCode": "30.11"
                  },
                  {
                    "code": "30.114",
                    "name": "Produksjon av annet flytende materiell",
                    "shortName": "Annen flytende materiellproduksjon",
                    "level": 5,
                    "parentCode": "30.11"
                  },
                  {
                    "code": "30.115",
                    "name": "Innrednings- og installasjonsarbeid utført på skip over 100 br.tonn",
                    "shortName": "Install. m.m. på skip over 100 br.t.",
                    "level": 5,
                    "parentCode": "30.11"
                  },
                  {
                    "code": "30.116",
                    "name": "Innrednings- og installasjonsarbeid utført på oljeplattformer og moduler",
                    "shortName": "Install. m.m. på oljepl./moduler",
                    "level": 5,
                    "parentCode": "30.11"
                  }
                ]
              },
              {
                "code": "30.12",
                "name": "Bygging av fritidsbåter",
                "shortName": "Bygging av fritidsbåter",
                "level": 4,
                "parentCode": "30.1",
                "children": [
                  {
                    "code": "30.120",
                    "name": "Bygging av fritidsbåter",
                    "shortName": "Bygging av fritidsbåter",
                    "level": 5,
                    "parentCode": "30.12"
                  }
                ]
              }
            ]
          },
          {
            "code": "30.2",
            "name": "Produksjon av lokomotiver og annet rullende materiell til jernbane og sporvei",
            "shortName": "Jernbane- og sporvognmateriell mv.",
            "level": 3,
            "parentCode": "30",
            "children": [
              {
                "code": "30.20",
                "name": "Produksjon av lokomotiver og annet rullende materiell til jernbane og sporvei",
                "shortName": "Jernbane- og sporvognmateriell mv.",
                "level": 4,
                "parentCode": "30.2",
                "children": [
                  {
                    "code": "30.200",
                    "name": "Produksjon av lokomotiver og annet rullende materiell til jernbane og sporvei",
                    "shortName": "Jernbane- og sporvognmateriell mv.",
                    "level": 5,
                    "parentCode": "30.20"
                  }
                ]
              }
            ]
          },
          {
            "code": "30.3",
            "name": "Produksjon av luftfartøyer og romfartøyer og lignende utstyr",
            "shortName": "Prod. luft- og romfartøy og lignende",
            "level": 3,
            "parentCode": "30",
            "children": [
              {
                "code": "30.30",
                "name": "Produksjon av luftfartøyer og romfartøyer og lignende utstyr",
                "shortName": "Prod. luft- og romfartøy og lignende",
                "level": 4,
                "parentCode": "30.3",
                "children": [
                  {
                    "code": "30.300",
                    "name": "Produksjon av luftfartøyer og romfartøyer og lignende utstyr",
                    "shortName": "Prod. luft- og romfartøy og lignende",
                    "level": 5,
                    "parentCode": "30.30"
                  }
                ]
              }
            ]
          },
          {
            "code": "30.4",
            "name": "Produksjon av militære stridskjøretøyer",
            "shortName": "Produksjon militære stridskjøretøy",
            "level": 3,
            "parentCode": "30",
            "children": [
              {
                "code": "30.40",
                "name": "Produksjon av militære stridskjøretøyer",
                "shortName": "Produksjon militære stridskjøretøy",
                "level": 4,
                "parentCode": "30.4",
                "children": [
                  {
                    "code": "30.400",
                    "name": "Produksjon av militære stridskjøretøyer",
                    "shortName": "Produksjon militære stridskjøretøy",
                    "level": 5,
                    "parentCode": "30.40"
                  }
                ]
              }
            ]
          },
          {
            "code": "30.9",
            "name": "Produksjon av transportmidler ikke nevnt annet sted",
            "shortName": "Produksjon transportmidler ellers",
            "level": 3,
            "parentCode": "30",
            "children": [
              {
                "code": "30.91",
                "name": "Produksjon av motorsykler",
                "shortName": "Motorsykkelproduksjon",
                "level": 4,
                "parentCode": "30.9",
                "children": [
                  {
                    "code": "30.910",
                    "name": "Produksjon av motorsykler",
                    "shortName": "Motorsykkelproduksjon",
                    "level": 5,
                    "parentCode": "30.91"
                  }
                ]
              },
              {
                "code": "30.92",
                "name": "Produksjon av sykler og invalidevogner",
                "shortName": "Sykkel- og invalidevognprod.",
                "level": 4,
                "parentCode": "30.9",
                "children": [
                  {
                    "code": "30.920",
                    "name": "Produksjon av sykler og invalidevogner",
                    "shortName": "Sykkel- og invalidevognprod.",
                    "level": 5,
                    "parentCode": "30.92"
                  }
                ]
              },
              {
                "code": "30.99",
                "name": "Produksjon av andre transportmidler ikke nevnt annet sted",
                "shortName": "Transportmiddelproduksjon el.",
                "level": 4,
                "parentCode": "30.9",
                "children": [
                  {
                    "code": "30.990",
                    "name": "Produksjon av andre transportmidler ikke nevnt annet sted",
                    "shortName": "Transportmiddelproduksjon el.",
                    "level": 5,
                    "parentCode": "30.99"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "31",
        "name": "Produksjon av møbler",
        "shortName": "Møbelindustri",
        "level": 2,
        "parentCode": "C",
        "children": [
          {
            "code": "31.0",
            "name": "Produksjon av møbler",
            "shortName": "Produksjon av møbler",
            "level": 3,
            "parentCode": "31",
            "children": [
              {
                "code": "31.01",
                "name": "Produksjon av kontor- og butikkmøbler",
                "shortName": "Kontor- og butikkmøbelprod.",
                "level": 4,
                "parentCode": "31.0",
                "children": [
                  {
                    "code": "31.010",
                    "name": "Produksjon av kontor- og butikkmøbler",
                    "shortName": "Kontor- og butikkmøbelprod.",
                    "level": 5,
                    "parentCode": "31.01"
                  }
                ]
              },
              {
                "code": "31.02",
                "name": "Produksjon av kjøkkenmøbler",
                "shortName": "Kjøkkenmøbelproduksjon",
                "level": 4,
                "parentCode": "31.0",
                "children": [
                  {
                    "code": "31.020",
                    "name": "Produksjon av kjøkkenmøbler",
                    "shortName": "Kjøkkenmøbelproduksjon",
                    "level": 5,
                    "parentCode": "31.02"
                  }
                ]
              },
              {
                "code": "31.03",
                "name": "Produksjon av madrasser",
                "shortName": "Madrassproduksjon",
                "level": 4,
                "parentCode": "31.0",
                "children": [
                  {
                    "code": "31.030",
                    "name": "Produksjon av madrasser",
                    "shortName": "Madrassproduksjon",
                    "level": 5,
                    "parentCode": "31.03"
                  }
                ]
              },
              {
                "code": "31.09",
                "name": "Produksjon av møbler ellers",
                "shortName": "Møbelproduksjon el.",
                "level": 4,
                "parentCode": "31.0",
                "children": [
                  {
                    "code": "31.090",
                    "name": "Produksjon av møbler ellers",
                    "shortName": "Møbelproduksjon el.",
                    "level": 5,
                    "parentCode": "31.09"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "32",
        "name": "Annen industriproduksjon",
        "shortName": "Annen industri",
        "level": 2,
        "parentCode": "C",
        "children": [
          {
            "code": "32.1",
            "name": "Produksjon av gull- og sølvvarer, bijouteri og lignende artikler",
            "shortName": "Produksjon gull- og sølvvarer mv.",
            "level": 3,
            "parentCode": "32",
            "children": [
              {
                "code": "32.11",
                "name": "Preging av mynter og medaljer",
                "shortName": "Mynt- og medaljepreging",
                "level": 4,
                "parentCode": "32.1",
                "children": [
                  {
                    "code": "32.110",
                    "name": "Preging av mynter og medaljer",
                    "shortName": "Mynt- og medaljepreging",
                    "level": 5,
                    "parentCode": "32.11"
                  }
                ]
              },
              {
                "code": "32.12",
                "name": "Produksjon av gull- og sølvvarer og lignende artikler",
                "shortName": "Gull- og sølvvareprod. mv.",
                "level": 4,
                "parentCode": "32.1",
                "children": [
                  {
                    "code": "32.120",
                    "name": "Produksjon av gull- og sølvvarer og lignende artikler",
                    "shortName": "Gull- og sølvvareprod. mv.",
                    "level": 5,
                    "parentCode": "32.12"
                  }
                ]
              },
              {
                "code": "32.13",
                "name": "Produksjon av bijouteri og lignende artikler",
                "shortName": "Bijouterivareproduksjon mv.",
                "level": 4,
                "parentCode": "32.1",
                "children": [
                  {
                    "code": "32.130",
                    "name": "Produksjon av bijouteri og lignende artikler",
                    "shortName": "Bijouterivareproduksjon mv.",
                    "level": 5,
                    "parentCode": "32.13"
                  }
                ]
              }
            ]
          },
          {
            "code": "32.2",
            "name": "Produksjon av musikkinstrumenter",
            "shortName": "Musikkinstrumentproduksjon",
            "level": 3,
            "parentCode": "32",
            "children": [
              {
                "code": "32.20",
                "name": "Produksjon av musikkinstrumenter",
                "shortName": "Musikkinstrumentproduksjon",
                "level": 4,
                "parentCode": "32.2",
                "children": [
                  {
                    "code": "32.200",
                    "name": "Produksjon av musikkinstrumenter",
                    "shortName": "Musikkinstrumentproduksjon",
                    "level": 5,
                    "parentCode": "32.20"
                  }
                ]
              }
            ]
          },
          {
            "code": "32.3",
            "name": "Produksjon av sportsartikler",
            "shortName": "Sportsartikkelproduksjon",
            "level": 3,
            "parentCode": "32",
            "children": [
              {
                "code": "32.30",
                "name": "Produksjon av sportsartikler",
                "shortName": "Sportsartikkelproduksjon",
                "level": 4,
                "parentCode": "32.3",
                "children": [
                  {
                    "code": "32.300",
                    "name": "Produksjon av sportsartikler",
                    "shortName": "Sportsartikkelproduksjon",
                    "level": 5,
                    "parentCode": "32.30"
                  }
                ]
              }
            ]
          },
          {
            "code": "32.4",
            "name": "Produksjon av spill og leker",
            "shortName": "Spill- og leketøyproduksjon",
            "level": 3,
            "parentCode": "32",
            "children": [
              {
                "code": "32.40",
                "name": "Produksjon av spill og leker",
                "shortName": "Spill- og leketøyproduksjon",
                "level": 4,
                "parentCode": "32.4",
                "children": [
                  {
                    "code": "32.400",
                    "name": "Produksjon av spill og leker",
                    "shortName": "Spill- og leketøyproduksjon",
                    "level": 5,
                    "parentCode": "32.40"
                  }
                ]
              }
            ]
          },
          {
            "code": "32.5",
            "name": "Produksjon av medisinske og tanntekniske instrumenter og utstyr",
            "shortName": "Medisinske og tanntekniske instr.",
            "level": 3,
            "parentCode": "32",
            "children": [
              {
                "code": "32.50",
                "name": "Produksjon av medisinske og tanntekniske instrumenter og utstyr",
                "shortName": "Medisinske og tanntekniske instr.",
                "level": 4,
                "parentCode": "32.5",
                "children": [
                  {
                    "code": "32.500",
                    "name": "Produksjon av medisinske og tanntekniske instrumenter og utstyr",
                    "shortName": "Medisinske og tanntekniske instr.",
                    "level": 5,
                    "parentCode": "32.50"
                  }
                ]
              }
            ]
          },
          {
            "code": "32.9",
            "name": "Industriproduksjon ikke nevnt annet sted",
            "shortName": "Industriproduksjon el.",
            "level": 3,
            "parentCode": "32",
            "children": [
              {
                "code": "32.91",
                "name": "Produksjon av koster og børster",
                "shortName": "Kost- og børsteproduksjon",
                "level": 4,
                "parentCode": "32.9",
                "children": [
                  {
                    "code": "32.910",
                    "name": "Produksjon av koster og børster",
                    "shortName": "Kost- og børsteproduksjon",
                    "level": 5,
                    "parentCode": "32.91"
                  }
                ]
              },
              {
                "code": "32.99",
                "name": "Annen industriproduksjon ikke nevnt annet sted",
                "shortName": "Industriproduksjon ellers",
                "level": 4,
                "parentCode": "32.9",
                "children": [
                  {
                    "code": "32.990",
                    "name": "Annen industriproduksjon ikke nevnt annet sted",
                    "shortName": "Industriproduksjon ellers",
                    "level": 5,
                    "parentCode": "32.99"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "33",
        "name": "Reparasjon og installasjon av maskiner og utstyr",
        "shortName": "Maskinreparasjon og -installasjon",
        "level": 2,
        "parentCode": "C",
        "children": [
          {
            "code": "33.1",
            "name": "Reparasjon av metallvarer, maskiner og utstyr",
            "shortName": "Reparasjon metallvarer, maskiner mv.",
            "level": 3,
            "parentCode": "33",
            "children": [
              {
                "code": "33.11",
                "name": "Reparasjon av bearbeidede metallprodukter",
                "shortName": "Rep. av bearbeidede metallprodukter",
                "level": 4,
                "parentCode": "33.1",
                "children": [
                  {
                    "code": "33.110",
                    "name": "Reparasjon av bearbeidede metallprodukter",
                    "shortName": "Rep. av bearbeidede metallprodukter",
                    "level": 5,
                    "parentCode": "33.11"
                  }
                ]
              },
              {
                "code": "33.12",
                "name": "Reparasjon av maskiner",
                "shortName": "Reparasjon av maskiner",
                "level": 4,
                "parentCode": "33.1",
                "children": [
                  {
                    "code": "33.120",
                    "name": "Reparasjon av maskiner",
                    "shortName": "Reparasjon av maskiner",
                    "level": 5,
                    "parentCode": "33.12"
                  }
                ]
              },
              {
                "code": "33.13",
                "name": "Reparasjon av elektronisk og optisk utstyr",
                "shortName": "Rep. av elektronisk og optisk utstyr",
                "level": 4,
                "parentCode": "33.1",
                "children": [
                  {
                    "code": "33.130",
                    "name": "Reparasjon av elektronisk og optisk utstyr",
                    "shortName": "Rep. av elektronisk og optisk utstyr",
                    "level": 5,
                    "parentCode": "33.13"
                  }
                ]
              },
              {
                "code": "33.14",
                "name": "Reparasjon av elektrisk utstyr",
                "shortName": "Rep. av elektrisk utstyr",
                "level": 4,
                "parentCode": "33.1",
                "children": [
                  {
                    "code": "33.140",
                    "name": "Reparasjon av elektrisk utstyr",
                    "shortName": "Rep. av elektrisk utstyr",
                    "level": 5,
                    "parentCode": "33.14"
                  }
                ]
              },
              {
                "code": "33.15",
                "name": "Reparasjon og vedlikehold av skip og båter",
                "shortName": "Rep./vedlikehold av skip og båter",
                "level": 4,
                "parentCode": "33.1",
                "children": [
                  {
                    "code": "33.150",
                    "name": "Reparasjon og vedlikehold av skip og båter",
                    "shortName": "Rep./vedlikehold av skip og båter",
                    "level": 5,
                    "parentCode": "33.15"
                  }
                ]
              },
              {
                "code": "33.16",
                "name": "Reparasjon og vedlikehold av luftfartøyer og romfartøyer",
                "shortName": "Rep./vedlikeh. luft- og romfartøyer",
                "level": 4,
                "parentCode": "33.1",
                "children": [
                  {
                    "code": "33.160",
                    "name": "Reparasjon og vedlikehold av luftfartøyer og romfartøyer",
                    "shortName": "Rep./vedlikeh. luft- og romfartøyer",
                    "level": 5,
                    "parentCode": "33.16"
                  }
                ]
              },
              {
                "code": "33.17",
                "name": "Reparasjon og vedlikehold av andre transportmidler",
                "shortName": "Rep./vedlikeh. av andre transportmidler",
                "level": 4,
                "parentCode": "33.1",
                "children": [
                  {
                    "code": "33.170",
                    "name": "Reparasjon og vedlikehold av andre transportmidler",
                    "shortName": "Rep./vedlikeh. av andre transportmidler",
                    "level": 5,
                    "parentCode": "33.17"
                  }
                ]
              },
              {
                "code": "33.19",
                "name": "Reparasjon av annet utstyr",
                "shortName": "Rep. av annet utstyr",
                "level": 4,
                "parentCode": "33.1",
                "children": [
                  {
                    "code": "33.190",
                    "name": "Reparasjon av annet utstyr",
                    "shortName": "Rep. av annet utstyr",
                    "level": 5,
                    "parentCode": "33.19"
                  }
                ]
              }
            ]
          },
          {
            "code": "33.2",
            "name": "Installasjon av industrimaskiner og -utstyr",
            "shortName": "Installasjon industrimask., utstyr",
            "level": 3,
            "parentCode": "33",
            "children": [
              {
                "code": "33.20",
                "name": "Installasjon av industrimaskiner og -utstyr",
                "shortName": "Installasjon industrimask. og utstyr",
                "level": 4,
                "parentCode": "33.2",
                "children": [
                  {
                    "code": "33.200",
                    "name": "Installasjon av industrimaskiner og -utstyr",
                    "shortName": "Installasjon industrimask. og utstyr",
                    "level": 5,
                    "parentCode": "33.20"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "code": "D",
    "name": "Elektrisitets-, gass-, damp- og varmtvannsforsyning",
    "shortName": "Kraftforsyning",
    "level": 1,
    "parentCode": "",
    "children": [
      {
        "code": "35",
        "name": "Elektrisitets-, gass-, damp- og varmtvannsforsyning",
        "shortName": "Kraftforsyning",
        "level": 2,
        "parentCode": "D",
        "children": [
          {
            "code": "35.1",
            "name": "Produksjon, overføring og distribusjon av elektrisitet",
            "shortName": "El.prod., overføring og distrib.",
            "level": 3,
            "parentCode": "35",
            "children": [
              {
                "code": "35.11",
                "name": "Produksjon av elektrisitet",
                "shortName": "Produksjon av elektrisitet",
                "level": 4,
                "parentCode": "35.1",
                "children": [
                  {
                    "code": "35.111",
                    "name": "Produksjon av elektrisitet fra vannkraft",
                    "shortName": "Elektrisitetsprod. fra vannkraft",
                    "level": 5,
                    "parentCode": "35.11"
                  },
                  {
                    "code": "35.112",
                    "name": "Produksjon av elektrisitet fra vindkraft",
                    "shortName": "Elektrisitetsprod. fra vindkraft",
                    "level": 5,
                    "parentCode": "35.11"
                  },
                  {
                    "code": "35.113",
                    "name": "Produksjon av elektrisitet fra biobrensel",
                    "shortName": "El. fra biobrensel",
                    "level": 5,
                    "parentCode": "35.11"
                  },
                  {
                    "code": "35.114",
                    "name": "Produksjon av elektrisitet fra naturgass",
                    "shortName": "Elektrisitetsprod. fra naturgass",
                    "level": 5,
                    "parentCode": "35.11"
                  },
                  {
                    "code": "35.119",
                    "name": "Produksjon av elektrisitet ellers",
                    "shortName": "Elektrisitetsprod. ellers",
                    "level": 5,
                    "parentCode": "35.11"
                  }
                ]
              },
              {
                "code": "35.12",
                "name": "Overføring av elektrisitet",
                "shortName": "Overføring av elektrisitet",
                "level": 4,
                "parentCode": "35.1",
                "children": [
                  {
                    "code": "35.120",
                    "name": "Overføring av elektrisitet",
                    "shortName": "Overføring av elektrisitet",
                    "level": 5,
                    "parentCode": "35.12"
                  }
                ]
              },
              {
                "code": "35.13",
                "name": "Distribusjon av elektrisitet",
                "shortName": "Distribusjon av elektrisitet",
                "level": 4,
                "parentCode": "35.1",
                "children": [
                  {
                    "code": "35.130",
                    "name": "Distribusjon av elektrisitet",
                    "shortName": "Distribusjon av elektrisitet",
                    "level": 5,
                    "parentCode": "35.13"
                  }
                ]
              },
              {
                "code": "35.14",
                "name": "Handel med elektrisitet",
                "shortName": "Handel med elektrisitet",
                "level": 4,
                "parentCode": "35.1",
                "children": [
                  {
                    "code": "35.140",
                    "name": "Handel med elektrisitet",
                    "shortName": "Handel med elektrisitet",
                    "level": 5,
                    "parentCode": "35.14"
                  }
                ]
              }
            ]
          },
          {
            "code": "35.2",
            "name": "Produksjon av gass og distribusjon av gass gjennom ledningsnett",
            "shortName": "Produksjon gass gj. ledningsnett",
            "level": 3,
            "parentCode": "35",
            "children": [
              {
                "code": "35.21",
                "name": "Produksjon av gass",
                "shortName": "Gassproduksjon",
                "level": 4,
                "parentCode": "35.2",
                "children": [
                  {
                    "code": "35.210",
                    "name": "Produksjon av gass",
                    "shortName": "Gassproduksjon",
                    "level": 5,
                    "parentCode": "35.21"
                  }
                ]
              },
              {
                "code": "35.22",
                "name": "Distribusjon av gass gjennom ledningsnett",
                "shortName": "Gassdistrib. via. ledningsnett",
                "level": 4,
                "parentCode": "35.2",
                "children": [
                  {
                    "code": "35.220",
                    "name": "Distribusjon av gass gjennom ledningsnett",
                    "shortName": "Gassdistrib. via ledningsnett",
                    "level": 5,
                    "parentCode": "35.22"
                  }
                ]
              },
              {
                "code": "35.23",
                "name": "Handel med gass gjennom ledningsnett",
                "shortName": "Handel med gass via ledningsnett",
                "level": 4,
                "parentCode": "35.2",
                "children": [
                  {
                    "code": "35.230",
                    "name": "Handel med gass gjennom ledningsnett",
                    "shortName": "Handel med gass via ledningsnett",
                    "level": 5,
                    "parentCode": "35.23"
                  }
                ]
              }
            ]
          },
          {
            "code": "35.3",
            "name": "Damp- og varmtvannsforsyning",
            "shortName": "Damp- og varmtvannsforsyning",
            "level": 3,
            "parentCode": "35",
            "children": [
              {
                "code": "35.30",
                "name": "Damp- og varmtvannsforsyning",
                "shortName": "Damp- og varmtvannsforsyning",
                "level": 4,
                "parentCode": "35.3",
                "children": [
                  {
                    "code": "35.300",
                    "name": "Damp- og varmtvannsforsyning",
                    "shortName": "Damp- og varmtvannsforsyning",
                    "level": 5,
                    "parentCode": "35.30"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "code": "E",
    "name": "Vannforsyning, avløps- og renovasjonsvirksomhet",
    "shortName": "Vann, avløp, renovasjon",
    "level": 1,
    "parentCode": "",
    "children": [
      {
        "code": "36",
        "name": "Uttak fra kilde, rensing og distribusjon av vann",
        "shortName": "Vannforsyning",
        "level": 2,
        "parentCode": "E",
        "children": [
          {
            "code": "36.0",
            "name": "Uttak fra kilde, rensing og distribusjon av vann",
            "shortName": "Vannforsyning",
            "level": 3,
            "parentCode": "36",
            "children": [
              {
                "code": "36.00",
                "name": "Uttak fra kilde, rensing og distribusjon av vann",
                "shortName": "Vannforsyning",
                "level": 4,
                "parentCode": "36.0",
                "children": [
                  {
                    "code": "36.000",
                    "name": "Uttak fra kilde, rensing og distribusjon av vann",
                    "shortName": "Vannforsyning",
                    "level": 5,
                    "parentCode": "36.00"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "37",
        "name": "Oppsamling og behandling av avløpsvann",
        "shortName": "Håndtering av avløpsvann",
        "level": 2,
        "parentCode": "E",
        "children": [
          {
            "code": "37.0",
            "name": "Oppsamling og behandling av avløpsvann",
            "shortName": "Håndtering av avløpsvann",
            "level": 3,
            "parentCode": "37",
            "children": [
              {
                "code": "37.00",
                "name": "Oppsamling og behandling av avløpsvann",
                "shortName": "Håndtering av avløpsvann",
                "level": 4,
                "parentCode": "37.0",
                "children": [
                  {
                    "code": "37.000",
                    "name": "Oppsamling og behandling av avløpsvann",
                    "shortName": "Håndtering av avløpsvann",
                    "level": 5,
                    "parentCode": "37.00"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "38",
        "name": "Innsamling, behandling, disponering og gjenvinning av avfall",
        "shortName": "Avfallshåndtering",
        "level": 2,
        "parentCode": "E",
        "children": [
          {
            "code": "38.1",
            "name": "Innsamling av avfall",
            "shortName": "Innsamling av avfall",
            "level": 3,
            "parentCode": "38",
            "children": [
              {
                "code": "38.11",
                "name": "Innsamling av ikke-farlig avfall",
                "shortName": "Innsaml. av ikke-farlig avfall",
                "level": 4,
                "parentCode": "38.1",
                "children": [
                  {
                    "code": "38.110",
                    "name": "Innsamling av ikke-farlig avfall",
                    "shortName": "Innsaml. av ikke-farlig avfall",
                    "level": 5,
                    "parentCode": "38.11"
                  }
                ]
              },
              {
                "code": "38.12",
                "name": "Innsamling av farlig avfall",
                "shortName": "Innsamling av farlig avfall",
                "level": 4,
                "parentCode": "38.1",
                "children": [
                  {
                    "code": "38.120",
                    "name": "Innsamling av farlig avfall",
                    "shortName": "Innsamling av farlig avfall",
                    "level": 5,
                    "parentCode": "38.12"
                  }
                ]
              }
            ]
          },
          {
            "code": "38.2",
            "name": "Behandling og disponering av avfall",
            "shortName": "Behandl. og disponering av avfall",
            "level": 3,
            "parentCode": "38",
            "children": [
              {
                "code": "38.21",
                "name": "Behandling og disponering av ikke-farlig avfall",
                "shortName": "Behandl. og disp. av ikke-farlig avfall",
                "level": 4,
                "parentCode": "38.2",
                "children": [
                  {
                    "code": "38.210",
                    "name": "Behandling og disponering av ikke-farlig avfall",
                    "shortName": "Behandl. og disp. av ikke-farlig avfall",
                    "level": 5,
                    "parentCode": "38.21"
                  }
                ]
              },
              {
                "code": "38.22",
                "name": "Behandling og disponering av farlig avfall",
                "shortName": "Behandl. og disp. av farlig avfall",
                "level": 4,
                "parentCode": "38.2",
                "children": [
                  {
                    "code": "38.220",
                    "name": "Behandling og disponering av farlig avfall",
                    "shortName": "Behandl. og disp. av farlig avfall",
                    "level": 5,
                    "parentCode": "38.22"
                  }
                ]
              }
            ]
          },
          {
            "code": "38.3",
            "name": "Materialgjenvinning",
            "shortName": "Materialgjenvinning",
            "level": 3,
            "parentCode": "38",
            "children": [
              {
                "code": "38.31",
                "name": "Demontering av vrakede gjenstander",
                "shortName": "Demont. av vrakede gjenstander",
                "level": 4,
                "parentCode": "38.3",
                "children": [
                  {
                    "code": "38.310",
                    "name": "Demontering av vrakede gjenstander",
                    "shortName": "Demont. av vrakede gjenstander",
                    "level": 5,
                    "parentCode": "38.31"
                  }
                ]
              },
              {
                "code": "38.32",
                "name": "Sortering og bearbeiding av avfall for materialgjenvinning",
                "shortName": "Sort./bearb. avfall for matr.gjenv.",
                "level": 4,
                "parentCode": "38.3",
                "children": [
                  {
                    "code": "38.320",
                    "name": "Sortering og bearbeiding av avfall for materialgjenvinning",
                    "shortName": "Sort./bearb. avfall for matr.gjenv.",
                    "level": 5,
                    "parentCode": "38.32"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "39",
        "name": "Miljørydding, miljørensing og lignende virksomhet",
        "shortName": "Miljørydding og miljørensing",
        "level": 2,
        "parentCode": "E",
        "children": [
          {
            "code": "39.0",
            "name": "Miljørydding, miljørensing og lignende virksomhet",
            "shortName": "Miljørydding og miljørensing",
            "level": 3,
            "parentCode": "39",
            "children": [
              {
                "code": "39.00",
                "name": "Miljørydding, miljørensing og lignende virksomhet",
                "shortName": "Miljørydding og miljørensing",
                "level": 4,
                "parentCode": "39.0",
                "children": [
                  {
                    "code": "39.000",
                    "name": "Miljørydding, miljørensing og lignende virksomhet",
                    "shortName": "Miljørydding og miljørensing",
                    "level": 5,
                    "parentCode": "39.00"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "code": "F",
    "name": "Bygge- og anleggsvirksomhet",
    "shortName": "Bygge- og anleggsvirksomhet",
    "level": 1,
    "parentCode": "",
    "children": [
      {
        "code": "41",
        "name": "Oppføring av bygninger",
        "shortName": "Oppføring av bygninger",
        "level": 2,
        "parentCode": "F",
        "children": [
          {
            "code": "41.1",
            "name": "Utvikling av byggeprosjekter",
            "shortName": "Utvikling av byggeprosjekter",
            "level": 3,
            "parentCode": "41",
            "children": [
              {
                "code": "41.10",
                "name": "Utvikling av byggeprosjekter",
                "shortName": "Utvikling av byggeprosjekter",
                "level": 4,
                "parentCode": "41.1",
                "children": [
                  {
                    "code": "41.101",
                    "name": "Boligbyggelag",
                    "shortName": "Boligbyggelag",
                    "level": 5,
                    "parentCode": "41.10"
                  },
                  {
                    "code": "41.109",
                    "name": "Utvikling og salg av egen fast eiendom ellers",
                    "shortName": "Utvikl./salg av egen fast eiendom",
                    "level": 5,
                    "parentCode": "41.10"
                  }
                ]
              }
            ]
          },
          {
            "code": "41.2",
            "name": "Oppføring av bygninger",
            "shortName": "Oppføring av bygninger",
            "level": 3,
            "parentCode": "41",
            "children": [
              {
                "code": "41.20",
                "name": "Oppføring av bygninger",
                "shortName": "Oppføring av bygninger",
                "level": 4,
                "parentCode": "41.2",
                "children": [
                  {
                    "code": "41.200",
                    "name": "Oppføring av bygninger",
                    "shortName": "Oppføring av bygninger",
                    "level": 5,
                    "parentCode": "41.20"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "42",
        "name": "Anleggsvirksomhet",
        "shortName": "Anleggsvirksomhet",
        "level": 2,
        "parentCode": "F",
        "children": [
          {
            "code": "42.1",
            "name": "Bygging av veier og jernbaner",
            "shortName": "Bygging av veier og jernbaner",
            "level": 3,
            "parentCode": "42",
            "children": [
              {
                "code": "42.11",
                "name": "Bygging av veier og motorveier",
                "shortName": "Bygging av veier og motorveier",
                "level": 4,
                "parentCode": "42.1",
                "children": [
                  {
                    "code": "42.110",
                    "name": "Bygging av veier og motorveier",
                    "shortName": "Bygging av veier og motorveier",
                    "level": 5,
                    "parentCode": "42.11"
                  }
                ]
              },
              {
                "code": "42.12",
                "name": "Bygging av jernbaner og undergrunnsbaner",
                "shortName": "Bygg. av jernbaner/undergrunnsbaner",
                "level": 4,
                "parentCode": "42.1",
                "children": [
                  {
                    "code": "42.120",
                    "name": "Bygging av jernbaner og undergrunnsbaner",
                    "shortName": "Bygg. av jernbaner/undergrunnsbaner",
                    "level": 5,
                    "parentCode": "42.12"
                  }
                ]
              },
              {
                "code": "42.13",
                "name": "Bygging av bruer og tunneler",
                "shortName": "Bygging av bruer og tunneler",
                "level": 4,
                "parentCode": "42.1",
                "children": [
                  {
                    "code": "42.130",
                    "name": "Bygging av bruer og tunneler",
                    "shortName": "Bygging av bruer og tunneler",
                    "level": 5,
                    "parentCode": "42.13"
                  }
                ]
              }
            ]
          },
          {
            "code": "42.2",
            "name": "Bygging av vann- og kloakkanlegg, og anlegg for elektrisitet og telekommunikasjon",
            "shortName": "Vann-/kloakk-, el-. og telekom. anl.",
            "level": 3,
            "parentCode": "42",
            "children": [
              {
                "code": "42.21",
                "name": "Bygging av vann- og kloakkanlegg",
                "shortName": "Bygging av vann- og kloakkanl.",
                "level": 4,
                "parentCode": "42.2",
                "children": [
                  {
                    "code": "42.210",
                    "name": "Bygging av vann- og kloakkanlegg",
                    "shortName": "Bygging av vann- og kloakkanl.",
                    "level": 5,
                    "parentCode": "42.21"
                  }
                ]
              },
              {
                "code": "42.22",
                "name": "Bygging av anlegg for elektrisitet og telekommunikasjon",
                "shortName": "Bygg. av el.anl. og telekomm.anl.",
                "level": 4,
                "parentCode": "42.2",
                "children": [
                  {
                    "code": "42.220",
                    "name": "Bygging av anlegg for elektrisitet og telekommunikasjon",
                    "shortName": "Bygg. av el.anl. og telekomm.anl.",
                    "level": 5,
                    "parentCode": "42.22"
                  }
                ]
              }
            ]
          },
          {
            "code": "42.9",
            "name": "Bygging av andre anlegg",
            "shortName": "Bygging av andre anlegg",
            "level": 3,
            "parentCode": "42",
            "children": [
              {
                "code": "42.91",
                "name": "Bygging av havne- og damanlegg",
                "shortName": "Bygging av havne- og damanlegg",
                "level": 4,
                "parentCode": "42.9",
                "children": [
                  {
                    "code": "42.910",
                    "name": "Bygging av havne- og damanlegg",
                    "shortName": "Bygging av havne- og damanlegg",
                    "level": 5,
                    "parentCode": "42.91"
                  }
                ]
              },
              {
                "code": "42.99",
                "name": "Bygging av andre anlegg ikke nevnt annet sted",
                "shortName": "Bygging av andre anlegg",
                "level": 4,
                "parentCode": "42.9",
                "children": [
                  {
                    "code": "42.990",
                    "name": "Bygging av andre anlegg ikke nevnt annet sted",
                    "shortName": "Bygging av andre anlegg",
                    "level": 5,
                    "parentCode": "42.99"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "43",
        "name": "Spesialisert bygge- og anleggsvirksomhet",
        "shortName": "Spes. bygge- og anleggsvirksomhet",
        "level": 2,
        "parentCode": "F",
        "children": [
          {
            "code": "43.1",
            "name": "Riving og grunnarbeid",
            "shortName": "Riving og grunnarbeid",
            "level": 3,
            "parentCode": "43",
            "children": [
              {
                "code": "43.11",
                "name": "Riving av bygninger og andre konstruksjoner",
                "shortName": "Riv. av bygn./andre konstruksjoner",
                "level": 4,
                "parentCode": "43.1",
                "children": [
                  {
                    "code": "43.110",
                    "name": "Riving av bygninger og andre konstruksjoner",
                    "shortName": "Riv. av bygn./andre konstruksjoner",
                    "level": 5,
                    "parentCode": "43.11"
                  }
                ]
              },
              {
                "code": "43.12",
                "name": "Grunnarbeid",
                "shortName": "Grunnarbeid",
                "level": 4,
                "parentCode": "43.1",
                "children": [
                  {
                    "code": "43.120",
                    "name": "Grunnarbeid",
                    "shortName": "Grunnarbeid",
                    "level": 5,
                    "parentCode": "43.12"
                  }
                ]
              },
              {
                "code": "43.13",
                "name": "Prøveboring",
                "shortName": "Prøveboring",
                "level": 4,
                "parentCode": "43.1",
                "children": [
                  {
                    "code": "43.130",
                    "name": "Prøveboring",
                    "shortName": "Prøveboring",
                    "level": 5,
                    "parentCode": "43.13"
                  }
                ]
              }
            ]
          },
          {
            "code": "43.2",
            "name": "Elektrisk installasjonsarbeid, VVS-arbeid og annet installasjonsarbeid",
            "shortName": "El. install., VVS, annet installarb.",
            "level": 3,
            "parentCode": "43",
            "children": [
              {
                "code": "43.21",
                "name": "Elektrisk installasjonsarbeid",
                "shortName": "Elektrisk installasjonsarbeid",
                "level": 4,
                "parentCode": "43.2",
                "children": [
                  {
                    "code": "43.210",
                    "name": "Elektrisk installasjonsarbeid",
                    "shortName": "Elektrisk installasjonsarbeid",
                    "level": 5,
                    "parentCode": "43.21"
                  }
                ]
              },
              {
                "code": "43.22",
                "name": "VVS-arbeid",
                "shortName": "VVS-arbeid",
                "level": 4,
                "parentCode": "43.2",
                "children": [
                  {
                    "code": "43.221",
                    "name": "Rørleggerarbeid",
                    "shortName": "Rørleggerarbeid",
                    "level": 5,
                    "parentCode": "43.22"
                  },
                  {
                    "code": "43.222",
                    "name": "Kuldeanlegg- og varmepumpearbeid",
                    "shortName": "Kuldeanlegg- og varmepumpearbeid",
                    "level": 5,
                    "parentCode": "43.22"
                  },
                  {
                    "code": "43.223",
                    "name": "Ventilasjonsarbeid",
                    "shortName": "Ventilasjonsarbeid",
                    "level": 5,
                    "parentCode": "43.22"
                  }
                ]
              },
              {
                "code": "43.29",
                "name": "Annet installasjonsarbeid",
                "shortName": "Annet installasjonsarbeid",
                "level": 4,
                "parentCode": "43.2",
                "children": [
                  {
                    "code": "43.290",
                    "name": "Annet installasjonsarbeid",
                    "shortName": "Annet installasjonsarbeid",
                    "level": 5,
                    "parentCode": "43.29"
                  }
                ]
              }
            ]
          },
          {
            "code": "43.3",
            "name": "Ferdiggjøring av bygninger",
            "shortName": "Ferdiggjøring av bygninger",
            "level": 3,
            "parentCode": "43",
            "children": [
              {
                "code": "43.31",
                "name": "Stukkatørarbeid og pussing",
                "shortName": "Stukkatørarbeid og pussing",
                "level": 4,
                "parentCode": "43.3",
                "children": [
                  {
                    "code": "43.310",
                    "name": "Stukkatørarbeid og pussing",
                    "shortName": "Stukkatørarbeid og pussing",
                    "level": 5,
                    "parentCode": "43.31"
                  }
                ]
              },
              {
                "code": "43.32",
                "name": "Snekkerarbeid",
                "shortName": "Snekkerarbeid",
                "level": 4,
                "parentCode": "43.3",
                "children": [
                  {
                    "code": "43.320",
                    "name": "Snekkerarbeid",
                    "shortName": "Snekkerarbeid",
                    "level": 5,
                    "parentCode": "43.32"
                  }
                ]
              },
              {
                "code": "43.33",
                "name": "Gulvlegging og tapetsering",
                "shortName": "Gulvlegging og tapetsering",
                "level": 4,
                "parentCode": "43.3",
                "children": [
                  {
                    "code": "43.330",
                    "name": "Gulvlegging og tapetsering",
                    "shortName": "Gulvlegging og tapetsering",
                    "level": 5,
                    "parentCode": "43.33"
                  }
                ]
              },
              {
                "code": "43.34",
                "name": "Maler- og glassarbeid",
                "shortName": "Maler- og glassarbeid",
                "level": 4,
                "parentCode": "43.3",
                "children": [
                  {
                    "code": "43.341",
                    "name": "Malerarbeid",
                    "shortName": "Malerarbeid",
                    "level": 5,
                    "parentCode": "43.34"
                  },
                  {
                    "code": "43.342",
                    "name": "Glassarbeid",
                    "shortName": "Glassarbeid",
                    "level": 5,
                    "parentCode": "43.34"
                  }
                ]
              },
              {
                "code": "43.39",
                "name": "Annen ferdiggjøring av bygninger",
                "shortName": "Annen ferdiggjøring av bygninger",
                "level": 4,
                "parentCode": "43.3",
                "children": [
                  {
                    "code": "43.390",
                    "name": "Annen ferdiggjøring av bygninger",
                    "shortName": "Annen ferdiggjøring av bygninger",
                    "level": 5,
                    "parentCode": "43.39"
                  }
                ]
              }
            ]
          },
          {
            "code": "43.9",
            "name": "Annen spesialisert bygge- og anleggsvirksomhet",
            "shortName": "Annen spes. bygge- og anleggsvirks.",
            "level": 3,
            "parentCode": "43",
            "children": [
              {
                "code": "43.91",
                "name": "Takarbeid",
                "shortName": "Takarbeid",
                "level": 4,
                "parentCode": "43.9",
                "children": [
                  {
                    "code": "43.911",
                    "name": "Blikkenslagerarbeid",
                    "shortName": "Blikkenslagerarbeid",
                    "level": 5,
                    "parentCode": "43.91"
                  },
                  {
                    "code": "43.919",
                    "name": "Takarbeid ellers",
                    "shortName": "Takarbeid ellers",
                    "level": 5,
                    "parentCode": "43.91"
                  }
                ]
              },
              {
                "code": "43.99",
                "name": "Annen spesialisert bygge- og anleggsvirksomhet",
                "shortName": "Annen spes. bygge- og anleggsvirks.",
                "level": 4,
                "parentCode": "43.9",
                "children": [
                  {
                    "code": "43.990",
                    "name": "Annen spesialisert bygge- og anleggsvirksomhet",
                    "shortName": "Annen spes. bygge- og anleggsvirks.",
                    "level": 5,
                    "parentCode": "43.99"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "code": "G",
    "name": "Varehandel, reparasjon av motorvogner",
    "shortName": "Varehandel, bilverksteder",
    "level": 1,
    "parentCode": "",
    "children": [
      {
        "code": "45",
        "name": "Handel med og reparasjon av motorvogner",
        "shortName": "Kjøretøyreparasjoner og -handel",
        "level": 2,
        "parentCode": "G",
        "children": [
          {
            "code": "45.1",
            "name": "Handel med motorvogner, unntatt motorsykler",
            "shortName": "Motorvognhandel, unnt. motorsykler",
            "level": 3,
            "parentCode": "45",
            "children": [
              {
                "code": "45.11",
                "name": "Handel med biler og lette motorvogner, unntatt motorsykler",
                "shortName": "Handel med biler og lette motorv.",
                "level": 4,
                "parentCode": "45.1",
                "children": [
                  {
                    "code": "45.111",
                    "name": "Agentur- og engroshandel med biler og lette motorvogner, unntatt motorsykler",
                    "shortName": "Agentur/engros biler/unnt. motorsyk",
                    "level": 5,
                    "parentCode": "45.11"
                  },
                  {
                    "code": "45.112",
                    "name": "Detaljhandel med biler og lette motorvogner, unntatt motorsykler",
                    "shortName": "Detaljh. biler, unnt. motorsykler",
                    "level": 5,
                    "parentCode": "45.11"
                  }
                ]
              },
              {
                "code": "45.19",
                "name": "Handel med andre motorvogner, unntatt motorsykler",
                "shortName": "Handel med andre motorvogner",
                "level": 4,
                "parentCode": "45.1",
                "children": [
                  {
                    "code": "45.191",
                    "name": "Agentur- og engroshandel med andre motorvogner, unntatt motorsykler",
                    "shortName": "Agentur/engros motorvogner el.",
                    "level": 5,
                    "parentCode": "45.19"
                  },
                  {
                    "code": "45.192",
                    "name": "Detaljhandel med andre motorvogner, unntatt motorsykler",
                    "shortName": "Detaljh. motorvogner el.",
                    "level": 5,
                    "parentCode": "45.19"
                  }
                ]
              }
            ]
          },
          {
            "code": "45.2",
            "name": "Vedlikehold og reparasjon av motorvogner, unntatt motorsykler",
            "shortName": "Rep. av motorvogner/unnt. motorsyk.",
            "level": 3,
            "parentCode": "45",
            "children": [
              {
                "code": "45.20",
                "name": "Vedlikehold og reparasjon av motorvogner, unntatt motorsykler",
                "shortName": "Rep. av motorvogner/unnt. motorsyk.",
                "level": 4,
                "parentCode": "45.2",
                "children": [
                  {
                    "code": "45.200",
                    "name": "Vedlikehold og reparasjon av motorvogner, unntatt motorsykler",
                    "shortName": "Rep. av motorvogner/unnt. motorsyk.",
                    "level": 5,
                    "parentCode": "45.20"
                  }
                ]
              }
            ]
          },
          {
            "code": "45.3",
            "name": "Handel med deler og utstyr til motorvogner, unntatt motorsykler",
            "shortName": "Del-/utstyrshdl. til motorvogner",
            "level": 3,
            "parentCode": "45",
            "children": [
              {
                "code": "45.31",
                "name": "Agentur- og engroshandel med deler og utstyr til motorvogner, unntatt motorsykler",
                "shortName": "Agent.-/engrosh. motorv./-deler mv.",
                "level": 4,
                "parentCode": "45.3",
                "children": [
                  {
                    "code": "45.310",
                    "name": "Agentur- og engroshandel med deler og utstyr til motorvogner, unntatt motorsykler",
                    "shortName": "Agent.-/engrosh. motorv./-deler mv.",
                    "level": 5,
                    "parentCode": "45.31"
                  }
                ]
              },
              {
                "code": "45.32",
                "name": "Detaljhandel med deler og utstyr til motorvogner, unntatt motorsykler",
                "shortName": "Detalj. deler/utstyr til motorvogn",
                "level": 4,
                "parentCode": "45.3",
                "children": [
                  {
                    "code": "45.320",
                    "name": "Detaljhandel med deler og utstyr til motorvogner, unntatt motorsykler",
                    "shortName": "Detalj. deler/utstyr til motorvogn",
                    "level": 5,
                    "parentCode": "45.32"
                  }
                ]
              }
            ]
          },
          {
            "code": "45.4",
            "name": "Handel med motorsykler, deler og utstyr. Vedlikehold og reparasjon av motorsykler",
            "shortName": "Motorsykkelhandel og -rep. mv.",
            "level": 3,
            "parentCode": "45",
            "children": [
              {
                "code": "45.40",
                "name": "Handel med motorsykler, deler og utstyr. Vedlikehold og reparasjon av motorsykler",
                "shortName": "Motorsykkelhandel og -rep. mv.",
                "level": 4,
                "parentCode": "45.4",
                "children": [
                  {
                    "code": "45.401",
                    "name": "Agentur- og engroshandel med motorsykler, deler og utstyr",
                    "shortName": "Agentur-/engrosh. motorsykler",
                    "level": 5,
                    "parentCode": "45.40"
                  },
                  {
                    "code": "45.402",
                    "name": "Detaljhandel med motorsykler, deler og utstyr",
                    "shortName": "Detaljh. motorsykler mv.",
                    "level": 5,
                    "parentCode": "45.40"
                  },
                  {
                    "code": "45.403",
                    "name": "Vedlikehold og reparasjon av motorsykler",
                    "shortName": "Motorsykkelvedlikehold og -rep.",
                    "level": 5,
                    "parentCode": "45.40"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "46",
        "name": "Agentur- og engroshandel, unntatt med motorvogner",
        "shortName": "Agentur- og engroshandel",
        "level": 2,
        "parentCode": "G",
        "children": [
          {
            "code": "46.1",
            "name": "Agenturhandel",
            "shortName": "Agenturhandel",
            "level": 3,
            "parentCode": "46",
            "children": [
              {
                "code": "46.11",
                "name": "Agenturhandel med jordbruksråvarer, levende dyr, tekstilråvarer og innsatsvarer",
                "shortName": "Agentur jordbr. og tekstilråv. mv.",
                "level": 4,
                "parentCode": "46.1",
                "children": [
                  {
                    "code": "46.110",
                    "name": "Agenturhandel med jordbruksråvarer, levende dyr, tekstilråvarer og innsatsvarer",
                    "shortName": "Agentur jordbr. og tekstilråv. mv.",
                    "level": 5,
                    "parentCode": "46.11"
                  }
                ]
              },
              {
                "code": "46.12",
                "name": "Agenturhandel med brensel, drivstoff, malm, metaller og industrikjemikalier",
                "shortName": "Agentur brensel, drivstoff mv.",
                "level": 4,
                "parentCode": "46.1",
                "children": [
                  {
                    "code": "46.120",
                    "name": "Agenturhandel med brensel, drivstoff, malm, metaller og industrikjemikalier",
                    "shortName": "Agentur brensel, drivstoff mv.",
                    "level": 5,
                    "parentCode": "46.12"
                  }
                ]
              },
              {
                "code": "46.13",
                "name": "Agenturhandel med tømmer, trelast og byggevarer",
                "shortName": "Agentur tømmer, trelast, byggev.",
                "level": 4,
                "parentCode": "46.1",
                "children": [
                  {
                    "code": "46.130",
                    "name": "Agenturhandel med tømmer, trelast og byggevarer",
                    "shortName": "Agentur tømmer. trelast, byggev.",
                    "level": 5,
                    "parentCode": "46.13"
                  }
                ]
              },
              {
                "code": "46.14",
                "name": "Agenturhandel med maskiner, produksjonsutstyr, båter og luftfartøyer",
                "shortName": "Agentur maskiner, prod.utstyr mv.",
                "level": 4,
                "parentCode": "46.1",
                "children": [
                  {
                    "code": "46.140",
                    "name": "Agenturhandel med maskiner, produksjonsutstyr, båter og luftfartøyer",
                    "shortName": "Agentur maskiner, prod.utstyr mv.",
                    "level": 5,
                    "parentCode": "46.14"
                  }
                ]
              },
              {
                "code": "46.15",
                "name": "Agenturhandel med møbler, husholdningsvarer og jernvarer",
                "shortName": "Agentur møbler, hush.- og jernvarer",
                "level": 4,
                "parentCode": "46.1",
                "children": [
                  {
                    "code": "46.150",
                    "name": "Agenturhandel med møbler, husholdningsvarer og jernvarer",
                    "shortName": "Agentur møbler, hush.- og jernvarer",
                    "level": 5,
                    "parentCode": "46.15"
                  }
                ]
              },
              {
                "code": "46.16",
                "name": "Agenturhandel med tekstiler, klær, pelsskinn, skotøy og lærvarer",
                "shortName": "Agentur tekstiler/klær/skotøy mv.",
                "level": 4,
                "parentCode": "46.1",
                "children": [
                  {
                    "code": "46.160",
                    "name": "Agenturhandel med tekstiler, klær, pelsskinn, skotøy og lærvarer",
                    "shortName": "Agentur tekstiler/klær/skotøy mv.",
                    "level": 5,
                    "parentCode": "46.16"
                  }
                ]
              },
              {
                "code": "46.17",
                "name": "Agenturhandel med nærings- og nytelsesmidler",
                "shortName": "Agentur nærings- og nytelsesmidler",
                "level": 4,
                "parentCode": "46.1",
                "children": [
                  {
                    "code": "46.170",
                    "name": "Agenturhandel med nærings- og nytelsesmidler",
                    "shortName": "Agentur nærings- og nytelsesmidler",
                    "level": 5,
                    "parentCode": "46.17"
                  }
                ]
              },
              {
                "code": "46.18",
                "name": "Agenturhandel med spesialisert vareutvalg ellers",
                "shortName": "Agentur spesialisert vareutvalg el.",
                "level": 4,
                "parentCode": "46.1",
                "children": [
                  {
                    "code": "46.180",
                    "name": "Agenturhandel med spesialisert vareutvalg ellers",
                    "shortName": "Agentur spesialisert vareutvalg el.",
                    "level": 5,
                    "parentCode": "46.18"
                  }
                ]
              },
              {
                "code": "46.19",
                "name": "Agenturhandel med bredt vareutvalg",
                "shortName": "Agentur bredt vareutvalg",
                "level": 4,
                "parentCode": "46.1",
                "children": [
                  {
                    "code": "46.190",
                    "name": "Agenturhandel med bredt vareutvalg",
                    "shortName": "Agentur bredt vareutvalg",
                    "level": 5,
                    "parentCode": "46.19"
                  }
                ]
              }
            ]
          },
          {
            "code": "46.2",
            "name": "Engroshandel med jordbruksråvarer og levende dyr",
            "shortName": "Engrosh. jordbr.råvarer og lev. dyr",
            "level": 3,
            "parentCode": "46",
            "children": [
              {
                "code": "46.21",
                "name": "Engroshandel med korn, råtobakk, såvarer og fôrvarer",
                "shortName": "Engrosh. korn, såvarer og fôr",
                "level": 4,
                "parentCode": "46.2",
                "children": [
                  {
                    "code": "46.210",
                    "name": "Engroshandel med korn, råtobakk, såvarer og fôrvarer",
                    "shortName": "Engrosh. korn, såvarer og fôr",
                    "level": 5,
                    "parentCode": "46.21"
                  }
                ]
              },
              {
                "code": "46.22",
                "name": "Engroshandel med blomster og planter",
                "shortName": "Engrosh. blomster og planter",
                "level": 4,
                "parentCode": "46.2",
                "children": [
                  {
                    "code": "46.220",
                    "name": "Engroshandel med blomster og planter",
                    "shortName": "Engrosh. blomster og planter",
                    "level": 5,
                    "parentCode": "46.22"
                  }
                ]
              },
              {
                "code": "46.23",
                "name": "Engroshandel med levende dyr",
                "shortName": "Engrosh. levende dyr",
                "level": 4,
                "parentCode": "46.2",
                "children": [
                  {
                    "code": "46.230",
                    "name": "Engroshandel med levende dyr",
                    "shortName": "Engrosh. levende dyr",
                    "level": 5,
                    "parentCode": "46.23"
                  }
                ]
              },
              {
                "code": "46.24",
                "name": "Engroshandel med huder, skinn og lær",
                "shortName": "Engrosh. huder, skinn og lær",
                "level": 4,
                "parentCode": "46.2",
                "children": [
                  {
                    "code": "46.240",
                    "name": "Engroshandel med huder, skinn og lær",
                    "shortName": "Engrosh. huder, skinn og lær",
                    "level": 5,
                    "parentCode": "46.24"
                  }
                ]
              }
            ]
          },
          {
            "code": "46.3",
            "name": "Engroshandel med nærings- og nytelsesmidler",
            "shortName": "Engrosh., nærings- og nytelsesmidler",
            "level": 3,
            "parentCode": "46",
            "children": [
              {
                "code": "46.31",
                "name": "Engroshandel med frukt og grønnsaker",
                "shortName": "Engrosh. frukt og grønnsaker",
                "level": 4,
                "parentCode": "46.3",
                "children": [
                  {
                    "code": "46.310",
                    "name": "Engroshandel med frukt og grønnsaker",
                    "shortName": "Engrosh. frukt og grønnsaker",
                    "level": 5,
                    "parentCode": "46.31"
                  }
                ]
              },
              {
                "code": "46.32",
                "name": "Engroshandel med kjøtt og kjøttvarer",
                "shortName": "Engrosh. kjøtt og kjøttvarer",
                "level": 4,
                "parentCode": "46.3",
                "children": [
                  {
                    "code": "46.320",
                    "name": "Engroshandel med kjøtt og kjøttvarer",
                    "shortName": "Engrosh. kjøtt og kjøttvarer",
                    "level": 5,
                    "parentCode": "46.32"
                  }
                ]
              },
              {
                "code": "46.33",
                "name": "Engroshandel med meierivarer, egg, matolje og -fett",
                "shortName": "Engrosh. meierivarer, egg mv.",
                "level": 4,
                "parentCode": "46.3",
                "children": [
                  {
                    "code": "46.330",
                    "name": "Engroshandel med meierivarer, egg, matolje og -fett",
                    "shortName": "Engrosh. meierivarer, egg mv.",
                    "level": 5,
                    "parentCode": "46.33"
                  }
                ]
              },
              {
                "code": "46.34",
                "name": "Engroshandel med drikkevarer",
                "shortName": "Engrosh. drikkevarer",
                "level": 4,
                "parentCode": "46.3",
                "children": [
                  {
                    "code": "46.341",
                    "name": "Engroshandel med vin og brennevin",
                    "shortName": "Engrosh. vin og brennevin",
                    "level": 5,
                    "parentCode": "46.34"
                  },
                  {
                    "code": "46.349",
                    "name": "Engroshandel med drikkevarer ellers",
                    "shortName": "Engrosh. drikkevarer el.",
                    "level": 5,
                    "parentCode": "46.34"
                  }
                ]
              },
              {
                "code": "46.35",
                "name": "Engroshandel med tobakksvarer",
                "shortName": "Engrosh. tobakksvarer",
                "level": 4,
                "parentCode": "46.3",
                "children": [
                  {
                    "code": "46.350",
                    "name": "Engroshandel med tobakksvarer",
                    "shortName": "Engrosh. tobakksvarer",
                    "level": 5,
                    "parentCode": "46.35"
                  }
                ]
              },
              {
                "code": "46.36",
                "name": "Engroshandel med sukker, sjokolade og sukkervarer",
                "shortName": "Engrosh. sukker, sjok. og sukkerv.",
                "level": 4,
                "parentCode": "46.3",
                "children": [
                  {
                    "code": "46.360",
                    "name": "Engroshandel med sukker, sjokolade og sukkervarer",
                    "shortName": "Engrosh. sukker, sjok. og sukkerv.",
                    "level": 5,
                    "parentCode": "46.36"
                  }
                ]
              },
              {
                "code": "46.37",
                "name": "Engroshandel med kaffe, te, kakao og krydder",
                "shortName": "Engrosh. kaffe, te, kakao mv.",
                "level": 4,
                "parentCode": "46.3",
                "children": [
                  {
                    "code": "46.370",
                    "name": "Engroshandel med kaffe, te, kakao og krydder",
                    "shortName": "Engrosh. kaffe, te, kakao mv.",
                    "level": 5,
                    "parentCode": "46.37"
                  }
                ]
              },
              {
                "code": "46.38",
                "name": "Engroshandel med andre næringsmidler, herunder fisk, skalldyr og bløtdyr",
                "shortName": "Engrosh. andre næringsmidler",
                "level": 4,
                "parentCode": "46.3",
                "children": [
                  {
                    "code": "46.381",
                    "name": "Engroshandel med fisk, skalldyr og bløtdyr",
                    "shortName": "Engrosh. fisk og skalldyr",
                    "level": 5,
                    "parentCode": "46.38"
                  },
                  {
                    "code": "46.389",
                    "name": "Engroshandel med spesialisert utvalg av nærings- og nytelsesmidler ikke nevnt annet sted",
                    "shortName": "Engrosh. spes. utv. nær.-/nyt.midl.",
                    "level": 5,
                    "parentCode": "46.38"
                  }
                ]
              },
              {
                "code": "46.39",
                "name": "Engroshandel med bredt utvalg av nærings- og nytelsesmidler",
                "shortName": "Engrosh. bredt utv. nær.-/nyt. midl",
                "level": 4,
                "parentCode": "46.3",
                "children": [
                  {
                    "code": "46.390",
                    "name": "Engroshandel med bredt utvalg av nærings- og nytelsesmidler",
                    "shortName": "Engrosh. bredt utv. nær.-/nyt.midl.",
                    "level": 5,
                    "parentCode": "46.39"
                  }
                ]
              }
            ]
          },
          {
            "code": "46.4",
            "name": "Engroshandel med husholdningsvarer og varer til personlig bruk",
            "shortName": "Engrosh. hush.- og varer pers. bruk",
            "level": 3,
            "parentCode": "46",
            "children": [
              {
                "code": "46.41",
                "name": "Engroshandel med tekstiler og utstyrsvarer",
                "shortName": "Engrosh. tekstiler og utstyrsvarer",
                "level": 4,
                "parentCode": "46.4",
                "children": [
                  {
                    "code": "46.410",
                    "name": "Engroshandel med tekstiler og utstyrsvarer",
                    "shortName": "Engrosh. tekstiler og utstyrsvarer",
                    "level": 5,
                    "parentCode": "46.41"
                  }
                ]
              },
              {
                "code": "46.42",
                "name": "Engroshandel med klær og skotøy",
                "shortName": "Engrosh. klær og skotøy",
                "level": 4,
                "parentCode": "46.4",
                "children": [
                  {
                    "code": "46.421",
                    "name": "Engroshandel med klær",
                    "shortName": "Engrosh. klær",
                    "level": 5,
                    "parentCode": "46.42"
                  },
                  {
                    "code": "46.422",
                    "name": "Engroshandel med skotøy",
                    "shortName": "Engrosh. skotøy",
                    "level": 5,
                    "parentCode": "46.42"
                  }
                ]
              },
              {
                "code": "46.43",
                "name": "Engroshandel med elektriske husholdningsapparater",
                "shortName": "Engrosh. el. husholdningsapp. mv..",
                "level": 4,
                "parentCode": "46.4",
                "children": [
                  {
                    "code": "46.431",
                    "name": "Engroshandel med elektriske husholdningsapparater og -maskiner",
                    "shortName": "Engrosh. el.hush.app. og -maskiner",
                    "level": 5,
                    "parentCode": "46.43"
                  },
                  {
                    "code": "46.432",
                    "name": "Engroshandel med radio og fjernsyn",
                    "shortName": "Engrosh. radio og fjernsyn",
                    "level": 5,
                    "parentCode": "46.43"
                  },
                  {
                    "code": "46.433",
                    "name": "Engroshandel med plater, musikk- og videokassetter og CD- og DVD-plater",
                    "shortName": "Engrosh. musikk-,videokass.,CD,DVD",
                    "level": 5,
                    "parentCode": "46.43"
                  },
                  {
                    "code": "46.434",
                    "name": "Engroshandel med fotoutstyr",
                    "shortName": "Engrosh. fotoutstyr",
                    "level": 5,
                    "parentCode": "46.43"
                  },
                  {
                    "code": "46.435",
                    "name": "Engroshandel med optiske artikler",
                    "shortName": "Engrosh. optiske artikler",
                    "level": 5,
                    "parentCode": "46.43"
                  }
                ]
              },
              {
                "code": "46.44",
                "name": "Engroshandel med kjøkkenutstyr, glass, steintøy og rengjøringsmidler",
                "shortName": "Engrosh. kjøkkenutstyr, steintøy mv.",
                "level": 4,
                "parentCode": "46.4",
                "children": [
                  {
                    "code": "46.441",
                    "name": "Engroshandel med kjøkkenutstyr, glass og steintøy",
                    "shortName": "Engrosh. kjøkkenutstyr, steintøy mv.",
                    "level": 5,
                    "parentCode": "46.44"
                  },
                  {
                    "code": "46.442",
                    "name": "Engroshandel med rengjøringsmidler",
                    "shortName": "Engrosh. rengjøringsmidler",
                    "level": 5,
                    "parentCode": "46.44"
                  }
                ]
              },
              {
                "code": "46.45",
                "name": "Engroshandel med parfyme og kosmetikk",
                "shortName": "Engrosh. parfyme og kosmetikk",
                "level": 4,
                "parentCode": "46.4",
                "children": [
                  {
                    "code": "46.450",
                    "name": "Engroshandel med parfyme og kosmetikk",
                    "shortName": "Engrosh. parfyme og kosmetikk",
                    "level": 5,
                    "parentCode": "46.45"
                  }
                ]
              },
              {
                "code": "46.46",
                "name": "Engroshandel med sykepleie- og apotekvarer",
                "shortName": "Engrosh. sykepleie- og apotekvarer",
                "level": 4,
                "parentCode": "46.4",
                "children": [
                  {
                    "code": "46.460",
                    "name": "Engroshandel med sykepleie- og apotekvarer",
                    "shortName": "Engrosh. sykepleie- og apotekvarer",
                    "level": 5,
                    "parentCode": "46.46"
                  }
                ]
              },
              {
                "code": "46.47",
                "name": "Engroshandel med møbler, gulvbelegg, gulvtepper og belysningsutstyr",
                "shortName": "Engrosh. møbler og innredningsart.",
                "level": 4,
                "parentCode": "46.4",
                "children": [
                  {
                    "code": "46.471",
                    "name": "Engroshandel med møbler",
                    "shortName": "Engrosh. møbler",
                    "level": 5,
                    "parentCode": "46.47"
                  },
                  {
                    "code": "46.472",
                    "name": "Engroshandel med gulvtepper",
                    "shortName": "Engrosh. gulvtepper",
                    "level": 5,
                    "parentCode": "46.47"
                  },
                  {
                    "code": "46.473",
                    "name": "Engroshandel med belysningsutstyr",
                    "shortName": "Engrosh. belysningsutstyr",
                    "level": 5,
                    "parentCode": "46.47"
                  }
                ]
              },
              {
                "code": "46.48",
                "name": "Engroshandel med klokker, ur, gull- og sølvvarer",
                "shortName": "Engrosh. klokker/ur/gull-/sølvvarer",
                "level": 4,
                "parentCode": "46.4",
                "children": [
                  {
                    "code": "46.481",
                    "name": "Engroshandel med klokker og ur",
                    "shortName": "Engrosh. klokker og ur",
                    "level": 5,
                    "parentCode": "46.48"
                  },
                  {
                    "code": "46.482",
                    "name": "Engroshandel med gull- og sølvvarer",
                    "shortName": "Engrosh. gull- og sølvvarer",
                    "level": 5,
                    "parentCode": "46.48"
                  }
                ]
              },
              {
                "code": "46.49",
                "name": "Engroshandel med husholdningsvarer og varer til personlig bruk ellers",
                "shortName": "Engrosh. husholdningsvarer m.m.",
                "level": 4,
                "parentCode": "46.4",
                "children": [
                  {
                    "code": "46.491",
                    "name": "Engroshandel med bøker, aviser og blader",
                    "shortName": "Engrosh. bøker, aviser og blader",
                    "level": 5,
                    "parentCode": "46.49"
                  },
                  {
                    "code": "46.492",
                    "name": "Engroshandel med reiseeffekter og lærvarer",
                    "shortName": "Engrosh. reiseeffekter og lærvarer",
                    "level": 5,
                    "parentCode": "46.49"
                  },
                  {
                    "code": "46.493",
                    "name": "Engroshandel med fritidsbåter og -utstyr",
                    "shortName": "Engrosh. fritidsbåter og -utstyr",
                    "level": 5,
                    "parentCode": "46.49"
                  },
                  {
                    "code": "46.494",
                    "name": "Engroshandel med sportsutstyr",
                    "shortName": "Engrosh. sportsutstyr",
                    "level": 5,
                    "parentCode": "46.49"
                  },
                  {
                    "code": "46.495",
                    "name": "Engroshandel med spill og leker",
                    "shortName": "Engrosh. spill og leker",
                    "level": 5,
                    "parentCode": "46.49"
                  },
                  {
                    "code": "46.499",
                    "name": "Engroshandel med husholdningsvarer og varer til personlig bruk ikke nevnt annet sted",
                    "shortName": "Engrosh. hush.varer ellers",
                    "level": 5,
                    "parentCode": "46.49"
                  }
                ]
              }
            ]
          },
          {
            "code": "46.5",
            "name": "Engroshandel med IKT-utstyr",
            "shortName": "Engrosh. IKT-utstyr",
            "level": 3,
            "parentCode": "46",
            "children": [
              {
                "code": "46.51",
                "name": "Engroshandel med datamaskiner, tilleggsutstyr til datamaskiner samt programvare",
                "shortName": "Engrosh. datamask., programv. mv..",
                "level": 4,
                "parentCode": "46.5",
                "children": [
                  {
                    "code": "46.510",
                    "name": "Engroshandel med datamaskiner, tilleggsutstyr til datamaskiner samt programvare",
                    "shortName": "Engrosh. datamask., programv. mv.",
                    "level": 5,
                    "parentCode": "46.51"
                  }
                ]
              },
              {
                "code": "46.52",
                "name": "Engroshandel med elektronikkutstyr og telekommunikasjonsutstyr samt deler",
                "shortName": "Engrosh. elektronikk-/telekomm.uts.",
                "level": 4,
                "parentCode": "46.5",
                "children": [
                  {
                    "code": "46.520",
                    "name": "Engroshandel med elektronikkutstyr og telekommunikasjonsutstyr samt deler",
                    "shortName": "Engrosh. elektronikk-/telekomm.uts.",
                    "level": 5,
                    "parentCode": "46.52"
                  }
                ]
              }
            ]
          },
          {
            "code": "46.6",
            "name": "Engroshandel med andre maskiner og annet utstyr",
            "shortName": "Engrosh. mask. og utstyr el",
            "level": 3,
            "parentCode": "46",
            "children": [
              {
                "code": "46.61",
                "name": "Engroshandel med maskiner og utstyr til jordbruk og skogbruk",
                "shortName": "Engrosh. jordbr.-/skogbr.mask. mv.",
                "level": 4,
                "parentCode": "46.6",
                "children": [
                  {
                    "code": "46.610",
                    "name": "Engroshandel med maskiner og utstyr til jordbruk og skogbruk",
                    "shortName": "Engrosh. jordbr.-/skogbr.mask. mv.",
                    "level": 5,
                    "parentCode": "46.61"
                  }
                ]
              },
              {
                "code": "46.62",
                "name": "Engroshandel med maskinverktøy",
                "shortName": "Engrosh. maskinverktøy",
                "level": 4,
                "parentCode": "46.6",
                "children": [
                  {
                    "code": "46.620",
                    "name": "Engroshandel med maskinverktøy",
                    "shortName": "Engrosh. maskinverktøy",
                    "level": 5,
                    "parentCode": "46.62"
                  }
                ]
              },
              {
                "code": "46.63",
                "name": "Engroshandel med maskiner og utstyr til bergverksdrift, olje- og gassutvinning og bygge- og anleggsvirksomhet",
                "shortName": "Engros mask bygg/anl./oljeutv. mv.",
                "level": 4,
                "parentCode": "46.6",
                "children": [
                  {
                    "code": "46.630",
                    "name": "Engroshandel med maskiner og utstyr til bergverksdrift, olje- og gassutvinning og bygge- og anleggsvirksomhet",
                    "shortName": "Engros mask bygg/anl./oljeutv. mv.",
                    "level": 5,
                    "parentCode": "46.63"
                  }
                ]
              },
              {
                "code": "46.64",
                "name": "Engroshandel med maskiner og utstyr til tekstilproduksjon",
                "shortName": "Engrosh. tekstilprod.maskiner mv.",
                "level": 4,
                "parentCode": "46.6",
                "children": [
                  {
                    "code": "46.640",
                    "name": "Engroshandel med maskiner og utstyr til tekstilproduksjon",
                    "shortName": "Engrosh. tekstilprod.maskiner mv.",
                    "level": 5,
                    "parentCode": "46.64"
                  }
                ]
              },
              {
                "code": "46.65",
                "name": "Engroshandel med kontormøbler",
                "shortName": "Engrosh. kontormøbler",
                "level": 4,
                "parentCode": "46.6",
                "children": [
                  {
                    "code": "46.650",
                    "name": "Engroshandel med kontormøbler",
                    "shortName": "Engrosh. kontormøbler",
                    "level": 5,
                    "parentCode": "46.65"
                  }
                ]
              },
              {
                "code": "46.66",
                "name": "Engroshandel med maskiner og utstyr til kontor ellers",
                "shortName": "Engrosh. kontormask., -utstyr el.",
                "level": 4,
                "parentCode": "46.6",
                "children": [
                  {
                    "code": "46.660",
                    "name": "Engroshandel med maskiner og utstyr til kontor ellers",
                    "shortName": "Engrosh. kontormask., -utstyr el.",
                    "level": 5,
                    "parentCode": "46.66"
                  }
                ]
              },
              {
                "code": "46.69",
                "name": "Engroshandel med maskiner og utstyr ellers",
                "shortName": "Engrosh. maskiner og utstyr el.",
                "level": 4,
                "parentCode": "46.6",
                "children": [
                  {
                    "code": "46.691",
                    "name": "Engroshandel med maskiner og utstyr til kraftproduksjon og installasjon",
                    "shortName": "Engrosh. kraftprod.-,install.utstyr",
                    "level": 5,
                    "parentCode": "46.69"
                  },
                  {
                    "code": "46.692",
                    "name": "Engroshandel med skipsutstyr og fiskeredskap",
                    "shortName": "Engrosh. skipsutstyr og fiskeredsk.",
                    "level": 5,
                    "parentCode": "46.69"
                  },
                  {
                    "code": "46.693",
                    "name": "Engroshandel med maskiner og utstyr til industri ellers",
                    "shortName": "Engrosh. utstyr industri ellers",
                    "level": 5,
                    "parentCode": "46.69"
                  },
                  {
                    "code": "46.694",
                    "name": "Engroshandel med maskiner og utstyr til handel, transport og tjenesteyting ellers",
                    "shortName": "Engrosh. utstyr handel, transp. mv.",
                    "level": 5,
                    "parentCode": "46.69"
                  }
                ]
              }
            ]
          },
          {
            "code": "46.7",
            "name": "Engroshandel med spesialisert vareutvalg ellers",
            "shortName": "Engrosh. med spes. vareutvalg el.",
            "level": 3,
            "parentCode": "46",
            "children": [
              {
                "code": "46.71",
                "name": "Engroshandel med drivstoff og brensel",
                "shortName": "Engrosh. drivstoff og brensel",
                "level": 4,
                "parentCode": "46.7",
                "children": [
                  {
                    "code": "46.710",
                    "name": "Engroshandel med drivstoff og brensel",
                    "shortName": "Engrosh. drivstoff og brensel",
                    "level": 5,
                    "parentCode": "46.71"
                  }
                ]
              },
              {
                "code": "46.72",
                "name": "Engroshandel med metaller og metallholdig malm",
                "shortName": "Engrosh. metaller og metallh. malm",
                "level": 4,
                "parentCode": "46.7",
                "children": [
                  {
                    "code": "46.720",
                    "name": "Engroshandel med metaller og metallholdig malm",
                    "shortName": "Engrosh. metaller og metallh. malm",
                    "level": 5,
                    "parentCode": "46.72"
                  }
                ]
              },
              {
                "code": "46.73",
                "name": "Engroshandel med tømmer, trelast, byggevarer og sanitærutstyr",
                "shortName": "Engrosh. tømmer/trelast/byggev. mv.",
                "level": 4,
                "parentCode": "46.7",
                "children": [
                  {
                    "code": "46.731",
                    "name": "Engroshandel med tømmer",
                    "shortName": "Engrosh. tømmer",
                    "level": 5,
                    "parentCode": "46.73"
                  },
                  {
                    "code": "46.732",
                    "name": "Engroshandel med trelast",
                    "shortName": "Engrosh. trelast",
                    "level": 5,
                    "parentCode": "46.73"
                  },
                  {
                    "code": "46.733",
                    "name": "Engroshandel med fargevarer",
                    "shortName": "Engrosh. fargevarer",
                    "level": 5,
                    "parentCode": "46.73"
                  },
                  {
                    "code": "46.739",
                    "name": "Engroshandel med byggevarer ikke nevnt annet sted",
                    "shortName": "Engrosh. byggevarer el.",
                    "level": 5,
                    "parentCode": "46.73"
                  }
                ]
              },
              {
                "code": "46.74",
                "name": "Engroshandel med jernvarer, rørleggerartikler og oppvarmingsutstyr",
                "shortName": "Engrosh. jernv., rørleggerart. m.m.",
                "level": 4,
                "parentCode": "46.7",
                "children": [
                  {
                    "code": "46.740",
                    "name": "Engroshandel med jernvarer, rørleggerartikler og oppvarmingsutstyr",
                    "shortName": "Engrosh. jernv., rørleggerart. m.m.",
                    "level": 5,
                    "parentCode": "46.74"
                  }
                ]
              },
              {
                "code": "46.75",
                "name": "Engroshandel med kjemiske produkter",
                "shortName": "Engrosh. kjemiske produkter",
                "level": 4,
                "parentCode": "46.7",
                "children": [
                  {
                    "code": "46.750",
                    "name": "Engroshandel med kjemiske produkter",
                    "shortName": "Engrosh. kjemiske produkter",
                    "level": 5,
                    "parentCode": "46.75"
                  }
                ]
              },
              {
                "code": "46.76",
                "name": "Engroshandel med innsatsvarer ellers",
                "shortName": "Engrosh. innsatsvarer el.",
                "level": 4,
                "parentCode": "46.7",
                "children": [
                  {
                    "code": "46.761",
                    "name": "Engroshandel med papir og papp",
                    "shortName": "Engrosh. papir og papp",
                    "level": 5,
                    "parentCode": "46.76"
                  },
                  {
                    "code": "46.769",
                    "name": "Engroshandel med innsatsvarer ikke nevnt annet sted",
                    "shortName": "Engrosh innsatsvarer el.",
                    "level": 5,
                    "parentCode": "46.76"
                  }
                ]
              },
              {
                "code": "46.77",
                "name": "Engroshandel med avfall og skrap",
                "shortName": "Engrosh. avfall og skrap",
                "level": 4,
                "parentCode": "46.7",
                "children": [
                  {
                    "code": "46.770",
                    "name": "Engroshandel med avfall og skrap",
                    "shortName": "Engrosh. avfall og skrap",
                    "level": 5,
                    "parentCode": "46.77"
                  }
                ]
              }
            ]
          },
          {
            "code": "46.9",
            "name": "Uspesifisert engroshandel",
            "shortName": "Uspesifisert engroshandel",
            "level": 3,
            "parentCode": "46",
            "children": [
              {
                "code": "46.90",
                "name": "Uspesifisert engroshandel",
                "shortName": "Uspesifisert engroshandel",
                "level": 4,
                "parentCode": "46.9",
                "children": [
                  {
                    "code": "46.900",
                    "name": "Uspesifisert engroshandel",
                    "shortName": "Uspesifisert engroshandel",
                    "level": 5,
                    "parentCode": "46.90"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "47",
        "name": "Detaljhandel, unntatt med motorvogner",
        "shortName": "Detaljhandel, unntatt motorvogner",
        "level": 2,
        "parentCode": "G",
        "children": [
          {
            "code": "47.1",
            "name": "Butikkhandel med bredt vareutvalg",
            "shortName": "Butikkh. med bredt vareutvalg",
            "level": 3,
            "parentCode": "47",
            "children": [
              {
                "code": "47.11",
                "name": "Butikkhandel med bredt vareutvalg med hovedvekt på nærings- og nytelsesmidler",
                "shortName": "Butikkh. bredt utvalg nær.midler mv.",
                "level": 4,
                "parentCode": "47.1",
                "children": [
                  {
                    "code": "47.111",
                    "name": "Butikkhandel med bredt vareutvalg med hovedvekt på nærings- og nytelsesmidler",
                    "shortName": "Butikkh. bredt utvalg nær.midler mv.",
                    "level": 5,
                    "parentCode": "47.11"
                  },
                  {
                    "code": "47.112",
                    "name": "Kioskhandel med bredt vareutvalg med hovedvekt på nærings- og nytelsesmidler",
                    "shortName": "Kioskh. bredt utvalg nær.midler mv.",
                    "level": 5,
                    "parentCode": "47.11"
                  }
                ]
              },
              {
                "code": "47.19",
                "name": "Butikkhandel med bredt vareutvalg ellers",
                "shortName": "Butikkh. bredt vareutvalg el.",
                "level": 4,
                "parentCode": "47.1",
                "children": [
                  {
                    "code": "47.190",
                    "name": "Butikkhandel med bredt vareutvalg ellers",
                    "shortName": "Butikkh. bredt vareutvalg el.",
                    "level": 5,
                    "parentCode": "47.19"
                  }
                ]
              }
            ]
          },
          {
            "code": "47.2",
            "name": "Butikkhandel med nærings- og nytelsesmidler i spesialforretninger",
            "shortName": "Spesialforr. nær.- og nytelsesmidl.",
            "level": 3,
            "parentCode": "47",
            "children": [
              {
                "code": "47.21",
                "name": "Butikkhandel med frukt og grønnsaker",
                "shortName": "Butikkh. frukt og grønnsaker",
                "level": 4,
                "parentCode": "47.2",
                "children": [
                  {
                    "code": "47.210",
                    "name": "Butikkhandel med frukt og grønnsaker",
                    "shortName": "Butikkh. frukt og grønnsaker",
                    "level": 5,
                    "parentCode": "47.21"
                  }
                ]
              },
              {
                "code": "47.22",
                "name": "Butikkhandel med kjøtt og kjøttvarer",
                "shortName": "Butikkh. kjøtt og kjøttvarer",
                "level": 4,
                "parentCode": "47.2",
                "children": [
                  {
                    "code": "47.220",
                    "name": "Butikkhandel med kjøtt og kjøttvarer",
                    "shortName": "Butikkh. kjøtt og kjøttvarer",
                    "level": 5,
                    "parentCode": "47.22"
                  }
                ]
              },
              {
                "code": "47.23",
                "name": "Butikkhandel med fisk, skalldyr og bløtdyr",
                "shortName": "Butikkh. fisk, skalldyr og bløtdyr",
                "level": 4,
                "parentCode": "47.2",
                "children": [
                  {
                    "code": "47.230",
                    "name": "Butikkhandel med fisk, skalldyr og bløtdyr",
                    "shortName": "Butikkh. fisk, skalldyr og bløtdyr",
                    "level": 5,
                    "parentCode": "47.23"
                  }
                ]
              },
              {
                "code": "47.24",
                "name": "Butikkhandel med bakervarer, konditorvarer og sukkervarer",
                "shortName": "Butikkh. baker-, konditorvarer mv.",
                "level": 4,
                "parentCode": "47.2",
                "children": [
                  {
                    "code": "47.241",
                    "name": "Butikkhandel med bakervarer og konditorvarer",
                    "shortName": "Butikkh. baker- og konditorvarer",
                    "level": 5,
                    "parentCode": "47.24"
                  },
                  {
                    "code": "47.242",
                    "name": "Butikkhandel med sukkervarer",
                    "shortName": "Butikkh. sukkervarer",
                    "level": 5,
                    "parentCode": "47.24"
                  }
                ]
              },
              {
                "code": "47.25",
                "name": "Butikkhandel med drikkevarer",
                "shortName": "Butikkh. drikkevarer",
                "level": 4,
                "parentCode": "47.2",
                "children": [
                  {
                    "code": "47.251",
                    "name": "Butikkhandel med vin og brennevin",
                    "shortName": "Butikkh. vin og brennevin",
                    "level": 5,
                    "parentCode": "47.25"
                  },
                  {
                    "code": "47.259",
                    "name": "Butikkhandel med drikkevarer ellers",
                    "shortName": "Butikkh. drikkevarer el.",
                    "level": 5,
                    "parentCode": "47.25"
                  }
                ]
              },
              {
                "code": "47.26",
                "name": "Butikkhandel med tobakksvarer",
                "shortName": "Butikkh. tobakksvarer",
                "level": 4,
                "parentCode": "47.2",
                "children": [
                  {
                    "code": "47.260",
                    "name": "Butikkhandel med tobakksvarer",
                    "shortName": "Butikkh. tobakksvarer",
                    "level": 5,
                    "parentCode": "47.26"
                  }
                ]
              },
              {
                "code": "47.29",
                "name": "Butikkhandel med nærings- og nytelsesmidler ellers",
                "shortName": "Butikkh. nær.- og nytelsesmidler el.",
                "level": 4,
                "parentCode": "47.2",
                "children": [
                  {
                    "code": "47.291",
                    "name": "Butikkhandel med helsekost",
                    "shortName": "Butikkh. helsekost",
                    "level": 5,
                    "parentCode": "47.29"
                  },
                  {
                    "code": "47.292",
                    "name": "Butikkhandel med kaffe og te",
                    "shortName": "Butikkh. kaffe og te",
                    "level": 5,
                    "parentCode": "47.29"
                  },
                  {
                    "code": "47.299",
                    "name": "Butikkhandel med nærings- og nytelsesmidler ikke nevnt annet sted",
                    "shortName": "Butikkh. nær.- og nytelsesmidler el.",
                    "level": 5,
                    "parentCode": "47.29"
                  }
                ]
              }
            ]
          },
          {
            "code": "47.3",
            "name": "Detaljhandel med drivstoff til motorvogner",
            "shortName": "Detaljh. drivstoff til motorvogner",
            "level": 3,
            "parentCode": "47",
            "children": [
              {
                "code": "47.30",
                "name": "Detaljhandel med drivstoff til motorvogner",
                "shortName": "Detaljh. drivstoff til motorvogner",
                "level": 4,
                "parentCode": "47.3",
                "children": [
                  {
                    "code": "47.300",
                    "name": "Detaljhandel med drivstoff til motorvogner",
                    "shortName": "Detaljh. drivstoff til motorvogner",
                    "level": 5,
                    "parentCode": "47.30"
                  }
                ]
              }
            ]
          },
          {
            "code": "47.4",
            "name": "Butikkhandel med IKT-utstyr i spesialforretninger",
            "shortName": "Butikkh. med IKT-utstyr",
            "level": 3,
            "parentCode": "47",
            "children": [
              {
                "code": "47.41",
                "name": "Butikkhandel med datamaskiner og utstyr til datamaskiner",
                "shortName": "Butikkh. datamask. og tilleggsutst.",
                "level": 4,
                "parentCode": "47.4",
                "children": [
                  {
                    "code": "47.410",
                    "name": "Butikkhandel med datamaskiner og utstyr til datamaskiner",
                    "shortName": "Butikkh. datamask. og tilleggsutst.",
                    "level": 5,
                    "parentCode": "47.41"
                  }
                ]
              },
              {
                "code": "47.42",
                "name": "Butikkhandel med telekommunikasjonsutstyr",
                "shortName": "Butikkh. telekommunikasjonsutstyr",
                "level": 4,
                "parentCode": "47.4",
                "children": [
                  {
                    "code": "47.420",
                    "name": "Butikkhandel med telekommunikasjonsutstyr",
                    "shortName": "Butikkh. telekommunikasjonsutstyr",
                    "level": 5,
                    "parentCode": "47.42"
                  }
                ]
              },
              {
                "code": "47.43",
                "name": "Butikkhandel med audio- og videoutstyr",
                "shortName": "Butikkh. audio- og videoutstyr",
                "level": 4,
                "parentCode": "47.4",
                "children": [
                  {
                    "code": "47.430",
                    "name": "Butikkhandel med audio- og videoutstyr",
                    "shortName": "Butikkh. audio- og videoutstyr",
                    "level": 5,
                    "parentCode": "47.43"
                  }
                ]
              }
            ]
          },
          {
            "code": "47.5",
            "name": "Butikkhandel med andre husholdningsvarer i spesialforretninger",
            "shortName": "Butikkh. med andre husholdningsvarer",
            "level": 3,
            "parentCode": "47",
            "children": [
              {
                "code": "47.51",
                "name": "Butikkhandel med tekstiler og utstyrsvarer",
                "shortName": "Butikkh. tekstiler og utstyrsvarer",
                "level": 4,
                "parentCode": "47.5",
                "children": [
                  {
                    "code": "47.510",
                    "name": "Butikkhandel med tekstiler og utstyrsvarer",
                    "shortName": "Butikkh. tekstiler og utstyrsvarer",
                    "level": 5,
                    "parentCode": "47.51"
                  }
                ]
              },
              {
                "code": "47.52",
                "name": "Butikkhandel med jernvarer, fargevarer og glass",
                "shortName": "Butikkh. jernv., fargev. og glass",
                "level": 4,
                "parentCode": "47.5",
                "children": [
                  {
                    "code": "47.521",
                    "name": "Butikkhandel med bredt utvalg av jernvarer, fargevarer og andre byggevarer",
                    "shortName": "Byggvarehus m.m.",
                    "level": 5,
                    "parentCode": "47.52"
                  },
                  {
                    "code": "47.522",
                    "name": "Butikkhandel med jernvarer",
                    "shortName": "Butikkh. jernvarer",
                    "level": 5,
                    "parentCode": "47.52"
                  },
                  {
                    "code": "47.523",
                    "name": "Butikkhandel med fargevarer",
                    "shortName": "Butikkh. fargevarer",
                    "level": 5,
                    "parentCode": "47.52"
                  },
                  {
                    "code": "47.524",
                    "name": "Butikkhandel med trelast",
                    "shortName": "Butikkh. trelast",
                    "level": 5,
                    "parentCode": "47.52"
                  },
                  {
                    "code": "47.529",
                    "name": "Butikkhandel med byggevarer ikke nevnt annet sted",
                    "shortName": "Butikkh. byggevarer el.",
                    "level": 5,
                    "parentCode": "47.52"
                  }
                ]
              },
              {
                "code": "47.53",
                "name": "Butikkhandel med tapeter, gulvtepper og gardiner",
                "shortName": "Butikkh. tapet/gulvtepper/gardiner",
                "level": 4,
                "parentCode": "47.5",
                "children": [
                  {
                    "code": "47.531",
                    "name": "Butikkhandel med tapeter og gulvbelegg",
                    "shortName": "Butikkh. tapeter og gulvbelegg",
                    "level": 5,
                    "parentCode": "47.53"
                  },
                  {
                    "code": "47.532",
                    "name": "Butikkhandel med tepper",
                    "shortName": "Butikkh. tepper",
                    "level": 5,
                    "parentCode": "47.53"
                  },
                  {
                    "code": "47.533",
                    "name": "Butikkhandel med gardiner",
                    "shortName": "Butikkh. gardiner",
                    "level": 5,
                    "parentCode": "47.53"
                  }
                ]
              },
              {
                "code": "47.54",
                "name": "Butikkhandel med elektriske husholdningsapparater",
                "shortName": "Butikkh. el. hush.apparater",
                "level": 4,
                "parentCode": "47.5",
                "children": [
                  {
                    "code": "47.540",
                    "name": "Butikkhandel med elektriske husholdningsapparater",
                    "shortName": "Butikkh. el. hush.apparater",
                    "level": 5,
                    "parentCode": "47.54"
                  }
                ]
              },
              {
                "code": "47.59",
                "name": "Butikkhandel med møbler, belysningsutstyr og andre innredningsartikler",
                "shortName": "Butikkh. møbler/belys.utstyr mv.",
                "level": 4,
                "parentCode": "47.5",
                "children": [
                  {
                    "code": "47.591",
                    "name": "Butikkhandel med møbler",
                    "shortName": "Butikkh. møbler",
                    "level": 5,
                    "parentCode": "47.59"
                  },
                  {
                    "code": "47.592",
                    "name": "Butikkhandel med belysningsutstyr",
                    "shortName": "Butikkh. belysningsutstyr",
                    "level": 5,
                    "parentCode": "47.59"
                  },
                  {
                    "code": "47.593",
                    "name": "Butikkhandel med kjøkkenutstyr, glass og steintøy",
                    "shortName": "Butikkh. kjøkkenutstyr/steintøy mv.",
                    "level": 5,
                    "parentCode": "47.59"
                  },
                  {
                    "code": "47.594",
                    "name": "Butikkhandel med musikkinstrumenter og noter",
                    "shortName": "Butikkh. musikkinstr. og noter",
                    "level": 5,
                    "parentCode": "47.59"
                  },
                  {
                    "code": "47.599",
                    "name": "Butikkhandel med innredningsartikler ikke nevnt annet sted",
                    "shortName": "Butikkh. innredningsartikler el.",
                    "level": 5,
                    "parentCode": "47.59"
                  }
                ]
              }
            ]
          },
          {
            "code": "47.6",
            "name": "Butikkhandel med bøker, musikkartikler og andre fritidsartikler i spesialforretninger",
            "shortName": "Butikkh. med bøker, musikkart. etc.",
            "level": 3,
            "parentCode": "47",
            "children": [
              {
                "code": "47.61",
                "name": "Butikkhandel med bøker",
                "shortName": "Butikkh. bøker",
                "level": 4,
                "parentCode": "47.6",
                "children": [
                  {
                    "code": "47.610",
                    "name": "Butikkhandel med bøker",
                    "shortName": "Butikkh. bøker",
                    "level": 5,
                    "parentCode": "47.61"
                  }
                ]
              },
              {
                "code": "47.62",
                "name": "Butikkhandel med aviser og papirvarer",
                "shortName": "Butikkh. aviser og papirvarer",
                "level": 4,
                "parentCode": "47.6",
                "children": [
                  {
                    "code": "47.620",
                    "name": "Butikkhandel med aviser og papirvarer",
                    "shortName": "Butikkh. aviser og papirvarer",
                    "level": 5,
                    "parentCode": "47.62"
                  }
                ]
              },
              {
                "code": "47.63",
                "name": "Butikkhandel med innspillinger av musikk og video",
                "shortName": "Butikkh. innspill. av musikk/video",
                "level": 4,
                "parentCode": "47.6",
                "children": [
                  {
                    "code": "47.630",
                    "name": "Butikkhandel med innspillinger av musikk og video",
                    "shortName": "Butikkh. innspill. av musikk/video",
                    "level": 5,
                    "parentCode": "47.63"
                  }
                ]
              },
              {
                "code": "47.64",
                "name": "Butikkhandel med sportsutstyr",
                "shortName": "Butikkh. sportsutstyr",
                "level": 4,
                "parentCode": "47.6",
                "children": [
                  {
                    "code": "47.641",
                    "name": "Butikkhandel med sportsutstyr",
                    "shortName": "Butikkh. sportsutstyr",
                    "level": 5,
                    "parentCode": "47.64"
                  },
                  {
                    "code": "47.642",
                    "name": "Butikkhandel med fritidsbåter og -utstyr",
                    "shortName": "Butikkh. fritidsbåter og -utstyr",
                    "level": 5,
                    "parentCode": "47.64"
                  }
                ]
              },
              {
                "code": "47.65",
                "name": "Butikkhandel med spill og leker",
                "shortName": "Butikkh. spill og leker",
                "level": 4,
                "parentCode": "47.6",
                "children": [
                  {
                    "code": "47.650",
                    "name": "Butikkhandel med spill og leker",
                    "shortName": "Butikkh. spill og leker",
                    "level": 5,
                    "parentCode": "47.65"
                  }
                ]
              }
            ]
          },
          {
            "code": "47.7",
            "name": "Annen butikkhandel i spesialforretninger",
            "shortName": "Annen butikkhandel",
            "level": 3,
            "parentCode": "47",
            "children": [
              {
                "code": "47.71",
                "name": "Butikkhandel med klær",
                "shortName": "Butikkh. klær",
                "level": 4,
                "parentCode": "47.7",
                "children": [
                  {
                    "code": "47.710",
                    "name": "Butikkhandel med klær",
                    "shortName": "Butikkh. klær",
                    "level": 5,
                    "parentCode": "47.71"
                  }
                ]
              },
              {
                "code": "47.72",
                "name": "Butikkhandel med skotøy og lærvarer",
                "shortName": "Butikkh. skotøy og lærvarer",
                "level": 4,
                "parentCode": "47.7",
                "children": [
                  {
                    "code": "47.721",
                    "name": "Butikkhandel med skotøy",
                    "shortName": "Butikkh. skotøy",
                    "level": 5,
                    "parentCode": "47.72"
                  },
                  {
                    "code": "47.722",
                    "name": "Butikkhandel med reiseeffekter av lær og lærimitasjoner og varer av lær",
                    "shortName": "Butikkh. reiseeff. og andre lærvarer",
                    "level": 5,
                    "parentCode": "47.72"
                  }
                ]
              },
              {
                "code": "47.73",
                "name": "Butikkhandel med apotekvarer",
                "shortName": "Butikkh. apotekvarer",
                "level": 4,
                "parentCode": "47.7",
                "children": [
                  {
                    "code": "47.730",
                    "name": "Butikkhandel med apotekvarer",
                    "shortName": "Butikkh. apotekvarer",
                    "level": 5,
                    "parentCode": "47.73"
                  }
                ]
              },
              {
                "code": "47.74",
                "name": "Butikkhandel med medisinske og ortopediske artikler",
                "shortName": "Butikkh. medisinske/ortop. art.",
                "level": 4,
                "parentCode": "47.7",
                "children": [
                  {
                    "code": "47.740",
                    "name": "Butikkhandel med medisinske og ortopediske artikler",
                    "shortName": "Butikkh. medisinske/ortop. art.",
                    "level": 5,
                    "parentCode": "47.74"
                  }
                ]
              },
              {
                "code": "47.75",
                "name": "Butikkhandel med kosmetikk og toalettartikler",
                "shortName": "Butikkh. kosmetikk og toalettart.",
                "level": 4,
                "parentCode": "47.7",
                "children": [
                  {
                    "code": "47.750",
                    "name": "Butikkhandel med kosmetikk og toalettartikler",
                    "shortName": "Butikkh. kosmetikk og toalettart.",
                    "level": 5,
                    "parentCode": "47.75"
                  }
                ]
              },
              {
                "code": "47.76",
                "name": "Butikkhandel med blomster og planter, kjæledyr og fôrvarer til kjæledyr",
                "shortName": "Butikkh. blomster/planter mv.",
                "level": 4,
                "parentCode": "47.7",
                "children": [
                  {
                    "code": "47.761",
                    "name": "Butikkhandel med blomster og planter",
                    "shortName": "Butikkh. blomster og planter",
                    "level": 5,
                    "parentCode": "47.76"
                  },
                  {
                    "code": "47.762",
                    "name": "Butikkhandel med kjæledyr og fôrvarer til kjæledyr",
                    "shortName": "Butikkh. kjæledyr mv.",
                    "level": 5,
                    "parentCode": "47.76"
                  }
                ]
              },
              {
                "code": "47.77",
                "name": "Butikkhandel med ur, gull- og sølvvarer",
                "shortName": "Butikkh. ur, gull- og sølvvarer",
                "level": 4,
                "parentCode": "47.7",
                "children": [
                  {
                    "code": "47.771",
                    "name": "Butikkhandel med ur og klokker",
                    "shortName": "Butikkh. ur og klokker",
                    "level": 5,
                    "parentCode": "47.77"
                  },
                  {
                    "code": "47.772",
                    "name": "Butikkhandel med gull- og sølvvarer",
                    "shortName": "Butikkh. gull- og sølvvarer",
                    "level": 5,
                    "parentCode": "47.77"
                  }
                ]
              },
              {
                "code": "47.78",
                "name": "Annen butikkhandel med andre nye varer i spesialforretninger",
                "shortName": "Butikkh. nye varer i spes.forr. el.",
                "level": 4,
                "parentCode": "47.7",
                "children": [
                  {
                    "code": "47.781",
                    "name": "Butikkhandel med fotoutstyr",
                    "shortName": "Butikkh. fotoutstyr",
                    "level": 5,
                    "parentCode": "47.78"
                  },
                  {
                    "code": "47.782",
                    "name": "Butikkhandel med optiske artikler",
                    "shortName": "Butikkh. optiske artikler",
                    "level": 5,
                    "parentCode": "47.78"
                  },
                  {
                    "code": "47.789",
                    "name": "Butikkhandel ikke nevnt annet sted",
                    "shortName": "Butikkh. el.",
                    "level": 5,
                    "parentCode": "47.78"
                  }
                ]
              },
              {
                "code": "47.79",
                "name": "Butikkhandel med brukte varer",
                "shortName": "Butikkh. brukte varer",
                "level": 4,
                "parentCode": "47.7",
                "children": [
                  {
                    "code": "47.791",
                    "name": "Butikkhandel med antikviteter",
                    "shortName": "Butikkh. antikviteter",
                    "level": 5,
                    "parentCode": "47.79"
                  },
                  {
                    "code": "47.792",
                    "name": "Butikkhandel med brukte klær",
                    "shortName": "Butikkh. brukte klær",
                    "level": 5,
                    "parentCode": "47.79"
                  },
                  {
                    "code": "47.799",
                    "name": "Butikkhandel med brukte varer ellers",
                    "shortName": "Butikkh. brukte varer el.",
                    "level": 5,
                    "parentCode": "47.79"
                  }
                ]
              }
            ]
          },
          {
            "code": "47.8",
            "name": "Torghandel",
            "shortName": "Torghandel",
            "level": 3,
            "parentCode": "47",
            "children": [
              {
                "code": "47.81",
                "name": "Torghandel med næringsmidler, drikkevarer og tobakksvarer",
                "shortName": "Torgh. nær.midl./drikkev./tobakksv.",
                "level": 4,
                "parentCode": "47.8",
                "children": [
                  {
                    "code": "47.810",
                    "name": "Torghandel med næringsmidler, drikkevarer og tobakksvarer",
                    "shortName": "Torgh. nær.midl./drikkev./tobakksv",
                    "level": 5,
                    "parentCode": "47.81"
                  }
                ]
              },
              {
                "code": "47.82",
                "name": "Torghandel med tekstiler, klær, skotøy og utstyrsvarer",
                "shortName": "Torgh. tekstiler, klær, skotøy m.m.",
                "level": 4,
                "parentCode": "47.8",
                "children": [
                  {
                    "code": "47.820",
                    "name": "Torghandel med tekstiler, klær, skotøy og utstyrsvarer",
                    "shortName": "Torgh. tekstiler, klær, skotøy m.m.",
                    "level": 5,
                    "parentCode": "47.82"
                  }
                ]
              },
              {
                "code": "47.89",
                "name": "Torghandel med andre varer",
                "shortName": "Torgh. andre varer",
                "level": 4,
                "parentCode": "47.8",
                "children": [
                  {
                    "code": "47.890",
                    "name": "Torghandel med andre varer",
                    "shortName": "Torghandel med andre varer",
                    "level": 5,
                    "parentCode": "47.89"
                  }
                ]
              }
            ]
          },
          {
            "code": "47.9",
            "name": "Detaljhandel utenom utsalgssted",
            "shortName": "Detaljh. utenom utsalgssted",
            "level": 3,
            "parentCode": "47",
            "children": [
              {
                "code": "47.91",
                "name": "Postordrehandel og handel via Internett",
                "shortName": "Postordreh. og handel via Internett",
                "level": 4,
                "parentCode": "47.9",
                "children": [
                  {
                    "code": "47.911",
                    "name": "Postordre-/Internetthandel med bredt vareutvalg",
                    "shortName": "Postord.-/Internetth. br. vareutv.",
                    "level": 5,
                    "parentCode": "47.91"
                  },
                  {
                    "code": "47.912",
                    "name": "Postordre-/Internetthandel med tekstiler, utstyrsvarer, klær, skotøy, reiseeffekter og lærvarer",
                    "shortName": "Postord.-/Internetth. tekstiler mv.",
                    "level": 5,
                    "parentCode": "47.91"
                  },
                  {
                    "code": "47.913",
                    "name": "Postordre-/Internetthandel med belysningsutstyr, kjøkkenutstyr, møbler og innredningsartikler",
                    "shortName": "Postord.-/Internetth. møbler mv.",
                    "level": 5,
                    "parentCode": "47.91"
                  },
                  {
                    "code": "47.914",
                    "name": "Postordre-/Internetthandel med elektriske husholdningsapparater, radio, fjernsyn, plater, kassetter og musikkinstrumenter",
                    "shortName": "Post.-/Internetth. el.hush.app. mv.",
                    "level": 5,
                    "parentCode": "47.91"
                  },
                  {
                    "code": "47.915",
                    "name": "Postordre-/internetthandel med bøker, papir, aviser og blader",
                    "shortName": "Postord.-/Internetth. bøker mv.",
                    "level": 5,
                    "parentCode": "47.91"
                  },
                  {
                    "code": "47.916",
                    "name": "Postordre-/Internetthandel med IKT-utstyr",
                    "shortName": "Postord.-/Internetth. IKT-utstyr",
                    "level": 5,
                    "parentCode": "47.91"
                  },
                  {
                    "code": "47.917",
                    "name": "Postordre-/Internetthandel med helsekost",
                    "shortName": "Postord.-/Internetth. helsekost",
                    "level": 5,
                    "parentCode": "47.91"
                  },
                  {
                    "code": "47.919",
                    "name": "Postordre-/Internetthandel med annet spesialisert vareutvalg",
                    "shortName": "Postord.-/Internetth. ellers",
                    "level": 5,
                    "parentCode": "47.91"
                  }
                ]
              },
              {
                "code": "47.99",
                "name": "Detaljhandel utenom utsalgssted ellers",
                "shortName": "Detaljh. utenom utsalgssted el.",
                "level": 4,
                "parentCode": "47.9",
                "children": [
                  {
                    "code": "47.990",
                    "name": "Detaljhandel utenom utsalgssted ellers",
                    "shortName": "Detaljh. utenom utsalgssted el.",
                    "level": 5,
                    "parentCode": "47.99"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "code": "H",
    "name": "Transport og lagring",
    "shortName": "Transport og lagring",
    "level": 1,
    "parentCode": "",
    "children": [
      {
        "code": "49",
        "name": "Landtransport og rørtransport",
        "shortName": "Landtransport og rørtransport",
        "level": 2,
        "parentCode": "H",
        "children": [
          {
            "code": "49.1",
            "name": "Passasjertransport med jernbane",
            "shortName": "Passasjertransp. med jernbane",
            "level": 3,
            "parentCode": "49",
            "children": [
              {
                "code": "49.10",
                "name": "Passasjertransport med jernbane",
                "shortName": "Passasjertransp. med jernbane",
                "level": 4,
                "parentCode": "49.1",
                "children": [
                  {
                    "code": "49.100",
                    "name": "Passasjertransport med jernbane",
                    "shortName": "Passasjertransp. med jernbane",
                    "level": 5,
                    "parentCode": "49.10"
                  }
                ]
              }
            ]
          },
          {
            "code": "49.2",
            "name": "Godstransport med jernbane",
            "shortName": "Godstransp. med jernbane",
            "level": 3,
            "parentCode": "49",
            "children": [
              {
                "code": "49.20",
                "name": "Godstransport med jernbane",
                "shortName": "Godstransp. med jernbane",
                "level": 4,
                "parentCode": "49.2",
                "children": [
                  {
                    "code": "49.200",
                    "name": "Godstransport med jernbane",
                    "shortName": "Godstransp. med jernbane",
                    "level": 5,
                    "parentCode": "49.20"
                  }
                ]
              }
            ]
          },
          {
            "code": "49.3",
            "name": "Annen landtransport med passasjerer",
            "shortName": "Annen landtransp. med passasjerer",
            "level": 3,
            "parentCode": "49",
            "children": [
              {
                "code": "49.31",
                "name": "Transport med rutebil og sporvei i by- og forstadsområde",
                "shortName": "Rutebil/sporvei i by-/forstadsomr.",
                "level": 4,
                "parentCode": "49.3",
                "children": [
                  {
                    "code": "49.311",
                    "name": "Rutebiltransport i by- og forstadsområde",
                    "shortName": "Rutebiltransp. by-/forstadsområde",
                    "level": 5,
                    "parentCode": "49.31"
                  },
                  {
                    "code": "49.312",
                    "name": "Transport med sporveis- og forstadsbane",
                    "shortName": "Transp. sporveis-/forstadsbane",
                    "level": 5,
                    "parentCode": "49.31"
                  }
                ]
              },
              {
                "code": "49.32",
                "name": "Drosjebiltransport",
                "shortName": "Drosjebiltransport",
                "level": 4,
                "parentCode": "49.3",
                "children": [
                  {
                    "code": "49.320",
                    "name": "Drosjebiltransport",
                    "shortName": "Drosjebiltransport",
                    "level": 5,
                    "parentCode": "49.32"
                  }
                ]
              },
              {
                "code": "49.39",
                "name": "Landtransport med passasjerer ikke nevnt annet sted",
                "shortName": "Landtr. med passasjerer el.",
                "level": 4,
                "parentCode": "49.3",
                "children": [
                  {
                    "code": "49.391",
                    "name": "Rutebiltransport utenfor by- og forstadsområde",
                    "shortName": "Rutebiltr. utenfor by-/forstadsomr.",
                    "level": 5,
                    "parentCode": "49.39"
                  },
                  {
                    "code": "49.392",
                    "name": "Turbiltransport",
                    "shortName": "Turbiltransport",
                    "level": 5,
                    "parentCode": "49.39"
                  },
                  {
                    "code": "49.393",
                    "name": "Transport med taubaner, kabelbaner og skiheiser",
                    "shortName": "Transp. tau-/kabelbaner/skiheiser",
                    "level": 5,
                    "parentCode": "49.39"
                  }
                ]
              }
            ]
          },
          {
            "code": "49.4",
            "name": "Godstransport på vei, herunder flyttetransport",
            "shortName": "Godstransp. på vei/flyttetransport",
            "level": 3,
            "parentCode": "49",
            "children": [
              {
                "code": "49.41",
                "name": "Godstransport på vei",
                "shortName": "Godstransport på vei",
                "level": 4,
                "parentCode": "49.4",
                "children": [
                  {
                    "code": "49.410",
                    "name": "Godstransport på vei",
                    "shortName": "Godstransport på vei",
                    "level": 5,
                    "parentCode": "49.41"
                  }
                ]
              },
              {
                "code": "49.42",
                "name": "Flyttetransport",
                "shortName": "Flyttetransport",
                "level": 4,
                "parentCode": "49.4",
                "children": [
                  {
                    "code": "49.420",
                    "name": "Flyttetransport",
                    "shortName": "Flyttetransport",
                    "level": 5,
                    "parentCode": "49.42"
                  }
                ]
              }
            ]
          },
          {
            "code": "49.5",
            "name": "Rørtransport",
            "shortName": "Rørtransport",
            "level": 3,
            "parentCode": "49",
            "children": [
              {
                "code": "49.50",
                "name": "Rørtransport",
                "shortName": "Rørtransport",
                "level": 4,
                "parentCode": "49.5",
                "children": [
                  {
                    "code": "49.500",
                    "name": "Rørtransport",
                    "shortName": "Rørtransport",
                    "level": 5,
                    "parentCode": "49.50"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "50",
        "name": "Sjøfart",
        "shortName": "Sjøfart",
        "level": 2,
        "parentCode": "H",
        "children": [
          {
            "code": "50.1",
            "name": "Sjøfart og kysttrafikk med passasjerer",
            "shortName": "Sjøfart og kysttraf. m/passasjerer",
            "level": 3,
            "parentCode": "50",
            "children": [
              {
                "code": "50.10",
                "name": "Sjøfart og kysttrafikk med passasjerer",
                "shortName": "Sjøfart og kysttraf. m/passasjerer",
                "level": 4,
                "parentCode": "50.1",
                "children": [
                  {
                    "code": "50.101",
                    "name": "Utenriks sjøfart med passasjerer",
                    "shortName": "Utenriks sjøfart med passasjerer",
                    "level": 5,
                    "parentCode": "50.10"
                  },
                  {
                    "code": "50.102",
                    "name": "Innenlandske kystruter med passasjerer",
                    "shortName": "Innenl. kystruter med passasjerer",
                    "level": 5,
                    "parentCode": "50.10"
                  },
                  {
                    "code": "50.109",
                    "name": "Kysttrafikk ellers med passasjerer",
                    "shortName": "Kysttrafikk ellers med passasjerer",
                    "level": 5,
                    "parentCode": "50.10"
                  }
                ]
              }
            ]
          },
          {
            "code": "50.2",
            "name": "Sjøfart og kysttrafikk med gods",
            "shortName": "Sjøfart og kysttrafikk med gods",
            "level": 3,
            "parentCode": "50",
            "children": [
              {
                "code": "50.20",
                "name": "Sjøfart og kysttrafikk med gods",
                "shortName": "Sjøfart og kysttrafikk med gods",
                "level": 4,
                "parentCode": "50.2",
                "children": [
                  {
                    "code": "50.201",
                    "name": "Utenriks sjøfart med gods",
                    "shortName": "Utenriks sjøfart med gods",
                    "level": 5,
                    "parentCode": "50.20"
                  },
                  {
                    "code": "50.202",
                    "name": "Innenriks sjøfart med gods",
                    "shortName": "Innenriks sjøfart med gods",
                    "level": 5,
                    "parentCode": "50.20"
                  },
                  {
                    "code": "50.203",
                    "name": "Slepebåter",
                    "shortName": "Slepebåter",
                    "level": 5,
                    "parentCode": "50.20"
                  },
                  {
                    "code": "50.204",
                    "name": "Forsyning og andre sjøtransporttjenester for offshore",
                    "shortName": "Forsyn./andre sjøtr.tj. for offshore",
                    "level": 5,
                    "parentCode": "50.20"
                  }
                ]
              }
            ]
          },
          {
            "code": "50.3",
            "name": "Passasjertransport på elver og innsjøer",
            "shortName": "Passasjertr. på elver og innsjøer",
            "level": 3,
            "parentCode": "50",
            "children": [
              {
                "code": "50.30",
                "name": "Passasjertransport på elver og innsjøer",
                "shortName": "Passasjertr. på elver og innsjøer",
                "level": 4,
                "parentCode": "50.3",
                "children": [
                  {
                    "code": "50.300",
                    "name": "Passasjertransport på elver og innsjøer",
                    "shortName": "Passasjertr. på elver og innsjøer",
                    "level": 5,
                    "parentCode": "50.30"
                  }
                ]
              }
            ]
          },
          {
            "code": "50.4",
            "name": "Godstransport på elver og innsjøer",
            "shortName": "Godstransp. på elver og innsjøer",
            "level": 3,
            "parentCode": "50",
            "children": [
              {
                "code": "50.40",
                "name": "Godstransport på elver og innsjøer",
                "shortName": "Godstransp. på elver og innsjøer",
                "level": 4,
                "parentCode": "50.4",
                "children": [
                  {
                    "code": "50.400",
                    "name": "Godstransport på elver og innsjøer",
                    "shortName": "Godstransp. på elver og innsjøer",
                    "level": 5,
                    "parentCode": "50.40"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "51",
        "name": "Lufttransport",
        "shortName": "Lufttransport",
        "level": 2,
        "parentCode": "H",
        "children": [
          {
            "code": "51.1",
            "name": "Lufttransport med passasjerer",
            "shortName": "Lufttransp. med passasjerer",
            "level": 3,
            "parentCode": "51",
            "children": [
              {
                "code": "51.10",
                "name": "Lufttransport med passasjerer",
                "shortName": "Lufttransp. med passasjerer",
                "level": 4,
                "parentCode": "51.1",
                "children": [
                  {
                    "code": "51.100",
                    "name": "Lufttransport med passasjerer",
                    "shortName": "Lufttransp. med passasjerer",
                    "level": 5,
                    "parentCode": "51.10"
                  }
                ]
              }
            ]
          },
          {
            "code": "51.2",
            "name": "Lufttransport med gods samt romfart",
            "shortName": "Lufttransp. med gods samt romfart",
            "level": 3,
            "parentCode": "51",
            "children": [
              {
                "code": "51.21",
                "name": "Lufttransport med gods",
                "shortName": "Lufttransp. med gods",
                "level": 4,
                "parentCode": "51.2",
                "children": [
                  {
                    "code": "51.210",
                    "name": "Lufttransport med gods",
                    "shortName": "Lufttransp. med gods",
                    "level": 5,
                    "parentCode": "51.21"
                  }
                ]
              },
              {
                "code": "51.22",
                "name": "Romfart",
                "shortName": "Romfart",
                "level": 4,
                "parentCode": "51.2",
                "children": [
                  {
                    "code": "51.220",
                    "name": "Romfart",
                    "shortName": "Romfart",
                    "level": 5,
                    "parentCode": "51.22"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "52",
        "name": "Lagring og andre tjenester tilknyttet transport",
        "shortName": "Transporttjenester og lagring",
        "level": 2,
        "parentCode": "H",
        "children": [
          {
            "code": "52.1",
            "name": "Lagring",
            "shortName": "Lagring",
            "level": 3,
            "parentCode": "52",
            "children": [
              {
                "code": "52.10",
                "name": "Lagring",
                "shortName": "Lagring",
                "level": 4,
                "parentCode": "52.1",
                "children": [
                  {
                    "code": "52.100",
                    "name": "Lagring",
                    "shortName": "Lagring",
                    "level": 5,
                    "parentCode": "52.10"
                  }
                ]
              }
            ]
          },
          {
            "code": "52.2",
            "name": "Andre tjenester tilknyttet transport",
            "shortName": "Andre tjenester tilkn. transport",
            "level": 3,
            "parentCode": "52",
            "children": [
              {
                "code": "52.21",
                "name": "Andre tjenester tilknyttet landtransport",
                "shortName": "Andre tjen. tilkn. landtransport",
                "level": 4,
                "parentCode": "52.2",
                "children": [
                  {
                    "code": "52.211",
                    "name": "Drift av gods- og transportsentraler",
                    "shortName": "Drift av gods- og transportsentraler",
                    "level": 5,
                    "parentCode": "52.21"
                  },
                  {
                    "code": "52.212",
                    "name": "Drift av parkeringsplasser og parkeringshus",
                    "shortName": "Drift av parkeringsplasser og -hus",
                    "level": 5,
                    "parentCode": "52.21"
                  },
                  {
                    "code": "52.213",
                    "name": "Drift av bomstasjoner",
                    "shortName": "Drift av bomstasjoner",
                    "level": 5,
                    "parentCode": "52.21"
                  },
                  {
                    "code": "52.214",
                    "name": "Drift av taxisentraler og annen formidling av persontransport",
                    "shortName": "Drift av taxisentraler m.m.",
                    "level": 5,
                    "parentCode": "52.21"
                  },
                  {
                    "code": "52.216",
                    "name": "Kondensering av gass med henblikk på transport",
                    "shortName": "Kondensering av gass mtp. transport",
                    "level": 5,
                    "parentCode": "52.21"
                  },
                  {
                    "code": "52.219",
                    "name": "Tjenester tilknyttet landtransport ellers",
                    "shortName": "Tjen. tilkn. landtransport el.",
                    "level": 5,
                    "parentCode": "52.21"
                  }
                ]
              },
              {
                "code": "52.22",
                "name": "Andre tjenester tilknyttet sjøtransport",
                "shortName": "Andre tjen. tilkn. sjøtransport",
                "level": 4,
                "parentCode": "52.2",
                "children": [
                  {
                    "code": "52.221",
                    "name": "Drift av havne- og kaianlegg",
                    "shortName": "Drift av havne- og kaianlegg",
                    "level": 5,
                    "parentCode": "52.22"
                  },
                  {
                    "code": "52.222",
                    "name": "Redningstjeneste",
                    "shortName": "Redningstjeneste",
                    "level": 5,
                    "parentCode": "52.22"
                  },
                  {
                    "code": "52.223",
                    "name": "Forsyningsbaser",
                    "shortName": "Forsyningsbaser",
                    "level": 5,
                    "parentCode": "52.22"
                  },
                  {
                    "code": "52.229",
                    "name": "Tjenester tilknyttet sjøtransport ellers",
                    "shortName": "Tjen. tilkn. sjøtransport el.",
                    "level": 5,
                    "parentCode": "52.22"
                  }
                ]
              },
              {
                "code": "52.23",
                "name": "Andre tjenester tilknyttet lufttransport",
                "shortName": "Andre tjen. tilkn. lufttransport",
                "level": 4,
                "parentCode": "52.2",
                "children": [
                  {
                    "code": "52.230",
                    "name": "Andre tjenester tilknyttet lufttransport",
                    "shortName": "Andre tjen. tilkn. lufttransport",
                    "level": 5,
                    "parentCode": "52.23"
                  }
                ]
              },
              {
                "code": "52.24",
                "name": "Lasting og lossing",
                "shortName": "Lasting og lossing",
                "level": 4,
                "parentCode": "52.2",
                "children": [
                  {
                    "code": "52.240",
                    "name": "Lasting og lossing",
                    "shortName": "Lasting og lossing",
                    "level": 5,
                    "parentCode": "52.24"
                  }
                ]
              },
              {
                "code": "52.29",
                "name": "Andre tjenester tilknyttet transport",
                "shortName": "Andre tjenester tilknyttet transport",
                "level": 4,
                "parentCode": "52.2",
                "children": [
                  {
                    "code": "52.291",
                    "name": "Spedisjon",
                    "shortName": "Spedisjon",
                    "level": 5,
                    "parentCode": "52.29"
                  },
                  {
                    "code": "52.292",
                    "name": "Skipsmegling",
                    "shortName": "Skipsmegling",
                    "level": 5,
                    "parentCode": "52.29"
                  },
                  {
                    "code": "52.293",
                    "name": "Flymegling",
                    "shortName": "Flymegling",
                    "level": 5,
                    "parentCode": "52.29"
                  },
                  {
                    "code": "52.299",
                    "name": "Transportformidling ellers",
                    "shortName": "Transportformidling ellers",
                    "level": 5,
                    "parentCode": "52.29"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "53",
        "name": "Post og distribusjonsvirksomhet",
        "shortName": "Post og distribusjonsvirksomhet",
        "level": 2,
        "parentCode": "H",
        "children": [
          {
            "code": "53.1",
            "name": "Landsdekkende posttjenester",
            "shortName": "Landsdekkende posttjenester",
            "level": 3,
            "parentCode": "53",
            "children": [
              {
                "code": "53.10",
                "name": "Landsdekkende posttjenester",
                "shortName": "Landsdekkende posttjenester",
                "level": 4,
                "parentCode": "53.1",
                "children": [
                  {
                    "code": "53.100",
                    "name": "Landsdekkende posttjenester",
                    "shortName": "Landsdekkende posttjenester",
                    "level": 5,
                    "parentCode": "53.10"
                  }
                ]
              }
            ]
          },
          {
            "code": "53.2",
            "name": "Andre post- og budtjenester",
            "shortName": "Andre post- og budtjenester",
            "level": 3,
            "parentCode": "53",
            "children": [
              {
                "code": "53.20",
                "name": "Andre post- og budtjenester",
                "shortName": "Andre post- og budtjenester",
                "level": 4,
                "parentCode": "53.2",
                "children": [
                  {
                    "code": "53.200",
                    "name": "Andre post- og budtjenester",
                    "shortName": "Andre post- og budtjenester",
                    "level": 5,
                    "parentCode": "53.20"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "code": "I",
    "name": "Overnattings- og serveringsvirksomhet",
    "shortName": "Overnattings- og serveringsvirks.",
    "level": 1,
    "parentCode": "",
    "children": [
      {
        "code": "55",
        "name": "Overnattingsvirksomhet",
        "shortName": "Overnattingsvirksomhet",
        "level": 2,
        "parentCode": "I",
        "children": [
          {
            "code": "55.1",
            "name": "Hotellvirksomhet",
            "shortName": "Hotellvirksomhet",
            "level": 3,
            "parentCode": "55",
            "children": [
              {
                "code": "55.10",
                "name": "Hotellvirksomhet",
                "shortName": "Hotellvirksomhet",
                "level": 4,
                "parentCode": "55.1",
                "children": [
                  {
                    "code": "55.101",
                    "name": "Drift av hoteller, pensjonater og moteller med restaurant",
                    "shortName": "Drift av hoteller med restaurant",
                    "level": 5,
                    "parentCode": "55.10"
                  },
                  {
                    "code": "55.102",
                    "name": "Drift av hoteller, pensjonater og moteller uten restaurant",
                    "shortName": "Drift av hoteller uten restaurant",
                    "level": 5,
                    "parentCode": "55.10"
                  }
                ]
              }
            ]
          },
          {
            "code": "55.2",
            "name": "Drift av vandrerhjem og ferieleiligheter",
            "shortName": "Drift av vandrerhjem/ferieleil.",
            "level": 3,
            "parentCode": "55",
            "children": [
              {
                "code": "55.20",
                "name": "Drift av vandrerhjem og ferieleiligheter",
                "shortName": "Drift av vandrerhjem/ferieleil.",
                "level": 4,
                "parentCode": "55.2",
                "children": [
                  {
                    "code": "55.201",
                    "name": "Drift av vandrerhjem",
                    "shortName": "Drift av vandrerhjem",
                    "level": 5,
                    "parentCode": "55.20"
                  },
                  {
                    "code": "55.202",
                    "name": "Drift av ferieleiligheter",
                    "shortName": "Drift av ferieleiligheter",
                    "level": 5,
                    "parentCode": "55.20"
                  }
                ]
              }
            ]
          },
          {
            "code": "55.3",
            "name": "Drift av campingplasser",
            "shortName": "Drift av campingplasser",
            "level": 3,
            "parentCode": "55",
            "children": [
              {
                "code": "55.30",
                "name": "Drift av campingplasser",
                "shortName": "Drift av campingplasser",
                "level": 4,
                "parentCode": "55.3",
                "children": [
                  {
                    "code": "55.300",
                    "name": "Drift av campingplasser",
                    "shortName": "Drift av campingplasser",
                    "level": 5,
                    "parentCode": "55.30"
                  }
                ]
              }
            ]
          },
          {
            "code": "55.9",
            "name": "Annen overnatting",
            "shortName": "Annen overnatting",
            "level": 3,
            "parentCode": "55",
            "children": [
              {
                "code": "55.90",
                "name": "Annen overnatting",
                "shortName": "Annen overnatting",
                "level": 4,
                "parentCode": "55.9",
                "children": [
                  {
                    "code": "55.900",
                    "name": "Annen overnatting",
                    "shortName": "Annen overnatting",
                    "level": 5,
                    "parentCode": "55.90"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "56",
        "name": "Serveringsvirksomhet",
        "shortName": "Serveringsvirksomhet",
        "level": 2,
        "parentCode": "I",
        "children": [
          {
            "code": "56.1",
            "name": "Restaurantvirksomhet",
            "shortName": "Restaurantvirksomhet",
            "level": 3,
            "parentCode": "56",
            "children": [
              {
                "code": "56.10",
                "name": "Restaurantvirksomhet",
                "shortName": "Restaurantvirksomhet",
                "level": 4,
                "parentCode": "56.1",
                "children": [
                  {
                    "code": "56.101",
                    "name": "Drift av restauranter og kafeer",
                    "shortName": "Drift av restauranter og kafeer",
                    "level": 5,
                    "parentCode": "56.10"
                  },
                  {
                    "code": "56.102",
                    "name": "Drift av gatekjøkken",
                    "shortName": "Drift av gatekjøkken",
                    "level": 5,
                    "parentCode": "56.10"
                  }
                ]
              }
            ]
          },
          {
            "code": "56.2",
            "name": "Cateringvirksomhet og kantiner drevet som selvstendig virksomhet",
            "shortName": "Catering- og kantinevirksomhet",
            "level": 3,
            "parentCode": "56",
            "children": [
              {
                "code": "56.21",
                "name": "Cateringvirksomhet",
                "shortName": "Cateringvirksomhet",
                "level": 4,
                "parentCode": "56.2",
                "children": [
                  {
                    "code": "56.210",
                    "name": "Cateringvirksomhet",
                    "shortName": "Cateringvirksomhet",
                    "level": 5,
                    "parentCode": "56.21"
                  }
                ]
              },
              {
                "code": "56.29",
                "name": "Kantiner drevet som selvstendig virksomhet",
                "shortName": "Kantinedrift, selvst. virksomhet",
                "level": 4,
                "parentCode": "56.2",
                "children": [
                  {
                    "code": "56.290",
                    "name": "Kantiner drevet som selvstendig virksomhet",
                    "shortName": "Kantinedrift, selvst. virksomhet",
                    "level": 5,
                    "parentCode": "56.29"
                  }
                ]
              }
            ]
          },
          {
            "code": "56.3",
            "name": "Drift av barer",
            "shortName": "Drift av barer",
            "level": 3,
            "parentCode": "56",
            "children": [
              {
                "code": "56.30",
                "name": "Drift av barer",
                "shortName": "Drift av barer",
                "level": 4,
                "parentCode": "56.3",
                "children": [
                  {
                    "code": "56.301",
                    "name": "Drift av puber",
                    "shortName": "Drift av puber",
                    "level": 5,
                    "parentCode": "56.30"
                  },
                  {
                    "code": "56.309",
                    "name": "Drift av barer ellers",
                    "shortName": "Drift av barer ellers",
                    "level": 5,
                    "parentCode": "56.30"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "code": "J",
    "name": "Informasjon og kommunikasjon",
    "shortName": "Informasjon og kommunikasjon",
    "level": 1,
    "parentCode": "",
    "children": [
      {
        "code": "58",
        "name": "Forlagsvirksomhet",
        "shortName": "Forlagsvirksomhet",
        "level": 2,
        "parentCode": "J",
        "children": [
          {
            "code": "58.1",
            "name": "Utgivelse av bøker, tidsskrifter og annen forlagsvirksomhet",
            "shortName": "Utgiv. av bøker, tidsskrifter etc.",
            "level": 3,
            "parentCode": "58",
            "children": [
              {
                "code": "58.11",
                "name": "Utgivelse av bøker",
                "shortName": "Utgivelse av bøker",
                "level": 4,
                "parentCode": "58.1",
                "children": [
                  {
                    "code": "58.110",
                    "name": "Utgivelse av bøker",
                    "shortName": "Utgivelse av bøker",
                    "level": 5,
                    "parentCode": "58.11"
                  }
                ]
              },
              {
                "code": "58.12",
                "name": "Utgivelse av kataloger og adresselister",
                "shortName": "Utgiv. av kataloger/adresselister",
                "level": 4,
                "parentCode": "58.1",
                "children": [
                  {
                    "code": "58.120",
                    "name": "Utgivelse av kataloger og adresselister",
                    "shortName": "Utgiv. av kataloger/adresselister",
                    "level": 5,
                    "parentCode": "58.12"
                  }
                ]
              },
              {
                "code": "58.13",
                "name": "Utgivelse av aviser",
                "shortName": "Utgivelse av aviser",
                "level": 4,
                "parentCode": "58.1",
                "children": [
                  {
                    "code": "58.130",
                    "name": "Utgivelse av aviser",
                    "shortName": "Utgivelse av aviser",
                    "level": 5,
                    "parentCode": "58.13"
                  }
                ]
              },
              {
                "code": "58.14",
                "name": "Utgivelse av blader og tidsskrifter",
                "shortName": "Utgivelse av blader og tidsskrifter",
                "level": 4,
                "parentCode": "58.1",
                "children": [
                  {
                    "code": "58.140",
                    "name": "Utgivelse av blader og tidsskrifter",
                    "shortName": "Utgivelse av blader og tidsskrifter",
                    "level": 5,
                    "parentCode": "58.14"
                  }
                ]
              },
              {
                "code": "58.19",
                "name": "Forlagsvirksomhet ellers",
                "shortName": "Forlagsvirksomhet ellers",
                "level": 4,
                "parentCode": "58.1",
                "children": [
                  {
                    "code": "58.190",
                    "name": "Forlagsvirksomhet ellers",
                    "shortName": "Forlagsvirksomhet ellers",
                    "level": 5,
                    "parentCode": "58.19"
                  }
                ]
              }
            ]
          },
          {
            "code": "58.2",
            "name": "Utgivelse av programvare",
            "shortName": "Utgivelse av programvare",
            "level": 3,
            "parentCode": "58",
            "children": [
              {
                "code": "58.21",
                "name": "Utgivelse av programvare for dataspill",
                "shortName": "Utgiv. av programv. for dataspill",
                "level": 4,
                "parentCode": "58.2",
                "children": [
                  {
                    "code": "58.210",
                    "name": "Utgivelse av programvare for dataspill",
                    "shortName": "Utgiv. av programv. for dataspill",
                    "level": 5,
                    "parentCode": "58.21"
                  }
                ]
              },
              {
                "code": "58.29",
                "name": "Utgivelse av annen programvare",
                "shortName": "Utgiv. av annen programvare",
                "level": 4,
                "parentCode": "58.2",
                "children": [
                  {
                    "code": "58.290",
                    "name": "Utgivelse av annen programvare",
                    "shortName": "Utgiv. av annen programvare",
                    "level": 5,
                    "parentCode": "58.29"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "59",
        "name": "Film-, video- og fjernsynsprogramproduksjon, utgivelse av musikk- og lydopptak",
        "shortName": "Film- og TV-prod., musikkutgivelse",
        "level": 2,
        "parentCode": "J",
        "children": [
          {
            "code": "59.1",
            "name": "Virksomhet innen film, video og fjernsynsprogrammer",
            "shortName": "Virks. innen film/video/tv-program.",
            "level": 3,
            "parentCode": "59",
            "children": [
              {
                "code": "59.11",
                "name": "Produksjon av film, video og fjernsynsprogrammer",
                "shortName": "Prod. av film/video/fjernsynsprogr.",
                "level": 4,
                "parentCode": "59.1",
                "children": [
                  {
                    "code": "59.110",
                    "name": "Produksjon av film, video og fjernsynsprogrammer",
                    "shortName": "Prod. av film/video/fjernsynsprogr.",
                    "level": 5,
                    "parentCode": "59.11"
                  }
                ]
              },
              {
                "code": "59.12",
                "name": "Etterarbeid knyttet til produksjon av film, video og fjernsynsprogrammer",
                "shortName": "Etterarb. til film-/video-/TV-prod.",
                "level": 4,
                "parentCode": "59.1",
                "children": [
                  {
                    "code": "59.120",
                    "name": "Etterarbeid knyttet til produksjon av film, video og fjernsynsprogrammer",
                    "shortName": "Etterarb. til film-/video-/TV-prod.",
                    "level": 5,
                    "parentCode": "59.12"
                  }
                ]
              },
              {
                "code": "59.13",
                "name": "Distribusjon av film, video og fjernsynsprogrammer",
                "shortName": "Distrib. film/video/fjernsynsprogr.",
                "level": 4,
                "parentCode": "59.1",
                "children": [
                  {
                    "code": "59.130",
                    "name": "Distribusjon av film, video og fjernsynsprogrammer",
                    "shortName": "Distrib. film/video/fjernsynsprogr.",
                    "level": 5,
                    "parentCode": "59.13"
                  }
                ]
              },
              {
                "code": "59.14",
                "name": "Filmframvisning",
                "shortName": "Filmframvisning",
                "level": 4,
                "parentCode": "59.1",
                "children": [
                  {
                    "code": "59.140",
                    "name": "Filmframvisning",
                    "shortName": "Filmframvisning",
                    "level": 5,
                    "parentCode": "59.14"
                  }
                ]
              }
            ]
          },
          {
            "code": "59.2",
            "name": "Produksjon og utgivelse av musikk- og lydopptak",
            "shortName": "Prod./utgiv. av musikk-/lydopptak",
            "level": 3,
            "parentCode": "59",
            "children": [
              {
                "code": "59.20",
                "name": "Produksjon og utgivelse av musikk- og lydopptak",
                "shortName": "Prod./utgiv. av musikk-/lydopptak",
                "level": 4,
                "parentCode": "59.2",
                "children": [
                  {
                    "code": "59.200",
                    "name": "Produksjon og utgivelse av musikk- og lydopptak",
                    "shortName": "Prod./utgiv. av musikk-/lydopptak",
                    "level": 5,
                    "parentCode": "59.20"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "60",
        "name": "Radio- og fjernsynskringkasting",
        "shortName": "Radio- og fjernsynskringkasting",
        "level": 2,
        "parentCode": "J",
        "children": [
          {
            "code": "60.1",
            "name": "Radiokringkasting",
            "shortName": "Radiokringkasting",
            "level": 3,
            "parentCode": "60",
            "children": [
              {
                "code": "60.10",
                "name": "Radiokringkasting",
                "shortName": "Radiokringkasting",
                "level": 4,
                "parentCode": "60.1",
                "children": [
                  {
                    "code": "60.100",
                    "name": "Radiokringkasting",
                    "shortName": "Radiokringkasting",
                    "level": 5,
                    "parentCode": "60.10"
                  }
                ]
              }
            ]
          },
          {
            "code": "60.2",
            "name": "Fjernsynskringkasting",
            "shortName": "Fjernsynskringkasting",
            "level": 3,
            "parentCode": "60",
            "children": [
              {
                "code": "60.20",
                "name": "Fjernsynskringkasting",
                "shortName": "Fjernsynskringkasting",
                "level": 4,
                "parentCode": "60.2",
                "children": [
                  {
                    "code": "60.200",
                    "name": "Fjernsynskringkasting",
                    "shortName": "Fjernsynskringkasting",
                    "level": 5,
                    "parentCode": "60.20"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "61",
        "name": "Telekommunikasjon",
        "shortName": "Telekommunikasjon",
        "level": 2,
        "parentCode": "J",
        "children": [
          {
            "code": "61.1",
            "name": "Kabelbasert telekommunikasjon",
            "shortName": "Kabelbasert telekomm.",
            "level": 3,
            "parentCode": "61",
            "children": [
              {
                "code": "61.10",
                "name": "Kabelbasert telekommunikasjon",
                "shortName": "Kabelbasert telekomm.",
                "level": 4,
                "parentCode": "61.1",
                "children": [
                  {
                    "code": "61.100",
                    "name": "Kabelbasert telekommunikasjon",
                    "shortName": "Kabelbasert telekomm.",
                    "level": 5,
                    "parentCode": "61.10"
                  }
                ]
              }
            ]
          },
          {
            "code": "61.2",
            "name": "Trådløs telekommunikasjon",
            "shortName": "Trådløs telekomm.",
            "level": 3,
            "parentCode": "61",
            "children": [
              {
                "code": "61.20",
                "name": "Trådløs telekommunikasjon",
                "shortName": "Trådløs telekomm.",
                "level": 4,
                "parentCode": "61.2",
                "children": [
                  {
                    "code": "61.200",
                    "name": "Trådløs telekommunikasjon",
                    "shortName": "Trådløs telekomm.",
                    "level": 5,
                    "parentCode": "61.20"
                  }
                ]
              }
            ]
          },
          {
            "code": "61.3",
            "name": "Satellittbasert telekommunikasjon",
            "shortName": "Satellittbasert telekomm.",
            "level": 3,
            "parentCode": "61",
            "children": [
              {
                "code": "61.30",
                "name": "Satellittbasert telekommunikasjon",
                "shortName": "Satellittbasert telekomm.",
                "level": 4,
                "parentCode": "61.3",
                "children": [
                  {
                    "code": "61.300",
                    "name": "Satellittbasert telekommunikasjon",
                    "shortName": "Satellittbasert telekomm.",
                    "level": 5,
                    "parentCode": "61.30"
                  }
                ]
              }
            ]
          },
          {
            "code": "61.9",
            "name": "Telekommunikasjon ellers",
            "shortName": "Telekommunikasjon ellers",
            "level": 3,
            "parentCode": "61",
            "children": [
              {
                "code": "61.90",
                "name": "Telekommunikasjon ellers",
                "shortName": "Telekommunikasjon ellers",
                "level": 4,
                "parentCode": "61.9",
                "children": [
                  {
                    "code": "61.900",
                    "name": "Telekommunikasjon ellers",
                    "shortName": "Telekommunikasjon ellers",
                    "level": 5,
                    "parentCode": "61.90"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "62",
        "name": "Tjenester tilknyttet informasjonsteknologi",
        "shortName": "IT-tjenester",
        "level": 2,
        "parentCode": "J",
        "children": [
          {
            "code": "62.0",
            "name": "Tjenester tilknyttet informasjonsteknologi",
            "shortName": "Tjen. tilkn. informasjonsteknologi",
            "level": 3,
            "parentCode": "62",
            "children": [
              {
                "code": "62.01",
                "name": "Programmeringstjenester",
                "shortName": "Programmeringstjenester",
                "level": 4,
                "parentCode": "62.0",
                "children": [
                  {
                    "code": "62.010",
                    "name": "Programmeringstjenester",
                    "shortName": "Programmeringstjenester",
                    "level": 5,
                    "parentCode": "62.01"
                  }
                ]
              },
              {
                "code": "62.02",
                "name": "Konsulentvirksomhet tilknyttet informasjonsteknologi",
                "shortName": "Kons.virks. tilkn. informasj.tekn.",
                "level": 4,
                "parentCode": "62.0",
                "children": [
                  {
                    "code": "62.020",
                    "name": "Konsulentvirksomhet tilknyttet informasjonsteknologi",
                    "shortName": "Kons.virks. tilkn. informasj.tekn.",
                    "level": 5,
                    "parentCode": "62.02"
                  }
                ]
              },
              {
                "code": "62.03",
                "name": "Forvaltning og drift av IT-systemer",
                "shortName": "Forvaltning og drift av IT-systemer",
                "level": 4,
                "parentCode": "62.0",
                "children": [
                  {
                    "code": "62.030",
                    "name": "Forvaltning og drift av IT-systemer",
                    "shortName": "Forvaltning og drift av IT-systemer",
                    "level": 5,
                    "parentCode": "62.03"
                  }
                ]
              },
              {
                "code": "62.09",
                "name": "Andre tjenester tilknyttet informasjonsteknologi",
                "shortName": "Tjen. tilkn. informasjonsteknologi el.",
                "level": 4,
                "parentCode": "62.0",
                "children": [
                  {
                    "code": "62.090",
                    "name": "Andre tjenester tilknyttet informasjonsteknologi",
                    "shortName": "Tjen. tilkn. informasjonsteknologi el.",
                    "level": 5,
                    "parentCode": "62.09"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "63",
        "name": "Informasjonstjenester",
        "shortName": "Informasjonstjenester",
        "level": 2,
        "parentCode": "J",
        "children": [
          {
            "code": "63.1",
            "name": "Databehandling, datalagring og tilknyttede tjenester, drift av web-portaler",
            "shortName": "Databeh./datalagr./web-portaler",
            "level": 3,
            "parentCode": "63",
            "children": [
              {
                "code": "63.11",
                "name": "Databehandling, datalagring og tilknyttede tjenester",
                "shortName": "Databeh./-lagring og tilkn. tjen.",
                "level": 4,
                "parentCode": "63.1",
                "children": [
                  {
                    "code": "63.110",
                    "name": "Databehandling, datalagring og tilknyttede tjenester",
                    "shortName": "Databeh./-lagring og tilkn. tjen.",
                    "level": 5,
                    "parentCode": "63.11"
                  }
                ]
              },
              {
                "code": "63.12",
                "name": "Drift av web-portaler",
                "shortName": "Drift av web-portaler",
                "level": 4,
                "parentCode": "63.1",
                "children": [
                  {
                    "code": "63.120",
                    "name": "Drift av web-portaler",
                    "shortName": "Drift av web-portaler",
                    "level": 5,
                    "parentCode": "63.12"
                  }
                ]
              }
            ]
          },
          {
            "code": "63.9",
            "name": "Andre informasjonstjenester",
            "shortName": "Andre informasjonstjenester",
            "level": 3,
            "parentCode": "63",
            "children": [
              {
                "code": "63.91",
                "name": "Nyhetsbyråer",
                "shortName": "Nyhetsbyråer",
                "level": 4,
                "parentCode": "63.9",
                "children": [
                  {
                    "code": "63.910",
                    "name": "Nyhetsbyråer",
                    "shortName": "Nyhetsbyråer",
                    "level": 5,
                    "parentCode": "63.91"
                  }
                ]
              },
              {
                "code": "63.99",
                "name": "Andre informasjonstjenester ikke nevnt annet sted",
                "shortName": "Andre informasjonstjenester",
                "level": 4,
                "parentCode": "63.9",
                "children": [
                  {
                    "code": "63.990",
                    "name": "Andre informasjonstjenester ikke nevnt annet sted",
                    "shortName": "Andre informasjonstjenester",
                    "level": 5,
                    "parentCode": "63.99"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "code": "K",
    "name": "Finansierings- og forsikringsvirksomhet",
    "shortName": "Finansiering og forsikring",
    "level": 1,
    "parentCode": "",
    "children": [
      {
        "code": "64",
        "name": "Finansieringsvirksomhet",
        "shortName": "Finansieringsvirksomhet",
        "level": 2,
        "parentCode": "K",
        "children": [
          {
            "code": "64.1",
            "name": "Bankvirksomhet",
            "shortName": "Bankvirksomhet",
            "level": 3,
            "parentCode": "64",
            "children": [
              {
                "code": "64.11",
                "name": "Sentralbankvirksomhet",
                "shortName": "Sentralbankvirksomhet",
                "level": 4,
                "parentCode": "64.1",
                "children": [
                  {
                    "code": "64.110",
                    "name": "Sentralbankvirksomhet",
                    "shortName": "Sentralbankvirksomhet",
                    "level": 5,
                    "parentCode": "64.11"
                  }
                ]
              },
              {
                "code": "64.19",
                "name": "Bankvirksomhet ellers",
                "shortName": "Bankvirksomhet ellers",
                "level": 4,
                "parentCode": "64.1",
                "children": [
                  {
                    "code": "64.190",
                    "name": "Bankvirksomhet ellers",
                    "shortName": "Bankvirksomhet ellers",
                    "level": 5,
                    "parentCode": "64.19"
                  }
                ]
              }
            ]
          },
          {
            "code": "64.2",
            "name": "Holdingselskaper",
            "shortName": "Holdingselskaper",
            "level": 3,
            "parentCode": "64",
            "children": [
              {
                "code": "64.20",
                "name": "Holdingselskaper",
                "shortName": "Holdingselskaper",
                "level": 4,
                "parentCode": "64.2",
                "children": [
                  {
                    "code": "64.201",
                    "name": "Finansielle holdingselskaper",
                    "shortName": "Finansielle holdingselskaper",
                    "level": 5,
                    "parentCode": "64.20"
                  },
                  {
                    "code": "64.202",
                    "name": "Spesielle holdingselskaper",
                    "shortName": "Spesielle holdingselskaper",
                    "level": 5,
                    "parentCode": "64.20"
                  }
                ]
              }
            ]
          },
          {
            "code": "64.3",
            "name": "Verdipapirfond, investeringsselskaper o.l.",
            "shortName": "Verdipapirfond/invest.selskap o.l.",
            "level": 3,
            "parentCode": "64",
            "children": [
              {
                "code": "64.30",
                "name": "Verdipapirfond, investeringsselskaper o.l.",
                "shortName": "Verdipapirfond/invest.selskap. o.l.",
                "level": 4,
                "parentCode": "64.3",
                "children": [
                  {
                    "code": "64.301",
                    "name": "Verdipapirfond",
                    "shortName": "Verdipapirfond",
                    "level": 5,
                    "parentCode": "64.30"
                  },
                  {
                    "code": "64.302",
                    "name": "Alternative investeringsfond (AIF) som ikke er verdipapirfond",
                    "shortName": "Alternative investeringsfond AIF",
                    "level": 5,
                    "parentCode": "64.30"
                  },
                  {
                    "code": "64.305",
                    "name": "Finansstiftelser",
                    "shortName": "Finansstiftelser",
                    "level": 5,
                    "parentCode": "64.30"
                  },
                  {
                    "code": "64.306",
                    "name": "Egeninvesteringsselskaper i finansielle konsern og for offentlig forvaltning",
                    "shortName": "Egeninvesteringsselskaper i finansielle konsern og for offentlig forvaltning",
                    "level": 5,
                    "parentCode": "64.30"
                  },
                  {
                    "code": "64.308",
                    "name": "Familieeide egeninvesteringsselskaper",
                    "shortName": "Familieide egeninvesteringsselskaper",
                    "level": 5,
                    "parentCode": "64.30"
                  }
                ]
              }
            ]
          },
          {
            "code": "64.9",
            "name": "Annen finansieringsvirksomhet",
            "shortName": "Annen finansieringsvirksomhet",
            "level": 3,
            "parentCode": "64",
            "children": [
              {
                "code": "64.91",
                "name": "Finansiell leasing",
                "shortName": "Finansiell leasing",
                "level": 4,
                "parentCode": "64.9",
                "children": [
                  {
                    "code": "64.910",
                    "name": "Finansiell leasing",
                    "shortName": "Finansiell leasing",
                    "level": 5,
                    "parentCode": "64.91"
                  }
                ]
              },
              {
                "code": "64.92",
                "name": "Annen kredittgivning",
                "shortName": "Annen kredittgivning",
                "level": 4,
                "parentCode": "64.9",
                "children": [
                  {
                    "code": "64.920",
                    "name": "Annen kredittgivning",
                    "shortName": "Annen kredittgiving",
                    "level": 5,
                    "parentCode": "64.92"
                  }
                ]
              },
              {
                "code": "64.99",
                "name": "Annen finansieringsvirksomhet ikke nevnt annet sted",
                "shortName": "Finansieringsvirksomhet el.",
                "level": 4,
                "parentCode": "64.9",
                "children": [
                  {
                    "code": "64.990",
                    "name": "Annen finansieringsvirksomhet ikke nevnt annet sted",
                    "shortName": "Finansieringsvirksomhet el.",
                    "level": 5,
                    "parentCode": "64.99"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "65",
        "name": "Forsikringsvirksomhet og pensjonskasser, unntatt trygdeordninger underlagt offentlig forvaltning",
        "shortName": "Forsikring og pensjonskasser",
        "level": 2,
        "parentCode": "K",
        "children": [
          {
            "code": "65.1",
            "name": "Forsikring",
            "shortName": "Forsikring",
            "level": 3,
            "parentCode": "65",
            "children": [
              {
                "code": "65.11",
                "name": "Livsforsikring",
                "shortName": "Livsforsikring",
                "level": 4,
                "parentCode": "65.1",
                "children": [
                  {
                    "code": "65.110",
                    "name": "Livsforsikring",
                    "shortName": "Livsforsikring",
                    "level": 5,
                    "parentCode": "65.11"
                  }
                ]
              },
              {
                "code": "65.12",
                "name": "Skadeforsikring",
                "shortName": "Skadeforsikring",
                "level": 4,
                "parentCode": "65.1",
                "children": [
                  {
                    "code": "65.120",
                    "name": "Skadeforsikring",
                    "shortName": "Skadeforsikring",
                    "level": 5,
                    "parentCode": "65.12"
                  }
                ]
              }
            ]
          },
          {
            "code": "65.2",
            "name": "Gjenforsikring",
            "shortName": "Gjenforsikring",
            "level": 3,
            "parentCode": "65",
            "children": [
              {
                "code": "65.20",
                "name": "Gjenforsikring",
                "shortName": "Gjenforsikring",
                "level": 4,
                "parentCode": "65.2",
                "children": [
                  {
                    "code": "65.200",
                    "name": "Gjenforsikring",
                    "shortName": "Gjenforsikring",
                    "level": 5,
                    "parentCode": "65.20"
                  }
                ]
              }
            ]
          },
          {
            "code": "65.3",
            "name": "Pensjonskasser",
            "shortName": "Pensjonskasser",
            "level": 3,
            "parentCode": "65",
            "children": [
              {
                "code": "65.30",
                "name": "Pensjonskasser",
                "shortName": "Pensjonskasser",
                "level": 4,
                "parentCode": "65.3",
                "children": [
                  {
                    "code": "65.300",
                    "name": "Pensjonskasser",
                    "shortName": "Pensjonskasser",
                    "level": 5,
                    "parentCode": "65.30"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "66",
        "name": "Tjenester tilknyttet finansierings- og forsikringsvirksomhet",
        "shortName": "Finans-, forsikringshjelpetjenester",
        "level": 2,
        "parentCode": "K",
        "children": [
          {
            "code": "66.1",
            "name": "Tjenester tilknyttet finansieringsvirksomhet",
            "shortName": "Tjen. tilkn. finansieringsvirks.",
            "level": 3,
            "parentCode": "66",
            "children": [
              {
                "code": "66.11",
                "name": "Administrasjon av finansmarkeder",
                "shortName": "Administrasjon av finansmarkeder",
                "level": 4,
                "parentCode": "66.1",
                "children": [
                  {
                    "code": "66.110",
                    "name": "Administrasjon av finansmarkeder",
                    "shortName": "Administrasjon av finansmarkeder",
                    "level": 5,
                    "parentCode": "66.11"
                  }
                ]
              },
              {
                "code": "66.12",
                "name": "Verdipapirmegling",
                "shortName": "Verdipapirmegling",
                "level": 4,
                "parentCode": "66.1",
                "children": [
                  {
                    "code": "66.120",
                    "name": "Verdipapirmegling",
                    "shortName": "Verdipapirmegling",
                    "level": 5,
                    "parentCode": "66.12"
                  }
                ]
              },
              {
                "code": "66.19",
                "name": "Andre tjenester tilknyttet finansieringsvirksomhet",
                "shortName": "Tjen. tilkn. finansieringsvirks. el.",
                "level": 4,
                "parentCode": "66.1",
                "children": [
                  {
                    "code": "66.190",
                    "name": "Andre tjenester tilknyttet finansieringsvirksomhet",
                    "shortName": "Tjen. tilkn. finansieringsvirks. el.",
                    "level": 5,
                    "parentCode": "66.19"
                  }
                ]
              }
            ]
          },
          {
            "code": "66.2",
            "name": "Tjenester tilknyttet forsikringsvirksomhet og pensjonskasser",
            "shortName": "Tjen. til forsikr./pensjonskasser",
            "level": 3,
            "parentCode": "66",
            "children": [
              {
                "code": "66.21",
                "name": "Risiko- og skadevurdering",
                "shortName": "Risiko- og skadevurdering",
                "level": 4,
                "parentCode": "66.2",
                "children": [
                  {
                    "code": "66.210",
                    "name": "Risiko- og skadevurdering",
                    "shortName": "Risiko- og skadevurdering",
                    "level": 5,
                    "parentCode": "66.21"
                  }
                ]
              },
              {
                "code": "66.22",
                "name": "Forsikringsformidling",
                "shortName": "Forsikringsformidling",
                "level": 4,
                "parentCode": "66.2",
                "children": [
                  {
                    "code": "66.220",
                    "name": "Forsikringsformidling",
                    "shortName": "Forsikringsformidling",
                    "level": 5,
                    "parentCode": "66.22"
                  }
                ]
              },
              {
                "code": "66.29",
                "name": "Andre tjenester tilknyttet forsikringsvirksomhet og pensjonskasser",
                "shortName": "Tjen. fors.virks./pensj.kasser el.",
                "level": 4,
                "parentCode": "66.2",
                "children": [
                  {
                    "code": "66.290",
                    "name": "Andre tjenester tilknyttet forsikringsvirksomhet og pensjonskasser",
                    "shortName": "Tjen. fors.virks./pensj.kasser el.",
                    "level": 5,
                    "parentCode": "66.29"
                  }
                ]
              }
            ]
          },
          {
            "code": "66.3",
            "name": "Fondsforvaltningsvirksomhet",
            "shortName": "Fondsforvaltningsvirksomhet",
            "level": 3,
            "parentCode": "66",
            "children": [
              {
                "code": "66.30",
                "name": "Fondsforvaltningsvirksomhet",
                "shortName": "Fondsforvaltningsvirksomhet",
                "level": 4,
                "parentCode": "66.3",
                "children": [
                  {
                    "code": "66.300",
                    "name": "Fondsforvaltningsvirksomhet",
                    "shortName": "Fondsforvaltningsvirksomhet",
                    "level": 5,
                    "parentCode": "66.30"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "code": "L",
    "name": "Omsetning og drift av fast eiendom",
    "shortName": "Omsetning og drift av fast eiendom",
    "level": 1,
    "parentCode": "",
    "children": [
      {
        "code": "68",
        "name": "Omsetning og drift av fast eiendom",
        "shortName": "Omsetning og drift av fast eiendom",
        "level": 2,
        "parentCode": "L",
        "children": [
          {
            "code": "68.1",
            "name": "Kjøp og salg av egen fast eiendom",
            "shortName": "Kjøp/salg av egen fast eiendom",
            "level": 3,
            "parentCode": "68",
            "children": [
              {
                "code": "68.10",
                "name": "Kjøp og salg av egen fast eiendom",
                "shortName": "Kjøp/salg av egen fast eiendom",
                "level": 4,
                "parentCode": "68.1",
                "children": [
                  {
                    "code": "68.100",
                    "name": "Kjøp og salg av egen fast eiendom",
                    "shortName": "Kjøp/salg av egen fast eiendom",
                    "level": 5,
                    "parentCode": "68.10"
                  }
                ]
              }
            ]
          },
          {
            "code": "68.2",
            "name": "Utleie av egen eller leid fast eiendom",
            "shortName": "Utleie av egen/leid fast eiendom",
            "level": 3,
            "parentCode": "68",
            "children": [
              {
                "code": "68.20",
                "name": "Utleie av egen eller leid fast eiendom",
                "shortName": "Utleie av egen/leid fast eiendom",
                "level": 4,
                "parentCode": "68.2",
                "children": [
                  {
                    "code": "68.201",
                    "name": "Borettslag",
                    "shortName": "Borettslag",
                    "level": 5,
                    "parentCode": "68.20"
                  },
                  {
                    "code": "68.209",
                    "name": "Utleie av egen eller leid fast eiendom ellers",
                    "shortName": "Utl. av egen/leid fast eiendom el.",
                    "level": 5,
                    "parentCode": "68.20"
                  }
                ]
              }
            ]
          },
          {
            "code": "68.3",
            "name": "Omsetning og drift av fast eiendom på oppdrag",
            "shortName": "Oppdragsvirksomhet for fast eiendom",
            "level": 3,
            "parentCode": "68",
            "children": [
              {
                "code": "68.31",
                "name": "Eiendomsmegling",
                "shortName": "Eiendomsmegling",
                "level": 4,
                "parentCode": "68.3",
                "children": [
                  {
                    "code": "68.310",
                    "name": "Eiendomsmegling",
                    "shortName": "Eiendomsmegling",
                    "level": 5,
                    "parentCode": "68.31"
                  }
                ]
              },
              {
                "code": "68.32",
                "name": "Eiendomsforvaltning",
                "shortName": "Eiendomsforvaltning",
                "level": 4,
                "parentCode": "68.3",
                "children": [
                  {
                    "code": "68.320",
                    "name": "Eiendomsforvaltning",
                    "shortName": "Eiendomsforvaltning",
                    "level": 5,
                    "parentCode": "68.32"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "code": "M",
    "name": "Faglig, vitenskapelig og teknisk tjenesteyting",
    "shortName": "Faglig, vit. og tekn. tjenesteyting",
    "level": 1,
    "parentCode": "",
    "children": [
      {
        "code": "69",
        "name": "Juridisk og regnskapsmessig tjenesteyting",
        "shortName": "Juridisk og regnsk.messig tj.yting",
        "level": 2,
        "parentCode": "M",
        "children": [
          {
            "code": "69.1",
            "name": "Juridisk tjenesteyting",
            "shortName": "Juridisk tjenesteyting",
            "level": 3,
            "parentCode": "69",
            "children": [
              {
                "code": "69.10",
                "name": "Juridisk tjenesteyting",
                "shortName": "Juridisk tjenesteyting",
                "level": 4,
                "parentCode": "69.1",
                "children": [
                  {
                    "code": "69.100",
                    "name": "Juridisk tjenesteyting",
                    "shortName": "Juridisk tjenesteyting",
                    "level": 5,
                    "parentCode": "69.10"
                  }
                ]
              }
            ]
          },
          {
            "code": "69.2",
            "name": "Regnskap, revisjon og skatterådgivning",
            "shortName": "Regnskap/revisjon/skatterådgiv.",
            "level": 3,
            "parentCode": "69",
            "children": [
              {
                "code": "69.20",
                "name": "Regnskap, revisjon og skatterådgivning",
                "shortName": "Regnskap/revisjon/skatterådgiv.",
                "level": 4,
                "parentCode": "69.2",
                "children": [
                  {
                    "code": "69.201",
                    "name": "Regnskap og bokføring",
                    "shortName": "Regnskap og bokføring",
                    "level": 5,
                    "parentCode": "69.20"
                  },
                  {
                    "code": "69.202",
                    "name": "Revisjon",
                    "shortName": "Revisjon",
                    "level": 5,
                    "parentCode": "69.20"
                  },
                  {
                    "code": "69.203",
                    "name": "Skatterådgivning",
                    "shortName": "Skatterådgivning",
                    "level": 5,
                    "parentCode": "69.20"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "70",
        "name": "Hovedkontortjenester, administrativ rådgivning",
        "shortName": "Hovedkontortjen. og adm. rådgivning",
        "level": 2,
        "parentCode": "M",
        "children": [
          {
            "code": "70.1",
            "name": "Hovedkontortjenester",
            "shortName": "Hovedkontortjenester",
            "level": 3,
            "parentCode": "70",
            "children": [
              {
                "code": "70.10",
                "name": "Hovedkontortjenester",
                "shortName": "Hovedkontortjenester",
                "level": 4,
                "parentCode": "70.1",
                "children": [
                  {
                    "code": "70.100",
                    "name": "Hovedkontortjenester",
                    "shortName": "Hovedkontortjenester",
                    "level": 5,
                    "parentCode": "70.10"
                  }
                ]
              }
            ]
          },
          {
            "code": "70.2",
            "name": "Administrativ rådgivning",
            "shortName": "Administrativ rådgivning",
            "level": 3,
            "parentCode": "70",
            "children": [
              {
                "code": "70.21",
                "name": "PR og kommunikasjonstjenester",
                "shortName": "PR og kommunikasjonstjenester",
                "level": 4,
                "parentCode": "70.2",
                "children": [
                  {
                    "code": "70.210",
                    "name": "PR og kommunikasjonstjenester",
                    "shortName": "PR og kommunikasjonstjenester",
                    "level": 5,
                    "parentCode": "70.21"
                  }
                ]
              },
              {
                "code": "70.22",
                "name": "Bedriftsrådgivning og annen administrativ rådgivning",
                "shortName": "Bedriftsrådgiv./annen adm. rådgiv.",
                "level": 4,
                "parentCode": "70.2",
                "children": [
                  {
                    "code": "70.220",
                    "name": "Bedriftsrådgivning og annen administrativ rådgivning",
                    "shortName": "Bedriftsrådgiv./annen adm. rådgiv.",
                    "level": 5,
                    "parentCode": "70.22"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "71",
        "name": "Arkitektvirksomhet og teknisk konsulentvirksomhet, og teknisk prøving og analyse",
        "shortName": "Arkitekter og tekniske konsulenter",
        "level": 2,
        "parentCode": "M",
        "children": [
          {
            "code": "71.1",
            "name": "Arkitektvirksomhet og teknisk konsulentvirksomhet",
            "shortName": "Arkitekt- og tekn. konsulentvirks.",
            "level": 3,
            "parentCode": "71",
            "children": [
              {
                "code": "71.11",
                "name": "Arkitektvirksomhet",
                "shortName": "Arkitektvirksomhet",
                "level": 4,
                "parentCode": "71.1",
                "children": [
                  {
                    "code": "71.111",
                    "name": "Plan- og reguleringsarbeid",
                    "shortName": "Plan- og reguleringsarbeid",
                    "level": 5,
                    "parentCode": "71.11"
                  },
                  {
                    "code": "71.112",
                    "name": "Arkitekttjenester vedrørende byggverk",
                    "shortName": "Arkitekttjen. vedr. byggverk",
                    "level": 5,
                    "parentCode": "71.11"
                  },
                  {
                    "code": "71.113",
                    "name": "Landskapsarkitekttjenester",
                    "shortName": "Landskapsarkitekttjenester",
                    "level": 5,
                    "parentCode": "71.11"
                  }
                ]
              },
              {
                "code": "71.12",
                "name": "Teknisk konsulentvirksomhet",
                "shortName": "Teknisk konsulentvirksomhet",
                "level": 4,
                "parentCode": "71.1",
                "children": [
                  {
                    "code": "71.121",
                    "name": "Byggeteknisk konsulentvirksomhet",
                    "shortName": "Byggeteknisk konsulentvirks.",
                    "level": 5,
                    "parentCode": "71.12"
                  },
                  {
                    "code": "71.122",
                    "name": "Geologiske undersøkelser",
                    "shortName": "Geologiske undersøkelser",
                    "level": 5,
                    "parentCode": "71.12"
                  },
                  {
                    "code": "71.123",
                    "name": "Kart og oppmåling",
                    "shortName": "Kart og oppmåling",
                    "level": 5,
                    "parentCode": "71.12"
                  },
                  {
                    "code": "71.129",
                    "name": "Annen teknisk konsulentvirksomhet",
                    "shortName": "Annen teknisk konsulentvirks.",
                    "level": 5,
                    "parentCode": "71.12"
                  }
                ]
              }
            ]
          },
          {
            "code": "71.2",
            "name": "Teknisk prøving og analyse",
            "shortName": "Teknisk prøving og analyse",
            "level": 3,
            "parentCode": "71",
            "children": [
              {
                "code": "71.20",
                "name": "Teknisk prøving og analyse",
                "shortName": "Teknisk prøving og analyse",
                "level": 4,
                "parentCode": "71.2",
                "children": [
                  {
                    "code": "71.200",
                    "name": "Teknisk prøving og analyse",
                    "shortName": "Teknisk prøving og analyse",
                    "level": 5,
                    "parentCode": "71.20"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "72",
        "name": "Forskning og utviklingsarbeid",
        "shortName": "Forskning og utviklingsarbeid",
        "level": 2,
        "parentCode": "M",
        "children": [
          {
            "code": "72.1",
            "name": "Forskning og utviklingsarbeid innen naturvitenskap og teknikk",
            "shortName": "Forskning naturvitenskap, teknikk",
            "level": 3,
            "parentCode": "72",
            "children": [
              {
                "code": "72.11",
                "name": "Forskning og utviklingsarbeid innen bioteknologi",
                "shortName": "Forsk./utvikl.arb. innen bioteknologi",
                "level": 4,
                "parentCode": "72.1",
                "children": [
                  {
                    "code": "72.110",
                    "name": "Forskning og utviklingsarbeid innen bioteknologi",
                    "shortName": "Forsk./utvikl.arb. innen bioteknologi",
                    "level": 5,
                    "parentCode": "72.11"
                  }
                ]
              },
              {
                "code": "72.19",
                "name": "Annen forskning og annet utviklingsarbeid innen naturvitenskap og teknikk",
                "shortName": "Annen forsk. innen naturvit. og teknikk",
                "level": 4,
                "parentCode": "72.1",
                "children": [
                  {
                    "code": "72.190",
                    "name": "Annen forskning og annet utviklingsarbeid innen naturvitenskap og teknikk",
                    "shortName": "Annen forsk. innen naturvit. og teknikk",
                    "level": 5,
                    "parentCode": "72.19"
                  }
                ]
              }
            ]
          },
          {
            "code": "72.2",
            "name": "Forskning og utviklingsarbeid innen samfunnsvitenskap og humanistiske fag",
            "shortName": "Forskning samfunnsvit., human. fag",
            "level": 3,
            "parentCode": "72",
            "children": [
              {
                "code": "72.20",
                "name": "Forskning og utviklingsarbeid innen samfunnsvitenskap og humanistiske fag",
                "shortName": "Forskning samfunnsvit., human. fag",
                "level": 4,
                "parentCode": "72.2",
                "children": [
                  {
                    "code": "72.200",
                    "name": "Forskning og utviklingsarbeid innen samfunnsvitenskap og humanistiske fag",
                    "shortName": "Forskning samfunnsvit., human. fag",
                    "level": 5,
                    "parentCode": "72.20"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "73",
        "name": "Annonse- og reklamevirksomhet og markedsundersøkelser",
        "shortName": "Reklamevirksomhet og markedsund.",
        "level": 2,
        "parentCode": "M",
        "children": [
          {
            "code": "73.1",
            "name": "Annonse- og reklamevirksomhet",
            "shortName": "Annonse- og reklamevirksomhet",
            "level": 3,
            "parentCode": "73",
            "children": [
              {
                "code": "73.11",
                "name": "Reklamebyråer",
                "shortName": "Reklamebyråer",
                "level": 4,
                "parentCode": "73.1",
                "children": [
                  {
                    "code": "73.110",
                    "name": "Reklamebyråer",
                    "shortName": "Reklamebyråer",
                    "level": 5,
                    "parentCode": "73.11"
                  }
                ]
              },
              {
                "code": "73.12",
                "name": "Medieformidlingstjenester",
                "shortName": "Medieformidlingstjenester",
                "level": 4,
                "parentCode": "73.1",
                "children": [
                  {
                    "code": "73.120",
                    "name": "Medieformidlingstjenester",
                    "shortName": "Medieformidlingstjenester",
                    "level": 5,
                    "parentCode": "73.12"
                  }
                ]
              }
            ]
          },
          {
            "code": "73.2",
            "name": "Markeds- og opinionsundersøkelser",
            "shortName": "Markeds- og opinionsundersøkelser",
            "level": 3,
            "parentCode": "73",
            "children": [
              {
                "code": "73.20",
                "name": "Markeds- og opinionsundersøkelser",
                "shortName": "Markeds- og opinionsundersøkelser",
                "level": 4,
                "parentCode": "73.2",
                "children": [
                  {
                    "code": "73.200",
                    "name": "Markeds- og opinionsundersøkelser",
                    "shortName": "Markeds- og opinionsundersøkelser",
                    "level": 5,
                    "parentCode": "73.20"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "74",
        "name": "Annen faglig, vitenskapelig og teknisk virksomhet",
        "shortName": "Fagl., vit. og tekn. virks. ellers",
        "level": 2,
        "parentCode": "M",
        "children": [
          {
            "code": "74.1",
            "name": "Spesialisert designvirksomhet",
            "shortName": "Spesialisert designvirksomhet",
            "level": 3,
            "parentCode": "74",
            "children": [
              {
                "code": "74.10",
                "name": "Spesialisert designvirksomhet",
                "shortName": "Spesialisert designvirksomhet",
                "level": 4,
                "parentCode": "74.1",
                "children": [
                  {
                    "code": "74.101",
                    "name": "Industridesign, produktdesign og annen teknisk designvirksomhet",
                    "shortName": "Ind.-/produkt-/tekn.designvirks el",
                    "level": 5,
                    "parentCode": "74.10"
                  },
                  {
                    "code": "74.102",
                    "name": "Grafisk og visuell kommunikasjonsdesign",
                    "shortName": "Grafisk/visuell kommunikasj.design",
                    "level": 5,
                    "parentCode": "74.10"
                  },
                  {
                    "code": "74.103",
                    "name": "Interiørarkitekt-, interiørdesign- og interiørkonsulentvirksomhet",
                    "shortName": "Interiørark./-design/interiørkons.",
                    "level": 5,
                    "parentCode": "74.10"
                  }
                ]
              }
            ]
          },
          {
            "code": "74.2",
            "name": "Fotografvirksomhet",
            "shortName": "Fotografvirksomhet",
            "level": 3,
            "parentCode": "74",
            "children": [
              {
                "code": "74.20",
                "name": "Fotografvirksomhet",
                "shortName": "Fotografvirksomhet",
                "level": 4,
                "parentCode": "74.2",
                "children": [
                  {
                    "code": "74.200",
                    "name": "Fotografvirksomhet",
                    "shortName": "Fotografvirksomhet",
                    "level": 5,
                    "parentCode": "74.20"
                  }
                ]
              }
            ]
          },
          {
            "code": "74.3",
            "name": "Oversettelses- og tolkevirksomhet",
            "shortName": "Oversettelses- og tolkevirksomhet",
            "level": 3,
            "parentCode": "74",
            "children": [
              {
                "code": "74.30",
                "name": "Oversettelses- og tolkevirksomhet",
                "shortName": "Oversettelses- og tolkevirksomhet",
                "level": 4,
                "parentCode": "74.3",
                "children": [
                  {
                    "code": "74.300",
                    "name": "Oversettelses- og tolkevirksomhet",
                    "shortName": "Oversettelses- og tolkevirksomhet",
                    "level": 5,
                    "parentCode": "74.30"
                  }
                ]
              }
            ]
          },
          {
            "code": "74.9",
            "name": "Annen faglig, vitenskapelig og teknisk virksomhet",
            "shortName": "Annen faglig/vit.skap./tekn. virks.",
            "level": 3,
            "parentCode": "74",
            "children": [
              {
                "code": "74.90",
                "name": "Annen faglig, vitenskapelig og teknisk virksomhet",
                "shortName": "Annen faglig/vit.skap./tekn. virks.",
                "level": 4,
                "parentCode": "74.9",
                "children": [
                  {
                    "code": "74.901",
                    "name": "Takseringsvirksomhet",
                    "shortName": "Takseringsvirksomhet",
                    "level": 5,
                    "parentCode": "74.90"
                  },
                  {
                    "code": "74.902",
                    "name": "Modellbyråvirksomhet",
                    "shortName": "Modellbyråvirksomhet",
                    "level": 5,
                    "parentCode": "74.90"
                  },
                  {
                    "code": "74.903",
                    "name": "Impresariovirksomhet",
                    "shortName": "Impresariovirksomhet",
                    "level": 5,
                    "parentCode": "74.90"
                  },
                  {
                    "code": "74.909",
                    "name": "Annen faglig, vitenskapelig og teknisk virksomhet ikke nevnt annet sted",
                    "shortName": "Faglig/vit.skapelig/tekn.virks. el.",
                    "level": 5,
                    "parentCode": "74.90"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "75",
        "name": "Veterinærtjenester",
        "shortName": "Veterinærtjenester",
        "level": 2,
        "parentCode": "M",
        "children": [
          {
            "code": "75.0",
            "name": "Veterinærtjenester",
            "shortName": "Veterinærtjenester",
            "level": 3,
            "parentCode": "75",
            "children": [
              {
                "code": "75.00",
                "name": "Veterinærtjenester",
                "shortName": "Veterinærtjenester",
                "level": 4,
                "parentCode": "75.0",
                "children": [
                  {
                    "code": "75.000",
                    "name": "Veterinærtjenester",
                    "shortName": "Veterinærtjenester",
                    "level": 5,
                    "parentCode": "75.00"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "code": "N",
    "name": "Forretningsmessig tjenesteyting",
    "shortName": "Forretningsmessig tjenesteyting",
    "level": 1,
    "parentCode": "",
    "children": [
      {
        "code": "77",
        "name": "Utleie- og leasingvirksomhet",
        "shortName": "Utleie- og leasingvirksomhet",
        "level": 2,
        "parentCode": "N",
        "children": [
          {
            "code": "77.1",
            "name": "Utleie og leasing av motorvogner",
            "shortName": "Bilutleie",
            "level": 3,
            "parentCode": "77",
            "children": [
              {
                "code": "77.11",
                "name": "Utleie og leasing av biler og andre lette motorvogner",
                "shortName": "Utl./leas. biler/andre lette motorv.",
                "level": 4,
                "parentCode": "77.1",
                "children": [
                  {
                    "code": "77.110",
                    "name": "Utleie og leasing av biler og andre lette motorvogner",
                    "shortName": "Utl./leas. biler/andre lette motorv.",
                    "level": 5,
                    "parentCode": "77.11"
                  }
                ]
              },
              {
                "code": "77.12",
                "name": "Utleie og leasing av lastebiler",
                "shortName": "Utleie og leasing av lastebiler",
                "level": 4,
                "parentCode": "77.1",
                "children": [
                  {
                    "code": "77.120",
                    "name": "Utleie og leasing av lastebiler",
                    "shortName": "Utleie og leasing av lastebiler",
                    "level": 5,
                    "parentCode": "77.12"
                  }
                ]
              }
            ]
          },
          {
            "code": "77.2",
            "name": "Utleie og leasing av husholdningsvarer og varer til personlig bruk",
            "shortName": "Utl. hush.varer og varer pers. bruk",
            "level": 3,
            "parentCode": "77",
            "children": [
              {
                "code": "77.21",
                "name": "Utleie og leasing av sports- og fritidsutstyr",
                "shortName": "Utl./leas. sports- og fritidsutstyr",
                "level": 4,
                "parentCode": "77.2",
                "children": [
                  {
                    "code": "77.210",
                    "name": "Utleie og leasing av sports- og fritidsutstyr",
                    "shortName": "Utl./leas. sports- og fritidsutstyr",
                    "level": 5,
                    "parentCode": "77.21"
                  }
                ]
              },
              {
                "code": "77.22",
                "name": "Utleie av videofilm, DVD og lignende",
                "shortName": "Utleie videofilm, DVD og lignende",
                "level": 4,
                "parentCode": "77.2",
                "children": [
                  {
                    "code": "77.220",
                    "name": "Utleie av videofilm, DVD og lignende",
                    "shortName": "Utleie videofilm, DVD og lignende",
                    "level": 5,
                    "parentCode": "77.22"
                  }
                ]
              },
              {
                "code": "77.29",
                "name": "Utleie og leasing av andre husholdningsvarer og varer til personlig bruk",
                "shortName": "Utl./leas. husholdningsvarer el.",
                "level": 4,
                "parentCode": "77.2",
                "children": [
                  {
                    "code": "77.290",
                    "name": "Utleie og leasing av andre husholdningsvarer og varer til personlig bruk",
                    "shortName": "Utl./leas. husholdningsvarer el.",
                    "level": 5,
                    "parentCode": "77.29"
                  }
                ]
              }
            ]
          },
          {
            "code": "77.3",
            "name": "Utleie og leasing av andre maskiner, og annet utstyr og materiell",
            "shortName": "Utleie av maskiner og utstyr ellers",
            "level": 3,
            "parentCode": "77",
            "children": [
              {
                "code": "77.31",
                "name": "Utleie og leasing av landbruksmaskiner og -utstyr",
                "shortName": "Utl./leas. landbruksmaskiner og -utstyr",
                "level": 4,
                "parentCode": "77.3",
                "children": [
                  {
                    "code": "77.310",
                    "name": "Utleie og leasing av landbruksmaskiner og -utstyr",
                    "shortName": "Utl./leas. landbruksmaskiner og -utstyr",
                    "level": 5,
                    "parentCode": "77.31"
                  }
                ]
              },
              {
                "code": "77.32",
                "name": "Utleie og leasing av bygge- og anleggsmaskiner og -utstyr",
                "shortName": "Utl./leas. bygge- og anleggsmask.",
                "level": 4,
                "parentCode": "77.3",
                "children": [
                  {
                    "code": "77.320",
                    "name": "Utleie og leasing av bygge- og anleggsmaskiner og -utstyr",
                    "shortName": "Utl./leas. bygge- og anleggsmask.",
                    "level": 5,
                    "parentCode": "77.32"
                  }
                ]
              },
              {
                "code": "77.33",
                "name": "Utleie og leasing av kontor- og datamaskiner",
                "shortName": "Utl./leas. kontor- og datamaskiner",
                "level": 4,
                "parentCode": "77.3",
                "children": [
                  {
                    "code": "77.330",
                    "name": "Utleie og leasing av kontor- og datamaskiner",
                    "shortName": "Utl./leas. kontor- og datamaskiner",
                    "level": 5,
                    "parentCode": "77.33"
                  }
                ]
              },
              {
                "code": "77.34",
                "name": "Utleie og leasing av sjøtransportmateriell",
                "shortName": "Utl./leas. sjøtransportmateriell",
                "level": 4,
                "parentCode": "77.3",
                "children": [
                  {
                    "code": "77.340",
                    "name": "Utleie og leasing av sjøtransportmateriell",
                    "shortName": "Utl./leas. sjøtransportmateriell",
                    "level": 5,
                    "parentCode": "77.34"
                  }
                ]
              },
              {
                "code": "77.35",
                "name": "Utleie og leasing av lufttransportmateriell",
                "shortName": "Utl./leas. lufttransportmateriell",
                "level": 4,
                "parentCode": "77.3",
                "children": [
                  {
                    "code": "77.350",
                    "name": "Utleie og leasing av lufttransportmateriell",
                    "shortName": "Utl./leas. lufttransportmateriell",
                    "level": 5,
                    "parentCode": "77.35"
                  }
                ]
              },
              {
                "code": "77.39",
                "name": "Utleie og leasing av andre maskiner og annet utstyr og materiell ikke nevnt annet sted",
                "shortName": "Utl./leas. andre mask./annet utstyr",
                "level": 4,
                "parentCode": "77.3",
                "children": [
                  {
                    "code": "77.390",
                    "name": "Utleie og leasing av andre maskiner og annet utstyr og materiell ikke nevnt annet sted",
                    "shortName": "Utl./leas. andre mask./annet utstyr",
                    "level": 5,
                    "parentCode": "77.39"
                  }
                ]
              }
            ]
          },
          {
            "code": "77.4",
            "name": "Leasing av immateriell eiendom og lignende produkter, unntatt opphavsrettsbeskyttede verker",
            "shortName": "Leas. av immateriell eiendom mv.",
            "level": 3,
            "parentCode": "77",
            "children": [
              {
                "code": "77.40",
                "name": "Leasing av immateriell eiendom og lignende produkter, unntatt opphavsrettsbeskyttede verker",
                "shortName": "Leas. av immateriell eiendom mv.",
                "level": 4,
                "parentCode": "77.4",
                "children": [
                  {
                    "code": "77.400",
                    "name": "Leasing av immateriell eiendom og lignende produkter, unntatt opphavsrettsbeskyttede verker",
                    "shortName": "Leas. av immateriell eiendom mv.",
                    "level": 5,
                    "parentCode": "77.40"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "78",
        "name": "Arbeidskrafttjenester",
        "shortName": "Arbeidskrafttjenester",
        "level": 2,
        "parentCode": "N",
        "children": [
          {
            "code": "78.1",
            "name": "Rekruttering og formidling av arbeidskraft",
            "shortName": "Rekrutt./formidling av arbeidskraft",
            "level": 3,
            "parentCode": "78",
            "children": [
              {
                "code": "78.10",
                "name": "Rekruttering og formidling av arbeidskraft",
                "shortName": "Rekrutt./formidling av arbeidskraft",
                "level": 4,
                "parentCode": "78.1",
                "children": [
                  {
                    "code": "78.100",
                    "name": "Rekruttering og formidling av arbeidskraft",
                    "shortName": "Rekrutt./formidling av arbeidskraft",
                    "level": 5,
                    "parentCode": "78.10"
                  }
                ]
              }
            ]
          },
          {
            "code": "78.2",
            "name": "Utleie av arbeidskraft",
            "shortName": "Utleie av arbeidskraft",
            "level": 3,
            "parentCode": "78",
            "children": [
              {
                "code": "78.20",
                "name": "Utleie av arbeidskraft",
                "shortName": "Utleie av arbeidskraft",
                "level": 4,
                "parentCode": "78.2",
                "children": [
                  {
                    "code": "78.200",
                    "name": "Utleie av arbeidskraft",
                    "shortName": "Utleie av arbeidskraft",
                    "level": 5,
                    "parentCode": "78.20"
                  }
                ]
              }
            ]
          },
          {
            "code": "78.3",
            "name": "Andre personaladministrative tjenester",
            "shortName": "Andre personaladm. tjen.",
            "level": 3,
            "parentCode": "78",
            "children": [
              {
                "code": "78.30",
                "name": "Andre personaladministrative tjenester",
                "shortName": "Andre personaladm. tjen.",
                "level": 4,
                "parentCode": "78.3",
                "children": [
                  {
                    "code": "78.300",
                    "name": "Andre personaladministrative tjenester",
                    "shortName": "Andre personaladm. tjen.",
                    "level": 5,
                    "parentCode": "78.30"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "79",
        "name": "Reisebyrå- og reisearrangørvirksomhet og tilknyttede tjenester",
        "shortName": "Reisebyråer og reisearrangører",
        "level": 2,
        "parentCode": "N",
        "children": [
          {
            "code": "79.1",
            "name": "Reisebyrå- og reisearrangørvirksomhet",
            "shortName": "Reisebyrå- og reisearrangørvirks.",
            "level": 3,
            "parentCode": "79",
            "children": [
              {
                "code": "79.11",
                "name": "Reisebyråvirksomhet",
                "shortName": "Reisebyråvirksomhet",
                "level": 4,
                "parentCode": "79.1",
                "children": [
                  {
                    "code": "79.110",
                    "name": "Reisebyråvirksomhet",
                    "shortName": "Reisebyråvirksomhet",
                    "level": 5,
                    "parentCode": "79.11"
                  }
                ]
              },
              {
                "code": "79.12",
                "name": "Reisearrangørvirksomhet",
                "shortName": "Reisearrangørvirksomhet",
                "level": 4,
                "parentCode": "79.1",
                "children": [
                  {
                    "code": "79.120",
                    "name": "Reisearrangørvirksomhet",
                    "shortName": "Reisearrangørvirksomhet",
                    "level": 5,
                    "parentCode": "79.12"
                  }
                ]
              }
            ]
          },
          {
            "code": "79.9",
            "name": "Annen arrangørvirksomhet og tilknyttede tjenester",
            "shortName": "Annen arrangørvirks. og tilkn.tjen.",
            "level": 3,
            "parentCode": "79",
            "children": [
              {
                "code": "79.90",
                "name": "Annen arrangørvirksomhet og tilknyttede tjenester",
                "shortName": "Annen arrangørvirks. og tilkn. tjen.",
                "level": 4,
                "parentCode": "79.9",
                "children": [
                  {
                    "code": "79.901",
                    "name": "Turistkontorvirksomhet og destinasjonsselskaper",
                    "shortName": "Turistkontorvirks./destinasj.selsk.",
                    "level": 5,
                    "parentCode": "79.90"
                  },
                  {
                    "code": "79.902",
                    "name": "Guider og reiseledere",
                    "shortName": "Guider og reiseledere",
                    "level": 5,
                    "parentCode": "79.90"
                  },
                  {
                    "code": "79.903",
                    "name": "Opplevelses-, arrangements- og aktivitetsarrangørvirksomhet",
                    "shortName": "Opplevelses-/arrangementsvirks.m.m.",
                    "level": 5,
                    "parentCode": "79.90"
                  },
                  {
                    "code": "79.909",
                    "name": "Turistrelaterte tjenester ikke nevnt annet sted",
                    "shortName": "Turistrelaterte tjenester el.",
                    "level": 5,
                    "parentCode": "79.90"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "80",
        "name": "Vakttjeneste og etterforsking",
        "shortName": "Vakttjeneste og etterforsking",
        "level": 2,
        "parentCode": "N",
        "children": [
          {
            "code": "80.1",
            "name": "Private vakttjenester",
            "shortName": "Private vakttjenester",
            "level": 3,
            "parentCode": "80",
            "children": [
              {
                "code": "80.10",
                "name": "Private vakttjenester",
                "shortName": "Private vakttjenester",
                "level": 4,
                "parentCode": "80.1",
                "children": [
                  {
                    "code": "80.100",
                    "name": "Private vakttjenester",
                    "shortName": "Private vakttjenester",
                    "level": 5,
                    "parentCode": "80.10"
                  }
                ]
              }
            ]
          },
          {
            "code": "80.2",
            "name": "Tjenester tilknyttet vakttjenester",
            "shortName": "Tjenester tilknyttet vakttjenester",
            "level": 3,
            "parentCode": "80",
            "children": [
              {
                "code": "80.20",
                "name": "Tjenester tilknyttet vakttjenester",
                "shortName": "Tjenester tilknyttet vakttjenester",
                "level": 4,
                "parentCode": "80.2",
                "children": [
                  {
                    "code": "80.200",
                    "name": "Tjenester tilknyttet vakttjenester",
                    "shortName": "Tjenester tilknyttet vakttjenester",
                    "level": 5,
                    "parentCode": "80.20"
                  }
                ]
              }
            ]
          },
          {
            "code": "80.3",
            "name": "Etterforsking",
            "shortName": "Etterforsking",
            "level": 3,
            "parentCode": "80",
            "children": [
              {
                "code": "80.30",
                "name": "Etterforsking",
                "shortName": "Etterforsking",
                "level": 4,
                "parentCode": "80.3",
                "children": [
                  {
                    "code": "80.300",
                    "name": "Etterforsking",
                    "shortName": "Etterforsking",
                    "level": 5,
                    "parentCode": "80.30"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "81",
        "name": "Tjenester tilknyttet eiendomsdrift",
        "shortName": "Tjenester tilknyttet eiendomsdrift",
        "level": 2,
        "parentCode": "N",
        "children": [
          {
            "code": "81.1",
            "name": "Kombinerte tjenester tilknyttet eiendomsdrift",
            "shortName": "Komb. tjen. tilkn. eiendomsdrift",
            "level": 3,
            "parentCode": "81",
            "children": [
              {
                "code": "81.10",
                "name": "Kombinerte tjenester tilknyttet eiendomsdrift",
                "shortName": "Komb. tjen. tilkn. eiendomsdrift",
                "level": 4,
                "parentCode": "81.1",
                "children": [
                  {
                    "code": "81.101",
                    "name": "Vaktmestertjenester",
                    "shortName": "Vaktmestertjenester",
                    "level": 5,
                    "parentCode": "81.10"
                  },
                  {
                    "code": "81.109",
                    "name": "Andre kombinerte tjenester tilknyttet eiendomsdrift",
                    "shortName": "Andre komb. tjen. tilkn. eiendomsdr.",
                    "level": 5,
                    "parentCode": "81.10"
                  }
                ]
              }
            ]
          },
          {
            "code": "81.2",
            "name": "Rengjøringsvirksomhet",
            "shortName": "Rengjøringsvirksomhet",
            "level": 3,
            "parentCode": "81",
            "children": [
              {
                "code": "81.21",
                "name": "Rengjøring av bygninger",
                "shortName": "Rengjøring av bygninger",
                "level": 4,
                "parentCode": "81.2",
                "children": [
                  {
                    "code": "81.210",
                    "name": "Rengjøring av bygninger",
                    "shortName": "Rengjøring av bygninger",
                    "level": 5,
                    "parentCode": "81.21"
                  }
                ]
              },
              {
                "code": "81.22",
                "name": "Utvendig rengjøring av bygninger og industriell rengjøring",
                "shortName": "Utv. rengj. bygn./ind. rengjøring",
                "level": 4,
                "parentCode": "81.2",
                "children": [
                  {
                    "code": "81.220",
                    "name": "Utvendig rengjøring av bygninger og industriell rengjøring",
                    "shortName": "Utv. rengj. bygn./ind. rengjøring",
                    "level": 5,
                    "parentCode": "81.22"
                  }
                ]
              },
              {
                "code": "81.29",
                "name": "Annen rengjøringsvirksomhet",
                "shortName": "Annen rengjøringsvirksomhet",
                "level": 4,
                "parentCode": "81.2",
                "children": [
                  {
                    "code": "81.291",
                    "name": "Skadedyrkontroll",
                    "shortName": "Skadedyrkontroll",
                    "level": 5,
                    "parentCode": "81.29"
                  },
                  {
                    "code": "81.299",
                    "name": "Annen rengjøringsvirksomhet ikke nevnt annet sted",
                    "shortName": "Rengjøringsvirksomhet ellers",
                    "level": 5,
                    "parentCode": "81.29"
                  }
                ]
              }
            ]
          },
          {
            "code": "81.3",
            "name": "Beplantning av hager og parkanlegg",
            "shortName": "Beplantning av hager og parkanl.",
            "level": 3,
            "parentCode": "81",
            "children": [
              {
                "code": "81.30",
                "name": "Beplantning av hager og parkanlegg",
                "shortName": "Beplantning av hager og parkanl.",
                "level": 4,
                "parentCode": "81.3",
                "children": [
                  {
                    "code": "81.300",
                    "name": "Beplantning av hager og parkanlegg",
                    "shortName": "Beplantning av hager og parkanl.",
                    "level": 5,
                    "parentCode": "81.30"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "82",
        "name": "Annen forretningsmessig tjenesteyting",
        "shortName": "Forretningsm. tjenesteyt. ellers",
        "level": 2,
        "parentCode": "N",
        "children": [
          {
            "code": "82.1",
            "name": "Kontortjenester",
            "shortName": "Kontortjenester",
            "level": 3,
            "parentCode": "82",
            "children": [
              {
                "code": "82.11",
                "name": "Kombinerte kontortjenester",
                "shortName": "Kombinerte kontortjenester",
                "level": 4,
                "parentCode": "82.1",
                "children": [
                  {
                    "code": "82.110",
                    "name": "Kombinerte kontortjenester",
                    "shortName": "Kombinerte kontortjenester",
                    "level": 5,
                    "parentCode": "82.11"
                  }
                ]
              },
              {
                "code": "82.19",
                "name": "Fotokopiering, forberedelse av dokumenter og andre spesialiserte kontortjenester",
                "shortName": "Fotokopiering/spes. kontortjen. el.",
                "level": 4,
                "parentCode": "82.1",
                "children": [
                  {
                    "code": "82.190",
                    "name": "Fotokopiering, forberedelse av dokumenter og andre spesialiserte kontortjenester",
                    "shortName": "Fotokopiering/spes. kontortjen. el.",
                    "level": 5,
                    "parentCode": "82.19"
                  }
                ]
              }
            ]
          },
          {
            "code": "82.2",
            "name": "Telefonvakttjenester og telefonsalg",
            "shortName": "Telefonvakttjenester/telefonsalg",
            "level": 3,
            "parentCode": "82",
            "children": [
              {
                "code": "82.20",
                "name": "Telefonvakttjenester og telefonsalg",
                "shortName": "Telefonvakttjenester/telefonsalg",
                "level": 4,
                "parentCode": "82.2",
                "children": [
                  {
                    "code": "82.201",
                    "name": "Telefonvakttjenester",
                    "shortName": "Telefonvakttjenester",
                    "level": 5,
                    "parentCode": "82.20"
                  },
                  {
                    "code": "82.202",
                    "name": "Telefonsalg",
                    "shortName": "Telefonsalg",
                    "level": 5,
                    "parentCode": "82.20"
                  }
                ]
              }
            ]
          },
          {
            "code": "82.3",
            "name": "Kongress-, messe- og utstillingsvirksomhet",
            "shortName": "Kongress-/messe-/utstillingsvirks.",
            "level": 3,
            "parentCode": "82",
            "children": [
              {
                "code": "82.30",
                "name": "Kongress-, messe- og utstillingsvirksomhet",
                "shortName": "Kongress-/messe-/utstillingsvirks.",
                "level": 4,
                "parentCode": "82.3",
                "children": [
                  {
                    "code": "82.300",
                    "name": "Kongress-, messe- og utstillingsvirksomhet",
                    "shortName": "Kongress-/messe-/utstillingsvirks.",
                    "level": 5,
                    "parentCode": "82.30"
                  }
                ]
              }
            ]
          },
          {
            "code": "82.9",
            "name": "Forretningsmessig tjenesteyting ikke nevnt annet sted",
            "shortName": "Annen forretningsmessig tj.yting",
            "level": 3,
            "parentCode": "82",
            "children": [
              {
                "code": "82.91",
                "name": "Inkasso- og kredittopplysningsvirksomhet",
                "shortName": "Inkasso- og kredittopplysningsvirks.",
                "level": 4,
                "parentCode": "82.9",
                "children": [
                  {
                    "code": "82.910",
                    "name": "Inkasso- og kredittopplysningsvirksomhet",
                    "shortName": "Inkasso- og kredittopplysningsvirks.",
                    "level": 5,
                    "parentCode": "82.91"
                  }
                ]
              },
              {
                "code": "82.92",
                "name": "Pakkevirksomhet",
                "shortName": "Pakkevirksomhet",
                "level": 4,
                "parentCode": "82.9",
                "children": [
                  {
                    "code": "82.920",
                    "name": "Pakkevirksomhet",
                    "shortName": "Pakkevirksomhet",
                    "level": 5,
                    "parentCode": "82.92"
                  }
                ]
              },
              {
                "code": "82.99",
                "name": "Annen forretningsmessig tjenesteyting ikke nevnt annet sted",
                "shortName": "Forr.messig tj.yting ikke nevnt el.",
                "level": 4,
                "parentCode": "82.9",
                "children": [
                  {
                    "code": "82.990",
                    "name": "Annen forretningsmessig tjenesteyting ikke nevnt annet sted",
                    "shortName": "Forr.messig tj.yting ikke nevnt el.",
                    "level": 5,
                    "parentCode": "82.99"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "code": "O",
    "name": "Offentlig administrasjon og forsvar, og trygdeordninger underlagt offentlig forvaltning",
    "shortName": "Off.adm., forsvar, sosialforsikring",
    "level": 1,
    "parentCode": "",
    "children": [
      {
        "code": "84",
        "name": "Offentlig administrasjon og forsvar, og trygdeordninger underlagt offentlig forvaltning",
        "shortName": "Off.adm., forsvar, sosialforsikring",
        "level": 2,
        "parentCode": "O",
        "children": [
          {
            "code": "84.1",
            "name": "Offentlig administrasjon og forvaltning",
            "shortName": "Off. administrasjon, forvaltning",
            "level": 3,
            "parentCode": "84",
            "children": [
              {
                "code": "84.11",
                "name": "Generell offentlig administrasjon",
                "shortName": "Generell offentlig administrasjon",
                "level": 4,
                "parentCode": "84.1",
                "children": [
                  {
                    "code": "84.110",
                    "name": "Generell offentlig administrasjon",
                    "shortName": "Generell offentlig administrasjon",
                    "level": 5,
                    "parentCode": "84.11"
                  }
                ]
              },
              {
                "code": "84.12",
                "name": "Offentlig administrasjon tilknyttet helsestell, sosial virksomhet, undervisning, kirke, kultur og miljøvern",
                "shortName": "Off.adm. helse, sos.virks. m.m.",
                "level": 4,
                "parentCode": "84.1",
                "children": [
                  {
                    "code": "84.120",
                    "name": "Offentlig administrasjon tilknyttet helsestell, sosial virksomhet, undervisning, kirke, kultur og miljøvern",
                    "shortName": "Off.adm. helse, sos.virks. m.m.",
                    "level": 5,
                    "parentCode": "84.12"
                  }
                ]
              },
              {
                "code": "84.13",
                "name": "Offentlig administrasjon tilknyttet næringsvirksomhet og arbeidsmarked",
                "shortName": "Off.adm. nær.virks. og arb.marked",
                "level": 4,
                "parentCode": "84.1",
                "children": [
                  {
                    "code": "84.130",
                    "name": "Offentlig administrasjon tilknyttet næringsvirksomhet og arbeidsmarked",
                    "shortName": "Off.adm. nær.virks. og arb.marked",
                    "level": 5,
                    "parentCode": "84.13"
                  }
                ]
              }
            ]
          },
          {
            "code": "84.2",
            "name": "Offentlig administrasjon tilknyttet utenriks- og sikkerhetssaker",
            "shortName": "Off.adm. utenriks-/sikkerhetssaker",
            "level": 3,
            "parentCode": "84",
            "children": [
              {
                "code": "84.21",
                "name": "Utenrikssaker",
                "shortName": "Utenrikssaker",
                "level": 4,
                "parentCode": "84.2",
                "children": [
                  {
                    "code": "84.210",
                    "name": "Utenrikssaker",
                    "shortName": "Utenrikssaker",
                    "level": 5,
                    "parentCode": "84.21"
                  }
                ]
              },
              {
                "code": "84.22",
                "name": "Forsvar",
                "shortName": "Forsvar",
                "level": 4,
                "parentCode": "84.2",
                "children": [
                  {
                    "code": "84.220",
                    "name": "Forsvar",
                    "shortName": "Forsvar",
                    "level": 5,
                    "parentCode": "84.22"
                  }
                ]
              },
              {
                "code": "84.23",
                "name": "Retts- og fengselsvesen",
                "shortName": "Retts- og fengselsvesen",
                "level": 4,
                "parentCode": "84.2",
                "children": [
                  {
                    "code": "84.230",
                    "name": "Retts- og fengselsvesen",
                    "shortName": "Retts- og fengselsvesen",
                    "level": 5,
                    "parentCode": "84.23"
                  }
                ]
              },
              {
                "code": "84.24",
                "name": "Politi- og påtalemyndighet",
                "shortName": "Politi- og påtalemyndighet",
                "level": 4,
                "parentCode": "84.2",
                "children": [
                  {
                    "code": "84.240",
                    "name": "Politi- og påtalemyndighet",
                    "shortName": "Politi- og påtalemyndighet",
                    "level": 5,
                    "parentCode": "84.24"
                  }
                ]
              },
              {
                "code": "84.25",
                "name": "Brannvern",
                "shortName": "Brannvern",
                "level": 4,
                "parentCode": "84.2",
                "children": [
                  {
                    "code": "84.250",
                    "name": "Brannvern",
                    "shortName": "Brannvern",
                    "level": 5,
                    "parentCode": "84.25"
                  }
                ]
              }
            ]
          },
          {
            "code": "84.3",
            "name": "Trygdeordninger underlagt offentlig forvaltning",
            "shortName": "Sosialforsikring, trygd",
            "level": 3,
            "parentCode": "84",
            "children": [
              {
                "code": "84.30",
                "name": "Trygdeordninger underlagt offentlig forvaltning",
                "shortName": "Sosialforsikring, trygd",
                "level": 4,
                "parentCode": "84.3",
                "children": [
                  {
                    "code": "84.300",
                    "name": "Trygdeordninger underlagt offentlig forvaltning",
                    "shortName": "Sosialforsikring, trygd",
                    "level": 5,
                    "parentCode": "84.30"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "code": "P",
    "name": "Undervisning",
    "shortName": "Undervisning",
    "level": 1,
    "parentCode": "",
    "children": [
      {
        "code": "85",
        "name": "Undervisning",
        "shortName": "Undervisning",
        "level": 2,
        "parentCode": "P",
        "children": [
          {
            "code": "85.1",
            "name": "Førskoleundervisning",
            "shortName": "Førskoleundervisning",
            "level": 3,
            "parentCode": "85",
            "children": [
              {
                "code": "85.10",
                "name": "Førskoleundervisning",
                "shortName": "Førskoleundervisning",
                "level": 4,
                "parentCode": "85.1",
                "children": [
                  {
                    "code": "85.100",
                    "name": "Førskoleundervisning",
                    "shortName": "Førskoleundervisning",
                    "level": 5,
                    "parentCode": "85.10"
                  }
                ]
              }
            ]
          },
          {
            "code": "85.2",
            "name": "Grunnskoleundervisning",
            "shortName": "Grunnskoleundervisning",
            "level": 3,
            "parentCode": "85",
            "children": [
              {
                "code": "85.20",
                "name": "Grunnskoleundervisning",
                "shortName": "Grunnskoleundervisning",
                "level": 4,
                "parentCode": "85.2",
                "children": [
                  {
                    "code": "85.201",
                    "name": "Ordinær grunnskoleundervisning",
                    "shortName": "Ordinær grunnskoleundervisning",
                    "level": 5,
                    "parentCode": "85.20"
                  },
                  {
                    "code": "85.202",
                    "name": "Spesialskoleundervisning for funksjonshemmede",
                    "shortName": "Spes.undervisn. for funksj.hemmede",
                    "level": 5,
                    "parentCode": "85.20"
                  },
                  {
                    "code": "85.203",
                    "name": "Kompetansesentra og annen spesialundervisning",
                    "shortName": "Kompetansesentra og lignende",
                    "level": 5,
                    "parentCode": "85.20"
                  }
                ]
              }
            ]
          },
          {
            "code": "85.3",
            "name": "Undervisning på videregående skoles nivå",
            "shortName": "Undervisning videregående skoler",
            "level": 3,
            "parentCode": "85",
            "children": [
              {
                "code": "85.31",
                "name": "Videregående opplæring innen allmennfaglige studieretninger",
                "shortName": "Undervisning i allmennfag",
                "level": 4,
                "parentCode": "85.3",
                "children": [
                  {
                    "code": "85.310",
                    "name": "Videregående opplæring innen allmennfaglige studieretninger",
                    "shortName": "Undervisning i allmennfag",
                    "level": 5,
                    "parentCode": "85.31"
                  }
                ]
              },
              {
                "code": "85.32",
                "name": "Videregående opplæring innen tekniske og andre yrkesfaglige studieretninger",
                "shortName": "Undervisn. i tekn./yrkesrettede fag",
                "level": 4,
                "parentCode": "85.3",
                "children": [
                  {
                    "code": "85.320",
                    "name": "Videregående opplæring innen tekniske og andre yrkesfaglige studieretninger",
                    "shortName": "Undervisn. i tekn./yrkesrettede fag",
                    "level": 5,
                    "parentCode": "85.32"
                  }
                ]
              }
            ]
          },
          {
            "code": "85.4",
            "name": "Undervisning i høyere utdanning",
            "shortName": "Undervisning i høyere utdanning",
            "level": 3,
            "parentCode": "85",
            "children": [
              {
                "code": "85.41",
                "name": "Undervisning ved fagskoler",
                "shortName": "Undervisning ved fagskoler",
                "level": 4,
                "parentCode": "85.4",
                "children": [
                  {
                    "code": "85.410",
                    "name": "Undervisning ved fagskoler",
                    "shortName": "Undervisning ved fagskoler",
                    "level": 5,
                    "parentCode": "85.41"
                  }
                ]
              },
              {
                "code": "85.42",
                "name": "Undervisning på universitets- og høgskolenivå",
                "shortName": "Undervisning universitet, høgskoler",
                "level": 4,
                "parentCode": "85.4",
                "children": [
                  {
                    "code": "85.421",
                    "name": "Undervisning ved universiteter",
                    "shortName": "Undervisning ved universiteter",
                    "level": 5,
                    "parentCode": "85.42"
                  },
                  {
                    "code": "85.422",
                    "name": "Undervisning ved vitenskapelige høgskoler",
                    "shortName": "Underv. ved vit.skap høgskoler",
                    "level": 5,
                    "parentCode": "85.42"
                  },
                  {
                    "code": "85.423",
                    "name": "Undervisning ved statlige høgskoler",
                    "shortName": "Underv. ved statlige høgskoler",
                    "level": 5,
                    "parentCode": "85.42"
                  },
                  {
                    "code": "85.424",
                    "name": "Undervisning ved militære høgskoler",
                    "shortName": "Underv. ved militære høgskoler",
                    "level": 5,
                    "parentCode": "85.42"
                  },
                  {
                    "code": "85.429",
                    "name": "Undervisning ved andre høgskoler",
                    "shortName": "Underv. ved andre høgskoler",
                    "level": 5,
                    "parentCode": "85.42"
                  }
                ]
              }
            ]
          },
          {
            "code": "85.5",
            "name": "Annen undervisning",
            "shortName": "Annen undervisning",
            "level": 3,
            "parentCode": "85",
            "children": [
              {
                "code": "85.51",
                "name": "Undervisning innen idrett og rekreasjon",
                "shortName": "Underv. innen idrett og rekreasjon",
                "level": 4,
                "parentCode": "85.5",
                "children": [
                  {
                    "code": "85.510",
                    "name": "Undervisning innen idrett og rekreasjon",
                    "shortName": "Underv. innen idrett og rekreasjon",
                    "level": 5,
                    "parentCode": "85.51"
                  }
                ]
              },
              {
                "code": "85.52",
                "name": "Undervisning innen kultur",
                "shortName": "Undervisning innen kultur",
                "level": 4,
                "parentCode": "85.5",
                "children": [
                  {
                    "code": "85.521",
                    "name": "Kommunal kulturskoleundervisning",
                    "shortName": "Kommunal kulturskoleunderv.",
                    "level": 5,
                    "parentCode": "85.52"
                  },
                  {
                    "code": "85.522",
                    "name": "Undervisning i kunstfag",
                    "shortName": "Undervisning i kunstfag",
                    "level": 5,
                    "parentCode": "85.52"
                  },
                  {
                    "code": "85.529",
                    "name": "Annen undervisning innen kultur",
                    "shortName": "Annen undervisning innen kultur",
                    "level": 5,
                    "parentCode": "85.52"
                  }
                ]
              },
              {
                "code": "85.53",
                "name": "Trafikkskoleundervisning",
                "shortName": "Trafikkskoleundervisning",
                "level": 4,
                "parentCode": "85.5",
                "children": [
                  {
                    "code": "85.530",
                    "name": "Trafikkskoleundervisning",
                    "shortName": "Trafikkskoleundervisning",
                    "level": 5,
                    "parentCode": "85.53"
                  }
                ]
              },
              {
                "code": "85.59",
                "name": "Annen undervisning ikke nevnt annet sted",
                "shortName": "Undervisning el.",
                "level": 4,
                "parentCode": "85.5",
                "children": [
                  {
                    "code": "85.591",
                    "name": "Folkehøgskoleundervisning",
                    "shortName": "Folkehøgskoleundervisning",
                    "level": 5,
                    "parentCode": "85.59"
                  },
                  {
                    "code": "85.592",
                    "name": "Arbeidsmarkedskurs",
                    "shortName": "Arbeidsmarkedkurs",
                    "level": 5,
                    "parentCode": "85.59"
                  },
                  {
                    "code": "85.593",
                    "name": "Studieforbunds- og frivillige organisasjoners kurs",
                    "shortName": "Studieforb.- og friv. organ kurs",
                    "level": 5,
                    "parentCode": "85.59"
                  },
                  {
                    "code": "85.594",
                    "name": "Voksenopplæringssentre",
                    "shortName": "Voksenopplæringssentre",
                    "level": 5,
                    "parentCode": "85.59"
                  },
                  {
                    "code": "85.595",
                    "name": "Timelærervirksomhet",
                    "shortName": "Timelærervirksomhet",
                    "level": 5,
                    "parentCode": "85.59"
                  },
                  {
                    "code": "85.596",
                    "name": "Undervisning innen religion",
                    "shortName": "Undervisning innen religion",
                    "level": 5,
                    "parentCode": "85.59"
                  },
                  {
                    "code": "85.599",
                    "name": "Annen undervisning ikke nevnt annet sted",
                    "shortName": "Undervisning ellers",
                    "level": 5,
                    "parentCode": "85.59"
                  }
                ]
              }
            ]
          },
          {
            "code": "85.6",
            "name": "Tjenester tilknyttet undervisning",
            "shortName": "Tjenester tilkn. undervisning",
            "level": 3,
            "parentCode": "85",
            "children": [
              {
                "code": "85.60",
                "name": "Tjenester tilknyttet undervisning",
                "shortName": "Tjenester tilkn. undervisning",
                "level": 4,
                "parentCode": "85.6",
                "children": [
                  {
                    "code": "85.601",
                    "name": "Pedagogisk-psykologisk rådgivningstjeneste",
                    "shortName": "Pedag./psyk. rådgivningstjeneste",
                    "level": 5,
                    "parentCode": "85.60"
                  },
                  {
                    "code": "85.609",
                    "name": "Andre tjenester tilknyttet undervisning",
                    "shortName": "Tjenester tilkn. undervisning el.",
                    "level": 5,
                    "parentCode": "85.60"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "code": "Q",
    "name": "Helse- og sosialtjenester",
    "shortName": "Helse- og sosialtjenester",
    "level": 1,
    "parentCode": "",
    "children": [
      {
        "code": "86",
        "name": "Helsetjenester",
        "shortName": "Helsetjenester",
        "level": 2,
        "parentCode": "Q",
        "children": [
          {
            "code": "86.1",
            "name": "Sykehustjenester",
            "shortName": "Sykehustjenester",
            "level": 3,
            "parentCode": "86",
            "children": [
              {
                "code": "86.10",
                "name": "Sykehustjenester",
                "shortName": "Sykehustjenester",
                "level": 4,
                "parentCode": "86.1",
                "children": [
                  {
                    "code": "86.101",
                    "name": "Alminnelige somatiske sykehus",
                    "shortName": "Alminnelige somatiske sykehus",
                    "level": 5,
                    "parentCode": "86.10"
                  },
                  {
                    "code": "86.102",
                    "name": "Somatiske spesialsykehus",
                    "shortName": "Somatiske spesialsykehus",
                    "level": 5,
                    "parentCode": "86.10"
                  },
                  {
                    "code": "86.103",
                    "name": "Andre somatiske spesialinstitusjoner",
                    "shortName": "Andre somat. spesialinstitusjoner",
                    "level": 5,
                    "parentCode": "86.10"
                  },
                  {
                    "code": "86.104",
                    "name": "Institusjoner i psykisk helsevern for voksne",
                    "shortName": "Inst. i psyk helsevern voksne",
                    "level": 5,
                    "parentCode": "86.10"
                  },
                  {
                    "code": "86.105",
                    "name": "Institusjoner i psykisk helsevern for barn og unge",
                    "shortName": "Inst. psyk. helsevern barn/unge",
                    "level": 5,
                    "parentCode": "86.10"
                  },
                  {
                    "code": "86.106",
                    "name": "Rusmiddelinstitusjoner",
                    "shortName": "Rusmiddelinstitusjoner",
                    "level": 5,
                    "parentCode": "86.10"
                  },
                  {
                    "code": "86.107",
                    "name": "Rehabiliterings- og opptreningsinstitusjoner",
                    "shortName": "Rehab.- og opptreningsinstitusjoner",
                    "level": 5,
                    "parentCode": "86.10"
                  }
                ]
              }
            ]
          },
          {
            "code": "86.2",
            "name": "Lege- og tannlegetjenester",
            "shortName": "Lege- og tannlegetjenester",
            "level": 3,
            "parentCode": "86",
            "children": [
              {
                "code": "86.21",
                "name": "Legetjeneste",
                "shortName": "Legetjeneste",
                "level": 4,
                "parentCode": "86.2",
                "children": [
                  {
                    "code": "86.211",
                    "name": "Allmenn legetjeneste",
                    "shortName": "Allmenn legetjeneste",
                    "level": 5,
                    "parentCode": "86.21"
                  },
                  {
                    "code": "86.212",
                    "name": "Somatiske poliklinikker",
                    "shortName": "Somatiske poliklinikker",
                    "level": 5,
                    "parentCode": "86.21"
                  }
                ]
              },
              {
                "code": "86.22",
                "name": "Spesialisert legetjeneste",
                "shortName": "Spesialisert legetjeneste",
                "level": 4,
                "parentCode": "86.2",
                "children": [
                  {
                    "code": "86.221",
                    "name": "Spesialisert legetjeneste, unntatt psykiatrisk legetjeneste",
                    "shortName": "Spes.legetj., unnt. psykiatrisk",
                    "level": 5,
                    "parentCode": "86.22"
                  },
                  {
                    "code": "86.222",
                    "name": "Legetjenester innen psykisk helsevern",
                    "shortName": "Legetj. innen psykisk helsevern",
                    "level": 5,
                    "parentCode": "86.22"
                  },
                  {
                    "code": "86.223",
                    "name": "Poliklinikker i psykisk helsevern for voksne",
                    "shortName": "Poliklin. i psyk. helsevern voksne",
                    "level": 5,
                    "parentCode": "86.22"
                  },
                  {
                    "code": "86.224",
                    "name": "Poliklinikker i psykisk helsevern for barn og unge",
                    "shortName": "Poliklin. i psyk. helsev. barn/unge",
                    "level": 5,
                    "parentCode": "86.22"
                  },
                  {
                    "code": "86.225",
                    "name": "Rusmiddelpoliklinikker",
                    "shortName": "Rusmiddelpoliklinikker",
                    "level": 5,
                    "parentCode": "86.22"
                  }
                ]
              },
              {
                "code": "86.23",
                "name": "Tannhelsetjenester",
                "shortName": "Tannhelsetjenester",
                "level": 4,
                "parentCode": "86.2",
                "children": [
                  {
                    "code": "86.230",
                    "name": "Tannhelsetjenester",
                    "shortName": "Tannhelsetjenester",
                    "level": 5,
                    "parentCode": "86.23"
                  }
                ]
              }
            ]
          },
          {
            "code": "86.9",
            "name": "Andre helsetjenester",
            "shortName": "Andre helsetjenester",
            "level": 3,
            "parentCode": "86",
            "children": [
              {
                "code": "86.90",
                "name": "Andre helsetjenester",
                "shortName": "Andre helsetjenester",
                "level": 4,
                "parentCode": "86.9",
                "children": [
                  {
                    "code": "86.901",
                    "name": "Hjemmesykepleie",
                    "shortName": "Hjemmesykepleie",
                    "level": 5,
                    "parentCode": "86.90"
                  },
                  {
                    "code": "86.902",
                    "name": "Fysioterapitjeneste",
                    "shortName": "Fysioterapitjeneste",
                    "level": 5,
                    "parentCode": "86.90"
                  },
                  {
                    "code": "86.903",
                    "name": "Helsestasjons- og skolehelsetjeneste",
                    "shortName": "Helsestasjons- og skolehelsetjeneste",
                    "level": 5,
                    "parentCode": "86.90"
                  },
                  {
                    "code": "86.904",
                    "name": "Annen forebyggende helsetjeneste",
                    "shortName": "Annen forebyggende helsetjeneste",
                    "level": 5,
                    "parentCode": "86.90"
                  },
                  {
                    "code": "86.905",
                    "name": "Klinisk psykologtjeneste",
                    "shortName": "Klinisk psykologtjeneste",
                    "level": 5,
                    "parentCode": "86.90"
                  },
                  {
                    "code": "86.906",
                    "name": "Medisinske laboratorietjenester",
                    "shortName": "Medisinske laboratorietjenester",
                    "level": 5,
                    "parentCode": "86.90"
                  },
                  {
                    "code": "86.907",
                    "name": "Ambulansetjenester",
                    "shortName": "Ambulansetjenester",
                    "level": 5,
                    "parentCode": "86.90"
                  },
                  {
                    "code": "86.909",
                    "name": "Andre helsetjenester",
                    "shortName": "Andre helsetjenester",
                    "level": 5,
                    "parentCode": "86.90"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "87",
        "name": "Pleie- og omsorgstjenester i institusjon",
        "shortName": "Pleie og omsorg i institusjon",
        "level": 2,
        "parentCode": "Q",
        "children": [
          {
            "code": "87.1",
            "name": "Pleie- og omsorgstjenester i institusjon",
            "shortName": "Pleie- og omsorg i institusjon",
            "level": 3,
            "parentCode": "87",
            "children": [
              {
                "code": "87.10",
                "name": "Pleie- og omsorgstjenester i institusjon",
                "shortName": "Pleie- og omsorg i institusjon",
                "level": 4,
                "parentCode": "87.1",
                "children": [
                  {
                    "code": "87.101",
                    "name": "Somatiske spesialsykehjem",
                    "shortName": "Somatiske spesialsykehjem",
                    "level": 5,
                    "parentCode": "87.10"
                  },
                  {
                    "code": "87.102",
                    "name": "Somatiske sykehjem",
                    "shortName": "Somatiske sykehjem",
                    "level": 5,
                    "parentCode": "87.10"
                  }
                ]
              }
            ]
          },
          {
            "code": "87.2",
            "name": "Institusjoner og bofellesskap innen omsorg for psykisk utviklingshemmede, psykisk helsearbeid og rusmiddelomsorg",
            "shortName": "Inst./bof.skap psyk.utv.hem. mv.",
            "level": 3,
            "parentCode": "87",
            "children": [
              {
                "code": "87.20",
                "name": "Institusjoner og bofellesskap innen omsorg for psykisk utviklingshemmede, psykisk helsearbeid og rusmiddelomsorg",
                "shortName": "Inst./bof.skap psyk. utv.hem. mv.",
                "level": 4,
                "parentCode": "87.2",
                "children": [
                  {
                    "code": "87.201",
                    "name": "Psykiatriske sykehjem",
                    "shortName": "Psykiatriske sykehjem",
                    "level": 5,
                    "parentCode": "87.20"
                  },
                  {
                    "code": "87.202",
                    "name": "Omsorgsinstitusjoner for rusmiddelmisbrukere",
                    "shortName": "Omsorgsinst. for rusmiddelmisbruk.",
                    "level": 5,
                    "parentCode": "87.20"
                  },
                  {
                    "code": "87.203",
                    "name": "Bofellesskap for psykisk utviklingshemmede",
                    "shortName": "Bofellesskap for psyk utv.hemmede",
                    "level": 5,
                    "parentCode": "87.20"
                  }
                ]
              }
            ]
          },
          {
            "code": "87.3",
            "name": "Institusjoner og bofellesskap innen omsorg for eldre og funksjonshemmede",
            "shortName": "Inst./bofellesskap eldre/funksj.hem.",
            "level": 3,
            "parentCode": "87",
            "children": [
              {
                "code": "87.30",
                "name": "Institusjoner og bofellesskap innen omsorg for eldre og funksjonshemmede",
                "shortName": "Inst./bofellesskap eldre/funksj.hem.",
                "level": 4,
                "parentCode": "87.3",
                "children": [
                  {
                    "code": "87.301",
                    "name": "Aldershjem",
                    "shortName": "Aldershjem",
                    "level": 5,
                    "parentCode": "87.30"
                  },
                  {
                    "code": "87.302",
                    "name": "Bofellesskap for eldre og funksjonshemmede med fast tilknyttet personell hele døgnet",
                    "shortName": "Heldøgns pleie eldre/funksjonshem.",
                    "level": 5,
                    "parentCode": "87.30"
                  },
                  {
                    "code": "87.303",
                    "name": "Bofellesskap for eldre og funksjonshemmede med fast tilknyttet personell deler av døgnet",
                    "shortName": "Deldøgns pleie eldre /funksj.hem.",
                    "level": 5,
                    "parentCode": "87.30"
                  },
                  {
                    "code": "87.304",
                    "name": "Avlastningsboliger/-institusjoner",
                    "shortName": "Avlastningsboliger/-institusjoner",
                    "level": 5,
                    "parentCode": "87.30"
                  },
                  {
                    "code": "87.305",
                    "name": "Barneboliger",
                    "shortName": "Barneboliger",
                    "level": 5,
                    "parentCode": "87.30"
                  }
                ]
              }
            ]
          },
          {
            "code": "87.9",
            "name": "Andre omsorgsinstitusjoner",
            "shortName": "Andre omsorgsinstitusjoner",
            "level": 3,
            "parentCode": "87",
            "children": [
              {
                "code": "87.90",
                "name": "Andre omsorgsinstitusjoner",
                "shortName": "Andre omsorgsinstitusjoner",
                "level": 4,
                "parentCode": "87.9",
                "children": [
                  {
                    "code": "87.901",
                    "name": "Institusjoner innen barne- og ungdomsvern",
                    "shortName": "Inst for barne- og ungdomsvern",
                    "level": 5,
                    "parentCode": "87.90"
                  },
                  {
                    "code": "87.909",
                    "name": "Omsorgsinstitusjoner ellers",
                    "shortName": "Omsorgsinstitusjoner ellers",
                    "level": 5,
                    "parentCode": "87.90"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "88",
        "name": "Sosiale omsorgstjenester uten botilbud",
        "shortName": "Omsorg uten botilbud, barnehager mv.",
        "level": 2,
        "parentCode": "Q",
        "children": [
          {
            "code": "88.1",
            "name": "Sosialtjenester uten botilbud for eldre og funksjonshemmede",
            "shortName": "Sosialtj. u/botilbud eldre/funksj.hem",
            "level": 3,
            "parentCode": "88",
            "children": [
              {
                "code": "88.10",
                "name": "Sosialtjenester uten botilbud for eldre og funksjonshemmede",
                "shortName": "Sosialtj. u/botilbud eldre/funksj.hem.",
                "level": 4,
                "parentCode": "88.1",
                "children": [
                  {
                    "code": "88.101",
                    "name": "Hjemmehjelp",
                    "shortName": "Hjemmehjelp",
                    "level": 5,
                    "parentCode": "88.10"
                  },
                  {
                    "code": "88.102",
                    "name": "Dagsentra/aktivitetssentra for eldre og funksjonshemmede",
                    "shortName": "Akt.sentra eldre og funksjonshem.",
                    "level": 5,
                    "parentCode": "88.10"
                  },
                  {
                    "code": "88.103",
                    "name": "Eldresentre",
                    "shortName": "Eldresentre",
                    "level": 5,
                    "parentCode": "88.10"
                  }
                ]
              }
            ]
          },
          {
            "code": "88.9",
            "name": "Andre sosialtjenester uten botilbud",
            "shortName": "Andre sosialtjen. uten botilbud",
            "level": 3,
            "parentCode": "88",
            "children": [
              {
                "code": "88.91",
                "name": "Sosialtjenester uten botilbud for barn og ungdom",
                "shortName": "Sosialtj. u/botilbud barn/ungdom",
                "level": 4,
                "parentCode": "88.9",
                "children": [
                  {
                    "code": "88.911",
                    "name": "Barnehager",
                    "shortName": "Barnehager",
                    "level": 5,
                    "parentCode": "88.91"
                  },
                  {
                    "code": "88.912",
                    "name": "Barneparker og dagmammaer",
                    "shortName": "Barneparker og dagmammaer",
                    "level": 5,
                    "parentCode": "88.91"
                  },
                  {
                    "code": "88.913",
                    "name": "Skolefritidsordninger",
                    "shortName": "Skolefritidsordninger",
                    "level": 5,
                    "parentCode": "88.91"
                  },
                  {
                    "code": "88.914",
                    "name": "Fritidsklubber for barn og ungdom",
                    "shortName": "Fritidsklubber for barn og ungdom",
                    "level": 5,
                    "parentCode": "88.91"
                  }
                ]
              },
              {
                "code": "88.99",
                "name": "Andre sosialtjenester uten botilbud ikke nevnt annet sted",
                "shortName": "Sosialtjenester u/botilbud el.",
                "level": 4,
                "parentCode": "88.9",
                "children": [
                  {
                    "code": "88.991",
                    "name": "Barneverntjenester",
                    "shortName": "Barneverntjenester",
                    "level": 5,
                    "parentCode": "88.99"
                  },
                  {
                    "code": "88.992",
                    "name": "Familieverntjenester",
                    "shortName": "Familieverntjenester",
                    "level": 5,
                    "parentCode": "88.99"
                  },
                  {
                    "code": "88.993",
                    "name": "Arbeidstrening for ordinært arbeidsmarked",
                    "shortName": "Arb.trening for ordinært arb.marked",
                    "level": 5,
                    "parentCode": "88.99"
                  },
                  {
                    "code": "88.994",
                    "name": "Varig tilrettelagt arbeid",
                    "shortName": "Varig tilrettelagt arbeid",
                    "level": 5,
                    "parentCode": "88.99"
                  },
                  {
                    "code": "88.995",
                    "name": "Sosiale velferdsorganisasjoner",
                    "shortName": "Sosiale velferdsorganisasjoner",
                    "level": 5,
                    "parentCode": "88.99"
                  },
                  {
                    "code": "88.996",
                    "name": "Asylmottak",
                    "shortName": "Asylmottak",
                    "level": 5,
                    "parentCode": "88.99"
                  },
                  {
                    "code": "88.997",
                    "name": "Sosialtjenester for rusmiddelmisbrukere uten botilbud",
                    "shortName": "Sos.tj. rusmisbr. uten botilbud",
                    "level": 5,
                    "parentCode": "88.99"
                  },
                  {
                    "code": "88.998",
                    "name": "Kommunale sosialkontortjenester",
                    "shortName": "Kommunale sosialkontortjenester",
                    "level": 5,
                    "parentCode": "88.99"
                  },
                  {
                    "code": "88.999",
                    "name": "Andre sosialtjenester uten botilbud",
                    "shortName": "Andre sosialtjenester uten botilbud",
                    "level": 5,
                    "parentCode": "88.99"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "code": "R",
    "name": "Kulturell virksomhet, underholdning og fritidsaktiviteter",
    "shortName": "Kultur, underholdning og fritid",
    "level": 1,
    "parentCode": "",
    "children": [
      {
        "code": "90",
        "name": "Kunstnerisk virksomhet og underholdningsvirksomhet",
        "shortName": "Kunstnerisk virks. og underholdning",
        "level": 2,
        "parentCode": "R",
        "children": [
          {
            "code": "90.0",
            "name": "Kunstnerisk virksomhet og underholdningsvirksomhet",
            "shortName": "Kunstnerisk virks. og underholdning",
            "level": 3,
            "parentCode": "90",
            "children": [
              {
                "code": "90.01",
                "name": "Utøvende kunstnere og underholdningsvirksomhet",
                "shortName": "Utøv. kunstnere og underhold.virks.",
                "level": 4,
                "parentCode": "90.0",
                "children": [
                  {
                    "code": "90.011",
                    "name": "Utøvende kunstnere og underholdningsvirksomhet innen musikk",
                    "shortName": "Utøv. kunstnere innen musikk",
                    "level": 5,
                    "parentCode": "90.01"
                  },
                  {
                    "code": "90.012",
                    "name": "Utøvende kunstnere og underholdningsvirksomhet innen scenekunst",
                    "shortName": "Utøv. kunstnere innen scenekunst",
                    "level": 5,
                    "parentCode": "90.01"
                  },
                  {
                    "code": "90.019",
                    "name": "Utøvende kunstnere og underholdningsvirksomhet ikke nevnt annet sted",
                    "shortName": "Utøv. kunstnere ellers",
                    "level": 5,
                    "parentCode": "90.01"
                  }
                ]
              },
              {
                "code": "90.02",
                "name": "Tjenester tilknyttet underholdningsvirksomhet",
                "shortName": "Tjen. tilkn. underholdningsvirks.",
                "level": 4,
                "parentCode": "90.0",
                "children": [
                  {
                    "code": "90.020",
                    "name": "Tjenester tilknyttet underholdningsvirksomhet",
                    "shortName": "Tjen. tilkn. underholdningsvirks.",
                    "level": 5,
                    "parentCode": "90.02"
                  }
                ]
              },
              {
                "code": "90.03",
                "name": "Selvstendig kunstnerisk virksomhet",
                "shortName": "Selvstendig kunstnerisk virks.",
                "level": 4,
                "parentCode": "90.0",
                "children": [
                  {
                    "code": "90.031",
                    "name": "Selvstendig kunstnerisk virksomhet innen visuell kunst",
                    "shortName": "Selvst. kunst.virks. visuell kunst",
                    "level": 5,
                    "parentCode": "90.03"
                  },
                  {
                    "code": "90.032",
                    "name": "Selvstendig kunstnerisk virksomhet innen musikk",
                    "shortName": "Selvst. kunst.virks. innen musikk",
                    "level": 5,
                    "parentCode": "90.03"
                  },
                  {
                    "code": "90.033",
                    "name": "Selvstendig kunstnerisk virksomhet innen scenekunst",
                    "shortName": "Selvst. kunst.virks. scenekunst",
                    "level": 5,
                    "parentCode": "90.03"
                  },
                  {
                    "code": "90.034",
                    "name": "Selvstendig kunstnerisk virksomhet innen litteratur",
                    "shortName": "Selvst. kunst.virks. litteratur",
                    "level": 5,
                    "parentCode": "90.03"
                  },
                  {
                    "code": "90.035",
                    "name": "Selvstendig kunstnerisk virksomhet innen blogging ",
                    "shortName": "Selvstendig kunstnerisk virksomhet innen blogging ",
                    "level": 5,
                    "parentCode": "90.03"
                  },
                  {
                    "code": "90.039",
                    "name": "Selvstendig kunstnerisk virksomhet ikke nevnt annet sted",
                    "shortName": "Annen selvst. kunstnerisk virks.",
                    "level": 5,
                    "parentCode": "90.03"
                  }
                ]
              },
              {
                "code": "90.04",
                "name": "Drift av lokaler tilknyttet kunstnerisk virksomhet",
                "shortName": "Drift lokaler tilkn. kunst.virks.",
                "level": 4,
                "parentCode": "90.0",
                "children": [
                  {
                    "code": "90.040",
                    "name": "Drift av lokaler tilknyttet kunstnerisk virksomhet",
                    "shortName": "Drift lokaler tilkn. kunst.virks.",
                    "level": 5,
                    "parentCode": "90.04"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "91",
        "name": "Drift av biblioteker, arkiver, museer og annen kulturvirksomhet",
        "shortName": "Bibliotek, muséer o.a. kulturvirks.",
        "level": 2,
        "parentCode": "R",
        "children": [
          {
            "code": "91.0",
            "name": "Drift av biblioteker, arkiver, museer og annen kulturvirksomhet",
            "shortName": "Bibliotek, muséer o.a. kulturvirks.",
            "level": 3,
            "parentCode": "91",
            "children": [
              {
                "code": "91.01",
                "name": "Drift av biblioteker og arkiver",
                "shortName": "Drift av biblioteker og arkiver",
                "level": 4,
                "parentCode": "91.0",
                "children": [
                  {
                    "code": "91.011",
                    "name": "Drift av folkebiblioteker",
                    "shortName": "Drift av folkebiblioteker",
                    "level": 5,
                    "parentCode": "91.01"
                  },
                  {
                    "code": "91.012",
                    "name": "Drift av fag- og forskningsbiblioteker",
                    "shortName": "Drift av fag-/forskningsbiblioteker",
                    "level": 5,
                    "parentCode": "91.01"
                  },
                  {
                    "code": "91.013",
                    "name": "Drift av arkiver",
                    "shortName": "Drift av arkiver",
                    "level": 5,
                    "parentCode": "91.01"
                  }
                ]
              },
              {
                "code": "91.02",
                "name": "Drift av museer",
                "shortName": "Drift av museer",
                "level": 4,
                "parentCode": "91.0",
                "children": [
                  {
                    "code": "91.021",
                    "name": "Drift av kunst- og kunstindustrimuseer",
                    "shortName": "Drift av kunst-/kunstindustrimuseer",
                    "level": 5,
                    "parentCode": "91.02"
                  },
                  {
                    "code": "91.022",
                    "name": "Drift av kulturhistoriske museer",
                    "shortName": "Drift av kulturhistoriske museer",
                    "level": 5,
                    "parentCode": "91.02"
                  },
                  {
                    "code": "91.023",
                    "name": "Drift av naturhistoriske museer",
                    "shortName": "Drift av naturhistoriske museer",
                    "level": 5,
                    "parentCode": "91.02"
                  },
                  {
                    "code": "91.029",
                    "name": "Drift av museer ikke nevnt annet sted",
                    "shortName": "Drift av museer ellers",
                    "level": 5,
                    "parentCode": "91.02"
                  }
                ]
              },
              {
                "code": "91.03",
                "name": "Drift av historiske steder og bygninger og lignende severdigheter",
                "shortName": "Drift av hist. steder og bygn. mv.",
                "level": 4,
                "parentCode": "91.0",
                "children": [
                  {
                    "code": "91.030",
                    "name": "Drift av historiske steder og bygninger og lignende severdigheter",
                    "shortName": "Drift av hist. steder og bygn. mv.",
                    "level": 5,
                    "parentCode": "91.03"
                  }
                ]
              },
              {
                "code": "91.04",
                "name": "Drift av botaniske og zoologiske hager og naturreservater",
                "shortName": "Drift av bot./zool. hager/naturres.",
                "level": 4,
                "parentCode": "91.0",
                "children": [
                  {
                    "code": "91.040",
                    "name": "Drift av botaniske og zoologiske hager og naturreservater",
                    "shortName": "Drift av bot./zool. hager/naturres.",
                    "level": 5,
                    "parentCode": "91.04"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "92",
        "name": "Lotteri og totalisatorspill",
        "shortName": "Lotteri og totalisatorspill",
        "level": 2,
        "parentCode": "R",
        "children": [
          {
            "code": "92.0",
            "name": "Lotteri og totalisatorspill",
            "shortName": "Lotteri og totalisatorspill",
            "level": 3,
            "parentCode": "92",
            "children": [
              {
                "code": "92.00",
                "name": "Lotteri og totalisatorspill",
                "shortName": "Lotteri og totalisatorspill",
                "level": 4,
                "parentCode": "92.0",
                "children": [
                  {
                    "code": "92.000",
                    "name": "Lotteri og totalisatorspill",
                    "shortName": "Lotteri og totalisatorspill",
                    "level": 5,
                    "parentCode": "92.00"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "93",
        "name": "Sports- og fritidsaktiviteter og drift av fornøyelsesetablissementer",
        "shortName": "Sports- og fritidsaktiviteter",
        "level": 2,
        "parentCode": "R",
        "children": [
          {
            "code": "93.1",
            "name": "Sportsaktiviteter",
            "shortName": "Sportsaktiviteter",
            "level": 3,
            "parentCode": "93",
            "children": [
              {
                "code": "93.11",
                "name": "Drift av idrettsanlegg",
                "shortName": "Drift av idrettsanlegg",
                "level": 4,
                "parentCode": "93.1",
                "children": [
                  {
                    "code": "93.110",
                    "name": "Drift av idrettsanlegg",
                    "shortName": "Drift av idrettsanlegg",
                    "level": 5,
                    "parentCode": "93.11"
                  }
                ]
              },
              {
                "code": "93.12",
                "name": "Idrettslag og -klubber",
                "shortName": "Idrettslag og -klubber",
                "level": 4,
                "parentCode": "93.1",
                "children": [
                  {
                    "code": "93.120",
                    "name": "Idrettslag og -klubber",
                    "shortName": "Idrettslag og -klubber",
                    "level": 5,
                    "parentCode": "93.12"
                  }
                ]
              },
              {
                "code": "93.13",
                "name": "Treningssentre",
                "shortName": "Treningssentre",
                "level": 4,
                "parentCode": "93.1",
                "children": [
                  {
                    "code": "93.130",
                    "name": "Treningssentre",
                    "shortName": "Treningssentre",
                    "level": 5,
                    "parentCode": "93.13"
                  }
                ]
              },
              {
                "code": "93.19",
                "name": "Andre sportsaktiviteter",
                "shortName": "Andre sportsaktiviteter",
                "level": 4,
                "parentCode": "93.1",
                "children": [
                  {
                    "code": "93.190",
                    "name": "Andre sportsaktiviteter",
                    "shortName": "Andre sportsaktiviteter",
                    "level": 5,
                    "parentCode": "93.19"
                  }
                ]
              }
            ]
          },
          {
            "code": "93.2",
            "name": "Fritidsaktiviteter og drift av fornøyelsesetablissementer",
            "shortName": "Fritidsaktiviteter, fornøyelsesetabl.",
            "level": 3,
            "parentCode": "93",
            "children": [
              {
                "code": "93.21",
                "name": "Drift av fornøyelses- og temaparker",
                "shortName": "Drift av fornøyelses- og temaparker",
                "level": 4,
                "parentCode": "93.2",
                "children": [
                  {
                    "code": "93.210",
                    "name": "Drift av fornøyelses- og temaparker",
                    "shortName": "Drift av fornøyelses- og temaparker",
                    "level": 5,
                    "parentCode": "93.21"
                  }
                ]
              },
              {
                "code": "93.29",
                "name": "Andre fritidsaktiviteter",
                "shortName": "Andre fritidsaktiviteter",
                "level": 4,
                "parentCode": "93.2",
                "children": [
                  {
                    "code": "93.291",
                    "name": "Opplevelsesaktiviteter",
                    "shortName": "Opplevelsesaktiviteter",
                    "level": 5,
                    "parentCode": "93.29"
                  },
                  {
                    "code": "93.292",
                    "name": "Fritidsetablissement",
                    "shortName": "Fritidsetablissement",
                    "level": 5,
                    "parentCode": "93.29"
                  },
                  {
                    "code": "93.299",
                    "name": "Fritidsvirksomhet ellers",
                    "shortName": "Firtidsvirksomhet ellers",
                    "level": 5,
                    "parentCode": "93.29"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "code": "S",
    "name": "Annen tjenesteyting",
    "shortName": "Annen tjenesteyting",
    "level": 1,
    "parentCode": "",
    "children": [
      {
        "code": "94",
        "name": "Aktiviteter i medlemsorganisasjoner",
        "shortName": "Aktiviteter i medlemsorgansiasjoner",
        "level": 2,
        "parentCode": "S",
        "children": [
          {
            "code": "94.1",
            "name": "Næringslivs- og arbeidsgiverorganisasjoner og yrkessammenslutninger",
            "shortName": "Næringslivs-/arbeidsgiverorg mv.",
            "level": 3,
            "parentCode": "94",
            "children": [
              {
                "code": "94.11",
                "name": "Næringslivs- og arbeidsgiverorganisasjoner",
                "shortName": "Næringslivs-/arbeidsgiverorg. mv.",
                "level": 4,
                "parentCode": "94.1",
                "children": [
                  {
                    "code": "94.110",
                    "name": "Næringslivs- og arbeidsgiverorganisasjoner",
                    "shortName": "Næringslivs-/arbeidsgiverorg. mv.",
                    "level": 5,
                    "parentCode": "94.11"
                  }
                ]
              },
              {
                "code": "94.12",
                "name": "Yrkessammenslutninger",
                "shortName": "Yrkessammenslutninger",
                "level": 4,
                "parentCode": "94.1",
                "children": [
                  {
                    "code": "94.120",
                    "name": "Yrkessammenslutninger",
                    "shortName": "Yrkessammenslutninger",
                    "level": 5,
                    "parentCode": "94.12"
                  }
                ]
              }
            ]
          },
          {
            "code": "94.2",
            "name": "Arbeidstakerorganisasjoner",
            "shortName": "Arbeidstakerorganisasjoner",
            "level": 3,
            "parentCode": "94",
            "children": [
              {
                "code": "94.20",
                "name": "Arbeidstakerorganisasjoner",
                "shortName": "Arbeidstakerorganisasjoner",
                "level": 4,
                "parentCode": "94.2",
                "children": [
                  {
                    "code": "94.200",
                    "name": "Arbeidstakerorganisasjoner",
                    "shortName": "Arbeidstakerorganisasjoner",
                    "level": 5,
                    "parentCode": "94.20"
                  }
                ]
              }
            ]
          },
          {
            "code": "94.9",
            "name": "Aktiviteter i andre medlemsorganisasjoner",
            "shortName": "Aktiviteter i andre medlemsorg.",
            "level": 3,
            "parentCode": "94",
            "children": [
              {
                "code": "94.91",
                "name": "Religiøse organisasjoner",
                "shortName": "Religiøse organisasjoner",
                "level": 4,
                "parentCode": "94.9",
                "children": [
                  {
                    "code": "94.910",
                    "name": "Religiøse organisasjoner",
                    "shortName": "Religiøse organisasjoner",
                    "level": 5,
                    "parentCode": "94.91"
                  }
                ]
              },
              {
                "code": "94.92",
                "name": "Partipolitiske organisasjoner",
                "shortName": "Partipolitiske organisasjoner",
                "level": 4,
                "parentCode": "94.9",
                "children": [
                  {
                    "code": "94.920",
                    "name": "Partipolitiske organisasjoner",
                    "shortName": "Partipolitiske organisasjoner",
                    "level": 5,
                    "parentCode": "94.92"
                  }
                ]
              },
              {
                "code": "94.99",
                "name": "Aktiviteter i andre medlemsorganisasjoner ikke nevnt annet sted",
                "shortName": "Aktiviteter i andre medlemsorg. el.",
                "level": 4,
                "parentCode": "94.9",
                "children": [
                  {
                    "code": "94.991",
                    "name": "Aktiviteter i andre interesseorganisasjoner ikke nevnt annet sted",
                    "shortName": "Interesseorganisasjoner ellers",
                    "level": 5,
                    "parentCode": "94.99"
                  },
                  {
                    "code": "94.992",
                    "name": "Fond/legat som støtter veldedige og allmennyttige formål",
                    "shortName": "Fond/legat allmennyttige formål",
                    "level": 5,
                    "parentCode": "94.99"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "95",
        "name": "Reparasjon av datamaskiner, husholdningsvarer og varer til personlig bruk",
        "shortName": "Reparasjon av varer til pers. bruk",
        "level": 2,
        "parentCode": "S",
        "children": [
          {
            "code": "95.1",
            "name": "Reparasjon av datamaskiner og kommunikasjonsutstyr",
            "shortName": "Rep. av datamaskiner og komm.utstyr",
            "level": 3,
            "parentCode": "95",
            "children": [
              {
                "code": "95.11",
                "name": "Reparasjon av datamaskiner og tilleggsutstyr",
                "shortName": "Rep. av datamask. og tilleggsutstyr",
                "level": 4,
                "parentCode": "95.1",
                "children": [
                  {
                    "code": "95.110",
                    "name": "Reparasjon av datamaskiner og tilleggsutstyr",
                    "shortName": "Rep. av datamask. og tilleggsutstyr",
                    "level": 5,
                    "parentCode": "95.11"
                  }
                ]
              },
              {
                "code": "95.12",
                "name": "Reparasjon av kommunikasjonsutstyr",
                "shortName": "Rep. av kommunikasjonsutstyr",
                "level": 4,
                "parentCode": "95.1",
                "children": [
                  {
                    "code": "95.120",
                    "name": "Reparasjon av kommunikasjonsutstyr",
                    "shortName": "Rep. av kommunikasjonsutstyr",
                    "level": 5,
                    "parentCode": "95.12"
                  }
                ]
              }
            ]
          },
          {
            "code": "95.2",
            "name": "Reparasjon av husholdningsvarer og varer til personlig bruk",
            "shortName": "Reparasjon varer personlig bruk",
            "level": 3,
            "parentCode": "95",
            "children": [
              {
                "code": "95.21",
                "name": "Reparasjon av elektronikk til husholdningsbruk",
                "shortName": "Rep. av elektronikk til hush.bruk",
                "level": 4,
                "parentCode": "95.2",
                "children": [
                  {
                    "code": "95.210",
                    "name": "Reparasjon av elektronikk til husholdningsbruk",
                    "shortName": "Rep. av elektronikk til hush.bruk",
                    "level": 5,
                    "parentCode": "95.21"
                  }
                ]
              },
              {
                "code": "95.22",
                "name": "Reparasjon av husholdningsvarer og hageredskaper",
                "shortName": "Rep. av hush.varer og hageredskaper",
                "level": 4,
                "parentCode": "95.2",
                "children": [
                  {
                    "code": "95.220",
                    "name": "Reparasjon av husholdningsvarer og hageredskaper",
                    "shortName": "Rep. av hush.varer og hageredskaper",
                    "level": 5,
                    "parentCode": "95.22"
                  }
                ]
              },
              {
                "code": "95.23",
                "name": "Reparasjon av skotøy og lærvarer",
                "shortName": "Rep. av skotøy og lærvarer",
                "level": 4,
                "parentCode": "95.2",
                "children": [
                  {
                    "code": "95.230",
                    "name": "Reparasjon av skotøy og lærvarer",
                    "shortName": "Rep. av skotøy og lærvarer",
                    "level": 5,
                    "parentCode": "95.23"
                  }
                ]
              },
              {
                "code": "95.24",
                "name": "Reparasjon av møbler og boliginnredning",
                "shortName": "Rep. av møbler og boliginnredning",
                "level": 4,
                "parentCode": "95.2",
                "children": [
                  {
                    "code": "95.240",
                    "name": "Reparasjon av møbler og boliginnredning",
                    "shortName": "Rep. av møbler og boliginnredning",
                    "level": 5,
                    "parentCode": "95.24"
                  }
                ]
              },
              {
                "code": "95.25",
                "name": "Reparasjon av ur, gull- og sølvvarer",
                "shortName": "Rep. av ur, gull- og sølvvarer",
                "level": 4,
                "parentCode": "95.2",
                "children": [
                  {
                    "code": "95.250",
                    "name": "Reparasjon av ur, gull- og sølvvarer",
                    "shortName": "Rep. av ur, gull- og sølvvarer",
                    "level": 5,
                    "parentCode": "95.25"
                  }
                ]
              },
              {
                "code": "95.29",
                "name": "Reparasjon av andre husholdningsvarer og varer til personlig bruk",
                "shortName": "Rep. av husholdningsvarer el.",
                "level": 4,
                "parentCode": "95.2",
                "children": [
                  {
                    "code": "95.290",
                    "name": "Reparasjon av andre husholdningsvarer og varer til personlig bruk",
                    "shortName": "Rep. av husholdningsvarer el.",
                    "level": 5,
                    "parentCode": "95.29"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "code": "96",
        "name": "Annen personlig tjenesteyting",
        "shortName": "Annen personlig tjenesteyting",
        "level": 2,
        "parentCode": "S",
        "children": [
          {
            "code": "96.0",
            "name": "Annen personlig tjenesteyting",
            "shortName": "Annen personlig tjenesteyting",
            "level": 3,
            "parentCode": "96",
            "children": [
              {
                "code": "96.01",
                "name": "Vaskeri- og renserivirksomhet",
                "shortName": "Vaskeri- og renserivirksomhet",
                "level": 4,
                "parentCode": "96.0",
                "children": [
                  {
                    "code": "96.010",
                    "name": "Vaskeri- og renserivirksomhet",
                    "shortName": "Vaskeri- og renserivirksomhet",
                    "level": 5,
                    "parentCode": "96.01"
                  }
                ]
              },
              {
                "code": "96.02",
                "name": "Frisering og annen skjønnhetspleie",
                "shortName": "Frisering og skjønnhetspleie el.",
                "level": 4,
                "parentCode": "96.0",
                "children": [
                  {
                    "code": "96.020",
                    "name": "Frisering og annen skjønnhetspleie",
                    "shortName": "Frisering og skjønnhetspleie el.",
                    "level": 5,
                    "parentCode": "96.02"
                  }
                ]
              },
              {
                "code": "96.03",
                "name": "Begravelsesbyråvirksomhet og drift av kirkegårder og krematorier",
                "shortName": "Begrav.byrå, kirkegårdsdrift mv.",
                "level": 4,
                "parentCode": "96.0",
                "children": [
                  {
                    "code": "96.030",
                    "name": "Begravelsesbyråvirksomhet og drift av kirkegårder og krematorier",
                    "shortName": "Begrav.byrå, kirkegårdsdrift mv..",
                    "level": 5,
                    "parentCode": "96.03"
                  }
                ]
              },
              {
                "code": "96.04",
                "name": "Virksomhet knyttet til kroppspleie og fysisk velvære",
                "shortName": "Helsestudiovirksomhet mv..",
                "level": 4,
                "parentCode": "96.0",
                "children": [
                  {
                    "code": "96.040",
                    "name": "Virksomhet knyttet til kroppspleie og fysisk velvære",
                    "shortName": "Helsestudiovirksomhet mv.",
                    "level": 5,
                    "parentCode": "96.04"
                  }
                ]
              },
              {
                "code": "96.09",
                "name": "Personlig tjenesteyting ikke nevnt annet sted",
                "shortName": "Personlig tjenesteyting el.",
                "level": 4,
                "parentCode": "96.0",
                "children": [
                  {
                    "code": "96.090",
                    "name": "Personlig tjenesteyting ikke nevnt annet sted",
                    "shortName": "Personlig tjenesteyting el.",
                    "level": 5,
                    "parentCode": "96.09"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "code": "T",
    "name": "Lønnet arbeid i private husholdninger",
    "shortName": "Lønnet arbeid i private husholdn.",
    "level": 1,
    "parentCode": "",
    "children": [
      {
        "code": "97",
        "name": "Lønnet arbeid i private husholdninger",
        "shortName": "Lønnet arbeid i private husholdn.",
        "level": 2,
        "parentCode": "T",
        "children": [
          {
            "code": "97.0",
            "name": "Lønnet arbeid i private husholdninger",
            "shortName": "Lønnet arbeid i private husholdn.",
            "level": 3,
            "parentCode": "97",
            "children": [
              {
                "code": "97.00",
                "name": "Lønnet arbeid i private husholdninger",
                "shortName": "Lønnet arbeid i private husholdn.",
                "level": 4,
                "parentCode": "97.0",
                "children": [
                  {
                    "code": "97.000",
                    "name": "Lønnet arbeid i private husholdninger",
                    "shortName": "Lønnet arbeid i private husholdn.",
                    "level": 5,
                    "parentCode": "97.00"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "code": "U",
    "name": "Internasjonale organisasjoner og organer",
    "shortName": "Internasjonale organer",
    "level": 1,
    "parentCode": "",
    "children": [
      {
        "code": "99",
        "name": "Internasjonale organisasjoner og organer",
        "shortName": "Internasjonale organer",
        "level": 2,
        "parentCode": "U",
        "children": [
          {
            "code": "99.0",
            "name": "Internasjonale organisasjoner og organer",
            "shortName": "Internasjonale organer",
            "level": 3,
            "parentCode": "99",
            "children": [
              {
                "code": "99.00",
                "name": "Internasjonale organisasjoner og organer",
                "shortName": "Internasjonale organer",
                "level": 4,
                "parentCode": "99.0",
                "children": [
                  {
                    "code": "99.000",
                    "name": "Internasjonale organisasjoner og organer",
                    "shortName": "Internasjonale organer",
                    "level": 5,
                    "parentCode": "99.00"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];

// Helper function to find an industry code by code
export function findIndustryCode(code: string): IndustryCode | undefined {
  return industryCodes.all.find(c => c.code === code);
}

// Helper function to get all child codes (and their children) for a given code
export function getAllChildCodes(code: string): string[] {
  const directChildren = industryCodes.all.filter(c => c.parentCode === code);
  const childCodes = directChildren.map(c => c.code);
  
  // Recursively get children of children
  directChildren.forEach(child => {
    const grandChildren = getAllChildCodes(child.code);
    childCodes.push(...grandChildren);
  });
  
  return childCodes;
}
